import { jsx as v, jsxs as P, Fragment as je } from "react/jsx-runtime";
import * as h from "react";
import ae, { createContext as Pt, useContext as io, useCallback as De, useState as Ne, useRef as Te, useEffect as Se, useMemo as Do, createElement as Ek, forwardRef as pt, cloneElement as gf, useLayoutEffect as bf, useReducer as Ak, Component as Ok, useImperativeHandle as zk } from "react";
import * as so from "react-dom";
import Ui from "react-dom";
import { D as Ad, p as Nk, s as jk, a as Rk } from "./communicationBanner-B5DYcgiW.js";
import { g as $_e, h as S_e } from "./communicationBanner-B5DYcgiW.js";
const Ik = (e, t, n, o) => {
  const a = [n, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(a, "warn", "react-i18next::", !0);
  Un(a[0]) && (a[0] = `react-i18next:: ${a[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...a) : console?.warn && console.warn(...a);
}, Od = {}, jl = (e, t, n, o) => {
  Un(n) && Od[n] || (Un(n) && (Od[n] = /* @__PURE__ */ new Date()), Ik(e, t, n, o));
}, vf = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, Rl = (e, t, n) => {
  e.loadNamespaces(t, vf(e, n));
}, zd = (e, t, n, o) => {
  if (Un(n) && (n = [n]), e.options.preload && e.options.preload.indexOf(t) > -1) return Rl(e, n, o);
  n.forEach((a) => {
    e.options.ns.indexOf(a) < 0 && e.options.ns.push(a);
  }), e.loadLanguages(t, vf(e, o));
}, Tk = (e, t, n = {}) => !t.languages || !t.languages.length ? (jl(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: n.lng,
  precheck: (o, a) => {
    if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !a(o.isLanguageChangingTo, e)) return !1;
  }
}), Un = (e) => typeof e == "string", Pk = (e) => typeof e == "object" && e !== null, Dk = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Lk = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Mk = (e) => Lk[e], Fk = (e) => e.replace(Dk, Mk);
let Wk = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Fk
};
const Bk = () => Wk;
let Vk;
const Uk = () => Vk, yf = Pt();
class qk {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Hk = (e, t) => {
  const n = Te();
  return Se(() => {
    n.current = e;
  }, [e, t]), n.current;
}, _f = (e, t, n, o) => e.getFixedT(t, n, o), Kk = (e, t, n, o) => De(_f(e, t, n, o), [e, t, n, o]), lo = (e, t = {}) => {
  const {
    i18n: n
  } = t, {
    i18n: o,
    defaultNS: a
  } = io(yf) || {}, r = n || o || Uk();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new qk()), !r) {
    jl(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const k = (S, $) => Un($) ? $ : Pk($) && Un($.defaultValue) ? $.defaultValue : Array.isArray(S) ? S[S.length - 1] : S, x = [k, {}, !1];
    return x.t = k, x.i18n = {}, x.ready = !1, x;
  }
  r.options.react?.wait && jl(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Bk(),
    ...r.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: l
  } = i;
  let c = e || a || r.options?.defaultNS;
  c = Un(c) ? [c] : c || ["translation"], r.reportNamespaces.addUsedNamespaces?.(c);
  const u = (r.isInitialized || r.initializedStoreOnce) && c.every((k) => Tk(k, r, i)), d = Kk(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), m = () => d, f = () => _f(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), [g, p] = Ne(m);
  let b = c.join();
  t.lng && (b = `${t.lng}${b}`);
  const w = Hk(b), y = Te(!0);
  Se(() => {
    const {
      bindI18n: k,
      bindI18nStore: x
    } = i;
    y.current = !0, !u && !s && (t.lng ? zd(r, t.lng, c, () => {
      y.current && p(f);
    }) : Rl(r, c, () => {
      y.current && p(f);
    })), u && w && w !== b && y.current && p(f);
    const S = () => {
      y.current && p(f);
    };
    return k && r?.on(k, S), x && r?.store.on(x, S), () => {
      y.current = !1, r && k && k?.split(" ").forEach(($) => r.off($, S)), x && r && x.split(" ").forEach(($) => r.store.off($, S));
    };
  }, [r, b]), Se(() => {
    y.current && u && p(m);
  }, [r, l, u]);
  const _ = [g, r, u];
  if (_.t = g, _.i18n = r, _.ready = u, u || !u && !s) return _;
  throw new Promise((k) => {
    t.lng ? zd(r, t.lng, c, () => k()) : Rl(r, c, () => k());
  });
};
function Gk({
  i18n: e,
  defaultNS: t,
  children: n
}) {
  const o = Do(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return Ek(yf.Provider, {
    value: o
  }, n);
}
function wf(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = wf(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function ze() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = wf(e)) && (o && (o += " "), o += t);
  return o;
}
const Zk = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Jk = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Yk = Zk.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Jk[e]
})), Xk = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Qk = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function ex(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const $e = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = Yk.find((l) => l.name === e), s = ze("icon", `ds-${i?.class}`, Qk[t], Xk[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: ex(i?.paths) });
  }
);
$e.displayName = "Icon";
const tx = "_loader_1ksyv_29", nx = "_circle_1ksyv_41", mo = {
  loader: tx,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: nx,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, ox = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, ax = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function rx({ onDark: e, size: t = "medium", color: n = "primary", className: o }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      className: ze(
        mo.loader,
        mo[ox[t]],
        mo[ax[n]],
        e && mo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: mo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ P(
          "circle",
          {
            className: mo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const ix = "_button_z1os6_29", sx = "_disabled_z1os6_43", lx = "_loader_z1os6_263", an = {
  button: ix,
  disabled: sx,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: lx,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, Mc = pt(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: o = !1,
    icon: a,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...m
  }, f) => {
    const g = ze(
      an.button,
      an[cx[t]],
      an[ux[n]],
      o && an["is-full-width"],
      c && an.disabled,
      r === "right" && an["has-icon-right"],
      l && an["is-contrasted"],
      i && an["is-loading"],
      u
    ), p = /* @__PURE__ */ P(je, { children: [
      i && /* @__PURE__ */ v(rx, { className: an.loader, onDark: !0, size: "small" }),
      a && r === "left" && /* @__PURE__ */ v($e, { color: "inherit", size: s, name: a }),
      d ?? e,
      a && r === "right" && /* @__PURE__ */ v($e, { color: "inherit", size: s, name: a })
    ] });
    if (dx(m))
      return /* @__PURE__ */ v(
        "a",
        {
          ...m,
          href: c ? void 0 : m.href,
          className: g,
          target: m.target,
          ref: f,
          children: p
        }
      );
    if (hx(m))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...m,
          className: g,
          ref: f,
          children: p
        }
      );
  }
);
Mc.displayName = "Button";
const cx = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, ux = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function dx(e) {
  return "href" in e && typeof e.href == "string";
}
function hx(e) {
  return !("href" in e);
}
const Nd = {
  MOBILE: 640,
  TABLET: 768
}, px = "_text_1g0xp_29", Ln = {
  text: px,
  "is-small": "_is-small_1g0xp_34",
  "is-ellipsis": "_is-ellipsis_1g0xp_38",
  "is-center": "_is-center_1g0xp_44",
  "color-primary": "_color-primary_1g0xp_47",
  "color-secondary": "_color-secondary_1g0xp_50",
  "color-tertiary": "_color-tertiary_1g0xp_53",
  "color-eco-green": "_color-eco-green_1g0xp_56",
  "color-success": "_color-success_1g0xp_59",
  "color-error": "_color-error_1g0xp_62",
  "color-inverted": "_color-inverted_1g0xp_65",
  "color-warning": "_color-warning_1g0xp_68",
  "color-highlight": "_color-highlight_1g0xp_71",
  "color-inherit": "_color-inherit_1g0xp_74",
  "is-bold": "_is-bold_1g0xp_77",
  "size-xs": "_size-xs_1g0xp_80",
  "size-sm": "_size-sm_1g0xp_83",
  "size-base": "_size-base_1g0xp_86",
  "size-lg": "_size-lg_1g0xp_89",
  "size-xl": "_size-xl_1g0xp_92",
  "dialog-overlay-show": "_dialog-overlay-show_1g0xp_1",
  "dialog-content-show": "_dialog-content-show_1g0xp_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1g0xp_1"
};
function Ze({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: n,
  ellipsis: o,
  isSpan: a,
  className: r = "",
  color: i = "primary",
  isBold: s,
  size: l,
  title: c,
  center: u,
  ...d
}) {
  const m = ze(
    Ln.text,
    n && Ln["is-small"],
    o && Ln["is-ellipsis"],
    i && Ln[`color-${i}`],
    s && Ln["is-bold"],
    l && Ln[`size-${l}`],
    u && Ln["is-center"],
    r
  ), f = a ? "span" : "div";
  return t ? /* @__PURE__ */ v(f, { className: m, dangerouslySetInnerHTML: t, ...d, title: c }) : /* @__PURE__ */ v(f, { className: m, ...d, children: e });
}
const Rs = {
  "flex-children": "_flex-children_1c6gy_29",
  "justify-self-start": "_justify-self-start_1c6gy_29",
  "justify-self-end": "_justify-self-end_1c6gy_32",
  "justify-self-center": "_justify-self-center_1c6gy_35",
  "align-self-start": "_align-self-start_1c6gy_38",
  "align-self-end": "_align-self-end_1c6gy_41",
  "align-self-center": "_align-self-center_1c6gy_44",
  "dialog-overlay-show": "_dialog-overlay-show_1c6gy_1",
  "dialog-content-show": "_dialog-content-show_1c6gy_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1c6gy_1"
}, mx = ({ alignSelf: e, justifySelf: t, children: n }) => {
  const o = ze(
    Rs["flex-children"],
    e && Rs[`align-self-${e}`],
    t && Rs[`justify-self-${t}`]
  );
  return /* @__PURE__ */ v("div", { className: o, children: n });
}, fx = "_flex_1taae_29", gx = "_wrap_1taae_67", bx = "_nowrap_1taae_70", vx = "_shrink_1taae_88", xt = {
  flex: fx,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: gx,
  nowrap: bx,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: vx,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function ce({
  children: e,
  direction: t = "row",
  justifyContent: n = "start",
  alignItems: o = "start",
  flexWrap: a = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: s = !1,
  gap: l,
  style: c,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: m = !1,
  shrink: f = !1,
  ...g
}) {
  const p = ze(
    xt.flex,
    xt[`flex-${t}`],
    xt[`justify-${n}`],
    xt[`align-${o}`],
    xt[a],
    i && xt["is-full-width"],
    s && xt["is-full-height"],
    l && xt[`gap-${l}`],
    u && xt["no-margin"],
    d && xt["flex-grow"],
    m && xt["hide-on-mobile"],
    f && xt.shrink,
    r
  );
  return /* @__PURE__ */ v("div", { className: p, ...g, style: c, children: e });
}
ce.FlexChildren = mx;
function me(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var dn = globalThis?.document ? h.useLayoutEffect : () => {
}, yx = h[" useInsertionEffect ".trim().toString()] || dn;
function Da({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [a, r, i] = _x({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : a;
  {
    const u = h.useRef(e !== void 0);
    h.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = h.useCallback(
    (u) => {
      if (s) {
        const d = wx(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function _x({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = h.useState(e), a = h.useRef(n), r = h.useRef(t);
  return yx(() => {
    r.current = t;
  }, [t]), h.useEffect(() => {
    a.current !== n && (r.current?.(n), a.current = n);
  }, [n, a]), [n, o, r];
}
function wx(e) {
  return typeof e == "function";
}
function jd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Fc(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((a) => {
      const r = jd(a, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let a = 0; a < o.length; a++) {
          const r = o[a];
          typeof r == "function" ? r() : jd(e[a], null);
        }
      };
  };
}
function Fe(...e) {
  return h.useCallback(Fc(...e), e);
}
function kx(e, t) {
  const n = h.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = h.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(n.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function a(r) {
    const i = h.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, a];
}
function co(e, t = []) {
  let n = [];
  function o(r, i) {
    const s = h.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      const { scope: m, children: f, ...g } = d, p = m?.[e]?.[l] || s, b = h.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: f });
    };
    c.displayName = r + "Provider";
    function u(d, m) {
      const f = m?.[e]?.[l] || s, g = h.useContext(f);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const a = () => {
    const r = n.map((i) => h.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return a.scopeName = e, [o, xx(a, ...t)];
}
function xx(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(a) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(a)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function ai(e) {
  const t = /* @__PURE__ */ $x(e), n = h.forwardRef((o, a) => {
    const { children: r, ...i } = o, s = h.Children.toArray(r), l = s.find(Cx);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? h.Children.count(c) > 1 ? h.Children.only(null) : h.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: a, children: h.isValidElement(c) ? h.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: a, children: r });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function $x(e) {
  const t = h.forwardRef((n, o) => {
    const { children: a, ...r } = n;
    if (h.isValidElement(a)) {
      const i = Ax(a), s = Ex(r, a.props);
      return a.type !== h.Fragment && (s.ref = o ? Fc(o, i) : i), h.cloneElement(a, s);
    }
    return h.Children.count(a) > 1 ? h.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Sx = Symbol("radix.slottable");
function Cx(e) {
  return h.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Sx;
}
function Ex(e, t) {
  const n = { ...t };
  for (const o in t) {
    const a = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? a && r ? n[o] = (...i) => {
      const s = r(...i);
      return a(...i), s;
    } : a && (n[o] = a) : o === "style" ? n[o] = { ...a, ...r } : o === "className" && (n[o] = [a, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ax(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ox = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], be = Ox.reduce((e, t) => {
  const n = /* @__PURE__ */ ai(`Primitive.${t}`), o = h.forwardRef((a, r) => {
    const { asChild: i, ...s } = a, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Il(e, t) {
  e && so.flushSync(() => e.dispatchEvent(t));
}
var zx = h.createContext(void 0);
function qi(e) {
  const t = h.useContext(zx);
  return e || t || "ltr";
}
function Wc(e) {
  const t = e + "CollectionProvider", [n, o] = co(t), [a, r] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, y = ae.useRef(null), _ = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(a, { scope: b, itemMap: _, collectionRef: y, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ ai(s), c = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y } = p, _ = r(s, w), k = Fe(b, _.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: y });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ ai(u), f = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y, ..._ } = p, k = ae.useRef(null), x = Fe(b, k), S = r(u, w);
      return ae.useEffect(() => (S.itemMap.set(k, { ref: k, ..._ }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(m, { [d]: "", ref: x, children: y });
    }
  );
  f.displayName = u;
  function g(p) {
    const b = r(e + "CollectionConsumer", p);
    return ae.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const y = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (_, k) => y.indexOf(_.ref.current) - y.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    g,
    o
  ];
}
var Nx = h[" useId ".trim().toString()] || (() => {
}), jx = 0;
function qn(e) {
  const [t, n] = h.useState(Nx());
  return dn(() => {
    n((o) => o ?? String(jx++));
  }, [e]), t ? `radix-${t}` : "";
}
function Rx(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var wt = (e) => {
  const { present: t, children: n } = e, o = Ix(t), a = typeof n == "function" ? n({ present: o.isPresent }) : h.Children.only(n), r = Fe(o.ref, Tx(a));
  return typeof n == "function" || o.isPresent ? h.cloneElement(a, { ref: r }) : null;
};
wt.displayName = "Presence";
function Ix(e) {
  const [t, n] = h.useState(), o = h.useRef(null), a = h.useRef(e), r = h.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = Rx(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const c = or(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), dn(() => {
    const c = o.current, u = a.current;
    if (u !== e) {
      const d = r.current, m = or(c);
      e ? l("MOUNT") : m === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== m ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, l]), dn(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (f) => {
        const g = or(o.current).includes(CSS.escape(f.animationName));
        if (f.target === t && g && (l("ANIMATION_END"), !a.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, m = (f) => {
        f.target === t && (r.current = or(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: h.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function or(e) {
  return e?.animationName || "none";
}
function Tx(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function qe(e) {
  const t = h.useRef(e);
  return h.useEffect(() => {
    t.current = e;
  }), h.useMemo(() => (...n) => t.current?.(...n), []);
}
var Is = "rovingFocusGroup.onEntryFocus", Px = { bubbles: !1, cancelable: !0 }, La = "RovingFocusGroup", [Tl, kf, Dx] = Wc(La), [Lx, xf] = co(
  La,
  [Dx]
), [Mx, Fx] = Lx(La), $f = h.forwardRef(
  (e, t) => /* @__PURE__ */ v(Tl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Tl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Wx, { ...e, ref: t }) }) })
);
$f.displayName = La;
var Wx = h.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: a = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, m = h.useRef(null), f = Fe(t, m), g = qi(r), [p, b] = Da({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: La
  }), [w, y] = h.useState(!1), _ = qe(c), k = kf(n), x = h.useRef(!1), [S, $] = h.useState(0);
  return h.useEffect(() => {
    const E = m.current;
    if (E)
      return E.addEventListener(Is, _), () => E.removeEventListener(Is, _);
  }, [_]), /* @__PURE__ */ v(
    Mx,
    {
      scope: n,
      orientation: o,
      dir: g,
      loop: a,
      currentTabStopId: p,
      onItemFocus: h.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: h.useCallback(() => y(!0), []),
      onFocusableItemAdd: h.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: h.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        be.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: f,
          style: { outline: "none", ...e.style },
          onMouseDown: me(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: me(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const A = new CustomEvent(Is, Px);
              if (E.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
                const I = k().filter((L) => L.focusable), U = I.find((L) => L.active), M = I.find((L) => L.id === p), z = [U, M, ...I].filter(
                  Boolean
                ).map((L) => L.ref.current);
                Ef(z, u);
              }
            }
            x.current = !1;
          }),
          onBlur: me(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Sf = "RovingFocusGroupItem", Cf = h.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: a = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = qn(), c = r || l, u = Fx(Sf, n), d = u.currentTabStopId === c, m = kf(n), { onFocusableItemAdd: f, onFocusableItemRemove: g, currentTabStopId: p } = u;
    return h.useEffect(() => {
      if (o)
        return f(), () => g();
    }, [o, f, g]), /* @__PURE__ */ v(
      Tl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: o,
        active: a,
        children: /* @__PURE__ */ v(
          be.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: me(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: me(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: me(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = Ux(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let y = m().filter((_) => _.focusable).map((_) => _.ref.current);
                if (w === "last") y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const _ = y.indexOf(b.currentTarget);
                  y = u.loop ? qx(y, _ + 1) : y.slice(_ + 1);
                }
                setTimeout(() => Ef(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
Cf.displayName = Sf;
var Bx = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Vx(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ux(e, t, n) {
  const o = Vx(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Bx[o];
}
function Ef(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function qx(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Hx = $f, Kx = Cf;
function Gx(e) {
  const t = h.useRef({ value: e, previous: e });
  return h.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Zx(e) {
  const [t, n] = Ne(!1), o = De(() => n(!0), []), a = De(() => n(!1), []), r = De(() => n((i) => !i), []);
  return { value: t, setValue: n, setTrue: o, setFalse: a, toggle: r };
}
function Jx() {
  const [e, t] = Ne({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Se(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function Yx() {
  const { width: e } = Jx();
  let t = "desktop";
  return e && e <= Nd.MOBILE ? t = "mobile" : e && e <= Nd.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function Xx(e, t = globalThis?.document) {
  const n = qe(e);
  h.useEffect(() => {
    const o = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var Qx = "DismissableLayer", Pl = "dismissableLayer.update", e1 = "dismissableLayer.pointerDownOutside", t1 = "dismissableLayer.focusOutside", Rd, Af = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Bc = h.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = h.useContext(Af), [u, d] = h.useState(null), m = u?.ownerDocument ?? globalThis?.document, [, f] = h.useState({}), g = Fe(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), y = u ? p.indexOf(u) : -1, _ = c.layersWithOutsidePointerEventsDisabled.size > 0, k = y >= w, x = a1(($) => {
      const E = $.target, C = [...c.branches].some((A) => A.contains(E));
      !k || C || (a?.($), i?.($), $.defaultPrevented || s?.());
    }, m), S = r1(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, m);
    return Xx(($) => {
      y === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, m), h.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Rd = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Id(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Rd);
        };
    }, [u, m, n, c]), h.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Id());
    }, [u, c]), h.useEffect(() => {
      const $ = () => f({});
      return document.addEventListener(Pl, $), () => document.removeEventListener(Pl, $);
    }, []), /* @__PURE__ */ v(
      be.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: _ ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: me(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: me(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: me(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Bc.displayName = Qx;
var n1 = "DismissableLayerBranch", o1 = h.forwardRef((e, t) => {
  const n = h.useContext(Af), o = h.useRef(null), a = Fe(t, o);
  return h.useEffect(() => {
    const r = o.current;
    if (r)
      return n.branches.add(r), () => {
        n.branches.delete(r);
      };
  }, [n.branches]), /* @__PURE__ */ v(be.div, { ...e, ref: a });
});
o1.displayName = n1;
function a1(e, t = globalThis?.document) {
  const n = qe(e), o = h.useRef(!1), a = h.useRef(() => {
  });
  return h.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          Of(
            e1,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", a.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function r1(e, t = globalThis?.document) {
  const n = qe(e), o = h.useRef(!1);
  return h.useEffect(() => {
    const a = (r) => {
      r.target && !o.current && Of(t1, n, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Id() {
  const e = new CustomEvent(Pl);
  document.dispatchEvent(e);
}
function Of(e, t, n, { discrete: o }) {
  const a = n.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), o ? Il(a, r) : a.dispatchEvent(r);
}
var i1 = "Portal", zf = h.forwardRef((e, t) => {
  const { container: n, ...o } = e, [a, r] = h.useState(!1);
  dn(() => r(!0), []);
  const i = n || a && globalThis?.document?.body;
  return i ? Ui.createPortal(/* @__PURE__ */ v(be.div, { ...o, ref: t }), i) : null;
});
zf.displayName = i1;
var Ut = function() {
  return Ut = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ut.apply(this, arguments);
};
function Nf(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
  return n;
}
function s1(e, t, n) {
  for (var o = 0, a = t.length, r; o < a; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Ts = "focusScope.autoFocusOnMount", Ps = "focusScope.autoFocusOnUnmount", Td = { bubbles: !1, cancelable: !0 }, l1 = "FocusScope", jf = h.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = h.useState(null), c = qe(a), u = qe(r), d = h.useRef(null), m = Fe(t, (p) => l(p)), f = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (o) {
      let p = function(_) {
        if (f.paused || !s) return;
        const k = _.target;
        s.contains(k) ? d.current = k : _n(d.current, { select: !0 });
      }, b = function(_) {
        if (f.paused || !s) return;
        const k = _.relatedTarget;
        k !== null && (s.contains(k) || _n(d.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const k of _)
            k.removedNodes.length > 0 && _n(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const y = new MutationObserver(w);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [o, s, f.paused]), h.useEffect(() => {
    if (s) {
      Dd.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(Ts, Td);
        s.addEventListener(Ts, c), s.dispatchEvent(b), b.defaultPrevented || (c1(m1(Rf(s)), { select: !0 }), document.activeElement === p && _n(s));
      }
      return () => {
        s.removeEventListener(Ts, c), setTimeout(() => {
          const b = new CustomEvent(Ps, Td);
          s.addEventListener(Ps, u), s.dispatchEvent(b), b.defaultPrevented || _n(p ?? document.body, { select: !0 }), s.removeEventListener(Ps, u), Dd.remove(f);
        }, 0);
      };
    }
  }, [s, c, u, f]);
  const g = h.useCallback(
    (p) => {
      if (!n && !o || f.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const y = p.currentTarget, [_, k] = u1(y);
        _ && k ? !p.shiftKey && w === k ? (p.preventDefault(), n && _n(_, { select: !0 })) : p.shiftKey && w === _ && (p.preventDefault(), n && _n(k, { select: !0 })) : w === y && p.preventDefault();
      }
    },
    [n, o, f.paused]
  );
  return /* @__PURE__ */ v(be.div, { tabIndex: -1, ...i, ref: m, onKeyDown: g });
});
jf.displayName = l1;
function c1(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (_n(o, { select: t }), document.activeElement !== n) return;
}
function u1(e) {
  const t = Rf(e), n = Pd(t, e), o = Pd(t.reverse(), e);
  return [n, o];
}
function Rf(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Pd(e, t) {
  for (const n of e)
    if (!d1(n, { upTo: t })) return n;
}
function d1(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function h1(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function _n(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && h1(e) && t && e.select();
  }
}
var Dd = p1();
function p1() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Ld(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ld(e, t), e[0]?.resume();
    }
  };
}
function Ld(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function m1(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ds = 0;
function f1() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Md()), document.body.insertAdjacentElement("beforeend", e[1] ?? Md()), Ds++, () => {
      Ds === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ds--;
    };
  }, []);
}
function Md() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Dr = "right-scroll-bar-position", Lr = "width-before-scroll-bar", g1 = "with-scroll-bars-hidden", b1 = "--removed-body-scroll-bar-size";
function Ls(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function v1(e, t) {
  var n = Ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var a = n.value;
          a !== o && (n.value = o, n.callback(o, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var y1 = typeof window < "u" ? h.useLayoutEffect : h.useEffect, Fd = /* @__PURE__ */ new WeakMap();
function _1(e, t) {
  var n = v1(null, function(o) {
    return e.forEach(function(a) {
      return Ls(a, o);
    });
  });
  return y1(function() {
    var o = Fd.get(n);
    if (o) {
      var a = new Set(o), r = new Set(e), i = n.current;
      a.forEach(function(s) {
        r.has(s) || Ls(s, null);
      }), r.forEach(function(s) {
        a.has(s) || Ls(s, i);
      });
    }
    Fd.set(n, e);
  }, [e]), n;
}
function w1(e) {
  return e;
}
function k1(e, t) {
  t === void 0 && (t = w1);
  var n = [], o = !1, a = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(r);
      }
      n = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(r), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return a;
}
function x1(e) {
  e === void 0 && (e = {});
  var t = k1(null);
  return t.options = Ut({ async: !0, ssr: !1 }, e), t;
}
var If = function(e) {
  var t = e.sideCar, n = Nf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return h.createElement(o, Ut({}, n));
};
If.isSideCarExport = !0;
function $1(e, t) {
  return e.useMedium(t), If;
}
var Tf = x1(), Ms = function() {
}, Hi = h.forwardRef(function(e, t) {
  var n = h.useRef(null), o = h.useState({
    onScrollCapture: Ms,
    onWheelCapture: Ms,
    onTouchMoveCapture: Ms
  }), a = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, y = e.gapMode, _ = Nf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = m, x = _1([n, t]), S = Ut(Ut({}, _), a);
  return h.createElement(
    h.Fragment,
    null,
    u && h.createElement(k, { sideCar: Tf, removeScrollBar: c, shards: d, noIsolation: f, inert: g, setCallbacks: r, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    i ? h.cloneElement(h.Children.only(s), Ut(Ut({}, S), { ref: x })) : h.createElement(w, Ut({}, S, { className: l, ref: x }), s)
  );
});
Hi.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Hi.classNames = {
  fullWidth: Lr,
  zeroRight: Dr
};
var S1 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function C1() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = S1();
  return t && e.setAttribute("nonce", t), e;
}
function E1(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function A1(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var O1 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = C1()) && (E1(t, n), A1(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, z1 = function() {
  var e = O1();
  return function(t, n) {
    h.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Pf = function() {
  var e = z1(), t = function(n) {
    var o = n.styles, a = n.dynamic;
    return e(o, a), null;
  };
  return t;
}, N1 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Fs = function(e) {
  return parseInt(e || "", 10) || 0;
}, j1 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Fs(n), Fs(o), Fs(a)];
}, R1 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return N1;
  var t = j1(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, I1 = Pf(), jo = "data-scroll-locked", T1 = function(e, t, n, o) {
  var a = e.left, r = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(g1, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(jo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Dr, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Lr, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Dr, " .").concat(Dr, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Lr, " .").concat(Lr, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(jo, `] {
    `).concat(b1, ": ").concat(s, `px;
  }
`);
}, Wd = function() {
  var e = parseInt(document.body.getAttribute(jo) || "0", 10);
  return isFinite(e) ? e : 0;
}, P1 = function() {
  h.useEffect(function() {
    return document.body.setAttribute(jo, (Wd() + 1).toString()), function() {
      var e = Wd() - 1;
      e <= 0 ? document.body.removeAttribute(jo) : document.body.setAttribute(jo, e.toString());
    };
  }, []);
}, D1 = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, a = o === void 0 ? "margin" : o;
  P1();
  var r = h.useMemo(function() {
    return R1(a);
  }, [a]);
  return h.createElement(I1, { styles: T1(r, !t, a, n ? "" : "!important") });
}, Dl = !1;
if (typeof window < "u")
  try {
    var ar = Object.defineProperty({}, "passive", {
      get: function() {
        return Dl = !0, !0;
      }
    });
    window.addEventListener("test", ar, ar), window.removeEventListener("test", ar, ar);
  } catch {
    Dl = !1;
  }
var fo = Dl ? { passive: !1 } : !1, L1 = function(e) {
  return e.tagName === "TEXTAREA";
}, Df = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !L1(e) && n[t] === "visible")
  );
}, M1 = function(e) {
  return Df(e, "overflowY");
}, F1 = function(e) {
  return Df(e, "overflowX");
}, Bd = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var a = Lf(e, o);
    if (a) {
      var r = Mf(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, W1 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, B1 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Lf = function(e, t) {
  return e === "v" ? M1(t) : F1(t);
}, Mf = function(e, t) {
  return e === "v" ? W1(t) : B1(t);
}, V1 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, U1 = function(e, t, n, o, a) {
  var r = V1(e, window.getComputedStyle(t).direction), i = r * o, s = n.target, l = t.contains(s), c = !1, u = i > 0, d = 0, m = 0;
  do {
    var f = Mf(e, s), g = f[0], p = f[1], b = f[2], w = p - b - r * g;
    (g || w) && Lf(e, s) && (d += w, m += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(m) < 1) && (c = !0), c;
}, rr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Vd = function(e) {
  return [e.deltaX, e.deltaY];
}, Ud = function(e) {
  return e && "current" in e ? e.current : e;
}, q1 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, H1 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, K1 = 0, go = [];
function G1(e) {
  var t = h.useRef([]), n = h.useRef([0, 0]), o = h.useRef(), a = h.useState(K1++)[0], r = h.useState(Pf)[0], i = h.useRef(e);
  h.useEffect(function() {
    i.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = s1([e.lockRef.current], (e.shards || []).map(Ud)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = h.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = rr(p), y = n.current, _ = "deltaX" in p ? p.deltaX : y[0] - w[0], k = "deltaY" in p ? p.deltaY : y[1] - w[1], x, S = p.target, $ = Math.abs(_) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = Bd($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = Bd($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (_ || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return U1(C, b, p, C === "h" ? _ : k);
  }, []), l = h.useCallback(function(p) {
    var b = p;
    if (!(!go.length || go[go.length - 1] !== r)) {
      var w = "deltaY" in b ? Vd(b) : rr(b), y = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && q1(x.delta, w);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var _ = (i.current.shards || []).map(Ud).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = _.length > 0 ? s(b, _[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = h.useCallback(function(p, b, w, y) {
    var _ = { name: p, delta: b, target: w, should: y, shadowParent: Z1(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== _;
      });
    }, 1);
  }, []), u = h.useCallback(function(p) {
    n.current = rr(p), o.current = void 0;
  }, []), d = h.useCallback(function(p) {
    c(p.type, Vd(p), p.target, s(p, e.lockRef.current));
  }, []), m = h.useCallback(function(p) {
    c(p.type, rr(p), p.target, s(p, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return go.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, fo), document.addEventListener("touchmove", l, fo), document.addEventListener("touchstart", u, fo), function() {
      go = go.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, fo), document.removeEventListener("touchmove", l, fo), document.removeEventListener("touchstart", u, fo);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    g ? h.createElement(r, { styles: H1(a) }) : null,
    f ? h.createElement(D1, { gapMode: e.gapMode }) : null
  );
}
function Z1(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const J1 = $1(Tf, G1);
var Ff = h.forwardRef(function(e, t) {
  return h.createElement(Hi, Ut({}, e, { ref: t, sideCar: J1 }));
});
Ff.classNames = Hi.classNames;
var Y1 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, bo = /* @__PURE__ */ new WeakMap(), ir = /* @__PURE__ */ new WeakMap(), sr = {}, Ws = 0, Wf = function(e) {
  return e && (e.host || Wf(e.parentNode));
}, X1 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Wf(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Q1 = function(e, t, n, o) {
  var a = X1(t, Array.isArray(e) ? e : [e]);
  sr[n] || (sr[n] = /* @__PURE__ */ new WeakMap());
  var r = sr[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(a), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  a.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var f = m.getAttribute(o), g = f !== null && f !== "false", p = (bo.get(m) || 0) + 1, b = (r.get(m) || 0) + 1;
          bo.set(m, p), r.set(m, b), i.push(m), p === 1 && g && ir.set(m, !0), b === 1 && m.setAttribute(n, "true"), g || m.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return u(t), s.clear(), Ws++, function() {
    i.forEach(function(d) {
      var m = bo.get(d) - 1, f = r.get(d) - 1;
      bo.set(d, m), r.set(d, f), m || (ir.has(d) || d.removeAttribute(o), ir.delete(d)), f || d.removeAttribute(n);
    }), Ws--, Ws || (bo = /* @__PURE__ */ new WeakMap(), bo = /* @__PURE__ */ new WeakMap(), ir = /* @__PURE__ */ new WeakMap(), sr = {});
  };
}, e0 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = Y1(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), Q1(o, a, n, "aria-hidden")) : function() {
    return null;
  };
}, Ki = "Dialog", [Bf, lye] = co(Ki), [t0, Dt] = Bf(Ki), Vf = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: a,
    onOpenChange: r,
    modal: i = !0
  } = e, s = h.useRef(null), l = h.useRef(null), [c, u] = Da({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: Ki
  });
  return /* @__PURE__ */ v(
    t0,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: qn(),
      titleId: qn(),
      descriptionId: qn(),
      open: c,
      onOpenChange: u,
      onOpenToggle: h.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: n
    }
  );
};
Vf.displayName = Ki;
var Uf = "DialogTrigger", n0 = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Dt(Uf, n), r = Fe(t, a.triggerRef);
    return /* @__PURE__ */ v(
      be.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": qc(a.open),
        ...o,
        ref: r,
        onClick: me(e.onClick, a.onOpenToggle)
      }
    );
  }
);
n0.displayName = Uf;
var Vc = "DialogPortal", [o0, qf] = Bf(Vc, {
  forceMount: void 0
}), Hf = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: a } = e, r = Dt(Vc, t);
  return /* @__PURE__ */ v(o0, { scope: t, forceMount: n, children: h.Children.map(o, (i) => /* @__PURE__ */ v(wt, { present: n || r.open, children: /* @__PURE__ */ v(zf, { asChild: !0, container: a, children: i }) })) });
};
Hf.displayName = Vc;
var ri = "DialogOverlay", Kf = h.forwardRef(
  (e, t) => {
    const n = qf(ri, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Dt(ri, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(wt, { present: o || r.open, children: /* @__PURE__ */ v(r0, { ...a, ref: t }) }) : null;
  }
);
Kf.displayName = ri;
var a0 = /* @__PURE__ */ ai("DialogOverlay.RemoveScroll"), r0 = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Dt(ri, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(Ff, { as: a0, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ v(
        be.div,
        {
          "data-state": qc(a.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Gn = "DialogContent", Gf = h.forwardRef(
  (e, t) => {
    const n = qf(Gn, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Dt(Gn, e.__scopeDialog);
    return /* @__PURE__ */ v(wt, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(i0, { ...a, ref: t }) : /* @__PURE__ */ v(s0, { ...a, ref: t }) });
  }
);
Gf.displayName = Gn;
var i0 = h.forwardRef(
  (e, t) => {
    const n = Dt(Gn, e.__scopeDialog), o = h.useRef(null), a = Fe(t, n.contentRef, o);
    return h.useEffect(() => {
      const r = o.current;
      if (r) return e0(r);
    }, []), /* @__PURE__ */ v(
      Zf,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: me(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: me(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: me(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), s0 = h.forwardRef(
  (e, t) => {
    const n = Dt(Gn, e.__scopeDialog), o = h.useRef(!1), a = h.useRef(!1);
    return /* @__PURE__ */ v(
      Zf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || n.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, a.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = r.target;
          n.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && a.current && r.preventDefault();
        }
      }
    );
  }
), Zf = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: r, ...i } = e, s = Dt(Gn, n), l = h.useRef(null), c = Fe(t, l);
    return f1(), /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        jf,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: a,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            Bc,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": qc(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ P(je, { children: [
        /* @__PURE__ */ v(u0, { titleId: s.titleId }),
        /* @__PURE__ */ v(h0, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Uc = "DialogTitle", l0 = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Dt(Uc, n);
    return /* @__PURE__ */ v(be.h2, { id: a.titleId, ...o, ref: t });
  }
);
l0.displayName = Uc;
var Jf = "DialogDescription", c0 = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Dt(Jf, n);
    return /* @__PURE__ */ v(be.p, { id: a.descriptionId, ...o, ref: t });
  }
);
c0.displayName = Jf;
var Yf = "DialogClose", Xf = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Dt(Yf, n);
    return /* @__PURE__ */ v(
      be.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: me(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Xf.displayName = Yf;
function qc(e) {
  return e ? "open" : "closed";
}
var Qf = "DialogTitleWarning", [cye, eg] = kx(Qf, {
  contentName: Gn,
  titleName: Uc,
  docsSlug: "dialog"
}), u0 = ({ titleId: e }) => {
  const t = eg(Qf), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return h.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, d0 = "DialogDescriptionWarning", h0 = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${eg(d0).contentName}}.`;
  return h.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, p0 = Vf, m0 = Hf, f0 = Kf, g0 = Gf, b0 = Xf;
function v0(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function y0(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var Hc = "ScrollArea", [tg, uye] = co(Hc), [_0, Et] = tg(Hc), ng = h.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: a,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = h.useState(null), [c, u] = h.useState(null), [d, m] = h.useState(null), [f, g] = h.useState(null), [p, b] = h.useState(null), [w, y] = h.useState(0), [_, k] = h.useState(0), [x, S] = h.useState(!1), [$, E] = h.useState(!1), C = Fe(t, (I) => l(I)), A = qi(a);
    return /* @__PURE__ */ v(
      _0,
      {
        scope: n,
        type: o,
        dir: A,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: m,
        scrollbarX: f,
        onScrollbarXChange: g,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: y,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          be.div,
          {
            dir: A,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
ng.displayName = Hc;
var og = "ScrollAreaViewport", ag = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: a, ...r } = e, i = Et(og, n), s = h.useRef(null), l = Fe(t, s, i.onViewportChange);
    return /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ v(
        be.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
ag.displayName = og;
var Jt = "ScrollAreaScrollbar", w0 = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = Et(Jt, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = a, s = e.orientation === "horizontal";
    return h.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), a.type === "hover" ? /* @__PURE__ */ v(k0, { ...o, ref: t, forceMount: n }) : a.type === "scroll" ? /* @__PURE__ */ v(x0, { ...o, ref: t, forceMount: n }) : a.type === "auto" ? /* @__PURE__ */ v(rg, { ...o, ref: t, forceMount: n }) : a.type === "always" ? /* @__PURE__ */ v(Kc, { ...o, ref: t }) : null;
  }
);
w0.displayName = Jt;
var k0 = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = Et(Jt, e.__scopeScrollArea), [r, i] = h.useState(!1);
  return h.useEffect(() => {
    const s = a.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), a.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ v(wt, { present: n || r, children: /* @__PURE__ */ v(
    rg,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), x0 = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = Et(Jt, e.__scopeScrollArea), r = e.orientation === "horizontal", i = Zi(() => l("SCROLL_END"), 100), [s, l] = y0("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return h.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, a.scrollHideDelay, l]), h.useEffect(() => {
    const c = a.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const m = () => {
        const f = c[u];
        d !== f && (l("SCROLL"), i()), d = f;
      };
      return c.addEventListener("scroll", m), () => c.removeEventListener("scroll", m);
    }
  }, [a.viewport, r, l, i]), /* @__PURE__ */ v(wt, { present: n || s !== "hidden", children: /* @__PURE__ */ v(
    Kc,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: me(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: me(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), rg = h.forwardRef((e, t) => {
  const n = Et(Jt, e.__scopeScrollArea), { forceMount: o, ...a } = e, [r, i] = h.useState(!1), s = e.orientation === "horizontal", l = Zi(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Lo(n.viewport, l), Lo(n.content, l), /* @__PURE__ */ v(wt, { present: o || r, children: /* @__PURE__ */ v(
    Kc,
    {
      "data-state": r ? "visible" : "hidden",
      ...a,
      ref: t
    }
  ) });
}), Kc = h.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, a = Et(Jt, e.__scopeScrollArea), r = h.useRef(null), i = h.useRef(0), [s, l] = h.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = lg(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (m) => r.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function d(m, f) {
    return N0(m, i.current, s, f);
  }
  return n === "horizontal" ? /* @__PURE__ */ v(
    $0,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollLeft, f = qd(m, s, a.dir);
          r.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = d(m, a.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ v(
    S0,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollTop, f = qd(m, s);
          r.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = d(m));
      }
    }
  ) : null;
}), $0 = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = Et(Jt, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = Fe(t, l, r.onScrollbarXChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    sg,
    {
      "data-orientation": "horizontal",
      ...a,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Gi(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(m), ug(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: si(i.paddingLeft),
            paddingEnd: si(i.paddingRight)
          }
        });
      }
    }
  );
}), S0 = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = Et(Jt, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = Fe(t, l, r.onScrollbarYChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    sg,
    {
      "data-orientation": "vertical",
      ...a,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Gi(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(m), ug(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: si(i.paddingTop),
            paddingEnd: si(i.paddingBottom)
          }
        });
      }
    }
  );
}), [C0, ig] = tg(Jt), sg = h.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: a,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...m
  } = e, f = Et(Jt, n), [g, p] = h.useState(null), b = Fe(t, (C) => p(C)), w = h.useRef(null), y = h.useRef(""), _ = f.viewport, k = o.content - o.viewport, x = qe(u), S = qe(l), $ = Zi(d, 10);
  function E(C) {
    if (w.current) {
      const A = C.clientX - w.current.left, I = C.clientY - w.current.top;
      c({ x: A, y: I });
    }
  }
  return h.useEffect(() => {
    const C = (A) => {
      const I = A.target;
      g?.contains(I) && x(A, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [_, g, k, x]), h.useEffect(S, [o, S]), Lo(g, $), Lo(f.content, $), /* @__PURE__ */ v(
    C0,
    {
      scope: n,
      scrollbar: g,
      hasThumb: a,
      onThumbChange: qe(r),
      onThumbPointerUp: qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: qe(s),
      children: /* @__PURE__ */ v(
        be.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: me(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = g.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: me(e.onPointerMove, E),
          onPointerUp: me(e.onPointerUp, (C) => {
            const A = C.target;
            A.hasPointerCapture(C.pointerId) && A.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = y.current, f.viewport && (f.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), ii = "ScrollAreaThumb", E0 = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = ig(ii, e.__scopeScrollArea);
    return /* @__PURE__ */ v(wt, { present: n || a.hasThumb, children: /* @__PURE__ */ v(A0, { ref: t, ...o }) });
  }
), A0 = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...a } = e, r = Et(ii, n), i = ig(ii, n), { onThumbPositionChange: s } = i, l = Fe(
      t,
      (d) => i.onThumbChange(d)
    ), c = h.useRef(void 0), u = Zi(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return h.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const m = () => {
          if (u(), !c.current) {
            const f = j0(d, s);
            c.current = f, s();
          }
        };
        return s(), d.addEventListener("scroll", m), () => d.removeEventListener("scroll", m);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      be.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...a,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: me(e.onPointerDownCapture, (d) => {
          const m = d.target.getBoundingClientRect(), f = d.clientX - m.left, g = d.clientY - m.top;
          i.onThumbPointerDown({ x: f, y: g });
        }),
        onPointerUp: me(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
E0.displayName = ii;
var Gc = "ScrollAreaCorner", O0 = h.forwardRef(
  (e, t) => {
    const n = Et(Gc, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ v(z0, { ...e, ref: t }) : null;
  }
);
O0.displayName = Gc;
var z0 = h.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, a = Et(Gc, n), [r, i] = h.useState(0), [s, l] = h.useState(0), c = !!(r && s);
  return Lo(a.scrollbarX, () => {
    const u = a.scrollbarX?.offsetHeight || 0;
    a.onCornerHeightChange(u), l(u);
  }), Lo(a.scrollbarY, () => {
    const u = a.scrollbarY?.offsetWidth || 0;
    a.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    be.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function si(e) {
  return e ? parseInt(e, 10) : 0;
}
function lg(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Gi(e) {
  const t = lg(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function N0(e, t, n, o = "ltr") {
  const a = Gi(n), r = a / 2, i = t || r, s = a - i, l = n.scrollbar.paddingStart + i, c = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return cg([l, c], d)(e);
}
function qd(e, t, n = "ltr") {
  const o = Gi(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - a, i = t.content - t.viewport, s = r - o, l = n === "ltr" ? [0, i] : [i * -1, 0], c = v0(e, l);
  return cg([0, i], [0, s])(c);
}
function cg(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function ug(e, t) {
  return e > 0 && e < t;
}
var j0 = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function a() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== r.left, s = n.top !== r.top;
    (i || s) && t(), n = r, o = window.requestAnimationFrame(a);
  }(), () => window.cancelAnimationFrame(o);
};
function Zi(e, t) {
  const n = qe(e), o = h.useRef(0);
  return h.useEffect(() => () => window.clearTimeout(o.current), []), h.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Lo(e, t) {
  const n = qe(t);
  dn(() => {
    let o = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(o), a.unobserve(e);
      };
    }
  }, [e, n]);
}
var R0 = ng, I0 = ag, T0 = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), P0 = "VisuallyHidden", dg = h.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    be.span,
    {
      ...e,
      ref: t,
      style: { ...T0, ...e.style }
    }
  )
);
dg.displayName = P0;
var D0 = dg;
const L0 = "_divider_dlgq8_29", M0 = "_dashed_dlgq8_61", ra = {
  divider: L0,
  "small-space": "_small-space_dlgq8_35",
  "medium-space": "_medium-space_dlgq8_38",
  "no-space": "_no-space_dlgq8_41",
  "with-text": "_with-text_dlgq8_44",
  dashed: M0,
  "divider-text": "_divider-text_dlgq8_70",
  "dialog-overlay-show": "_dialog-overlay-show_dlgq8_1",
  "dialog-content-show": "_dialog-content-show_dlgq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dlgq8_1"
};
function F0({ className: e, text: t, dashed: n, space: o = "medium", ...a }) {
  const r = ze(
    ra.divider,
    ra[`${o}-space`],
    t && ra["with-text"],
    n && ra.dashed,
    e
  );
  return /* @__PURE__ */ v("div", { className: r, role: "separator", "aria-label": t || "divider", ...a, children: t && /* @__PURE__ */ v("span", { className: ra["divider-text"], children: t }) });
}
function Ll(e) {
  return e.replace(/\s/g, "-");
}
function hg(e, t) {
  return Ll(`${t}-${e}`);
}
function W0(e) {
  const [t, n] = Ne([]);
  return Se(() => {
    const o = [];
    let a = 0;
    for (const r of e) {
      const i = document.getElementById(hg(r.title, a));
      i && (o.push(i.clientWidth), a++);
    }
    n(o);
  }, [e]), t;
}
function B0(e) {
  return Do(() => e.map((t, n) => ({
    ...t,
    value: hg(t.title, n)
  })), [e]);
}
function V0(e = 0) {
  const [t, n] = Ne(e);
  return {
    activeTabIndex: t,
    setActiveTabIndex: n
  };
}
var Ji = "Tabs", [U0, dye] = co(Ji, [
  xf
]), pg = xf(), [q0, Zc] = U0(Ji), mg = h.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: a,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = qi(s), [d, m] = Da({
      prop: o,
      onChange: a,
      defaultProp: r ?? "",
      caller: Ji
    });
    return /* @__PURE__ */ v(
      q0,
      {
        scope: n,
        baseId: qn(),
        value: d,
        onValueChange: m,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          be.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
mg.displayName = Ji;
var fg = "TabsList", gg = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...a } = e, r = Zc(fg, n), i = pg(n);
    return /* @__PURE__ */ v(
      Hx,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          be.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
gg.displayName = fg;
var bg = "TabsTrigger", vg = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: a = !1, ...r } = e, i = Zc(bg, n), s = pg(n), l = wg(i.baseId, o), c = kg(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      Kx,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ v(
          be.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: l,
            ...r,
            ref: t,
            onMouseDown: me(e.onMouseDown, (d) => {
              !a && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: me(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: me(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !a && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
vg.displayName = bg;
var yg = "TabsContent", _g = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: a, children: r, ...i } = e, s = Zc(yg, n), l = wg(s.baseId, o), c = kg(s.baseId, o), u = o === s.value, d = h.useRef(u);
    return h.useEffect(() => {
      const m = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ v(wt, { present: a || u, children: ({ present: m }) => /* @__PURE__ */ v(
      be.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !m,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: m && r
      }
    ) });
  }
);
_g.displayName = yg;
function wg(e, t) {
  return `${e}-trigger-${t}`;
}
function kg(e, t) {
  return `${e}-content-${t}`;
}
var H0 = mg, K0 = gg, G0 = vg, Z0 = _g;
const J0 = "_tabs_11da8_29", Wt = {
  tabs: J0,
  "is-full-width": "_is-full-width_11da8_32",
  "tabs-content": "_tabs-content_11da8_35",
  "tabs-list": "_tabs-list_11da8_38",
  "is-small": "_is-small_11da8_41",
  "tabs-trigger-list": "_tabs-trigger-list_11da8_44",
  "tabs-trigger": "_tabs-trigger_11da8_44",
  "is-medium": "_is-medium_11da8_67",
  "tabs-underline": "_tabs-underline_11da8_77",
  "tabs-divider": "_tabs-divider_11da8_86",
  "dialog-overlay-show": "_dialog-overlay-show_11da8_1",
  "dialog-content-show": "_dialog-content-show_11da8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11da8_1"
};
function Y0({
  tabs: e,
  isFullWidth: t,
  size: n = "medium",
  className: o = "",
  tabIndex: a = 0,
  onTabChange: r,
  ...i
}) {
  const { activeTabIndex: s, setActiveTabIndex: l } = V0(a), c = B0(e), u = W0(e), d = ze(Wt.tabs, t && Wt["is-full-width"], o), m = ze(Wt["tabs-trigger"], n && Wt[`is-${n}`]);
  return /* @__PURE__ */ P(
    H0,
    {
      onValueChange: (f) => {
        const g = c.findIndex((p) => Ll(p.value) === f);
        l(g), r?.(g);
      },
      className: d,
      defaultValue: c[s]?.value,
      orientation: "horizontal",
      ...i,
      children: [
        /* @__PURE__ */ v(R0, { children: /* @__PURE__ */ v(I0, { children: /* @__PURE__ */ P(K0, { className: ze(Wt["tabs-list"], n === "small" && Wt["is-small"]), children: [
          /* @__PURE__ */ P("div", { className: Wt["tabs-trigger-list"], children: [
            c.map((f) => {
              const g = f.value;
              return /* @__PURE__ */ v(
                G0,
                {
                  id: g,
                  "aria-controls": g,
                  "aria-labelledby": g,
                  className: m,
                  value: g,
                  children: f.title
                },
                g
              );
            }),
            /* @__PURE__ */ v(
              "span",
              {
                className: Wt["tabs-underline"],
                style: {
                  width: u[s],
                  transform: `translateX(${u.slice(0, s).reduce((f, g) => f + g, 0) + s * 16}px)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ v("div", { className: Wt["tabs-divider"] })
        ] }) }) }),
        c.map((f) => {
          const g = Ll(f.value);
          return /* @__PURE__ */ v(Z0, { className: Wt["tabs-content"], "aria-labelledby": g, value: g, children: f.content }, g);
        })
      ]
    }
  );
}
const X0 = "_drawer_1xu3v_29", Bs = {
  "drawer-overlay": "_drawer-overlay_1xu3v_29",
  drawer: X0,
  "drawer-close": "_drawer-close_1xu3v_60"
};
function Q0({ children: e, isOpen: t, onClose: n, className: o }) {
  const a = ze(Bs.drawer, o);
  return /* @__PURE__ */ v(p0, { defaultOpen: t, open: t, children: /* @__PURE__ */ P(m0, { children: [
    /* @__PURE__ */ v(f0, { className: Bs["drawer-overlay"], onClick: n }),
    /* @__PURE__ */ P(g0, { className: a, children: [
      e,
      /* @__PURE__ */ v(b0, { asChild: !0, children: /* @__PURE__ */ v("button", { onClick: n, className: Bs["drawer-close"], "aria-label": "Close", children: /* @__PURE__ */ v($e, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
var Jc = "Progress", Yc = 100, [e$, hye] = co(Jc), [t$, n$] = e$(Jc), xg = h.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: a,
      getValueLabel: r = o$,
      ...i
    } = e;
    (a || a === 0) && !Hd(a) && console.error(a$(`${a}`, "Progress"));
    const s = Hd(a) ? a : Yc;
    o !== null && !Kd(o, s) && console.error(r$(`${o}`, "Progress"));
    const l = Kd(o, s) ? o : null, c = li(l) ? r(l, s) : void 0;
    return /* @__PURE__ */ v(t$, { scope: n, value: l, max: s, children: /* @__PURE__ */ v(
      be.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": li(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": Cg(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
xg.displayName = Jc;
var $g = "ProgressIndicator", Sg = h.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, a = n$($g, n);
    return /* @__PURE__ */ v(
      be.div,
      {
        "data-state": Cg(a.value, a.max),
        "data-value": a.value ?? void 0,
        "data-max": a.max,
        ...o,
        ref: t
      }
    );
  }
);
Sg.displayName = $g;
function o$(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Cg(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function li(e) {
  return typeof e == "number";
}
function Hd(e) {
  return li(e) && !isNaN(e) && e > 0;
}
function Kd(e, t) {
  return li(e) && !isNaN(e) && e <= t && e >= 0;
}
function a$(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Yc}\`.`;
}
function r$(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Yc} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var i$ = xg, s$ = Sg;
const l$ = "_small_ghhu4_36", c$ = "_indicator_ghhu4_40", u$ = "_primary_ghhu4_49", d$ = "_secondary_ghhu4_55", h$ = "_tertiary_ghhu4_61", p$ = "_success_ghhu4_67", m$ = "_error_ghhu4_79", ia = {
  "progress-bar": "_progress-bar_ghhu4_29",
  small: l$,
  indicator: c$,
  "full-width": "_full-width_ghhu4_46",
  primary: u$,
  secondary: d$,
  tertiary: h$,
  success: p$,
  "eco-green": "_eco-green_ghhu4_73",
  error: m$,
  "dialog-overlay-show": "_dialog-overlay-show_ghhu4_1",
  "dialog-content-show": "_dialog-content-show_ghhu4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_ghhu4_1"
}, Gd = ({ value: e = 0, color: t = "primary", size: n, isFullWidth: o, ariaLabel: a }) => {
  const [r, i] = Ne(0), s = ze(
    ia["progress-bar"],
    n && ia[n],
    t && ia[t],
    o && ia["full-width"]
  );
  return Se(() => {
    const l = setTimeout(() => i(e), 500);
    return () => clearTimeout(l);
  }, [e]), /* @__PURE__ */ v(i$, { className: s, "aria-label": a, children: /* @__PURE__ */ v(s$, { className: ia.indicator, style: { transform: `translateX(-${100 - r}%)` } }) });
}, Zd = {
  "is-hidden-desktop": "_is-hidden-desktop_1m12x_29",
  "is-hidden-mobile": "_is-hidden-mobile_1m12x_40",
  "unset-ul": "_unset-ul_1m12x_54",
  "dialog-overlay-show": "_dialog-overlay-show_1m12x_1",
  "dialog-content-show": "_dialog-content-show_1m12x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1m12x_1"
}, Mo = ({ children: e, hideOn: t, className: n }) => {
  const o = ze(t && Zd[`is-hidden-${t}`], n);
  return /* @__PURE__ */ v("li", { className: o, children: /* @__PURE__ */ v("ul", { className: Zd["unset-ul"], children: e }) });
}, f$ = "_badge_zy4sa_29", g$ = "_root_zy4sa_58", sa = {
  badge: f$,
  "is-small": "_is-small_zy4sa_42",
  "has-child": "_has-child_zy4sa_48",
  "on-icon": "_on-icon_zy4sa_53",
  root: g$
};
function Xc({ value: e, isSmall: t = !1, onIcon: n = !1, children: o, className: a, ...r }) {
  const i = ze(
    sa.badge,
    t && sa["is-small"],
    n && sa["on-icon"],
    !!o && sa["has-child"],
    a
  );
  return o ? /* @__PURE__ */ P("span", { className: sa.root, ...r, children: [
    /* @__PURE__ */ v("span", { className: i, children: !t && e }),
    o
  ] }) : /* @__PURE__ */ v("span", { className: i, ...r, children: !t && e });
}
var uo = "NavigationMenu", [Qc, Eg, b$] = Wc(uo), [Ml, v$, y$] = Wc(uo), [eu, pye] = co(
  uo,
  [b$, y$]
), [_$, At] = eu(uo), [w$, k$] = eu(uo), Ag = h.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: a,
      defaultValue: r,
      delayDuration: i = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = e, [d, m] = h.useState(null), f = Fe(t, (C) => m(C)), g = qi(c), p = h.useRef(0), b = h.useRef(0), w = h.useRef(0), [y, _] = h.useState(!0), [k, x] = Da({
      prop: o,
      onChange: (C) => {
        const A = C !== "", I = s > 0;
        A ? (window.clearTimeout(w.current), I && _(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => _(!0),
          s
        )), a?.(C);
      },
      defaultProp: r ?? "",
      caller: uo
    }), S = h.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => x(""), 150);
    }, [x]), $ = h.useCallback(
      (C) => {
        window.clearTimeout(b.current), x(C);
      },
      [x]
    ), E = h.useCallback(
      (C) => {
        k === C ? window.clearTimeout(b.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(b.current), x(C);
        }, i);
      },
      [k, x, i]
    );
    return h.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(b.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ v(
      Og,
      {
        scope: n,
        isRootMenu: !0,
        value: k,
        dir: g,
        orientation: l,
        rootNavigationMenu: d,
        onTriggerEnter: (C) => {
          window.clearTimeout(p.current), y ? E(C) : $(C);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), S();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: S,
        onItemSelect: (C) => {
          x((A) => A === C ? "" : C);
        },
        onItemDismiss: () => x(""),
        children: /* @__PURE__ */ v(
          be.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: g,
            ...u,
            ref: f
          }
        )
      }
    );
  }
);
Ag.displayName = uo;
var Fl = "NavigationMenuSub", x$ = h.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: a,
      defaultValue: r,
      orientation: i = "horizontal",
      ...s
    } = e, l = At(Fl, n), [c, u] = Da({
      prop: o,
      onChange: a,
      defaultProp: r ?? "",
      caller: Fl
    });
    return /* @__PURE__ */ v(
      Og,
      {
        scope: n,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: i,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (d) => u(d),
        onItemSelect: (d) => u(d),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ v(be.div, { "data-orientation": i, ...s, ref: t })
      }
    );
  }
);
x$.displayName = Fl;
var Og = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    dir: a,
    orientation: r,
    children: i,
    value: s,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: d,
    onContentEnter: m,
    onContentLeave: f
  } = e, [g, p] = h.useState(null), [b, w] = h.useState(/* @__PURE__ */ new Map()), [y, _] = h.useState(null);
  return /* @__PURE__ */ v(
    _$,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: o,
      value: s,
      previousValue: Gx(s),
      baseId: qn(),
      dir: a,
      orientation: r,
      viewport: g,
      onViewportChange: p,
      indicatorTrack: y,
      onIndicatorTrackChange: _,
      onTriggerEnter: qe(u),
      onTriggerLeave: qe(d),
      onContentEnter: qe(m),
      onContentLeave: qe(f),
      onItemSelect: qe(l),
      onItemDismiss: qe(c),
      onViewportContentChange: h.useCallback((k, x) => {
        w((S) => (S.set(k, x), new Map(S)));
      }, []),
      onViewportContentRemove: h.useCallback((k) => {
        w((x) => x.has(k) ? (x.delete(k), new Map(x)) : x);
      }, []),
      children: /* @__PURE__ */ v(Qc.Provider, { scope: t, children: /* @__PURE__ */ v(w$, { scope: t, items: b, children: i }) })
    }
  );
}, zg = "NavigationMenuList", Ng = h.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, a = At(zg, n), r = /* @__PURE__ */ v(be.ul, { "data-orientation": a.orientation, ...o, ref: t });
    return /* @__PURE__ */ v(be.div, { style: { position: "relative" }, ref: a.onIndicatorTrackChange, children: /* @__PURE__ */ v(Qc.Slot, { scope: n, children: a.isRootMenu ? /* @__PURE__ */ v(Mg, { asChild: !0, children: r }) : r }) });
  }
);
Ng.displayName = zg;
var jg = "NavigationMenuItem", [$$, Rg] = eu(jg), Ig = h.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: o, ...a } = e, r = qn(), i = o || r || "LEGACY_REACT_AUTO_VALUE", s = h.useRef(null), l = h.useRef(null), c = h.useRef(null), u = h.useRef(() => {
    }), d = h.useRef(!1), m = h.useCallback((g = "start") => {
      if (s.current) {
        u.current();
        const p = Bl(s.current);
        p.length && ou(g === "start" ? p : p.reverse());
      }
    }, []), f = h.useCallback(() => {
      if (s.current) {
        const g = Bl(s.current);
        g.length && (u.current = R$(g));
      }
    }, []);
    return /* @__PURE__ */ v(
      $$,
      {
        scope: n,
        value: i,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: c,
        wasEscapeCloseRef: d,
        onEntryKeyDown: m,
        onFocusProxyEnter: m,
        onRootContentClose: f,
        onContentFocusOutside: f,
        children: /* @__PURE__ */ v(be.li, { ...a, ref: t })
      }
    );
  }
);
Ig.displayName = jg;
var Wl = "NavigationMenuTrigger", Tg = h.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...a } = e, r = At(Wl, e.__scopeNavigationMenu), i = Rg(Wl, e.__scopeNavigationMenu), s = h.useRef(null), l = Fe(s, i.triggerRef, t), c = Wg(r.baseId, i.value), u = Bg(r.baseId, i.value), d = h.useRef(!1), m = h.useRef(!1), f = i.value === r.value;
  return /* @__PURE__ */ P(je, { children: [
    /* @__PURE__ */ v(Qc.ItemSlot, { scope: n, value: i.value, children: /* @__PURE__ */ v(Fg, { asChild: !0, children: /* @__PURE__ */ v(
      be.button,
      {
        id: c,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": au(f),
        "aria-expanded": f,
        "aria-controls": u,
        ...a,
        ref: l,
        onPointerEnter: me(e.onPointerEnter, () => {
          m.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: me(
          e.onPointerMove,
          ci(() => {
            o || m.current || i.wasEscapeCloseRef.current || d.current || (r.onTriggerEnter(i.value), d.current = !0);
          })
        ),
        onPointerLeave: me(
          e.onPointerLeave,
          ci(() => {
            o || (r.onTriggerLeave(), d.current = !1);
          })
        ),
        onClick: me(e.onClick, () => {
          r.onItemSelect(i.value), m.current = f;
        }),
        onKeyDown: me(e.onKeyDown, (g) => {
          const p = { horizontal: "ArrowDown", vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[r.orientation];
          f && g.key === p && (i.onEntryKeyDown(), g.preventDefault());
        })
      }
    ) }) }),
    f && /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        D0,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (g) => {
            const p = i.contentRef.current, b = g.relatedTarget, w = b === s.current, y = p?.contains(b);
            (w || !y) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      r.viewport && /* @__PURE__ */ v("span", { "aria-owns": u })
    ] })
  ] });
});
Tg.displayName = Wl;
var S$ = "NavigationMenuLink", Jd = "navigationMenu.linkSelect", Pg = h.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: o, onSelect: a, ...r } = e;
    return /* @__PURE__ */ v(Fg, { asChild: !0, children: /* @__PURE__ */ v(
      be.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...r,
        ref: t,
        onClick: me(
          e.onClick,
          (i) => {
            const s = i.target, l = new CustomEvent(Jd, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(Jd, (c) => a?.(c), { once: !0 }), Il(s, l), !l.defaultPrevented && !i.metaKey) {
              const c = new CustomEvent(Mr, {
                bubbles: !0,
                cancelable: !0
              });
              Il(s, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Pg.displayName = S$;
var tu = "NavigationMenuIndicator", C$ = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = At(tu, e.__scopeNavigationMenu), r = !!a.value;
  return a.indicatorTrack ? Ui.createPortal(
    /* @__PURE__ */ v(wt, { present: n || r, children: /* @__PURE__ */ v(E$, { ...o, ref: t }) }),
    a.indicatorTrack
  ) : null;
});
C$.displayName = tu;
var E$ = h.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, a = At(tu, n), r = Eg(n), [i, s] = h.useState(
    null
  ), [l, c] = h.useState(null), u = a.orientation === "horizontal", d = !!a.value;
  h.useEffect(() => {
    const f = r().find((g) => g.value === a.value)?.ref.current;
    f && s(f);
  }, [r, a.value]);
  const m = () => {
    i && c({
      size: u ? i.offsetWidth : i.offsetHeight,
      offset: u ? i.offsetLeft : i.offsetTop
    });
  };
  return Vl(i, m), Vl(a.indicatorTrack, m), l ? /* @__PURE__ */ v(
    be.div,
    {
      "aria-hidden": !0,
      "data-state": d ? "visible" : "hidden",
      "data-orientation": a.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), Fo = "NavigationMenuContent", Dg = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = At(Fo, e.__scopeNavigationMenu), r = Rg(Fo, e.__scopeNavigationMenu), i = Fe(r.contentRef, t), s = r.value === a.value, l = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...o
  };
  return a.viewport ? /* @__PURE__ */ v(A$, { forceMount: n, ...l, ref: i }) : /* @__PURE__ */ v(wt, { present: n || s, children: /* @__PURE__ */ v(
    Lg,
    {
      "data-state": au(s),
      ...l,
      ref: i,
      onPointerEnter: me(e.onPointerEnter, a.onContentEnter),
      onPointerLeave: me(
        e.onPointerLeave,
        ci(a.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && a.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
Dg.displayName = Fo;
var A$ = h.forwardRef((e, t) => {
  const n = At(Fo, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: a } = n;
  return dn(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), dn(() => () => a(e.value), [e.value, a]), null;
}), Mr = "navigationMenu.rootContentDismiss", Lg = h.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: o,
    triggerRef: a,
    focusProxyRef: r,
    wasEscapeCloseRef: i,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...c
  } = e, u = At(Fo, n), d = h.useRef(null), m = Fe(d, t), f = Wg(u.baseId, o), g = Bg(u.baseId, o), p = Eg(n), b = h.useRef(null), { onItemDismiss: w } = u;
  h.useEffect(() => {
    const _ = d.current;
    if (u.isRootMenu && _) {
      const k = () => {
        w(), s(), _.contains(document.activeElement) && a.current?.focus();
      };
      return _.addEventListener(Mr, k), () => _.removeEventListener(Mr, k);
    }
  }, [u.isRootMenu, e.value, a, w, s]);
  const y = h.useMemo(() => {
    const _ = p().map((C) => C.value);
    u.dir === "rtl" && _.reverse();
    const k = _.indexOf(u.value), x = _.indexOf(u.previousValue), S = o === u.value, $ = x === _.indexOf(o);
    if (!S && !$) return b.current;
    const E = (() => {
      if (k !== x) {
        if (S && x !== -1) return k > x ? "from-end" : "from-start";
        if ($ && k !== -1) return k > x ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = E, E;
  }, [u.previousValue, u.value, u.dir, p, o]);
  return /* @__PURE__ */ v(Mg, { asChild: !0, children: /* @__PURE__ */ v(
    Bc,
    {
      id: g,
      "aria-labelledby": f,
      "data-motion": y,
      "data-orientation": u.orientation,
      ...c,
      ref: m,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const _ = new Event(Mr, {
          bubbles: !0,
          cancelable: !0
        });
        d.current?.dispatchEvent(_);
      },
      onFocusOutside: me(e.onFocusOutside, (_) => {
        l();
        const k = _.target;
        u.rootNavigationMenu?.contains(k) && _.preventDefault();
      }),
      onPointerDownOutside: me(e.onPointerDownOutside, (_) => {
        const k = _.target, x = p().some(($) => $.ref.current?.contains(k)), S = u.isRootMenu && u.viewport?.contains(k);
        (x || S || !u.isRootMenu) && _.preventDefault();
      }),
      onKeyDown: me(e.onKeyDown, (_) => {
        const k = _.altKey || _.ctrlKey || _.metaKey;
        if (_.key === "Tab" && !k) {
          const x = Bl(_.currentTarget), S = document.activeElement, $ = x.findIndex((C) => C === S), E = _.shiftKey ? x.slice(0, $).reverse() : x.slice($ + 1, x.length);
          ou(E) ? _.preventDefault() : r.current?.focus();
        }
      }),
      onEscapeKeyDown: me(e.onEscapeKeyDown, (_) => {
        i.current = !0;
      })
    }
  ) });
}), nu = "NavigationMenuViewport", O$ = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = !!At(nu, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ v(wt, { present: n || a, children: /* @__PURE__ */ v(z$, { ...o, ref: t }) });
});
O$.displayName = nu;
var z$ = h.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: o, ...a } = e, r = At(nu, n), i = Fe(t, r.onViewportChange), s = k$(
    Fo,
    e.__scopeNavigationMenu
  ), [l, c] = h.useState(null), [u, d] = h.useState(null), m = l ? l?.width + "px" : void 0, f = l ? l?.height + "px" : void 0, g = !!r.value, p = g ? r.value : r.previousValue;
  return Vl(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ v(
    be.div,
    {
      "data-state": au(g),
      "data-orientation": r.orientation,
      ...a,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !g && r.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": m,
        "--radix-navigation-menu-viewport-height": f,
        ...a.style
      },
      onPointerEnter: me(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: me(e.onPointerLeave, ci(r.onContentLeave)),
      children: Array.from(s.items).map(([b, { ref: w, forceMount: y, ..._ }]) => {
        const k = p === b;
        return /* @__PURE__ */ v(wt, { present: y || k, children: /* @__PURE__ */ v(
          Lg,
          {
            ..._,
            ref: Fc(w, (x) => {
              k && x && d(x);
            })
          }
        ) }, b);
      })
    }
  );
}), N$ = "FocusGroup", Mg = h.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, a = At(N$, n);
    return /* @__PURE__ */ v(Ml.Provider, { scope: n, children: /* @__PURE__ */ v(Ml.Slot, { scope: n, children: /* @__PURE__ */ v(be.div, { dir: a.dir, ...o, ref: t }) }) });
  }
), Yd = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], j$ = "FocusGroupItem", Fg = h.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, a = v$(n), r = At(j$, n);
    return /* @__PURE__ */ v(Ml.ItemSlot, { scope: n, children: /* @__PURE__ */ v(
      be.button,
      {
        ...o,
        ref: t,
        onKeyDown: me(e.onKeyDown, (i) => {
          if (["Home", "End", ...Yd].includes(i.key)) {
            let s = a().map((l) => l.ref.current);
            if ([r.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && s.reverse(), Yd.includes(i.key)) {
              const l = s.indexOf(i.currentTarget);
              s = s.slice(l + 1);
            }
            setTimeout(() => ou(s)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function Bl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ou(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function R$(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Vl(e, t) {
  const n = qe(t);
  dn(() => {
    let o = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(o), a.unobserve(e);
      };
    }
  }, [e, n]);
}
function au(e) {
  return e ? "open" : "closed";
}
function Wg(e, t) {
  return `${e}-trigger-${t}`;
}
function Bg(e, t) {
  return `${e}-content-${t}`;
}
function ci(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var I$ = Ag, T$ = Ng, ui = Ig, P$ = Tg, D$ = Pg, L$ = Dg;
const M$ = "_arrow_1367h_117", F$ = "_navbar_1367h_29", xe = {
  "navbar-item": "_navbar-item_1367h_29",
  "navbar-item-background-hover": "_navbar-item-background-hover_1367h_33",
  "navbar-drawer": "_navbar-drawer_1367h_37",
  "first-on-mobile": "_first-on-mobile_1367h_52",
  "second-on-mobile": "_second-on-mobile_1367h_61",
  "navbar-end": "_navbar-end_1367h_70",
  "navbar-item-wrapper": "_navbar-item-wrapper_1367h_89",
  "navbar-item-flex-grow": "_navbar-item-flex-grow_1367h_105",
  "navbar-item-button": "_navbar-item-button_1367h_108",
  arrow: M$,
  "navbar-has-dropdown": "_navbar-has-dropdown_1367h_130",
  "navbar-dropdown": "_navbar-dropdown_1367h_156",
  "is-size-small": "_is-size-small_1367h_161",
  "is-size-medium": "_is-size-medium_1367h_164",
  "navbar-item-no-padding-top-bottom": "_navbar-item-no-padding-top-bottom_1367h_191",
  "navbar-item-is-right": "_navbar-item-is-right_1367h_195",
  "navbar-item-is-center": "_navbar-item-is-center_1367h_200",
  "navbar-item-no-padding": "_navbar-item-no-padding_1367h_191",
  "is-right": "_is-right_1367h_207",
  "is-left": "_is-left_1367h_211",
  navbar: F$,
  "is-fixed-top": "_is-fixed-top_1367h_228",
  "navbar-burger": "_navbar-burger_1367h_241",
  "navbar-menu": "_navbar-menu_1367h_282",
  "burger-close": "_burger-close_1367h_296",
  "navbar-start": "_navbar-start_1367h_316",
  "unset-li": "_unset-li_1367h_350",
  "margin-auto-top": "_margin-auto-top_1367h_357",
  "navbar-item-larger-padding-bottom": "_navbar-item-larger-padding-bottom_1367h_366",
  "dialog-overlay-show": "_dialog-overlay-show_1367h_1",
  "dialog-content-show": "_dialog-content-show_1367h_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1367h_1"
}, Vg = ({ children: e, isFixedTop: t }) => /* @__PURE__ */ v(I$, { children: /* @__PURE__ */ v(T$, { className: ze(xe.navbar, t && xe["is-fixed-top"]), children: e }) }), Ug = ({ children: e, notificationValue: t }) => {
  const { value: n, toggle: o } = Zx(), { isMobile: a, isTablet: r } = Yx();
  return /* @__PURE__ */ P(je, { children: [
    (a || r) && /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(ue, { children: t ? /* @__PURE__ */ v(Xc, { value: t, isSmall: !0, children: /* @__PURE__ */ P("button", { onClick: o, className: xe["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }) : /* @__PURE__ */ P("button", { onClick: o, className: xe["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }),
      /* @__PURE__ */ v(Q0, { isOpen: n, onClose: o, className: ze(xe["navbar-drawer"]), children: e })
    ] }),
    /* @__PURE__ */ v("li", { className: ze(xe["navbar-menu"]), children: /* @__PURE__ */ P("ul", { children: [
      /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v("button", { className: xe["burger-close"], onClick: o, "aria-label": "burger-close", children: /* @__PURE__ */ v($e, { name: "remove", size: "large" }) }) }),
      e
    ] }) })
  ] });
}, ue = ({
  children: e,
  href: t,
  hideOn: n,
  isFirstOnMobile: o,
  isSecondOnMobile: a,
  noPaddingRight: r,
  largerPaddingBottom: i,
  noTopBottomPadding: s,
  onClick: l,
  marginAutoTop: c,
  isButton: u,
  backgroundOnHover: d = !0,
  isFlexGrow: m = !1
}) => {
  const f = ze(
    c && xe["margin-auto-top"],
    o && xe["first-on-mobile"],
    a && xe["second-on-mobile"],
    r && xe["navbar-item-no-padding"],
    u && xe["navbar-item-button"],
    s && xe["navbar-item-no-padding-top-bottom"],
    i && xe["navbar-item-larger-padding-bottom"],
    d && xe["navbar-item-background-hover"],
    m && xe["navbar-item-flex-grow"]
  ), g = t ? /* @__PURE__ */ v(ui, { onClick: l, className: ze(xe["navbar-item-wrapper"], f), children: /* @__PURE__ */ v(D$, { className: ze(xe["navbar-item"], f), href: t, children: e }) }) : /* @__PURE__ */ v(ui, { onClick: l, className: ze(xe["navbar-item"], f), children: e });
  return n ? /* @__PURE__ */ v(Mo, { hideOn: n, className: ze(xe["navbar-item-wrapper"], f), children: g }) : g;
}, qg = ({ children: e, position: t }) => {
  const n = ze(t && xe[`navbar-${t}`]);
  return /* @__PURE__ */ v("li", { className: n, children: /* @__PURE__ */ v("ul", { className: n, children: e }) });
}, ru = ({ children: e, hideOn: t }) => {
  const n = ze(xe["navbar-has-dropdown"], xe["navbar-item-wrapper"]);
  return t ? /* @__PURE__ */ v(Mo, { hideOn: t, className: xe["navbar-item-wrapper"], children: /* @__PURE__ */ v(ui, { className: n, children: e }) }) : /* @__PURE__ */ v(ui, { className: n, children: e });
}, iu = ({ children: e }) => /* @__PURE__ */ v(P$, { className: xe["navbar-item"], children: /* @__PURE__ */ P(ce, { gap: "2", alignItems: "center", isFullWidth: !0, justifyContent: "space-between", children: [
  e,
  /* @__PURE__ */ v($e, { name: "up-arrow", size: "small", className: xe.arrow })
] }) }), su = ({ children: e, size: t, align: n = "right" }) => {
  const o = ze(
    xe["navbar-dropdown"],
    xe[`is-${n}`],
    xe["navbar-item"],
    t && xe[`is-size-${t}`]
  );
  return /* @__PURE__ */ v(L$, { className: o, children: /* @__PURE__ */ v("ul", { children: e }) });
}, Xd = {
  "unset-list": "_unset-list_50wvn_29",
  "navbar-brand": "_navbar-brand_50wvn_38"
}, Hg = ({ children: e }) => /* @__PURE__ */ v("li", { className: Xd["unset-list"], children: /* @__PURE__ */ v("ul", { className: Xd["navbar-brand"], children: e }) }), Vs = {
  "unset-list": "_unset-list_g6gr1_29",
  "navbar-divider": "_navbar-divider_g6gr1_35"
}, Oo = ({ hideOn: e }) => {
  const t = ze(Vs["navbar-divider"]);
  return e ? /* @__PURE__ */ v(Mo, { hideOn: e, children: /* @__PURE__ */ v("li", { className: Vs["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) }) }) : /* @__PURE__ */ v("li", { className: Vs["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) });
}, W$ = {
  "dropdown-divider": "_dropdown-divider_6mcrd_29"
}, St = () => /* @__PURE__ */ v("hr", { className: ze(W$["dropdown-divider"]) }), B$ = "_avatar_1ikzc_29", Qd = {
  avatar: B$,
  "is-xsmall": "_is-xsmall_1ikzc_32",
  "is-small": "_is-small_1ikzc_36",
  "is-medium": "_is-medium_1ikzc_40",
  "is-large": "_is-large_1ikzc_44",
  "dialog-overlay-show": "_dialog-overlay-show_1ikzc_1",
  "dialog-content-show": "_dialog-content-show_1ikzc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ikzc_1"
};
function Kg({ url: e, alt: t, size: n = "medium", className: o, ...a }) {
  const r = ze(Qd.avatar, n && Qd[`is-${n}`], o);
  return /* @__PURE__ */ v("img", { className: r, src: e, alt: t, ...a });
}
const eh = {
  "communication-banner": "_communication-banner_2kn0i_1"
};
function V$({ text: e, url: t }) {
  return /* @__PURE__ */ v("a", { href: t, children: /* @__PURE__ */ P("div", { className: eh["communication-banner"], children: [
    /* @__PURE__ */ v("p", { children: e }),
    /* @__PURE__ */ v($e, { size: "2xl", name: "angle-right", className: eh.icon })
  ] }) });
}
function Gg(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Gg(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function U$() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Gg(e)) && (o && (o += " "), o += t);
  return o;
}
const q$ = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], H$ = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, K$ = q$.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: H$[e]
})), G$ = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Z$ = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function J$(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const Y$ = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = K$.find((l) => l.name === e), s = U$("icon", `ds-${i?.class}`, Z$[t], G$[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: J$(i?.paths) });
  }
);
Y$.displayName = "Icon";
const X$ = ["en", "fr", "it"], Zg = Pt({
  locale: "en"
});
function Jg({ children: e, ...t }) {
  return /* @__PURE__ */ v(Zg.Provider, { value: t, children: e });
}
const Q$ = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function eS(e) {
  return X$.includes(e) && !0;
}
function tS(e, t) {
  const n = Q$.test(t);
  let o;
  return eS(e) || n ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function Ae(e) {
  const { locale: t } = io(Zg);
  return tS(t, e);
}
let th = class extends Error {
  code;
  errorData;
  constructor(t, n, o) {
    super(t), this.name = "HeError", this.code = n, this.errorData = o;
  }
};
function Yg(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: nS } = Object.prototype, { getPrototypeOf: lu } = Object, { iterator: Yi, toStringTag: Xg } = Symbol, Xi = /* @__PURE__ */ ((e) => (t) => {
  const n = nS.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Lt = (e) => (e = e.toLowerCase(), (t) => Xi(t) === e), Qi = (e) => (t) => typeof t === e, { isArray: Jo } = Array, Wo = Qi("undefined");
function Ma(e) {
  return e !== null && !Wo(e) && e.constructor !== null && !Wo(e.constructor) && ct(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Qg = Lt("ArrayBuffer");
function oS(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Qg(e.buffer), t;
}
const aS = Qi("string"), ct = Qi("function"), eb = Qi("number"), Fa = (e) => e !== null && typeof e == "object", rS = (e) => e === !0 || e === !1, Fr = (e) => {
  if (Xi(e) !== "object")
    return !1;
  const t = lu(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Xg in e) && !(Yi in e);
}, iS = (e) => {
  if (!Fa(e) || Ma(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, sS = Lt("Date"), lS = Lt("File"), cS = Lt("Blob"), uS = Lt("FileList"), dS = (e) => Fa(e) && ct(e.pipe), hS = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ct(e.append) && ((t = Xi(e)) === "formdata" || // detect form-data instance
  t === "object" && ct(e.toString) && e.toString() === "[object FormData]"));
}, pS = Lt("URLSearchParams"), [mS, fS, gS, bS] = ["ReadableStream", "Request", "Response", "Headers"].map(Lt), vS = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Wa(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, a;
  if (typeof e != "object" && (e = [e]), Jo(e))
    for (o = 0, a = e.length; o < a; o++)
      t.call(null, e[o], o, e);
  else {
    if (Ma(e))
      return;
    const r = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function tb(e, t) {
  if (Ma(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, a;
  for (; o-- > 0; )
    if (a = n[o], t === a.toLowerCase())
      return a;
  return null;
}
const Fn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, nb = (e) => !Wo(e) && e !== Fn;
function Ul() {
  const { caseless: e, skipUndefined: t } = nb(this) && this || {}, n = {}, o = (a, r) => {
    const i = e && tb(n, r) || r;
    Fr(n[i]) && Fr(a) ? n[i] = Ul(n[i], a) : Fr(a) ? n[i] = Ul({}, a) : Jo(a) ? n[i] = a.slice() : (!t || !Wo(a)) && (n[i] = a);
  };
  for (let a = 0, r = arguments.length; a < r; a++)
    arguments[a] && Wa(arguments[a], o);
  return n;
}
const yS = (e, t, n, { allOwnKeys: o } = {}) => (Wa(t, (a, r) => {
  n && ct(a) ? e[r] = Yg(a, n) : e[r] = a;
}, { allOwnKeys: o }), e), _S = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), wS = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, kS = (e, t, n, o) => {
  let a, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), r = a.length; r-- > 0; )
      i = a[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && lu(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, xS = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, $S = (e) => {
  if (!e) return null;
  if (Jo(e)) return e;
  let t = e.length;
  if (!eb(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, SS = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && lu(Uint8Array)), CS = (e, t) => {
  const n = (e && e[Yi]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, ES = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, AS = Lt("HTMLFormElement"), OS = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, o) {
    return n.toUpperCase() + o;
  }
), nh = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), zS = Lt("RegExp"), ob = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  Wa(n, (a, r) => {
    let i;
    (i = t(a, r, e)) !== !1 && (o[r] = i || a);
  }), Object.defineProperties(e, o);
}, NS = (e) => {
  ob(e, (t, n) => {
    if (ct(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (ct(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, jS = (e, t) => {
  const n = {}, o = (a) => {
    a.forEach((r) => {
      n[r] = !0;
    });
  };
  return Jo(e) ? o(e) : o(String(e).split(t)), n;
}, RS = () => {
}, IS = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function TS(e) {
  return !!(e && ct(e.append) && e[Xg] === "FormData" && e[Yi]);
}
const PS = (e) => {
  const t = new Array(10), n = (o, a) => {
    if (Fa(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Ma(o))
        return o;
      if (!("toJSON" in o)) {
        t[a] = o;
        const r = Jo(o) ? [] : {};
        return Wa(o, (i, s) => {
          const l = n(i, a + 1);
          !Wo(l) && (r[s] = l);
        }), t[a] = void 0, r;
      }
    }
    return o;
  };
  return n(e, 0);
}, DS = Lt("AsyncFunction"), LS = (e) => e && (Fa(e) || ct(e)) && ct(e.then) && ct(e.catch), ab = ((e, t) => e ? setImmediate : t ? ((n, o) => (Fn.addEventListener("message", ({ source: a, data: r }) => {
  a === Fn && r === n && o.length && o.shift()();
}, !1), (a) => {
  o.push(a), Fn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ct(Fn.postMessage)
), MS = typeof queueMicrotask < "u" ? queueMicrotask.bind(Fn) : typeof process < "u" && process.nextTick || ab, FS = (e) => e != null && ct(e[Yi]), j = {
  isArray: Jo,
  isArrayBuffer: Qg,
  isBuffer: Ma,
  isFormData: hS,
  isArrayBufferView: oS,
  isString: aS,
  isNumber: eb,
  isBoolean: rS,
  isObject: Fa,
  isPlainObject: Fr,
  isEmptyObject: iS,
  isReadableStream: mS,
  isRequest: fS,
  isResponse: gS,
  isHeaders: bS,
  isUndefined: Wo,
  isDate: sS,
  isFile: lS,
  isBlob: cS,
  isRegExp: zS,
  isFunction: ct,
  isStream: dS,
  isURLSearchParams: pS,
  isTypedArray: SS,
  isFileList: uS,
  forEach: Wa,
  merge: Ul,
  extend: yS,
  trim: vS,
  stripBOM: _S,
  inherits: wS,
  toFlatObject: kS,
  kindOf: Xi,
  kindOfTest: Lt,
  endsWith: xS,
  toArray: $S,
  forEachEntry: CS,
  matchAll: ES,
  isHTMLForm: AS,
  hasOwnProperty: nh,
  hasOwnProp: nh,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ob,
  freezeMethods: NS,
  toObjectSet: jS,
  toCamelCase: OS,
  noop: RS,
  toFiniteNumber: IS,
  findKey: tb,
  global: Fn,
  isContextDefined: nb,
  isSpecCompliantForm: TS,
  toJSONObject: PS,
  isAsyncFn: DS,
  isThenable: LS,
  setImmediate: ab,
  asap: MS,
  isIterable: FS
};
function de(e, t, n, o, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), a && (this.response = a, this.status = a.status ? a.status : null);
}
j.inherits(de, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: j.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const rb = de.prototype, ib = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ib[e] = { value: e };
});
Object.defineProperties(de, ib);
Object.defineProperty(rb, "isAxiosError", { value: !0 });
de.from = (e, t, n, o, a, r) => {
  const i = Object.create(rb);
  j.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return de.call(i, s, l, n, o, a), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const WS = null;
function ql(e) {
  return j.isPlainObject(e) || j.isArray(e);
}
function sb(e) {
  return j.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function oh(e, t, n) {
  return e ? e.concat(t).map(function(o, a) {
    return o = sb(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function BS(e) {
  return j.isArray(e) && !e.some(ql);
}
const VS = j.toFlatObject(j, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function es(e, t, n) {
  if (!j.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = j.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, g) {
    return !j.isUndefined(g[f]);
  });
  const o = n.metaTokens, a = n.visitor || c, r = n.dots, i = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && j.isSpecCompliantForm(t);
  if (!j.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(f) {
    if (f === null) return "";
    if (j.isDate(f))
      return f.toISOString();
    if (j.isBoolean(f))
      return f.toString();
    if (!s && j.isBlob(f))
      throw new de("Blob is not supported. Use a Buffer instead.");
    return j.isArrayBuffer(f) || j.isTypedArray(f) ? s && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, g, p) {
    let b = f;
    if (f && !p && typeof f == "object") {
      if (j.endsWith(g, "{}"))
        g = o ? g : g.slice(0, -2), f = JSON.stringify(f);
      else if (j.isArray(f) && BS(f) || (j.isFileList(f) || j.endsWith(g, "[]")) && (b = j.toArray(f)))
        return g = sb(g), b.forEach(function(w, y) {
          !(j.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? oh([g], y, r) : i === null ? g : g + "[]",
            l(w)
          );
        }), !1;
    }
    return ql(f) ? !0 : (t.append(oh(p, g, r), l(f)), !1);
  }
  const u = [], d = Object.assign(VS, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: ql
  });
  function m(f, g) {
    if (!j.isUndefined(f)) {
      if (u.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      u.push(f), j.forEach(f, function(p, b) {
        (!(j.isUndefined(p) || p === null) && a.call(
          t,
          p,
          j.isString(b) ? b.trim() : b,
          g,
          d
        )) === !0 && m(p, g ? g.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!j.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function ah(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function cu(e, t) {
  this._pairs = [], e && es(e, this, t);
}
const lb = cu.prototype;
lb.append = function(e, t) {
  this._pairs.push([e, t]);
};
lb.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, ah);
  } : ah;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function US(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function cb(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || US;
  j.isFunction(n) && (n = {
    serialize: n
  });
  const a = n && n.serialize;
  let r;
  if (a ? r = a(t, n) : r = j.isURLSearchParams(t) ? t.toString() : new cu(t, n).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let rh = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    j.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
};
const ub = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, qS = typeof URLSearchParams < "u" ? URLSearchParams : cu, HS = typeof FormData < "u" ? FormData : null, KS = typeof Blob < "u" ? Blob : null, GS = {
  isBrowser: !0,
  classes: {
    URLSearchParams: qS,
    FormData: HS,
    Blob: KS
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, uu = typeof window < "u" && typeof document < "u", Hl = typeof navigator == "object" && navigator || void 0, ZS = uu && (!Hl || ["ReactNative", "NativeScript", "NS"].indexOf(Hl.product) < 0), JS = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", YS = uu && window.location.href || "http://localhost", XS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: uu,
  hasStandardBrowserEnv: ZS,
  hasStandardBrowserWebWorkerEnv: JS,
  navigator: Hl,
  origin: YS
}, Symbol.toStringTag, { value: "Module" })), et = {
  ...XS,
  ...GS
};
function QS(e, t) {
  return es(e, new et.classes.URLSearchParams(), {
    visitor: function(n, o, a, r) {
      return et.isNode && j.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function eC(e) {
  return j.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function tC(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const a = n.length;
  let r;
  for (o = 0; o < a; o++)
    r = n[o], t[r] = e[r];
  return t;
}
function db(e) {
  function t(n, o, a, r) {
    let i = n[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= n.length;
    return i = !i && j.isArray(a) ? a.length : i, l ? (j.hasOwnProp(a, i) ? a[i] = [a[i], o] : a[i] = o, !s) : ((!a[i] || !j.isObject(a[i])) && (a[i] = []), t(n, o, a[i], r) && j.isArray(a[i]) && (a[i] = tC(a[i])), !s);
  }
  if (j.isFormData(e) && j.isFunction(e.entries)) {
    const n = {};
    return j.forEachEntry(e, (o, a) => {
      t(eC(o), a, n, 0);
    }), n;
  }
  return null;
}
function nC(e, t, n) {
  if (j.isString(e))
    try {
      return (t || JSON.parse)(e), j.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const Ba = {
  transitional: ub,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", o = n.indexOf("application/json") > -1, a = j.isObject(e);
    if (a && j.isHTMLForm(e) && (e = new FormData(e)), j.isFormData(e))
      return o ? JSON.stringify(db(e)) : e;
    if (j.isArrayBuffer(e) || j.isBuffer(e) || j.isStream(e) || j.isFile(e) || j.isBlob(e) || j.isReadableStream(e))
      return e;
    if (j.isArrayBufferView(e))
      return e.buffer;
    if (j.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return QS(e, this.formSerializer).toString();
      if ((r = j.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return es(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return a || o ? (t.setContentType("application/json", !1), nC(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Ba.transitional, n = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (j.isResponse(e) || j.isReadableStream(e))
      return e;
    if (e && j.isString(e) && (n && !this.responseType || o)) {
      const a = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (a)
          throw r.name === "SyntaxError" ? de.from(r, de.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: et.classes.FormData,
    Blob: et.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
j.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ba.headers[e] = {};
});
const oC = j.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), aC = (e) => {
  const t = {};
  let n, o, a;
  return e && e.split(`
`).forEach(function(r) {
    a = r.indexOf(":"), n = r.substring(0, a).trim().toLowerCase(), o = r.substring(a + 1).trim(), !(!n || t[n] && oC[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, ih = Symbol("internals");
function la(e) {
  return e && String(e).trim().toLowerCase();
}
function Wr(e) {
  return e === !1 || e == null ? e : j.isArray(e) ? e.map(Wr) : String(e);
}
function rC(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const iC = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Us(e, t, n, o, a) {
  if (j.isFunction(o))
    return o.call(this, t, n);
  if (a && (t = n), !!j.isString(t)) {
    if (j.isString(o))
      return t.indexOf(o) !== -1;
    if (j.isRegExp(o))
      return o.test(t);
  }
}
function sC(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function lC(e, t) {
  const n = j.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(a, r, i) {
        return this[o].call(this, t, a, r, i);
      },
      configurable: !0
    });
  });
}
let ut = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, o) {
    const a = this;
    function r(s, l, c) {
      const u = la(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = j.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = Wr(s));
    }
    const i = (s, l) => j.forEach(s, (c, u) => r(c, u, l));
    if (j.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (j.isString(t) && (t = t.trim()) && !iC(t))
      i(aC(t), n);
    else if (j.isObject(t) && j.isIterable(t)) {
      let s = {}, l, c;
      for (const u of t) {
        if (!j.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        s[c = u[0]] = (l = s[c]) ? j.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      i(s, n);
    } else
      t != null && r(n, t, o);
    return this;
  }
  get(t, n) {
    if (t = la(t), t) {
      const o = j.findKey(this, t);
      if (o) {
        const a = this[o];
        if (!n)
          return a;
        if (n === !0)
          return rC(a);
        if (j.isFunction(n))
          return n.call(this, a, o);
        if (j.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = la(t), t) {
      const o = j.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!n || Us(this, this[o], o, n)));
    }
    return !1;
  }
  delete(t, n) {
    const o = this;
    let a = !1;
    function r(i) {
      if (i = la(i), i) {
        const s = j.findKey(o, i);
        s && (!n || Us(o, o[s], s, n)) && (delete o[s], a = !0);
      }
    }
    return j.isArray(t) ? t.forEach(r) : r(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let o = n.length, a = !1;
    for (; o--; ) {
      const r = n[o];
      (!t || Us(this, this[r], r, t, !0)) && (delete this[r], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, o = {};
    return j.forEach(this, (a, r) => {
      const i = j.findKey(o, r);
      if (i) {
        n[i] = Wr(a), delete n[r];
        return;
      }
      const s = t ? sC(r) : String(r).trim();
      s !== r && delete n[r], n[s] = Wr(a), o[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return j.forEach(this, (o, a) => {
      o != null && o !== !1 && (n[a] = t && j.isArray(o) ? o.join(", ") : o);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const o = new this(t);
    return n.forEach((a) => o.set(a)), o;
  }
  static accessor(t) {
    const n = (this[ih] = this[ih] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(r) {
      const i = la(r);
      n[i] || (lC(o, r), n[i] = !0);
    }
    return j.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
ut.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
j.reduceDescriptors(ut.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
j.freezeMethods(ut);
function qs(e, t) {
  const n = this || Ba, o = t || n, a = ut.from(o.headers);
  let r = o.data;
  return j.forEach(e, function(i) {
    r = i.call(n, r, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), r;
}
function hb(e) {
  return !!(e && e.__CANCEL__);
}
function Yo(e, t, n) {
  de.call(this, e ?? "canceled", de.ERR_CANCELED, t, n), this.name = "CanceledError";
}
j.inherits(Yo, de, {
  __CANCEL__: !0
});
function pb(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new de(
    "Request failed with status code " + n.status,
    [de.ERR_BAD_REQUEST, de.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function cC(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function uC(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let a = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), n[a] = s, o[a] = l;
    let u = r, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === r && (r = (r + 1) % e), l - i < t)
      return;
    const m = c && l - c;
    return m ? Math.round(d * 1e3 / m) : void 0;
  };
}
function dC(e, t) {
  let n = 0, o = 1e3 / t, a, r;
  const i = (s, l = Date.now()) => {
    n = l, a = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= o ? i(s, l) : (a = s, r || (r = setTimeout(() => {
      r = null, i(a);
    }, o - c)));
  }, () => a && i(a)];
}
const di = (e, t, n = 3) => {
  let o = 0;
  const a = uC(50, 250);
  return dC((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = a(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, sh = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, lh = (e) => (...t) => j.asap(() => e(...t)), hC = et.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, et.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(et.origin),
  et.navigator && /(msie|trident)/i.test(et.navigator.userAgent)
) : () => !0, pC = et.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, a, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      j.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), j.isString(o) && i.push("path=" + o), j.isString(a) && i.push("domain=" + a), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function mC(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function fC(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function mb(e, t, n) {
  let o = !mC(t);
  return e && (o || n == !1) ? fC(e, t) : t;
}
const ch = (e) => e instanceof ut ? { ...e } : e;
function Zn(e, t) {
  t = t || {};
  const n = {};
  function o(c, u, d, m) {
    return j.isPlainObject(c) && j.isPlainObject(u) ? j.merge.call({ caseless: m }, c, u) : j.isPlainObject(u) ? j.merge({}, u) : j.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d, m) {
    if (j.isUndefined(u)) {
      if (!j.isUndefined(c))
        return o(void 0, c, d, m);
    } else return o(c, u, d, m);
  }
  function r(c, u) {
    if (!j.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (j.isUndefined(u)) {
      if (!j.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => a(ch(c), ch(u), d, !0)
  };
  return j.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    j.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const fb = (e) => {
  const t = Zn({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: a, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = ut.from(i), t.url = cb(mb(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), j.isFormData(n)) {
    if (et.hasStandardBrowserEnv || et.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (j.isFunction(n.getHeaders)) {
      const l = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (et.hasStandardBrowserEnv && (o && j.isFunction(o) && (o = o(t)), o || o !== !1 && hC(t.url))) {
    const l = a && r && pC.read(r);
    l && i.set(a, l);
  }
  return t;
}, gC = typeof XMLHttpRequest < "u", bC = gC && function(e) {
  return new Promise(function(t, n) {
    const o = fb(e);
    let a = o.data;
    const r = ut.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, m, f;
    function g() {
      m && m(), f && f(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function b() {
      if (!p)
        return;
      const y = ut.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), _ = {
        data: !i || i === "text" || i === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: y,
        config: e,
        request: p
      };
      pb(function(k) {
        t(k), g();
      }, function(k) {
        n(k), g();
      }, _), p = null;
    }
    "onloadend" in p ? p.onloadend = b : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, p.onabort = function() {
      p && (n(new de("Request aborted", de.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function(y) {
      const _ = y && y.message ? y.message : "Network Error", k = new de(_, de.ERR_NETWORK, e, p);
      k.event = y || null, n(k), p = null;
    }, p.ontimeout = function() {
      let y = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const _ = o.transitional || ub;
      o.timeoutErrorMessage && (y = o.timeoutErrorMessage), n(new de(
        y,
        _.clarifyTimeoutError ? de.ETIMEDOUT : de.ECONNABORTED,
        e,
        p
      )), p = null;
    }, a === void 0 && r.setContentType(null), "setRequestHeader" in p && j.forEach(r.toJSON(), function(y, _) {
      p.setRequestHeader(_, y);
    }), j.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), i && i !== "json" && (p.responseType = o.responseType), l && ([d, f] = di(l, !0), p.addEventListener("progress", d)), s && p.upload && ([u, m] = di(s), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", m)), (o.cancelToken || o.signal) && (c = (y) => {
      p && (n(!y || y.type ? new Yo(null, e, p) : y), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = cC(o.url);
    if (w && et.protocols.indexOf(w) === -1) {
      n(new de("Unsupported protocol " + w + ":", de.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(a || null);
  });
}, vC = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), a;
    const r = function(c) {
      if (!a) {
        a = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof de ? u : new Yo(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new de(`timeout ${t} of ms exceeded`, de.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => j.asap(s), l;
  }
}, yC = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let o = 0, a;
  for (; o < n; )
    a = o + t, yield e.slice(o, a), o = a;
}, _C = async function* (e, t) {
  for await (const n of wC(e))
    yield* yC(n, t);
}, wC = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, uh = (e, t, n, o) => {
  const a = _C(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await a.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let m = r += d;
          n(m);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, dh = 64 * 1024, { isFunction: lr } = j, gb = (({ fetch: e, Request: t, Response: n }) => ({
  fetch: e,
  Request: t,
  Response: n
}))(j.global), {
  ReadableStream: hh,
  TextEncoder: ph
} = j.global, mh = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, kC = (e) => {
  const { fetch: t, Request: n, Response: o } = Object.assign({}, gb, e), a = lr(t), r = lr(n), i = lr(o);
  if (!a)
    return !1;
  const s = a && lr(hh), l = a && (typeof ph == "function" ? /* @__PURE__ */ ((g) => (p) => g.encode(p))(new ph()) : async (g) => new Uint8Array(await new n(g).arrayBuffer())), c = r && s && mh(() => {
    let g = !1;
    const p = new n(et.origin, {
      body: new hh(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !p;
  }), u = i && s && mh(() => j.isReadableStream(new o("").body)), d = {
    stream: u && ((g) => g.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !d[g] && (d[g] = (p, b) => {
      let w = p && p[g];
      if (w)
        return w.call(p);
      throw new de(`Response type '${g}' is not supported`, de.ERR_NOT_SUPPORT, b);
    });
  });
  const m = async (g) => {
    if (g == null)
      return 0;
    if (j.isBlob(g))
      return g.size;
    if (j.isSpecCompliantForm(g))
      return (await new n(et.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (j.isArrayBufferView(g) || j.isArrayBuffer(g))
      return g.byteLength;
    if (j.isURLSearchParams(g) && (g = g + ""), j.isString(g))
      return (await l(g)).byteLength;
  }, f = async (g, p) => j.toFiniteNumber(g.getContentLength()) ?? m(p);
  return async (g) => {
    let {
      url: p,
      method: b,
      data: w,
      signal: y,
      cancelToken: _,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: A
    } = fb(g);
    $ = $ ? ($ + "").toLowerCase() : "text";
    let I = vC([y, _ && _.toAbortSignal()], k), U = null;
    const M = I && I.unsubscribe && (() => {
      I.unsubscribe();
    });
    let z;
    try {
      if (S && c && b !== "get" && b !== "head" && (z = await f(E, w)) !== 0) {
        let O = new n(p, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (j.isFormData(w) && (N = O.headers.get("content-type")) && E.setContentType(N), O.body) {
          const [T, W] = sh(
            z,
            di(lh(S))
          );
          w = uh(O.body, dh, T, W);
        }
      }
      j.isString(C) || (C = C ? "include" : "omit");
      const L = r && "credentials" in n.prototype, q = {
        ...A,
        signal: I,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: L ? C : void 0
      };
      U = r && new n(p, q);
      let K = await (r ? t(U, A) : t(p, q));
      const Z = u && ($ === "stream" || $ === "response");
      if (u && (x || Z && M)) {
        const O = {};
        ["status", "statusText", "headers"].forEach((B) => {
          O[B] = K[B];
        });
        const N = j.toFiniteNumber(K.headers.get("content-length")), [T, W] = x && sh(
          N,
          di(lh(x), !0)
        ) || [];
        K = new o(
          uh(K.body, dh, T, () => {
            W && W(), M && M();
          }),
          O
        );
      }
      $ = $ || "text";
      let te = await d[j.findKey(d, $) || "text"](K, g);
      return !Z && M && M(), await new Promise((O, N) => {
        pb(O, N, {
          data: te,
          headers: ut.from(K.headers),
          status: K.status,
          statusText: K.statusText,
          config: g,
          request: U
        });
      });
    } catch (L) {
      throw M && M(), L && L.name === "TypeError" && /Load failed|fetch/i.test(L.message) ? Object.assign(
        new de("Network Error", de.ERR_NETWORK, g, U),
        {
          cause: L.cause || L
        }
      ) : de.from(L, L && L.code, g, U);
    }
  };
}, xC = /* @__PURE__ */ new Map(), bb = (e) => {
  let t = j.merge.call({
    skipUndefined: !0
  }, gb, e ? e.env : null);
  const { fetch: n, Request: o, Response: a } = t, r = [
    o,
    a,
    n
  ];
  let i = r.length, s = i, l, c, u = xC;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : kC(t)), u = c;
  return c;
};
bb();
const Kl = {
  http: WS,
  xhr: bC,
  fetch: {
    get: bb
  }
};
j.forEach(Kl, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const fh = (e) => `- ${e}`, $C = (e) => j.isFunction(e) || e === null || e === !1, vb = {
  getAdapter: (e, t) => {
    e = j.isArray(e) ? e : [e];
    const { length: n } = e;
    let o, a;
    const r = {};
    for (let i = 0; i < n; i++) {
      o = e[i];
      let s;
      if (a = o, !$C(o) && (a = Kl[(s = String(o)).toLowerCase()], a === void 0))
        throw new de(`Unknown adapter '${s}'`);
      if (a && (j.isFunction(a) || (a = a.get(t))))
        break;
      r[s || "#" + i] = a;
    }
    if (!a) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = n ? i.length > 1 ? `since :
` + i.map(fh).join(`
`) : " " + fh(i[0]) : "as no adapter specified";
      throw new de(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Kl
};
function Hs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Yo(null, e);
}
function gh(e) {
  return Hs(e), e.headers = ut.from(e.headers), e.data = qs.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), vb.getAdapter(e.adapter || Ba.adapter, e)(e).then(function(t) {
    return Hs(e), t.data = qs.call(
      e,
      e.transformResponse,
      t
    ), t.headers = ut.from(t.headers), t;
  }, function(t) {
    return hb(t) || (Hs(e), t && t.response && (t.response.data = qs.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = ut.from(t.response.headers))), Promise.reject(t);
  });
}
const yb = "1.12.0", ts = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ts[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const bh = {};
ts.transitional = function(e, t, n) {
  function o(a, r) {
    return "[Axios v" + yb + "] Transitional option '" + a + "'" + r + (n ? ". " + n : "");
  }
  return (a, r, i) => {
    if (e === !1)
      throw new de(
        o(r, " has been removed" + (t ? " in " + t : "")),
        de.ERR_DEPRECATED
      );
    return t && !bh[r] && (bh[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, r, i) : !0;
  };
};
ts.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function SC(e, t, n) {
  if (typeof e != "object")
    throw new de("options must be an object", de.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let a = o.length;
  for (; a-- > 0; ) {
    const r = o[a], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new de("option " + r + " must be " + l, de.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new de("Unknown option " + r, de.ERR_BAD_OPTION);
  }
}
const Br = {
  assertOptions: SC,
  validators: ts
}, Bt = Br.validators;
let Hn = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new rh(),
      response: new rh()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (o) {
      if (o instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const r = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? r && !String(o.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + r) : o.stack = r;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Zn(this.defaults, n);
    const { transitional: o, paramsSerializer: a, headers: r } = n;
    o !== void 0 && Br.assertOptions(o, {
      silentJSONParsing: Bt.transitional(Bt.boolean),
      forcedJSONParsing: Bt.transitional(Bt.boolean),
      clarifyTimeoutError: Bt.transitional(Bt.boolean)
    }, !1), a != null && (j.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Br.assertOptions(a, {
      encode: Bt.function,
      serialize: Bt.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Br.assertOptions(n, {
      baseUrl: Bt.spelling("baseURL"),
      withXsrfToken: Bt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = r && j.merge(
      r.common,
      r[n.method]
    );
    r && j.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete r[g];
      }
    ), n.headers = ut.concat(i, r);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (l = l && g.synchronous, s.unshift(g.fulfilled, g.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(g) {
      c.push(g.fulfilled, g.rejected);
    });
    let u, d = 0, m;
    if (!l) {
      const g = [gh.bind(this), void 0];
      for (g.unshift(...s), g.push(...c), m = g.length, u = Promise.resolve(n); d < m; )
        u = u.then(g[d++], g[d++]);
      return u;
    }
    m = s.length;
    let f = n;
    for (d = 0; d < m; ) {
      const g = s[d++], p = s[d++];
      try {
        f = g(f);
      } catch (b) {
        p.call(this, b);
        break;
      }
    }
    try {
      u = gh.call(this, f);
    } catch (g) {
      return Promise.reject(g);
    }
    for (d = 0, m = c.length; d < m; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Zn(this.defaults, t);
    const n = mb(t.baseURL, t.url, t.allowAbsoluteUrls);
    return cb(n, t.params, t.paramsSerializer);
  }
};
j.forEach(["delete", "get", "head", "options"], function(e) {
  Hn.prototype[e] = function(t, n) {
    return this.request(Zn(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
j.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, a, r) {
      return this.request(Zn(r || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  Hn.prototype[e] = t(), Hn.prototype[e + "Form"] = t(!0);
});
let CC = class _b {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const o = this;
    this.promise.then((a) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](a);
      o._listeners = null;
    }), this.promise.then = (a) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(a);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(a, r, i) {
      o.reason || (o.reason = new Yo(a, r, i), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new _b(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function EC(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function AC(e) {
  return j.isObject(e) && e.isAxiosError === !0;
}
const Gl = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Gl).forEach(([e, t]) => {
  Gl[t] = e;
});
function wb(e) {
  const t = new Hn(e), n = Yg(Hn.prototype.request, t);
  return j.extend(n, Hn.prototype, t, { allOwnKeys: !0 }), j.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return wb(Zn(e, o));
  }, n;
}
const We = wb(Ba);
We.Axios = Hn;
We.CanceledError = Yo;
We.CancelToken = CC;
We.isCancel = hb;
We.VERSION = yb;
We.toFormData = es;
We.AxiosError = de;
We.Cancel = We.CanceledError;
We.all = function(e) {
  return Promise.all(e);
};
We.spread = EC;
We.isAxiosError = AC;
We.mergeConfig = Zn;
We.AxiosHeaders = ut;
We.formToJSON = (e) => db(j.isHTMLForm(e) ? new FormData(e) : e);
We.getAdapter = vb.getAdapter;
We.HttpStatusCode = Gl;
We.default = We;
const {
  Axios: vye,
  AxiosError: OC,
  CanceledError: yye,
  isCancel: _ye,
  CancelToken: wye,
  VERSION: kye,
  all: xye,
  Cancel: $ye,
  isAxiosError: Sye,
  spread: Cye,
  toFormData: Eye,
  AxiosHeaders: Aye,
  HttpStatusCode: Oye,
  formToJSON: zye,
  getAdapter: Nye,
  mergeConfig: jye
} = We, zC = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
let kb = class {
  baseUrl;
  headers;
  constructor(t, n = {}) {
    this.baseUrl = t, this.headers = n?.headers || {};
  }
  async fetch(t, n = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const a = zC.test(t) ? t : `${this.baseUrl}${t}`;
    a.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await We(a, {
        ...o,
        method: n,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof OC ? new th(`${r.code} - ${r.status} - ${a}`, r.status, r.response?.data) : new th("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
};
new kb("", {});
function NC(e, t = {}) {
  if (!e) {
    console.warn("setSearchFetchConfig: URL is empty or undefined");
    return;
  }
  new kb(e, t);
}
const jC = "ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT", RC = "https://api.jawg.io", IC = "dependency,neighbourhood,locality,borough,localadmin,county,macrocounty,region,macroregion,country,postalcode", cr = {
  "access-token": jC,
  layers: IC,
  sources: "wof",
  size: 10
};
async function TC(e, t) {
  const n = `${RC}/places/v1/autocomplete`;
  if (!n)
    throw new Error("JAWG_URL is not defined");
  let o = `${n}?text=${e}&access-token=${cr["access-token"]}&layers=${cr.layers}&sources=${cr.sources}&size=${cr.size}`;
  t && (o += `&lang=${t}`);
  const a = await fetch(o, {
    headers: {
      "Accept-Language": t || "fr"
    }
  });
  if (!a.ok)
    throw new Error(`JAWG API error: ${a.status}`);
  return a.json();
}
function xb(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = xb(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Jn() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = xb(e)) && (o && (o += " "), o += t);
  return o;
}
const PC = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], DC = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, LC = PC.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: DC[e]
})), MC = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, FC = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function WC(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const Ca = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = LC.find((l) => l.name === e), s = Jn("icon", `ds-${i?.class}`, FC[t], MC[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: WC(i?.paths) });
  }
);
Ca.displayName = "Icon";
const BC = "_disabled_1rzsq_47", ur = {
  "icon-button": "_icon-button_1rzsq_29",
  "size-small": "_size-small_1rzsq_38",
  "size-medium": "_size-medium_1rzsq_41",
  "size-large": "_size-large_1rzsq_44",
  disabled: BC,
  "is-borderless": "_is-borderless_1rzsq_51",
  "dialog-overlay-show": "_dialog-overlay-show_1rzsq_1",
  "dialog-content-show": "_dialog-content-show_1rzsq_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1rzsq_1"
}, VC = pt(
  ({ icon: e, size: t, isBorderless: n, onClick: o, className: a, ...r }, i) => /* @__PURE__ */ v(
    "button",
    {
      ref: i,
      className: Jn(
        ur["icon-button"],
        r.disabled && ur.disabled,
        t && ur[`size-${t}`],
        n && ur["is-borderless"],
        a
      ),
      onClick: o,
      ...r,
      children: /* @__PURE__ */ v(Ca, { name: e, size: t })
    }
  )
);
VC.displayName = "IconButton";
const UC = "_loader_1ksyv_29", qC = "_circle_1ksyv_41", vo = {
  loader: UC,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: qC,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, HC = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, KC = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function GC({ onDark: e, size: t = "medium", color: n = "primary", className: o }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      className: Jn(
        vo.loader,
        vo[HC[t]],
        vo[KC[n]],
        e && vo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: vo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ P(
          "circle",
          {
            className: vo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const ZC = "_button_z1os6_29", JC = "_disabled_z1os6_43", YC = "_loader_z1os6_263", rn = {
  button: ZC,
  disabled: JC,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: YC,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, XC = pt(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: o = !1,
    icon: a,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...m
  }, f) => {
    const g = Jn(
      rn.button,
      rn[QC[t]],
      rn[eE[n]],
      o && rn["is-full-width"],
      c && rn.disabled,
      r === "right" && rn["has-icon-right"],
      l && rn["is-contrasted"],
      i && rn["is-loading"],
      u
    ), p = /* @__PURE__ */ P(je, { children: [
      i && /* @__PURE__ */ v(GC, { className: rn.loader, onDark: !0, size: "small" }),
      a && r === "left" && /* @__PURE__ */ v(Ca, { color: "inherit", size: s, name: a }),
      d ?? e,
      a && r === "right" && /* @__PURE__ */ v(Ca, { color: "inherit", size: s, name: a })
    ] });
    if (tE(m))
      return /* @__PURE__ */ v(
        "a",
        {
          ...m,
          href: c ? void 0 : m.href,
          className: g,
          target: m.target,
          ref: f,
          children: p
        }
      );
    if (nE(m))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...m,
          className: g,
          ref: f,
          children: p
        }
      );
  }
);
XC.displayName = "Button";
const QC = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, eE = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function tE(e) {
  return "href" in e && typeof e.href == "string";
}
function nE(e) {
  return !("href" in e);
}
const oE = (e, t) => {
  let n;
  return () => {
    clearTimeout(n), n = setTimeout(e, t);
  };
}, Zl = {
  xs: { items: 1, peek: 15 },
  sm: { items: 2, peek: 20 },
  md: { items: 3, peek: 25 },
  lg: { items: 4, peek: 15 },
  xl: { items: 5, peek: 10 }
}, aE = [
  { size: 1280, key: "xl" },
  { size: 1024, key: "lg" },
  { size: 768, key: "md" },
  { size: 640, key: "sm" }
];
function rE(e, t) {
  const n = Te(null), [o, a] = Ne("100%"), [r, i] = Ne(0), [s, l] = Ne(0), [c, u] = Ne(0), d = Do(
    () => ({
      ...Zl,
      ...t.itemsPerBreakpoint
    }),
    [t.itemsPerBreakpoint]
  ), m = () => {
    n.current && (l(n.current.scrollWidth), u(n.current.clientWidth));
  }, f = Do(
    () => ({
      shouldDisplayNext: r + c < s,
      shouldDisplayPrev: r > 0
    }),
    [r, c, s]
  );
  Se(() => {
    const w = n.current;
    if (!w) return;
    const y = () => {
      const x = w.clientWidth ?? 0;
      let S = d.xs;
      for (const { size: M, key: z } of aE)
        if (window.matchMedia(`(min-width: ${M}px)`).matches) {
          S = d[z] ?? Zl[z];
          break;
        }
      const $ = getComputedStyle(w), E = parseInt($.gap) || 0;
      let C = 0;
      if (t.paddingElementWrapper && w.children.length) {
        const M = w.children[w.children.length - 1], z = getComputedStyle(M);
        C = parseInt(z.paddingRight);
      }
      const A = x - E * (S.items + (S.peek === 0 ? -1 : 0)) - C, I = S.items + (S.peek === 0 ? 0 : S.peek / 100), U = A / I;
      a(`${U}px`), m();
    };
    y(), m();
    const _ = () => i(w.scrollLeft), k = oE(() => {
      y(), m();
    }, 500);
    return w.addEventListener("scroll", _), window.addEventListener("resize", k), () => {
      w.removeEventListener("scroll", _), window.removeEventListener("resize", k);
    };
  }, [d, t.paddingElementWrapper, e]), Se(m, [e]), Se(() => {
    t.onNavigationStateChange?.(f);
  }, [f, t]);
  const g = () => {
    n.current && n.current.scrollTo({
      left: Math.max(0, r - n.current.offsetWidth),
      behavior: "smooth"
    });
  }, p = () => {
    n.current && n.current.scrollTo({
      left: Math.min(s - c, r + n.current.offsetWidth),
      behavior: "smooth"
    });
  }, b = (w) => {
    if (!n.current) return parseInt(o);
    const y = ae.Children.count(e), _ = {
      first: w === 0,
      last: w === y - 1
    }, k = () => {
      if (!t.paddingElementWrapper) return 0;
      const x = n.current?.children[w];
      if (!x) return 0;
      const S = getComputedStyle(x);
      return _.first ? parseInt(S.paddingLeft || "0") : _.last ? parseInt(S.paddingRight || "0") : 0;
    };
    return parseInt(o) + k();
  };
  return {
    carouselRef: n,
    shouldDisplayPrev: f.shouldDisplayPrev,
    shouldDisplayNext: f.shouldDisplayNext,
    scrollPrev: g,
    scrollNext: p,
    itemWidth: o,
    getItemWidth: b
  };
}
const iE = "_carousel_u43l3_29", dr = {
  carousel: iE,
  "carousel-content": "_carousel-content_u43l3_33",
  "gap-0": "_gap-0_u43l3_47",
  "gap-1": "_gap-1_u43l3_50",
  "gap-2": "_gap-2_u43l3_53",
  "gap-3": "_gap-3_u43l3_56",
  "gap-4": "_gap-4_u43l3_59",
  "gap-5": "_gap-5_u43l3_62",
  "gap-6": "_gap-6_u43l3_65",
  "gap-7": "_gap-7_u43l3_68",
  "gap-8": "_gap-8_u43l3_71",
  "gap-9": "_gap-9_u43l3_74",
  "gap-10": "_gap-10_u43l3_77",
  "gap-11": "_gap-11_u43l3_80",
  "gap-12": "_gap-12_u43l3_83",
  "gap-14": "_gap-14_u43l3_86",
  "gap-16": "_gap-16_u43l3_89",
  "gap-18": "_gap-18_u43l3_92",
  "gap-20": "_gap-20_u43l3_95",
  "gap-24": "_gap-24_u43l3_98",
  "gap-28": "_gap-28_u43l3_101",
  "gap-32": "_gap-32_u43l3_104",
  "gap-36": "_gap-36_u43l3_107",
  "gap-40": "_gap-40_u43l3_110",
  "gap-44": "_gap-44_u43l3_113",
  "gap-48": "_gap-48_u43l3_116",
  "gap-52": "_gap-52_u43l3_119",
  "gap-56": "_gap-56_u43l3_122",
  "gap-60": "_gap-60_u43l3_125",
  "gap-64": "_gap-64_u43l3_128",
  "gap-72": "_gap-72_u43l3_131",
  "gap-80": "_gap-80_u43l3_134",
  "gap-96": "_gap-96_u43l3_137",
  "padding-element-wrapper": "_padding-element-wrapper_u43l3_140",
  "dialog-overlay-show": "_dialog-overlay-show_u43l3_1",
  "dialog-content-show": "_dialog-content-show_u43l3_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_u43l3_1"
}, sE = ({
  children: e,
  className: t = "",
  paddingElementWrapper: n = !1,
  gap: o = "8",
  itemsPerBreakpoint: a = Zl,
  onNavigationStateChange: r,
  ...i
}, s) => {
  const { carouselRef: l, shouldDisplayPrev: c, shouldDisplayNext: u, scrollPrev: d, scrollNext: m, getItemWidth: f } = rE(
    e,
    {
      itemsPerBreakpoint: a,
      paddingElementWrapper: n,
      onNavigationStateChange: r
    }
  ), g = ae.Children.map(e, (b, w) => ae.isValidElement(b) ? ae.cloneElement(b, {
    style: {
      ...b.props.style,
      width: `${f(w)}px`,
      flexShrink: 0
    }
  }) : b);
  ae.useImperativeHandle(s, () => ({
    scrollNext: m,
    scrollPrev: d,
    shouldDisplayNext: u,
    shouldDisplayPrev: c,
    carouselElement: l.current
  }));
  const p = Jn(dr.carousel, t);
  return /* @__PURE__ */ v("div", { className: p, ...i, children: /* @__PURE__ */ v(
    "ul",
    {
      ref: l,
      className: Jn(
        dr["carousel-content"],
        n && dr["padding-element-wrapper"],
        o && dr[`gap-${o}`]
      ),
      children: g
    }
  ) });
};
ae.forwardRef(sE);
function ge(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var En = globalThis?.document ? h.useLayoutEffect : () => {
}, lE = h[" useInsertionEffect ".trim().toString()] || En;
function ns({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [a, r, i] = cE({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : a;
  {
    const u = h.useRef(e !== void 0);
    h.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = h.useCallback(
    (u) => {
      if (s) {
        const d = uE(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function cE({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = h.useState(e), a = h.useRef(n), r = h.useRef(t);
  return lE(() => {
    r.current = t;
  }, [t]), h.useEffect(() => {
    a.current !== n && (r.current?.(n), a.current = n);
  }, [n, a]), [n, o, r];
}
function uE(e) {
  return typeof e == "function";
}
function vh(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function $b(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((a) => {
      const r = vh(a, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let a = 0; a < o.length; a++) {
          const r = o[a];
          typeof r == "function" ? r() : vh(e[a], null);
        }
      };
  };
}
function He(...e) {
  return h.useCallback($b(...e), e);
}
function dE(e, t) {
  const n = h.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = h.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(n.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function a(r) {
    const i = h.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, a];
}
function ho(e, t = []) {
  let n = [];
  function o(r, i) {
    const s = h.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      const { scope: m, children: f, ...g } = d, p = m?.[e]?.[l] || s, b = h.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: f });
    };
    c.displayName = r + "Provider";
    function u(d, m) {
      const f = m?.[e]?.[l] || s, g = h.useContext(f);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const a = () => {
    const r = n.map((i) => h.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return a.scopeName = e, [o, hE(a, ...t)];
}
function hE(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(a) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(a)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function hi(e) {
  const t = /* @__PURE__ */ pE(e), n = h.forwardRef((o, a) => {
    const { children: r, ...i } = o, s = h.Children.toArray(r), l = s.find(fE);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? h.Children.count(c) > 1 ? h.Children.only(null) : h.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: a, children: h.isValidElement(c) ? h.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: a, children: r });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function pE(e) {
  const t = h.forwardRef((n, o) => {
    const { children: a, ...r } = n;
    if (h.isValidElement(a)) {
      const i = bE(a), s = gE(r, a.props);
      return a.type !== h.Fragment && (s.ref = o ? $b(o, i) : i), h.cloneElement(a, s);
    }
    return h.Children.count(a) > 1 ? h.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var mE = Symbol("radix.slottable");
function fE(e) {
  return h.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === mE;
}
function gE(e, t) {
  const n = { ...t };
  for (const o in t) {
    const a = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? a && r ? n[o] = (...i) => {
      const s = r(...i);
      return a(...i), s;
    } : a && (n[o] = a) : o === "style" ? n[o] = { ...a, ...r } : o === "className" && (n[o] = [a, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function bE(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var vE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Oe = vE.reduce((e, t) => {
  const n = /* @__PURE__ */ hi(`Primitive.${t}`), o = h.forwardRef((a, r) => {
    const { asChild: i, ...s } = a, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Sb(e, t) {
  e && so.flushSync(() => e.dispatchEvent(t));
}
var yE = h.createContext(void 0);
function du(e) {
  const t = h.useContext(yE);
  return e || t || "ltr";
}
function Cb(e) {
  const t = e + "CollectionProvider", [n, o] = ho(t), [a, r] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, y = ae.useRef(null), _ = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(a, { scope: b, itemMap: _, collectionRef: y, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ hi(s), c = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y } = p, _ = r(s, w), k = He(b, _.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: y });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ hi(u), f = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y, ..._ } = p, k = ae.useRef(null), x = He(b, k), S = r(u, w);
      return ae.useEffect(() => (S.itemMap.set(k, { ref: k, ..._ }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(m, { [d]: "", ref: x, children: y });
    }
  );
  f.displayName = u;
  function g(p) {
    const b = r(e + "CollectionConsumer", p);
    return ae.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const y = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (_, k) => y.indexOf(_.ref.current) - y.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    g,
    o
  ];
}
var _E = h[" useId ".trim().toString()] || (() => {
}), wE = 0;
function Eb(e) {
  const [t, n] = h.useState(_E());
  return En(() => {
    n((o) => o ?? String(wE++));
  }, [e]), t ? `radix-${t}` : "";
}
function kE(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var mn = (e) => {
  const { present: t, children: n } = e, o = xE(t), a = typeof n == "function" ? n({ present: o.isPresent }) : h.Children.only(n), r = He(o.ref, $E(a));
  return typeof n == "function" || o.isPresent ? h.cloneElement(a, { ref: r }) : null;
};
mn.displayName = "Presence";
function xE(e) {
  const [t, n] = h.useState(), o = h.useRef(null), a = h.useRef(e), r = h.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = kE(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const c = hr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), En(() => {
    const c = o.current, u = a.current;
    if (u !== e) {
      const d = r.current, m = hr(c);
      e ? l("MOUNT") : m === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== m ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, l]), En(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (f) => {
        const g = hr(o.current).includes(CSS.escape(f.animationName));
        if (f.target === t && g && (l("ANIMATION_END"), !a.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, m = (f) => {
        f.target === t && (r.current = hr(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: h.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function hr(e) {
  return e?.animationName || "none";
}
function $E(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Qe(e) {
  const t = h.useRef(e);
  return h.useEffect(() => {
    t.current = e;
  }), h.useMemo(() => (...n) => t.current?.(...n), []);
}
var Ks = "rovingFocusGroup.onEntryFocus", SE = { bubbles: !1, cancelable: !0 }, Va = "RovingFocusGroup", [Jl, Ab, CE] = Cb(Va), [EE, Ob] = ho(
  Va,
  [CE]
), [AE, OE] = EE(Va), zb = h.forwardRef(
  (e, t) => /* @__PURE__ */ v(Jl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Jl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(zE, { ...e, ref: t }) }) })
);
zb.displayName = Va;
var zE = h.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: a = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, m = h.useRef(null), f = He(t, m), g = du(r), [p, b] = ns({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: Va
  }), [w, y] = h.useState(!1), _ = Qe(c), k = Ab(n), x = h.useRef(!1), [S, $] = h.useState(0);
  return h.useEffect(() => {
    const E = m.current;
    if (E)
      return E.addEventListener(Ks, _), () => E.removeEventListener(Ks, _);
  }, [_]), /* @__PURE__ */ v(
    AE,
    {
      scope: n,
      orientation: o,
      dir: g,
      loop: a,
      currentTabStopId: p,
      onItemFocus: h.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: h.useCallback(() => y(!0), []),
      onFocusableItemAdd: h.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: h.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        Oe.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: f,
          style: { outline: "none", ...e.style },
          onMouseDown: ge(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: ge(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const A = new CustomEvent(Ks, SE);
              if (E.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
                const I = k().filter((L) => L.focusable), U = I.find((L) => L.active), M = I.find((L) => L.id === p), z = [U, M, ...I].filter(
                  Boolean
                ).map((L) => L.ref.current);
                Rb(z, u);
              }
            }
            x.current = !1;
          }),
          onBlur: ge(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Nb = "RovingFocusGroupItem", jb = h.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: a = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = Eb(), c = r || l, u = OE(Nb, n), d = u.currentTabStopId === c, m = Ab(n), { onFocusableItemAdd: f, onFocusableItemRemove: g, currentTabStopId: p } = u;
    return h.useEffect(() => {
      if (o)
        return f(), () => g();
    }, [o, f, g]), /* @__PURE__ */ v(
      Jl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: o,
        active: a,
        children: /* @__PURE__ */ v(
          Oe.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: ge(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: ge(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: ge(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = RE(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let y = m().filter((_) => _.focusable).map((_) => _.ref.current);
                if (w === "last") y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const _ = y.indexOf(b.currentTarget);
                  y = u.loop ? IE(y, _ + 1) : y.slice(_ + 1);
                }
                setTimeout(() => Rb(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
jb.displayName = Nb;
var NE = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function jE(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function RE(e, t, n) {
  const o = jE(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return NE[o];
}
function Rb(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function IE(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var TE = zb, PE = jb;
function DE(e) {
  const [t, n] = h.useState(void 0);
  return En(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const r = a[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function LE(e) {
  const t = h.useRef({ value: e, previous: e });
  return h.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const ME = typeof document < "u" ? ae.useLayoutEffect : () => {
};
var Gs;
Gs = ae.useInsertionEffect;
const pi = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Ib = /* @__PURE__ */ ae.createContext(pi), FE = /* @__PURE__ */ ae.createContext(!1);
let WE = !!(typeof window < "u" && window.document && window.document.createElement), Zs = /* @__PURE__ */ new WeakMap();
function BE(e = !1) {
  let t = io(Ib), n = Te(null);
  if (n.current === null && !e) {
    var o, a;
    let r = (a = ae.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (o = a.ReactCurrentOwner) === null || o === void 0 ? void 0 : o.current;
    if (r) {
      let i = Zs.get(r);
      i == null ? Zs.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== i.state && (t.current = i.id, Zs.delete(r));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function VE(e) {
  let t = io(Ib);
  t === pi && !WE && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = BE(!!e), o = t === pi && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${o}-${n}`;
}
function UE(e) {
  let t = ae.useId(), [n] = Ne(GE()), o = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${pi.prefix}`;
  return e || `${o}-${t}`;
}
ae.useId;
function qE() {
  return !1;
}
function HE() {
  return !0;
}
function KE(e) {
  return () => {
  };
}
function GE() {
  return typeof ae.useSyncExternalStore == "function" ? ae.useSyncExternalStore(KE, qE, HE) : io(FE);
}
let ZE = /* @__PURE__ */ new Map();
typeof FinalizationRegistry < "u" && new FinalizationRegistry((e) => {
  ZE.delete(e);
});
const JE = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), YE = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function XE(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), o = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (o) return o.direction === "rtl";
    if (n.script) return JE.has(n.script);
  }
  let t = e.split("-")[0];
  return YE.has(t);
}
const QE = Symbol.for("react-aria.i18n.locale");
function eA() {
  let e = typeof window < "u" && window[QE] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: XE(e) ? "rtl" : "ltr"
  };
}
eA();
const os = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, Yl = (e) => os(e).defaultView || window;
function as(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(n) && n.some((o) => e.test(o.brand)) || e.test(window.navigator.userAgent);
}
function hu(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function fn(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const pu = fn(function() {
  return hu(/^Mac/i);
}), tA = fn(function() {
  return hu(/^iPhone/i);
}), nA = fn(function() {
  return hu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  pu() && navigator.maxTouchPoints > 1;
}), oA = fn(function() {
  return tA() || nA();
});
fn(function() {
  return pu() || oA();
});
fn(function() {
  return as(/AppleWebKit/i) && !aA();
});
const aA = fn(function() {
  return as(/Chrome/i);
}), rA = fn(function() {
  return as(/Android/i);
});
fn(function() {
  return as(/Firefox/i);
});
let ca = /* @__PURE__ */ new Map(), yh = /* @__PURE__ */ new Set();
function _h() {
  if (typeof window > "u") return;
  function e(o) {
    return "propertyName" in o;
  }
  let t = (o) => {
    if (!e(o) || !o.target) return;
    let a = ca.get(o.target);
    a || (a = /* @__PURE__ */ new Set(), ca.set(o.target, a), o.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(o.propertyName);
  }, n = (o) => {
    if (!e(o) || !o.target) return;
    let a = ca.get(o.target);
    if (a && (a.delete(o.propertyName), a.size === 0 && (o.target.removeEventListener("transitioncancel", n), ca.delete(o.target)), ca.size === 0)) {
      for (let r of yh) r();
      yh.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? _h() : document.addEventListener("DOMContentLoaded", _h));
function iA(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : rA() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
let sA = !1;
const lA = ae.createContext({
  register: () => {
  }
});
lA.displayName = "PressResponderContext";
let cA = /* @__PURE__ */ new Set(), ba = /* @__PURE__ */ new Map(), Yn = !1, Xl = !1;
function mu(e, t) {
  for (let n of cA) n(e, t);
}
function uA(e) {
  return !(e.metaKey || !pu() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function mi(e) {
  Yn = !0, uA(e) && mu("keyboard", e);
}
function Ct(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (Yn = !0, mu("pointer", e));
}
function Tb(e) {
  iA(e) && (Yn = !0);
}
function Pb(e) {
  e.target === window || e.target === document || sA || !e.isTrusted || (!Yn && !Xl && mu("virtual", e), Yn = !1, Xl = !1);
}
function Db() {
  Yn = !1, Xl = !0;
}
function wh(e) {
  if (typeof window > "u" || typeof document > "u" || ba.get(Yl(e))) return;
  const t = Yl(e), n = os(e);
  let o = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    Yn = !0, o.apply(this, arguments);
  }, n.addEventListener("keydown", mi, !0), n.addEventListener("keyup", mi, !0), n.addEventListener("click", Tb, !0), t.addEventListener("focus", Pb, !0), t.addEventListener("blur", Db, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Ct, !0), n.addEventListener("pointermove", Ct, !0), n.addEventListener("pointerup", Ct, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Ct, !0), n.addEventListener("mousemove", Ct, !0), n.addEventListener("mouseup", Ct, !0)), t.addEventListener("beforeunload", () => {
    Lb(e);
  }, {
    once: !0
  }), ba.set(t, {
    focus: o
  });
}
const Lb = (e, t) => {
  const n = Yl(e), o = os(e);
  t && o.removeEventListener("DOMContentLoaded", t), ba.has(n) && (n.HTMLElement.prototype.focus = ba.get(n).focus, o.removeEventListener("keydown", mi, !0), o.removeEventListener("keyup", mi, !0), o.removeEventListener("click", Tb, !0), n.removeEventListener("focus", Pb, !0), n.removeEventListener("blur", Db, !1), typeof PointerEvent < "u" ? (o.removeEventListener("pointerdown", Ct, !0), o.removeEventListener("pointermove", Ct, !0), o.removeEventListener("pointerup", Ct, !0)) : process.env.NODE_ENV === "test" && (o.removeEventListener("mousedown", Ct, !0), o.removeEventListener("mousemove", Ct, !0), o.removeEventListener("mouseup", Ct, !0)), ba.delete(n));
};
function dA(e) {
  const t = os(e);
  let n;
  return t.readyState !== "loading" ? wh(e) : (n = () => {
    wh(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Lb(e, n);
}
typeof document < "u" && dA();
Pt(null);
function hA(e, t = globalThis?.document) {
  const n = Qe(e);
  h.useEffect(() => {
    const o = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var pA = "DismissableLayer", Ql = "dismissableLayer.update", mA = "dismissableLayer.pointerDownOutside", fA = "dismissableLayer.focusOutside", kh, Mb = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), fu = h.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = h.useContext(Mb), [u, d] = h.useState(null), m = u?.ownerDocument ?? globalThis?.document, [, f] = h.useState({}), g = He(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), y = u ? p.indexOf(u) : -1, _ = c.layersWithOutsidePointerEventsDisabled.size > 0, k = y >= w, x = bA(($) => {
      const E = $.target, C = [...c.branches].some((A) => A.contains(E));
      !k || C || (a?.($), i?.($), $.defaultPrevented || s?.());
    }, m), S = vA(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, m);
    return hA(($) => {
      y === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, m), h.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (kh = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), xh(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = kh);
        };
    }, [u, m, n, c]), h.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), xh());
    }, [u, c]), h.useEffect(() => {
      const $ = () => f({});
      return document.addEventListener(Ql, $), () => document.removeEventListener(Ql, $);
    }, []), /* @__PURE__ */ v(
      Oe.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: _ ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ge(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ge(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ge(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
fu.displayName = pA;
var gA = "DismissableLayerBranch", Fb = h.forwardRef((e, t) => {
  const n = h.useContext(Mb), o = h.useRef(null), a = He(t, o);
  return h.useEffect(() => {
    const r = o.current;
    if (r)
      return n.branches.add(r), () => {
        n.branches.delete(r);
      };
  }, [n.branches]), /* @__PURE__ */ v(Oe.div, { ...e, ref: a });
});
Fb.displayName = gA;
function bA(e, t = globalThis?.document) {
  const n = Qe(e), o = h.useRef(!1), a = h.useRef(() => {
  });
  return h.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          Wb(
            mA,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", a.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function vA(e, t = globalThis?.document) {
  const n = Qe(e), o = h.useRef(!1);
  return h.useEffect(() => {
    const a = (r) => {
      r.target && !o.current && Wb(fA, n, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function xh() {
  const e = new CustomEvent(Ql);
  document.dispatchEvent(e);
}
function Wb(e, t, n, { discrete: o }) {
  const a = n.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), o ? Sb(a, r) : a.dispatchEvent(r);
}
var yA = fu, _A = Fb, wA = "Portal", Bb = h.forwardRef((e, t) => {
  const { container: n, ...o } = e, [a, r] = h.useState(!1);
  En(() => r(!0), []);
  const i = n || a && globalThis?.document?.body;
  return i ? Ui.createPortal(/* @__PURE__ */ v(Oe.div, { ...o, ref: t }), i) : null;
});
Bb.displayName = wA;
var st = function() {
  return st = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, st.apply(this, arguments);
};
function Vb(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
  return n;
}
function kA(e, t, n) {
  for (var o = 0, a = t.length, r; o < a; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Js = "focusScope.autoFocusOnMount", Ys = "focusScope.autoFocusOnUnmount", $h = { bubbles: !1, cancelable: !0 }, xA = "FocusScope", Ub = h.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = h.useState(null), c = Qe(a), u = Qe(r), d = h.useRef(null), m = He(t, (p) => l(p)), f = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (o) {
      let p = function(_) {
        if (f.paused || !s) return;
        const k = _.target;
        s.contains(k) ? d.current = k : wn(d.current, { select: !0 });
      }, b = function(_) {
        if (f.paused || !s) return;
        const k = _.relatedTarget;
        k !== null && (s.contains(k) || wn(d.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const k of _)
            k.removedNodes.length > 0 && wn(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const y = new MutationObserver(w);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [o, s, f.paused]), h.useEffect(() => {
    if (s) {
      Ch.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(Js, $h);
        s.addEventListener(Js, c), s.dispatchEvent(b), b.defaultPrevented || ($A(OA(qb(s)), { select: !0 }), document.activeElement === p && wn(s));
      }
      return () => {
        s.removeEventListener(Js, c), setTimeout(() => {
          const b = new CustomEvent(Ys, $h);
          s.addEventListener(Ys, u), s.dispatchEvent(b), b.defaultPrevented || wn(p ?? document.body, { select: !0 }), s.removeEventListener(Ys, u), Ch.remove(f);
        }, 0);
      };
    }
  }, [s, c, u, f]);
  const g = h.useCallback(
    (p) => {
      if (!n && !o || f.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const y = p.currentTarget, [_, k] = SA(y);
        _ && k ? !p.shiftKey && w === k ? (p.preventDefault(), n && wn(_, { select: !0 })) : p.shiftKey && w === _ && (p.preventDefault(), n && wn(k, { select: !0 })) : w === y && p.preventDefault();
      }
    },
    [n, o, f.paused]
  );
  return /* @__PURE__ */ v(Oe.div, { tabIndex: -1, ...i, ref: m, onKeyDown: g });
});
Ub.displayName = xA;
function $A(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (wn(o, { select: t }), document.activeElement !== n) return;
}
function SA(e) {
  const t = qb(e), n = Sh(t, e), o = Sh(t.reverse(), e);
  return [n, o];
}
function qb(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Sh(e, t) {
  for (const n of e)
    if (!CA(n, { upTo: t })) return n;
}
function CA(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function EA(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function wn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && EA(e) && t && e.select();
  }
}
var Ch = AA();
function AA() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Eh(e, t), e.unshift(t);
    },
    remove(t) {
      e = Eh(e, t), e[0]?.resume();
    }
  };
}
function Eh(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function OA(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Xs = 0;
function zA() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ah()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ah()), Xs++, () => {
      Xs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Xs--;
    };
  }, []);
}
function Ah() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Vr = "right-scroll-bar-position", Ur = "width-before-scroll-bar", NA = "with-scroll-bars-hidden", jA = "--removed-body-scroll-bar-size";
function Qs(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function RA(e, t) {
  var n = Ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var a = n.value;
          a !== o && (n.value = o, n.callback(o, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var IA = typeof window < "u" ? h.useLayoutEffect : h.useEffect, Oh = /* @__PURE__ */ new WeakMap();
function TA(e, t) {
  var n = RA(null, function(o) {
    return e.forEach(function(a) {
      return Qs(a, o);
    });
  });
  return IA(function() {
    var o = Oh.get(n);
    if (o) {
      var a = new Set(o), r = new Set(e), i = n.current;
      a.forEach(function(s) {
        r.has(s) || Qs(s, null);
      }), r.forEach(function(s) {
        a.has(s) || Qs(s, i);
      });
    }
    Oh.set(n, e);
  }, [e]), n;
}
function PA(e) {
  return e;
}
function DA(e, t) {
  t === void 0 && (t = PA);
  var n = [], o = !1, a = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(r);
      }
      n = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(r), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return a;
}
function LA(e) {
  e === void 0 && (e = {});
  var t = DA(null);
  return t.options = st({ async: !0, ssr: !1 }, e), t;
}
var Hb = function(e) {
  var t = e.sideCar, n = Vb(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return h.createElement(o, st({}, n));
};
Hb.isSideCarExport = !0;
function MA(e, t) {
  return e.useMedium(t), Hb;
}
var Kb = LA(), el = function() {
}, rs = h.forwardRef(function(e, t) {
  var n = h.useRef(null), o = h.useState({
    onScrollCapture: el,
    onWheelCapture: el,
    onTouchMoveCapture: el
  }), a = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, y = e.gapMode, _ = Vb(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = m, x = TA([n, t]), S = st(st({}, _), a);
  return h.createElement(
    h.Fragment,
    null,
    u && h.createElement(k, { sideCar: Kb, removeScrollBar: c, shards: d, noIsolation: f, inert: g, setCallbacks: r, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    i ? h.cloneElement(h.Children.only(s), st(st({}, S), { ref: x })) : h.createElement(w, st({}, S, { className: l, ref: x }), s)
  );
});
rs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
rs.classNames = {
  fullWidth: Ur,
  zeroRight: Vr
};
var FA = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function WA() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = FA();
  return t && e.setAttribute("nonce", t), e;
}
function BA(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function VA(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var UA = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = WA()) && (BA(t, n), VA(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, qA = function() {
  var e = UA();
  return function(t, n) {
    h.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Gb = function() {
  var e = qA(), t = function(n) {
    var o = n.styles, a = n.dynamic;
    return e(o, a), null;
  };
  return t;
}, HA = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, tl = function(e) {
  return parseInt(e || "", 10) || 0;
}, KA = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [tl(n), tl(o), tl(a)];
}, GA = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return HA;
  var t = KA(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, ZA = Gb(), Ro = "data-scroll-locked", JA = function(e, t, n, o) {
  var a = e.left, r = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(NA, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Ro, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Vr, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Ur, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Vr, " .").concat(Vr, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Ur, " .").concat(Ur, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Ro, `] {
    `).concat(jA, ": ").concat(s, `px;
  }
`);
}, zh = function() {
  var e = parseInt(document.body.getAttribute(Ro) || "0", 10);
  return isFinite(e) ? e : 0;
}, YA = function() {
  h.useEffect(function() {
    return document.body.setAttribute(Ro, (zh() + 1).toString()), function() {
      var e = zh() - 1;
      e <= 0 ? document.body.removeAttribute(Ro) : document.body.setAttribute(Ro, e.toString());
    };
  }, []);
}, XA = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, a = o === void 0 ? "margin" : o;
  YA();
  var r = h.useMemo(function() {
    return GA(a);
  }, [a]);
  return h.createElement(ZA, { styles: JA(r, !t, a, n ? "" : "!important") });
}, ec = !1;
if (typeof window < "u")
  try {
    var pr = Object.defineProperty({}, "passive", {
      get: function() {
        return ec = !0, !0;
      }
    });
    window.addEventListener("test", pr, pr), window.removeEventListener("test", pr, pr);
  } catch {
    ec = !1;
  }
var yo = ec ? { passive: !1 } : !1, QA = function(e) {
  return e.tagName === "TEXTAREA";
}, Zb = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !QA(e) && n[t] === "visible")
  );
}, eO = function(e) {
  return Zb(e, "overflowY");
}, tO = function(e) {
  return Zb(e, "overflowX");
}, Nh = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var a = Jb(e, o);
    if (a) {
      var r = Yb(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, nO = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, oO = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Jb = function(e, t) {
  return e === "v" ? eO(t) : tO(t);
}, Yb = function(e, t) {
  return e === "v" ? nO(t) : oO(t);
}, aO = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, rO = function(e, t, n, o, a) {
  var r = aO(e, window.getComputedStyle(t).direction), i = r * o, s = n.target, l = t.contains(s), c = !1, u = i > 0, d = 0, m = 0;
  do {
    var f = Yb(e, s), g = f[0], p = f[1], b = f[2], w = p - b - r * g;
    (g || w) && Jb(e, s) && (d += w, m += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(m) < 1) && (c = !0), c;
}, mr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, jh = function(e) {
  return [e.deltaX, e.deltaY];
}, Rh = function(e) {
  return e && "current" in e ? e.current : e;
}, iO = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, sO = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, lO = 0, _o = [];
function cO(e) {
  var t = h.useRef([]), n = h.useRef([0, 0]), o = h.useRef(), a = h.useState(lO++)[0], r = h.useState(Gb)[0], i = h.useRef(e);
  h.useEffect(function() {
    i.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = kA([e.lockRef.current], (e.shards || []).map(Rh)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = h.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = mr(p), y = n.current, _ = "deltaX" in p ? p.deltaX : y[0] - w[0], k = "deltaY" in p ? p.deltaY : y[1] - w[1], x, S = p.target, $ = Math.abs(_) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = Nh($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = Nh($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (_ || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return rO(C, b, p, C === "h" ? _ : k);
  }, []), l = h.useCallback(function(p) {
    var b = p;
    if (!(!_o.length || _o[_o.length - 1] !== r)) {
      var w = "deltaY" in b ? jh(b) : mr(b), y = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && iO(x.delta, w);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var _ = (i.current.shards || []).map(Rh).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = _.length > 0 ? s(b, _[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = h.useCallback(function(p, b, w, y) {
    var _ = { name: p, delta: b, target: w, should: y, shadowParent: uO(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== _;
      });
    }, 1);
  }, []), u = h.useCallback(function(p) {
    n.current = mr(p), o.current = void 0;
  }, []), d = h.useCallback(function(p) {
    c(p.type, jh(p), p.target, s(p, e.lockRef.current));
  }, []), m = h.useCallback(function(p) {
    c(p.type, mr(p), p.target, s(p, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return _o.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, yo), document.addEventListener("touchmove", l, yo), document.addEventListener("touchstart", u, yo), function() {
      _o = _o.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, yo), document.removeEventListener("touchmove", l, yo), document.removeEventListener("touchstart", u, yo);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    g ? h.createElement(r, { styles: sO(a) }) : null,
    f ? h.createElement(XA, { gapMode: e.gapMode }) : null
  );
}
function uO(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const dO = MA(Kb, cO);
var Xb = h.forwardRef(function(e, t) {
  return h.createElement(rs, st({}, e, { ref: t, sideCar: dO }));
});
Xb.classNames = rs.classNames;
var hO = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, wo = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), gr = {}, nl = 0, Qb = function(e) {
  return e && (e.host || Qb(e.parentNode));
}, pO = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Qb(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, mO = function(e, t, n, o) {
  var a = pO(t, Array.isArray(e) ? e : [e]);
  gr[n] || (gr[n] = /* @__PURE__ */ new WeakMap());
  var r = gr[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(a), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  a.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var f = m.getAttribute(o), g = f !== null && f !== "false", p = (wo.get(m) || 0) + 1, b = (r.get(m) || 0) + 1;
          wo.set(m, p), r.set(m, b), i.push(m), p === 1 && g && fr.set(m, !0), b === 1 && m.setAttribute(n, "true"), g || m.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return u(t), s.clear(), nl++, function() {
    i.forEach(function(d) {
      var m = wo.get(d) - 1, f = r.get(d) - 1;
      wo.set(d, m), r.set(d, f), m || (fr.has(d) || d.removeAttribute(o), fr.delete(d)), f || d.removeAttribute(n);
    }), nl--, nl || (wo = /* @__PURE__ */ new WeakMap(), wo = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), gr = {});
  };
}, fO = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = hO(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), mO(o, a, n, "aria-hidden")) : function() {
    return null;
  };
}, ev = "Dialog", [tv, Iye] = ho(ev), [Tye, Yt] = tv(ev), nv = "DialogTrigger", gO = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Yt(nv, n), r = He(t, a.triggerRef);
    return /* @__PURE__ */ v(
      Oe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": bu(a.open),
        ...o,
        ref: r,
        onClick: ge(e.onClick, a.onOpenToggle)
      }
    );
  }
);
gO.displayName = nv;
var bO = "DialogPortal", [Pye, ov] = tv(bO, {
  forceMount: void 0
}), fi = "DialogOverlay", vO = h.forwardRef(
  (e, t) => {
    const n = ov(fi, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Yt(fi, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(mn, { present: o || r.open, children: /* @__PURE__ */ v(_O, { ...a, ref: t }) }) : null;
  }
);
vO.displayName = fi;
var yO = /* @__PURE__ */ hi("DialogOverlay.RemoveScroll"), _O = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Yt(fi, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(Xb, { as: yO, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ v(
        Oe.div,
        {
          "data-state": bu(a.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Xn = "DialogContent", wO = h.forwardRef(
  (e, t) => {
    const n = ov(Xn, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Yt(Xn, e.__scopeDialog);
    return /* @__PURE__ */ v(mn, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(kO, { ...a, ref: t }) : /* @__PURE__ */ v(xO, { ...a, ref: t }) });
  }
);
wO.displayName = Xn;
var kO = h.forwardRef(
  (e, t) => {
    const n = Yt(Xn, e.__scopeDialog), o = h.useRef(null), a = He(t, n.contentRef, o);
    return h.useEffect(() => {
      const r = o.current;
      if (r) return fO(r);
    }, []), /* @__PURE__ */ v(
      av,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ge(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: ge(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: ge(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), xO = h.forwardRef(
  (e, t) => {
    const n = Yt(Xn, e.__scopeDialog), o = h.useRef(!1), a = h.useRef(!1);
    return /* @__PURE__ */ v(
      av,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || n.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, a.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = r.target;
          n.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && a.current && r.preventDefault();
        }
      }
    );
  }
), av = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: r, ...i } = e, s = Yt(Xn, n), l = h.useRef(null), c = He(t, l);
    return zA(), /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        Ub,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: a,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            fu,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": bu(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ P(je, { children: [
        /* @__PURE__ */ v(EO, { titleId: s.titleId }),
        /* @__PURE__ */ v(OO, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), gu = "DialogTitle", $O = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Yt(gu, n);
    return /* @__PURE__ */ v(Oe.h2, { id: a.titleId, ...o, ref: t });
  }
);
$O.displayName = gu;
var rv = "DialogDescription", SO = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Yt(rv, n);
    return /* @__PURE__ */ v(Oe.p, { id: a.descriptionId, ...o, ref: t });
  }
);
SO.displayName = rv;
var iv = "DialogClose", CO = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Yt(iv, n);
    return /* @__PURE__ */ v(
      Oe.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: ge(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
CO.displayName = iv;
function bu(e) {
  return e ? "open" : "closed";
}
var sv = "DialogTitleWarning", [Dye, lv] = dE(sv, {
  contentName: Xn,
  titleName: gu,
  docsSlug: "dialog"
}), EO = ({ titleId: e }) => {
  const t = lv(sv), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return h.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, AO = "DialogDescriptionWarning", OO = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${lv(AO).contentName}}.`;
  return h.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
};
function zO(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function cn(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    n[o] = e[o];
  }
  return n;
}
function pe() {
  return pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, pe.apply(null, arguments);
}
function tc(e, t) {
  return tc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, tc(e, t);
}
function NO(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, tc(e, t);
}
var br = { exports: {} }, ol = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ih;
function jO() {
  if (Ih) return we;
  Ih = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function _(x) {
    if (typeof x == "object" && x !== null) {
      var S = x.$$typeof;
      switch (S) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case o:
            case r:
            case a:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case u:
                case g:
                case f:
                case i:
                  return x;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function k(x) {
    return _(x) === c;
  }
  return we.AsyncMode = l, we.ConcurrentMode = c, we.ContextConsumer = s, we.ContextProvider = i, we.Element = t, we.ForwardRef = u, we.Fragment = o, we.Lazy = g, we.Memo = f, we.Portal = n, we.Profiler = r, we.StrictMode = a, we.Suspense = d, we.isAsyncMode = function(x) {
    return k(x) || _(x) === l;
  }, we.isConcurrentMode = k, we.isContextConsumer = function(x) {
    return _(x) === s;
  }, we.isContextProvider = function(x) {
    return _(x) === i;
  }, we.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, we.isForwardRef = function(x) {
    return _(x) === u;
  }, we.isFragment = function(x) {
    return _(x) === o;
  }, we.isLazy = function(x) {
    return _(x) === g;
  }, we.isMemo = function(x) {
    return _(x) === f;
  }, we.isPortal = function(x) {
    return _(x) === n;
  }, we.isProfiler = function(x) {
    return _(x) === r;
  }, we.isStrictMode = function(x) {
    return _(x) === a;
  }, we.isSuspense = function(x) {
    return _(x) === d;
  }, we.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === o || x === c || x === r || x === a || x === d || x === m || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === f || x.$$typeof === i || x.$$typeof === s || x.$$typeof === u || x.$$typeof === b || x.$$typeof === w || x.$$typeof === y || x.$$typeof === p);
  }, we.typeOf = _, we;
}
var Ce = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Th;
function RO() {
  return Th || (Th = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function _(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === o || V === c || V === r || V === a || V === d || V === m || typeof V == "object" && V !== null && (V.$$typeof === g || V.$$typeof === f || V.$$typeof === i || V.$$typeof === s || V.$$typeof === u || V.$$typeof === b || V.$$typeof === w || V.$$typeof === y || V.$$typeof === p);
    }
    function k(V) {
      if (typeof V == "object" && V !== null) {
        var fe = V.$$typeof;
        switch (fe) {
          case t:
            var X = V.type;
            switch (X) {
              case l:
              case c:
              case o:
              case r:
              case a:
              case d:
                return X;
              default:
                var Ye = X && X.$$typeof;
                switch (Ye) {
                  case s:
                  case u:
                  case g:
                  case f:
                  case i:
                    return Ye;
                  default:
                    return fe;
                }
            }
          case n:
            return fe;
        }
      }
    }
    var x = l, S = c, $ = s, E = i, C = t, A = u, I = o, U = g, M = f, z = n, L = r, q = a, K = d, Z = !1;
    function te(V) {
      return Z || (Z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(V) || k(V) === l;
    }
    function O(V) {
      return k(V) === c;
    }
    function N(V) {
      return k(V) === s;
    }
    function T(V) {
      return k(V) === i;
    }
    function W(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function B(V) {
      return k(V) === u;
    }
    function J(V) {
      return k(V) === o;
    }
    function ee(V) {
      return k(V) === g;
    }
    function D(V) {
      return k(V) === f;
    }
    function Y(V) {
      return k(V) === n;
    }
    function Q(V) {
      return k(V) === r;
    }
    function G(V) {
      return k(V) === a;
    }
    function ne(V) {
      return k(V) === d;
    }
    Ce.AsyncMode = x, Ce.ConcurrentMode = S, Ce.ContextConsumer = $, Ce.ContextProvider = E, Ce.Element = C, Ce.ForwardRef = A, Ce.Fragment = I, Ce.Lazy = U, Ce.Memo = M, Ce.Portal = z, Ce.Profiler = L, Ce.StrictMode = q, Ce.Suspense = K, Ce.isAsyncMode = te, Ce.isConcurrentMode = O, Ce.isContextConsumer = N, Ce.isContextProvider = T, Ce.isElement = W, Ce.isForwardRef = B, Ce.isFragment = J, Ce.isLazy = ee, Ce.isMemo = D, Ce.isPortal = Y, Ce.isProfiler = Q, Ce.isStrictMode = G, Ce.isSuspense = ne, Ce.isValidElementType = _, Ce.typeOf = k;
  }()), Ce;
}
var Ph;
function cv() {
  return Ph || (Ph = 1, process.env.NODE_ENV === "production" ? ol.exports = jO() : ol.exports = RO()), ol.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var al, Dh;
function IO() {
  if (Dh) return al;
  Dh = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return al = a() ? Object.assign : function(r, i) {
    for (var s, l = o(r), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var m = 0; m < c.length; m++)
          n.call(s, c[m]) && (l[c[m]] = s[c[m]]);
      }
    }
    return l;
  }, al;
}
var rl, Lh;
function vu() {
  if (Lh) return rl;
  Lh = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return rl = e, rl;
}
var Mh, Fh;
function uv() {
  return Fh || (Fh = 1, Mh = Function.call.bind(Object.prototype.hasOwnProperty)), Mh;
}
var il, Wh;
function TO() {
  if (Wh) return il;
  Wh = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ vu(), n = {}, o = /* @__PURE__ */ uv();
    e = function(r) {
      var i = "Warning: " + r;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(r, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in r)
        if (o(r, u)) {
          var d;
          try {
            if (typeof r[u] != "function") {
              var m = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            d = r[u](i, u, l, s, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var f = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (f ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, il = a, il;
}
var sl, Bh;
function PO() {
  if (Bh) return sl;
  Bh = 1;
  var e = cv(), t = IO(), n = /* @__PURE__ */ vu(), o = /* @__PURE__ */ uv(), a = /* @__PURE__ */ TO(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return sl = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(O) {
      var N = O && (c && O[c] || O[u]);
      if (typeof N == "function")
        return N;
    }
    var m = "<<anonymous>>", f = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: y(),
      arrayOf: _,
      element: k(),
      elementType: x(),
      instanceOf: S,
      node: A(),
      objectOf: E,
      oneOf: $,
      oneOfType: C,
      shape: U,
      exact: M
    };
    function g(O, N) {
      return O === N ? O !== 0 || 1 / O === 1 / N : O !== O && N !== N;
    }
    function p(O, N) {
      this.message = O, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function b(O) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, T = 0;
      function W(J, ee, D, Y, Q, G, ne) {
        if (Y = Y || m, G = G || D, ne !== n) {
          if (l) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = Y + ":" + D;
            !N[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[fe] = !0, T++);
          }
        }
        return ee[D] == null ? J ? ee[D] === null ? new p("The " + Q + " `" + G + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new p("The " + Q + " `" + G + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : O(ee, D, Y, Q, G);
      }
      var B = W.bind(null, !1);
      return B.isRequired = W.bind(null, !0), B;
    }
    function w(O) {
      function N(T, W, B, J, ee, D) {
        var Y = T[W], Q = q(Y);
        if (Q !== O) {
          var G = K(Y);
          return new p(
            "Invalid " + J + " `" + ee + "` of type " + ("`" + G + "` supplied to `" + B + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return b(N);
    }
    function y() {
      return b(i);
    }
    function _(O) {
      function N(T, W, B, J, ee) {
        if (typeof O != "function")
          return new p("Property `" + ee + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var D = T[W];
        if (!Array.isArray(D)) {
          var Y = q(D);
          return new p("Invalid " + J + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected an array."));
        }
        for (var Q = 0; Q < D.length; Q++) {
          var G = O(D, Q, B, J, ee + "[" + Q + "]", n);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return b(N);
    }
    function k() {
      function O(N, T, W, B, J) {
        var ee = N[T];
        if (!s(ee)) {
          var D = q(ee);
          return new p("Invalid " + B + " `" + J + "` of type " + ("`" + D + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(O);
    }
    function x() {
      function O(N, T, W, B, J) {
        var ee = N[T];
        if (!e.isValidElementType(ee)) {
          var D = q(ee);
          return new p("Invalid " + B + " `" + J + "` of type " + ("`" + D + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(O);
    }
    function S(O) {
      function N(T, W, B, J, ee) {
        if (!(T[W] instanceof O)) {
          var D = O.name || m, Y = te(T[W]);
          return new p("Invalid " + J + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected ") + ("instance of `" + D + "`."));
        }
        return null;
      }
      return b(N);
    }
    function $(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), i;
      function N(T, W, B, J, ee) {
        for (var D = T[W], Y = 0; Y < O.length; Y++)
          if (g(D, O[Y]))
            return null;
        var Q = JSON.stringify(O, function(G, ne) {
          var V = K(ne);
          return V === "symbol" ? String(ne) : ne;
        });
        return new p("Invalid " + J + " `" + ee + "` of value `" + String(D) + "` " + ("supplied to `" + B + "`, expected one of " + Q + "."));
      }
      return b(N);
    }
    function E(O) {
      function N(T, W, B, J, ee) {
        if (typeof O != "function")
          return new p("Property `" + ee + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var D = T[W], Y = q(D);
        if (Y !== "object")
          return new p("Invalid " + J + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected an object."));
        for (var Q in D)
          if (o(D, Q)) {
            var G = O(D, Q, B, J, ee + "." + Q, n);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return b(N);
    }
    function C(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var N = 0; N < O.length; N++) {
        var T = O[N];
        if (typeof T != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Z(T) + " at index " + N + "."
          ), i;
      }
      function W(B, J, ee, D, Y) {
        for (var Q = [], G = 0; G < O.length; G++) {
          var ne = O[G], V = ne(B, J, ee, D, Y, n);
          if (V == null)
            return null;
          V.data && o(V.data, "expectedType") && Q.push(V.data.expectedType);
        }
        var fe = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new p("Invalid " + D + " `" + Y + "` supplied to " + ("`" + ee + "`" + fe + "."));
      }
      return b(W);
    }
    function A() {
      function O(N, T, W, B, J) {
        return z(N[T]) ? null : new p("Invalid " + B + " `" + J + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return b(O);
    }
    function I(O, N, T, W, B) {
      return new p(
        (O || "React class") + ": " + N + " type `" + T + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function U(O) {
      function N(T, W, B, J, ee) {
        var D = T[W], Y = q(D);
        if (Y !== "object")
          return new p("Invalid " + J + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var Q in O) {
          var G = O[Q];
          if (typeof G != "function")
            return I(B, J, ee, Q, K(G));
          var ne = G(D, Q, B, J, ee + "." + Q, n);
          if (ne)
            return ne;
        }
        return null;
      }
      return b(N);
    }
    function M(O) {
      function N(T, W, B, J, ee) {
        var D = T[W], Y = q(D);
        if (Y !== "object")
          return new p("Invalid " + J + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + B + "`, expected `object`."));
        var Q = t({}, T[W], O);
        for (var G in Q) {
          var ne = O[G];
          if (o(O, G) && typeof ne != "function")
            return I(B, J, ee, G, K(ne));
          if (!ne)
            return new p(
              "Invalid " + J + " `" + ee + "` key `" + G + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(T[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var V = ne(D, G, B, J, ee + "." + G, n);
          if (V)
            return V;
        }
        return null;
      }
      return b(N);
    }
    function z(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(z);
          if (O === null || s(O))
            return !0;
          var N = d(O);
          if (N) {
            var T = N.call(O), W;
            if (N !== O.entries) {
              for (; !(W = T.next()).done; )
                if (!z(W.value))
                  return !1;
            } else
              for (; !(W = T.next()).done; ) {
                var B = W.value;
                if (B && !z(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(O, N) {
      return O === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function q(O) {
      var N = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : L(N, O) ? "symbol" : N;
    }
    function K(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var N = q(O);
      if (N === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function Z(O) {
      var N = K(O);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function te(O) {
      return !O.constructor || !O.constructor.name ? m : O.constructor.name;
    }
    return f.checkPropTypes = a, f.resetWarningCache = a.resetWarningCache, f.PropTypes = f, f;
  }, sl;
}
var ll, Vh;
function DO() {
  if (Vh) return ll;
  Vh = 1;
  var e = /* @__PURE__ */ vu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ll = function() {
    function o(i, s, l, c, u, d) {
      if (d !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    o.isRequired = o;
    function a() {
      return o;
    }
    var r = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: a,
      element: o,
      elementType: o,
      instanceOf: a,
      node: o,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, ll;
}
var Uh;
function LO() {
  if (Uh) return br.exports;
  if (Uh = 1, process.env.NODE_ENV !== "production") {
    var e = cv(), t = !0;
    br.exports = /* @__PURE__ */ PO()(e.isElement, t);
  } else
    br.exports = /* @__PURE__ */ DO()();
  return br.exports;
}
var MO = /* @__PURE__ */ LO();
const H = /* @__PURE__ */ zO(MO);
var cl = { exports: {} }, ke = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qh;
function FO() {
  if (qh) return ke;
  qh = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function p(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case e:
          switch (b = b.type, b) {
            case n:
            case a:
            case o:
            case c:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case i:
                case l:
                case m:
                case d:
                case r:
                  return b;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return ke.ContextConsumer = i, ke.ContextProvider = r, ke.Element = e, ke.ForwardRef = l, ke.Fragment = n, ke.Lazy = m, ke.Memo = d, ke.Portal = t, ke.Profiler = a, ke.StrictMode = o, ke.Suspense = c, ke.SuspenseList = u, ke.isAsyncMode = function() {
    return !1;
  }, ke.isConcurrentMode = function() {
    return !1;
  }, ke.isContextConsumer = function(b) {
    return p(b) === i;
  }, ke.isContextProvider = function(b) {
    return p(b) === r;
  }, ke.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, ke.isForwardRef = function(b) {
    return p(b) === l;
  }, ke.isFragment = function(b) {
    return p(b) === n;
  }, ke.isLazy = function(b) {
    return p(b) === m;
  }, ke.isMemo = function(b) {
    return p(b) === d;
  }, ke.isPortal = function(b) {
    return p(b) === t;
  }, ke.isProfiler = function(b) {
    return p(b) === a;
  }, ke.isStrictMode = function(b) {
    return p(b) === o;
  }, ke.isSuspense = function(b) {
    return p(b) === c;
  }, ke.isSuspenseList = function(b) {
    return p(b) === u;
  }, ke.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === a || b === o || b === c || b === u || b === f || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === d || b.$$typeof === r || b.$$typeof === i || b.$$typeof === l || b.$$typeof === g || b.getModuleId !== void 0);
  }, ke.typeOf = p, ke;
}
var Ee = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hh;
function WO() {
  return Hh || (Hh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = !1, p = !1, b = !1, w = !1, y = !1, _;
    _ = Symbol.for("react.module.reference");
    function k(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === a || y || X === o || X === c || X === u || w || X === f || g || p || b || typeof X == "object" && X !== null && (X.$$typeof === m || X.$$typeof === d || X.$$typeof === r || X.$$typeof === i || X.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === _ || X.getModuleId !== void 0));
    }
    function x(X) {
      if (typeof X == "object" && X !== null) {
        var Ye = X.$$typeof;
        switch (Ye) {
          case e:
            var Ve = X.type;
            switch (Ve) {
              case n:
              case a:
              case o:
              case c:
              case u:
                return Ve;
              default:
                var Ft = Ve && Ve.$$typeof;
                switch (Ft) {
                  case s:
                  case i:
                  case l:
                  case m:
                  case d:
                  case r:
                    return Ft;
                  default:
                    return Ye;
                }
            }
          case t:
            return Ye;
        }
      }
    }
    var S = i, $ = r, E = e, C = l, A = n, I = m, U = d, M = t, z = a, L = o, q = c, K = u, Z = !1, te = !1;
    function O(X) {
      return Z || (Z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(X) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(X) {
      return x(X) === i;
    }
    function W(X) {
      return x(X) === r;
    }
    function B(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function J(X) {
      return x(X) === l;
    }
    function ee(X) {
      return x(X) === n;
    }
    function D(X) {
      return x(X) === m;
    }
    function Y(X) {
      return x(X) === d;
    }
    function Q(X) {
      return x(X) === t;
    }
    function G(X) {
      return x(X) === a;
    }
    function ne(X) {
      return x(X) === o;
    }
    function V(X) {
      return x(X) === c;
    }
    function fe(X) {
      return x(X) === u;
    }
    Ee.ContextConsumer = S, Ee.ContextProvider = $, Ee.Element = E, Ee.ForwardRef = C, Ee.Fragment = A, Ee.Lazy = I, Ee.Memo = U, Ee.Portal = M, Ee.Profiler = z, Ee.StrictMode = L, Ee.Suspense = q, Ee.SuspenseList = K, Ee.isAsyncMode = O, Ee.isConcurrentMode = N, Ee.isContextConsumer = T, Ee.isContextProvider = W, Ee.isElement = B, Ee.isForwardRef = J, Ee.isFragment = ee, Ee.isLazy = D, Ee.isMemo = Y, Ee.isPortal = Q, Ee.isProfiler = G, Ee.isStrictMode = ne, Ee.isSuspense = V, Ee.isSuspenseList = fe, Ee.isValidElementType = k, Ee.typeOf = x;
  }()), Ee;
}
var Kh;
function BO() {
  return Kh || (Kh = 1, process.env.NODE_ENV === "production" ? cl.exports = FO() : cl.exports = WO()), cl.exports;
}
var Gh = BO();
const Zh = (e) => typeof e == "object" && e != null && e.nodeType === 1, Jh = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", vr = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return Jh(n.overflowY, t) || Jh(n.overflowX, t) || ((o) => {
      const a = ((r) => {
        if (!r.ownerDocument || !r.ownerDocument.defaultView) return null;
        try {
          return r.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!a && (a.clientHeight < o.scrollHeight || a.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, yr = (e, t, n, o, a, r, i, s) => r < e && i > t || r > e && i < t ? 0 : r <= e && s <= n || i >= t && s >= n ? r - e - o : i > t && s < n || r < e && s > n ? i - t + a : 0, VO = (e) => e.parentElement ?? (e.getRootNode().host || null), UO = (e, t) => {
  var n, o, a, r;
  if (typeof document > "u") return [];
  const { inline: i, boundary: s, skipOverflowHiddenElements: l } = t, c = typeof s == "function" ? s : (M) => M !== s;
  if (!Zh(e)) throw new TypeError("Invalid target");
  const u = document.scrollingElement || document.documentElement, d = [];
  let m = e;
  for (; Zh(m) && c(m); ) {
    if (m = VO(m), m === u) {
      d.push(m);
      break;
    }
    m != null && m === document.body && vr(m) && !vr(document.documentElement) || m != null && vr(m, l) && d.push(m);
  }
  const f = (o = (n = window.visualViewport) == null ? void 0 : n.width) != null ? o : innerWidth, g = (r = (a = window.visualViewport) == null ? void 0 : a.height) != null ? r : innerHeight, { scrollX: p, scrollY: b } = window, { height: w, width: y, top: _, right: k, bottom: x, left: S } = e.getBoundingClientRect(), { top: $, right: E, left: C } = ((M) => {
    const z = window.getComputedStyle(M);
    return { top: parseFloat(z.scrollMarginTop) || 0, right: parseFloat(z.scrollMarginRight) || 0, bottom: parseFloat(z.scrollMarginBottom) || 0, left: parseFloat(z.scrollMarginLeft) || 0 };
  })(e);
  let A = _ - $, I = i === "center" ? S + y / 2 - C + E : i === "end" ? k + E : S - C;
  const U = [];
  for (let M = 0; M < d.length; M++) {
    const z = d[M], { height: L, width: q, top: K, right: Z, bottom: te, left: O } = z.getBoundingClientRect();
    if (_ >= 0 && S >= 0 && x <= g && k <= f && (z === u && !vr(z) || _ >= K && x <= te && S >= O && k <= Z)) return U;
    const N = getComputedStyle(z), T = parseInt(N.borderLeftWidth, 10), W = parseInt(N.borderTopWidth, 10), B = parseInt(N.borderRightWidth, 10), J = parseInt(N.borderBottomWidth, 10);
    let ee = 0, D = 0;
    const Y = "offsetWidth" in z ? z.offsetWidth - z.clientWidth - T - B : 0, Q = "offsetHeight" in z ? z.offsetHeight - z.clientHeight - W - J : 0, G = "offsetWidth" in z ? z.offsetWidth === 0 ? 0 : q / z.offsetWidth : 0, ne = "offsetHeight" in z ? z.offsetHeight === 0 ? 0 : L / z.offsetHeight : 0;
    if (u === z) ee = yr(b, b + g, g, W, J, b + A, b + A + w, w), D = i === "start" ? I : i === "center" ? I - f / 2 : i === "end" ? I - f : yr(p, p + f, f, T, B, p + I, p + I + y, y), ee = Math.max(0, ee + b), D = Math.max(0, D + p);
    else {
      ee = yr(K, te, L, W, J + Q, A, A + w, w), D = i === "start" ? I - O - T : i === "center" ? I - (O + q / 2) + Y / 2 : i === "end" ? I - Z + B + Y : yr(O, Z, q, T, B + Y, I, I + y, y);
      const { scrollLeft: V, scrollTop: fe } = z;
      ee = ne === 0 ? 0 : Math.max(0, Math.min(fe + ee / ne, z.scrollHeight - L / ne + Q)), D = G === 0 ? 0 : Math.max(0, Math.min(V + D / G, z.scrollWidth - q / G + Y)), A += fe - ee, I += V - D;
    }
    U.push({ el: z, top: ee, left: D });
  }
  return U;
};
var qO = 0;
function Yh(e) {
  return typeof e == "function" ? e : vt;
}
function vt() {
}
function dv(e, t) {
  if (e) {
    var n = UO(e, {
      boundary: t
    });
    n.forEach(function(o) {
      var a = o.el, r = o.top, i = o.left;
      a.scrollTop = r, a.scrollLeft = i;
    });
  }
}
function Xh(e, t, n) {
  var o = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return o;
}
function yu(e, t) {
  var n;
  function o() {
    n && clearTimeout(n);
  }
  function a() {
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    o(), n = setTimeout(function() {
      n = null, e.apply(void 0, i);
    }, t);
  }
  return a.cancel = o, a;
}
function Ge() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      r[i - 1] = arguments[i];
    return t.some(function(s) {
      return s && s.apply(void 0, [o].concat(r)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function zo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    t.forEach(function(a) {
      typeof a == "function" ? a(o) : a && (a.current = o);
    });
  };
}
function hv() {
  return String(qO++);
}
function HO(e) {
  var t = e.isOpen, n = e.resultCount, o = e.previousResultCount;
  return t ? n ? n !== o ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Qh(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function pv(e) {
  return typeof e.type == "string";
}
function mv(e) {
  return e.props;
}
function KO(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var GO = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function _r(e) {
  e === void 0 && (e = {});
  var t = {};
  return GO.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function gi(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(n, o) {
    return n[o] = bi(t, o) ? t[o] : e[o], n;
  }, {});
}
function bi(e, t) {
  return e[t] !== void 0;
}
function nc(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function ZO(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Wn(e, t, n, o, a) {
  var r = n.length;
  if (r === 0)
    return -1;
  var i = r - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var s = e + t;
  s < 0 ? s = i : s > i && (s = 0);
  var l = Bo(s, t < 0, n, o, a);
  return l === -1 ? e >= r ? -1 : e : l;
}
function Bo(e, t, n, o, a) {
  a === void 0 && (a = !1);
  var r = n.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!o(n[i], i))
        return i;
  } else
    for (var s = e; s < r; s++)
      if (!o(n[s], s))
        return s;
  return a ? Bo(t ? r - 1 : 0, t, n, o) : -1;
}
function vi(e, t, n, o) {
  return o === void 0 && (o = !0), n && t.some(function(a) {
    return a && (Xh(a, e, n) || o && Xh(a, n.document.activeElement, n));
  });
}
var _u = vt;
process.env.NODE_ENV !== "production" && (_u = function(e, t, n) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(a) {
    t[a] !== void 0 && n[a] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + a + '" to be uncontrolled. ' + o) : t[a] === void 0 && n[a] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + a + '" to be controlled. ' + o);
  });
});
var JO = yu(function(e) {
  fv(e).textContent = "";
}, 500);
function fv(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function gv(e, t) {
  if (!(!e || !t)) {
    var n = fv(t);
    n.textContent = e, JO(t);
  }
}
function YO(e) {
  var t = e?.getElementById("a11y-status-message");
  t && t.remove();
}
var bv = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, vv = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, yv = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, qr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Hr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, _v = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, wv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, kv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, xv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, $v = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Sv = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Cv = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Ev = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, oc = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Av = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Ov = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, zv = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, XO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Av,
  blurInput: Sv,
  changeInput: Cv,
  clickButton: oc,
  clickItem: $v,
  controlledPropUpdatedSelectedItem: Ov,
  itemMouseEnter: yv,
  keyDownArrowDown: Hr,
  keyDownArrowUp: qr,
  keyDownEnd: xv,
  keyDownEnter: wv,
  keyDownEscape: _v,
  keyDownHome: kv,
  keyDownSpaceButton: Ev,
  mouseUp: vv,
  touchEnd: zv,
  unknown: bv
}), QO = ["refKey", "ref"], ez = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], tz = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], nz = ["refKey", "ref"], oz = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], az = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function n(a) {
      var r;
      r = t.call(this, a) || this, r.id = r.props.id || "downshift-" + hv(), r.menuId = r.props.menuId || r.id + "-menu", r.labelId = r.props.labelId || r.id + "-label", r.inputId = r.props.inputId || r.id + "-input", r.getItemId = r.props.getItemId || function(y) {
        return r.id + "-item-" + y;
      }, r.items = [], r.itemCount = null, r.previousResultCount = 0, r.timeoutIds = [], r.internalSetTimeout = function(y, _) {
        var k = setTimeout(function() {
          r.timeoutIds = r.timeoutIds.filter(function(x) {
            return x !== k;
          }), y();
        }, _);
        r.timeoutIds.push(k);
      }, r.setItemCount = function(y) {
        r.itemCount = y;
      }, r.unsetItemCount = function() {
        r.itemCount = null;
      }, r.isItemDisabled = function(y, _) {
        var k = r.getItemNodeFromIndex(_);
        return k && k.hasAttribute("disabled");
      }, r.setHighlightedIndex = function(y, _) {
        y === void 0 && (y = r.props.defaultHighlightedIndex), _ === void 0 && (_ = {}), _ = _r(_), r.internalSetState(pe({
          highlightedIndex: y
        }, _));
      }, r.clearSelection = function(y) {
        r.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: r.props.defaultHighlightedIndex,
          isOpen: r.props.defaultIsOpen
        }, y);
      }, r.selectItem = function(y, _, k) {
        _ = _r(_), r.internalSetState(pe({
          isOpen: r.props.defaultIsOpen,
          highlightedIndex: r.props.defaultHighlightedIndex,
          selectedItem: y,
          inputValue: r.props.itemToString(y)
        }, _), k);
      }, r.selectItemAtIndex = function(y, _, k) {
        var x = r.items[y];
        x != null && r.selectItem(x, _, k);
      }, r.selectHighlightedItem = function(y, _) {
        return r.selectItemAtIndex(r.getState().highlightedIndex, y, _);
      }, r.internalSetState = function(y, _) {
        var k, x, S = {}, $ = typeof y == "function";
        return !$ && y.hasOwnProperty("inputValue") && r.props.onInputValueChange(y.inputValue, pe({}, r.getStateAndHelpers(), y)), r.setState(function(E) {
          var C;
          E = r.getState(E);
          var A = $ ? y(E) : y;
          A = r.props.stateReducer(E, A), k = A.hasOwnProperty("selectedItem");
          var I = {};
          return k && A.selectedItem !== E.selectedItem && (x = A.selectedItem), (C = A).type || (C.type = bv), Object.keys(A).forEach(function(U) {
            E[U] !== A[U] && (S[U] = A[U]), U !== "type" && (A[U], bi(r.props, U) || (I[U] = A[U]));
          }), $ && A.hasOwnProperty("inputValue") && r.props.onInputValueChange(A.inputValue, pe({}, r.getStateAndHelpers(), A)), I;
        }, function() {
          Yh(_)();
          var E = Object.keys(S).length > 1;
          E && r.props.onStateChange(S, r.getStateAndHelpers()), k && r.props.onSelect(y.selectedItem, r.getStateAndHelpers()), x !== void 0 && r.props.onChange(x, r.getStateAndHelpers()), r.props.onUserAction(S, r.getStateAndHelpers());
        });
      }, r.rootRef = function(y) {
        return r._rootNode = y;
      }, r.getRootProps = function(y, _) {
        var k, x = y === void 0 ? {} : y, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = cn(x, QO), A = _ === void 0 ? {} : _, I = A.suppressRefError, U = I === void 0 ? !1 : I;
        r.getRootProps.called = !0, r.getRootProps.refKey = $, r.getRootProps.suppressRefError = U;
        var M = r.getState(), z = M.isOpen;
        return pe((k = {}, k[$] = zo(E, r.rootRef), k.role = "combobox", k["aria-expanded"] = z, k["aria-haspopup"] = "listbox", k["aria-owns"] = z ? r.menuId : void 0, k["aria-labelledby"] = r.labelId, k), C);
      }, r.keyDownHandlers = {
        ArrowDown: function(y) {
          var _ = this;
          if (y.preventDefault(), this.getState().isOpen) {
            var k = y.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(k, {
              type: Hr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Hr
            }, function() {
              var x = _.getItemCount();
              if (x > 0) {
                var S = _.getState(), $ = S.highlightedIndex, E = Wn($, 1, {
                  length: x
                }, _.isItemDisabled, !0);
                _.setHighlightedIndex(E, {
                  type: Hr
                });
              }
            });
        },
        ArrowUp: function(y) {
          var _ = this;
          if (y.preventDefault(), this.getState().isOpen) {
            var k = y.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(k, {
              type: qr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: qr
            }, function() {
              var x = _.getItemCount();
              if (x > 0) {
                var S = _.getState(), $ = S.highlightedIndex, E = Wn($, -1, {
                  length: x
                }, _.isItemDisabled, !0);
                _.setHighlightedIndex(E, {
                  type: qr
                });
              }
            });
        },
        Enter: function(y) {
          if (y.which !== 229) {
            var _ = this.getState(), k = _.isOpen, x = _.highlightedIndex;
            if (k && x != null) {
              y.preventDefault();
              var S = this.items[x], $ = this.getItemNodeFromIndex(x);
              if (S == null || $ && $.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: wv
              });
            }
          }
        },
        Escape: function(y) {
          y.preventDefault(), this.reset(pe({
            type: _v
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, r.buttonKeyDownHandlers = pe({}, r.keyDownHandlers, {
        " ": function(y) {
          y.preventDefault(), this.toggleMenu({
            type: Ev
          });
        }
      }), r.inputKeyDownHandlers = pe({}, r.keyDownHandlers, {
        Home: function(y) {
          var _ = this.getState(), k = _.isOpen;
          if (k) {
            y.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Bo(0, !1, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: kv
              });
            }
          }
        },
        End: function(y) {
          var _ = this.getState(), k = _.isOpen;
          if (k) {
            y.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Bo(x - 1, !0, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: xv
              });
            }
          }
        }
      }), r.getToggleButtonProps = function(y) {
        var _ = y === void 0 ? {} : y, k = _.onClick;
        _.onPress;
        var x = _.onKeyDown, S = _.onKeyUp, $ = _.onBlur, E = cn(_, ez), C = r.getState(), A = C.isOpen, I = {
          onClick: Ge(k, r.buttonHandleClick),
          onKeyDown: Ge(x, r.buttonHandleKeyDown),
          onKeyUp: Ge(S, r.buttonHandleKeyUp),
          onBlur: Ge($, r.buttonHandleBlur)
        }, U = E.disabled ? {} : I;
        return pe({
          type: "button",
          role: "button",
          "aria-label": A ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, U, E);
      }, r.buttonHandleKeyUp = function(y) {
        y.preventDefault();
      }, r.buttonHandleKeyDown = function(y) {
        var _ = nc(y);
        r.buttonKeyDownHandlers[_] && r.buttonKeyDownHandlers[_].call(r, y);
      }, r.buttonHandleClick = function(y) {
        if (y.preventDefault(), r.props.environment) {
          var _ = r.props.environment.document, k = _.body, x = _.activeElement;
          k && k === x && y.target.focus();
        }
        process.env.NODE_ENV === "test" ? r.toggleMenu({
          type: oc
        }) : r.internalSetTimeout(function() {
          return r.toggleMenu({
            type: oc
          });
        });
      }, r.buttonHandleBlur = function(y) {
        var _ = y.target;
        r.internalSetTimeout(function() {
          if (!(r.isMouseDown || !r.props.environment)) {
            var k = r.props.environment.document.activeElement;
            (k == null || k.id !== r.inputId) && k !== _ && r.reset({
              type: Av
            });
          }
        });
      }, r.getLabelProps = function(y) {
        return pe({
          htmlFor: r.inputId,
          id: r.labelId
        }, y);
      }, r.getInputProps = function(y) {
        var _ = y === void 0 ? {} : y, k = _.onKeyDown, x = _.onBlur, S = _.onChange, $ = _.onInput;
        _.onChangeText;
        var E = cn(_, tz), C, A = {};
        C = "onChange";
        var I = r.getState(), U = I.inputValue, M = I.isOpen, z = I.highlightedIndex;
        if (!E.disabled) {
          var L;
          A = (L = {}, L[C] = Ge(S, $, r.inputHandleChange), L.onKeyDown = Ge(k, r.inputHandleKeyDown), L.onBlur = Ge(x, r.inputHandleBlur), L);
        }
        return pe({
          "aria-autocomplete": "list",
          "aria-activedescendant": M && typeof z == "number" && z >= 0 ? r.getItemId(z) : void 0,
          "aria-controls": M ? r.menuId : void 0,
          "aria-labelledby": E && E["aria-label"] ? void 0 : r.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: U,
          id: r.inputId
        }, A, E);
      }, r.inputHandleKeyDown = function(y) {
        var _ = nc(y);
        _ && r.inputKeyDownHandlers[_] && r.inputKeyDownHandlers[_].call(r, y);
      }, r.inputHandleChange = function(y) {
        r.internalSetState({
          type: Cv,
          isOpen: !0,
          inputValue: y.target.value,
          highlightedIndex: r.props.defaultHighlightedIndex
        });
      }, r.inputHandleBlur = function() {
        r.internalSetTimeout(function() {
          var y;
          if (!(r.isMouseDown || !r.props.environment)) {
            var _ = r.props.environment.document.activeElement, k = (_ == null || (y = _.dataset) == null ? void 0 : y.toggle) && r._rootNode && r._rootNode.contains(_);
            k || r.reset({
              type: Sv
            });
          }
        });
      }, r.menuRef = function(y) {
        r._menuNode = y;
      }, r.getMenuProps = function(y, _) {
        var k, x = y === void 0 ? {} : y, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = cn(x, nz), A = _ === void 0 ? {} : _, I = A.suppressRefError, U = I === void 0 ? !1 : I;
        return r.getMenuProps.called = !0, r.getMenuProps.refKey = $, r.getMenuProps.suppressRefError = U, pe((k = {}, k[$] = zo(E, r.menuRef), k.role = "listbox", k["aria-labelledby"] = C && C["aria-label"] ? void 0 : r.labelId, k.id = r.menuId, k), C);
      }, r.getItemProps = function(y) {
        var _, k = y === void 0 ? {} : y, x = k.onMouseMove, S = k.onMouseDown, $ = k.onClick;
        k.onPress;
        var E = k.index, C = k.item, A = C === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : KO("getItemProps", "item") : C, I = cn(k, oz);
        E === void 0 ? (r.items.push(A), E = r.items.indexOf(A)) : r.items[E] = A;
        var U = "onClick", M = $, z = (_ = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Ge(x, function() {
            E !== r.getState().highlightedIndex && (r.setHighlightedIndex(E, {
              type: yv
            }), r.avoidScrolling = !0, r.internalSetTimeout(function() {
              return r.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Ge(S, function(q) {
            q.preventDefault();
          })
        }, _[U] = Ge(M, function() {
          r.selectItemAtIndex(E, {
            type: $v
          });
        }), _), L = I.disabled ? {
          onMouseDown: z.onMouseDown
        } : z;
        return pe({
          id: r.getItemId(E),
          role: "option",
          "aria-selected": r.getState().highlightedIndex === E
        }, L, I);
      }, r.clearItems = function() {
        r.items = [];
      }, r.reset = function(y, _) {
        y === void 0 && (y = {}), y = _r(y), r.internalSetState(function(k) {
          var x = k.selectedItem;
          return pe({
            isOpen: r.props.defaultIsOpen,
            highlightedIndex: r.props.defaultHighlightedIndex,
            inputValue: r.props.itemToString(x)
          }, y);
        }, _);
      }, r.toggleMenu = function(y, _) {
        y === void 0 && (y = {}), y = _r(y), r.internalSetState(function(k) {
          var x = k.isOpen;
          return pe({
            isOpen: !x
          }, x && {
            highlightedIndex: r.props.defaultHighlightedIndex
          }, y);
        }, function() {
          var k = r.getState(), x = k.isOpen, S = k.highlightedIndex;
          x && r.getItemCount() > 0 && typeof S == "number" && r.setHighlightedIndex(S, y), Yh(_)();
        });
      }, r.openMenu = function(y) {
        r.internalSetState({
          isOpen: !0
        }, y);
      }, r.closeMenu = function(y) {
        r.internalSetState({
          isOpen: !1
        }, y);
      }, r.updateStatus = yu(function() {
        var y;
        if ((y = r.props) != null && (y = y.environment) != null && y.document) {
          var _ = r.getState(), k = r.items[_.highlightedIndex], x = r.getItemCount(), S = r.props.getA11yStatusMessage(pe({
            itemToString: r.props.itemToString,
            previousResultCount: r.previousResultCount,
            resultCount: x,
            highlightedItem: k
          }, _));
          r.previousResultCount = x, gv(S, r.props.environment.document);
        }
      }, 200);
      var i = r.props, s = i.defaultHighlightedIndex, l = i.initialHighlightedIndex, c = l === void 0 ? s : l, u = i.defaultIsOpen, d = i.initialIsOpen, m = d === void 0 ? u : d, f = i.initialInputValue, g = f === void 0 ? "" : f, p = i.initialSelectedItem, b = p === void 0 ? null : p, w = r.getState({
        highlightedIndex: c,
        isOpen: m,
        inputValue: g,
        selectedItem: b
      });
      return w.selectedItem != null && r.props.initialInputValue === void 0 && (w.inputValue = r.props.itemToString(w.selectedItem)), r.state = w, r;
    }
    NO(n, t);
    var o = n.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(a) {
        clearTimeout(a);
      }), this.timeoutIds = [];
    }, o.getState = function(a) {
      return a === void 0 && (a = this.state), gi(a, this.props);
    }, o.getItemCount = function() {
      var a = this.items.length;
      return this.itemCount != null ? a = this.itemCount : this.props.itemCount !== void 0 && (a = this.props.itemCount), a;
    }, o.getItemNodeFromIndex = function(a) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(a)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var a = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(a, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(a, r) {
      var i = this.getItemCount(), s = this.getState(), l = s.highlightedIndex;
      if (i > 0) {
        var c = Wn(l, a, {
          length: i
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, r);
      }
    }, o.getStateAndHelpers = function() {
      var a = this.getState(), r = a.highlightedIndex, i = a.inputValue, s = a.selectedItem, l = a.isOpen, c = this.props.itemToString, u = this.id, d = this.getRootProps, m = this.getToggleButtonProps, f = this.getLabelProps, g = this.getMenuProps, p = this.getInputProps, b = this.getItemProps, w = this.openMenu, y = this.closeMenu, _ = this.toggleMenu, k = this.selectItem, x = this.selectItemAtIndex, S = this.selectHighlightedItem, $ = this.setHighlightedIndex, E = this.clearSelection, C = this.clearItems, A = this.reset, I = this.setItemCount, U = this.unsetItemCount, M = this.internalSetState;
      return {
        // prop getters
        getRootProps: d,
        getToggleButtonProps: m,
        getLabelProps: f,
        getMenuProps: g,
        getInputProps: p,
        getItemProps: b,
        // actions
        reset: A,
        openMenu: w,
        closeMenu: y,
        toggleMenu: _,
        selectItem: k,
        selectItemAtIndex: x,
        selectHighlightedItem: S,
        setHighlightedIndex: $,
        clearSelection: E,
        clearItems: C,
        setItemCount: I,
        unsetItemCount: U,
        setState: M,
        // props
        itemToString: c,
        // derived
        id: u,
        // state
        highlightedIndex: r,
        inputValue: i,
        isOpen: l,
        selectedItem: s
      };
    }, o.componentDidMount = function() {
      var a = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && ep(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          a.internalClearTimeouts();
        };
      else {
        var r = function() {
          a.isMouseDown = !0;
        }, i = function(d) {
          a.isMouseDown = !1;
          var m = vi(d.target, [a._rootNode, a._menuNode], a.props.environment);
          !m && a.getState().isOpen && a.reset({
            type: vv
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, s = function() {
          a.isTouchMove = !1;
        }, l = function() {
          a.isTouchMove = !0;
        }, c = function(d) {
          var m = vi(d.target, [a._rootNode, a._menuNode], a.props.environment, !1);
          !a.isTouchMove && !m && a.getState().isOpen && a.reset({
            type: zv
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", r), u.addEventListener("mouseup", i), u.addEventListener("touchstart", s), u.addEventListener("touchmove", l), u.addEventListener("touchend", c), this.cleanup = function() {
          a.internalClearTimeouts(), a.updateStatus.cancel(), u.removeEventListener("mousedown", r), u.removeEventListener("mouseup", i), u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", l), u.removeEventListener("touchend", c);
        };
      }
    }, o.shouldScroll = function(a, r) {
      var i = this.props.highlightedIndex === void 0 ? this.getState() : this.props, s = i.highlightedIndex, l = r.highlightedIndex === void 0 ? a : r, c = l.highlightedIndex, u = s && this.getState().isOpen && !a.isOpen, d = s !== c;
      return u || d;
    }, o.componentDidUpdate = function(a, r) {
      process.env.NODE_ENV !== "production" && (_u(this.state, a, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && ep(this._menuNode, this.getMenuProps)), bi(this.props, "selectedItem") && this.props.selectedItemChanged(a.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Ov,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(r, a) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var a = Qh(this.props.children, vt);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var r = Qh(a(this.getStateAndHelpers()));
      if (!r)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && rz(r, this.getRootProps), r;
      if (pv(r))
        return /* @__PURE__ */ gf(r, this.getRootProps(mv(r)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(Ok);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: HO,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && ZO(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: vt,
    onInputValueChange: vt,
    onUserAction: vt,
    onChange: vt,
    onSelect: vt,
    onOuterClick: vt,
    selectedItemChanged: function(t, n) {
      return t !== n;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, n) {
      return n;
    },
    suppressRefError: !1,
    scrollIntoView: dv
  }, e.stateChangeTypes = XO, e;
}();
process.env.NODE_ENV !== "production" && (az.propTypes = {
  children: H.func,
  defaultHighlightedIndex: H.number,
  defaultIsOpen: H.bool,
  initialHighlightedIndex: H.number,
  initialSelectedItem: H.any,
  initialInputValue: H.string,
  initialIsOpen: H.bool,
  getA11yStatusMessage: H.func,
  itemToString: H.func,
  onChange: H.func,
  onSelect: H.func,
  onStateChange: H.func,
  onInputValueChange: H.func,
  onUserAction: H.func,
  onOuterClick: H.func,
  selectedItemChanged: H.func,
  stateReducer: H.func,
  itemCount: H.number,
  id: H.string,
  environment: H.shape({
    addEventListener: H.func.isRequired,
    removeEventListener: H.func.isRequired,
    document: H.shape({
      createElement: H.func.isRequired,
      getElementById: H.func.isRequired,
      activeElement: H.any.isRequired,
      body: H.any.isRequired
    }).isRequired,
    Node: H.func.isRequired
  }),
  suppressRefError: H.bool,
  scrollIntoView: H.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: H.any,
  isOpen: H.bool,
  inputValue: H.string,
  highlightedIndex: H.number,
  labelId: H.string,
  inputId: H.string,
  menuId: H.string,
  getItemId: H.func
  /* eslint-enable react/no-unused-prop-types */
});
function ep(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function rz(e, t) {
  var n = t.refKey, o = n !== "ref", a = !pv(e);
  a && !o && !Gh.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !a && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Gh.isForwardRef(e) && !mv(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var Nv = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function iz(e, t, n) {
  var o = e.props, a = e.type, r = {};
  Object.keys(t).forEach(function(i) {
    sz(i, e, t, n), n[i] !== t[i] && (r[i] = n[i]);
  }), o.onStateChange && Object.keys(r).length && o.onStateChange(pe({
    type: a
  }, r));
}
function sz(e, t, n, o) {
  var a = t.props, r = t.type, i = "on" + wu(e) + "Change";
  a[i] && o[e] !== void 0 && o[e] !== n[e] && a[i](pe({
    type: r
  }, o));
}
function lz(e, t) {
  return t.changes;
}
var tp = yu(function(e, t) {
  gv(e, t);
}, 200), cz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? bf : Se, uz = "useId" in ae ? function(e) {
  var t = e.id, n = e.labelId, o = e.menuId, a = e.getItemId, r = e.toggleButtonId, i = e.inputId, s = "downshift-" + ae.useId();
  t || (t = s);
  var l = Te({
    labelId: n || t + "-label",
    menuId: o || t + "-menu",
    getItemId: a || function(c) {
      return t + "-item-" + c;
    },
    toggleButtonId: r || t + "-toggle-button",
    inputId: i || t + "-input"
  });
  return l.current;
} : function(e) {
  var t = e.id, n = t === void 0 ? "downshift-" + hv() : t, o = e.labelId, a = e.menuId, r = e.getItemId, i = e.toggleButtonId, s = e.inputId, l = Te({
    labelId: o || n + "-label",
    menuId: a || n + "-menu",
    getItemId: r || function(c) {
      return n + "-item-" + c;
    },
    toggleButtonId: i || n + "-toggle-button",
    inputId: s || n + "-input"
  });
  return l.current;
};
function dz(e, t, n, o) {
  var a, r;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    a = n[t], r = t;
  } else
    r = t === void 0 ? n.indexOf(e) : t, a = e;
  return [a, r];
}
function wu(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function jv(e) {
  var t = Te(e);
  return t.current = e, t;
}
function hz(e, t, n, o) {
  var a = Te(), r = Te(), i = De(function(f, g) {
    r.current = g, f = gi(f, g.props);
    var p = e(f, g), b = g.props.stateReducer(f, pe({}, g, {
      changes: p
    }));
    return b;
  }, [e]), s = Ak(i, t, n), l = s[0], c = s[1], u = jv(t), d = De(function(f) {
    return c(pe({
      props: u.current
    }, f));
  }, [u]), m = r.current;
  return Se(function() {
    var f = gi(a.current, m?.props), g = m && a.current && !o(f, l);
    g && iz(m, f, l), a.current = l;
  }, [l, m, o]), [l, d];
}
var va = {
  itemToString: function(e) {
    return e ? String(e) : "";
  },
  itemToKey: function(e) {
    return e;
  },
  stateReducer: lz,
  scrollIntoView: dv,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Cn(e, t, n) {
  n === void 0 && (n = Nv);
  var o = e["default" + wu(t)];
  return o !== void 0 ? o : n[t];
}
function ya(e, t, n) {
  n === void 0 && (n = Nv);
  var o = e[t];
  if (o !== void 0)
    return o;
  var a = e["initial" + wu(t)];
  return a !== void 0 ? a : Cn(e, t, n);
}
function pz(e) {
  var t = ya(e, "selectedItem"), n = ya(e, "isOpen"), o = vz(e), a = ya(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && n ? e.items.findIndex(function(r) {
      return e.itemToKey(r) === e.itemToKey(t);
    }) : o,
    isOpen: n,
    selectedItem: t,
    inputValue: a
  };
}
function _a(e, t, n) {
  var o = e.items, a = e.initialHighlightedIndex, r = e.defaultHighlightedIndex, i = e.isItemDisabled, s = e.itemToKey, l = t.selectedItem, c = t.highlightedIndex;
  return o.length === 0 ? -1 : a !== void 0 && c === a && !i(o[a], a) ? a : r !== void 0 && !i(o[r], r) ? r : l ? o.findIndex(function(u) {
    return s(l) === s(u);
  }) : n < 0 && !i(o[o.length - 1], o.length - 1) ? o.length - 1 : n > 0 && !i(o[0], 0) ? 0 : -1;
}
function mz(e, t, n) {
  var o = Te({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return Se(function() {
    if (!e)
      return vt;
    var a = n.map(function(u) {
      return u.current;
    });
    function r() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function i(u) {
      o.current.isMouseDown = !1, vi(u.target, a, e) || t();
    }
    function s() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function l() {
      o.current.isTouchMove = !0;
    }
    function c(u) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !vi(u.target, a, e, !1) && t();
    }
    return e.addEventListener("mousedown", r), e.addEventListener("mouseup", i), e.addEventListener("touchstart", s), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function() {
      e.removeEventListener("mousedown", r), e.removeEventListener("mouseup", i), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [n, e, t]), o.current;
}
var Rv = function() {
  return vt;
};
process.env.NODE_ENV !== "production" && (Rv = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var o = Te(t.reduce(function(r, i) {
    return r[i] = {}, r;
  }, {}));
  Se(function() {
    Object.keys(o.current).forEach(function(r) {
      var i = o.current[r];
      if (!Object.keys(i).length) {
        console.error("downshift: You forgot to call the " + r + " getter function on your component / element.");
        return;
      }
      var s = i.suppressRefError, l = i.refKey, c = i.elementRef;
      s || c != null && c.current || console.error('downshift: The ref prop "' + l + '" from ' + r + " was not applied correctly on your element.");
    });
  }, []);
  var a = De(function(r, i, s, l) {
    o.current[r] = {
      suppressRefError: i,
      refKey: s,
      elementRef: l
    };
  }, []);
  return a;
});
function fz(e, t, n, o) {
  o === void 0 && (o = {});
  var a = o.document, r = is();
  Se(function() {
    if (!(!e || r || !a)) {
      var i = e(t);
      tp(i, a);
    }
  }, n), Se(function() {
    return function() {
      tp.cancel(), YO(a);
    };
  }, [a]);
}
function gz(e) {
  var t = e.highlightedIndex, n = e.isOpen, o = e.itemRefs, a = e.getItemNodeFromIndex, r = e.menuElement, i = e.scrollIntoView, s = Te(!0);
  return cz(function() {
    t < 0 || !n || !Object.keys(o.current).length || (s.current === !1 ? s.current = !0 : i(a(t), r));
  }, [t]), s;
}
var Iv = vt;
process.env.NODE_ENV !== "production" && (Iv = function(e) {
  var t = e.props, n = e.state, o = Te(t), a = is();
  Se(function() {
    a || (_u(n, o.current, t), o.current = t);
  }, [n, t, a]);
});
function np(e, t, n) {
  var o;
  n === void 0 && (n = !0);
  var a = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return pe({
    isOpen: !1,
    highlightedIndex: -1
  }, a && pe({
    selectedItem: e.items[t],
    isOpen: Cn(e, "isOpen"),
    highlightedIndex: Cn(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function bz(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function is() {
  var e = ae.useRef(!0);
  return ae.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function ac(e) {
  var t = Cn(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function vz(e) {
  var t = ya(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var Kr = {
  environment: H.shape({
    addEventListener: H.func.isRequired,
    removeEventListener: H.func.isRequired,
    document: H.shape({
      createElement: H.func.isRequired,
      getElementById: H.func.isRequired,
      activeElement: H.any.isRequired,
      body: H.any.isRequired
    }).isRequired,
    Node: H.func.isRequired
  }),
  itemToString: H.func,
  itemToKey: H.func,
  stateReducer: H.func
}, Tv = pe({}, Kr, {
  getA11yStatusMessage: H.func,
  highlightedIndex: H.number,
  defaultHighlightedIndex: H.number,
  initialHighlightedIndex: H.number,
  isOpen: H.bool,
  defaultIsOpen: H.bool,
  initialIsOpen: H.bool,
  selectedItem: H.any,
  initialSelectedItem: H.any,
  defaultSelectedItem: H.any,
  id: H.string,
  labelId: H.string,
  menuId: H.string,
  getItemId: H.func,
  toggleButtonId: H.string,
  onSelectedItemChange: H.func,
  onHighlightedIndexChange: H.func,
  onStateChange: H.func,
  onIsOpenChange: H.func,
  scrollIntoView: H.func
});
function yz(e, t, n) {
  var o = t.type, a = t.props, r;
  switch (o) {
    case n.ItemMouseMove:
      r = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      r = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      r = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : _a(a, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      r = {
        isOpen: !0,
        highlightedIndex: _a(a, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      r = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      r = {
        highlightedIndex: a.isItemDisabled(a.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      r = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      r = {
        highlightedIndex: ac(a),
        isOpen: Cn(a, "isOpen"),
        selectedItem: Cn(a, "selectedItem"),
        inputValue: Cn(a, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return pe({}, e, r);
}
st(st({}, Tv), { items: H.array.isRequired, isItemDisabled: H.func });
st(st({}, va), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var ku = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, xu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, $u = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Su = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Cu = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Eu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Au = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Ou = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, zu = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, yi = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Nu = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Pv = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Dv = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, ju = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Lv = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Mv = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Fv = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Wv = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Bv = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Ru = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Vv = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Uv = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, Iu = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, qv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: Iu,
  FunctionCloseMenu: Wv,
  FunctionOpenMenu: Fv,
  FunctionReset: Uv,
  FunctionSelectItem: Ru,
  FunctionSetHighlightedIndex: Bv,
  FunctionSetInputValue: Vv,
  FunctionToggleMenu: Mv,
  InputBlur: yi,
  InputChange: zu,
  InputClick: Nu,
  InputKeyDownArrowDown: ku,
  InputKeyDownArrowUp: xu,
  InputKeyDownEnd: Cu,
  InputKeyDownEnter: Ou,
  InputKeyDownEscape: $u,
  InputKeyDownHome: Su,
  InputKeyDownPageDown: Au,
  InputKeyDownPageUp: Eu,
  ItemClick: ju,
  ItemMouseMove: Dv,
  MenuMouseLeave: Pv,
  ToggleButtonClick: Lv
});
function _z(e) {
  var t = pz(e), n = t.selectedItem, o = t.inputValue;
  return o === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(n)), pe({}, t, {
    inputValue: o
  });
}
var wz = pe({}, Tv, {
  items: H.array.isRequired,
  isItemDisabled: H.func,
  inputValue: H.string,
  defaultInputValue: H.string,
  initialInputValue: H.string,
  inputId: H.string,
  onInputValueChange: H.func
});
function kz(e, t, n, o) {
  var a = Te(), r = hz(e, t, n, o), i = r[0], s = r[1], l = is();
  return Se(function() {
    if (bi(t, "selectedItem")) {
      if (!l) {
        var c = t.itemToKey(t.selectedItem) !== t.itemToKey(a.current);
        c && s({
          type: Iu,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      a.current = i.selectedItem === a.current ? t.selectedItem : i.selectedItem;
    }
  }, [i.selectedItem, t.selectedItem]), [gi(i, t), s];
}
var Hv = vt;
process.env.NODE_ENV !== "production" && (Hv = function(e, t) {
  H.checkPropTypes(wz, e, "prop", t.name);
});
var xz = pe({}, va, {
  isItemDisabled: function() {
    return !1;
  }
});
function $z(e, t) {
  var n, o = t.type, a = t.props, r = t.altKey, i;
  switch (o) {
    case ju:
      i = {
        isOpen: Cn(a, "isOpen"),
        highlightedIndex: ac(a),
        selectedItem: a.items[t.index],
        inputValue: a.itemToString(a.items[t.index])
      };
      break;
    case ku:
      e.isOpen ? i = {
        highlightedIndex: Wn(e.highlightedIndex, 1, a.items, a.isItemDisabled, !0)
      } : i = {
        highlightedIndex: r && e.selectedItem == null ? -1 : _a(a, e, 1),
        isOpen: a.items.length >= 0
      };
      break;
    case xu:
      e.isOpen ? r ? i = np(a, e.highlightedIndex) : i = {
        highlightedIndex: Wn(e.highlightedIndex, -1, a.items, a.isItemDisabled, !0)
      } : i = {
        highlightedIndex: _a(a, e, -1),
        isOpen: a.items.length >= 0
      };
      break;
    case Ou:
      i = np(a, e.highlightedIndex);
      break;
    case $u:
      i = pe({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Eu:
      i = {
        highlightedIndex: Wn(e.highlightedIndex, -10, a.items, a.isItemDisabled, !0)
      };
      break;
    case Au:
      i = {
        highlightedIndex: Wn(e.highlightedIndex, 10, a.items, a.isItemDisabled, !0)
      };
      break;
    case Su:
      i = {
        highlightedIndex: Bo(0, !1, a.items, a.isItemDisabled)
      };
      break;
    case Cu:
      i = {
        highlightedIndex: Bo(a.items.length - 1, !0, a.items, a.isItemDisabled)
      };
      break;
    case yi:
      i = pe({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = a.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: a.items[e.highlightedIndex],
        inputValue: a.itemToString(a.items[e.highlightedIndex])
      });
      break;
    case zu:
      i = {
        isOpen: !0,
        highlightedIndex: ac(a),
        inputValue: t.inputValue
      };
      break;
    case Nu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : _a(a, e, 0)
      };
      break;
    case Ru:
      i = {
        selectedItem: t.selectedItem,
        inputValue: a.itemToString(t.selectedItem)
      };
      break;
    case Iu:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return yz(e, t, qv);
  }
  return pe({}, e, i);
}
var Sz = ["onMouseLeave", "refKey", "ref"], Cz = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], Ez = ["onClick", "onPress", "refKey", "ref"], Az = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Tu.stateChangeTypes = qv;
function Tu(e) {
  e === void 0 && (e = {}), Hv(e, Tu);
  var t = pe({}, xz, e), n = t.items, o = t.scrollIntoView, a = t.environment, r = t.getA11yStatusMessage, i = kz($z, t, _z, bz), s = i[0], l = i[1], c = s.isOpen, u = s.highlightedIndex, d = s.selectedItem, m = s.inputValue, f = Te(null), g = Te({}), p = Te(null), b = Te(null), w = is(), y = uz(t), _ = Te(), k = jv({
    state: s,
    props: t
  }), x = De(function(T) {
    return g.current[y.getItemId(T)];
  }, [y]);
  fz(r, s, [c, u, d, m], a);
  var S = gz({
    menuElement: f.current,
    highlightedIndex: u,
    isOpen: c,
    itemRefs: g,
    scrollIntoView: o,
    getItemNodeFromIndex: x
  });
  Iv({
    props: t,
    state: s
  }), Se(function() {
    var T = ya(t, "isOpen");
    T && p.current && p.current.focus();
  }, []), Se(function() {
    w || (_.current = n.length);
  });
  var $ = mz(a, De(function() {
    k.current.state.isOpen && l({
      type: yi,
      selectItem: !1
    });
  }, [l, k]), Do(function() {
    return [f, b, p];
  }, [f.current, b.current, p.current])), E = Rv("getInputProps", "getMenuProps");
  Se(function() {
    c || (g.current = {});
  }, [c]), Se(function() {
    var T;
    !c || !(a != null && a.document) || !(p != null && (T = p.current) != null && T.focus) || a.document.activeElement !== p.current && p.current.focus();
  }, [c, a]);
  var C = Do(function() {
    return {
      ArrowDown: function(T) {
        T.preventDefault(), l({
          type: ku,
          altKey: T.altKey
        });
      },
      ArrowUp: function(T) {
        T.preventDefault(), l({
          type: xu,
          altKey: T.altKey
        });
      },
      Home: function(T) {
        k.current.state.isOpen && (T.preventDefault(), l({
          type: Su
        }));
      },
      End: function(T) {
        k.current.state.isOpen && (T.preventDefault(), l({
          type: Cu
        }));
      },
      Escape: function(T) {
        var W = k.current.state;
        (W.isOpen || W.inputValue || W.selectedItem || W.highlightedIndex > -1) && (T.preventDefault(), l({
          type: $u
        }));
      },
      Enter: function(T) {
        var W = k.current.state;
        !W.isOpen || T.which === 229 || (T.preventDefault(), l({
          type: Ou
        }));
      },
      PageUp: function(T) {
        k.current.state.isOpen && (T.preventDefault(), l({
          type: Eu
        }));
      },
      PageDown: function(T) {
        k.current.state.isOpen && (T.preventDefault(), l({
          type: Au
        }));
      }
    };
  }, [l, k]), A = De(function(T) {
    return pe({
      id: y.labelId,
      htmlFor: y.inputId
    }, T);
  }, [y]), I = De(function(T, W) {
    var B, J = T === void 0 ? {} : T, ee = J.onMouseLeave, D = J.refKey, Y = D === void 0 ? "ref" : D, Q = J.ref, G = cn(J, Sz), ne = W === void 0 ? {} : W, V = ne.suppressRefError, fe = V === void 0 ? !1 : V;
    return E("getMenuProps", fe, Y, f), pe((B = {}, B[Y] = zo(Q, function(X) {
      f.current = X;
    }), B.id = y.menuId, B.role = "listbox", B["aria-labelledby"] = G && G["aria-label"] ? void 0 : "" + y.labelId, B.onMouseLeave = Ge(ee, function() {
      l({
        type: Pv
      });
    }), B), G);
  }, [l, E, y]), U = De(function(T) {
    var W, B, J = T === void 0 ? {} : T, ee = J.item, D = J.index, Y = J.refKey, Q = Y === void 0 ? "ref" : Y, G = J.ref, ne = J.onMouseMove, V = J.onMouseDown, fe = J.onClick;
    J.onPress;
    var X = J.disabled, Ye = cn(J, Cz);
    X !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Ve = k.current, Ft = Ve.props, mt = Ve.state, In = dz(ee, D, Ft.items, "Pass either item or index to getItemProps!"), Tn = In[0], kt = In[1], on = Ft.isItemDisabled(Tn, kt), bn = "onClick", Pn = fe, _e = function() {
      $.isTouchEnd || kt === mt.highlightedIndex || (S.current = !1, l({
        type: Dv,
        index: kt,
        disabled: on
      }));
    }, ft = function() {
      l({
        type: ju,
        index: kt
      });
    }, oe = function(Dn) {
      return Dn.preventDefault();
    };
    return pe((W = {}, W[Q] = zo(G, function(Dn) {
      Dn && (g.current[y.getItemId(kt)] = Dn);
    }), W["aria-disabled"] = on, W["aria-selected"] = kt === mt.highlightedIndex, W.id = y.getItemId(kt), W.role = "option", W), !on && (B = {}, B[bn] = Ge(Pn, ft), B), {
      onMouseMove: Ge(ne, _e),
      onMouseDown: Ge(V, oe)
    }, Ye);
  }, [l, y, k, $, S]), M = De(function(T) {
    var W, B = T === void 0 ? {} : T, J = B.onClick;
    B.onPress;
    var ee = B.refKey, D = ee === void 0 ? "ref" : ee, Y = B.ref, Q = cn(B, Ez), G = k.current.state, ne = function() {
      l({
        type: Lv
      });
    };
    return pe((W = {}, W[D] = zo(Y, function(V) {
      b.current = V;
    }), W["aria-controls"] = y.menuId, W["aria-expanded"] = G.isOpen, W.id = y.toggleButtonId, W.tabIndex = -1, W), !Q.disabled && pe({}, {
      onClick: Ge(J, ne)
    }), Q);
  }, [l, k, y]), z = De(function(T, W) {
    var B, J = T === void 0 ? {} : T, ee = J.onKeyDown, D = J.onChange, Y = J.onInput, Q = J.onBlur;
    J.onChangeText;
    var G = J.onClick, ne = J.refKey, V = ne === void 0 ? "ref" : ne, fe = J.ref, X = cn(J, Az), Ye = W === void 0 ? {} : W, Ve = Ye.suppressRefError, Ft = Ve === void 0 ? !1 : Ve;
    E("getInputProps", Ft, V, p);
    var mt = k.current.state, In = function(ft) {
      var oe = nc(ft);
      oe && C[oe] && C[oe](ft);
    }, Tn = function(ft) {
      l({
        type: zu,
        inputValue: ft.target.value
      });
    }, kt = function(ft) {
      if (a != null && a.document && mt.isOpen && !$.isMouseDown) {
        var oe = ft.relatedTarget === null && a.document.activeElement !== a.document.body;
        l({
          type: yi,
          selectItem: !oe
        });
      }
    }, on = function() {
      l({
        type: Nu
      });
    }, bn = "onChange", Pn = {};
    if (!X.disabled) {
      var _e;
      Pn = (_e = {}, _e[bn] = Ge(D, Y, Tn), _e.onKeyDown = Ge(ee, In), _e.onBlur = Ge(Q, kt), _e.onClick = Ge(G, on), _e);
    }
    return pe((B = {}, B[V] = zo(fe, function(ft) {
      p.current = ft;
    }), B["aria-activedescendant"] = mt.isOpen && mt.highlightedIndex > -1 ? y.getItemId(mt.highlightedIndex) : "", B["aria-autocomplete"] = "list", B["aria-controls"] = y.menuId, B["aria-expanded"] = mt.isOpen, B["aria-labelledby"] = X && X["aria-label"] ? void 0 : y.labelId, B.autoComplete = "off", B.id = y.inputId, B.role = "combobox", B.value = mt.inputValue, B), Pn, X);
  }, [l, y, a, C, k, $, E]), L = De(function() {
    l({
      type: Mv
    });
  }, [l]), q = De(function() {
    l({
      type: Wv
    });
  }, [l]), K = De(function() {
    l({
      type: Fv
    });
  }, [l]), Z = De(function(T) {
    l({
      type: Bv,
      highlightedIndex: T
    });
  }, [l]), te = De(function(T) {
    l({
      type: Ru,
      selectedItem: T
    });
  }, [l]), O = De(function(T) {
    l({
      type: Vv,
      inputValue: T
    });
  }, [l]), N = De(function() {
    l({
      type: Uv
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: U,
    getLabelProps: A,
    getMenuProps: I,
    getInputProps: z,
    getToggleButtonProps: M,
    // actions.
    toggleMenu: L,
    openMenu: K,
    closeMenu: q,
    setHighlightedIndex: Z,
    setInputValue: O,
    selectItem: te,
    reset: N,
    // state.
    highlightedIndex: u,
    isOpen: c,
    selectedItem: d,
    inputValue: m
  };
}
Kr.stateReducer, Kr.itemToKey, Kr.environment, H.array, H.array, H.array, H.func, H.number, H.number, H.number, H.func, H.func, H.string, H.string;
va.itemToKey, va.stateReducer, va.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const Oz = "_autocomplete_olk74_29", zz = "_suggestion_olk74_87", Nz = "_highlight_olk74_107", vn = {
  autocomplete: Oz,
  "autocomplete-container": "_autocomplete-container_olk74_38",
  "input-button-container": "_input-button-container_olk74_43",
  "autocomplete-input": "_autocomplete-input_olk74_49",
  "autocomplete-button": "_autocomplete-button_olk74_63",
  "suggestions-container": "_suggestions-container_olk74_87",
  suggestion: zz,
  highlight: Nz
};
function jz({
  id: e,
  placeholder: t,
  value: n,
  onChange: o,
  suggestions: a = [],
  buttonText: r,
  onSubmit: i,
  hideButtonText: s,
  className: l,
  ...c
}) {
  const { isOpen: u, getLabelProps: d, getMenuProps: m, getInputProps: f, highlightedIndex: g, getItemProps: p, selectedItem: b } = Tu({
    id: e,
    onInputValueChange({ inputValue: _ }) {
      o && o(_ ?? "");
    },
    items: a,
    itemToString(_) {
      return _?.value ?? "";
    }
  }), w = Jn(vn.autocomplete, l);
  function y(_) {
    _.preventDefault(), i && i(_, b ?? void 0);
  }
  return /* @__PURE__ */ P("div", { className: w, ...c, children: [
    /* @__PURE__ */ v("form", { className: vn["autocomplete-container"], onSubmit: y, children: /* @__PURE__ */ P("div", { className: vn["input-button-container"], children: [
      /* @__PURE__ */ v("label", { ...d(), hidden: !0, children: t }),
      /* @__PURE__ */ v(
        "input",
        {
          className: vn["autocomplete-input"],
          type: "text",
          placeholder: t,
          value: n,
          ...f()
        }
      ),
      /* @__PURE__ */ P("button", { "aria-label": r, className: vn["autocomplete-button"], children: [
        /* @__PURE__ */ v(Ca, { name: "search" }),
        !s && r
      ] })
    ] }) }),
    /* @__PURE__ */ v("ul", { className: vn["suggestions-container"], ...m(), "data-test": u, "aria-busy": !u, children: u && a.map((_, k) => /* @__PURE__ */ v(
      "li",
      {
        className: `${vn.suggestion} ${g === k ? vn.highlight : ""}`,
        ...p({ item: _, index: k }),
        children: _.value
      },
      _.id
    )) })
  ] });
}
function Rz(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var ss = "Switch", [Iz, Lye] = ho(ss), [Tz, Pz] = Iz(ss), Dz = h.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: a,
      defaultChecked: r,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = e, [m, f] = h.useState(null), g = He(t, (_) => f(_)), p = h.useRef(!1), b = m ? u || !!m.closest("form") : !0, [w, y] = ns({
      prop: a,
      defaultProp: r ?? !1,
      onChange: c,
      caller: ss
    });
    return /* @__PURE__ */ P(Tz, { scope: n, checked: w, disabled: s, children: [
      /* @__PURE__ */ v(
        Oe.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": Zv(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: g,
          onClick: ge(e.onClick, (_) => {
            y((k) => !k), b && (p.current = _.isPropagationStopped(), p.current || _.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        Gv,
        {
          control: m,
          bubbles: !p.current,
          name: o,
          value: l,
          checked: w,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Dz.displayName = ss;
var Kv = "SwitchThumb", Lz = h.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, a = Pz(Kv, n);
    return /* @__PURE__ */ v(
      Oe.span,
      {
        "data-state": Zv(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Lz.displayName = Kv;
var Mz = "SwitchBubbleInput", Gv = h.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...a
  }, r) => {
    const i = h.useRef(null), s = He(i, r), l = LE(n), c = DE(t);
    return h.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== n && m) {
        const f = new Event("click", { bubbles: o });
        m.call(u, n), u.dispatchEvent(f);
      }
    }, [l, n, o]), /* @__PURE__ */ v(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...a,
        tabIndex: -1,
        ref: s,
        style: {
          ...a.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Gv.displayName = Mz;
function Zv(e) {
  return e ? "checked" : "unchecked";
}
function Fz(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var Pu = "ScrollArea", [Jv, Mye] = ho(Pu), [Wz, Ot] = Jv(Pu), Bz = h.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: a,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = h.useState(null), [c, u] = h.useState(null), [d, m] = h.useState(null), [f, g] = h.useState(null), [p, b] = h.useState(null), [w, y] = h.useState(0), [_, k] = h.useState(0), [x, S] = h.useState(!1), [$, E] = h.useState(!1), C = He(t, (I) => l(I)), A = du(a);
    return /* @__PURE__ */ v(
      Wz,
      {
        scope: n,
        type: o,
        dir: A,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: m,
        scrollbarX: f,
        onScrollbarXChange: g,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: y,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          Oe.div,
          {
            dir: A,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Bz.displayName = Pu;
var Yv = "ScrollAreaViewport", Vz = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: a, ...r } = e, i = Ot(Yv, n), s = h.useRef(null), l = He(t, s, i.onViewportChange);
    return /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ v(
        Oe.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
Vz.displayName = Yv;
var Xt = "ScrollAreaScrollbar", Uz = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = Ot(Xt, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = a, s = e.orientation === "horizontal";
    return h.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), a.type === "hover" ? /* @__PURE__ */ v(qz, { ...o, ref: t, forceMount: n }) : a.type === "scroll" ? /* @__PURE__ */ v(Hz, { ...o, ref: t, forceMount: n }) : a.type === "auto" ? /* @__PURE__ */ v(Xv, { ...o, ref: t, forceMount: n }) : a.type === "always" ? /* @__PURE__ */ v(Du, { ...o, ref: t }) : null;
  }
);
Uz.displayName = Xt;
var qz = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = Ot(Xt, e.__scopeScrollArea), [r, i] = h.useState(!1);
  return h.useEffect(() => {
    const s = a.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), a.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ v(mn, { present: n || r, children: /* @__PURE__ */ v(
    Xv,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Hz = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = Ot(Xt, e.__scopeScrollArea), r = e.orientation === "horizontal", i = cs(() => l("SCROLL_END"), 100), [s, l] = Fz("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return h.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, a.scrollHideDelay, l]), h.useEffect(() => {
    const c = a.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const m = () => {
        const f = c[u];
        d !== f && (l("SCROLL"), i()), d = f;
      };
      return c.addEventListener("scroll", m), () => c.removeEventListener("scroll", m);
    }
  }, [a.viewport, r, l, i]), /* @__PURE__ */ v(mn, { present: n || s !== "hidden", children: /* @__PURE__ */ v(
    Du,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: ge(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ge(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Xv = h.forwardRef((e, t) => {
  const n = Ot(Xt, e.__scopeScrollArea), { forceMount: o, ...a } = e, [r, i] = h.useState(!1), s = e.orientation === "horizontal", l = cs(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Vo(n.viewport, l), Vo(n.content, l), /* @__PURE__ */ v(mn, { present: o || r, children: /* @__PURE__ */ v(
    Du,
    {
      "data-state": r ? "visible" : "hidden",
      ...a,
      ref: t
    }
  ) });
}), Du = h.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, a = Ot(Xt, e.__scopeScrollArea), r = h.useRef(null), i = h.useRef(0), [s, l] = h.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = ty(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (m) => r.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function d(m, f) {
    return eN(m, i.current, s, f);
  }
  return n === "horizontal" ? /* @__PURE__ */ v(
    Kz,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollLeft, f = op(m, s, a.dir);
          r.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = d(m, a.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ v(
    Gz,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollTop, f = op(m, s);
          r.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = d(m));
      }
    }
  ) : null;
}), Kz = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = Ot(Xt, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = He(t, l, r.onScrollbarXChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    ey,
    {
      "data-orientation": "horizontal",
      ...a,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ls(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(m), oy(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: wi(i.paddingLeft),
            paddingEnd: wi(i.paddingRight)
          }
        });
      }
    }
  );
}), Gz = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = Ot(Xt, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = He(t, l, r.onScrollbarYChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    ey,
    {
      "data-orientation": "vertical",
      ...a,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ls(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(m), oy(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: wi(i.paddingTop),
            paddingEnd: wi(i.paddingBottom)
          }
        });
      }
    }
  );
}), [Zz, Qv] = Jv(Xt), ey = h.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: a,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...m
  } = e, f = Ot(Xt, n), [g, p] = h.useState(null), b = He(t, (C) => p(C)), w = h.useRef(null), y = h.useRef(""), _ = f.viewport, k = o.content - o.viewport, x = Qe(u), S = Qe(l), $ = cs(d, 10);
  function E(C) {
    if (w.current) {
      const A = C.clientX - w.current.left, I = C.clientY - w.current.top;
      c({ x: A, y: I });
    }
  }
  return h.useEffect(() => {
    const C = (A) => {
      const I = A.target;
      g?.contains(I) && x(A, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [_, g, k, x]), h.useEffect(S, [o, S]), Vo(g, $), Vo(f.content, $), /* @__PURE__ */ v(
    Zz,
    {
      scope: n,
      scrollbar: g,
      hasThumb: a,
      onThumbChange: Qe(r),
      onThumbPointerUp: Qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: Qe(s),
      children: /* @__PURE__ */ v(
        Oe.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: ge(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = g.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: ge(e.onPointerMove, E),
          onPointerUp: ge(e.onPointerUp, (C) => {
            const A = C.target;
            A.hasPointerCapture(C.pointerId) && A.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = y.current, f.viewport && (f.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), _i = "ScrollAreaThumb", Jz = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = Qv(_i, e.__scopeScrollArea);
    return /* @__PURE__ */ v(mn, { present: n || a.hasThumb, children: /* @__PURE__ */ v(Yz, { ref: t, ...o }) });
  }
), Yz = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...a } = e, r = Ot(_i, n), i = Qv(_i, n), { onThumbPositionChange: s } = i, l = He(
      t,
      (d) => i.onThumbChange(d)
    ), c = h.useRef(void 0), u = cs(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return h.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const m = () => {
          if (u(), !c.current) {
            const f = tN(d, s);
            c.current = f, s();
          }
        };
        return s(), d.addEventListener("scroll", m), () => d.removeEventListener("scroll", m);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      Oe.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...a,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: ge(e.onPointerDownCapture, (d) => {
          const m = d.target.getBoundingClientRect(), f = d.clientX - m.left, g = d.clientY - m.top;
          i.onThumbPointerDown({ x: f, y: g });
        }),
        onPointerUp: ge(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
Jz.displayName = _i;
var Lu = "ScrollAreaCorner", Xz = h.forwardRef(
  (e, t) => {
    const n = Ot(Lu, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ v(Qz, { ...e, ref: t }) : null;
  }
);
Xz.displayName = Lu;
var Qz = h.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, a = Ot(Lu, n), [r, i] = h.useState(0), [s, l] = h.useState(0), c = !!(r && s);
  return Vo(a.scrollbarX, () => {
    const u = a.scrollbarX?.offsetHeight || 0;
    a.onCornerHeightChange(u), l(u);
  }), Vo(a.scrollbarY, () => {
    const u = a.scrollbarY?.offsetWidth || 0;
    a.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    Oe.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function wi(e) {
  return e ? parseInt(e, 10) : 0;
}
function ty(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function ls(e) {
  const t = ty(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function eN(e, t, n, o = "ltr") {
  const a = ls(n), r = a / 2, i = t || r, s = a - i, l = n.scrollbar.paddingStart + i, c = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return ny([l, c], d)(e);
}
function op(e, t, n = "ltr") {
  const o = ls(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - a, i = t.content - t.viewport, s = r - o, l = n === "ltr" ? [0, i] : [i * -1, 0], c = Rz(e, l);
  return ny([0, i], [0, s])(c);
}
function ny(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function oy(e, t) {
  return e > 0 && e < t;
}
var tN = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function a() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== r.left, s = n.top !== r.top;
    (i || s) && t(), n = r, o = window.requestAnimationFrame(a);
  }(), () => window.cancelAnimationFrame(o);
};
function cs(e, t) {
  const n = Qe(e), o = h.useRef(0);
  return h.useEffect(() => () => window.clearTimeout(o.current), []), h.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Vo(e, t) {
  const n = Qe(t);
  En(() => {
    let o = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(o), a.unobserve(e);
      };
    }
  }, [e, n]);
}
var nN = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), oN = "VisuallyHidden", Mu = h.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    Oe.span,
    {
      ...e,
      ref: t,
      style: { ...nN, ...e.style }
    }
  )
);
Mu.displayName = oN;
var us = "Tabs", [aN, Fye] = ho(us, [
  Ob
]), ay = Ob(), [rN, Fu] = aN(us), iN = h.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: a,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = du(s), [d, m] = ns({
      prop: o,
      onChange: a,
      defaultProp: r ?? "",
      caller: us
    });
    return /* @__PURE__ */ v(
      rN,
      {
        scope: n,
        baseId: Eb(),
        value: d,
        onValueChange: m,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          Oe.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
iN.displayName = us;
var ry = "TabsList", sN = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...a } = e, r = Fu(ry, n), i = ay(n);
    return /* @__PURE__ */ v(
      TE,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          Oe.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
sN.displayName = ry;
var iy = "TabsTrigger", lN = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: a = !1, ...r } = e, i = Fu(iy, n), s = ay(n), l = ly(i.baseId, o), c = cy(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      PE,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ v(
          Oe.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: l,
            ...r,
            ref: t,
            onMouseDown: ge(e.onMouseDown, (d) => {
              !a && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: ge(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: ge(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !a && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
lN.displayName = iy;
var sy = "TabsContent", cN = h.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: a, children: r, ...i } = e, s = Fu(sy, n), l = ly(s.baseId, o), c = cy(s.baseId, o), u = o === s.value, d = h.useRef(u);
    return h.useEffect(() => {
      const m = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ v(mn, { present: a || u, children: ({ present: m }) => /* @__PURE__ */ v(
      Oe.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !m,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: m && r
      }
    ) });
  }
);
cN.displayName = sy;
function ly(e, t) {
  return `${e}-trigger-${t}`;
}
function cy(e, t) {
  return `${e}-content-${t}`;
}
var uN = "ToastProvider", [uy, dN, hN] = Cb("Toast"), [dy, Wye] = ho("Toast", [hN]), [Bye, ds] = dy(uN), hy = "ToastViewport", pN = ["F8"], rc = "toast.viewportPause", ic = "toast.viewportResume", mN = h.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: o = pN,
      label: a = "Notifications ({hotkey})",
      ...r
    } = e, i = ds(hy, n), s = dN(n), l = h.useRef(null), c = h.useRef(null), u = h.useRef(null), d = h.useRef(null), m = He(t, d, i.onViewportChange), f = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    h.useEffect(() => {
      const b = (w) => {
        o.length !== 0 && o.every((y) => w[y] || w.code === y) && d.current?.focus();
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [o]), h.useEffect(() => {
      const b = l.current, w = d.current;
      if (g && b && w) {
        const y = () => {
          if (!i.isClosePausedRef.current) {
            const S = new CustomEvent(rc);
            w.dispatchEvent(S), i.isClosePausedRef.current = !0;
          }
        }, _ = () => {
          if (i.isClosePausedRef.current) {
            const S = new CustomEvent(ic);
            w.dispatchEvent(S), i.isClosePausedRef.current = !1;
          }
        }, k = (S) => {
          !b.contains(S.relatedTarget) && _();
        }, x = () => {
          b.contains(document.activeElement) || _();
        };
        return b.addEventListener("focusin", y), b.addEventListener("focusout", k), b.addEventListener("pointermove", y), b.addEventListener("pointerleave", x), window.addEventListener("blur", y), window.addEventListener("focus", _), () => {
          b.removeEventListener("focusin", y), b.removeEventListener("focusout", k), b.removeEventListener("pointermove", y), b.removeEventListener("pointerleave", x), window.removeEventListener("blur", y), window.removeEventListener("focus", _);
        };
      }
    }, [g, i.isClosePausedRef]);
    const p = h.useCallback(
      ({ tabbingDirection: b }) => {
        const w = s().map((y) => {
          const _ = y.ref.current, k = [_, ...NN(_)];
          return b === "forwards" ? k : k.reverse();
        });
        return (b === "forwards" ? w.reverse() : w).flat();
      },
      [s]
    );
    return h.useEffect(() => {
      const b = d.current;
      if (b) {
        const w = (y) => {
          const _ = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !_) {
            const k = document.activeElement, x = y.shiftKey;
            if (y.target === b && x) {
              c.current?.focus();
              return;
            }
            const S = p({ tabbingDirection: x ? "backwards" : "forwards" }), $ = S.findIndex((E) => E === k);
            ul(S.slice($ + 1)) ? y.preventDefault() : x ? c.current?.focus() : u.current?.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [s, p]), /* @__PURE__ */ P(
      _A,
      {
        ref: l,
        role: "region",
        "aria-label": a.replace("{hotkey}", f),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ v(
            sc,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const b = p({
                  tabbingDirection: "forwards"
                });
                ul(b);
              }
            }
          ),
          /* @__PURE__ */ v(uy.Slot, { scope: n, children: /* @__PURE__ */ v(Oe.ol, { tabIndex: -1, ...r, ref: m }) }),
          g && /* @__PURE__ */ v(
            sc,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = p({
                  tabbingDirection: "backwards"
                });
                ul(b);
              }
            }
          )
        ]
      }
    );
  }
);
mN.displayName = hy;
var py = "ToastFocusProxy", sc = h.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: o, ...a } = e, r = ds(py, n);
    return /* @__PURE__ */ v(
      Mu,
      {
        tabIndex: 0,
        ...a,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          const s = i.relatedTarget;
          !r.viewport?.contains(s) && o();
        }
      }
    );
  }
);
sc.displayName = py;
var Ua = "Toast", fN = "toast.swipeStart", gN = "toast.swipeMove", bN = "toast.swipeCancel", vN = "toast.swipeEnd", yN = h.forwardRef(
  (e, t) => {
    const { forceMount: n, open: o, defaultOpen: a, onOpenChange: r, ...i } = e, [s, l] = ns({
      prop: o,
      defaultProp: a ?? !0,
      onChange: r,
      caller: Ua
    });
    return /* @__PURE__ */ v(mn, { present: n || s, children: /* @__PURE__ */ v(
      kN,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: Qe(e.onPause),
        onResume: Qe(e.onResume),
        onSwipeStart: ge(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ge(e.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: ge(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ge(e.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
yN.displayName = Ua;
var [_N, wN] = dy(Ua, {
  onClose() {
  }
}), kN = h.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: o = "foreground",
      duration: a,
      open: r,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: m,
      onSwipeEnd: f,
      ...g
    } = e, p = ds(Ua, n), [b, w] = h.useState(null), y = He(t, (z) => w(z)), _ = h.useRef(null), k = h.useRef(null), x = a || p.duration, S = h.useRef(0), $ = h.useRef(x), E = h.useRef(0), { onToastAdd: C, onToastRemove: A } = p, I = Qe(() => {
      b?.contains(document.activeElement) && p.viewport?.focus(), i();
    }), U = h.useCallback(
      (z) => {
        !z || z === 1 / 0 || (window.clearTimeout(E.current), S.current = (/* @__PURE__ */ new Date()).getTime(), E.current = window.setTimeout(I, z));
      },
      [I]
    );
    h.useEffect(() => {
      const z = p.viewport;
      if (z) {
        const L = () => {
          U($.current), c?.();
        }, q = () => {
          const K = (/* @__PURE__ */ new Date()).getTime() - S.current;
          $.current = $.current - K, window.clearTimeout(E.current), l?.();
        };
        return z.addEventListener(rc, q), z.addEventListener(ic, L), () => {
          z.removeEventListener(rc, q), z.removeEventListener(ic, L);
        };
      }
    }, [p.viewport, x, l, c, U]), h.useEffect(() => {
      r && !p.isClosePausedRef.current && U(x);
    }, [r, x, p.isClosePausedRef, U]), h.useEffect(() => (C(), () => A()), [C, A]);
    const M = h.useMemo(() => b ? vy(b) : null, [b]);
    return p.viewport ? /* @__PURE__ */ P(je, { children: [
      M && /* @__PURE__ */ v(
        xN,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: M
        }
      ),
      /* @__PURE__ */ v(_N, { scope: n, onClose: I, children: so.createPortal(
        /* @__PURE__ */ v(uy.ItemSlot, { scope: n, children: /* @__PURE__ */ v(
          yA,
          {
            asChild: !0,
            onEscapeKeyDown: ge(s, () => {
              p.isFocusedToastEscapeKeyDownRef.current || I(), p.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ v(
              Oe.li,
              {
                tabIndex: 0,
                "data-state": r ? "open" : "closed",
                "data-swipe-direction": p.swipeDirection,
                ...g,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: ge(e.onKeyDown, (z) => {
                  z.key === "Escape" && (s?.(z.nativeEvent), z.nativeEvent.defaultPrevented || (p.isFocusedToastEscapeKeyDownRef.current = !0, I()));
                }),
                onPointerDown: ge(e.onPointerDown, (z) => {
                  z.button === 0 && (_.current = { x: z.clientX, y: z.clientY });
                }),
                onPointerMove: ge(e.onPointerMove, (z) => {
                  if (!_.current) return;
                  const L = z.clientX - _.current.x, q = z.clientY - _.current.y, K = !!k.current, Z = ["left", "right"].includes(p.swipeDirection), te = ["left", "up"].includes(p.swipeDirection) ? Math.min : Math.max, O = Z ? te(0, L) : 0, N = Z ? 0 : te(0, q), T = z.pointerType === "touch" ? 10 : 2, W = { x: O, y: N }, B = { originalEvent: z, delta: W };
                  K ? (k.current = W, wr(gN, d, B, {
                    discrete: !1
                  })) : ap(W, p.swipeDirection, T) ? (k.current = W, wr(fN, u, B, {
                    discrete: !1
                  }), z.target.setPointerCapture(z.pointerId)) : (Math.abs(L) > T || Math.abs(q) > T) && (_.current = null);
                }),
                onPointerUp: ge(e.onPointerUp, (z) => {
                  const L = k.current, q = z.target;
                  if (q.hasPointerCapture(z.pointerId) && q.releasePointerCapture(z.pointerId), k.current = null, _.current = null, L) {
                    const K = z.currentTarget, Z = { originalEvent: z, delta: L };
                    ap(L, p.swipeDirection, p.swipeThreshold) ? wr(vN, f, Z, {
                      discrete: !0
                    }) : wr(
                      bN,
                      m,
                      Z,
                      {
                        discrete: !0
                      }
                    ), K.addEventListener("click", (te) => te.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        p.viewport
      ) })
    ] }) : null;
  }
), xN = (e) => {
  const { __scopeToast: t, children: n, ...o } = e, a = ds(Ua, t), [r, i] = h.useState(!1), [s, l] = h.useState(!1);
  return ON(() => i(!0)), h.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ v(Bb, { asChild: !0, children: /* @__PURE__ */ v(Mu, { ...o, children: r && /* @__PURE__ */ P(je, { children: [
    a.label,
    " ",
    n
  ] }) }) });
}, $N = "ToastTitle", SN = h.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ v(Oe.div, { ...o, ref: t });
  }
);
SN.displayName = $N;
var CN = "ToastDescription", EN = h.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ v(Oe.div, { ...o, ref: t });
  }
);
EN.displayName = CN;
var my = "ToastAction", AN = h.forwardRef(
  (e, t) => {
    const { altText: n, ...o } = e;
    return n.trim() ? /* @__PURE__ */ v(by, { altText: n, asChild: !0, children: /* @__PURE__ */ v(gy, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${my}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
AN.displayName = my;
var fy = "ToastClose", gy = h.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e, a = wN(fy, n);
    return /* @__PURE__ */ v(by, { asChild: !0, children: /* @__PURE__ */ v(
      Oe.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: ge(e.onClick, a.onClose)
      }
    ) });
  }
);
gy.displayName = fy;
var by = h.forwardRef((e, t) => {
  const { __scopeToast: n, altText: o, ...a } = e;
  return /* @__PURE__ */ v(
    Oe.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...a,
      ref: t
    }
  );
});
function vy(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), zN(n)) {
      const o = n.ariaHidden || n.hidden || n.style.display === "none", a = n.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const r = n.dataset.radixToastAnnounceAlt;
          r && t.push(r);
        } else
          t.push(...vy(n));
    }
  }), t;
}
function wr(e, t, n, { discrete: o }) {
  const a = n.originalEvent.currentTarget, r = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), o ? Sb(a, r) : a.dispatchEvent(r);
}
var ap = (e, t, n = 0) => {
  const o = Math.abs(e.x), a = Math.abs(e.y), r = o > a;
  return t === "left" || t === "right" ? r && o > n : !r && a > n;
};
function ON(e = () => {
}) {
  const t = Qe(e);
  En(() => {
    let n = 0, o = 0;
    return n = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function zN(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function NN(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ul(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function jN(e, t = 500) {
  const [n, o] = Ne(e);
  return Se(() => {
    const a = setTimeout(() => o(e), t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), n;
}
const RN = Pt(void 0);
function IN({ children: e, config: t }) {
  const { apiUrl: n } = t;
  NC(n);
  const o = {
    apiUrl: "",
    locale: "fr"
  }, [a, r] = Ne({
    ...o,
    ...t
  }), i = {
    config: a,
    setConfig: r
  };
  return /* @__PURE__ */ v(RN.Provider, { value: i, children: e });
}
Pt(void 0);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function lc() {
  return lc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, lc.apply(this, arguments);
}
var rp;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(rp || (rp = {}));
function Me(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function qa(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function cc(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: o = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), o && o !== "#" && (t += o.charAt(0) === "#" ? o : "#" + o), t;
}
function yy(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let o = e.indexOf("?");
    o >= 0 && (t.search = e.substr(o), e = e.substr(0, o)), e && (t.pathname = e);
  }
  return t;
}
var ip;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(ip || (ip = {}));
function sp(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, o] = TN(e.path, e.caseSensitive, e.end), a = t.match(n);
  if (!a) return null;
  let r = a[0], i = r.replace(/(.)\/+$/, "$1"), s = a.slice(1);
  return {
    params: o.reduce((l, c, u) => {
      let {
        paramName: d,
        isOptional: m
      } = c;
      if (d === "*") {
        let g = s[u] || "";
        i = r.slice(0, r.length - g.length).replace(/(.)\/+$/, "$1");
      }
      const f = s[u];
      return m && !f ? l[d] = void 0 : l[d] = (f || "").replace(/%2F/g, "/"), l;
    }, {}),
    pathname: r,
    pathnameBase: i,
    pattern: e
  };
}
function TN(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), qa(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let o = [], a = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (r, i, s) => (o.push({
    paramName: i,
    isOptional: s != null
  }), s ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (o.push({
    paramName: "*"
  }), a += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? a += "\\/*$" : e !== "" && e !== "/" && (a += "(?:(?=\\/|$))"), [new RegExp(a, t ? void 0 : "i"), o];
}
function Uo(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, o = e.charAt(n);
  return o && o !== "/" ? null : e.slice(n) || "/";
}
function PN(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: o = "",
    hash: a = ""
  } = typeof e == "string" ? yy(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : DN(n, t) : t,
    search: MN(o),
    hash: FN(a)
  };
}
function DN(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? n.length > 1 && n.pop() : o !== "." && n.push(o);
  }), n.length > 1 ? n.join("/") : "/";
}
function dl(e, t, n, o) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(o) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function LN(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function _y(e, t) {
  let n = LN(e);
  return t ? n.map((o, a) => a === n.length - 1 ? o.pathname : o.pathnameBase) : n.map((o) => o.pathnameBase);
}
function wy(e, t, n, o) {
  o === void 0 && (o = !1);
  let a;
  typeof e == "string" ? a = yy(e) : (a = lc({}, e), Me(!a.pathname || !a.pathname.includes("?"), dl("?", "pathname", "search", a)), Me(!a.pathname || !a.pathname.includes("#"), dl("#", "pathname", "hash", a)), Me(!a.search || !a.search.includes("#"), dl("#", "search", "hash", a)));
  let r = e === "" || a.pathname === "", i = r ? "/" : a.pathname, s;
  if (i == null)
    s = n;
  else {
    let d = t.length - 1;
    if (!o && i.startsWith("..")) {
      let m = i.split("/");
      for (; m[0] === ".."; )
        m.shift(), d -= 1;
      a.pathname = m.join("/");
    }
    s = d >= 0 ? t[d] : "/";
  }
  let l = PN(a, s), c = i && i !== "/" && i.endsWith("/"), u = (r || i === ".") && n.endsWith("/");
  return !l.pathname.endsWith("/") && (c || u) && (l.pathname += "/"), l;
}
const Wu = (e) => e.join("/").replace(/\/\/+/g, "/"), MN = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, FN = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, ky = ["post", "put", "patch", "delete"];
new Set(ky);
const WN = ["get", ...ky];
new Set(WN);
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function uc() {
  return uc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, uc.apply(this, arguments);
}
const hs = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (hs.displayName = "DataRouter");
const xy = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (xy.displayName = "DataRouterState");
const BN = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (BN.displayName = "Await");
const gn = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (gn.displayName = "Navigation");
const Bu = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (Bu.displayName = "Location");
const Xo = /* @__PURE__ */ h.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (Xo.displayName = "Route");
const VN = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (VN.displayName = "RouteError");
function UN(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  Vu() || (process.env.NODE_ENV !== "production" ? Me(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : Me(!1));
  let {
    basename: o,
    navigator: a
  } = h.useContext(gn), {
    hash: r,
    pathname: i,
    search: s
  } = Ka(e, {
    relative: n
  }), l = i;
  return o !== "/" && (l = i === "/" ? o : Wu([o, i])), a.createHref({
    pathname: l,
    search: s,
    hash: r
  });
}
function Vu() {
  return h.useContext(Bu) != null;
}
function Ha() {
  return Vu() || (process.env.NODE_ENV !== "production" ? Me(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : Me(!1)), h.useContext(Bu).location;
}
const $y = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Sy(e) {
  h.useContext(gn).static || h.useLayoutEffect(e);
}
function qN() {
  let {
    isDataRoute: e
  } = h.useContext(Xo);
  return e ? JN() : HN();
}
function HN() {
  Vu() || (process.env.NODE_ENV !== "production" ? Me(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : Me(!1));
  let e = h.useContext(hs), {
    basename: t,
    future: n,
    navigator: o
  } = h.useContext(gn), {
    matches: a
  } = h.useContext(Xo), {
    pathname: r
  } = Ha(), i = JSON.stringify(_y(a, n.v7_relativeSplatPath)), s = h.useRef(!1);
  return Sy(() => {
    s.current = !0;
  }), h.useCallback(function(l, c) {
    if (c === void 0 && (c = {}), process.env.NODE_ENV !== "production" && qa(s.current, $y), !s.current) return;
    if (typeof l == "number") {
      o.go(l);
      return;
    }
    let u = wy(l, JSON.parse(i), r, c.relative === "path");
    e == null && t !== "/" && (u.pathname = u.pathname === "/" ? t : Wu([t, u.pathname])), (c.replace ? o.replace : o.push)(u, c.state, c);
  }, [t, o, i, r, e]);
}
function Ka(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: o
  } = h.useContext(gn), {
    matches: a
  } = h.useContext(Xo), {
    pathname: r
  } = Ha(), i = JSON.stringify(_y(a, o.v7_relativeSplatPath));
  return h.useMemo(() => wy(e, JSON.parse(i), r, n === "path"), [e, i, r, n]);
}
var Cy = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(Cy || {}), Uu = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(Uu || {});
function Ey(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function KN(e) {
  let t = h.useContext(hs);
  return t || (process.env.NODE_ENV !== "production" ? Me(!1, Ey(e)) : Me(!1)), t;
}
function GN(e) {
  let t = h.useContext(Xo);
  return t || (process.env.NODE_ENV !== "production" ? Me(!1, Ey(e)) : Me(!1)), t;
}
function Ay(e) {
  let t = GN(e), n = t.matches[t.matches.length - 1];
  return n.route.id || (process.env.NODE_ENV !== "production" ? Me(!1, e + ' can only be used on routes that contain a unique "id"') : Me(!1)), n.route.id;
}
function ZN() {
  return Ay(Uu.UseRouteId);
}
function JN() {
  let {
    router: e
  } = KN(Cy.UseNavigateStable), t = Ay(Uu.UseNavigateStable), n = h.useRef(!1);
  return Sy(() => {
    n.current = !0;
  }), h.useCallback(function(o, a) {
    a === void 0 && (a = {}), process.env.NODE_ENV !== "production" && qa(n.current, $y), n.current && (typeof o == "number" ? e.navigate(o) : e.navigate(o, uc({
      fromRouteId: t
    }, a)));
  }, [e, t]);
}
new Promise(() => {
});
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function qo() {
  return qo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, qo.apply(this, arguments);
}
function qu(e, t) {
  if (e == null) return {};
  var n = {}, o = Object.keys(e), a, r;
  for (r = 0; r < o.length; r++)
    a = o[r], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
const Gr = "get", Zr = "application/x-www-form-urlencoded";
function ps(e) {
  return e != null && typeof e.tagName == "string";
}
function YN(e) {
  return ps(e) && e.tagName.toLowerCase() === "button";
}
function XN(e) {
  return ps(e) && e.tagName.toLowerCase() === "form";
}
function QN(e) {
  return ps(e) && e.tagName.toLowerCase() === "input";
}
function ej(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function tj(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !ej(e);
}
let kr = null;
function nj() {
  if (kr === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), kr = !1;
    } catch {
      kr = !0;
    }
  return kr;
}
const oj = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function hl(e) {
  return e != null && !oj.has(e) ? (process.env.NODE_ENV !== "production" && qa(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + Zr + '"')), null) : e;
}
function aj(e, t) {
  let n, o, a, r, i;
  if (XN(e)) {
    let s = e.getAttribute("action");
    o = s ? Uo(s, t) : null, n = e.getAttribute("method") || Gr, a = hl(e.getAttribute("enctype")) || Zr, r = new FormData(e);
  } else if (YN(e) || QN(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (o = l ? Uo(l, t) : null, n = e.getAttribute("formmethod") || s.getAttribute("method") || Gr, a = hl(e.getAttribute("formenctype")) || hl(s.getAttribute("enctype")) || Zr, r = new FormData(s, e), !nj()) {
      let {
        name: c,
        type: u,
        value: d
      } = e;
      if (u === "image") {
        let m = c ? c + "." : "";
        r.append(m + "x", "0"), r.append(m + "y", "0");
      } else c && r.append(c, d);
    }
  } else {
    if (ps(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = Gr, o = null, a = Zr, i = e;
  }
  return r && a === "text/plain" && (i = r, r = void 0), {
    action: o,
    method: n.toLowerCase(),
    encType: a,
    formData: r,
    body: i
  };
}
const rj = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], ij = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"], sj = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "viewTransition"], lj = "6";
try {
  window.__reactRouterVersion = lj;
} catch {
}
const Oy = /* @__PURE__ */ h.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (Oy.displayName = "ViewTransition");
const cj = /* @__PURE__ */ h.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (cj.displayName = "Fetchers");
process.env.NODE_ENV;
const uj = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", dj = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, zy = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    onClick: n,
    relative: o,
    reloadDocument: a,
    replace: r,
    state: i,
    target: s,
    to: l,
    preventScrollReset: c,
    viewTransition: u
  } = e, d = qu(e, rj), {
    basename: m
  } = h.useContext(gn), f, g = !1;
  if (typeof l == "string" && dj.test(l) && (f = l, uj))
    try {
      let y = new URL(window.location.href), _ = l.startsWith("//") ? new URL(y.protocol + l) : new URL(l), k = Uo(_.pathname, m);
      _.origin === y.origin && k != null ? l = k + _.search + _.hash : g = !0;
    } catch {
      process.env.NODE_ENV !== "production" && qa(!1, '<Link to="' + l + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let p = UN(l, {
    relative: o
  }), b = fj(l, {
    replace: r,
    state: i,
    target: s,
    preventScrollReset: c,
    relative: o,
    viewTransition: u
  });
  function w(y) {
    n && n(y), y.defaultPrevented || b(y);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ h.createElement("a", qo({}, d, {
      href: f || p,
      onClick: g || a ? n : w,
      ref: t,
      target: s
    }))
  );
});
process.env.NODE_ENV !== "production" && (zy.displayName = "Link");
const hj = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    "aria-current": n = "page",
    caseSensitive: o = !1,
    className: a = "",
    end: r = !1,
    style: i,
    to: s,
    viewTransition: l,
    children: c
  } = e, u = qu(e, ij), d = Ka(s, {
    relative: u.relative
  }), m = Ha(), f = h.useContext(xy), {
    navigator: g,
    basename: p
  } = h.useContext(gn), b = f != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  wj(d) && l === !0, w = g.encodeLocation ? g.encodeLocation(d).pathname : d.pathname, y = m.pathname, _ = f && f.navigation && f.navigation.location ? f.navigation.location.pathname : null;
  o || (y = y.toLowerCase(), _ = _ ? _.toLowerCase() : null, w = w.toLowerCase()), _ && p && (_ = Uo(_, p) || _);
  const k = w !== "/" && w.endsWith("/") ? w.length - 1 : w.length;
  let x = y === w || !r && y.startsWith(w) && y.charAt(k) === "/", S = _ != null && (_ === w || !r && _.startsWith(w) && _.charAt(w.length) === "/"), $ = {
    isActive: x,
    isPending: S,
    isTransitioning: b
  }, E = x ? n : void 0, C;
  typeof a == "function" ? C = a($) : C = [a, x ? "active" : null, S ? "pending" : null, b ? "transitioning" : null].filter(Boolean).join(" ");
  let A = typeof i == "function" ? i($) : i;
  return /* @__PURE__ */ h.createElement(zy, qo({}, u, {
    "aria-current": E,
    className: C,
    ref: t,
    style: A,
    to: s,
    viewTransition: l
  }), typeof c == "function" ? c($) : c);
});
process.env.NODE_ENV !== "production" && (hj.displayName = "NavLink");
const pj = /* @__PURE__ */ h.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: o,
    reloadDocument: a,
    replace: r,
    state: i,
    method: s = Gr,
    action: l,
    onSubmit: c,
    relative: u,
    preventScrollReset: d,
    viewTransition: m
  } = e, f = qu(e, sj), g = yj(), p = _j(l, {
    relative: u
  }), b = s.toLowerCase() === "get" ? "get" : "post", w = (y) => {
    if (c && c(y), y.defaultPrevented) return;
    y.preventDefault();
    let _ = y.nativeEvent.submitter, k = _?.getAttribute("formmethod") || s;
    g(_ || y.currentTarget, {
      fetcherKey: n,
      method: k,
      navigate: o,
      replace: r,
      state: i,
      relative: u,
      preventScrollReset: d,
      viewTransition: m
    });
  };
  return /* @__PURE__ */ h.createElement("form", qo({
    ref: t,
    method: b,
    action: p,
    onSubmit: a ? c : w
  }, f));
});
process.env.NODE_ENV !== "production" && (pj.displayName = "Form");
process.env.NODE_ENV;
var ki;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(ki || (ki = {}));
var lp;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(lp || (lp = {}));
function mj(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function Ny(e) {
  let t = h.useContext(hs);
  return t || (process.env.NODE_ENV !== "production" ? Me(!1, mj(e)) : Me(!1)), t;
}
function fj(e, t) {
  let {
    target: n,
    replace: o,
    state: a,
    preventScrollReset: r,
    relative: i,
    viewTransition: s
  } = t === void 0 ? {} : t, l = qN(), c = Ha(), u = Ka(e, {
    relative: i
  });
  return h.useCallback((d) => {
    if (tj(d, n)) {
      d.preventDefault();
      let m = o !== void 0 ? o : cc(c) === cc(u);
      l(e, {
        replace: m,
        state: a,
        preventScrollReset: r,
        relative: i,
        viewTransition: s
      });
    }
  }, [c, l, u, o, a, n, e, r, i, s]);
}
function gj() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let bj = 0, vj = () => "__" + String(++bj) + "__";
function yj() {
  let {
    router: e
  } = Ny(ki.UseSubmit), {
    basename: t
  } = h.useContext(gn), n = ZN();
  return h.useCallback(function(o, a) {
    a === void 0 && (a = {}), gj();
    let {
      action: r,
      method: i,
      encType: s,
      formData: l,
      body: c
    } = aj(o, t);
    if (a.navigate === !1) {
      let u = a.fetcherKey || vj();
      e.fetch(u, n, a.action || r, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: c,
        formMethod: a.method || i,
        formEncType: a.encType || s,
        flushSync: a.flushSync
      });
    } else
      e.navigate(a.action || r, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: c,
        formMethod: a.method || i,
        formEncType: a.encType || s,
        replace: a.replace,
        state: a.state,
        fromRouteId: n,
        flushSync: a.flushSync,
        viewTransition: a.viewTransition
      });
  }, [e, t, n]);
}
function _j(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: o
  } = h.useContext(gn), a = h.useContext(Xo);
  a || (process.env.NODE_ENV !== "production" ? Me(!1, "useFormAction must be used inside a RouteContext") : Me(!1));
  let [r] = a.matches.slice(-1), i = qo({}, Ka(e || ".", {
    relative: n
  })), s = Ha();
  if (e == null) {
    i.search = s.search;
    let l = new URLSearchParams(i.search), c = l.getAll("index");
    if (c.some((u) => u === "")) {
      l.delete("index"), c.filter((d) => d).forEach((d) => l.append("index", d));
      let u = l.toString();
      i.search = u ? "?" + u : "";
    }
  }
  return (!e || e === ".") && r.route.index && (i.search = i.search ? i.search.replace(/^\?/, "?index&") : "?index"), o !== "/" && (i.pathname = i.pathname === "/" ? o : Wu([o, i.pathname])), cc(i);
}
function wj(e, t) {
  t === void 0 && (t = {});
  let n = h.useContext(Oy);
  n == null && (process.env.NODE_ENV !== "production" ? Me(!1, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : Me(!1));
  let {
    basename: o
  } = Ny(ki.useViewTransitionState), a = Ka(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let r = Uo(n.currentLocation.pathname, o) || n.currentLocation.pathname, i = Uo(n.nextLocation.pathname, o) || n.nextLocation.pathname;
  return sp(a.pathname, i) != null || sp(a.pathname, r) != null;
}
function jy(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = jy(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function kj() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = jy(e)) && (o && (o += " "), o += t);
  return o;
}
const xj = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], $j = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Sj = xj.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: $j[e]
})), Cj = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Ej = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Aj(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const Oj = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = Sj.find((l) => l.name === e), s = kj("icon", `ds-${i?.class}`, Ej[t], Cj[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: Aj(i?.paths) });
  }
);
Oj.displayName = "Icon";
Pt({
  locale: "en"
});
function zj(e, t) {
  const [n, o] = Ne(e), a = jN(n, 500), [r, i] = Ne([]);
  Se(() => {
    a.length > 3 && TC(a, t).then((l) => {
      const c = l?.features.map((u) => ({ value: u.properties.label, id: u.properties.gid }));
      i(c);
    });
  }, [a, t]);
  const s = a.length > 2 ? r ?? [] : [];
  return { value: n, setValue: o, suggestedDestinations: s };
}
function Nj() {
  return De((e, t) => {
    let n;
    t ? n = `${t.value}?location_id=${t.id}&provider=Jawg` : n = "everywhere", window !== void 0 && (window.location.href = `/search-v2/${n}`);
  }, []);
}
function jj({
  placeholder: e,
  buttonText: t,
  id: n,
  className: o,
  locale: a,
  ...r
}) {
  const { setValue: i, suggestedDestinations: s } = zj("", a), l = Nj();
  return /* @__PURE__ */ v(
    jz,
    {
      className: o,
      id: n || "search-bar",
      placeholder: e || "Search destinations",
      suggestions: s,
      onChange: i,
      onSubmit: l,
      buttonText: t || "Search",
      ...r
    }
  );
}
function Rj({
  config: e,
  placeholder: t = "Search destinations",
  buttonText: n = "Search",
  id: o,
  className: a,
  ...r
}) {
  return /* @__PURE__ */ v(IN, { config: e, children: /* @__PURE__ */ v(
    jj,
    {
      placeholder: t,
      buttonText: n,
      id: o,
      className: a,
      locale: e.locale,
      ...r
    }
  ) });
}
function Ij() {
  const [e, t] = Ne({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Se(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function Tj() {
  const { width: e } = Ij();
  let t = "desktop";
  return e && e <= Ad.MOBILE ? t = "mobile" : e && e <= Ad.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function Pj(e, t, n) {
  Se(() => {
    if (window)
      return window.addEventListener(e, t, n), () => {
        window.removeEventListener(e, t, n);
      };
  }, [e, t, n]);
}
const cp = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const m = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((f) => f(t, m));
    }
  }, a = () => t, s = { setState: o, getState: a, getInitialState: () => l, subscribe: (c) => (n.add(c), () => n.delete(c)) }, l = t = e(o, a, s);
  return s;
}, Ry = (e) => e ? cp(e) : cp, Dj = (e) => e;
function Iy(e, t = Dj) {
  const n = ae.useSyncExternalStore(
    e.subscribe,
    ae.useCallback(() => t(e.getState()), [e, t]),
    ae.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return ae.useDebugValue(n), n;
}
function Lj(e) {
  const t = {
    conversations: void 0,
    userInfos: void 0,
    apiUrl: "",
    assetsUrl: ""
  };
  return Ry((n) => ({
    ...t,
    ...e,
    setNavigationBarData: (o) => n({
      conversations: o.conversations,
      userInfos: o.userInfos
    }),
    setConversations: (o) => n({ conversations: o }),
    setUserInfos: (o) => n({ userInfos: o }),
    setApiUrl: (o) => n({ apiUrl: o }),
    setAssetsUrl: (o) => n({ assetsUrl: o }),
    clear: () => n({
      conversations: void 0,
      userInfos: void 0
    })
  }));
}
const Ty = Pt(void 0);
function Mj({ children: e, ...t }) {
  const n = Te(null);
  return n.current || (n.current = Lj(t)), /* @__PURE__ */ v(Ty.Provider, { value: n.current, children: e });
}
const up = (e) => Symbol.iterator in e, dp = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), hp = (e, t) => {
  const n = e instanceof Map ? e : new Map(e.entries()), o = t instanceof Map ? t : new Map(t.entries());
  if (n.size !== o.size)
    return !1;
  for (const [a, r] of n)
    if (!o.has(a) || !Object.is(r, o.get(a)))
      return !1;
  return !0;
}, Fj = (e, t) => {
  const n = e[Symbol.iterator](), o = t[Symbol.iterator]();
  let a = n.next(), r = o.next();
  for (; !a.done && !r.done; ) {
    if (!Object.is(a.value, r.value))
      return !1;
    a = n.next(), r = o.next();
  }
  return !!a.done && !!r.done;
};
function Wj(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : up(e) && up(t) ? dp(e) && dp(t) ? hp(e, t) : Fj(e, t) : hp(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function Py(e) {
  const t = ae.useRef(void 0);
  return (n) => {
    const o = e(n);
    return Wj(t.current, o) ? t.current : t.current = o;
  };
}
function Qn(e) {
  const t = io(Ty);
  if (!t) throw new Error("Missing NavigationContext.Provider in the tree");
  return Iy(t, Py(e));
}
const Dy = Pt(void 0);
function ms(e) {
  const t = io(Dy);
  if (!t) throw new Error("Missing UserContext.Provider in the tree");
  return Iy(t, Py(e));
}
function Bj(e) {
  const t = {
    isSignedIn: !1
  };
  return Ry((n) => ({
    ...t,
    ...e,
    setIsSignedIn: (o) => n({ isSignedIn: o }),
    signout: () => n({ isSignedIn: !1 })
  }));
}
function Vj({ children: e, ...t }) {
  const n = Te(null);
  return n.current || (n.current = Bj(t)), /* @__PURE__ */ v(Dy.Provider, { value: n.current, children: e });
}
const ie = (e) => typeof e == "string", ua = () => {
  let e, t;
  const n = new Promise((o, a) => {
    e = o, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, pp = (e) => e == null ? "" : "" + e, Uj = (e, t, n) => {
  e.forEach((o) => {
    t[o] && (n[o] = t[o]);
  });
}, qj = /###/g, mp = (e) => e && e.indexOf("###") > -1 ? e.replace(qj, ".") : e, fp = (e) => !e || ie(e), wa = (e, t, n) => {
  const o = ie(t) ? t.split(".") : t;
  let a = 0;
  for (; a < o.length - 1; ) {
    if (fp(e)) return {};
    const r = mp(o[a]);
    !e[r] && n && (e[r] = new n()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++a;
  }
  return fp(e) ? {} : {
    obj: e,
    k: mp(o[a])
  };
}, gp = (e, t, n) => {
  const {
    obj: o,
    k: a
  } = wa(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[a] = n;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = wa(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = wa(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = n;
}, Hj = (e, t, n, o) => {
  const {
    obj: a,
    k: r
  } = wa(e, t, Object);
  a[r] = a[r] || [], a[r].push(n);
}, xi = (e, t) => {
  const {
    obj: n,
    k: o
  } = wa(e, t);
  if (n && Object.prototype.hasOwnProperty.call(n, o))
    return n[o];
}, Kj = (e, t, n) => {
  const o = xi(e, n);
  return o !== void 0 ? o : xi(t, n);
}, Ly = (e, t, n) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? ie(e[o]) || e[o] instanceof String || ie(t[o]) || t[o] instanceof String ? n && (e[o] = t[o]) : Ly(e[o], t[o], n) : e[o] = t[o]);
  return e;
}, ko = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Gj = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Zj = (e) => ie(e) ? e.replace(/[&<>"'\/]/g, (t) => Gj[t]) : e;
class Jj {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const Yj = [" ", ",", "?", "!", ";"], Xj = new Jj(20), Qj = (e, t, n) => {
  t = t || "", n = n || "";
  const o = Yj.filter((i) => t.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const a = Xj.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !a.test(e);
  if (!r) {
    const i = e.indexOf(n);
    i > 0 && !a.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, dc = (e, t, n = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(n);
  let a = e;
  for (let r = 0; r < o.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += n), s += o[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    a = i;
  }
  return a;
}, Ea = (e) => e?.replace("_", "-"), eR = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class $i {
  constructor(t, n = {}) {
    this.init(t, n);
  }
  init(t, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = t || eR, this.options = n, this.debug = n.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, o, a) {
    return a && !this.debug ? null : (ie(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new $i(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new $i(this.logger, t);
  }
}
var Ht = new $i();
class fs {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const a = this.observers[o].get(n) || 0;
      this.observers[o].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t, ...n) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([a, r]) => {
      for (let i = 0; i < r; i++)
        a(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([a, r]) => {
      for (let i = 0; i < r; i++)
        a.apply(a, [t, ...n]);
    });
  }
}
class bp extends fs {
  constructor(t, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, o, a = {}) {
    const r = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], o && (Array.isArray(o) ? s.push(...o) : ie(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = xi(this.data, s);
    return !l && !n && !o && t.indexOf(".") > -1 && (t = s[0], n = s[1], o = s.slice(2).join(".")), l || !i || !ie(o) ? l : dc(this.data?.[t]?.[n], o, r);
  }
  addResource(t, n, o, a, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, n];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), gp(this.data, s, a), r.silent || this.emit("added", t, n, o, a);
  }
  addResources(t, n, o, a = {
    silent: !1
  }) {
    for (const r in o)
      (ie(o[r]) || Array.isArray(o[r])) && this.addResource(t, n, r, o[r], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, o);
  }
  addResourceBundle(t, n, o, a, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = o, o = n, n = s[1]), this.addNamespaces(n);
    let l = xi(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), a ? Ly(l, o, r) : l = {
      ...l,
      ...o
    }, gp(this.data, s, l), i.silent || this.emit("added", t, n, o);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var My = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, o, a) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, n, o, a) ?? t;
    }), t;
  }
};
const Fy = Symbol("i18next/PATH_KEY");
function tR() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let n;
  return t.get = (o, a) => (n?.revoke?.(), a === Fy ? e : (e.push(a), n = Proxy.revocable(o, t), n.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function hc(e, t) {
  const {
    [Fy]: n
  } = e(tR());
  return n.join(t?.keySeparator ?? ".");
}
const vp = {}, yp = (e) => !ie(e) && typeof e != "boolean" && typeof e != "number";
class Si extends fs {
  constructor(t, n = {}) {
    super(), Uj(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ht.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, n = {
    interpolation: {}
  }) {
    const o = {
      ...n
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, n) {
    let o = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let r = n.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !Qj(t, o, a);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: ie(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== a || o === a && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: ie(r) ? [r] : r
    };
  }
  translate(t, n, o) {
    let a = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof a != "object" && this.options.overloadTranslationOptionHandler && (a = this.options.overloadTranslationOptionHandler(arguments)), typeof a == "object" && (a = {
      ...a
    }), a || (a = {}), t == null) return "";
    typeof t == "function" && (t = hc(t, {
      ...this.options,
      ...a
    })), Array.isArray(t) || (t = [String(t)]);
    const r = a.returnDetails !== void 0 ? a.returnDetails : this.options.returnDetails, i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], a), c = l[l.length - 1];
    let u = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = a.lng || this.language, m = a.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return m ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : s;
    const f = this.resolve(t, a);
    let g = f?.res;
    const p = f?.usedKey || s, b = f?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], y = a.joinArrays !== void 0 ? a.joinArrays : this.options.joinArrays, _ = !this.i18nFormat || this.i18nFormat.handleAsObject, k = a.count !== void 0 && !ie(a.count), x = Si.hasDefaultValue(a), S = k ? this.pluralResolver.getSuffix(d, a.count, a) : "", $ = a.ordinal && k ? this.pluralResolver.getSuffix(d, a.count, {
      ordinal: !1
    }) : "", E = k && !a.ordinal && a.count === 0, C = E && a[`defaultValue${this.options.pluralSeparator}zero`] || a[`defaultValue${S}`] || a[`defaultValue${$}`] || a.defaultValue;
    let A = g;
    _ && !g && x && (A = C);
    const I = yp(A), U = Object.prototype.toString.apply(A);
    if (_ && A && I && w.indexOf(U) < 0 && !(ie(y) && Array.isArray(A))) {
      if (!a.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, A, {
          ...a,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (f.res = M, f.usedParams = this.getUsedParamsDetails(a), f) : M;
      }
      if (i) {
        const M = Array.isArray(A), z = M ? [] : {}, L = M ? b : p;
        for (const q in A)
          if (Object.prototype.hasOwnProperty.call(A, q)) {
            const K = `${L}${i}${q}`;
            x && !g ? z[q] = this.translate(K, {
              ...a,
              defaultValue: yp(C) ? C[q] : void 0,
              joinArrays: !1,
              ns: l
            }) : z[q] = this.translate(K, {
              ...a,
              joinArrays: !1,
              ns: l
            }), z[q] === K && (z[q] = A[q]);
          }
        g = z;
      }
    } else if (_ && ie(y) && Array.isArray(g))
      g = g.join(y), g && (g = this.extendTranslation(g, t, a, o));
    else {
      let M = !1, z = !1;
      !this.isValidLookup(g) && x && (M = !0, g = C), this.isValidLookup(g) || (z = !0, g = s);
      const q = (a.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && z ? void 0 : g, K = x && C !== g && this.options.updateMissing;
      if (z || M || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", d, c, s, K ? C : g), i) {
          const N = this.resolve(s, {
            ...a,
            keySeparator: !1
          });
          N && N.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Z = [];
        const te = this.languageUtils.getFallbackCodes(this.options.fallbackLng, a.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && te && te[0])
          for (let N = 0; N < te.length; N++)
            Z.push(te[N]);
        else this.options.saveMissingTo === "all" ? Z = this.languageUtils.toResolveHierarchy(a.lng || this.language) : Z.push(a.lng || this.language);
        const O = (N, T, W) => {
          const B = x && W !== g ? W : q;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(N, c, T, B, K, a) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(N, c, T, B, K, a), this.emit("missingKey", N, c, T, g);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? Z.forEach((N) => {
          const T = this.pluralResolver.getSuffixes(N, a);
          E && a[`defaultValue${this.options.pluralSeparator}zero`] && T.indexOf(`${this.options.pluralSeparator}zero`) < 0 && T.push(`${this.options.pluralSeparator}zero`), T.forEach((W) => {
            O([N], s + W, a[`defaultValue${W}`] || C);
          });
        }) : O(Z, s, C));
      }
      g = this.extendTranslation(g, t, a, f, o), z && g === s && this.options.appendNamespaceToMissingKey && (g = `${c}${u}${s}`), (z || M) && this.options.parseMissingKeyHandler && (g = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, M ? g : void 0, a));
    }
    return r ? (f.res = g, f.usedParams = this.getUsedParamsDetails(a), f) : g;
  }
  extendTranslation(t, n, o, a, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = ie(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !ie(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || a.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), m = d && d.length;
        c < m && (o.nest = !1);
      }
      !o.lng && a && a.res && (o.lng = this.language || a.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null) : this.translate(...d, n), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = ie(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = My.handle(s, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, n = {}) {
    let o, a, r, i, s;
    return ie(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const m = n.count !== void 0 && !ie(n.count), f = m && !n.ordinal && n.count === 0, g = n.context !== void 0 && (ie(n.context) || typeof n.context == "number") && n.context !== "", p = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !vp[`${p[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (vp[`${p[0]}-${b}`] = !0, this.logger.warn(`key "${a}" for languages "${p.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const y = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(y, u, w, b, n);
          else {
            let k;
            m && (k = this.pluralResolver.getSuffix(w, n.count, n));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (m && (n.ordinal && k.indexOf(S) === 0 && y.push(u + k.replace(S, this.options.pluralSeparator)), y.push(u + k), f && y.push(u + x)), g) {
              const $ = `${u}${this.options.contextSeparator || "_"}${n.context}`;
              y.push($), m && (n.ordinal && k.indexOf(S) === 0 && y.push($ + k.replace(S, this.options.pluralSeparator)), y.push($ + k), f && y.push($ + x));
            }
          }
          let _;
          for (; _ = y.pop(); )
            this.isValidLookup(o) || (r = _, o = this.getResource(w, b, _, n));
        }));
      });
    }), {
      res: o,
      usedKey: a,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, o, a = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, n, o, a) : this.resourceStore.getResource(t, n, o, a);
  }
  getUsedParamsDetails(t = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !ie(t.replace);
    let a = o ? t.replace : t;
    if (o && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !o) {
      a = {
        ...a
      };
      for (const r of n)
        delete a[r];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && n === o.substring(0, n.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class _p {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ht.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Ea(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Ea(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (ie(t) && t.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((o) => {
      if (n) return;
      const a = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((o) => {
      if (n) return;
      const a = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(a)) return n = a;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return n = r;
      n = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), ie(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let o = t[n];
    return o || (o = t[this.getScriptPartFromCode(n)]), o || (o = t[this.formatLanguageCode(n)]), o || (o = t[this.getLanguagePartFromCode(n)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, n) {
    const o = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], t), a = [], r = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return ie(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : ie(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      a.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), a;
  }
}
const wp = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, kp = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class nR {
  constructor(t, n = {}) {
    this.languageUtils = t, this.options = n, this.logger = Ht.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, n = {}) {
    const o = Ea(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: a
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: a
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), kp;
      if (!t.match(/-|_/)) return kp;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(l, n);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, n, o = {}) {
    return this.getSuffixes(t, o).map((a) => `${n}${a}`);
  }
  getSuffixes(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o ? o.resolvedOptions().pluralCategories.sort((a, r) => wp[a] - wp[r]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : [];
  }
  getSuffix(t, n, o = {}) {
    const a = this.getRule(t, o);
    return a ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", n, o));
  }
}
const xp = (e, t, n, o = ".", a = !0) => {
  let r = Kj(e, t, n);
  return !r && a && ie(n) && (r = dc(e, n, o), r === void 0 && (r = dc(t, n, o))), r;
}, pl = (e) => e.replace(/\$/g, "$$$$");
class oR {
  constructor(t = {}) {
    this.logger = Ht.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: o,
      useRawValueToEscape: a,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: m,
      nestingPrefixEscaped: f,
      nestingSuffix: g,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: y
    } = t.interpolation;
    this.escape = n !== void 0 ? n : Zj, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = r ? ko(r) : i || "{{", this.suffix = s ? ko(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = m ? ko(m) : f || ko("$t("), this.nestingSuffix = g ? ko(g) : p || ko(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = y !== void 0 ? y : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, o) => n?.source === o ? (n.lastIndex = 0, n) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, n, o, a) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const w = xp(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(w, void 0, o, {
          ...a,
          ...n,
          interpolationkey: f
        }) : w;
      }
      const g = f.split(this.formatSeparator), p = g.shift().trim(), b = g.join(this.formatSeparator).trim();
      return this.format(xp(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure), b, o, {
        ...a,
        ...n,
        interpolationkey: p
      });
    };
    this.resetRegExp();
    const u = a?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a?.interpolation?.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => pl(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? pl(this.escape(f)) : pl(f)
    }].forEach((f) => {
      for (s = 0; r = f.regex.exec(t); ) {
        const g = r[1].trim();
        if (i = c(g), i === void 0)
          if (typeof u == "function") {
            const b = u(t, r, a);
            i = ie(b) ? b : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, g))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${g} for interpolating ${t}`), i = "";
        else !ie(i) && !this.useRawValueToEscape && (i = pp(i));
        const p = f.safeValue(i);
        if (t = t.replace(r[0], p), d ? (f.regex.lastIndex += i.length, f.regex.lastIndex -= r[0].length) : f.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n, o = {}) {
    let a, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let m = `{${d[1]}`;
      l = d[0], m = this.interpolate(m, i);
      const f = m.match(/'/g), g = m.match(/"/g);
      ((f?.length ?? 0) % 2 === 0 && !g || g.length % 2 !== 0) && (m = m.replace(/'/g, '"'));
      try {
        i = JSON.parse(m), c && (i = {
          ...c,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${m}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !ie(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(a[1]) ? a[1].lastIndexOf("}") + 1 : a[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = a[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), a[1] = a[1].slice(0, c)), r = n(s.call(this, a[1].trim(), i), i), r && a[0] === t && !ie(r)) return r;
      ie(r) || (r = pp(r)), r || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: a[1].trim()
      }), r.trim())), t = t.replace(a[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const aR = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const a = o[1].substring(0, o[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, $p = (e) => {
  const t = {};
  return (n, o, a) => {
    let r = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (r = {
      ...r,
      [a.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Ea(o), a), t[i] = s), s(n);
  };
}, rR = (e) => (t, n, o) => e(Ea(n), o)(t);
class iR {
  constructor(t = {}) {
    this.logger = Ht.create("formatter"), this.options = t, this.init(t);
  }
  init(t, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const o = n.cacheInBuiltFormats ? $p : rR;
    this.formats = {
      number: o((a, r) => {
        const i = new Intl.NumberFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((a, r) => {
        const i = new Intl.NumberFormat(a, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((a, r) => {
        const i = new Intl.DateTimeFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((a, r) => {
        const i = new Intl.RelativeTimeFormat(a, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((a, r) => {
        const i = new Intl.ListFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = $p(n);
  }
  format(t, n, o, a = {}) {
    const r = n.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((s) => s.indexOf(")") > -1)) {
      const s = r.findIndex((l) => l.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, s)].join(this.formatSeparator);
    }
    return r.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = aR(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const m = a?.formatParams?.[a.interpolationkey] || {}, f = m.locale || m.lng || a.locale || a.lng || o;
          d = this.formats[c](s, f, {
            ...u,
            ...a,
            ...m
          });
        } catch (m) {
          this.logger.warn(m);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const sR = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class lR extends fs {
  constructor(t, n, o, a = {}) {
    super(), this.backend = t, this.store = n, this.services = o, this.languageUtils = o.languageUtils, this.options = a, this.logger = Ht.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, a.backend, a);
  }
  queueLoad(t, n, o, a) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const m = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[m] = 2 : this.state[m] < 0 || (this.state[m] === 1 ? i[m] === void 0 && (i[m] = !0) : (this.state[m] = 1, u = !1, i[m] === void 0 && (i[m] = !0), r[m] === void 0 && (r[m] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, o) {
    const a = t.split("|"), r = a[0], i = a[1];
    n && this.emit("failedLoading", r, i, n), !n && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      Hj(l.loaded, [r], i), sR(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, o, a = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: o,
        tried: a,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, o, a + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n, o = {}, a) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    ie(t) && (t = this.languageUtils.toResolveHierarchy(t)), ie(n) && (n = [n]);
    const r = this.queueLoad(t, n, o, a);
    if (!r.toLoad.length)
      return r.pending.length || a(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, n, o) {
    this.prepareLoading(t, n, {}, o);
  }
  reload(t, n, o) {
    this.prepareLoading(t, n, {
      reload: !0
    }, o);
  }
  loadOne(t, n = "") {
    const o = t.split("|"), a = o[0], r = o[1];
    this.read(a, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${r} for language ${a} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${r} for language ${a}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, n, o, a, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, o, a, l) : u = c(t, n, o, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, o, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, o, a);
    }
  }
}
const Sp = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), ie(e[1]) && (t.defaultValue = e[1]), ie(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((o) => {
        t[o] = n[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Cp = (e) => (ie(e.ns) && (e.ns = [e.ns]), ie(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), ie(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), xr = () => {
}, cR = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class Aa extends fs {
  constructor(t = {}, n) {
    if (super(), this.options = Cp(t), this.services = {}, this.logger = Ht, this.modules = {
      external: []
    }, cR(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init(t = {}, n) {
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), t.defaultNS == null && t.ns && (ie(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Sp();
    this.options = {
      ...o,
      ...this.options,
      ...Cp(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const a = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ht.init(a(this.modules.logger), this.options) : Ht.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = iR;
      const u = new _p(this.options);
      this.store = new bp(this.options.resources, this.options);
      const d = this.services;
      d.logger = Ht, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new nR(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = a(c), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new oR(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new lR(a(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (f, ...g) => {
        this.emit(f, ...g);
      }), this.modules.languageDetector && (d.languageDetector = a(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = a(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Si(this.services, this.options), this.translator.on("*", (f, ...g) => {
        this.emit(f, ...g);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = xr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...u) => this.store[c](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...u) => (this.store[c](...u), this);
    });
    const s = ua(), l = () => {
      const c = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(d), n(u, d);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), s;
  }
  loadResources(t, n = xr) {
    let o = n;
    const a = ie(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && r.indexOf(c) < 0 && r.push(c);
        });
      };
      a ? i(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, n, o) {
    const a = ua();
    return typeof t == "function" && (o = t, t = void 0), typeof n == "function" && (o = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), o || (o = xr), this.services.backendConnector.reload(t, n, (r) => {
      a.resolve(), o(r);
    }), a;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && My.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const o = this.languages[n];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, n) {
    this.isLanguageChangingTo = t;
    const o = ua();
    this.emit("languageChanging", t);
    const a = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (a(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), n && n(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = ie(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(ie(s) ? [s] : s);
      c && (this.language || a(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, n, o) {
    const a = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || a.lng, l.lngs = l.lngs || a.lngs, l.ns = l.ns || a.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || a.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = hc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = hc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return ie(t) ? a.lng = t : a.lngs = t, a.ns = n, a.keyPrefix = o, a;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!a || i(r, t)));
  }
  loadNamespaces(t, n) {
    const o = ua();
    return this.options.ns ? (ie(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      o.resolve(), n && n(a);
    }), o) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const o = ua();
    ie(t) && (t = [t]);
    const a = this.options.preload || [], r = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = a.concat(r), this.loadResources((i) => {
      o.resolve(), n && n(i);
    }), o) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const a = new Intl.Locale(t);
      if (a && a.getTextInfo) {
        const r = a.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new _p(Sp());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, n) {
    return new Aa(t, n);
  }
  cloneInstance(t = {}, n = xr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Aa(a);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      r[s] = this[s];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const s = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), l[c]), l), {});
      r.store = new bp(s, a), r.services.resourceStore = r.store;
    }
    return r.translator = new Si(r.services, a), r.translator.on("*", (s, ...l) => {
      r.emit(s, ...l);
    }), r.init(a, n), r.translator.options = a, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const at = Aa.createInstance();
at.createInstance = Aa.createInstance;
const uR = at.createInstance;
at.dir;
at.init;
at.loadResources;
at.reloadResources;
at.use;
at.changeLanguage;
at.getFixedT;
at.t;
at.exists;
at.setDefaultNamespace;
at.hasLoadedNamespace;
at.loadNamespaces;
at.loadLanguages;
const dR = "Studio", hR = "{{count}} soveværelse", pR = "{{count}} soveværelser", mR = "", fR = "{{count}} seng", gR = "{{count}} senge", bR = "Din kalender er blevet opdateret.", vR = "", yR = "", _R = "", wR = "", kR = "", xR = "", $R = "", SR = "", CR = "Annuller", ER = "Datoer", AR = "Slet", OR = "Beskrivelse", zR = "Destination", NR = "Sådan!", jR = "Rediger", RR = "Filtre", IR = "", TR = "", PR = "Gæster", DR = "boliger", LR = "", MR = "Lokation", FR = "Rediger", WR = "Navn", BR = "Næste", VR = "", UR = "", qR = "{{count}} voksne", HR = "", KR = "", GR = "{{count}} babyer", ZR = "", JR = "", YR = "{{count}} børn", XR = "{{count}} gæst", QR = "{{count}} gæst", eI = "{{count}} gæster", tI = "Telefonnummerets format er ikke gyldigt.", nI = "Modtag e-mailnotifikationer", oI = "Gem", aI = "Ingen lokationer fundet", rI = "Rejseliste", iI = "", sI = "valgfrit", lI = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: dR,
  bedroomsNumbers_one: hR,
  bedroomsNumbers_other: pR,
  beds_zero: mR,
  beds_one: fR,
  beds_other: gR,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_calendarUpdated_toast: bR,
  global_calendar_aMonth: vR,
  global_calendar_exactDates: yR,
  global_calendar_oneWeek: _R,
  global_calendar_oneWeekend: wR,
  global_calendar_plusMinusDay_zero: kR,
  global_calendar_plusMinusDay_one: xR,
  global_calendar_plusMinusDay_other: $R,
  global_calendar_twoWeeks: SR,
  global_cancel: CR,
  global_dates: ER,
  global_delete: AR,
  global_description: OR,
  global_destination: zR,
  global_done: NR,
  global_edit: jR,
  global_filters: RR,
  global_fixDates: IR,
  global_flexibleDates: TR,
  global_guests: PR,
  global_homes: DR,
  global_lastMinute: LR,
  global_location: MR,
  global_modify: FR,
  global_name: WR,
  global_next: BR,
  global_numberOfAdults_zero: VR,
  global_numberOfAdults_one: UR,
  global_numberOfAdults_other: qR,
  global_numberOfBabies_zero: HR,
  global_numberOfBabies_one: KR,
  global_numberOfBabies_other: GR,
  global_numberOfChildren_zero: ZR,
  global_numberOfChildren_one: JR,
  global_numberOfChildren_other: YR,
  global_numberOfGuests_zero: XR,
  global_numberOfGuests_one: QR,
  global_numberOfGuests_other: eI,
  global_phoneNumber_notValid: tI,
  global_receiveEmailAlerts: nI,
  global_save: oI,
  global_searchBar_noLocationFound: aI,
  global_travelWishlist: rI,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: iI,
  optional: sI,
  "privacy-policy": "Privatpolitik"
}, cI = "Kontakt os", uI = "FAQ", dI = "Garantier", hI = "GuestPoints", pI = "Hjælp", mI = "Log out", fI = "Messages", gI = "Settings", bI = {
  "about-the-calendar": "Kalenderen",
  "add-home": "Add a home",
  contact: cI,
  faq: uI,
  guarantees: dI,
  guestpoints: hI,
  help: pI,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor meget koster det?",
  logout: mI,
  messages: fI,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: gI,
  "sign-in": "Log ind",
  "sign-up": "Tilmeld dig",
  "sign-up-for-free": "Tilmeld dig gratis",
  "signin.modal.apple-button": "Log ind med Apple",
  "signin.modal.facebook-button": "Log ind med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, vI = "https://www.homeexchange.com/blog/", yI = "/p/general-terms-of-use", _I = "https://www.homeexchange.com/da/p/community-da", wI = "https://homeexchangehelp.zendesk.com/hc/en-us", kI = "", xI = "https://www.homeexchange.com/da/p/service-homeexchange-da", $I = "https://www.homeexchange.com/da/p/guestpoints-da", SI = "https://www.homeexchange.com/da/p/press-da", CI = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", EI = "", AI = "", OI = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", zI = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: vI,
  cgu: yI,
  community: _I,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: wI,
  forum: kI,
  guarantees: xI,
  guestpoints: $I,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: SI,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: CI,
  travelWishlist_faq_links: EI,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: AI,
  values: OI
}, NI = "Studio", jI = "{{count}} schlafzimmer", RI = "{{count}} schlafzimmer", II = "", TI = "{{count}} Bett", PI = "{{count}} Betten", DI = "Ihr Kalender wurde aktualisiert.", LI = "Ein Monat", MI = "Genaue Daten", FI = "Eine Woche", WI = "Ein Wochenende", BI = "", VI = "{{count}} Tag", UI = "{{count}} Tage", qI = "Zwei Wochen", HI = "Abbrechen", KI = "Daten", GI = "Löschen", ZI = "Beschreibung", JI = "Reiseziel", YI = "Fertig!", XI = "Bearbeiten", QI = "Filter", eT = "Feste Daten", tT = "Flexible Daten", nT = "Gäste", oT = "Unterkünfte", aT = "Last Minute", rT = "Ort", iT = "Ändern", sT = "Name", lT = "Weiter", cT = "", uT = "{{count}} Erwachsener", dT = "{{count}} Erwachsene", hT = "", pT = "{{count}} Baby", mT = "{{count}} Babys", fT = "", gT = "{{count}} Kind", bT = "{{count}} Kinder", vT = "{{count}} Gast", yT = "{{count}} Gast", _T = "{{count}} Gäste", wT = "Das Format der Telefonnummer ist ungültig.", kT = "Benachrichtigungen per E-Mail erhalten", xT = "Speichern", $T = "Kein Reiseziel gefunden", ST = "Reiseprojekte", CT = "", ET = "optional", AT = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: NI,
  bedroomsNumbers_one: jI,
  bedroomsNumbers_other: RI,
  beds_zero: II,
  beds_one: TI,
  beds_other: PI,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_calendarUpdated_toast: DI,
  global_calendar_aMonth: LI,
  global_calendar_exactDates: MI,
  global_calendar_oneWeek: FI,
  global_calendar_oneWeekend: WI,
  global_calendar_plusMinusDay_zero: BI,
  global_calendar_plusMinusDay_one: VI,
  global_calendar_plusMinusDay_other: UI,
  global_calendar_twoWeeks: qI,
  global_cancel: HI,
  global_dates: KI,
  global_delete: GI,
  global_description: ZI,
  global_destination: JI,
  global_done: YI,
  global_edit: XI,
  global_filters: QI,
  global_fixDates: eT,
  global_flexibleDates: tT,
  global_guests: nT,
  global_homes: oT,
  global_lastMinute: aT,
  global_location: rT,
  global_modify: iT,
  global_name: sT,
  global_next: lT,
  global_numberOfAdults_zero: cT,
  global_numberOfAdults_one: uT,
  global_numberOfAdults_other: dT,
  global_numberOfBabies_zero: hT,
  global_numberOfBabies_one: pT,
  global_numberOfBabies_other: mT,
  global_numberOfChildren_zero: fT,
  global_numberOfChildren_one: gT,
  global_numberOfChildren_other: bT,
  global_numberOfGuests_zero: vT,
  global_numberOfGuests_one: yT,
  global_numberOfGuests_other: _T,
  global_phoneNumber_notValid: wT,
  global_receiveEmailAlerts: kT,
  global_save: xT,
  global_searchBar_noLocationFound: $T,
  global_travelWishlist: ST,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: CT,
  optional: ET,
  "privacy-policy": "Datenschutz"
}, OT = "Kontaktieren Sie uns", zT = "FAQ", NT = "Garantien", jT = "GuestPoints", RT = "Hilfe", IT = "Log out", TT = "Messages", PT = "Settings", DT = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: OT,
  faq: zT,
  guarantees: NT,
  guestpoints: jT,
  help: RT,
  "how-it-works": "Wie funktioniert es?",
  "how-much-does-it-cost": "Wieviel kostet es?",
  logout: IT,
  messages: TT,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: PT,
  "sign-in": "Einloggen",
  "sign-up": "Anmelden",
  "sign-up-for-free": "Kostenlos anmelden",
  "signin.modal.apple-button": "Melden Sie sich mit Apple an",
  "signin.modal.facebook-button": "Mit Facebook anmelden",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, LT = "https://www.homeexchange.com/de/blog/", MT = "/de/p/homeexchangenutzungsbedingungen", FT = "https://www.homeexchange.com/de/p/our-community-de", WT = "https://homeexchangehelp.zendesk.com/hc/de", BT = "", VT = "https://www.homeexchange.com/de/p/service-homeexchange-de", UT = "https://www.homeexchange.com/de/p/guestpoints-de", qT = "https://www.homeexchange.com/de/p/press-de", HT = "https://www.homeexchange.com/p/worte-homeexchanger", KT = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", GT = "", ZT = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", JT = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: LT,
  cgu: MT,
  community: FT,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: WT,
  forum: BT,
  guarantees: VT,
  guestpoints: UT,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: qT,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: HT,
  travelWishlist_faq_links: KT,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: GT,
  values: ZT
}, YT = "Studio", XT = "{{count}} bedroom", QT = "{{count}} bedrooms", eP = "", tP = "{{count}} bed", nP = "{{count}} beds", oP = "Your calendar has been updated.", aP = "A month", rP = "Exact dates", iP = "One week", sP = "One weekend", lP = "", cP = "± {{count}} day", uP = "± {{count}} days", dP = "Two weeks", hP = "Cancel", pP = "Dates", mP = "Delete", fP = "Description", gP = "Destination", bP = "Done!", vP = "Edit", yP = "Filters", _P = "Fixed dates", wP = "Flexible dates", kP = "Guests", xP = "homes", $P = "Last minute", SP = "Location", CP = "Modify", EP = "Name", AP = "Next", OP = "", zP = "{{count}} adult", NP = "{{count}} adults", jP = "", RP = "{{count}} baby", IP = "{{count}} babies", TP = "", PP = "{{count}} child", DP = "{{count}} children", LP = "{{count}} guest", MP = "{{count}} guest", FP = "{{count}} guests", WP = "The phone number format is not valid", BP = "Receive email alerts", VP = "Save", UP = "No locations found", qP = "Travel wishlist", HP = "No result", KP = "optional", GP = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: YT,
  bedroomsNumbers_one: XT,
  bedroomsNumbers_other: QT,
  beds_zero: eP,
  beds_one: tP,
  beds_other: nP,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_calendarUpdated_toast: oP,
  global_calendar_aMonth: aP,
  global_calendar_exactDates: rP,
  global_calendar_oneWeek: iP,
  global_calendar_oneWeekend: sP,
  global_calendar_plusMinusDay_zero: lP,
  global_calendar_plusMinusDay_one: cP,
  global_calendar_plusMinusDay_other: uP,
  global_calendar_twoWeeks: dP,
  global_cancel: hP,
  global_dates: pP,
  global_delete: mP,
  global_description: fP,
  global_destination: gP,
  global_done: bP,
  global_edit: vP,
  global_filters: yP,
  global_fixDates: _P,
  global_flexibleDates: wP,
  global_guests: kP,
  global_homes: xP,
  global_lastMinute: $P,
  global_location: SP,
  global_modify: CP,
  global_name: EP,
  global_next: AP,
  global_numberOfAdults_zero: OP,
  global_numberOfAdults_one: zP,
  global_numberOfAdults_other: NP,
  global_numberOfBabies_zero: jP,
  global_numberOfBabies_one: RP,
  global_numberOfBabies_other: IP,
  global_numberOfChildren_zero: TP,
  global_numberOfChildren_one: PP,
  global_numberOfChildren_other: DP,
  global_numberOfGuests_zero: LP,
  global_numberOfGuests_one: MP,
  global_numberOfGuests_other: FP,
  global_phoneNumber_notValid: WP,
  global_receiveEmailAlerts: BP,
  global_save: VP,
  global_searchBar_noLocationFound: UP,
  global_travelWishlist: qP,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: HP,
  optional: KP,
  "privacy-policy": "Privacy Policy"
}, ZP = "Contact us", JP = "FAQ", YP = "Guarantees", XP = "GuestPoints", QP = "Help", eD = "Log out", tD = "Messages", nD = "Settings", oD = {
  "about-the-calendar": "Calendar",
  "add-home": "Add a home",
  contact: ZP,
  faq: JP,
  guarantees: YP,
  guestpoints: XP,
  help: QP,
  "how-it-works": "How does it work?",
  "how-much-does-it-cost": "How much does it cost?",
  logout: eD,
  messages: tD,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Complete your home!",
  "notification.home.complete_home_first_time": "Complete your home and earn {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Add availability to your calendar for the coming year",
  "notification.home.new_calendar_type": "New calendar!",
  "notification.home.offline": "Publish your home!",
  "notification.membership.expired": "Membership expired",
  "notification.membership.lead": "Activate your membership and receive {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Complete your profile!",
  "notification.user_profile.motivate_incomplete": "Complete your profile and earn {{gp}} GuestPoints!",
  "refer-your-friends": "Refer your friends",
  settings: nD,
  "sign-in": "Sign in",
  "sign-up": "Sign up",
  "sign-up-for-free": "Sign up for free",
  "signin.modal.apple-button": "Sign in with Apple",
  "signin.modal.facebook-button": "Sign in with Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, aD = "https://www.homeexchange.com/blog/", rD = "/p/general-terms-of-use", iD = "https://www.homeexchange.com/p/community", sD = "https://homeexchangehelp.zendesk.com/hc/en-us", lD = "https://forum.homeexchange.com/c/english/20", cD = "https://www.homeexchange.com/p/service-homeexchange-en", uD = "https://www.homeexchange.com/p/guestpoints-en", dD = "https://www.homeexchange.com/p/press", hD = "https://www.homeexchange.com/p/words-of-homeexchanges", pD = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", mD = "https://www.homeexchange.com/p/where-the-welcome-really-begins", fD = "https://www.homeexchange.com/p/where-the-welcome-really-begins", gD = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: aD,
  cgu: rD,
  community: iD,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: sD,
  forum: lD,
  guarantees: cD,
  guestpoints: uD,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: dD,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: hD,
  travelWishlist_faq_links: pD,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: mD,
  values: fD
}, bD = "Estudio", vD = "{{count}} dormitorio", yD = "{{count}} dormitorios", _D = "", wD = "{{count}} cama", kD = "{{count}} camas", xD = "Tu calendario ha sido actualizado.", $D = "Un mes", SD = "Fechas exactas", CD = "Una semana", ED = "Un fin de semana", AD = "", OD = "± 1:{{count}} día", zD = "± 1:{{count}} días", ND = "Dos semanas", jD = "Cancelar", RD = "Fechas", ID = "Eliminar", TD = "Descripción", PD = "Destino", DD = "¡Listo!", LD = "Editar", MD = "Filtros", FD = "Fechas fijas", WD = "Fechas flexibles", BD = "Invitados", VD = "casas", UD = "Último minuto", qD = "Ubicación", HD = "Modificar", KD = "Nombre", GD = "Siguiente", ZD = "", JD = "{{count}} adulto", YD = "{{count}} adultos", XD = "", QD = "{{count}} bebé", eL = "bebé", tL = "", nL = "{{count}} niño/a", oL = "{{count}} niños", aL = "", rL = "{{count}} invitado/a", iL = "{{count}} invitados", sL = "El formato del número de teléfono no es válido.", lL = "Recibir notificaciones por correo electrónico", cL = "Guardar", uL = "No encontramos este lugar", dL = "Proyectos de viaje", hL = "", pL = "opcional", mL = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: bD,
  bedroomsNumbers_one: vD,
  bedroomsNumbers_other: yD,
  beds_zero: _D,
  beds_one: wD,
  beds_other: kD,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_calendarUpdated_toast: xD,
  global_calendar_aMonth: $D,
  global_calendar_exactDates: SD,
  global_calendar_oneWeek: CD,
  global_calendar_oneWeekend: ED,
  global_calendar_plusMinusDay_zero: AD,
  global_calendar_plusMinusDay_one: OD,
  global_calendar_plusMinusDay_other: zD,
  global_calendar_twoWeeks: ND,
  global_cancel: jD,
  global_dates: RD,
  global_delete: ID,
  global_description: TD,
  global_destination: PD,
  global_done: DD,
  global_edit: LD,
  global_filters: MD,
  global_fixDates: FD,
  global_flexibleDates: WD,
  global_guests: BD,
  global_homes: VD,
  global_lastMinute: UD,
  global_location: qD,
  global_modify: HD,
  global_name: KD,
  global_next: GD,
  global_numberOfAdults_zero: ZD,
  global_numberOfAdults_one: JD,
  global_numberOfAdults_other: YD,
  global_numberOfBabies_zero: XD,
  global_numberOfBabies_one: QD,
  global_numberOfBabies_other: eL,
  global_numberOfChildren_zero: tL,
  global_numberOfChildren_one: nL,
  global_numberOfChildren_other: oL,
  global_numberOfGuests_zero: aL,
  global_numberOfGuests_one: rL,
  global_numberOfGuests_other: iL,
  global_phoneNumber_notValid: sL,
  global_receiveEmailAlerts: lL,
  global_save: cL,
  global_searchBar_noLocationFound: uL,
  global_travelWishlist: dL,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: hL,
  optional: pL,
  "privacy-policy": "Política de Privacidad"
}, fL = "Contacte con nosotros", gL = "Preguntas frecuentes", bL = "Guarantías", vL = "GuestPoints", yL = "Ayuda", _L = "Log out", wL = "Messages", kL = "Settings", xL = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: fL,
  faq: gL,
  guarantees: bL,
  guestpoints: vL,
  help: yL,
  "how-it-works": "¿Cómo funciona?",
  "how-much-does-it-cost": "¿Cuánto cuesta?",
  logout: _L,
  messages: wL,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: kL,
  "sign-in": "Inicia sesión",
  "sign-up": "Regístrate",
  "sign-up-for-free": "Regístrate gratis",
  "signin.modal.apple-button": "Inicia sesión con Apple",
  "signin.modal.facebook-button": "Inicia sesión con Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, $L = "https://www.homeexchange.com/es/blog/", SL = "/es/p/homeexchange-condiciones-de-uso", CL = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", EL = "https://homeexchangehelp.zendesk.com/hc/es", AL = "https://forum.homeexchange.com/c/espanol/22", OL = "https://www.homeexchange.com/es/p/service-homeexchange-es", zL = "https://www.homeexchange.com/es/p/los-guestpoints", NL = "https://www.homeexchange.com/es/p/prensa", jL = "https://www.homeexchange.com/p/palabra-de-homeexchanger", RL = "", IL = "https://www.homeexchange.com/es/p/principios-intercambio-casa", TL = "https://www.homeexchange.com/es/p/principios-intercambio-casa", PL = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: $L,
  cgu: SL,
  community: CL,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: EL,
  forum: AL,
  guarantees: OL,
  guestpoints: zL,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: NL,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: jL,
  travelWishlist_faq_links: RL,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: IL,
  values: TL
}, DL = "Studio", LL = "{{count}} chambre", ML = "{{count}} chambres", FL = "", WL = "{{count}} lit", BL = "{{count}} lits", VL = "Votre calendrier a été mis à jour.", UL = "Un mois", qL = "Dates exactes", HL = "Une semaine", KL = "Un week-end", GL = "Vide", ZL = "± {{count}} jour", JL = "± {{count}} jours", YL = "Deux semaines", XL = "Annuler", QL = "Dates", eM = "Supprimer", tM = "Description", nM = "Destination", oM = "C'est prêt !", aM = "Modifier", rM = "Filtres", iM = "Dates fixes", sM = "Dates flexibles", lM = "Personnes", cM = "maisons", uM = "Dernière minute", dM = "Lieu", hM = "Modifier", pM = "Titre", mM = "Suivant", fM = "Vide", gM = "{{count}} adulte", bM = "{{count}} adultes", vM = "Vide", yM = "{{count}} bébé", _M = "{{count}} bébés", wM = "Vide", kM = "{{count}} enfant", xM = "{{count}} enfants", $M = "{{count}} invité·e", SM = "{{count}} invité·e", CM = "{{count}} invité·es", EM = "Le format du numéro de téléphone est invalide.", AM = "Recevoir des alertes par email", OM = "Sauvegarder", zM = "Aucun lieu trouvé", NM = "Projets de voyage", jM = "", RM = "facultatif", IM = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: DL,
  bedroomsNumbers_one: LL,
  bedroomsNumbers_other: ML,
  beds_zero: FL,
  beds_one: WL,
  beds_other: BL,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_calendarUpdated_toast: VL,
  global_calendar_aMonth: UL,
  global_calendar_exactDates: qL,
  global_calendar_oneWeek: HL,
  global_calendar_oneWeekend: KL,
  global_calendar_plusMinusDay_zero: GL,
  global_calendar_plusMinusDay_one: ZL,
  global_calendar_plusMinusDay_other: JL,
  global_calendar_twoWeeks: YL,
  global_cancel: XL,
  global_dates: QL,
  global_delete: eM,
  global_description: tM,
  global_destination: nM,
  global_done: oM,
  global_edit: aM,
  global_filters: rM,
  global_fixDates: iM,
  global_flexibleDates: sM,
  global_guests: lM,
  global_homes: cM,
  global_lastMinute: uM,
  global_location: dM,
  global_modify: hM,
  global_name: pM,
  global_next: mM,
  global_numberOfAdults_zero: fM,
  global_numberOfAdults_one: gM,
  global_numberOfAdults_other: bM,
  global_numberOfBabies_zero: vM,
  global_numberOfBabies_one: yM,
  global_numberOfBabies_other: _M,
  global_numberOfChildren_zero: wM,
  global_numberOfChildren_one: kM,
  global_numberOfChildren_other: xM,
  global_numberOfGuests_zero: $M,
  global_numberOfGuests_one: SM,
  global_numberOfGuests_other: CM,
  global_phoneNumber_notValid: EM,
  global_receiveEmailAlerts: AM,
  global_save: OM,
  global_searchBar_noLocationFound: zM,
  global_travelWishlist: NM,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: jM,
  optional: RM,
  "privacy-policy": "Charte de vie privée"
}, TM = "Contact", PM = "FAQ", DM = "Garanties", LM = "GuestPoints", MM = "Aide", FM = "Log out", WM = "Messages", BM = "Settings", VM = {
  "about-the-calendar": "Calendrier",
  "add-home": "Add a home",
  contact: TM,
  faq: PM,
  guarantees: DM,
  guestpoints: LM,
  help: MM,
  "how-it-works": "Comment ça marche ?",
  "how-much-does-it-cost": "Combien ça coûte ?",
  logout: FM,
  messages: WM,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: BM,
  "sign-in": "Se connecter",
  "sign-up": "S'inscrire",
  "sign-up-for-free": "Inscrivez-vous gratuitement",
  "signin.modal.apple-button": "Se connecter avec Apple",
  "signin.modal.facebook-button": "Se connecter avec Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, UM = "https://www.homeexchange.fr/blog/", qM = "/p/conditions-generale-d-utilisation", HM = "https://www.homeexchange.fr/p/communaute", KM = "https://homeexchangehelp.zendesk.com/hc/fr", GM = "https://forum.homeexchange.com/c/francais/21", ZM = "https://www.homeexchange.fr/p/service-homeexchange-fr", JM = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", YM = "https://www.homeexchange.fr/p/presse", XM = "https://www.homeexchange.com/p/paroles-homeexchangers", QM = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", e2 = "https://www.homeexchange.fr/p/les-fondamentaux ", t2 = "https://www.homeexchange.fr/p/les-fondamentaux", n2 = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: UM,
  cgu: qM,
  community: HM,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: KM,
  forum: GM,
  guarantees: ZM,
  guestpoints: JM,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: YM,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: XM,
  travelWishlist_faq_links: QM,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: e2,
  values: t2
}, o2 = "Studio", a2 = "{{count}} soba", r2 = "{{count}} sobe", i2 = "{{count}} sobe", s2 = "", l2 = "{{count}} krevet", c2 = "{{count}} kreveti", u2 = "{{count}} kreveti", d2 = "Vaš je kalendar ažuriran.", h2 = "Mjesec", p2 = "Točni datumi", m2 = "Jedan tjedan", f2 = "Jedan vikend", g2 = "dana", b2 = "dan", v2 = "dana", y2 = "± {{count}} dan", _2 = "Dva tjedna", w2 = "Odustani", k2 = "Datumi", x2 = "Izbrišite", $2 = "Opis", S2 = "Odredište", C2 = "Gotovo!", E2 = "Uredite", A2 = "Filtri", O2 = "Fiksni datumi", z2 = "Fleksibilni datumi", N2 = "Gosti", j2 = "domova", R2 = "U zadnji tren", I2 = "Lokacija", T2 = "Uredi", P2 = "", D2 = "Dalje", L2 = "odraslih osoba", M2 = "odrasla osoba", F2 = "odrasle osobe", W2 = "odraslih osoba", B2 = "beba", V2 = "beba", U2 = "bebe", q2 = "beba", H2 = "djece", K2 = "dijete", G2 = "djeteta", Z2 = "djece", J2 = "gostiju", Y2 = "gost", X2 = "gosta", Q2 = "gostiju", eF = "Format telefonskog broja nije valjan.", tF = "Primajte obavijesti e-poštom", nF = "Spremi", oF = "Nema pronađenih lokacija", aF = "Planovi putovanja", rF = "", iF = "nije obavezno", sF = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: o2,
  bedroomsNumbers_one: a2,
  bedroomsNumbers_few: r2,
  bedroomsNumbers_other: i2,
  beds_zero: s2,
  beds_one: l2,
  beds_few: c2,
  beds_other: u2,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_calendarUpdated_toast: d2,
  global_calendar_aMonth: h2,
  global_calendar_exactDates: p2,
  global_calendar_oneWeek: m2,
  global_calendar_oneWeekend: f2,
  global_calendar_plusMinusDay_zero: g2,
  global_calendar_plusMinusDay_one: b2,
  global_calendar_plusMinusDay_few: v2,
  global_calendar_plusMinusDay_other: y2,
  global_calendar_twoWeeks: _2,
  global_cancel: w2,
  global_dates: k2,
  global_delete: x2,
  global_description: $2,
  global_destination: S2,
  global_done: C2,
  global_edit: E2,
  global_filters: A2,
  global_fixDates: O2,
  global_flexibleDates: z2,
  global_guests: N2,
  global_homes: j2,
  global_lastMinute: R2,
  global_location: I2,
  global_modify: T2,
  global_name: P2,
  global_next: D2,
  global_numberOfAdults_zero: L2,
  global_numberOfAdults_one: M2,
  global_numberOfAdults_few: F2,
  global_numberOfAdults_other: W2,
  global_numberOfBabies_zero: B2,
  global_numberOfBabies_one: V2,
  global_numberOfBabies_few: U2,
  global_numberOfBabies_other: q2,
  global_numberOfChildren_zero: H2,
  global_numberOfChildren_one: K2,
  global_numberOfChildren_few: G2,
  global_numberOfChildren_other: Z2,
  global_numberOfGuests_zero: J2,
  global_numberOfGuests_one: Y2,
  global_numberOfGuests_few: X2,
  global_numberOfGuests_other: Q2,
  global_phoneNumber_notValid: eF,
  global_receiveEmailAlerts: tF,
  global_save: nF,
  global_searchBar_noLocationFound: oF,
  global_travelWishlist: aF,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: rF,
  optional: iF,
  "privacy-policy": "Pravila o privatnosti"
}, lF = "Kontaktirajte nas", cF = "FAQ", uF = "Garancije", dF = "GuestPoints", hF = "Pomoć", pF = "Log out", mF = "Messages", fF = "Settings", gF = {
  "about-the-calendar": "Kalendar",
  "add-home": "Add a home",
  contact: lF,
  faq: cF,
  guarantees: uF,
  guestpoints: dF,
  help: hF,
  "how-it-works": "Kako funkcionira?",
  "how-much-does-it-cost": "Koliko košta?",
  logout: pF,
  messages: mF,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: fF,
  "sign-in": "Prijavite se",
  "sign-up": "Registrirajte se",
  "sign-up-for-free": "Prijavite se besplatno",
  "signin.modal.apple-button": "Prijavite se s Apple ID-om",
  "signin.modal.facebook-button": "Prijavite se putem Facebooka",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, bF = "https://www.homeexchange.com/blog/", vF = "/p/general-terms-of-use", yF = "https://www.homeexchange.com/hr/p/zajednica", _F = "https://homeexchangehelp.zendesk.com/hc/en-us", wF = "", kF = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", xF = "https://www.homeexchange.com/hr/p/guestpoints-hr", $F = "https://www.homeexchange.com/hr/p/press-hr", SF = "https://www.homeexchange.com/p/rijeci-homeexchange", CF = "", EF = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", AF = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", OF = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: bF,
  cgu: vF,
  community: yF,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: _F,
  forum: wF,
  guarantees: kF,
  guestpoints: xF,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: $F,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: SF,
  travelWishlist_faq_links: CF,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: EF,
  values: AF
}, zF = "Monolocale", NF = "{{count}} camera da letto", jF = "{{count}} camere da letto", RF = "", IF = "{{count}} letto", TF = "{{count}} letti", PF = "Il tuo calendario è stato aggiornato.", DF = "", LF = "", MF = "", FF = "", WF = "", BF = "", VF = "", UF = "", qF = "Annulla", HF = "Date", KF = "Elimina", GF = "Descrizione", ZF = "Destinazione", JF = "Fatto!", YF = "Modifica", XF = "Filtri", QF = "", e3 = "", t3 = "Ospiti", n3 = "case", o3 = "", a3 = "Posizione", r3 = "Modifica", i3 = "Nome", s3 = "Avanti", l3 = "Zero", c3 = "Uno", u3 = "Altro", d3 = "Zero", h3 = "Uno", p3 = "Altro", m3 = "Zero", f3 = "Uno", g3 = "Altro", b3 = "Zero", v3 = "Uno", y3 = "Altro", _3 = "Il formato del numero di telefono non è valido.", w3 = "Ricevi avvisi via email", k3 = "Salva", x3 = "Nessuna posizione trovata", $3 = "Lista dei programmi di viaggio", S3 = "", C3 = "facoltativo", E3 = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: zF,
  bedroomsNumbers_one: NF,
  bedroomsNumbers_other: jF,
  beds_zero: RF,
  beds_one: IF,
  beds_other: TF,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_calendarUpdated_toast: PF,
  global_calendar_aMonth: DF,
  global_calendar_exactDates: LF,
  global_calendar_oneWeek: MF,
  global_calendar_oneWeekend: FF,
  global_calendar_plusMinusDay_zero: WF,
  global_calendar_plusMinusDay_one: BF,
  global_calendar_plusMinusDay_other: VF,
  global_calendar_twoWeeks: UF,
  global_cancel: qF,
  global_dates: HF,
  global_delete: KF,
  global_description: GF,
  global_destination: ZF,
  global_done: JF,
  global_edit: YF,
  global_filters: XF,
  global_fixDates: QF,
  global_flexibleDates: e3,
  global_guests: t3,
  global_homes: n3,
  global_lastMinute: o3,
  global_location: a3,
  global_modify: r3,
  global_name: i3,
  global_next: s3,
  global_numberOfAdults_zero: l3,
  global_numberOfAdults_one: c3,
  global_numberOfAdults_other: u3,
  global_numberOfBabies_zero: d3,
  global_numberOfBabies_one: h3,
  global_numberOfBabies_other: p3,
  global_numberOfChildren_zero: m3,
  global_numberOfChildren_one: f3,
  global_numberOfChildren_other: g3,
  global_numberOfGuests_zero: b3,
  global_numberOfGuests_one: v3,
  global_numberOfGuests_other: y3,
  global_phoneNumber_notValid: _3,
  global_receiveEmailAlerts: w3,
  global_save: k3,
  global_searchBar_noLocationFound: x3,
  global_travelWishlist: $3,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: S3,
  optional: C3,
  "privacy-policy": "Informativa sulla privacy"
}, A3 = "Contatti", O3 = "Domande frequenti", z3 = "Garanzie", N3 = "GuestPoints", j3 = "Aiuto", R3 = "Log out", I3 = "Messages", T3 = "Settings", P3 = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: A3,
  faq: O3,
  guarantees: z3,
  guestpoints: N3,
  help: j3,
  "how-it-works": "Come funziona?",
  "how-much-does-it-cost": "Quanto costa?",
  logout: R3,
  messages: I3,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: T3,
  "sign-in": "Accedi",
  "sign-up": "Registrati",
  "sign-up-for-free": "Iscriviti gratis",
  "signin.modal.apple-button": "Accedi con Apple",
  "signin.modal.facebook-button": "Accedi tramite Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, D3 = "https://www.homeexchange.it/blog/", L3 = "/p/homeexchange-condizioni-di-uso", M3 = "https://www.homeexchange.it/p/comunita", F3 = "https://homeexchangehelp.zendesk.com/hc/it", W3 = "", B3 = "https://www.homeexchange.it/p/service-homeexchange-it", V3 = "https://www.homeexchange.it/p/guestpoints-it", U3 = "https://www.homeexchange.it/p/stampa", q3 = "https://www.homeexchange.com/p/racconti-homeexchangers", H3 = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", K3 = "", G3 = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", Z3 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: D3,
  cgu: L3,
  community: M3,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: F3,
  forum: W3,
  guarantees: B3,
  guestpoints: V3,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: U3,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: q3,
  travelWishlist_faq_links: H3,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: K3,
  values: G3
}, J3 = "Studio", Y3 = "{{count}} soverom", X3 = "{{count}} soverom", Q3 = "", eW = "{{count}} seng", tW = "{{count}} senger", nW = "", oW = "", aW = "", rW = "", iW = "", sW = "", lW = "", cW = "", uW = "", dW = "", hW = "", pW = "", mW = "", fW = "", gW = "", bW = "", vW = "", yW = "", _W = "", wW = "", kW = "", xW = "", $W = "", SW = "", CW = "", EW = "", AW = "", OW = "", zW = "", NW = "", jW = "", RW = "", IW = "", TW = "", PW = "", DW = "", LW = "", MW = "", FW = "", WW = "", BW = "", VW = "", UW = "", qW = "", HW = "", KW = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: J3,
  bedroomsNumbers_one: Y3,
  bedroomsNumbers_other: X3,
  beds_zero: Q3,
  beds_one: eW,
  beds_other: tW,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: nW,
  global_calendar_aMonth: oW,
  global_calendar_exactDates: aW,
  global_calendar_oneWeek: rW,
  global_calendar_oneWeekend: iW,
  global_calendar_plusMinusDay_zero: sW,
  global_calendar_plusMinusDay_one: lW,
  global_calendar_plusMinusDay_other: cW,
  global_calendar_twoWeeks: uW,
  global_cancel: dW,
  global_dates: hW,
  global_delete: pW,
  global_description: mW,
  global_destination: fW,
  global_done: gW,
  global_edit: bW,
  global_filters: vW,
  global_fixDates: yW,
  global_flexibleDates: _W,
  global_guests: wW,
  global_homes: kW,
  global_lastMinute: xW,
  global_location: $W,
  global_modify: SW,
  global_name: CW,
  global_next: EW,
  global_numberOfAdults_zero: AW,
  global_numberOfAdults_one: OW,
  global_numberOfAdults_other: zW,
  global_numberOfBabies_zero: NW,
  global_numberOfBabies_one: jW,
  global_numberOfBabies_other: RW,
  global_numberOfChildren_zero: IW,
  global_numberOfChildren_one: TW,
  global_numberOfChildren_other: PW,
  global_numberOfGuests_zero: DW,
  global_numberOfGuests_one: LW,
  global_numberOfGuests_other: MW,
  global_phoneNumber_notValid: FW,
  global_receiveEmailAlerts: WW,
  global_save: BW,
  global_searchBar_noLocationFound: VW,
  global_travelWishlist: UW,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: qW,
  optional: HW,
  "privacy-policy": "Personvernpolicy"
}, GW = "Kontakt oss", ZW = "FAQ", JW = "Garantier", YW = "About the Guestpoints", XW = "Hjelp", QW = "Log out", eB = "Messages", tB = "Settings", nB = {
  "about-the-calendar": "About the calendar",
  "add-home": "Add a home",
  contact: GW,
  faq: ZW,
  guarantees: JW,
  guestpoints: YW,
  help: XW,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor mye koster det?",
  logout: QW,
  messages: eB,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: tB,
  "sign-in": "Logg inn",
  "sign-up": "Registrer deg",
  "sign-up-for-free": "Registrer deg gratis",
  "signin.modal.apple-button": "Logg inn med Apple",
  "signin.modal.facebook-button": "Logg inn med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, oB = "https://www.homeexchange.com/blog/", aB = "/p/general-terms-of-use", rB = "https://www.homeexchange.com/nb/p/nettverk", iB = "https://homeexchangehelp.zendesk.com/hc/pt", sB = "", lB = "https://www.homeexchange.com/nb/p/service-homeexchange-no", cB = "https://www.homeexchange.com/nb/p/guestpoints-no", uB = "https://www.homeexchange.com/nb/p/press-no", dB = "https://www.homeexchange.com/p/ifolge-homeexchangers", hB = "", pB = "", mB = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", fB = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: oB,
  cgu: aB,
  community: rB,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: iB,
  forum: sB,
  guarantees: lB,
  guestpoints: cB,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: uB,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: dB,
  travelWishlist_faq_links: hB,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: pB,
  values: mB
}, gB = "Studio", bB = "{{count}} slaapkamer", vB = "{{count}} slaapkamers", yB = "", _B = "{{count}} bed", wB = "{{count}} bedden", kB = "Je kalender is bijgewerkt.", xB = "Een maand", $B = "Exacte data", SB = "Een week", CB = "Een weekend", EB = "", AB = "", OB = "± {{count}} dagen", zB = "Twee weken", NB = "Annuleren", jB = "Data", RB = "Verwijderen", IB = "Beschrijving", TB = "Bestemming", PB = "Klaar!", DB = "Bewerken", LB = "Filters", MB = "Vaste data", FB = "Flexibele data", WB = "Gasten", BB = "huizen", VB = "Last minute", UB = "Locatie", qB = "Wijzigen", HB = "Naam", KB = "Volgende", GB = "", ZB = "{{count}} volwassene", JB = "{{count}} volwassenen", YB = "", XB = "{{count}} baby", QB = "{{count}} baby's", eV = "", tV = "{{count}} kind", nV = "{{count}} kinderen", oV = "", aV = "{{count}} gast", rV = "{{count}} gasten", iV = "De indeling van het telefoonnummer is niet geldig.", sV = "E-mailmeldingen ontvangen", lV = "Opslaan", cV = "Geen locaties gevonden", uV = "Reisplannen", dV = "Geen resultaat", hV = "optioneel", pV = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: gB,
  bedroomsNumbers_one: bB,
  bedroomsNumbers_other: vB,
  beds_zero: yB,
  beds_one: _B,
  beds_other: wB,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_calendarUpdated_toast: kB,
  global_calendar_aMonth: xB,
  global_calendar_exactDates: $B,
  global_calendar_oneWeek: SB,
  global_calendar_oneWeekend: CB,
  global_calendar_plusMinusDay_zero: EB,
  global_calendar_plusMinusDay_one: AB,
  global_calendar_plusMinusDay_other: OB,
  global_calendar_twoWeeks: zB,
  global_cancel: NB,
  global_dates: jB,
  global_delete: RB,
  global_description: IB,
  global_destination: TB,
  global_done: PB,
  global_edit: DB,
  global_filters: LB,
  global_fixDates: MB,
  global_flexibleDates: FB,
  global_guests: WB,
  global_homes: BB,
  global_lastMinute: VB,
  global_location: UB,
  global_modify: qB,
  global_name: HB,
  global_next: KB,
  global_numberOfAdults_zero: GB,
  global_numberOfAdults_one: ZB,
  global_numberOfAdults_other: JB,
  global_numberOfBabies_zero: YB,
  global_numberOfBabies_one: XB,
  global_numberOfBabies_other: QB,
  global_numberOfChildren_zero: eV,
  global_numberOfChildren_one: tV,
  global_numberOfChildren_other: nV,
  global_numberOfGuests_zero: oV,
  global_numberOfGuests_one: aV,
  global_numberOfGuests_other: rV,
  global_phoneNumber_notValid: iV,
  global_receiveEmailAlerts: sV,
  global_save: lV,
  global_searchBar_noLocationFound: cV,
  global_travelWishlist: uV,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: dV,
  optional: hV,
  "privacy-policy": "Privacy"
}, mV = "Neem contact met ons op", fV = "FAQ", gV = "Garanties", bV = "GuestPoints", vV = "Help", yV = "Log out", _V = "Messages", wV = "Settings", kV = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: mV,
  faq: fV,
  guarantees: gV,
  guestpoints: bV,
  help: vV,
  "how-it-works": "Hoe werkt het?",
  "how-much-does-it-cost": "Hoeveel kost het?",
  logout: yV,
  messages: _V,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Voltooi de advertentie van je woning!",
  "notification.home.complete_home_first_time": "Voltooi de advertentie van je huis en ontvang {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Voeg beschikbaarheid toe aan je kalender voor het komende jaar",
  "notification.home.new_calendar_type": "Nieuwe kalender!",
  "notification.home.offline": "Publiceer je huis!",
  "notification.membership.expired": "Lidmaatschap verlopen",
  "notification.membership.lead": "Activeer je lidmaatschap en ontvang {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Voltooi je profiel",
  "notification.user_profile.motivate_incomplete": "Voltooi je profiel en ontvang {{gp}} GuestPoints",
  "refer-your-friends": "Refer your friends",
  settings: wV,
  "sign-in": "Inloggen",
  "sign-up": "Inschrijven",
  "sign-up-for-free": "Meld je gratis aan",
  "signin.modal.apple-button": "Inloggen met Apple",
  "signin.modal.facebook-button": "Meld je aan met Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, xV = "https://www.homeexchange.com/nl/blog/", $V = "/nl/p/homeexchangegebruiksvoorwaarden", SV = "https://www.homeexchange.com/nl/p/gemeenschap", CV = "https://homeexchangehelp.zendesk.com/hc/en-us", EV = "https://forum.homeexchange.com/c/english/20", AV = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", OV = "https://www.homeexchange.com/nl/p/guestpoints-nl", zV = "https://www.homeexchange.com/nl/p/pers", NV = "https://www.homeexchange.com/p/wordsonhomeexchange", jV = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", RV = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", IV = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", TV = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: xV,
  cgu: $V,
  community: SV,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: CV,
  forum: EV,
  guarantees: AV,
  guestpoints: OV,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: zV,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: NV,
  travelWishlist_faq_links: jV,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: RV,
  values: IV
}, PV = "Studio", DV = "{{count}} quarto", LV = "{{count}} quartos", MV = "", FV = "{{count}} cama", WV = "{{count}} camas", BV = "O seu calendário foi atualizado.", VV = "Um mês", UV = "Datas exatas", qV = "Uma semana", HV = "Um fim de semana", KV = "", GV = "± 1:{{count}} dia", ZV = "± {{count]] dias", JV = "Duas semanas", YV = "Cancelar", XV = "Datas", QV = "Eliminar", e4 = "Descrição", t4 = "Destino", n4 = "Feito!", o4 = "Editar", a4 = "Filtros", r4 = "Datas fixas", i4 = "Datas flexíveis", s4 = "Convidados", l4 = "casas", c4 = "Última hora", u4 = "Localização", d4 = "Modificar", h4 = "Nome", p4 = "Seguinte", m4 = "", f4 = "{{count}} adulto", g4 = "{{count}} adultos", b4 = "", v4 = "{{count}} bebé", y4 = "{{count}} bebés", _4 = "", w4 = "{{count}} criança", k4 = "{{count}} crianças", x4 = "", $4 = "{{count}} convidado", S4 = "{{count}} convidados", C4 = "O formato do número de telefone não é válido.", E4 = "Receber alertas por e-mail", A4 = "Guardar", O4 = "Não foram encontradas localizações", z4 = "Ideias de viagens", N4 = "", j4 = "", R4 = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: PV,
  bedroomsNumbers_one: DV,
  bedroomsNumbers_other: LV,
  beds_zero: MV,
  beds_one: FV,
  beds_other: WV,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: BV,
  global_calendar_aMonth: VV,
  global_calendar_exactDates: UV,
  global_calendar_oneWeek: qV,
  global_calendar_oneWeekend: HV,
  global_calendar_plusMinusDay_zero: KV,
  global_calendar_plusMinusDay_one: GV,
  global_calendar_plusMinusDay_other: ZV,
  global_calendar_twoWeeks: JV,
  global_cancel: YV,
  global_dates: XV,
  global_delete: QV,
  global_description: e4,
  global_destination: t4,
  global_done: n4,
  global_edit: o4,
  global_filters: a4,
  global_fixDates: r4,
  global_flexibleDates: i4,
  global_guests: s4,
  global_homes: l4,
  global_lastMinute: c4,
  global_location: u4,
  global_modify: d4,
  global_name: h4,
  global_next: p4,
  global_numberOfAdults_zero: m4,
  global_numberOfAdults_one: f4,
  global_numberOfAdults_other: g4,
  global_numberOfBabies_zero: b4,
  global_numberOfBabies_one: v4,
  global_numberOfBabies_other: y4,
  global_numberOfChildren_zero: _4,
  global_numberOfChildren_one: w4,
  global_numberOfChildren_other: k4,
  global_numberOfGuests_zero: x4,
  global_numberOfGuests_one: $4,
  global_numberOfGuests_other: S4,
  global_phoneNumber_notValid: C4,
  global_receiveEmailAlerts: E4,
  global_save: A4,
  global_searchBar_noLocationFound: O4,
  global_travelWishlist: z4,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: N4,
  optional: j4,
  "privacy-policy": "Privacidade"
}, I4 = "Contacte-nos", T4 = "Perguntas frequentes", P4 = "Guarantias", D4 = "GuestPoints", L4 = "Ajuda", M4 = "Log out", F4 = "Messages", W4 = "Settings", B4 = {
  "about-the-calendar": "Calendário",
  "add-home": "Add a home",
  contact: I4,
  faq: T4,
  guarantees: P4,
  guestpoints: D4,
  help: L4,
  "how-it-works": "Como funciona?",
  "how-much-does-it-cost": "Quanto custa?",
  logout: M4,
  messages: F4,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: W4,
  "sign-in": "Iniciar sessão",
  "sign-up": "Inscreva-se",
  "sign-up-for-free": "Filie-se gratuitamente",
  "signin.modal.apple-button": "Iniciar sessão com a Apple",
  "signin.modal.facebook-button": "Iniciar sessão com o Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, V4 = "https://www.homeexchange.com/pt/blog/", U4 = "/p/general-terms-of-use", q4 = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", H4 = "https://homeexchangehelp.zendesk.com/hc/en-us", K4 = "", G4 = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", Z4 = "https://www.homeexchange.com/pt/p/os-guestpoints", J4 = "https://www.homeexchange.com/pt/p/press-pt", Y4 = "https://www.homeexchange.com/p/palavras-de-homeexchangers", X4 = "", Q4 = "", eU = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", tU = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: V4,
  cgu: U4,
  community: q4,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: H4,
  forum: K4,
  guarantees: G4,
  guestpoints: Z4,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: J4,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Y4,
  travelWishlist_faq_links: X4,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Q4,
  values: eU
}, nU = "Studio", oU = "{{count}} sovrum", aU = "{{count}} sovrum", rU = "", iU = "{{count}} säng", sU = "{{count}} sängar", lU = "", cU = "En månad", uU = "Exakta datum", dU = "En vecka", hU = "En helg", pU = "", mU = "± {{count}} dag", fU = "± {{count}} dagar", gU = "Två veckor", bU = "Avbryt", vU = "Datum", yU = "Ta bort", _U = "Beskrivning", wU = "Resmål", kU = "Klart!", xU = "", $U = "", SU = "Fasta datum", CU = "Flexibla datum", EU = "", AU = "hem", OU = "Sista minuten", zU = "Plats", NU = "Ändra", jU = "Namn", RU = "Nästa", IU = "", TU = "{{count}} vuxen", PU = "{{count}} vuxna", DU = "", LU = "{{count}} bebis", MU = "{{count}} bebisar", FU = "", WU = "{{count}} barn", BU = "{{count}} barn", VU = "{{count}} gäst", UU = "{{count}} gäst", qU = "{{count}} gäster", HU = "Telefonnumrets format är inte giltigt.", KU = "Få e-postaviseringar", GU = "Spara", ZU = "Inga resmål hittades", JU = "", YU = "", XU = "valfritt", QU = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: nU,
  bedroomsNumbers_one: oU,
  bedroomsNumbers_other: aU,
  beds_zero: rU,
  beds_one: iU,
  beds_other: sU,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_calendarUpdated_toast: lU,
  global_calendar_aMonth: cU,
  global_calendar_exactDates: uU,
  global_calendar_oneWeek: dU,
  global_calendar_oneWeekend: hU,
  global_calendar_plusMinusDay_zero: pU,
  global_calendar_plusMinusDay_one: mU,
  global_calendar_plusMinusDay_other: fU,
  global_calendar_twoWeeks: gU,
  global_cancel: bU,
  global_dates: vU,
  global_delete: yU,
  global_description: _U,
  global_destination: wU,
  global_done: kU,
  global_edit: xU,
  global_filters: $U,
  global_fixDates: SU,
  global_flexibleDates: CU,
  global_guests: EU,
  global_homes: AU,
  global_lastMinute: OU,
  global_location: zU,
  global_modify: NU,
  global_name: jU,
  global_next: RU,
  global_numberOfAdults_zero: IU,
  global_numberOfAdults_one: TU,
  global_numberOfAdults_other: PU,
  global_numberOfBabies_zero: DU,
  global_numberOfBabies_one: LU,
  global_numberOfBabies_other: MU,
  global_numberOfChildren_zero: FU,
  global_numberOfChildren_one: WU,
  global_numberOfChildren_other: BU,
  global_numberOfGuests_zero: VU,
  global_numberOfGuests_one: UU,
  global_numberOfGuests_other: qU,
  global_phoneNumber_notValid: HU,
  global_receiveEmailAlerts: KU,
  global_save: GU,
  global_searchBar_noLocationFound: ZU,
  global_travelWishlist: JU,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: YU,
  optional: XU,
  "privacy-policy": "Sekretesspolicy"
}, eq = "Kontakta oss", tq = "FAQ", nq = "Garantier", oq = "GuestPoints", aq = "Hjälp", rq = "Log out", iq = "Messages", sq = "Settings", lq = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: eq,
  faq: tq,
  guarantees: nq,
  guestpoints: oq,
  help: aq,
  "how-it-works": "Hur fungerar det?",
  "how-much-does-it-cost": "Hur mycket kostar det?",
  logout: rq,
  messages: iq,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: sq,
  "sign-in": "Logga in",
  "sign-up": "Registrera dig",
  "sign-up-for-free": "Registrera dig gratis",
  "signin.modal.apple-button": "Logga in med Apple",
  "signin.modal.facebook-button": "Logga in med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, cq = "https://www.homeexchange.com/blog/", uq = "/p/general-terms-of-use", dq = "https://www.homeexchange.com/sv/p/natverket", hq = "https://homeexchangehelp.zendesk.com/hc/es", pq = "", mq = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", fq = "https://www.homeexchange.com/sv/p/guestpoints-sv", gq = "https://www.homeexchange.com/sv/p/press-sv", bq = "https://www.homeexchange.com/p/medlemmarna-har-ordet", vq = "", yq = "", _q = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", wq = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: cq,
  cgu: uq,
  community: dq,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: hq,
  forum: pq,
  guarantees: mq,
  guestpoints: fq,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: gq,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: bq,
  travelWishlist_faq_links: vq,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: yq,
  values: _q
}, kq = "en", Wy = uR({
  fallbackLng: kq,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: lI,
      links: zI,
      header: bI
    },
    de: {
      common: AT,
      links: JT,
      header: DT
    },
    en: {
      common: GP,
      links: gD,
      header: oD
    },
    es: {
      common: mL,
      links: PL,
      header: xL
    },
    fr: {
      common: IM,
      links: n2,
      header: VM
    },
    hr: {
      common: sF,
      links: OF,
      header: gF
    },
    it: {
      common: E3,
      links: Z3,
      header: P3
    },
    nb: {
      common: KW,
      links: fB,
      header: nB
    },
    nl: {
      common: pV,
      links: TV,
      header: kV
    },
    pt: {
      common: R4,
      links: tU,
      header: B4
    },
    sv: {
      common: QU,
      links: wq,
      header: lq
    }
  }
});
Wy.init();
const Ep = Wy;
var xq = /(%?)(%([sdijo]))/g;
function $q(e, t) {
  switch (t) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const n = JSON.stringify(e);
      return n === "{}" || n === "[]" || /^\[object .+?\]$/.test(n) ? e : n;
    }
  }
}
function Hu(e, ...t) {
  if (t.length === 0)
    return e;
  let n = 0, o = e.replace(
    xq,
    (a, r, i, s) => {
      const l = t[n], c = $q(l, s);
      return r ? a : (n++, c);
    }
  );
  return n < t.length && (o += ` ${t.slice(n).join(" ")}`), o = o.replace(/%{2,2}/g, "%"), o;
}
var Sq = 2;
function Cq(e) {
  if (!e.stack)
    return;
  const t = e.stack.split(`
`);
  t.splice(1, Sq), e.stack = t.join(`
`);
}
var Eq = class extends Error {
  constructor(t, ...n) {
    super(t), this.message = t, this.name = "Invariant Violation", this.message = Hu(t, ...n), Cq(this);
  }
}, Ku = (e, t, ...n) => {
  if (!e)
    throw new Eq(t, ...n);
};
Ku.as = (e, t, n, ...o) => {
  if (!t) {
    const a = o.length === 0 ? n : Hu(n, ...o);
    let r;
    try {
      r = Reflect.construct(e, [
        a
      ]);
    } catch {
      r = e(a);
    }
    throw r;
  }
};
const Aq = "[MSW]";
function Gu(e, ...t) {
  const n = Hu(e, ...t);
  return `${Aq} ${n}`;
}
function Oq(e, ...t) {
  console.warn(Gu(e, ...t));
}
function zq(e, ...t) {
  console.error(Gu(e, ...t));
}
const pc = {
  formatMessage: Gu,
  warn: Oq,
  error: zq
};
function Nq() {
  Ku(
    typeof URL < "u",
    pc.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
const jq = /[/\\]msw[/\\]src[/\\](.+)/, Rq = /(node_modules)?[/\\]lib[/\\](core|browser|node|native|iife)[/\\]|^[^/\\]*$/;
function Iq(e) {
  const t = e.stack;
  if (!t)
    return;
  const n = t.split(`
`).slice(1).find((o) => !(jq.test(o) || Rq.test(o)));
  return n ? n.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
}
function Tq(e) {
  return e ? Reflect.has(e, Symbol.iterator) || Reflect.has(e, Symbol.asyncIterator) : !1;
}
class Ci {
  static cache = /* @__PURE__ */ new WeakMap();
  __kind;
  info;
  /**
   * Indicates whether this request handler has been used
   * (its resolver has successfully executed).
   */
  isUsed;
  resolver;
  resolverIterator;
  resolverIteratorResult;
  options;
  constructor(t) {
    this.resolver = t.resolver, this.options = t.options;
    const n = Iq(new Error());
    this.info = {
      ...t.info,
      callFrame: n
    }, this.isUsed = !1, this.__kind = "RequestHandler";
  }
  /**
   * Parse the intercepted request to extract additional information from it.
   * Parsed result is then exposed to other methods of this request handler.
   */
  async parse(t) {
    return {};
  }
  /**
   * Test if this handler matches the given request.
   *
   * This method is not used internally but is exposed
   * as a convenience method for consumers writing custom
   * handlers.
   */
  async test(t) {
    const n = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    return this.predicate({
      request: t.request,
      parsedResult: n,
      resolutionContext: t.resolutionContext
    });
  }
  extendResolverArgs(t) {
    return {};
  }
  // Clone the request instance before it's passed to the handler phases
  // and the response resolver so we can always read it for logging.
  // We only clone it once per request to avoid unnecessary overhead.
  cloneRequestOrGetFromCache(t) {
    const n = Ci.cache.get(t);
    if (typeof n < "u")
      return n;
    const o = t.clone();
    return Ci.cache.set(t, o), o;
  }
  /**
   * Execute this request handler and produce a mocked response
   * using the given resolver function.
   */
  async run(t) {
    if (this.isUsed && this.options?.once)
      return null;
    const n = this.cloneRequestOrGetFromCache(t.request), o = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    if (!await this.predicate({
      request: t.request,
      parsedResult: o,
      resolutionContext: t.resolutionContext
    }) || this.isUsed && this.options?.once)
      return null;
    this.isUsed = !0;
    const a = this.wrapResolver(this.resolver), r = this.extendResolverArgs({
      request: t.request,
      parsedResult: o
    }), i = await a({
      ...r,
      requestId: t.requestId,
      request: t.request
    }).catch((s) => {
      if (s instanceof Response)
        return s;
      throw s;
    });
    return this.createExecutionResult({
      // Pass the cloned request to the result so that logging
      // and other consumers could read its body once more.
      request: n,
      requestId: t.requestId,
      response: i,
      parsedResult: o
    });
  }
  wrapResolver(t) {
    return async (n) => {
      if (!this.resolverIterator) {
        const i = await t(n);
        if (!Tq(i))
          return i;
        this.resolverIterator = Symbol.iterator in i ? i[Symbol.iterator]() : i[Symbol.asyncIterator]();
      }
      this.isUsed = !1;
      const { done: o, value: a } = await this.resolverIterator.next(), r = await a;
      return r && (this.resolverIteratorResult = r.clone()), o ? (this.isUsed = !0, this.resolverIteratorResult?.clone()) : r;
    };
  }
  createExecutionResult(t) {
    return {
      handler: this,
      request: t.request,
      requestId: t.requestId,
      response: t.response,
      parsedResult: t.parsedResult
    };
  }
}
function Pq(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function Dq(e) {
  return e < 300 ? "#69AB32" : e < 400 ? "#F0BB4B" : "#E95F5D";
}
function Lq(e) {
  const t = /* @__PURE__ */ new Date();
  return `${t.getHours().toString().padStart(2, "0")}:${t.getMinutes().toString().padStart(2, "0")}:${t.getSeconds().toString().padStart(2, "0")}`;
}
async function Mq(e) {
  const t = await e.clone().text();
  return {
    url: new URL(e.url),
    method: e.method,
    headers: Object.fromEntries(e.headers.entries()),
    body: t
  };
}
var Fq = Object.create, By = Object.defineProperty, Wq = Object.getOwnPropertyDescriptor, Vy = Object.getOwnPropertyNames, Bq = Object.getPrototypeOf, Vq = Object.prototype.hasOwnProperty, Uy = (e, t) => function() {
  return t || (0, e[Vy(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Uq = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of Vy(t))
      !Vq.call(e, a) && a !== n && By(e, a, { get: () => t[a], enumerable: !(o = Wq(t, a)) || o.enumerable });
  return e;
}, qq = (e, t, n) => (n = e != null ? Fq(Bq(e)) : {}, Uq(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  By(n, "default", { value: e, enumerable: !0 }),
  e
)), Hq = Uy({
  "node_modules/statuses/codes.json"(e, t) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      103: "Early Hints",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a Teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Too Early",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }
}), Kq = Uy({
  "node_modules/statuses/index.js"(e, t) {
    var n = Hq();
    t.exports = s, s.message = n, s.code = o(n), s.codes = a(n), s.redirect = {
      300: !0,
      301: !0,
      302: !0,
      303: !0,
      305: !0,
      307: !0,
      308: !0
    }, s.empty = {
      204: !0,
      205: !0,
      304: !0
    }, s.retry = {
      502: !0,
      503: !0,
      504: !0
    };
    function o(l) {
      var c = {};
      return Object.keys(l).forEach(function(u) {
        var d = l[u], m = Number(u);
        c[d.toLowerCase()] = m;
      }), c;
    }
    function a(l) {
      return Object.keys(l).map(function(c) {
        return Number(c);
      });
    }
    function r(l) {
      var c = l.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(s.code, c))
        throw new Error('invalid status message: "' + l + '"');
      return s.code[c];
    }
    function i(l) {
      if (!Object.prototype.hasOwnProperty.call(s.message, l))
        throw new Error("invalid status code: " + l);
      return s.message[l];
    }
    function s(l) {
      if (typeof l == "number")
        return i(l);
      if (typeof l != "string")
        throw new TypeError("code must be a number or string");
      var c = parseInt(l, 10);
      return isNaN(c) ? r(l) : i(c);
    }
  }
}), Gq = qq(Kq()), qy = Gq.default;
/*! Bundled license information:

statuses/index.js:
  (*!
   * statuses
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
const { message: Zq } = qy;
async function Jq(e) {
  const t = e.clone(), n = await t.text(), o = t.status || 200, a = t.statusText || Zq[o] || "OK";
  return {
    status: o,
    statusText: a,
    headers: Object.fromEntries(t.headers.entries()),
    body: n
  };
}
function Yq(e) {
  for (var t = [], n = 0; n < e.length; ) {
    var o = e[n];
    if (o === "*" || o === "+" || o === "?") {
      t.push({ type: "MODIFIER", index: n, value: e[n++] });
      continue;
    }
    if (o === "\\") {
      t.push({ type: "ESCAPED_CHAR", index: n++, value: e[n++] });
      continue;
    }
    if (o === "{") {
      t.push({ type: "OPEN", index: n, value: e[n++] });
      continue;
    }
    if (o === "}") {
      t.push({ type: "CLOSE", index: n, value: e[n++] });
      continue;
    }
    if (o === ":") {
      for (var a = "", r = n + 1; r < e.length; ) {
        var i = e.charCodeAt(r);
        if (
          // `0-9`
          i >= 48 && i <= 57 || // `A-Z`
          i >= 65 && i <= 90 || // `a-z`
          i >= 97 && i <= 122 || // `_`
          i === 95
        ) {
          a += e[r++];
          continue;
        }
        break;
      }
      if (!a)
        throw new TypeError("Missing parameter name at ".concat(n));
      t.push({ type: "NAME", index: n, value: a }), n = r;
      continue;
    }
    if (o === "(") {
      var s = 1, l = "", r = n + 1;
      if (e[r] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(r));
      for (; r < e.length; ) {
        if (e[r] === "\\") {
          l += e[r++] + e[r++];
          continue;
        }
        if (e[r] === ")") {
          if (s--, s === 0) {
            r++;
            break;
          }
        } else if (e[r] === "(" && (s++, e[r + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(r));
        l += e[r++];
      }
      if (s)
        throw new TypeError("Unbalanced pattern at ".concat(n));
      if (!l)
        throw new TypeError("Missing pattern at ".concat(n));
      t.push({ type: "PATTERN", index: n, value: l }), n = r;
      continue;
    }
    t.push({ type: "CHAR", index: n, value: e[n++] });
  }
  return t.push({ type: "END", index: n, value: "" }), t;
}
function Xq(e, t) {
  t === void 0 && (t = {});
  for (var n = Yq(e), o = t.prefixes, a = o === void 0 ? "./" : o, r = t.delimiter, i = r === void 0 ? "/#?" : r, s = [], l = 0, c = 0, u = "", d = function(C) {
    if (c < n.length && n[c].type === C)
      return n[c++].value;
  }, m = function(C) {
    var A = d(C);
    if (A !== void 0)
      return A;
    var I = n[c], U = I.type, M = I.index;
    throw new TypeError("Unexpected ".concat(U, " at ").concat(M, ", expected ").concat(C));
  }, f = function() {
    for (var C = "", A; A = d("CHAR") || d("ESCAPED_CHAR"); )
      C += A;
    return C;
  }, g = function(C) {
    for (var A = 0, I = i; A < I.length; A++) {
      var U = I[A];
      if (C.indexOf(U) > -1)
        return !0;
    }
    return !1;
  }, p = function(C) {
    var A = s[s.length - 1], I = C || (A && typeof A == "string" ? A : "");
    if (A && !I)
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(A.name, '"'));
    return !I || g(I) ? "[^".concat(Sn(i), "]+?") : "(?:(?!".concat(Sn(I), ")[^").concat(Sn(i), "])+?");
  }; c < n.length; ) {
    var b = d("CHAR"), w = d("NAME"), y = d("PATTERN");
    if (w || y) {
      var _ = b || "";
      a.indexOf(_) === -1 && (u += _, _ = ""), u && (s.push(u), u = ""), s.push({
        name: w || l++,
        prefix: _,
        suffix: "",
        pattern: y || p(_),
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    var k = b || d("ESCAPED_CHAR");
    if (k) {
      u += k;
      continue;
    }
    u && (s.push(u), u = "");
    var x = d("OPEN");
    if (x) {
      var _ = f(), S = d("NAME") || "", $ = d("PATTERN") || "", E = f();
      m("CLOSE"), s.push({
        name: S || ($ ? l++ : ""),
        pattern: S && !$ ? p(_) : $,
        prefix: _,
        suffix: E,
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    m("END");
  }
  return s;
}
function Qq(e, t) {
  var n = [], o = Ky(e, n, t);
  return e6(o, n, t);
}
function e6(e, t, n) {
  n === void 0 && (n = {});
  var o = n.decode, a = o === void 0 ? function(r) {
    return r;
  } : o;
  return function(r) {
    var i = e.exec(r);
    if (!i)
      return !1;
    for (var s = i[0], l = i.index, c = /* @__PURE__ */ Object.create(null), u = function(m) {
      if (i[m] === void 0)
        return "continue";
      var f = t[m - 1];
      f.modifier === "*" || f.modifier === "+" ? c[f.name] = i[m].split(f.prefix + f.suffix).map(function(g) {
        return a(g, f);
      }) : c[f.name] = a(i[m], f);
    }, d = 1; d < i.length; d++)
      u(d);
    return { path: s, index: l, params: c };
  };
}
function Sn(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function Hy(e) {
  return e && e.sensitive ? "" : "i";
}
function t6(e, t) {
  if (!t)
    return e;
  for (var n = /\((?:\?<(.*?)>)?(?!\?)/g, o = 0, a = n.exec(e.source); a; )
    t.push({
      // Use parenthesized substring match if available, index otherwise
      name: a[1] || o++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), a = n.exec(e.source);
  return e;
}
function n6(e, t, n) {
  var o = e.map(function(a) {
    return Ky(a, t, n).source;
  });
  return new RegExp("(?:".concat(o.join("|"), ")"), Hy(n));
}
function o6(e, t, n) {
  return a6(Xq(e, n), t, n);
}
function a6(e, t, n) {
  n === void 0 && (n = {});
  for (var o = n.strict, a = o === void 0 ? !1 : o, r = n.start, i = r === void 0 ? !0 : r, s = n.end, l = s === void 0 ? !0 : s, c = n.encode, u = c === void 0 ? function(A) {
    return A;
  } : c, d = n.delimiter, m = d === void 0 ? "/#?" : d, f = n.endsWith, g = f === void 0 ? "" : f, p = "[".concat(Sn(g), "]|$"), b = "[".concat(Sn(m), "]"), w = i ? "^" : "", y = 0, _ = e; y < _.length; y++) {
    var k = _[y];
    if (typeof k == "string")
      w += Sn(u(k));
    else {
      var x = Sn(u(k.prefix)), S = Sn(u(k.suffix));
      if (k.pattern)
        if (t && t.push(k), x || S)
          if (k.modifier === "+" || k.modifier === "*") {
            var $ = k.modifier === "*" ? "?" : "";
            w += "(?:".concat(x, "((?:").concat(k.pattern, ")(?:").concat(S).concat(x, "(?:").concat(k.pattern, "))*)").concat(S, ")").concat($);
          } else
            w += "(?:".concat(x, "(").concat(k.pattern, ")").concat(S, ")").concat(k.modifier);
        else {
          if (k.modifier === "+" || k.modifier === "*")
            throw new TypeError('Can not repeat "'.concat(k.name, '" without a prefix and suffix'));
          w += "(".concat(k.pattern, ")").concat(k.modifier);
        }
      else
        w += "(?:".concat(x).concat(S, ")").concat(k.modifier);
    }
  }
  if (l)
    a || (w += "".concat(b, "?")), w += n.endsWith ? "(?=".concat(p, ")") : "$";
  else {
    var E = e[e.length - 1], C = typeof E == "string" ? b.indexOf(E[E.length - 1]) > -1 : E === void 0;
    a || (w += "(?:".concat(b, "(?=").concat(p, "))?")), C || (w += "(?=".concat(b, "|").concat(p, ")"));
  }
  return new RegExp(w, Hy(n));
}
function Ky(e, t, n) {
  return e instanceof RegExp ? t6(e, t) : Array.isArray(e) ? n6(e, t, n) : o6(e, t, n);
}
new TextEncoder();
function r6(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
function Ap(e, t) {
  const n = Object.getOwnPropertySymbols(t).find((o) => o.description === e);
  if (n)
    return Reflect.get(t, n);
}
var Ao = class extends Response {
  static isConfigurableStatusCode(e) {
    return e >= 200 && e <= 599;
  }
  static isRedirectResponse(e) {
    return Ao.STATUS_CODES_WITH_REDIRECT.includes(e);
  }
  /**
   * Returns a boolean indicating whether the given response status
   * code represents a response that can have a body.
   */
  static isResponseWithBody(e) {
    return !Ao.STATUS_CODES_WITHOUT_BODY.includes(e);
  }
  static setUrl(e, t) {
    if (!e || e === "about:" || !r6(e))
      return;
    const n = Ap("state", t);
    n ? n.urlList.push(new URL(e)) : Object.defineProperty(t, "url", {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !1
    });
  }
  /**
   * Parses the given raw HTTP headers into a Fetch API `Headers` instance.
   */
  static parseRawHeaders(e) {
    const t = new Headers();
    for (let n = 0; n < e.length; n += 2)
      t.append(e[n], e[n + 1]);
    return t;
  }
  constructor(e, t = {}) {
    var n;
    const o = (n = t.status) != null ? n : 200, a = Ao.isConfigurableStatusCode(o) ? o : 200, r = Ao.isResponseWithBody(o) ? e : null;
    if (super(r, {
      status: a,
      statusText: t.statusText,
      headers: t.headers
    }), o !== a) {
      const i = Ap("state", this);
      i ? i.status = o : Object.defineProperty(this, "status", {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !1
      });
    }
    Ao.setUrl(t.url, this);
  }
}, Gy = Ao;
Gy.STATUS_CODES_WITHOUT_BODY = [101, 103, 204, 205, 304];
Gy.STATUS_CODES_WITH_REDIRECT = [301, 302, 303, 307, 308];
function Zy() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const e = process.type;
    return e === "renderer" || e === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var i6 = Object.defineProperty, s6 = (e, t) => {
  for (var n in t)
    i6(e, n, { get: t[n], enumerable: !0 });
}, l6 = {};
s6(l6, {
  blue: () => u6,
  gray: () => d6,
  green: () => p6,
  red: () => h6,
  yellow: () => c6
});
function c6(e) {
  return `\x1B[33m${e}\x1B[0m`;
}
function u6(e) {
  return `\x1B[34m${e}\x1B[0m`;
}
function d6(e) {
  return `\x1B[90m${e}\x1B[0m`;
}
function h6(e) {
  return `\x1B[31m${e}\x1B[0m`;
}
function p6(e) {
  return `\x1B[32m${e}\x1B[0m`;
}
Zy();
function m6(e, t = !0) {
  return [t && e.origin, e.pathname].filter(Boolean).join("");
}
const f6 = /[?|#].*$/g;
function g6(e) {
  return new URL(`/${e}`, "http://localhost").searchParams;
}
function Jy(e) {
  return e.endsWith("?") ? e : e.replace(f6, "");
}
function b6(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function v6(e, t) {
  if (b6(e) || e.startsWith("*"))
    return e;
  const n = t || typeof location < "u" && location.href;
  return n ? (
    // Encode and decode the path to preserve escaped characters.
    decodeURI(new URL(encodeURI(e), n).href)
  ) : e;
}
function y6(e, t) {
  if (e instanceof RegExp)
    return e;
  const n = v6(e, t);
  return Jy(n);
}
function _6(e) {
  return e.replace(
    /([:a-zA-Z_-]*)(\*{1,2})+/g,
    (t, n, o) => {
      const a = "(.*)";
      return n ? n.startsWith(":") ? `${n}${o}` : `${n}${a}` : a;
    }
  ).replace(/([^/])(:)(?=\d+)/, "$1\\$2").replace(/^([^/]+)(:)(?=\/\/)/, "$1\\$2");
}
function w6(e, t, n) {
  const o = y6(t, n), a = typeof o == "string" ? _6(o) : o, r = m6(e), i = Qq(a, { decode: decodeURIComponent })(r), s = i && i.params || {};
  return {
    matches: i !== !1,
    params: s
  };
}
function k6(e) {
  if (typeof location > "u")
    return e.toString();
  const t = e instanceof URL ? e : new URL(e);
  return t.origin === location.origin ? t.pathname : t.origin + t.pathname;
}
var x6 = Object.create, Yy = Object.defineProperty, $6 = Object.getOwnPropertyDescriptor, Xy = Object.getOwnPropertyNames, S6 = Object.getPrototypeOf, C6 = Object.prototype.hasOwnProperty, E6 = (e, t) => function() {
  return t || (0, e[Xy(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, A6 = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of Xy(t))
      !C6.call(e, a) && a !== n && Yy(e, a, { get: () => t[a], enumerable: !(o = $6(t, a)) || o.enumerable });
  return e;
}, O6 = (e, t, n) => (n = e != null ? x6(S6(e)) : {}, A6(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Yy(n, "default", { value: e, enumerable: !0 }),
  e
)), z6 = E6({
  "node_modules/cookie/index.js"(e) {
    e.parse = s, e.serialize = u;
    var t = Object.prototype.toString, n = Object.prototype.hasOwnProperty, o = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, a = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, i = /^[\u0020-\u003A\u003D-\u007E]*$/;
    function s(g, p) {
      if (typeof g != "string")
        throw new TypeError("argument str must be a string");
      var b = {}, w = g.length;
      if (w < 2) return b;
      var y = p && p.decode || d, _ = 0, k = 0, x = 0;
      do {
        if (k = g.indexOf("=", _), k === -1) break;
        if (x = g.indexOf(";", _), x === -1)
          x = w;
        else if (k > x) {
          _ = g.lastIndexOf(";", k - 1) + 1;
          continue;
        }
        var S = l(g, _, k), $ = c(g, k, S), E = g.slice(S, $);
        if (!n.call(b, E)) {
          var C = l(g, k + 1, x), A = c(g, x, C);
          g.charCodeAt(C) === 34 && g.charCodeAt(A - 1) === 34 && (C++, A--);
          var I = g.slice(C, A);
          b[E] = f(I, y);
        }
        _ = x + 1;
      } while (_ < w);
      return b;
    }
    function l(g, p, b) {
      do {
        var w = g.charCodeAt(p);
        if (w !== 32 && w !== 9) return p;
      } while (++p < b);
      return b;
    }
    function c(g, p, b) {
      for (; p > b; ) {
        var w = g.charCodeAt(--p);
        if (w !== 32 && w !== 9) return p + 1;
      }
      return b;
    }
    function u(g, p, b) {
      var w = b && b.encode || encodeURIComponent;
      if (typeof w != "function")
        throw new TypeError("option encode is invalid");
      if (!o.test(g))
        throw new TypeError("argument name is invalid");
      var y = w(p);
      if (!a.test(y))
        throw new TypeError("argument val is invalid");
      var _ = g + "=" + y;
      if (!b) return _;
      if (b.maxAge != null) {
        var k = Math.floor(b.maxAge);
        if (!isFinite(k))
          throw new TypeError("option maxAge is invalid");
        _ += "; Max-Age=" + k;
      }
      if (b.domain) {
        if (!r.test(b.domain))
          throw new TypeError("option domain is invalid");
        _ += "; Domain=" + b.domain;
      }
      if (b.path) {
        if (!i.test(b.path))
          throw new TypeError("option path is invalid");
        _ += "; Path=" + b.path;
      }
      if (b.expires) {
        var x = b.expires;
        if (!m(x) || isNaN(x.valueOf()))
          throw new TypeError("option expires is invalid");
        _ += "; Expires=" + x.toUTCString();
      }
      if (b.httpOnly && (_ += "; HttpOnly"), b.secure && (_ += "; Secure"), b.partitioned && (_ += "; Partitioned"), b.priority) {
        var S = typeof b.priority == "string" ? b.priority.toLowerCase() : b.priority;
        switch (S) {
          case "low":
            _ += "; Priority=Low";
            break;
          case "medium":
            _ += "; Priority=Medium";
            break;
          case "high":
            _ += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (b.sameSite) {
        var $ = typeof b.sameSite == "string" ? b.sameSite.toLowerCase() : b.sameSite;
        switch ($) {
          case !0:
            _ += "; SameSite=Strict";
            break;
          case "lax":
            _ += "; SameSite=Lax";
            break;
          case "strict":
            _ += "; SameSite=Strict";
            break;
          case "none":
            _ += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return _;
    }
    function d(g) {
      return g.indexOf("%") !== -1 ? decodeURIComponent(g) : g;
    }
    function m(g) {
      return t.call(g) === "[object Date]";
    }
    function f(g, p) {
      try {
        return p(g);
      } catch {
        return g;
      }
    }
  }
}), N6 = O6(z6()), Qy = N6.default;
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
function j6(e, t) {
  return e.endsWith(t) ? e.length === t.length || e[e.length - t.length - 1] === "." : !1;
}
function R6(e, t) {
  const n = e.length - t.length - 2, o = e.lastIndexOf(".", n);
  return o === -1 ? e : e.slice(o + 1);
}
function I6(e, t, n) {
  if (n.validHosts !== null) {
    const a = n.validHosts;
    for (const r of a)
      if (
        /*@__INLINE__*/
        j6(t, r)
      )
        return r;
  }
  let o = 0;
  if (t.startsWith("."))
    for (; o < t.length && t[o] === "."; )
      o += 1;
  return e.length === t.length - o ? null : (
    /*@__INLINE__*/
    R6(t, e)
  );
}
function Op(e, t) {
  let n = 0, o = e.length, a = !1;
  if (!t) {
    if (e.startsWith("data:"))
      return null;
    for (; n < e.length && e.charCodeAt(n) <= 32; )
      n += 1;
    for (; o > n + 1 && e.charCodeAt(o - 1) <= 32; )
      o -= 1;
    if (e.charCodeAt(n) === 47 && e.charCodeAt(n + 1) === 47)
      n += 2;
    else {
      const c = e.indexOf(":/", n);
      if (c !== -1) {
        const u = c - n, d = e.charCodeAt(n), m = e.charCodeAt(n + 1), f = e.charCodeAt(n + 2), g = e.charCodeAt(n + 3), p = e.charCodeAt(n + 4);
        if (!(u === 5 && d === 104 && m === 116 && f === 116 && g === 112 && p === 115) && !(u === 4 && d === 104 && m === 116 && f === 116 && g === 112) && !(u === 3 && d === 119 && m === 115 && f === 115) && !(u === 2 && d === 119 && m === 115))
          for (let b = n; b < c; b += 1) {
            const w = e.charCodeAt(b) | 32;
            if (!(w >= 97 && w <= 122 || // [a, z]
            w >= 48 && w <= 57 || // [0, 9]
            w === 46 || // '.'
            w === 45 || // '-'
            w === 43))
              return null;
          }
        for (n = c + 2; e.charCodeAt(n) === 47; )
          n += 1;
      }
    }
    let i = -1, s = -1, l = -1;
    for (let c = n; c < o; c += 1) {
      const u = e.charCodeAt(c);
      if (u === 35 || // '#'
      u === 47 || // '/'
      u === 63) {
        o = c;
        break;
      } else u === 64 ? i = c : u === 93 ? s = c : u === 58 ? l = c : u >= 65 && u <= 90 && (a = !0);
    }
    if (i !== -1 && i > n && i < o && (n = i + 1), e.charCodeAt(n) === 91)
      return s !== -1 ? e.slice(n + 1, s).toLowerCase() : null;
    l !== -1 && l > n && l < o && (o = l);
  }
  for (; o > n + 1 && e.charCodeAt(o - 1) === 46; )
    o -= 1;
  const r = n !== 0 || o !== e.length ? e.slice(n, o) : e;
  return a ? r.toLowerCase() : r;
}
function T6(e) {
  if (e.length < 7 || e.length > 15)
    return !1;
  let t = 0;
  for (let n = 0; n < e.length; n += 1) {
    const o = e.charCodeAt(n);
    if (o === 46)
      t += 1;
    else if (o < 48 || o > 57)
      return !1;
  }
  return t === 3 && e.charCodeAt(0) !== 46 && e.charCodeAt(e.length - 1) !== 46;
}
function P6(e) {
  if (e.length < 3)
    return !1;
  let t = e.startsWith("[") ? 1 : 0, n = e.length;
  if (e[n - 1] === "]" && (n -= 1), n - t > 39)
    return !1;
  let o = !1;
  for (; t < n; t += 1) {
    const a = e.charCodeAt(t);
    if (a === 58)
      o = !0;
    else if (!(a >= 48 && a <= 57 || // 0-9
    a >= 97 && a <= 102 || // a-f
    a >= 65 && a <= 90))
      return !1;
  }
  return o;
}
function D6(e) {
  return P6(e) || T6(e);
}
function zp(e) {
  return e >= 97 && e <= 122 || e >= 48 && e <= 57 || e > 127;
}
function Np(e) {
  if (e.length > 255 || e.length === 0 || /*@__INLINE__*/
  !zp(e.charCodeAt(0)) && e.charCodeAt(0) !== 46 && // '.' (dot)
  e.charCodeAt(0) !== 95)
    return !1;
  let t = -1, n = -1;
  const o = e.length;
  for (let a = 0; a < o; a += 1) {
    const r = e.charCodeAt(a);
    if (r === 46) {
      if (
        // Check that previous label is < 63 bytes long (64 = 63 + '.')
        a - t > 64 || // Check that previous character was not already a '.'
        n === 46 || // Check that the previous label does not end with a '-' (dash)
        n === 45 || // Check that the previous label does not end with a '_' (underscore)
        n === 95
      )
        return !1;
      t = a;
    } else if (!/*@__INLINE__*/
    (zp(r) || r === 45 || r === 95))
      return !1;
    n = r;
  }
  return (
    // Check that last label is shorter than 63 chars
    o - t - 1 <= 63 && // Check that the last character is an allowed trailing label character.
    // Since we already checked that the char is a valid hostname character,
    // we only need to check that it's different from '-'.
    n !== 45
  );
}
function e_({ allowIcannDomains: e = !0, allowPrivateDomains: t = !1, detectIp: n = !0, extractHostname: o = !0, mixedInputs: a = !0, validHosts: r = null, validateHostname: i = !0 }) {
  return {
    allowIcannDomains: e,
    allowPrivateDomains: t,
    detectIp: n,
    extractHostname: o,
    mixedInputs: a,
    validHosts: r,
    validateHostname: i
  };
}
const L6 = (
  /*@__INLINE__*/
  e_({})
);
function M6(e) {
  return e === void 0 ? L6 : (
    /*@__INLINE__*/
    e_(e)
  );
}
function F6() {
  return {
    domain: null,
    domainWithoutSuffix: null,
    hostname: null,
    isIcann: null,
    isIp: null,
    isPrivate: null,
    publicSuffix: null,
    subdomain: null
  };
}
function W6(e) {
  e.domain = null, e.domainWithoutSuffix = null, e.hostname = null, e.isIcann = null, e.isIp = null, e.isPrivate = null, e.publicSuffix = null, e.subdomain = null;
}
function B6(e, t, n, o, a) {
  const r = (
    /*@__INLINE__*/
    M6(o)
  );
  return typeof e != "string" || (r.extractHostname ? r.mixedInputs ? a.hostname = Op(e, Np(e)) : a.hostname = Op(e, !1) : a.hostname = e, r.detectIp && a.hostname !== null && (a.isIp = D6(a.hostname), a.isIp)) ? a : r.validateHostname && r.extractHostname && a.hostname !== null && !Np(a.hostname) ? (a.hostname = null, a) : (a.hostname === null || (n(a.hostname, r, a), a.publicSuffix === null) || (a.domain = I6(a.publicSuffix, a.hostname, r)), a);
}
function V6(e, t, n) {
  if (!t.allowPrivateDomains && e.length > 3) {
    const o = e.length - 1, a = e.charCodeAt(o), r = e.charCodeAt(o - 1), i = e.charCodeAt(o - 2), s = e.charCodeAt(o - 3);
    if (a === 109 && r === 111 && i === 99 && s === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "com", !0;
    if (a === 103 && r === 114 && i === 111 && s === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "org", !0;
    if (a === 117 && r === 100 && i === 101 && s === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "edu", !0;
    if (a === 118 && r === 111 && i === 103 && s === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "gov", !0;
    if (a === 116 && r === 101 && i === 110 && s === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "net", !0;
    if (a === 101 && r === 100 && i === 46)
      return n.isIcann = !0, n.isPrivate = !1, n.publicSuffix = "de", !0;
  }
  return !1;
}
const U6 = /* @__PURE__ */ function() {
  const e = [1, {}], t = [0, { city: e }];
  return [0, { ck: [0, { www: e }], jp: [0, { kawasaki: t, kitakyushu: t, kobe: t, nagoya: t, sapporo: t, sendai: t, yokohama: t }] }];
}(), q6 = /* @__PURE__ */ function() {
  const e = [1, {}], t = [2, {}], n = [1, { com: e, edu: e, gov: e, net: e, org: e }], o = [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e }], a = [0, { "*": t }], r = [2, { s: a }], i = [0, { relay: t }], s = [2, { id: t }], l = [1, { gov: e }], c = [2, { vps: t }], u = [0, { airflow: a, "transfer-webapp": t }], d = [0, { "transfer-webapp": t, "transfer-webapp-fips": t }], m = [0, { notebook: t, studio: t }], f = [0, { labeling: t, notebook: t, studio: t }], g = [0, { notebook: t }], p = [0, { labeling: t, notebook: t, "notebook-fips": t, studio: t }], b = [0, { notebook: t, "notebook-fips": t, studio: t, "studio-fips": t }], w = [0, { shop: t }], y = [0, { "*": e }], _ = [1, { co: t }], k = [0, { objects: t }], x = [2, { nodes: t }], S = [0, { my: t }], $ = [0, { s3: t, "s3-accesspoint": t, "s3-website": t }], E = [0, { s3: t, "s3-accesspoint": t }], C = [0, { direct: t }], A = [0, { "webview-assets": t }], I = [0, { vfs: t, "webview-assets": t }], U = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": A, cloud9: I }], M = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": A, cloud9: I }], z = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": A, cloud9: I }], L = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], q = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-website": t }], K = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: q, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": A, cloud9: I }], Z = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: q, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": A, cloud9: I }], te = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t }], O = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: te, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], N = [0, { auth: t }], T = [0, { auth: t, "auth-fips": t }], W = [0, { "auth-fips": t }], B = [0, { apps: t }], J = [0, { paas: t }], ee = [2, { eu: t }], D = [0, { app: t }], Y = [0, { site: t }], Q = [1, { com: e, edu: e, net: e, org: e }], G = [0, { j: t }], ne = [0, { dyn: t }], V = [2, { web: t }], fe = [1, { co: e, com: e, edu: e, gov: e, net: e, org: e }], X = [0, { p: t }], Ye = [0, { user: t }], Ve = [0, { cdn: t }], Ft = [2, { raw: a }], mt = [0, { cust: t, reservd: t }], In = [0, { cust: t }], Tn = [0, { s3: t }], kt = [1, { biz: e, com: e, edu: e, gov: e, info: e, net: e, org: e }], on = [0, { ipfs: t }], bn = [1, { framer: t }], Pn = [0, { forgot: t }], _e = [1, { gs: e }], ft = [0, { nes: e }], oe = [1, { k12: e, cc: e, lib: e }], Dn = [1, { cc: e }], nr = [1, { cc: e, lib: e }];
  return [0, { ac: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, drr: t, feedback: t, forms: t }], ad: e, ae: [1, { ac: e, co: e, gov: e, mil: e, net: e, org: e, sch: e }], aero: [1, { airline: e, airport: e, "accident-investigation": e, "accident-prevention": e, aerobatic: e, aeroclub: e, aerodrome: e, agents: e, "air-surveillance": e, "air-traffic-control": e, aircraft: e, airtraffic: e, ambulance: e, association: e, author: e, ballooning: e, broker: e, caa: e, cargo: e, catering: e, certification: e, championship: e, charter: e, civilaviation: e, club: e, conference: e, consultant: e, consulting: e, control: e, council: e, crew: e, design: e, dgca: e, educator: e, emergency: e, engine: e, engineer: e, entertainment: e, equipment: e, exchange: e, express: e, federation: e, flight: e, freight: e, fuel: e, gliding: e, government: e, groundhandling: e, group: e, hanggliding: e, homebuilt: e, insurance: e, journal: e, journalist: e, leasing: e, logistics: e, magazine: e, maintenance: e, marketplace: e, media: e, microlight: e, modelling: e, navigation: e, parachuting: e, paragliding: e, "passenger-association": e, pilot: e, press: e, production: e, recreation: e, repbody: e, res: e, research: e, rotorcraft: e, safety: e, scientist: e, services: e, show: e, skydiving: e, software: e, student: e, taxi: e, trader: e, trading: e, trainer: e, union: e, workinggroup: e, works: e }], af: n, ag: [1, { co: e, com: e, net: e, nom: e, org: e, obj: t }], ai: [1, { com: e, net: e, off: e, org: e, uwu: t, framer: t }], al: o, am: [1, { co: e, com: e, commune: e, net: e, org: e, radio: t }], ao: [1, { co: e, ed: e, edu: e, gov: e, gv: e, it: e, og: e, org: e, pb: e }], aq: e, ar: [1, { bet: e, com: e, coop: e, edu: e, gob: e, gov: e, int: e, mil: e, musica: e, mutual: e, net: e, org: e, seg: e, senasa: e, tur: e }], arpa: [1, { e164: e, home: e, "in-addr": e, ip6: e, iris: e, uri: e, urn: e }], as: l, asia: [1, { cloudns: t, daemon: t, dix: t }], at: [1, { 4: t, ac: [1, { sth: e }], co: e, gv: e, or: e, funkfeuer: [0, { wien: t }], futurecms: [0, { "*": t, ex: a, in: a }], futurehosting: t, futuremailing: t, ortsinfo: [0, { ex: a, kunden: a }], biz: t, info: t, "123webseite": t, priv: t, my: t, myspreadshop: t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], au: [1, { asn: e, com: [1, { cloudlets: [0, { mel: t }], myspreadshop: t }], edu: [1, { act: e, catholic: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e }], gov: [1, { qld: e, sa: e, tas: e, vic: e, wa: e }], id: e, net: e, org: e, conf: e, oz: e, act: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e, hrsn: c }], aw: [1, { com: e }], ax: e, az: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, int: e, mil: e, name: e, net: e, org: e, pp: e, pro: e }], ba: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, brendly: w, rs: t }], bb: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, net: e, org: e, store: e, tv: e }], bd: y, be: [1, { ac: e, cloudns: t, webhosting: t, interhostsolutions: [0, { cloud: t }], kuleuven: [0, { ezproxy: t }], "123website": t, myspreadshop: t, transurl: a }], bf: l, bg: [1, { 0: e, 1: e, 2: e, 3: e, 4: e, 5: e, 6: e, 7: e, 8: e, 9: e, a: e, b: e, c: e, d: e, e, f: e, g: e, h: e, i: e, j: e, k: e, l: e, m: e, n: e, o: e, p: e, q: e, r: e, s: e, t: e, u: e, v: e, w: e, x: e, y: e, z: e, barsy: t }], bh: n, bi: [1, { co: e, com: e, edu: e, or: e, org: e }], biz: [1, { activetrail: t, "cloud-ip": t, cloudns: t, jozi: t, dyndns: t, "for-better": t, "for-more": t, "for-some": t, "for-the": t, selfip: t, webhop: t, orx: t, mmafan: t, myftp: t, "no-ip": t, dscloud: t }], bj: [1, { africa: e, agro: e, architectes: e, assur: e, avocats: e, co: e, com: e, eco: e, econo: e, edu: e, info: e, loisirs: e, money: e, net: e, org: e, ote: e, restaurant: e, resto: e, tourism: e, univ: e }], bm: n, bn: [1, { com: e, edu: e, gov: e, net: e, org: e, co: t }], bo: [1, { com: e, edu: e, gob: e, int: e, mil: e, net: e, org: e, tv: e, web: e, academia: e, agro: e, arte: e, blog: e, bolivia: e, ciencia: e, cooperativa: e, democracia: e, deporte: e, ecologia: e, economia: e, empresa: e, indigena: e, industria: e, info: e, medicina: e, movimiento: e, musica: e, natural: e, nombre: e, noticias: e, patria: e, plurinacional: e, politica: e, profesional: e, pueblo: e, revista: e, salud: e, tecnologia: e, tksat: e, transporte: e, wiki: e }], br: [1, { "9guacu": e, abc: e, adm: e, adv: e, agr: e, aju: e, am: e, anani: e, aparecida: e, api: e, app: e, arq: e, art: e, ato: e, b: e, barueri: e, belem: e, bet: e, bhz: e, bib: e, bio: e, blog: e, bmd: e, boavista: e, bsb: e, campinagrande: e, campinas: e, caxias: e, cim: e, cng: e, cnt: e, com: [1, { simplesite: t }], contagem: e, coop: e, coz: e, cri: e, cuiaba: e, curitiba: e, def: e, des: e, det: e, dev: e, ecn: e, eco: e, edu: e, emp: e, enf: e, eng: e, esp: e, etc: e, eti: e, far: e, feira: e, flog: e, floripa: e, fm: e, fnd: e, fortal: e, fot: e, foz: e, fst: e, g12: e, geo: e, ggf: e, goiania: e, gov: [1, { ac: e, al: e, am: e, ap: e, ba: e, ce: e, df: e, es: e, go: e, ma: e, mg: e, ms: e, mt: e, pa: e, pb: e, pe: e, pi: e, pr: e, rj: e, rn: e, ro: e, rr: e, rs: e, sc: e, se: e, sp: e, to: e }], gru: e, ia: e, imb: e, ind: e, inf: e, jab: e, jampa: e, jdf: e, joinville: e, jor: e, jus: e, leg: [1, { ac: t, al: t, am: t, ap: t, ba: t, ce: t, df: t, es: t, go: t, ma: t, mg: t, ms: t, mt: t, pa: t, pb: t, pe: t, pi: t, pr: t, rj: t, rn: t, ro: t, rr: t, rs: t, sc: t, se: t, sp: t, to: t }], leilao: e, lel: e, log: e, londrina: e, macapa: e, maceio: e, manaus: e, maringa: e, mat: e, med: e, mil: e, morena: e, mp: e, mus: e, natal: e, net: e, niteroi: e, nom: y, not: e, ntr: e, odo: e, ong: e, org: e, osasco: e, palmas: e, poa: e, ppg: e, pro: e, psc: e, psi: e, pvh: e, qsl: e, radio: e, rec: e, recife: e, rep: e, ribeirao: e, rio: e, riobranco: e, riopreto: e, salvador: e, sampa: e, santamaria: e, santoandre: e, saobernardo: e, saogonca: e, seg: e, sjc: e, slg: e, slz: e, social: e, sorocaba: e, srv: e, taxi: e, tc: e, tec: e, teo: e, the: e, tmp: e, trd: e, tur: e, tv: e, udi: e, vet: e, vix: e, vlog: e, wiki: e, xyz: e, zlg: e, tche: t }], bs: [1, { com: e, edu: e, gov: e, net: e, org: e, we: t }], bt: n, bv: e, bw: [1, { ac: e, co: e, gov: e, net: e, org: e }], by: [1, { gov: e, mil: e, com: e, of: e, mediatech: t }], bz: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, za: t, mydns: t, gsj: t }], ca: [1, { ab: e, bc: e, mb: e, nb: e, nf: e, nl: e, ns: e, nt: e, nu: e, on: e, pe: e, qc: e, sk: e, yk: e, gc: e, barsy: t, awdev: a, co: t, "no-ip": t, onid: t, myspreadshop: t, box: t }], cat: e, cc: [1, { cleverapps: t, cloudns: t, ftpaccess: t, "game-server": t, myphotos: t, scrapping: t, twmail: t, csx: t, fantasyleague: t, spawn: [0, { instances: t }] }], cd: l, cf: e, cg: e, ch: [1, { square7: t, cloudns: t, cloudscale: [0, { cust: t, lpg: k, rma: k }], objectstorage: [0, { lpg: t, rma: t }], flow: [0, { ae: [0, { alp1: t }], appengine: t }], "linkyard-cloud": t, gotdns: t, dnsking: t, "123website": t, myspreadshop: t, firenet: [0, { "*": t, svc: a }], "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], ci: [1, { ac: e, "xn--aroport-bya": e, aéroport: e, asso: e, co: e, com: e, ed: e, edu: e, go: e, gouv: e, int: e, net: e, or: e, org: e }], ck: y, cl: [1, { co: e, gob: e, gov: e, mil: e, cloudns: t }], cm: [1, { co: e, com: e, gov: e, net: e }], cn: [1, { ac: e, com: [1, { amazonaws: [0, { "cn-north-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "cn-northwest-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], compute: a, airflow: [0, { "cn-north-1": a, "cn-northwest-1": a }], eb: [0, { "cn-north-1": t, "cn-northwest-1": t }], elb: a }], amazonwebservices: [0, { on: [0, { "cn-north-1": u, "cn-northwest-1": u }] }], sagemaker: [0, { "cn-north-1": m, "cn-northwest-1": m }] }], edu: e, gov: e, mil: e, net: e, org: e, "xn--55qx5d": e, 公司: e, "xn--od0alg": e, 網絡: e, "xn--io0a7i": e, 网络: e, ah: e, bj: e, cq: e, fj: e, gd: e, gs: e, gx: e, gz: e, ha: e, hb: e, he: e, hi: e, hk: e, hl: e, hn: e, jl: e, js: e, jx: e, ln: e, mo: e, nm: e, nx: e, qh: e, sc: e, sd: e, sh: [1, { as: t }], sn: e, sx: e, tj: e, tw: e, xj: e, xz: e, yn: e, zj: e, "canva-apps": t, canvasite: S, myqnapcloud: t, quickconnect: C }], co: [1, { com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, carrd: t, crd: t, otap: a, hidns: t, leadpages: t, lpages: t, mypi: t, xmit: a, firewalledreplit: s, repl: s, supabase: [2, { realtime: t, storage: t }] }], com: [1, { a2hosted: t, cpserver: t, adobeaemcloud: [2, { dev: a }], africa: t, airkitapps: t, "airkitapps-au": t, aivencloud: t, alibabacloudcs: t, kasserver: t, amazonaws: [0, { "af-south-1": U, "ap-east-1": M, "ap-northeast-1": z, "ap-northeast-2": z, "ap-northeast-3": U, "ap-south-1": z, "ap-south-2": L, "ap-southeast-1": z, "ap-southeast-2": z, "ap-southeast-3": L, "ap-southeast-4": L, "ap-southeast-5": [0, { "execute-api": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "ca-central-1": K, "ca-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: q, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], "eu-central-1": z, "eu-central-2": L, "eu-north-1": M, "eu-south-1": U, "eu-south-2": L, "eu-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": A, cloud9: I }], "eu-west-2": M, "eu-west-3": U, "il-central-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": A, cloud9: [0, { vfs: t }] }], "me-central-1": L, "me-south-1": M, "sa-east-1": U, "us-east-1": [2, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: q, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": A, cloud9: I }], "us-east-2": Z, "us-gov-east-1": O, "us-gov-west-1": O, "us-west-1": K, "us-west-2": Z, compute: a, "compute-1": a, airflow: [0, { "af-south-1": a, "ap-east-1": a, "ap-northeast-1": a, "ap-northeast-2": a, "ap-northeast-3": a, "ap-south-1": a, "ap-south-2": a, "ap-southeast-1": a, "ap-southeast-2": a, "ap-southeast-3": a, "ap-southeast-4": a, "ap-southeast-5": a, "ca-central-1": a, "ca-west-1": a, "eu-central-1": a, "eu-central-2": a, "eu-north-1": a, "eu-south-1": a, "eu-south-2": a, "eu-west-1": a, "eu-west-2": a, "eu-west-3": a, "il-central-1": a, "me-central-1": a, "me-south-1": a, "sa-east-1": a, "us-east-1": a, "us-east-2": a, "us-west-1": a, "us-west-2": a }], s3: t, "s3-1": t, "s3-ap-east-1": t, "s3-ap-northeast-1": t, "s3-ap-northeast-2": t, "s3-ap-northeast-3": t, "s3-ap-south-1": t, "s3-ap-southeast-1": t, "s3-ap-southeast-2": t, "s3-ca-central-1": t, "s3-eu-central-1": t, "s3-eu-north-1": t, "s3-eu-west-1": t, "s3-eu-west-2": t, "s3-eu-west-3": t, "s3-external-1": t, "s3-fips-us-gov-east-1": t, "s3-fips-us-gov-west-1": t, "s3-global": [0, { accesspoint: [0, { mrap: t }] }], "s3-me-south-1": t, "s3-sa-east-1": t, "s3-us-east-2": t, "s3-us-gov-east-1": t, "s3-us-gov-west-1": t, "s3-us-west-1": t, "s3-us-west-2": t, "s3-website-ap-northeast-1": t, "s3-website-ap-southeast-1": t, "s3-website-ap-southeast-2": t, "s3-website-eu-west-1": t, "s3-website-sa-east-1": t, "s3-website-us-east-1": t, "s3-website-us-gov-west-1": t, "s3-website-us-west-1": t, "s3-website-us-west-2": t, elb: a }], amazoncognito: [0, { "af-south-1": N, "ap-east-1": N, "ap-northeast-1": N, "ap-northeast-2": N, "ap-northeast-3": N, "ap-south-1": N, "ap-south-2": N, "ap-southeast-1": N, "ap-southeast-2": N, "ap-southeast-3": N, "ap-southeast-4": N, "ap-southeast-5": N, "ap-southeast-7": N, "ca-central-1": N, "ca-west-1": N, "eu-central-1": N, "eu-central-2": N, "eu-north-1": N, "eu-south-1": N, "eu-south-2": N, "eu-west-1": N, "eu-west-2": N, "eu-west-3": N, "il-central-1": N, "me-central-1": N, "me-south-1": N, "mx-central-1": N, "sa-east-1": N, "us-east-1": T, "us-east-2": T, "us-gov-east-1": W, "us-gov-west-1": W, "us-west-1": T, "us-west-2": T }], amplifyapp: t, awsapprunner: a, awsapps: t, elasticbeanstalk: [2, { "af-south-1": t, "ap-east-1": t, "ap-northeast-1": t, "ap-northeast-2": t, "ap-northeast-3": t, "ap-south-1": t, "ap-southeast-1": t, "ap-southeast-2": t, "ap-southeast-3": t, "ca-central-1": t, "eu-central-1": t, "eu-north-1": t, "eu-south-1": t, "eu-west-1": t, "eu-west-2": t, "eu-west-3": t, "il-central-1": t, "me-south-1": t, "sa-east-1": t, "us-east-1": t, "us-east-2": t, "us-gov-east-1": t, "us-gov-west-1": t, "us-west-1": t, "us-west-2": t }], awsglobalaccelerator: t, siiites: t, appspacehosted: t, appspaceusercontent: t, "on-aptible": t, myasustor: t, "balena-devices": t, boutir: t, bplaced: t, cafjs: t, "canva-apps": t, "cdn77-storage": t, br: t, cn: t, de: t, eu: t, jpn: t, mex: t, ru: t, sa: t, uk: t, us: t, za: t, "clever-cloud": [0, { services: a }], dnsabr: t, "ip-ddns": t, jdevcloud: t, wpdevcloud: t, "cf-ipfs": t, "cloudflare-ipfs": t, trycloudflare: t, co: t, devinapps: a, builtwithdark: t, datadetect: [0, { demo: t, instance: t }], dattolocal: t, dattorelay: t, dattoweb: t, mydatto: t, digitaloceanspaces: a, discordsays: t, discordsez: t, drayddns: t, dreamhosters: t, durumis: t, blogdns: t, cechire: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, "dyn-o-saur": t, dynalias: t, "dyndns-at-home": t, "dyndns-at-work": t, "dyndns-blog": t, "dyndns-free": t, "dyndns-home": t, "dyndns-ip": t, "dyndns-mail": t, "dyndns-office": t, "dyndns-pics": t, "dyndns-remote": t, "dyndns-server": t, "dyndns-web": t, "dyndns-wiki": t, "dyndns-work": t, "est-a-la-maison": t, "est-a-la-masion": t, "est-le-patron": t, "est-mon-blogueur": t, "from-ak": t, "from-al": t, "from-ar": t, "from-ca": t, "from-ct": t, "from-dc": t, "from-de": t, "from-fl": t, "from-ga": t, "from-hi": t, "from-ia": t, "from-id": t, "from-il": t, "from-in": t, "from-ks": t, "from-ky": t, "from-ma": t, "from-md": t, "from-mi": t, "from-mn": t, "from-mo": t, "from-ms": t, "from-mt": t, "from-nc": t, "from-nd": t, "from-ne": t, "from-nh": t, "from-nj": t, "from-nm": t, "from-nv": t, "from-oh": t, "from-ok": t, "from-or": t, "from-pa": t, "from-pr": t, "from-ri": t, "from-sc": t, "from-sd": t, "from-tn": t, "from-tx": t, "from-ut": t, "from-va": t, "from-vt": t, "from-wa": t, "from-wi": t, "from-wv": t, "from-wy": t, getmyip: t, gotdns: t, "hobby-site": t, homelinux: t, homeunix: t, iamallama: t, "is-a-anarchist": t, "is-a-blogger": t, "is-a-bookkeeper": t, "is-a-bulls-fan": t, "is-a-caterer": t, "is-a-chef": t, "is-a-conservative": t, "is-a-cpa": t, "is-a-cubicle-slave": t, "is-a-democrat": t, "is-a-designer": t, "is-a-doctor": t, "is-a-financialadvisor": t, "is-a-geek": t, "is-a-green": t, "is-a-guru": t, "is-a-hard-worker": t, "is-a-hunter": t, "is-a-landscaper": t, "is-a-lawyer": t, "is-a-liberal": t, "is-a-libertarian": t, "is-a-llama": t, "is-a-musician": t, "is-a-nascarfan": t, "is-a-nurse": t, "is-a-painter": t, "is-a-personaltrainer": t, "is-a-photographer": t, "is-a-player": t, "is-a-republican": t, "is-a-rockstar": t, "is-a-socialist": t, "is-a-student": t, "is-a-teacher": t, "is-a-techie": t, "is-a-therapist": t, "is-an-accountant": t, "is-an-actor": t, "is-an-actress": t, "is-an-anarchist": t, "is-an-artist": t, "is-an-engineer": t, "is-an-entertainer": t, "is-certified": t, "is-gone": t, "is-into-anime": t, "is-into-cars": t, "is-into-cartoons": t, "is-into-games": t, "is-leet": t, "is-not-certified": t, "is-slick": t, "is-uberleet": t, "is-with-theband": t, "isa-geek": t, "isa-hockeynut": t, issmarterthanyou: t, "likes-pie": t, likescandy: t, "neat-url": t, "saves-the-whales": t, selfip: t, "sells-for-less": t, "sells-for-u": t, servebbs: t, "simple-url": t, "space-to-rent": t, "teaches-yoga": t, writesthisblog: t, ddnsfree: t, ddnsgeek: t, giize: t, gleeze: t, kozow: t, loseyourip: t, ooguy: t, theworkpc: t, mytuleap: t, "tuleap-partners": t, encoreapi: t, evennode: [0, { "eu-1": t, "eu-2": t, "eu-3": t, "eu-4": t, "us-1": t, "us-2": t, "us-3": t, "us-4": t }], onfabrica: t, "fastly-edge": t, "fastly-terrarium": t, "fastvps-server": t, mydobiss: t, firebaseapp: t, fldrv: t, forgeblocks: t, framercanvas: t, "freebox-os": t, freeboxos: t, freemyip: t, aliases121: t, gentapps: t, gentlentapis: t, githubusercontent: t, "0emm": a, appspot: [2, { r: a }], blogspot: t, codespot: t, googleapis: t, googlecode: t, pagespeedmobilizer: t, withgoogle: t, withyoutube: t, grayjayleagues: t, hatenablog: t, hatenadiary: t, herokuapp: t, gr: t, smushcdn: t, wphostedmail: t, wpmucdn: t, pixolino: t, "apps-1and1": t, "live-website": t, "webspace-host": t, dopaas: t, "hosted-by-previder": J, hosteur: [0, { "rag-cloud": t, "rag-cloud-ch": t }], "ik-server": [0, { jcloud: t, "jcloud-ver-jpc": t }], jelastic: [0, { demo: t }], massivegrid: J, wafaicloud: [0, { jed: t, ryd: t }], webadorsite: t, joyent: [0, { cns: a }], "on-forge": t, "on-vapor": t, lpusercontent: t, linode: [0, { members: t, nodebalancer: a }], linodeobjects: a, linodeusercontent: [0, { ip: t }], localtonet: t, lovableproject: t, barsycenter: t, barsyonline: t, lutrausercontent: a, modelscape: t, mwcloudnonprod: t, polyspace: t, mazeplay: t, miniserver: t, atmeta: t, fbsbx: B, meteorapp: ee, routingthecloud: t, "same-app": t, "same-preview": t, mydbserver: t, hostedpi: t, "mythic-beasts": [0, { caracal: t, customer: t, fentiger: t, lynx: t, ocelot: t, oncilla: t, onza: t, sphinx: t, vs: t, x: t, yali: t }], nospamproxy: [0, { cloud: [2, { o365: t }] }], "4u": t, nfshost: t, "3utilities": t, blogsyte: t, ciscofreak: t, damnserver: t, ddnsking: t, ditchyourip: t, dnsiskinky: t, dynns: t, geekgalaxy: t, "health-carereform": t, homesecuritymac: t, homesecuritypc: t, myactivedirectory: t, mysecuritycamera: t, myvnc: t, "net-freaks": t, onthewifi: t, point2this: t, quicksytes: t, securitytactics: t, servebeer: t, servecounterstrike: t, serveexchange: t, serveftp: t, servegame: t, servehalflife: t, servehttp: t, servehumour: t, serveirc: t, servemp3: t, servep2p: t, servepics: t, servequake: t, servesarcasm: t, stufftoread: t, unusualperson: t, workisboring: t, myiphost: t, observableusercontent: [0, { static: t }], simplesite: t, oaiusercontent: a, orsites: t, operaunite: t, "customer-oci": [0, { "*": t, oci: a, ocp: a, ocs: a }], oraclecloudapps: a, oraclegovcloudapps: a, "authgear-staging": t, authgearapps: t, skygearapp: t, outsystemscloud: t, ownprovider: t, pgfog: t, pagexl: t, gotpantheon: t, paywhirl: a, upsunapp: t, "postman-echo": t, prgmr: [0, { xen: t }], "project-study": [0, { dev: t }], pythonanywhere: ee, qa2: t, "alpha-myqnapcloud": t, "dev-myqnapcloud": t, mycloudnas: t, mynascloud: t, myqnapcloud: t, qualifioapp: t, ladesk: t, qualyhqpartner: a, qualyhqportal: a, qbuser: t, quipelements: a, rackmaze: t, "readthedocs-hosted": t, rhcloud: t, onrender: t, render: D, "subsc-pay": t, "180r": t, dojin: t, sakuratan: t, sakuraweb: t, x0: t, code: [0, { builder: a, "dev-builder": a, "stg-builder": a }], salesforce: [0, { platform: [0, { "code-builder-stg": [0, { test: [0, { "001": a }] }] }] }], logoip: t, scrysec: t, "firewall-gateway": t, myshopblocks: t, myshopify: t, shopitsite: t, "1kapp": t, appchizi: t, applinzi: t, sinaapp: t, vipsinaapp: t, streamlitapp: t, "try-snowplow": t, "playstation-cloud": t, myspreadshop: t, "w-corp-staticblitz": t, "w-credentialless-staticblitz": t, "w-staticblitz": t, "stackhero-network": t, stdlib: [0, { api: t }], strapiapp: [2, { media: t }], "streak-link": t, streaklinks: t, streakusercontent: t, "temp-dns": t, dsmynas: t, familyds: t, mytabit: t, taveusercontent: t, "tb-hosting": Y, reservd: t, thingdustdata: t, "townnews-staging": t, typeform: [0, { pro: t }], hk: t, it: t, "deus-canvas": t, vultrobjects: a, wafflecell: t, hotelwithflight: t, "reserve-online": t, cprapid: t, pleskns: t, remotewd: t, wiardweb: [0, { pages: t }], wixsite: t, wixstudio: t, messwithdns: t, "woltlab-demo": t, wpenginepowered: [2, { js: t }], xnbay: [2, { u2: t, "u2-local": t }], yolasite: t }], coop: e, cr: [1, { ac: e, co: e, ed: e, fi: e, go: e, or: e, sa: e }], cu: [1, { com: e, edu: e, gob: e, inf: e, nat: e, net: e, org: e }], cv: [1, { com: e, edu: e, id: e, int: e, net: e, nome: e, org: e, publ: e }], cw: Q, cx: [1, { gov: e, cloudns: t, ath: t, info: t, assessments: t, calculators: t, funnels: t, paynow: t, quizzes: t, researched: t, tests: t }], cy: [1, { ac: e, biz: e, com: [1, { scaleforce: G }], ekloges: e, gov: e, ltd: e, mil: e, net: e, org: e, press: e, pro: e, tm: e }], cz: [1, { gov: e, contentproxy9: [0, { rsc: t }], realm: t, e4: t, co: t, metacentrum: [0, { cloud: a, custom: t }], muni: [0, { cloud: [0, { flt: t, usr: t }] }] }], de: [1, { bplaced: t, square7: t, com: t, cosidns: ne, dnsupdater: t, "dynamisches-dns": t, "internet-dns": t, "l-o-g-i-n": t, ddnss: [2, { dyn: t, dyndns: t }], "dyn-ip24": t, dyndns1: t, "home-webserver": [2, { dyn: t }], "myhome-server": t, dnshome: t, fuettertdasnetz: t, isteingeek: t, istmein: t, lebtimnetz: t, leitungsen: t, traeumtgerade: t, frusky: a, goip: t, "xn--gnstigbestellen-zvb": t, günstigbestellen: t, "xn--gnstigliefern-wob": t, günstigliefern: t, "hs-heilbronn": [0, { it: [0, { pages: t, "pages-research": t }] }], "dyn-berlin": t, "in-berlin": t, "in-brb": t, "in-butter": t, "in-dsl": t, "in-vpn": t, iservschule: t, "mein-iserv": t, schuldock: t, schulplattform: t, schulserver: t, "test-iserv": t, keymachine: t, co: t, "git-repos": t, "lcube-server": t, "svn-repos": t, barsy: t, webspaceconfig: t, "123webseite": t, rub: t, "ruhr-uni-bochum": [2, { noc: [0, { io: t }] }], logoip: t, "firewall-gateway": t, "my-gateway": t, "my-router": t, spdns: t, my: t, speedpartner: [0, { customer: t }], myspreadshop: t, "taifun-dns": t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t, "dd-dns": t, "dray-dns": t, draydns: t, "dyn-vpn": t, dynvpn: t, "mein-vigor": t, "my-vigor": t, "my-wan": t, "syno-ds": t, "synology-diskstation": t, "synology-ds": t, "virtual-user": t, virtualuser: t, "community-pro": t, diskussionsbereich: t }], dj: e, dk: [1, { biz: t, co: t, firm: t, reg: t, store: t, "123hjemmeside": t, myspreadshop: t }], dm: fe, do: [1, { art: e, com: e, edu: e, gob: e, gov: e, mil: e, net: e, org: e, sld: e, web: e }], dz: [1, { art: e, asso: e, com: e, edu: e, gov: e, net: e, org: e, pol: e, soc: e, tm: e }], ec: [1, { abg: e, adm: e, agron: e, arqt: e, art: e, bar: e, chef: e, com: e, cont: e, cpa: e, cue: e, dent: e, dgn: e, disco: e, doc: e, edu: e, eng: e, esm: e, fin: e, fot: e, gal: e, gob: e, gov: e, gye: e, ibr: e, info: e, k12: e, lat: e, loj: e, med: e, mil: e, mktg: e, mon: e, net: e, ntr: e, odont: e, org: e, pro: e, prof: e, psic: e, psiq: e, pub: e, rio: e, rrpp: e, sal: e, tech: e, tul: e, tur: e, uio: e, vet: e, xxx: e, base: t, official: t }], edu: [1, { rit: [0, { "git-pages": t }] }], ee: [1, { aip: e, com: e, edu: e, fie: e, gov: e, lib: e, med: e, org: e, pri: e, riik: e }], eg: [1, { ac: e, com: e, edu: e, eun: e, gov: e, info: e, me: e, mil: e, name: e, net: e, org: e, sci: e, sport: e, tv: e }], er: y, es: [1, { com: e, edu: e, gob: e, nom: e, org: e, "123miweb": t, myspreadshop: t }], et: [1, { biz: e, com: e, edu: e, gov: e, info: e, name: e, net: e, org: e }], eu: [1, { airkitapps: t, cloudns: t, dogado: [0, { jelastic: t }], barsy: t, spdns: t, nxa: a, transurl: a, diskstation: t }], fi: [1, { aland: e, dy: t, "xn--hkkinen-5wa": t, häkkinen: t, iki: t, cloudplatform: [0, { fi: t }], datacenter: [0, { demo: t, paas: t }], kapsi: t, "123kotisivu": t, myspreadshop: t }], fj: [1, { ac: e, biz: e, com: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], fk: y, fm: [1, { com: e, edu: e, net: e, org: e, radio: t, user: a }], fo: e, fr: [1, { asso: e, com: e, gouv: e, nom: e, prd: e, tm: e, avoues: e, cci: e, greta: e, "huissier-justice": e, "en-root": t, "fbx-os": t, fbxos: t, "freebox-os": t, freeboxos: t, goupile: t, "123siteweb": t, "on-web": t, "chirurgiens-dentistes-en-france": t, dedibox: t, aeroport: t, avocat: t, chambagri: t, "chirurgiens-dentistes": t, "experts-comptables": t, medecin: t, notaires: t, pharmacien: t, port: t, veterinaire: t, myspreadshop: t, ynh: t }], ga: e, gb: e, gd: [1, { edu: e, gov: e }], ge: [1, { com: e, edu: e, gov: e, net: e, org: e, pvt: e, school: e }], gf: e, gg: [1, { co: e, net: e, org: e, botdash: t, kaas: t, stackit: t, panel: [2, { daemon: t }] }], gh: [1, { biz: e, com: e, edu: e, gov: e, mil: e, net: e, org: e }], gi: [1, { com: e, edu: e, gov: e, ltd: e, mod: e, org: e }], gl: [1, { co: e, com: e, edu: e, net: e, org: e }], gm: e, gn: [1, { ac: e, com: e, edu: e, gov: e, net: e, org: e }], gov: e, gp: [1, { asso: e, com: e, edu: e, mobi: e, net: e, org: e }], gq: e, gr: [1, { com: e, edu: e, gov: e, net: e, org: e, barsy: t, simplesite: t }], gs: e, gt: [1, { com: e, edu: e, gob: e, ind: e, mil: e, net: e, org: e }], gu: [1, { com: e, edu: e, gov: e, guam: e, info: e, net: e, org: e, web: e }], gw: [1, { nx: t }], gy: fe, hk: [1, { com: e, edu: e, gov: e, idv: e, net: e, org: e, "xn--ciqpn": e, 个人: e, "xn--gmqw5a": e, 個人: e, "xn--55qx5d": e, 公司: e, "xn--mxtq1m": e, 政府: e, "xn--lcvr32d": e, 敎育: e, "xn--wcvs22d": e, 教育: e, "xn--gmq050i": e, 箇人: e, "xn--uc0atv": e, 組織: e, "xn--uc0ay4a": e, 組织: e, "xn--od0alg": e, 網絡: e, "xn--zf0avx": e, 網络: e, "xn--mk0axi": e, 组織: e, "xn--tn0ag": e, 组织: e, "xn--od0aq3b": e, 网絡: e, "xn--io0a7i": e, 网络: e, inc: t, ltd: t }], hm: e, hn: [1, { com: e, edu: e, gob: e, mil: e, net: e, org: e }], hr: [1, { com: e, from: e, iz: e, name: e, brendly: w }], ht: [1, { adult: e, art: e, asso: e, com: e, coop: e, edu: e, firm: e, gouv: e, info: e, med: e, net: e, org: e, perso: e, pol: e, pro: e, rel: e, shop: e, rt: t }], hu: [1, { 2e3: e, agrar: e, bolt: e, casino: e, city: e, co: e, erotica: e, erotika: e, film: e, forum: e, games: e, hotel: e, info: e, ingatlan: e, jogasz: e, konyvelo: e, lakas: e, media: e, news: e, org: e, priv: e, reklam: e, sex: e, shop: e, sport: e, suli: e, szex: e, tm: e, tozsde: e, utazas: e, video: e }], id: [1, { ac: e, biz: e, co: e, desa: e, go: e, kop: e, mil: e, my: e, net: e, or: e, ponpes: e, sch: e, web: e, zone: t }], ie: [1, { gov: e, myspreadshop: t }], il: [1, { ac: e, co: [1, { ravpage: t, mytabit: t, tabitorder: t }], gov: e, idf: e, k12: e, muni: e, net: e, org: e }], "xn--4dbrk0ce": [1, { "xn--4dbgdty6c": e, "xn--5dbhl8d": e, "xn--8dbq2a": e, "xn--hebda8b": e }], ישראל: [1, { אקדמיה: e, ישוב: e, צהל: e, ממשל: e }], im: [1, { ac: e, co: [1, { ltd: e, plc: e }], com: e, net: e, org: e, tt: e, tv: e }], in: [1, { "5g": e, "6g": e, ac: e, ai: e, am: e, bihar: e, biz: e, business: e, ca: e, cn: e, co: e, com: e, coop: e, cs: e, delhi: e, dr: e, edu: e, er: e, firm: e, gen: e, gov: e, gujarat: e, ind: e, info: e, int: e, internet: e, io: e, me: e, mil: e, net: e, nic: e, org: e, pg: e, post: e, pro: e, res: e, travel: e, tv: e, uk: e, up: e, us: e, cloudns: t, barsy: t, web: t, supabase: t }], info: [1, { cloudns: t, "dynamic-dns": t, "barrel-of-knowledge": t, "barrell-of-knowledge": t, dyndns: t, "for-our": t, "groks-the": t, "groks-this": t, "here-for-more": t, knowsitall: t, selfip: t, webhop: t, barsy: t, mayfirst: t, mittwald: t, mittwaldserver: t, typo3server: t, dvrcam: t, ilovecollege: t, "no-ip": t, forumz: t, nsupdate: t, dnsupdate: t, "v-info": t }], int: [1, { eu: e }], io: [1, { 2038: t, co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, "on-acorn": a, myaddr: t, apigee: t, "b-data": t, beagleboard: t, bitbucket: t, bluebite: t, boxfuse: t, brave: r, browsersafetymark: t, bubble: Ve, bubbleapps: t, bigv: [0, { uk0: t }], cleverapps: t, cloudbeesusercontent: t, dappnode: [0, { dyndns: t }], darklang: t, definima: t, dedyn: t, icp0: Ft, icp1: Ft, qzz: t, "fh-muenster": t, shw: t, forgerock: [0, { id: t }], github: t, gitlab: t, lolipop: t, "hasura-app": t, hostyhosting: t, hypernode: t, moonscale: a, beebyte: J, beebyteapp: [0, { sekd1: t }], jele: t, webthings: t, loginline: t, barsy: t, azurecontainer: a, ngrok: [2, { ap: t, au: t, eu: t, in: t, jp: t, sa: t, us: t }], nodeart: [0, { stage: t }], pantheonsite: t, pstmn: [2, { mock: t }], protonet: t, qcx: [2, { sys: a }], qoto: t, vaporcloud: t, myrdbx: t, "rb-hosting": Y, "on-k3s": a, "on-rio": a, readthedocs: t, resindevice: t, resinstaging: [0, { devices: t }], hzc: t, sandcats: t, scrypted: [0, { client: t }], "mo-siemens": t, lair: B, stolos: a, musician: t, utwente: t, edugit: t, telebit: t, thingdust: [0, { dev: mt, disrec: mt, prod: In, testing: mt }], tickets: t, webflow: t, webflowtest: t, editorx: t, wixstudio: t, basicserver: t, virtualserver: t }], iq: o, ir: [1, { ac: e, co: e, gov: e, id: e, net: e, org: e, sch: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, arvanedge: t, vistablog: t }], is: e, it: [1, { edu: e, gov: e, abr: e, abruzzo: e, "aosta-valley": e, aostavalley: e, bas: e, basilicata: e, cal: e, calabria: e, cam: e, campania: e, "emilia-romagna": e, emiliaromagna: e, emr: e, "friuli-v-giulia": e, "friuli-ve-giulia": e, "friuli-vegiulia": e, "friuli-venezia-giulia": e, "friuli-veneziagiulia": e, "friuli-vgiulia": e, "friuliv-giulia": e, "friulive-giulia": e, friulivegiulia: e, "friulivenezia-giulia": e, friuliveneziagiulia: e, friulivgiulia: e, fvg: e, laz: e, lazio: e, lig: e, liguria: e, lom: e, lombardia: e, lombardy: e, lucania: e, mar: e, marche: e, mol: e, molise: e, piedmont: e, piemonte: e, pmn: e, pug: e, puglia: e, sar: e, sardegna: e, sardinia: e, sic: e, sicilia: e, sicily: e, taa: e, tos: e, toscana: e, "trentin-sud-tirol": e, "xn--trentin-sd-tirol-rzb": e, "trentin-süd-tirol": e, "trentin-sudtirol": e, "xn--trentin-sdtirol-7vb": e, "trentin-südtirol": e, "trentin-sued-tirol": e, "trentin-suedtirol": e, trentino: e, "trentino-a-adige": e, "trentino-aadige": e, "trentino-alto-adige": e, "trentino-altoadige": e, "trentino-s-tirol": e, "trentino-stirol": e, "trentino-sud-tirol": e, "xn--trentino-sd-tirol-c3b": e, "trentino-süd-tirol": e, "trentino-sudtirol": e, "xn--trentino-sdtirol-szb": e, "trentino-südtirol": e, "trentino-sued-tirol": e, "trentino-suedtirol": e, "trentinoa-adige": e, trentinoaadige: e, "trentinoalto-adige": e, trentinoaltoadige: e, "trentinos-tirol": e, trentinostirol: e, "trentinosud-tirol": e, "xn--trentinosd-tirol-rzb": e, "trentinosüd-tirol": e, trentinosudtirol: e, "xn--trentinosdtirol-7vb": e, trentinosüdtirol: e, "trentinosued-tirol": e, trentinosuedtirol: e, "trentinsud-tirol": e, "xn--trentinsd-tirol-6vb": e, "trentinsüd-tirol": e, trentinsudtirol: e, "xn--trentinsdtirol-nsb": e, trentinsüdtirol: e, "trentinsued-tirol": e, trentinsuedtirol: e, tuscany: e, umb: e, umbria: e, "val-d-aosta": e, "val-daosta": e, "vald-aosta": e, valdaosta: e, "valle-aosta": e, "valle-d-aosta": e, "valle-daosta": e, valleaosta: e, "valled-aosta": e, valledaosta: e, "vallee-aoste": e, "xn--valle-aoste-ebb": e, "vallée-aoste": e, "vallee-d-aoste": e, "xn--valle-d-aoste-ehb": e, "vallée-d-aoste": e, valleeaoste: e, "xn--valleaoste-e7a": e, valléeaoste: e, valleedaoste: e, "xn--valledaoste-ebb": e, valléedaoste: e, vao: e, vda: e, ven: e, veneto: e, ag: e, agrigento: e, al: e, alessandria: e, "alto-adige": e, altoadige: e, an: e, ancona: e, "andria-barletta-trani": e, "andria-trani-barletta": e, andriabarlettatrani: e, andriatranibarletta: e, ao: e, aosta: e, aoste: e, ap: e, aq: e, aquila: e, ar: e, arezzo: e, "ascoli-piceno": e, ascolipiceno: e, asti: e, at: e, av: e, avellino: e, ba: e, balsan: e, "balsan-sudtirol": e, "xn--balsan-sdtirol-nsb": e, "balsan-südtirol": e, "balsan-suedtirol": e, bari: e, "barletta-trani-andria": e, barlettatraniandria: e, belluno: e, benevento: e, bergamo: e, bg: e, bi: e, biella: e, bl: e, bn: e, bo: e, bologna: e, bolzano: e, "bolzano-altoadige": e, bozen: e, "bozen-sudtirol": e, "xn--bozen-sdtirol-2ob": e, "bozen-südtirol": e, "bozen-suedtirol": e, br: e, brescia: e, brindisi: e, bs: e, bt: e, bulsan: e, "bulsan-sudtirol": e, "xn--bulsan-sdtirol-nsb": e, "bulsan-südtirol": e, "bulsan-suedtirol": e, bz: e, ca: e, cagliari: e, caltanissetta: e, "campidano-medio": e, campidanomedio: e, campobasso: e, "carbonia-iglesias": e, carboniaiglesias: e, "carrara-massa": e, carraramassa: e, caserta: e, catania: e, catanzaro: e, cb: e, ce: e, "cesena-forli": e, "xn--cesena-forl-mcb": e, "cesena-forlì": e, cesenaforli: e, "xn--cesenaforl-i8a": e, cesenaforlì: e, ch: e, chieti: e, ci: e, cl: e, cn: e, co: e, como: e, cosenza: e, cr: e, cremona: e, crotone: e, cs: e, ct: e, cuneo: e, cz: e, "dell-ogliastra": e, dellogliastra: e, en: e, enna: e, fc: e, fe: e, fermo: e, ferrara: e, fg: e, fi: e, firenze: e, florence: e, fm: e, foggia: e, "forli-cesena": e, "xn--forl-cesena-fcb": e, "forlì-cesena": e, forlicesena: e, "xn--forlcesena-c8a": e, forlìcesena: e, fr: e, frosinone: e, ge: e, genoa: e, genova: e, go: e, gorizia: e, gr: e, grosseto: e, "iglesias-carbonia": e, iglesiascarbonia: e, im: e, imperia: e, is: e, isernia: e, kr: e, "la-spezia": e, laquila: e, laspezia: e, latina: e, lc: e, le: e, lecce: e, lecco: e, li: e, livorno: e, lo: e, lodi: e, lt: e, lu: e, lucca: e, macerata: e, mantova: e, "massa-carrara": e, massacarrara: e, matera: e, mb: e, mc: e, me: e, "medio-campidano": e, mediocampidano: e, messina: e, mi: e, milan: e, milano: e, mn: e, mo: e, modena: e, monza: e, "monza-brianza": e, "monza-e-della-brianza": e, monzabrianza: e, monzaebrianza: e, monzaedellabrianza: e, ms: e, mt: e, na: e, naples: e, napoli: e, no: e, novara: e, nu: e, nuoro: e, og: e, ogliastra: e, "olbia-tempio": e, olbiatempio: e, or: e, oristano: e, ot: e, pa: e, padova: e, padua: e, palermo: e, parma: e, pavia: e, pc: e, pd: e, pe: e, perugia: e, "pesaro-urbino": e, pesarourbino: e, pescara: e, pg: e, pi: e, piacenza: e, pisa: e, pistoia: e, pn: e, po: e, pordenone: e, potenza: e, pr: e, prato: e, pt: e, pu: e, pv: e, pz: e, ra: e, ragusa: e, ravenna: e, rc: e, re: e, "reggio-calabria": e, "reggio-emilia": e, reggiocalabria: e, reggioemilia: e, rg: e, ri: e, rieti: e, rimini: e, rm: e, rn: e, ro: e, roma: e, rome: e, rovigo: e, sa: e, salerno: e, sassari: e, savona: e, si: e, siena: e, siracusa: e, so: e, sondrio: e, sp: e, sr: e, ss: e, "xn--sdtirol-n2a": e, südtirol: e, suedtirol: e, sv: e, ta: e, taranto: e, te: e, "tempio-olbia": e, tempioolbia: e, teramo: e, terni: e, tn: e, to: e, torino: e, tp: e, tr: e, "trani-andria-barletta": e, "trani-barletta-andria": e, traniandriabarletta: e, tranibarlettaandria: e, trapani: e, trento: e, treviso: e, trieste: e, ts: e, turin: e, tv: e, ud: e, udine: e, "urbino-pesaro": e, urbinopesaro: e, va: e, varese: e, vb: e, vc: e, ve: e, venezia: e, venice: e, verbania: e, vercelli: e, verona: e, vi: e, "vibo-valentia": e, vibovalentia: e, vicenza: e, viterbo: e, vr: e, vs: e, vt: e, vv: e, "12chars": t, ibxos: t, iliadboxos: t, neen: [0, { jc: t }], "123homepage": t, "16-b": t, "32-b": t, "64-b": t, myspreadshop: t, syncloud: t }], je: [1, { co: e, net: e, org: e, of: t }], jm: y, jo: [1, { agri: e, ai: e, com: e, edu: e, eng: e, fm: e, gov: e, mil: e, net: e, org: e, per: e, phd: e, sch: e, tv: e }], jobs: e, jp: [1, { ac: e, ad: e, co: e, ed: e, go: e, gr: e, lg: e, ne: [1, { aseinet: Ye, gehirn: t, ivory: t, "mail-box": t, mints: t, mokuren: t, opal: t, sakura: t, sumomo: t, topaz: t }], or: e, aichi: [1, { aisai: e, ama: e, anjo: e, asuke: e, chiryu: e, chita: e, fuso: e, gamagori: e, handa: e, hazu: e, hekinan: e, higashiura: e, ichinomiya: e, inazawa: e, inuyama: e, isshiki: e, iwakura: e, kanie: e, kariya: e, kasugai: e, kira: e, kiyosu: e, komaki: e, konan: e, kota: e, mihama: e, miyoshi: e, nishio: e, nisshin: e, obu: e, oguchi: e, oharu: e, okazaki: e, owariasahi: e, seto: e, shikatsu: e, shinshiro: e, shitara: e, tahara: e, takahama: e, tobishima: e, toei: e, togo: e, tokai: e, tokoname: e, toyoake: e, toyohashi: e, toyokawa: e, toyone: e, toyota: e, tsushima: e, yatomi: e }], akita: [1, { akita: e, daisen: e, fujisato: e, gojome: e, hachirogata: e, happou: e, higashinaruse: e, honjo: e, honjyo: e, ikawa: e, kamikoani: e, kamioka: e, katagami: e, kazuno: e, kitaakita: e, kosaka: e, kyowa: e, misato: e, mitane: e, moriyoshi: e, nikaho: e, noshiro: e, odate: e, oga: e, ogata: e, semboku: e, yokote: e, yurihonjo: e }], aomori: [1, { aomori: e, gonohe: e, hachinohe: e, hashikami: e, hiranai: e, hirosaki: e, itayanagi: e, kuroishi: e, misawa: e, mutsu: e, nakadomari: e, noheji: e, oirase: e, owani: e, rokunohe: e, sannohe: e, shichinohe: e, shingo: e, takko: e, towada: e, tsugaru: e, tsuruta: e }], chiba: [1, { abiko: e, asahi: e, chonan: e, chosei: e, choshi: e, chuo: e, funabashi: e, futtsu: e, hanamigawa: e, ichihara: e, ichikawa: e, ichinomiya: e, inzai: e, isumi: e, kamagaya: e, kamogawa: e, kashiwa: e, katori: e, katsuura: e, kimitsu: e, kisarazu: e, kozaki: e, kujukuri: e, kyonan: e, matsudo: e, midori: e, mihama: e, minamiboso: e, mobara: e, mutsuzawa: e, nagara: e, nagareyama: e, narashino: e, narita: e, noda: e, oamishirasato: e, omigawa: e, onjuku: e, otaki: e, sakae: e, sakura: e, shimofusa: e, shirako: e, shiroi: e, shisui: e, sodegaura: e, sosa: e, tako: e, tateyama: e, togane: e, tohnosho: e, tomisato: e, urayasu: e, yachimata: e, yachiyo: e, yokaichiba: e, yokoshibahikari: e, yotsukaido: e }], ehime: [1, { ainan: e, honai: e, ikata: e, imabari: e, iyo: e, kamijima: e, kihoku: e, kumakogen: e, masaki: e, matsuno: e, matsuyama: e, namikata: e, niihama: e, ozu: e, saijo: e, seiyo: e, shikokuchuo: e, tobe: e, toon: e, uchiko: e, uwajima: e, yawatahama: e }], fukui: [1, { echizen: e, eiheiji: e, fukui: e, ikeda: e, katsuyama: e, mihama: e, minamiechizen: e, obama: e, ohi: e, ono: e, sabae: e, sakai: e, takahama: e, tsuruga: e, wakasa: e }], fukuoka: [1, { ashiya: e, buzen: e, chikugo: e, chikuho: e, chikujo: e, chikushino: e, chikuzen: e, chuo: e, dazaifu: e, fukuchi: e, hakata: e, higashi: e, hirokawa: e, hisayama: e, iizuka: e, inatsuki: e, kaho: e, kasuga: e, kasuya: e, kawara: e, keisen: e, koga: e, kurate: e, kurogi: e, kurume: e, minami: e, miyako: e, miyama: e, miyawaka: e, mizumaki: e, munakata: e, nakagawa: e, nakama: e, nishi: e, nogata: e, ogori: e, okagaki: e, okawa: e, oki: e, omuta: e, onga: e, onojo: e, oto: e, saigawa: e, sasaguri: e, shingu: e, shinyoshitomi: e, shonai: e, soeda: e, sue: e, tachiarai: e, tagawa: e, takata: e, toho: e, toyotsu: e, tsuiki: e, ukiha: e, umi: e, usui: e, yamada: e, yame: e, yanagawa: e, yukuhashi: e }], fukushima: [1, { aizubange: e, aizumisato: e, aizuwakamatsu: e, asakawa: e, bandai: e, date: e, fukushima: e, furudono: e, futaba: e, hanawa: e, higashi: e, hirata: e, hirono: e, iitate: e, inawashiro: e, ishikawa: e, iwaki: e, izumizaki: e, kagamiishi: e, kaneyama: e, kawamata: e, kitakata: e, kitashiobara: e, koori: e, koriyama: e, kunimi: e, miharu: e, mishima: e, namie: e, nango: e, nishiaizu: e, nishigo: e, okuma: e, omotego: e, ono: e, otama: e, samegawa: e, shimogo: e, shirakawa: e, showa: e, soma: e, sukagawa: e, taishin: e, tamakawa: e, tanagura: e, tenei: e, yabuki: e, yamato: e, yamatsuri: e, yanaizu: e, yugawa: e }], gifu: [1, { anpachi: e, ena: e, gifu: e, ginan: e, godo: e, gujo: e, hashima: e, hichiso: e, hida: e, higashishirakawa: e, ibigawa: e, ikeda: e, kakamigahara: e, kani: e, kasahara: e, kasamatsu: e, kawaue: e, kitagata: e, mino: e, minokamo: e, mitake: e, mizunami: e, motosu: e, nakatsugawa: e, ogaki: e, sakahogi: e, seki: e, sekigahara: e, shirakawa: e, tajimi: e, takayama: e, tarui: e, toki: e, tomika: e, wanouchi: e, yamagata: e, yaotsu: e, yoro: e }], gunma: [1, { annaka: e, chiyoda: e, fujioka: e, higashiagatsuma: e, isesaki: e, itakura: e, kanna: e, kanra: e, katashina: e, kawaba: e, kiryu: e, kusatsu: e, maebashi: e, meiwa: e, midori: e, minakami: e, naganohara: e, nakanojo: e, nanmoku: e, numata: e, oizumi: e, ora: e, ota: e, shibukawa: e, shimonita: e, shinto: e, showa: e, takasaki: e, takayama: e, tamamura: e, tatebayashi: e, tomioka: e, tsukiyono: e, tsumagoi: e, ueno: e, yoshioka: e }], hiroshima: [1, { asaminami: e, daiwa: e, etajima: e, fuchu: e, fukuyama: e, hatsukaichi: e, higashihiroshima: e, hongo: e, jinsekikogen: e, kaita: e, kui: e, kumano: e, kure: e, mihara: e, miyoshi: e, naka: e, onomichi: e, osakikamijima: e, otake: e, saka: e, sera: e, seranishi: e, shinichi: e, shobara: e, takehara: e }], hokkaido: [1, { abashiri: e, abira: e, aibetsu: e, akabira: e, akkeshi: e, asahikawa: e, ashibetsu: e, ashoro: e, assabu: e, atsuma: e, bibai: e, biei: e, bifuka: e, bihoro: e, biratori: e, chippubetsu: e, chitose: e, date: e, ebetsu: e, embetsu: e, eniwa: e, erimo: e, esan: e, esashi: e, fukagawa: e, fukushima: e, furano: e, furubira: e, haboro: e, hakodate: e, hamatonbetsu: e, hidaka: e, higashikagura: e, higashikawa: e, hiroo: e, hokuryu: e, hokuto: e, honbetsu: e, horokanai: e, horonobe: e, ikeda: e, imakane: e, ishikari: e, iwamizawa: e, iwanai: e, kamifurano: e, kamikawa: e, kamishihoro: e, kamisunagawa: e, kamoenai: e, kayabe: e, kembuchi: e, kikonai: e, kimobetsu: e, kitahiroshima: e, kitami: e, kiyosato: e, koshimizu: e, kunneppu: e, kuriyama: e, kuromatsunai: e, kushiro: e, kutchan: e, kyowa: e, mashike: e, matsumae: e, mikasa: e, minamifurano: e, mombetsu: e, moseushi: e, mukawa: e, muroran: e, naie: e, nakagawa: e, nakasatsunai: e, nakatombetsu: e, nanae: e, nanporo: e, nayoro: e, nemuro: e, niikappu: e, niki: e, nishiokoppe: e, noboribetsu: e, numata: e, obihiro: e, obira: e, oketo: e, okoppe: e, otaru: e, otobe: e, otofuke: e, otoineppu: e, oumu: e, ozora: e, pippu: e, rankoshi: e, rebun: e, rikubetsu: e, rishiri: e, rishirifuji: e, saroma: e, sarufutsu: e, shakotan: e, shari: e, shibecha: e, shibetsu: e, shikabe: e, shikaoi: e, shimamaki: e, shimizu: e, shimokawa: e, shinshinotsu: e, shintoku: e, shiranuka: e, shiraoi: e, shiriuchi: e, sobetsu: e, sunagawa: e, taiki: e, takasu: e, takikawa: e, takinoue: e, teshikaga: e, tobetsu: e, tohma: e, tomakomai: e, tomari: e, toya: e, toyako: e, toyotomi: e, toyoura: e, tsubetsu: e, tsukigata: e, urakawa: e, urausu: e, uryu: e, utashinai: e, wakkanai: e, wassamu: e, yakumo: e, yoichi: e }], hyogo: [1, { aioi: e, akashi: e, ako: e, amagasaki: e, aogaki: e, asago: e, ashiya: e, awaji: e, fukusaki: e, goshiki: e, harima: e, himeji: e, ichikawa: e, inagawa: e, itami: e, kakogawa: e, kamigori: e, kamikawa: e, kasai: e, kasuga: e, kawanishi: e, miki: e, minamiawaji: e, nishinomiya: e, nishiwaki: e, ono: e, sanda: e, sannan: e, sasayama: e, sayo: e, shingu: e, shinonsen: e, shiso: e, sumoto: e, taishi: e, taka: e, takarazuka: e, takasago: e, takino: e, tamba: e, tatsuno: e, toyooka: e, yabu: e, yashiro: e, yoka: e, yokawa: e }], ibaraki: [1, { ami: e, asahi: e, bando: e, chikusei: e, daigo: e, fujishiro: e, hitachi: e, hitachinaka: e, hitachiomiya: e, hitachiota: e, ibaraki: e, ina: e, inashiki: e, itako: e, iwama: e, joso: e, kamisu: e, kasama: e, kashima: e, kasumigaura: e, koga: e, miho: e, mito: e, moriya: e, naka: e, namegata: e, oarai: e, ogawa: e, omitama: e, ryugasaki: e, sakai: e, sakuragawa: e, shimodate: e, shimotsuma: e, shirosato: e, sowa: e, suifu: e, takahagi: e, tamatsukuri: e, tokai: e, tomobe: e, tone: e, toride: e, tsuchiura: e, tsukuba: e, uchihara: e, ushiku: e, yachiyo: e, yamagata: e, yawara: e, yuki: e }], ishikawa: [1, { anamizu: e, hakui: e, hakusan: e, kaga: e, kahoku: e, kanazawa: e, kawakita: e, komatsu: e, nakanoto: e, nanao: e, nomi: e, nonoichi: e, noto: e, shika: e, suzu: e, tsubata: e, tsurugi: e, uchinada: e, wajima: e }], iwate: [1, { fudai: e, fujisawa: e, hanamaki: e, hiraizumi: e, hirono: e, ichinohe: e, ichinoseki: e, iwaizumi: e, iwate: e, joboji: e, kamaishi: e, kanegasaki: e, karumai: e, kawai: e, kitakami: e, kuji: e, kunohe: e, kuzumaki: e, miyako: e, mizusawa: e, morioka: e, ninohe: e, noda: e, ofunato: e, oshu: e, otsuchi: e, rikuzentakata: e, shiwa: e, shizukuishi: e, sumita: e, tanohata: e, tono: e, yahaba: e, yamada: e }], kagawa: [1, { ayagawa: e, higashikagawa: e, kanonji: e, kotohira: e, manno: e, marugame: e, mitoyo: e, naoshima: e, sanuki: e, tadotsu: e, takamatsu: e, tonosho: e, uchinomi: e, utazu: e, zentsuji: e }], kagoshima: [1, { akune: e, amami: e, hioki: e, isa: e, isen: e, izumi: e, kagoshima: e, kanoya: e, kawanabe: e, kinko: e, kouyama: e, makurazaki: e, matsumoto: e, minamitane: e, nakatane: e, nishinoomote: e, satsumasendai: e, soo: e, tarumizu: e, yusui: e }], kanagawa: [1, { aikawa: e, atsugi: e, ayase: e, chigasaki: e, ebina: e, fujisawa: e, hadano: e, hakone: e, hiratsuka: e, isehara: e, kaisei: e, kamakura: e, kiyokawa: e, matsuda: e, minamiashigara: e, miura: e, nakai: e, ninomiya: e, odawara: e, oi: e, oiso: e, sagamihara: e, samukawa: e, tsukui: e, yamakita: e, yamato: e, yokosuka: e, yugawara: e, zama: e, zushi: e }], kochi: [1, { aki: e, geisei: e, hidaka: e, higashitsuno: e, ino: e, kagami: e, kami: e, kitagawa: e, kochi: e, mihara: e, motoyama: e, muroto: e, nahari: e, nakamura: e, nankoku: e, nishitosa: e, niyodogawa: e, ochi: e, okawa: e, otoyo: e, otsuki: e, sakawa: e, sukumo: e, susaki: e, tosa: e, tosashimizu: e, toyo: e, tsuno: e, umaji: e, yasuda: e, yusuhara: e }], kumamoto: [1, { amakusa: e, arao: e, aso: e, choyo: e, gyokuto: e, kamiamakusa: e, kikuchi: e, kumamoto: e, mashiki: e, mifune: e, minamata: e, minamioguni: e, nagasu: e, nishihara: e, oguni: e, ozu: e, sumoto: e, takamori: e, uki: e, uto: e, yamaga: e, yamato: e, yatsushiro: e }], kyoto: [1, { ayabe: e, fukuchiyama: e, higashiyama: e, ide: e, ine: e, joyo: e, kameoka: e, kamo: e, kita: e, kizu: e, kumiyama: e, kyotamba: e, kyotanabe: e, kyotango: e, maizuru: e, minami: e, minamiyamashiro: e, miyazu: e, muko: e, nagaokakyo: e, nakagyo: e, nantan: e, oyamazaki: e, sakyo: e, seika: e, tanabe: e, uji: e, ujitawara: e, wazuka: e, yamashina: e, yawata: e }], mie: [1, { asahi: e, inabe: e, ise: e, kameyama: e, kawagoe: e, kiho: e, kisosaki: e, kiwa: e, komono: e, kumano: e, kuwana: e, matsusaka: e, meiwa: e, mihama: e, minamiise: e, misugi: e, miyama: e, nabari: e, shima: e, suzuka: e, tado: e, taiki: e, taki: e, tamaki: e, toba: e, tsu: e, udono: e, ureshino: e, watarai: e, yokkaichi: e }], miyagi: [1, { furukawa: e, higashimatsushima: e, ishinomaki: e, iwanuma: e, kakuda: e, kami: e, kawasaki: e, marumori: e, matsushima: e, minamisanriku: e, misato: e, murata: e, natori: e, ogawara: e, ohira: e, onagawa: e, osaki: e, rifu: e, semine: e, shibata: e, shichikashuku: e, shikama: e, shiogama: e, shiroishi: e, tagajo: e, taiwa: e, tome: e, tomiya: e, wakuya: e, watari: e, yamamoto: e, zao: e }], miyazaki: [1, { aya: e, ebino: e, gokase: e, hyuga: e, kadogawa: e, kawaminami: e, kijo: e, kitagawa: e, kitakata: e, kitaura: e, kobayashi: e, kunitomi: e, kushima: e, mimata: e, miyakonojo: e, miyazaki: e, morotsuka: e, nichinan: e, nishimera: e, nobeoka: e, saito: e, shiiba: e, shintomi: e, takaharu: e, takanabe: e, takazaki: e, tsuno: e }], nagano: [1, { achi: e, agematsu: e, anan: e, aoki: e, asahi: e, azumino: e, chikuhoku: e, chikuma: e, chino: e, fujimi: e, hakuba: e, hara: e, hiraya: e, iida: e, iijima: e, iiyama: e, iizuna: e, ikeda: e, ikusaka: e, ina: e, karuizawa: e, kawakami: e, kiso: e, kisofukushima: e, kitaaiki: e, komagane: e, komoro: e, matsukawa: e, matsumoto: e, miasa: e, minamiaiki: e, minamimaki: e, minamiminowa: e, minowa: e, miyada: e, miyota: e, mochizuki: e, nagano: e, nagawa: e, nagiso: e, nakagawa: e, nakano: e, nozawaonsen: e, obuse: e, ogawa: e, okaya: e, omachi: e, omi: e, ookuwa: e, ooshika: e, otaki: e, otari: e, sakae: e, sakaki: e, saku: e, sakuho: e, shimosuwa: e, shinanomachi: e, shiojiri: e, suwa: e, suzaka: e, takagi: e, takamori: e, takayama: e, tateshina: e, tatsuno: e, togakushi: e, togura: e, tomi: e, ueda: e, wada: e, yamagata: e, yamanouchi: e, yasaka: e, yasuoka: e }], nagasaki: [1, { chijiwa: e, futsu: e, goto: e, hasami: e, hirado: e, iki: e, isahaya: e, kawatana: e, kuchinotsu: e, matsuura: e, nagasaki: e, obama: e, omura: e, oseto: e, saikai: e, sasebo: e, seihi: e, shimabara: e, shinkamigoto: e, togitsu: e, tsushima: e, unzen: e }], nara: [1, { ando: e, gose: e, heguri: e, higashiyoshino: e, ikaruga: e, ikoma: e, kamikitayama: e, kanmaki: e, kashiba: e, kashihara: e, katsuragi: e, kawai: e, kawakami: e, kawanishi: e, koryo: e, kurotaki: e, mitsue: e, miyake: e, nara: e, nosegawa: e, oji: e, ouda: e, oyodo: e, sakurai: e, sango: e, shimoichi: e, shimokitayama: e, shinjo: e, soni: e, takatori: e, tawaramoto: e, tenkawa: e, tenri: e, uda: e, yamatokoriyama: e, yamatotakada: e, yamazoe: e, yoshino: e }], niigata: [1, { aga: e, agano: e, gosen: e, itoigawa: e, izumozaki: e, joetsu: e, kamo: e, kariwa: e, kashiwazaki: e, minamiuonuma: e, mitsuke: e, muika: e, murakami: e, myoko: e, nagaoka: e, niigata: e, ojiya: e, omi: e, sado: e, sanjo: e, seiro: e, seirou: e, sekikawa: e, shibata: e, tagami: e, tainai: e, tochio: e, tokamachi: e, tsubame: e, tsunan: e, uonuma: e, yahiko: e, yoita: e, yuzawa: e }], oita: [1, { beppu: e, bungoono: e, bungotakada: e, hasama: e, hiji: e, himeshima: e, hita: e, kamitsue: e, kokonoe: e, kuju: e, kunisaki: e, kusu: e, oita: e, saiki: e, taketa: e, tsukumi: e, usa: e, usuki: e, yufu: e }], okayama: [1, { akaiwa: e, asakuchi: e, bizen: e, hayashima: e, ibara: e, kagamino: e, kasaoka: e, kibichuo: e, kumenan: e, kurashiki: e, maniwa: e, misaki: e, nagi: e, niimi: e, nishiawakura: e, okayama: e, satosho: e, setouchi: e, shinjo: e, shoo: e, soja: e, takahashi: e, tamano: e, tsuyama: e, wake: e, yakage: e }], okinawa: [1, { aguni: e, ginowan: e, ginoza: e, gushikami: e, haebaru: e, higashi: e, hirara: e, iheya: e, ishigaki: e, ishikawa: e, itoman: e, izena: e, kadena: e, kin: e, kitadaito: e, kitanakagusuku: e, kumejima: e, kunigami: e, minamidaito: e, motobu: e, nago: e, naha: e, nakagusuku: e, nakijin: e, nanjo: e, nishihara: e, ogimi: e, okinawa: e, onna: e, shimoji: e, taketomi: e, tarama: e, tokashiki: e, tomigusuku: e, tonaki: e, urasoe: e, uruma: e, yaese: e, yomitan: e, yonabaru: e, yonaguni: e, zamami: e }], osaka: [1, { abeno: e, chihayaakasaka: e, chuo: e, daito: e, fujiidera: e, habikino: e, hannan: e, higashiosaka: e, higashisumiyoshi: e, higashiyodogawa: e, hirakata: e, ibaraki: e, ikeda: e, izumi: e, izumiotsu: e, izumisano: e, kadoma: e, kaizuka: e, kanan: e, kashiwara: e, katano: e, kawachinagano: e, kishiwada: e, kita: e, kumatori: e, matsubara: e, minato: e, minoh: e, misaki: e, moriguchi: e, neyagawa: e, nishi: e, nose: e, osakasayama: e, sakai: e, sayama: e, sennan: e, settsu: e, shijonawate: e, shimamoto: e, suita: e, tadaoka: e, taishi: e, tajiri: e, takaishi: e, takatsuki: e, tondabayashi: e, toyonaka: e, toyono: e, yao: e }], saga: [1, { ariake: e, arita: e, fukudomi: e, genkai: e, hamatama: e, hizen: e, imari: e, kamimine: e, kanzaki: e, karatsu: e, kashima: e, kitagata: e, kitahata: e, kiyama: e, kouhoku: e, kyuragi: e, nishiarita: e, ogi: e, omachi: e, ouchi: e, saga: e, shiroishi: e, taku: e, tara: e, tosu: e, yoshinogari: e }], saitama: [1, { arakawa: e, asaka: e, chichibu: e, fujimi: e, fujimino: e, fukaya: e, hanno: e, hanyu: e, hasuda: e, hatogaya: e, hatoyama: e, hidaka: e, higashichichibu: e, higashimatsuyama: e, honjo: e, ina: e, iruma: e, iwatsuki: e, kamiizumi: e, kamikawa: e, kamisato: e, kasukabe: e, kawagoe: e, kawaguchi: e, kawajima: e, kazo: e, kitamoto: e, koshigaya: e, kounosu: e, kuki: e, kumagaya: e, matsubushi: e, minano: e, misato: e, miyashiro: e, miyoshi: e, moroyama: e, nagatoro: e, namegawa: e, niiza: e, ogano: e, ogawa: e, ogose: e, okegawa: e, omiya: e, otaki: e, ranzan: e, ryokami: e, saitama: e, sakado: e, satte: e, sayama: e, shiki: e, shiraoka: e, soka: e, sugito: e, toda: e, tokigawa: e, tokorozawa: e, tsurugashima: e, urawa: e, warabi: e, yashio: e, yokoze: e, yono: e, yorii: e, yoshida: e, yoshikawa: e, yoshimi: e }], shiga: [1, { aisho: e, gamo: e, higashiomi: e, hikone: e, koka: e, konan: e, kosei: e, koto: e, kusatsu: e, maibara: e, moriyama: e, nagahama: e, nishiazai: e, notogawa: e, omihachiman: e, otsu: e, ritto: e, ryuoh: e, takashima: e, takatsuki: e, torahime: e, toyosato: e, yasu: e }], shimane: [1, { akagi: e, ama: e, gotsu: e, hamada: e, higashiizumo: e, hikawa: e, hikimi: e, izumo: e, kakinoki: e, masuda: e, matsue: e, misato: e, nishinoshima: e, ohda: e, okinoshima: e, okuizumo: e, shimane: e, tamayu: e, tsuwano: e, unnan: e, yakumo: e, yasugi: e, yatsuka: e }], shizuoka: [1, { arai: e, atami: e, fuji: e, fujieda: e, fujikawa: e, fujinomiya: e, fukuroi: e, gotemba: e, haibara: e, hamamatsu: e, higashiizu: e, ito: e, iwata: e, izu: e, izunokuni: e, kakegawa: e, kannami: e, kawanehon: e, kawazu: e, kikugawa: e, kosai: e, makinohara: e, matsuzaki: e, minamiizu: e, mishima: e, morimachi: e, nishiizu: e, numazu: e, omaezaki: e, shimada: e, shimizu: e, shimoda: e, shizuoka: e, susono: e, yaizu: e, yoshida: e }], tochigi: [1, { ashikaga: e, bato: e, haga: e, ichikai: e, iwafune: e, kaminokawa: e, kanuma: e, karasuyama: e, kuroiso: e, mashiko: e, mibu: e, moka: e, motegi: e, nasu: e, nasushiobara: e, nikko: e, nishikata: e, nogi: e, ohira: e, ohtawara: e, oyama: e, sakura: e, sano: e, shimotsuke: e, shioya: e, takanezawa: e, tochigi: e, tsuga: e, ujiie: e, utsunomiya: e, yaita: e }], tokushima: [1, { aizumi: e, anan: e, ichiba: e, itano: e, kainan: e, komatsushima: e, matsushige: e, mima: e, minami: e, miyoshi: e, mugi: e, nakagawa: e, naruto: e, sanagochi: e, shishikui: e, tokushima: e, wajiki: e }], tokyo: [1, { adachi: e, akiruno: e, akishima: e, aogashima: e, arakawa: e, bunkyo: e, chiyoda: e, chofu: e, chuo: e, edogawa: e, fuchu: e, fussa: e, hachijo: e, hachioji: e, hamura: e, higashikurume: e, higashimurayama: e, higashiyamato: e, hino: e, hinode: e, hinohara: e, inagi: e, itabashi: e, katsushika: e, kita: e, kiyose: e, kodaira: e, koganei: e, kokubunji: e, komae: e, koto: e, kouzushima: e, kunitachi: e, machida: e, meguro: e, minato: e, mitaka: e, mizuho: e, musashimurayama: e, musashino: e, nakano: e, nerima: e, ogasawara: e, okutama: e, ome: e, oshima: e, ota: e, setagaya: e, shibuya: e, shinagawa: e, shinjuku: e, suginami: e, sumida: e, tachikawa: e, taito: e, tama: e, toshima: e }], tottori: [1, { chizu: e, hino: e, kawahara: e, koge: e, kotoura: e, misasa: e, nanbu: e, nichinan: e, sakaiminato: e, tottori: e, wakasa: e, yazu: e, yonago: e }], toyama: [1, { asahi: e, fuchu: e, fukumitsu: e, funahashi: e, himi: e, imizu: e, inami: e, johana: e, kamiichi: e, kurobe: e, nakaniikawa: e, namerikawa: e, nanto: e, nyuzen: e, oyabe: e, taira: e, takaoka: e, tateyama: e, toga: e, tonami: e, toyama: e, unazuki: e, uozu: e, yamada: e }], wakayama: [1, { arida: e, aridagawa: e, gobo: e, hashimoto: e, hidaka: e, hirogawa: e, inami: e, iwade: e, kainan: e, kamitonda: e, katsuragi: e, kimino: e, kinokawa: e, kitayama: e, koya: e, koza: e, kozagawa: e, kudoyama: e, kushimoto: e, mihama: e, misato: e, nachikatsuura: e, shingu: e, shirahama: e, taiji: e, tanabe: e, wakayama: e, yuasa: e, yura: e }], yamagata: [1, { asahi: e, funagata: e, higashine: e, iide: e, kahoku: e, kaminoyama: e, kaneyama: e, kawanishi: e, mamurogawa: e, mikawa: e, murayama: e, nagai: e, nakayama: e, nanyo: e, nishikawa: e, obanazawa: e, oe: e, oguni: e, ohkura: e, oishida: e, sagae: e, sakata: e, sakegawa: e, shinjo: e, shirataka: e, shonai: e, takahata: e, tendo: e, tozawa: e, tsuruoka: e, yamagata: e, yamanobe: e, yonezawa: e, yuza: e }], yamaguchi: [1, { abu: e, hagi: e, hikari: e, hofu: e, iwakuni: e, kudamatsu: e, mitou: e, nagato: e, oshima: e, shimonoseki: e, shunan: e, tabuse: e, tokuyama: e, toyota: e, ube: e, yuu: e }], yamanashi: [1, { chuo: e, doshi: e, fuefuki: e, fujikawa: e, fujikawaguchiko: e, fujiyoshida: e, hayakawa: e, hokuto: e, ichikawamisato: e, kai: e, kofu: e, koshu: e, kosuge: e, "minami-alps": e, minobu: e, nakamichi: e, nanbu: e, narusawa: e, nirasaki: e, nishikatsura: e, oshino: e, otsuki: e, showa: e, tabayama: e, tsuru: e, uenohara: e, yamanakako: e, yamanashi: e }], "xn--ehqz56n": e, 三重: e, "xn--1lqs03n": e, 京都: e, "xn--qqqt11m": e, 佐賀: e, "xn--f6qx53a": e, 兵庫: e, "xn--djrs72d6uy": e, 北海道: e, "xn--mkru45i": e, 千葉: e, "xn--0trq7p7nn": e, 和歌山: e, "xn--5js045d": e, 埼玉: e, "xn--kbrq7o": e, 大分: e, "xn--pssu33l": e, 大阪: e, "xn--ntsq17g": e, 奈良: e, "xn--uisz3g": e, 宮城: e, "xn--6btw5a": e, 宮崎: e, "xn--1ctwo": e, 富山: e, "xn--6orx2r": e, 山口: e, "xn--rht61e": e, 山形: e, "xn--rht27z": e, 山梨: e, "xn--nit225k": e, 岐阜: e, "xn--rht3d": e, 岡山: e, "xn--djty4k": e, 岩手: e, "xn--klty5x": e, 島根: e, "xn--kltx9a": e, 広島: e, "xn--kltp7d": e, 徳島: e, "xn--c3s14m": e, 愛媛: e, "xn--vgu402c": e, 愛知: e, "xn--efvn9s": e, 新潟: e, "xn--1lqs71d": e, 東京: e, "xn--4pvxs": e, 栃木: e, "xn--uuwu58a": e, 沖縄: e, "xn--zbx025d": e, 滋賀: e, "xn--8pvr4u": e, 熊本: e, "xn--5rtp49c": e, 石川: e, "xn--ntso0iqx3a": e, 神奈川: e, "xn--elqq16h": e, 福井: e, "xn--4it168d": e, 福岡: e, "xn--klt787d": e, 福島: e, "xn--rny31h": e, 秋田: e, "xn--7t0a264c": e, 群馬: e, "xn--uist22h": e, 茨城: e, "xn--8ltr62k": e, 長崎: e, "xn--2m4a15e": e, 長野: e, "xn--32vp30h": e, 青森: e, "xn--4it797k": e, 静岡: e, "xn--5rtq34k": e, 香川: e, "xn--k7yn95e": e, 高知: e, "xn--tor131o": e, 鳥取: e, "xn--d5qv7z876c": e, 鹿児島: e, kawasaki: y, kitakyushu: y, kobe: y, nagoya: y, sapporo: y, sendai: y, yokohama: y, buyshop: t, fashionstore: t, handcrafted: t, kawaiishop: t, supersale: t, theshop: t, "0am": t, "0g0": t, "0j0": t, "0t0": t, mydns: t, pgw: t, wjg: t, usercontent: t, angry: t, babyblue: t, babymilk: t, backdrop: t, bambina: t, bitter: t, blush: t, boo: t, boy: t, boyfriend: t, but: t, candypop: t, capoo: t, catfood: t, cheap: t, chicappa: t, chillout: t, chips: t, chowder: t, chu: t, ciao: t, cocotte: t, coolblog: t, cranky: t, cutegirl: t, daa: t, deca: t, deci: t, digick: t, egoism: t, fakefur: t, fem: t, flier: t, floppy: t, fool: t, frenchkiss: t, girlfriend: t, girly: t, gloomy: t, gonna: t, greater: t, hacca: t, heavy: t, her: t, hiho: t, hippy: t, holy: t, hungry: t, icurus: t, itigo: t, jellybean: t, kikirara: t, kill: t, kilo: t, kuron: t, littlestar: t, lolipopmc: t, lolitapunk: t, lomo: t, lovepop: t, lovesick: t, main: t, mods: t, mond: t, mongolian: t, moo: t, namaste: t, nikita: t, nobushi: t, noor: t, oops: t, parallel: t, parasite: t, pecori: t, peewee: t, penne: t, pepper: t, perma: t, pigboat: t, pinoko: t, punyu: t, pupu: t, pussycat: t, pya: t, raindrop: t, readymade: t, sadist: t, schoolbus: t, secret: t, staba: t, stripper: t, sub: t, sunnyday: t, thick: t, tonkotsu: t, under: t, upper: t, velvet: t, verse: t, versus: t, vivian: t, watson: t, weblike: t, whitesnow: t, zombie: t, hateblo: t, hatenablog: t, hatenadiary: t, "2-d": t, bona: t, crap: t, daynight: t, eek: t, flop: t, halfmoon: t, jeez: t, matrix: t, mimoza: t, netgamers: t, nyanta: t, o0o0: t, rdy: t, rgr: t, rulez: t, sakurastorage: [0, { isk01: Tn, isk02: Tn }], saloon: t, sblo: t, skr: t, tank: t, "uh-oh": t, undo: t, webaccel: [0, { rs: t, user: t }], websozai: t, xii: t }], ke: [1, { ac: e, co: e, go: e, info: e, me: e, mobi: e, ne: e, or: e, sc: e }], kg: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, us: t, xx: t }], kh: y, ki: kt, km: [1, { ass: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e, tm: e, asso: e, coop: e, gouv: e, medecin: e, notaires: e, pharmaciens: e, presse: e, veterinaire: e }], kn: [1, { edu: e, gov: e, net: e, org: e }], kp: [1, { com: e, edu: e, gov: e, org: e, rep: e, tra: e }], kr: [1, { ac: e, ai: e, co: e, es: e, go: e, hs: e, io: e, it: e, kg: e, me: e, mil: e, ms: e, ne: e, or: e, pe: e, re: e, sc: e, busan: e, chungbuk: e, chungnam: e, daegu: e, daejeon: e, gangwon: e, gwangju: e, gyeongbuk: e, gyeonggi: e, gyeongnam: e, incheon: e, jeju: e, jeonbuk: e, jeonnam: e, seoul: e, ulsan: e, c01: t, "eliv-cdn": t, "eliv-dns": t, mmv: t, vki: t }], kw: [1, { com: e, edu: e, emb: e, gov: e, ind: e, net: e, org: e }], ky: Q, kz: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, jcloud: t }], la: [1, { com: e, edu: e, gov: e, info: e, int: e, net: e, org: e, per: e, bnr: t }], lb: n, lc: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, oy: t }], li: e, lk: [1, { ac: e, assn: e, com: e, edu: e, gov: e, grp: e, hotel: e, int: e, ltd: e, net: e, ngo: e, org: e, sch: e, soc: e, web: e }], lr: n, ls: [1, { ac: e, biz: e, co: e, edu: e, gov: e, info: e, net: e, org: e, sc: e }], lt: l, lu: [1, { "123website": t }], lv: [1, { asn: e, com: e, conf: e, edu: e, gov: e, id: e, mil: e, net: e, org: e }], ly: [1, { com: e, edu: e, gov: e, id: e, med: e, net: e, org: e, plc: e, sch: e }], ma: [1, { ac: e, co: e, gov: e, net: e, org: e, press: e }], mc: [1, { asso: e, tm: e }], md: [1, { ir: t }], me: [1, { ac: e, co: e, edu: e, gov: e, its: e, net: e, org: e, priv: e, c66: t, craft: t, edgestack: t, filegear: t, "filegear-sg": t, lohmus: t, barsy: t, mcdir: t, brasilia: t, ddns: t, dnsfor: t, hopto: t, loginto: t, noip: t, webhop: t, soundcast: t, tcp4: t, vp4: t, diskstation: t, dscloud: t, i234: t, myds: t, synology: t, transip: Y, nohost: t }], mg: [1, { co: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e }], mh: e, mil: e, mk: [1, { com: e, edu: e, gov: e, inf: e, name: e, net: e, org: e }], ml: [1, { ac: e, art: e, asso: e, com: e, edu: e, gouv: e, gov: e, info: e, inst: e, net: e, org: e, pr: e, presse: e }], mm: y, mn: [1, { edu: e, gov: e, org: e, nyc: t }], mo: n, mobi: [1, { barsy: t, dscloud: t }], mp: [1, { ju: t }], mq: e, mr: l, ms: [1, { com: e, edu: e, gov: e, net: e, org: e, minisite: t }], mt: Q, mu: [1, { ac: e, co: e, com: e, gov: e, net: e, or: e, org: e }], museum: e, mv: [1, { aero: e, biz: e, com: e, coop: e, edu: e, gov: e, info: e, int: e, mil: e, museum: e, name: e, net: e, org: e, pro: e }], mw: [1, { ac: e, biz: e, co: e, com: e, coop: e, edu: e, gov: e, int: e, net: e, org: e }], mx: [1, { com: e, edu: e, gob: e, net: e, org: e }], my: [1, { biz: e, com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e }], mz: [1, { ac: e, adv: e, co: e, edu: e, gov: e, mil: e, net: e, org: e }], na: [1, { alt: e, co: e, com: e, gov: e, net: e, org: e }], name: [1, { her: Pn, his: Pn }], nc: [1, { asso: e, nom: e }], ne: e, net: [1, { adobeaemcloud: t, "adobeio-static": t, adobeioruntime: t, akadns: t, akamai: t, "akamai-staging": t, akamaiedge: t, "akamaiedge-staging": t, akamaihd: t, "akamaihd-staging": t, akamaiorigin: t, "akamaiorigin-staging": t, akamaized: t, "akamaized-staging": t, edgekey: t, "edgekey-staging": t, edgesuite: t, "edgesuite-staging": t, alwaysdata: t, myamaze: t, cloudfront: t, appudo: t, "atlassian-dev": [0, { prod: Ve }], myfritz: t, onavstack: t, shopselect: t, blackbaudcdn: t, boomla: t, bplaced: t, square7: t, cdn77: [0, { r: t }], "cdn77-ssl": t, gb: t, hu: t, jp: t, se: t, uk: t, clickrising: t, "ddns-ip": t, "dns-cloud": t, "dns-dynamic": t, cloudaccess: t, cloudflare: [2, { cdn: t }], cloudflareanycast: Ve, cloudflarecn: Ve, cloudflareglobal: Ve, ctfcloud: t, "feste-ip": t, "knx-server": t, "static-access": t, cryptonomic: a, dattolocal: t, mydatto: t, debian: t, definima: t, deno: t, icp: a, "at-band-camp": t, blogdns: t, "broke-it": t, buyshouses: t, dnsalias: t, dnsdojo: t, "does-it": t, dontexist: t, dynalias: t, dynathome: t, endofinternet: t, "from-az": t, "from-co": t, "from-la": t, "from-ny": t, "gets-it": t, "ham-radio-op": t, homeftp: t, homeip: t, homelinux: t, homeunix: t, "in-the-band": t, "is-a-chef": t, "is-a-geek": t, "isa-geek": t, "kicks-ass": t, "office-on-the": t, podzone: t, "scrapper-site": t, selfip: t, "sells-it": t, servebbs: t, serveftp: t, thruhere: t, webhop: t, casacam: t, dynu: t, dynv6: t, twmail: t, ru: t, channelsdvr: [2, { u: t }], fastly: [0, { freetls: t, map: t, prod: [0, { a: t, global: t }], ssl: [0, { a: t, b: t, global: t }] }], fastlylb: [2, { map: t }], edgeapp: t, "keyword-on": t, "live-on": t, "server-on": t, "cdn-edges": t, heteml: t, cloudfunctions: t, "grafana-dev": t, iobb: t, moonscale: t, "in-dsl": t, "in-vpn": t, oninferno: t, botdash: t, "apps-1and1": t, ipifony: t, cloudjiffy: [2, { "fra1-de": t, "west1-us": t }], elastx: [0, { "jls-sto1": t, "jls-sto2": t, "jls-sto3": t }], massivegrid: [0, { paas: [0, { "fr-1": t, "lon-1": t, "lon-2": t, "ny-1": t, "ny-2": t, "sg-1": t }] }], saveincloud: [0, { jelastic: t, "nordeste-idc": t }], scaleforce: G, kinghost: t, uni5: t, krellian: t, ggff: t, localcert: t, localto: a, barsy: t, luyani: t, memset: t, "azure-api": t, "azure-mobile": t, azureedge: t, azurefd: t, azurestaticapps: [2, { 1: t, 2: t, 3: t, 4: t, 5: t, 6: t, 7: t, centralus: t, eastasia: t, eastus2: t, westeurope: t, westus2: t }], azurewebsites: t, cloudapp: t, trafficmanager: t, windows: [0, { core: [0, { blob: t }], servicebus: t }], mynetname: [0, { sn: t }], routingthecloud: t, bounceme: t, ddns: t, "eating-organic": t, mydissent: t, myeffect: t, mymediapc: t, mypsx: t, mysecuritycamera: t, nhlfan: t, "no-ip": t, pgafan: t, privatizehealthinsurance: t, redirectme: t, serveblog: t, serveminecraft: t, sytes: t, dnsup: t, hicam: t, "now-dns": t, ownip: t, vpndns: t, cloudycluster: t, ovh: [0, { hosting: a, webpaas: a }], rackmaze: t, myradweb: t, in: t, "subsc-pay": t, squares: t, schokokeks: t, "firewall-gateway": t, seidat: t, senseering: t, siteleaf: t, mafelo: t, myspreadshop: t, "vps-host": [2, { jelastic: [0, { atl: t, njs: t, ric: t }] }], srcf: [0, { soc: t, user: t }], supabase: t, dsmynas: t, familyds: t, ts: [2, { c: a }], torproject: [2, { pages: t }], vusercontent: t, "reserve-online": t, "community-pro": t, meinforum: t, yandexcloud: [2, { storage: t, website: t }], za: t, zabc: t }], nf: [1, { arts: e, com: e, firm: e, info: e, net: e, other: e, per: e, rec: e, store: e, web: e }], ng: [1, { com: e, edu: e, gov: e, i: e, mil: e, mobi: e, name: e, net: e, org: e, sch: e, biz: [2, { co: t, dl: t, go: t, lg: t, on: t }], col: t, firm: t, gen: t, ltd: t, ngo: t, plc: t }], ni: [1, { ac: e, biz: e, co: e, com: e, edu: e, gob: e, in: e, info: e, int: e, mil: e, net: e, nom: e, org: e, web: e }], nl: [1, { co: t, "hosting-cluster": t, gov: t, khplay: t, "123website": t, myspreadshop: t, transurl: a, cistron: t, demon: t }], no: [1, { fhs: e, folkebibl: e, fylkesbibl: e, idrett: e, museum: e, priv: e, vgs: e, dep: e, herad: e, kommune: e, mil: e, stat: e, aa: _e, ah: _e, bu: _e, fm: _e, hl: _e, hm: _e, "jan-mayen": _e, mr: _e, nl: _e, nt: _e, of: _e, ol: _e, oslo: _e, rl: _e, sf: _e, st: _e, svalbard: _e, tm: _e, tr: _e, va: _e, vf: _e, akrehamn: e, "xn--krehamn-dxa": e, åkrehamn: e, algard: e, "xn--lgrd-poac": e, ålgård: e, arna: e, bronnoysund: e, "xn--brnnysund-m8ac": e, brønnøysund: e, brumunddal: e, bryne: e, drobak: e, "xn--drbak-wua": e, drøbak: e, egersund: e, fetsund: e, floro: e, "xn--flor-jra": e, florø: e, fredrikstad: e, hokksund: e, honefoss: e, "xn--hnefoss-q1a": e, hønefoss: e, jessheim: e, jorpeland: e, "xn--jrpeland-54a": e, jørpeland: e, kirkenes: e, kopervik: e, krokstadelva: e, langevag: e, "xn--langevg-jxa": e, langevåg: e, leirvik: e, mjondalen: e, "xn--mjndalen-64a": e, mjøndalen: e, "mo-i-rana": e, mosjoen: e, "xn--mosjen-eya": e, mosjøen: e, nesoddtangen: e, orkanger: e, osoyro: e, "xn--osyro-wua": e, osøyro: e, raholt: e, "xn--rholt-mra": e, råholt: e, sandnessjoen: e, "xn--sandnessjen-ogb": e, sandnessjøen: e, skedsmokorset: e, slattum: e, spjelkavik: e, stathelle: e, stavern: e, stjordalshalsen: e, "xn--stjrdalshalsen-sqb": e, stjørdalshalsen: e, tananger: e, tranby: e, vossevangen: e, aarborte: e, aejrie: e, afjord: e, "xn--fjord-lra": e, åfjord: e, agdenes: e, akershus: ft, aknoluokta: e, "xn--koluokta-7ya57h": e, ákŋoluokta: e, al: e, "xn--l-1fa": e, ål: e, alaheadju: e, "xn--laheadju-7ya": e, álaheadju: e, alesund: e, "xn--lesund-hua": e, ålesund: e, alstahaug: e, alta: e, "xn--lt-liac": e, áltá: e, alvdal: e, amli: e, "xn--mli-tla": e, åmli: e, amot: e, "xn--mot-tla": e, åmot: e, andasuolo: e, andebu: e, andoy: e, "xn--andy-ira": e, andøy: e, ardal: e, "xn--rdal-poa": e, årdal: e, aremark: e, arendal: e, "xn--s-1fa": e, ås: e, aseral: e, "xn--seral-lra": e, åseral: e, asker: e, askim: e, askoy: e, "xn--asky-ira": e, askøy: e, askvoll: e, asnes: e, "xn--snes-poa": e, åsnes: e, audnedaln: e, aukra: e, aure: e, aurland: e, "aurskog-holand": e, "xn--aurskog-hland-jnb": e, "aurskog-høland": e, austevoll: e, austrheim: e, averoy: e, "xn--avery-yua": e, averøy: e, badaddja: e, "xn--bdddj-mrabd": e, bådåddjå: e, "xn--brum-voa": e, bærum: e, bahcavuotna: e, "xn--bhcavuotna-s4a": e, báhcavuotna: e, bahccavuotna: e, "xn--bhccavuotna-k7a": e, báhccavuotna: e, baidar: e, "xn--bidr-5nac": e, báidár: e, bajddar: e, "xn--bjddar-pta": e, bájddar: e, balat: e, "xn--blt-elab": e, bálát: e, balestrand: e, ballangen: e, balsfjord: e, bamble: e, bardu: e, barum: e, batsfjord: e, "xn--btsfjord-9za": e, båtsfjord: e, bearalvahki: e, "xn--bearalvhki-y4a": e, bearalváhki: e, beardu: e, beiarn: e, berg: e, bergen: e, berlevag: e, "xn--berlevg-jxa": e, berlevåg: e, bievat: e, "xn--bievt-0qa": e, bievát: e, bindal: e, birkenes: e, bjarkoy: e, "xn--bjarky-fya": e, bjarkøy: e, bjerkreim: e, bjugn: e, bodo: e, "xn--bod-2na": e, bodø: e, bokn: e, bomlo: e, "xn--bmlo-gra": e, bømlo: e, bremanger: e, bronnoy: e, "xn--brnny-wuac": e, brønnøy: e, budejju: e, buskerud: ft, bygland: e, bykle: e, cahcesuolo: e, "xn--hcesuolo-7ya35b": e, čáhcesuolo: e, davvenjarga: e, "xn--davvenjrga-y4a": e, davvenjárga: e, davvesiida: e, deatnu: e, dielddanuorri: e, divtasvuodna: e, divttasvuotna: e, donna: e, "xn--dnna-gra": e, dønna: e, dovre: e, drammen: e, drangedal: e, dyroy: e, "xn--dyry-ira": e, dyrøy: e, eid: e, eidfjord: e, eidsberg: e, eidskog: e, eidsvoll: e, eigersund: e, elverum: e, enebakk: e, engerdal: e, etne: e, etnedal: e, evenassi: e, "xn--eveni-0qa01ga": e, evenášši: e, evenes: e, "evje-og-hornnes": e, farsund: e, fauske: e, fedje: e, fet: e, finnoy: e, "xn--finny-yua": e, finnøy: e, fitjar: e, fjaler: e, fjell: e, fla: e, "xn--fl-zia": e, flå: e, flakstad: e, flatanger: e, flekkefjord: e, flesberg: e, flora: e, folldal: e, forde: e, "xn--frde-gra": e, førde: e, forsand: e, fosnes: e, "xn--frna-woa": e, fræna: e, frana: e, frei: e, frogn: e, froland: e, frosta: e, froya: e, "xn--frya-hra": e, frøya: e, fuoisku: e, fuossko: e, fusa: e, fyresdal: e, gaivuotna: e, "xn--givuotna-8ya": e, gáivuotna: e, galsa: e, "xn--gls-elac": e, gálsá: e, gamvik: e, gangaviika: e, "xn--ggaviika-8ya47h": e, gáŋgaviika: e, gaular: e, gausdal: e, giehtavuoatna: e, gildeskal: e, "xn--gildeskl-g0a": e, gildeskål: e, giske: e, gjemnes: e, gjerdrum: e, gjerstad: e, gjesdal: e, gjovik: e, "xn--gjvik-wua": e, gjøvik: e, gloppen: e, gol: e, gran: e, grane: e, granvin: e, gratangen: e, grimstad: e, grong: e, grue: e, gulen: e, guovdageaidnu: e, ha: e, "xn--h-2fa": e, hå: e, habmer: e, "xn--hbmer-xqa": e, hábmer: e, hadsel: e, "xn--hgebostad-g3a": e, hægebostad: e, hagebostad: e, halden: e, halsa: e, hamar: e, hamaroy: e, hammarfeasta: e, "xn--hmmrfeasta-s4ac": e, hámmárfeasta: e, hammerfest: e, hapmir: e, "xn--hpmir-xqa": e, hápmir: e, haram: e, hareid: e, harstad: e, hasvik: e, hattfjelldal: e, haugesund: e, hedmark: [0, { os: e, valer: e, "xn--vler-qoa": e, våler: e }], hemne: e, hemnes: e, hemsedal: e, hitra: e, hjartdal: e, hjelmeland: e, hobol: e, "xn--hobl-ira": e, hobøl: e, hof: e, hol: e, hole: e, holmestrand: e, holtalen: e, "xn--holtlen-hxa": e, holtålen: e, hordaland: [0, { os: e }], hornindal: e, horten: e, hoyanger: e, "xn--hyanger-q1a": e, høyanger: e, hoylandet: e, "xn--hylandet-54a": e, høylandet: e, hurdal: e, hurum: e, hvaler: e, hyllestad: e, ibestad: e, inderoy: e, "xn--indery-fya": e, inderøy: e, iveland: e, ivgu: e, jevnaker: e, jolster: e, "xn--jlster-bya": e, jølster: e, jondal: e, kafjord: e, "xn--kfjord-iua": e, kåfjord: e, karasjohka: e, "xn--krjohka-hwab49j": e, kárášjohka: e, karasjok: e, karlsoy: e, karmoy: e, "xn--karmy-yua": e, karmøy: e, kautokeino: e, klabu: e, "xn--klbu-woa": e, klæbu: e, klepp: e, kongsberg: e, kongsvinger: e, kraanghke: e, "xn--kranghke-b0a": e, kråanghke: e, kragero: e, "xn--krager-gya": e, kragerø: e, kristiansand: e, kristiansund: e, krodsherad: e, "xn--krdsherad-m8a": e, krødsherad: e, "xn--kvfjord-nxa": e, kvæfjord: e, "xn--kvnangen-k0a": e, kvænangen: e, kvafjord: e, kvalsund: e, kvam: e, kvanangen: e, kvinesdal: e, kvinnherad: e, kviteseid: e, kvitsoy: e, "xn--kvitsy-fya": e, kvitsøy: e, laakesvuemie: e, "xn--lrdal-sra": e, lærdal: e, lahppi: e, "xn--lhppi-xqa": e, láhppi: e, lardal: e, larvik: e, lavagis: e, lavangen: e, leangaviika: e, "xn--leagaviika-52b": e, leaŋgaviika: e, lebesby: e, leikanger: e, leirfjord: e, leka: e, leksvik: e, lenvik: e, lerdal: e, lesja: e, levanger: e, lier: e, lierne: e, lillehammer: e, lillesand: e, lindas: e, "xn--linds-pra": e, lindås: e, lindesnes: e, loabat: e, "xn--loabt-0qa": e, loabát: e, lodingen: e, "xn--ldingen-q1a": e, lødingen: e, lom: e, loppa: e, lorenskog: e, "xn--lrenskog-54a": e, lørenskog: e, loten: e, "xn--lten-gra": e, løten: e, lund: e, lunner: e, luroy: e, "xn--lury-ira": e, lurøy: e, luster: e, lyngdal: e, lyngen: e, malatvuopmi: e, "xn--mlatvuopmi-s4a": e, málatvuopmi: e, malselv: e, "xn--mlselv-iua": e, målselv: e, malvik: e, mandal: e, marker: e, marnardal: e, masfjorden: e, masoy: e, "xn--msy-ula0h": e, måsøy: e, "matta-varjjat": e, "xn--mtta-vrjjat-k7af": e, "mátta-várjjat": e, meland: e, meldal: e, melhus: e, meloy: e, "xn--mely-ira": e, meløy: e, meraker: e, "xn--merker-kua": e, meråker: e, midsund: e, "midtre-gauldal": e, moareke: e, "xn--moreke-jua": e, moåreke: e, modalen: e, modum: e, molde: e, "more-og-romsdal": [0, { heroy: e, sande: e }], "xn--mre-og-romsdal-qqb": [0, { "xn--hery-ira": e, sande: e }], "møre-og-romsdal": [0, { herøy: e, sande: e }], moskenes: e, moss: e, mosvik: e, muosat: e, "xn--muost-0qa": e, muosát: e, naamesjevuemie: e, "xn--nmesjevuemie-tcba": e, nååmesjevuemie: e, "xn--nry-yla5g": e, nærøy: e, namdalseid: e, namsos: e, namsskogan: e, nannestad: e, naroy: e, narviika: e, narvik: e, naustdal: e, navuotna: e, "xn--nvuotna-hwa": e, návuotna: e, "nedre-eiker": e, nesna: e, nesodden: e, nesseby: e, nesset: e, nissedal: e, nittedal: e, "nord-aurdal": e, "nord-fron": e, "nord-odal": e, norddal: e, nordkapp: e, nordland: [0, { bo: e, "xn--b-5ga": e, bø: e, heroy: e, "xn--hery-ira": e, herøy: e }], "nordre-land": e, nordreisa: e, "nore-og-uvdal": e, notodden: e, notteroy: e, "xn--nttery-byae": e, nøtterøy: e, odda: e, oksnes: e, "xn--ksnes-uua": e, øksnes: e, omasvuotna: e, oppdal: e, oppegard: e, "xn--oppegrd-ixa": e, oppegård: e, orkdal: e, orland: e, "xn--rland-uua": e, ørland: e, orskog: e, "xn--rskog-uua": e, ørskog: e, orsta: e, "xn--rsta-fra": e, ørsta: e, osen: e, osteroy: e, "xn--ostery-fya": e, osterøy: e, ostfold: [0, { valer: e }], "xn--stfold-9xa": [0, { "xn--vler-qoa": e }], østfold: [0, { våler: e }], "ostre-toten": e, "xn--stre-toten-zcb": e, "østre-toten": e, overhalla: e, "ovre-eiker": e, "xn--vre-eiker-k8a": e, "øvre-eiker": e, oyer: e, "xn--yer-zna": e, øyer: e, oygarden: e, "xn--ygarden-p1a": e, øygarden: e, "oystre-slidre": e, "xn--ystre-slidre-ujb": e, "øystre-slidre": e, porsanger: e, porsangu: e, "xn--porsgu-sta26f": e, porsáŋgu: e, porsgrunn: e, rade: e, "xn--rde-ula": e, råde: e, radoy: e, "xn--rady-ira": e, radøy: e, "xn--rlingen-mxa": e, rælingen: e, rahkkeravju: e, "xn--rhkkervju-01af": e, ráhkkerávju: e, raisa: e, "xn--risa-5na": e, ráisa: e, rakkestad: e, ralingen: e, rana: e, randaberg: e, rauma: e, rendalen: e, rennebu: e, rennesoy: e, "xn--rennesy-v1a": e, rennesøy: e, rindal: e, ringebu: e, ringerike: e, ringsaker: e, risor: e, "xn--risr-ira": e, risør: e, rissa: e, roan: e, rodoy: e, "xn--rdy-0nab": e, rødøy: e, rollag: e, romsa: e, romskog: e, "xn--rmskog-bya": e, rømskog: e, roros: e, "xn--rros-gra": e, røros: e, rost: e, "xn--rst-0na": e, røst: e, royken: e, "xn--ryken-vua": e, røyken: e, royrvik: e, "xn--ryrvik-bya": e, røyrvik: e, ruovat: e, rygge: e, salangen: e, salat: e, "xn--slat-5na": e, sálat: e, "xn--slt-elab": e, sálát: e, saltdal: e, samnanger: e, sandefjord: e, sandnes: e, sandoy: e, "xn--sandy-yua": e, sandøy: e, sarpsborg: e, sauda: e, sauherad: e, sel: e, selbu: e, selje: e, seljord: e, siellak: e, sigdal: e, siljan: e, sirdal: e, skanit: e, "xn--sknit-yqa": e, skánit: e, skanland: e, "xn--sknland-fxa": e, skånland: e, skaun: e, skedsmo: e, ski: e, skien: e, skierva: e, "xn--skierv-uta": e, skiervá: e, skiptvet: e, skjak: e, "xn--skjk-soa": e, skjåk: e, skjervoy: e, "xn--skjervy-v1a": e, skjervøy: e, skodje: e, smola: e, "xn--smla-hra": e, smøla: e, snaase: e, "xn--snase-nra": e, snåase: e, snasa: e, "xn--snsa-roa": e, snåsa: e, snillfjord: e, snoasa: e, sogndal: e, sogne: e, "xn--sgne-gra": e, søgne: e, sokndal: e, sola: e, solund: e, somna: e, "xn--smna-gra": e, sømna: e, "sondre-land": e, "xn--sndre-land-0cb": e, "søndre-land": e, songdalen: e, "sor-aurdal": e, "xn--sr-aurdal-l8a": e, "sør-aurdal": e, "sor-fron": e, "xn--sr-fron-q1a": e, "sør-fron": e, "sor-odal": e, "xn--sr-odal-q1a": e, "sør-odal": e, "sor-varanger": e, "xn--sr-varanger-ggb": e, "sør-varanger": e, sorfold: e, "xn--srfold-bya": e, sørfold: e, sorreisa: e, "xn--srreisa-q1a": e, sørreisa: e, sortland: e, sorum: e, "xn--srum-gra": e, sørum: e, spydeberg: e, stange: e, stavanger: e, steigen: e, steinkjer: e, stjordal: e, "xn--stjrdal-s1a": e, stjørdal: e, stokke: e, "stor-elvdal": e, stord: e, stordal: e, storfjord: e, strand: e, stranda: e, stryn: e, sula: e, suldal: e, sund: e, sunndal: e, surnadal: e, sveio: e, svelvik: e, sykkylven: e, tana: e, telemark: [0, { bo: e, "xn--b-5ga": e, bø: e }], time: e, tingvoll: e, tinn: e, tjeldsund: e, tjome: e, "xn--tjme-hra": e, tjøme: e, tokke: e, tolga: e, tonsberg: e, "xn--tnsberg-q1a": e, tønsberg: e, torsken: e, "xn--trna-woa": e, træna: e, trana: e, tranoy: e, "xn--trany-yua": e, tranøy: e, troandin: e, trogstad: e, "xn--trgstad-r1a": e, trøgstad: e, tromsa: e, tromso: e, "xn--troms-zua": e, tromsø: e, trondheim: e, trysil: e, tvedestrand: e, tydal: e, tynset: e, tysfjord: e, tysnes: e, "xn--tysvr-vra": e, tysvær: e, tysvar: e, ullensaker: e, ullensvang: e, ulvik: e, unjarga: e, "xn--unjrga-rta": e, unjárga: e, utsira: e, vaapste: e, vadso: e, "xn--vads-jra": e, vadsø: e, "xn--vry-yla5g": e, værøy: e, vaga: e, "xn--vg-yiab": e, vågå: e, vagan: e, "xn--vgan-qoa": e, vågan: e, vagsoy: e, "xn--vgsy-qoa0j": e, vågsøy: e, vaksdal: e, valle: e, vang: e, vanylven: e, vardo: e, "xn--vard-jra": e, vardø: e, varggat: e, "xn--vrggt-xqad": e, várggát: e, varoy: e, vefsn: e, vega: e, vegarshei: e, "xn--vegrshei-c0a": e, vegårshei: e, vennesla: e, verdal: e, verran: e, vestby: e, vestfold: [0, { sande: e }], vestnes: e, "vestre-slidre": e, "vestre-toten": e, vestvagoy: e, "xn--vestvgy-ixa6o": e, vestvågøy: e, vevelstad: e, vik: e, vikna: e, vindafjord: e, voagat: e, volda: e, voss: e, co: t, "123hjemmeside": t, myspreadshop: t }], np: y, nr: kt, nu: [1, { merseine: t, mine: t, shacknet: t, enterprisecloud: t }], nz: [1, { ac: e, co: e, cri: e, geek: e, gen: e, govt: e, health: e, iwi: e, kiwi: e, maori: e, "xn--mori-qsa": e, māori: e, mil: e, net: e, org: e, parliament: e, school: e, cloudns: t }], om: [1, { co: e, com: e, edu: e, gov: e, med: e, museum: e, net: e, org: e, pro: e }], onion: e, org: [1, { altervista: t, pimienta: t, poivron: t, potager: t, sweetpepper: t, cdn77: [0, { c: t, rsc: t }], "cdn77-secure": [0, { origin: [0, { ssl: t }] }], ae: t, cloudns: t, "ip-dynamic": t, ddnss: t, dpdns: t, duckdns: t, tunk: t, blogdns: t, blogsite: t, boldlygoingnowhere: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, dvrdns: t, dynalias: t, dyndns: [2, { go: t, home: t }], endofinternet: t, endoftheinternet: t, "from-me": t, "game-host": t, gotdns: t, "hobby-site": t, homedns: t, homeftp: t, homelinux: t, homeunix: t, "is-a-bruinsfan": t, "is-a-candidate": t, "is-a-celticsfan": t, "is-a-chef": t, "is-a-geek": t, "is-a-knight": t, "is-a-linux-user": t, "is-a-patsfan": t, "is-a-soxfan": t, "is-found": t, "is-lost": t, "is-saved": t, "is-very-bad": t, "is-very-evil": t, "is-very-good": t, "is-very-nice": t, "is-very-sweet": t, "isa-geek": t, "kicks-ass": t, misconfused: t, podzone: t, readmyblog: t, selfip: t, sellsyourhome: t, servebbs: t, serveftp: t, servegame: t, "stuff-4-sale": t, webhop: t, accesscam: t, camdvr: t, freeddns: t, mywire: t, webredirect: t, twmail: t, eu: [2, { al: t, asso: t, at: t, au: t, be: t, bg: t, ca: t, cd: t, ch: t, cn: t, cy: t, cz: t, de: t, dk: t, edu: t, ee: t, es: t, fi: t, fr: t, gr: t, hr: t, hu: t, ie: t, il: t, in: t, int: t, is: t, it: t, jp: t, kr: t, lt: t, lu: t, lv: t, me: t, mk: t, mt: t, my: t, net: t, ng: t, nl: t, no: t, nz: t, pl: t, pt: t, ro: t, ru: t, se: t, si: t, sk: t, tr: t, uk: t, us: t }], fedorainfracloud: t, fedorapeople: t, fedoraproject: [0, { cloud: t, os: D, stg: [0, { os: D }] }], freedesktop: t, hatenadiary: t, hepforge: t, "in-dsl": t, "in-vpn": t, js: t, barsy: t, mayfirst: t, routingthecloud: t, bmoattachments: t, "cable-modem": t, collegefan: t, couchpotatofries: t, hopto: t, mlbfan: t, myftp: t, mysecuritycamera: t, nflfan: t, "no-ip": t, "read-books": t, ufcfan: t, zapto: t, dynserv: t, "now-dns": t, "is-local": t, httpbin: t, pubtls: t, jpn: t, "my-firewall": t, myfirewall: t, spdns: t, "small-web": t, dsmynas: t, familyds: t, teckids: Tn, tuxfamily: t, diskstation: t, hk: t, us: t, toolforge: t, wmcloud: [2, { beta: t }], wmflabs: t, za: t }], pa: [1, { abo: e, ac: e, com: e, edu: e, gob: e, ing: e, med: e, net: e, nom: e, org: e, sld: e }], pe: [1, { com: e, edu: e, gob: e, mil: e, net: e, nom: e, org: e }], pf: [1, { com: e, edu: e, org: e }], pg: y, ph: [1, { com: e, edu: e, gov: e, i: e, mil: e, net: e, ngo: e, org: e, cloudns: t }], pk: [1, { ac: e, biz: e, com: e, edu: e, fam: e, gkp: e, gob: e, gog: e, gok: e, gop: e, gos: e, gov: e, net: e, org: e, web: e }], pl: [1, { com: e, net: e, org: e, agro: e, aid: e, atm: e, auto: e, biz: e, edu: e, gmina: e, gsm: e, info: e, mail: e, media: e, miasta: e, mil: e, nieruchomosci: e, nom: e, pc: e, powiat: e, priv: e, realestate: e, rel: e, sex: e, shop: e, sklep: e, sos: e, szkola: e, targi: e, tm: e, tourism: e, travel: e, turystyka: e, gov: [1, { ap: e, griw: e, ic: e, is: e, kmpsp: e, konsulat: e, kppsp: e, kwp: e, kwpsp: e, mup: e, mw: e, oia: e, oirm: e, oke: e, oow: e, oschr: e, oum: e, pa: e, pinb: e, piw: e, po: e, pr: e, psp: e, psse: e, pup: e, rzgw: e, sa: e, sdn: e, sko: e, so: e, sr: e, starostwo: e, ug: e, ugim: e, um: e, umig: e, upow: e, uppo: e, us: e, uw: e, uzs: e, wif: e, wiih: e, winb: e, wios: e, witd: e, wiw: e, wkz: e, wsa: e, wskr: e, wsse: e, wuoz: e, wzmiuw: e, zp: e, zpisdn: e }], augustow: e, "babia-gora": e, bedzin: e, beskidy: e, bialowieza: e, bialystok: e, bielawa: e, bieszczady: e, boleslawiec: e, bydgoszcz: e, bytom: e, cieszyn: e, czeladz: e, czest: e, dlugoleka: e, elblag: e, elk: e, glogow: e, gniezno: e, gorlice: e, grajewo: e, ilawa: e, jaworzno: e, "jelenia-gora": e, jgora: e, kalisz: e, karpacz: e, kartuzy: e, kaszuby: e, katowice: e, "kazimierz-dolny": e, kepno: e, ketrzyn: e, klodzko: e, kobierzyce: e, kolobrzeg: e, konin: e, konskowola: e, kutno: e, lapy: e, lebork: e, legnica: e, lezajsk: e, limanowa: e, lomza: e, lowicz: e, lubin: e, lukow: e, malbork: e, malopolska: e, mazowsze: e, mazury: e, mielec: e, mielno: e, mragowo: e, naklo: e, nowaruda: e, nysa: e, olawa: e, olecko: e, olkusz: e, olsztyn: e, opoczno: e, opole: e, ostroda: e, ostroleka: e, ostrowiec: e, ostrowwlkp: e, pila: e, pisz: e, podhale: e, podlasie: e, polkowice: e, pomorskie: e, pomorze: e, prochowice: e, pruszkow: e, przeworsk: e, pulawy: e, radom: e, "rawa-maz": e, rybnik: e, rzeszow: e, sanok: e, sejny: e, skoczow: e, slask: e, slupsk: e, sosnowiec: e, "stalowa-wola": e, starachowice: e, stargard: e, suwalki: e, swidnica: e, swiebodzin: e, swinoujscie: e, szczecin: e, szczytno: e, tarnobrzeg: e, tgory: e, turek: e, tychy: e, ustka: e, walbrzych: e, warmia: e, warszawa: e, waw: e, wegrow: e, wielun: e, wlocl: e, wloclawek: e, wodzislaw: e, wolomin: e, wroclaw: e, zachpomor: e, zagan: e, zarow: e, zgora: e, zgorzelec: e, art: t, gliwice: t, krakow: t, poznan: t, wroc: t, zakopane: t, beep: t, "ecommerce-shop": t, cfolks: t, dfirma: t, dkonto: t, you2: t, shoparena: t, homesklep: t, sdscloud: t, unicloud: t, lodz: t, pabianice: t, plock: t, sieradz: t, skierniewice: t, zgierz: t, krasnik: t, leczna: t, lubartow: t, lublin: t, poniatowa: t, swidnik: t, co: t, torun: t, simplesite: t, myspreadshop: t, gda: t, gdansk: t, gdynia: t, med: t, sopot: t, bielsko: t }], pm: [1, { own: t, name: t }], pn: [1, { co: e, edu: e, gov: e, net: e, org: e }], post: e, pr: [1, { biz: e, com: e, edu: e, gov: e, info: e, isla: e, name: e, net: e, org: e, pro: e, ac: e, est: e, prof: e }], pro: [1, { aaa: e, aca: e, acct: e, avocat: e, bar: e, cpa: e, eng: e, jur: e, law: e, med: e, recht: e, "12chars": t, cloudns: t, barsy: t, ngrok: t }], ps: [1, { com: e, edu: e, gov: e, net: e, org: e, plo: e, sec: e }], pt: [1, { com: e, edu: e, gov: e, int: e, net: e, nome: e, org: e, publ: e, "123paginaweb": t }], pw: [1, { gov: e, cloudns: t, x443: t }], py: [1, { com: e, coop: e, edu: e, gov: e, mil: e, net: e, org: e }], qa: [1, { com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e, sch: e }], re: [1, { asso: e, com: e, netlib: t, can: t }], ro: [1, { arts: e, com: e, firm: e, info: e, nom: e, nt: e, org: e, rec: e, store: e, tm: e, www: e, co: t, shop: t, barsy: t }], rs: [1, { ac: e, co: e, edu: e, gov: e, in: e, org: e, brendly: w, barsy: t, ox: t }], ru: [1, { ac: t, edu: t, gov: t, int: t, mil: t, eurodir: t, adygeya: t, bashkiria: t, bir: t, cbg: t, com: t, dagestan: t, grozny: t, kalmykia: t, kustanai: t, marine: t, mordovia: t, msk: t, mytis: t, nalchik: t, nov: t, pyatigorsk: t, spb: t, vladikavkaz: t, vladimir: t, na4u: t, mircloud: t, myjino: [2, { hosting: a, landing: a, spectrum: a, vps: a }], cldmail: [0, { hb: t }], mcdir: c, mcpre: t, net: t, org: t, pp: t, lk3: t, ras: t }], rw: [1, { ac: e, co: e, coop: e, gov: e, mil: e, net: e, org: e }], sa: [1, { com: e, edu: e, gov: e, med: e, net: e, org: e, pub: e, sch: e }], sb: n, sc: n, sd: [1, { com: e, edu: e, gov: e, info: e, med: e, net: e, org: e, tv: e }], se: [1, { a: e, ac: e, b: e, bd: e, brand: e, c: e, d: e, e, f: e, fh: e, fhsk: e, fhv: e, g: e, h: e, i: e, k: e, komforb: e, kommunalforbund: e, komvux: e, l: e, lanbib: e, m: e, n: e, naturbruksgymn: e, o: e, org: e, p: e, parti: e, pp: e, press: e, r: e, s: e, t: e, tm: e, u: e, w: e, x: e, y: e, z: e, com: t, iopsys: t, "123minsida": t, itcouldbewor: t, myspreadshop: t }], sg: [1, { com: e, edu: e, gov: e, net: e, org: e, enscaled: t }], sh: [1, { com: e, gov: e, mil: e, net: e, org: e, hashbang: t, botda: t, lovable: t, platform: [0, { ent: t, eu: t, us: t }], now: t }], si: [1, { f5: t, gitapp: t, gitpage: t }], sj: e, sk: e, sl: n, sm: e, sn: [1, { art: e, com: e, edu: e, gouv: e, org: e, perso: e, univ: e }], so: [1, { com: e, edu: e, gov: e, me: e, net: e, org: e, surveys: t }], sr: e, ss: [1, { biz: e, co: e, com: e, edu: e, gov: e, me: e, net: e, org: e, sch: e }], st: [1, { co: e, com: e, consulado: e, edu: e, embaixada: e, mil: e, net: e, org: e, principe: e, saotome: e, store: e, helioho: t, kirara: t, noho: t }], su: [1, { abkhazia: t, adygeya: t, aktyubinsk: t, arkhangelsk: t, armenia: t, ashgabad: t, azerbaijan: t, balashov: t, bashkiria: t, bryansk: t, bukhara: t, chimkent: t, dagestan: t, "east-kazakhstan": t, exnet: t, georgia: t, grozny: t, ivanovo: t, jambyl: t, kalmykia: t, kaluga: t, karacol: t, karaganda: t, karelia: t, khakassia: t, krasnodar: t, kurgan: t, kustanai: t, lenug: t, mangyshlak: t, mordovia: t, msk: t, murmansk: t, nalchik: t, navoi: t, "north-kazakhstan": t, nov: t, obninsk: t, penza: t, pokrovsk: t, sochi: t, spb: t, tashkent: t, termez: t, togliatti: t, troitsk: t, tselinograd: t, tula: t, tuva: t, vladikavkaz: t, vladimir: t, vologda: t }], sv: [1, { com: e, edu: e, gob: e, org: e, red: e }], sx: l, sy: o, sz: [1, { ac: e, co: e, org: e }], tc: e, td: e, tel: e, tf: [1, { sch: t }], tg: e, th: [1, { ac: e, co: e, go: e, in: e, mi: e, net: e, or: e, online: t, shop: t }], tj: [1, { ac: e, biz: e, co: e, com: e, edu: e, go: e, gov: e, int: e, mil: e, name: e, net: e, nic: e, org: e, test: e, web: e }], tk: e, tl: l, tm: [1, { co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e }], tn: [1, { com: e, ens: e, fin: e, gov: e, ind: e, info: e, intl: e, mincom: e, nat: e, net: e, org: e, perso: e, tourism: e, orangecloud: t }], to: [1, { 611: t, com: e, edu: e, gov: e, mil: e, net: e, org: e, oya: t, x0: t, quickconnect: C, vpnplus: t }], tr: [1, { av: e, bbs: e, bel: e, biz: e, com: e, dr: e, edu: e, gen: e, gov: e, info: e, k12: e, kep: e, mil: e, name: e, net: e, org: e, pol: e, tel: e, tsk: e, tv: e, web: e, nc: l }], tt: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], tv: [1, { "better-than": t, dyndns: t, "on-the-web": t, "worse-than": t, from: t, sakura: t }], tw: [1, { club: e, com: [1, { mymailer: t }], ebiz: e, edu: e, game: e, gov: e, idv: e, mil: e, net: e, org: e, url: t, mydns: t }], tz: [1, { ac: e, co: e, go: e, hotel: e, info: e, me: e, mil: e, mobi: e, ne: e, or: e, sc: e, tv: e }], ua: [1, { com: e, edu: e, gov: e, in: e, net: e, org: e, cherkassy: e, cherkasy: e, chernigov: e, chernihiv: e, chernivtsi: e, chernovtsy: e, ck: e, cn: e, cr: e, crimea: e, cv: e, dn: e, dnepropetrovsk: e, dnipropetrovsk: e, donetsk: e, dp: e, if: e, "ivano-frankivsk": e, kh: e, kharkiv: e, kharkov: e, kherson: e, khmelnitskiy: e, khmelnytskyi: e, kiev: e, kirovograd: e, km: e, kr: e, kropyvnytskyi: e, krym: e, ks: e, kv: e, kyiv: e, lg: e, lt: e, lugansk: e, luhansk: e, lutsk: e, lv: e, lviv: e, mk: e, mykolaiv: e, nikolaev: e, od: e, odesa: e, odessa: e, pl: e, poltava: e, rivne: e, rovno: e, rv: e, sb: e, sebastopol: e, sevastopol: e, sm: e, sumy: e, te: e, ternopil: e, uz: e, uzhgorod: e, uzhhorod: e, vinnica: e, vinnytsia: e, vn: e, volyn: e, yalta: e, zakarpattia: e, zaporizhzhe: e, zaporizhzhia: e, zhitomir: e, zhytomyr: e, zp: e, zt: e, cc: t, inf: t, ltd: t, cx: t, biz: t, co: t, pp: t, v: t }], ug: [1, { ac: e, co: e, com: e, edu: e, go: e, gov: e, mil: e, ne: e, or: e, org: e, sc: e, us: e }], uk: [1, { ac: e, co: [1, { bytemark: [0, { dh: t, vm: t }], layershift: G, barsy: t, barsyonline: t, retrosnub: In, "nh-serv": t, "no-ip": t, adimo: t, myspreadshop: t }], gov: [1, { api: t, campaign: t, service: t }], ltd: e, me: e, net: e, nhs: e, org: [1, { glug: t, lug: t, lugs: t, affinitylottery: t, raffleentry: t, weeklylottery: t }], plc: e, police: e, sch: y, conn: t, copro: t, hosp: t, "independent-commission": t, "independent-inquest": t, "independent-inquiry": t, "independent-panel": t, "independent-review": t, "public-inquiry": t, "royal-commission": t, pymnt: t, barsy: t, nimsite: t, oraclegovcloudapps: a }], us: [1, { dni: e, isa: e, nsn: e, ak: oe, al: oe, ar: oe, as: oe, az: oe, ca: oe, co: oe, ct: oe, dc: oe, de: Dn, fl: oe, ga: oe, gu: oe, hi: nr, ia: oe, id: oe, il: oe, in: oe, ks: oe, ky: oe, la: oe, ma: [1, { k12: [1, { chtr: e, paroch: e, pvt: e }], cc: e, lib: e }], md: oe, me: oe, mi: [1, { k12: e, cc: e, lib: e, "ann-arbor": e, cog: e, dst: e, eaton: e, gen: e, mus: e, tec: e, washtenaw: e }], mn: oe, mo: oe, ms: [1, { k12: e, cc: e }], mt: oe, nc: oe, nd: nr, ne: oe, nh: oe, nj: oe, nm: oe, nv: oe, ny: oe, oh: oe, ok: oe, or: oe, pa: oe, pr: oe, ri: nr, sc: oe, sd: nr, tn: oe, tx: oe, ut: oe, va: oe, vi: oe, vt: oe, wa: oe, wi: oe, wv: Dn, wy: oe, cloudns: t, "is-by": t, "land-4-sale": t, "stuff-4-sale": t, heliohost: t, enscaled: [0, { phx: t }], mircloud: t, ngo: t, golffan: t, noip: t, pointto: t, freeddns: t, srv: [2, { gh: t, gl: t }], platterp: t, servername: t }], uy: [1, { com: e, edu: e, gub: e, mil: e, net: e, org: e }], uz: [1, { co: e, com: e, net: e, org: e }], va: e, vc: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, gv: [2, { d: t }], "0e": a, mydns: t }], ve: [1, { arts: e, bib: e, co: e, com: e, e12: e, edu: e, emprende: e, firm: e, gob: e, gov: e, info: e, int: e, mil: e, net: e, nom: e, org: e, rar: e, rec: e, store: e, tec: e, web: e }], vg: [1, { edu: e }], vi: [1, { co: e, com: e, k12: e, net: e, org: e }], vn: [1, { ac: e, ai: e, biz: e, com: e, edu: e, gov: e, health: e, id: e, info: e, int: e, io: e, name: e, net: e, org: e, pro: e, angiang: e, bacgiang: e, backan: e, baclieu: e, bacninh: e, "baria-vungtau": e, bentre: e, binhdinh: e, binhduong: e, binhphuoc: e, binhthuan: e, camau: e, cantho: e, caobang: e, daklak: e, daknong: e, danang: e, dienbien: e, dongnai: e, dongthap: e, gialai: e, hagiang: e, haiduong: e, haiphong: e, hanam: e, hanoi: e, hatinh: e, haugiang: e, hoabinh: e, hungyen: e, khanhhoa: e, kiengiang: e, kontum: e, laichau: e, lamdong: e, langson: e, laocai: e, longan: e, namdinh: e, nghean: e, ninhbinh: e, ninhthuan: e, phutho: e, phuyen: e, quangbinh: e, quangnam: e, quangngai: e, quangninh: e, quangtri: e, soctrang: e, sonla: e, tayninh: e, thaibinh: e, thainguyen: e, thanhhoa: e, thanhphohochiminh: e, thuathienhue: e, tiengiang: e, travinh: e, tuyenquang: e, vinhlong: e, vinhphuc: e, yenbai: e }], vu: Q, wf: [1, { biz: t, sch: t }], ws: [1, { com: e, edu: e, gov: e, net: e, org: e, advisor: a, cloud66: t, dyndns: t, mypets: t }], yt: [1, { org: t }], "xn--mgbaam7a8h": e, امارات: e, "xn--y9a3aq": e, հայ: e, "xn--54b7fta0cc": e, বাংলা: e, "xn--90ae": e, бг: e, "xn--mgbcpq6gpa1a": e, البحرين: e, "xn--90ais": e, бел: e, "xn--fiqs8s": e, 中国: e, "xn--fiqz9s": e, 中國: e, "xn--lgbbat1ad8j": e, الجزائر: e, "xn--wgbh1c": e, مصر: e, "xn--e1a4c": e, ею: e, "xn--qxa6a": e, ευ: e, "xn--mgbah1a3hjkrd": e, موريتانيا: e, "xn--node": e, გე: e, "xn--qxam": e, ελ: e, "xn--j6w193g": [1, { "xn--gmqw5a": e, "xn--55qx5d": e, "xn--mxtq1m": e, "xn--wcvs22d": e, "xn--uc0atv": e, "xn--od0alg": e }], 香港: [1, { 個人: e, 公司: e, 政府: e, 教育: e, 組織: e, 網絡: e }], "xn--2scrj9c": e, ಭಾರತ: e, "xn--3hcrj9c": e, ଭାରତ: e, "xn--45br5cyl": e, ভাৰত: e, "xn--h2breg3eve": e, भारतम्: e, "xn--h2brj9c8c": e, भारोत: e, "xn--mgbgu82a": e, ڀارت: e, "xn--rvc1e0am3e": e, ഭാരതം: e, "xn--h2brj9c": e, भारत: e, "xn--mgbbh1a": e, بارت: e, "xn--mgbbh1a71e": e, بھارت: e, "xn--fpcrj9c3d": e, భారత్: e, "xn--gecrj9c": e, ભારત: e, "xn--s9brj9c": e, ਭਾਰਤ: e, "xn--45brj9c": e, ভারত: e, "xn--xkc2dl3a5ee0h": e, இந்தியா: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, "xn--mgbtx2b": e, عراق: e, "xn--mgbayh7gpa": e, الاردن: e, "xn--3e0b707e": e, 한국: e, "xn--80ao21a": e, қаз: e, "xn--q7ce6a": e, ລາວ: e, "xn--fzc2c9e2c": e, ලංකා: e, "xn--xkc2al3hye2a": e, இலங்கை: e, "xn--mgbc0a9azcg": e, المغرب: e, "xn--d1alf": e, мкд: e, "xn--l1acc": e, мон: e, "xn--mix891f": e, 澳門: e, "xn--mix082f": e, 澳门: e, "xn--mgbx4cd0ab": e, مليسيا: e, "xn--mgb9awbf": e, عمان: e, "xn--mgbai9azgqp6j": e, پاکستان: e, "xn--mgbai9a5eva00b": e, پاكستان: e, "xn--ygbi2ammx": e, فلسطين: e, "xn--90a3ac": [1, { "xn--80au": e, "xn--90azh": e, "xn--d1at": e, "xn--c1avg": e, "xn--o1ac": e, "xn--o1ach": e }], срб: [1, { ак: e, обр: e, од: e, орг: e, пр: e, упр: e }], "xn--p1ai": e, рф: e, "xn--wgbl6a": e, قطر: e, "xn--mgberp4a5d4ar": e, السعودية: e, "xn--mgberp4a5d4a87g": e, السعودیة: e, "xn--mgbqly7c0a67fbc": e, السعودیۃ: e, "xn--mgbqly7cvafr": e, السعوديه: e, "xn--mgbpl2fh": e, سودان: e, "xn--yfro4i67o": e, 新加坡: e, "xn--clchc0ea0b2g2a9gcd": e, சிங்கப்பூர்: e, "xn--ogbpf8fl": e, سورية: e, "xn--mgbtf8fl": e, سوريا: e, "xn--o3cw4h": [1, { "xn--o3cyx2a": e, "xn--12co0c3b4eva": e, "xn--m3ch0j3a": e, "xn--h3cuzk1di": e, "xn--12c1fe0br": e, "xn--12cfi8ixb8l": e }], ไทย: [1, { ทหาร: e, ธุรกิจ: e, เน็ต: e, รัฐบาล: e, ศึกษา: e, องค์กร: e }], "xn--pgbs0dh": e, تونس: e, "xn--kpry57d": e, 台灣: e, "xn--kprw13d": e, 台湾: e, "xn--nnx388a": e, 臺灣: e, "xn--j1amh": e, укр: e, "xn--mgb2ddes": e, اليمن: e, xxx: e, ye: o, za: [0, { ac: e, agric: e, alt: e, co: e, edu: e, gov: e, grondar: e, law: e, mil: e, net: e, ngo: e, nic: e, nis: e, nom: e, org: e, school: e, tm: e, web: e }], zm: [1, { ac: e, biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, net: e, org: e, sch: e }], zw: [1, { ac: e, co: e, gov: e, mil: e, org: e }], aaa: e, aarp: e, abb: e, abbott: e, abbvie: e, abc: e, able: e, abogado: e, abudhabi: e, academy: [1, { official: t }], accenture: e, accountant: e, accountants: e, aco: e, actor: e, ads: e, adult: e, aeg: e, aetna: e, afl: e, africa: e, agakhan: e, agency: e, aig: e, airbus: e, airforce: e, airtel: e, akdn: e, alibaba: e, alipay: e, allfinanz: e, allstate: e, ally: e, alsace: e, alstom: e, amazon: e, americanexpress: e, americanfamily: e, amex: e, amfam: e, amica: e, amsterdam: e, analytics: e, android: e, anquan: e, anz: e, aol: e, apartments: e, app: [1, { adaptable: t, aiven: t, beget: a, brave: r, clerk: t, clerkstage: t, wnext: t, csb: [2, { preview: t }], convex: t, deta: t, ondigitalocean: t, easypanel: t, encr: [2, { frontend: t }], evervault: i, expo: [2, { staging: t }], edgecompute: t, "on-fleek": t, flutterflow: t, e2b: t, framer: t, github: t, hosted: a, run: [0, { "*": t, mtls: a }], web: t, hackclub: t, hasura: t, botdash: t, loginline: t, lovable: t, luyani: t, medusajs: t, messerli: t, netfy: t, netlify: t, ngrok: t, "ngrok-free": t, developer: a, noop: t, northflank: a, upsun: a, railway: [0, { up: t }], replit: s, nyat: t, snowflake: [0, { "*": t, privatelink: a }], streamlit: t, storipress: t, telebit: t, typedream: t, vercel: t, wal: t, bookonline: t, wdh: t, windsurf: t, zeabur: t, zerops: a }], apple: e, aquarelle: e, arab: e, aramco: e, archi: e, army: e, art: e, arte: e, asda: e, associates: e, athleta: e, attorney: e, auction: e, audi: e, audible: e, audio: e, auspost: e, author: e, auto: e, autos: e, aws: [1, { on: [0, { "af-south-1": u, "ap-east-1": u, "ap-northeast-1": u, "ap-northeast-2": u, "ap-northeast-3": u, "ap-south-1": u, "ap-south-2": u, "ap-southeast-1": u, "ap-southeast-2": u, "ap-southeast-3": u, "ap-southeast-4": u, "ap-southeast-5": u, "ca-central-1": u, "ca-west-1": u, "eu-central-1": u, "eu-central-2": u, "eu-north-1": u, "eu-south-1": u, "eu-south-2": u, "eu-west-1": u, "eu-west-2": u, "eu-west-3": u, "il-central-1": u, "me-central-1": u, "me-south-1": u, "sa-east-1": u, "us-east-1": u, "us-east-2": u, "us-west-1": u, "us-west-2": u, "us-gov-east-1": d, "us-gov-west-1": d }], sagemaker: [0, { "ap-northeast-1": f, "ap-northeast-2": f, "ap-south-1": f, "ap-southeast-1": f, "ap-southeast-2": f, "ca-central-1": p, "eu-central-1": f, "eu-west-1": f, "eu-west-2": f, "us-east-1": p, "us-east-2": p, "us-west-2": p, "af-south-1": m, "ap-east-1": m, "ap-northeast-3": m, "ap-south-2": g, "ap-southeast-3": m, "ap-southeast-4": g, "ca-west-1": [0, { notebook: t, "notebook-fips": t }], "eu-central-2": m, "eu-north-1": m, "eu-south-1": m, "eu-south-2": m, "eu-west-3": m, "il-central-1": m, "me-central-1": m, "me-south-1": m, "sa-east-1": m, "us-gov-east-1": b, "us-gov-west-1": b, "us-west-1": [0, { notebook: t, "notebook-fips": t, studio: t }], experiments: a }], repost: [0, { private: a }] }], axa: e, azure: e, baby: e, baidu: e, banamex: e, band: e, bank: e, bar: e, barcelona: e, barclaycard: e, barclays: e, barefoot: e, bargains: e, baseball: e, basketball: [1, { aus: t, nz: t }], bauhaus: e, bayern: e, bbc: e, bbt: e, bbva: e, bcg: e, bcn: e, beats: e, beauty: e, beer: e, berlin: e, best: e, bestbuy: e, bet: e, bharti: e, bible: e, bid: e, bike: e, bing: e, bingo: e, bio: e, black: e, blackfriday: e, blockbuster: e, blog: e, bloomberg: e, blue: e, bms: e, bmw: e, bnpparibas: e, boats: e, boehringer: e, bofa: e, bom: e, bond: e, boo: e, book: e, booking: e, bosch: e, bostik: e, boston: e, bot: e, boutique: e, box: e, bradesco: e, bridgestone: e, broadway: e, broker: e, brother: e, brussels: e, build: [1, { v0: t, windsurf: t }], builders: [1, { cloudsite: t }], business: _, buy: e, buzz: e, bzh: e, cab: e, cafe: e, cal: e, call: e, calvinklein: e, cam: e, camera: e, camp: [1, { emf: [0, { at: t }] }], canon: e, capetown: e, capital: e, capitalone: e, car: e, caravan: e, cards: e, care: e, career: e, careers: e, cars: e, casa: [1, { nabu: [0, { ui: t }] }], case: e, cash: e, casino: e, catering: e, catholic: e, cba: e, cbn: e, cbre: e, center: e, ceo: e, cern: e, cfa: e, cfd: e, chanel: e, channel: e, charity: e, chase: e, chat: e, cheap: e, chintai: e, christmas: e, chrome: e, church: e, cipriani: e, circle: e, cisco: e, citadel: e, citi: e, citic: e, city: e, claims: e, cleaning: e, click: e, clinic: e, clinique: e, clothing: e, cloud: [1, { convex: t, elementor: t, encoway: [0, { eu: t }], statics: a, ravendb: t, axarnet: [0, { "es-1": t }], diadem: t, jelastic: [0, { vip: t }], jele: t, "jenv-aruba": [0, { aruba: [0, { eur: [0, { it1: t }] }], it1: t }], keliweb: [2, { cs: t }], oxa: [2, { tn: t, uk: t }], primetel: [2, { uk: t }], reclaim: [0, { ca: t, uk: t, us: t }], trendhosting: [0, { ch: t, de: t }], jote: t, jotelulu: t, kuleuven: t, laravel: t, linkyard: t, magentosite: a, matlab: t, observablehq: t, perspecta: t, vapor: t, "on-rancher": a, scw: [0, { baremetal: [0, { "fr-par-1": t, "fr-par-2": t, "nl-ams-1": t }], "fr-par": [0, { cockpit: t, ddl: t, dtwh: t, fnc: [2, { functions: t }], ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], instances: [0, { priv: t, pub: t }], k8s: t, "nl-ams": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], "pl-waw": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t }], scalebook: t, smartlabeling: t }], servebolt: t, onstackit: [0, { runs: t }], trafficplex: t, "unison-services": t, urown: t, voorloper: t, zap: t }], club: [1, { cloudns: t, jele: t, barsy: t }], clubmed: e, coach: e, codes: [1, { owo: a }], coffee: e, college: e, cologne: e, commbank: e, community: [1, { nog: t, ravendb: t, myforum: t }], company: e, compare: e, computer: e, comsec: e, condos: e, construction: e, consulting: e, contact: e, contractors: e, cooking: e, cool: [1, { elementor: t, de: t }], corsica: e, country: e, coupon: e, coupons: e, courses: e, cpa: e, credit: e, creditcard: e, creditunion: e, cricket: e, crown: e, crs: e, cruise: e, cruises: e, cuisinella: e, cymru: e, cyou: e, dad: e, dance: e, data: e, date: e, dating: e, datsun: e, day: e, dclk: e, dds: e, deal: e, dealer: e, deals: e, degree: e, delivery: e, dell: e, deloitte: e, delta: e, democrat: e, dental: e, dentist: e, desi: e, design: [1, { graphic: t, bss: t }], dev: [1, { "12chars": t, myaddr: t, panel: t, lcl: a, lclstage: a, stg: a, stgstage: a, pages: t, r2: t, workers: t, deno: t, "deno-staging": t, deta: t, lp: [2, { api: t, objects: t }], evervault: i, fly: t, githubpreview: t, gateway: a, botdash: t, inbrowser: a, "is-a-good": t, "is-a": t, iserv: t, runcontainers: t, localcert: [0, { user: a }], loginline: t, barsy: t, mediatech: t, modx: t, ngrok: t, "ngrok-free": t, "is-a-fullstack": t, "is-cool": t, "is-not-a": t, localplayer: t, xmit: t, "platter-app": t, replit: [2, { archer: t, bones: t, canary: t, global: t, hacker: t, id: t, janeway: t, kim: t, kira: t, kirk: t, odo: t, paris: t, picard: t, pike: t, prerelease: t, reed: t, riker: t, sisko: t, spock: t, staging: t, sulu: t, tarpit: t, teams: t, tucker: t, wesley: t, worf: t }], crm: [0, { d: a, w: a, wa: a, wb: a, wc: a, wd: a, we: a, wf: a }], erp: V, vercel: t, webhare: a, hrsn: t }], dhl: e, diamonds: e, diet: e, digital: [1, { cloudapps: [2, { london: t }] }], direct: [1, { libp2p: t }], directory: e, discount: e, discover: e, dish: e, diy: e, dnp: e, docs: e, doctor: e, dog: e, domains: e, dot: e, download: e, drive: e, dtv: e, dubai: e, dunlop: e, dupont: e, durban: e, dvag: e, dvr: e, earth: e, eat: e, eco: e, edeka: e, education: _, email: [1, { crisp: [0, { on: t }], tawk: X, tawkto: X }], emerck: e, energy: e, engineer: e, engineering: e, enterprises: e, epson: e, equipment: e, ericsson: e, erni: e, esq: e, estate: [1, { compute: a }], eurovision: e, eus: [1, { party: Ye }], events: [1, { koobin: t, co: t }], exchange: e, expert: e, exposed: e, express: e, extraspace: e, fage: e, fail: e, fairwinds: e, faith: e, family: e, fan: e, fans: e, farm: [1, { storj: t }], farmers: e, fashion: e, fast: e, fedex: e, feedback: e, ferrari: e, ferrero: e, fidelity: e, fido: e, film: e, final: e, finance: e, financial: _, fire: e, firestone: e, firmdale: e, fish: e, fishing: e, fit: e, fitness: e, flickr: e, flights: e, flir: e, florist: e, flowers: e, fly: e, foo: e, food: e, football: e, ford: e, forex: e, forsale: e, forum: e, foundation: e, fox: e, free: e, fresenius: e, frl: e, frogans: e, frontier: e, ftr: e, fujitsu: e, fun: e, fund: e, furniture: e, futbol: e, fyi: e, gal: e, gallery: e, gallo: e, gallup: e, game: e, games: [1, { pley: t, sheezy: t }], gap: e, garden: e, gay: [1, { pages: t }], gbiz: e, gdn: [1, { cnpy: t }], gea: e, gent: e, genting: e, george: e, ggee: e, gift: e, gifts: e, gives: e, giving: e, glass: e, gle: e, global: [1, { appwrite: t }], globo: e, gmail: e, gmbh: e, gmo: e, gmx: e, godaddy: e, gold: e, goldpoint: e, golf: e, goo: e, goodyear: e, goog: [1, { cloud: t, translate: t, usercontent: a }], google: e, gop: e, got: e, grainger: e, graphics: e, gratis: e, green: e, gripe: e, grocery: e, group: [1, { discourse: t }], gucci: e, guge: e, guide: e, guitars: e, guru: e, hair: e, hamburg: e, hangout: e, haus: e, hbo: e, hdfc: e, hdfcbank: e, health: [1, { hra: t }], healthcare: e, help: e, helsinki: e, here: e, hermes: e, hiphop: e, hisamitsu: e, hitachi: e, hiv: e, hkt: e, hockey: e, holdings: e, holiday: e, homedepot: e, homegoods: e, homes: e, homesense: e, honda: e, horse: e, hospital: e, host: [1, { cloudaccess: t, freesite: t, easypanel: t, fastvps: t, myfast: t, tempurl: t, wpmudev: t, iserv: t, jele: t, mircloud: t, wp2: t, half: t }], hosting: [1, { opencraft: t }], hot: e, hotel: e, hotels: e, hotmail: e, house: e, how: e, hsbc: e, hughes: e, hyatt: e, hyundai: e, ibm: e, icbc: e, ice: e, icu: e, ieee: e, ifm: e, ikano: e, imamat: e, imdb: e, immo: e, immobilien: e, inc: e, industries: e, infiniti: e, ing: e, ink: e, institute: e, insurance: e, insure: e, international: e, intuit: e, investments: e, ipiranga: e, irish: e, ismaili: e, ist: e, istanbul: e, itau: e, itv: e, jaguar: e, java: e, jcb: e, jeep: e, jetzt: e, jewelry: e, jio: e, jll: e, jmp: e, jnj: e, joburg: e, jot: e, joy: e, jpmorgan: e, jprs: e, juegos: e, juniper: e, kaufen: e, kddi: e, kerryhotels: e, kerryproperties: e, kfh: e, kia: e, kids: e, kim: e, kindle: e, kitchen: e, kiwi: e, koeln: e, komatsu: e, kosher: e, kpmg: e, kpn: e, krd: [1, { co: t, edu: t }], kred: e, kuokgroup: e, kyoto: e, lacaixa: e, lamborghini: e, lamer: e, land: e, landrover: e, lanxess: e, lasalle: e, lat: e, latino: e, latrobe: e, law: e, lawyer: e, lds: e, lease: e, leclerc: e, lefrak: e, legal: e, lego: e, lexus: e, lgbt: e, lidl: e, life: e, lifeinsurance: e, lifestyle: e, lighting: e, like: e, lilly: e, limited: e, limo: e, lincoln: e, link: [1, { myfritz: t, cyon: t, dweb: a, inbrowser: a, nftstorage: on, mypep: t, storacha: on, w3s: on }], live: [1, { aem: t, hlx: t, ewp: a }], living: e, llc: e, llp: e, loan: e, loans: e, locker: e, locus: e, lol: [1, { omg: t }], london: e, lotte: e, lotto: e, love: e, lpl: e, lplfinancial: e, ltd: e, ltda: e, lundbeck: e, luxe: e, luxury: e, madrid: e, maif: e, maison: e, makeup: e, man: e, management: e, mango: e, map: e, market: e, marketing: e, markets: e, marriott: e, marshalls: e, mattel: e, mba: e, mckinsey: e, med: e, media: bn, meet: e, melbourne: e, meme: e, memorial: e, men: e, menu: [1, { barsy: t, barsyonline: t }], merck: e, merckmsd: e, miami: e, microsoft: e, mini: e, mint: e, mit: e, mitsubishi: e, mlb: e, mls: e, mma: e, mobile: e, moda: e, moe: e, moi: e, mom: e, monash: e, money: e, monster: e, mormon: e, mortgage: e, moscow: e, moto: e, motorcycles: e, mov: e, movie: e, msd: e, mtn: e, mtr: e, music: e, nab: e, nagoya: e, navy: e, nba: e, nec: e, netbank: e, netflix: e, network: [1, { aem: t, alces: a, co: t, arvo: t, azimuth: t, tlon: t }], neustar: e, new: e, news: [1, { noticeable: t }], next: e, nextdirect: e, nexus: e, nfl: e, ngo: e, nhk: e, nico: e, nike: e, nikon: e, ninja: e, nissan: e, nissay: e, nokia: e, norton: e, now: e, nowruz: e, nowtv: e, nra: e, nrw: e, ntt: e, nyc: e, obi: e, observer: e, office: e, okinawa: e, olayan: e, olayangroup: e, ollo: e, omega: e, one: [1, { kin: a, service: t }], ong: [1, { obl: t }], onl: e, online: [1, { eero: t, "eero-stage": t, websitebuilder: t, barsy: t }], ooo: e, open: e, oracle: e, orange: [1, { tech: t }], organic: e, origins: e, osaka: e, otsuka: e, ott: e, ovh: [1, { nerdpol: t }], page: [1, { aem: t, hlx: t, translated: t, codeberg: t, heyflow: t, prvcy: t, rocky: t, pdns: t, plesk: t }], panasonic: e, paris: e, pars: e, partners: e, parts: e, party: e, pay: e, pccw: e, pet: e, pfizer: e, pharmacy: e, phd: e, philips: e, phone: e, photo: e, photography: e, photos: bn, physio: e, pics: e, pictet: e, pictures: [1, { 1337: t }], pid: e, pin: e, ping: e, pink: e, pioneer: e, pizza: [1, { ngrok: t }], place: _, play: e, playstation: e, plumbing: e, plus: e, pnc: e, pohl: e, poker: e, politie: e, porn: e, praxi: e, press: e, prime: e, prod: e, productions: e, prof: e, progressive: e, promo: e, properties: e, property: e, protection: e, pru: e, prudential: e, pub: [1, { id: a, kin: a, barsy: t }], pwc: e, qpon: e, quebec: e, quest: e, racing: e, radio: e, read: e, realestate: e, realtor: e, realty: e, recipes: e, red: e, redumbrella: e, rehab: e, reise: e, reisen: e, reit: e, reliance: e, ren: e, rent: e, rentals: e, repair: e, report: e, republican: e, rest: e, restaurant: e, review: e, reviews: [1, { aem: t }], rexroth: e, rich: e, richardli: e, ricoh: e, ril: e, rio: e, rip: [1, { clan: t }], rocks: [1, { myddns: t, stackit: t, "lima-city": t, webspace: t }], rodeo: e, rogers: e, room: e, rsvp: e, rugby: e, ruhr: e, run: [1, { appwrite: a, development: t, ravendb: t, liara: [2, { iran: t }], lovable: t, build: a, code: a, database: a, migration: a, onporter: t, repl: t, stackit: t, val: V, vercel: t, wix: t }], rwe: e, ryukyu: e, saarland: e, safe: e, safety: e, sakura: e, sale: e, salon: e, samsclub: e, samsung: e, sandvik: e, sandvikcoromant: e, sanofi: e, sap: e, sarl: e, sas: e, save: e, saxo: e, sbi: e, sbs: e, scb: e, schaeffler: e, schmidt: e, scholarships: e, school: e, schule: e, schwarz: e, science: e, scot: [1, { gov: [2, { service: t }] }], search: e, seat: e, secure: e, security: e, seek: e, select: e, sener: e, services: [1, { loginline: t }], seven: e, sew: e, sex: e, sexy: e, sfr: e, shangrila: e, sharp: e, shell: e, shia: e, shiksha: e, shoes: e, shop: [1, { base: t, hoplix: t, barsy: t, barsyonline: t, shopware: t }], shopping: e, shouji: e, show: e, silk: e, sina: e, singles: e, site: [1, { square: t, canva: S, cloudera: a, convex: t, cyon: t, caffeine: t, fastvps: t, figma: t, preview: t, heyflow: t, jele: t, jouwweb: t, loginline: t, barsy: t, notion: t, omniwe: t, opensocial: t, madethis: t, platformsh: a, tst: a, byen: t, srht: t, novecore: t, cpanel: t, wpsquared: t, sourcecraft: t }], ski: e, skin: e, sky: e, skype: e, sling: e, smart: e, smile: e, sncf: e, soccer: e, social: e, softbank: e, software: e, sohu: e, solar: e, solutions: e, song: e, sony: e, soy: e, spa: e, space: [1, { myfast: t, heiyu: t, hf: [2, { static: t }], "app-ionos": t, project: t, uber: t, xs4all: t }], sport: e, spot: e, srl: e, stada: e, staples: e, star: e, statebank: e, statefarm: e, stc: e, stcgroup: e, stockholm: e, storage: e, store: [1, { barsy: t, sellfy: t, shopware: t, storebase: t }], stream: e, studio: e, study: e, style: e, sucks: e, supplies: e, supply: e, support: [1, { barsy: t }], surf: e, surgery: e, suzuki: e, swatch: e, swiss: e, sydney: e, systems: [1, { knightpoint: t }], tab: e, taipei: e, talk: e, taobao: e, target: e, tatamotors: e, tatar: e, tattoo: e, tax: e, taxi: e, tci: e, tdk: e, team: [1, { discourse: t, jelastic: t }], tech: [1, { cleverapps: t }], technology: _, temasek: e, tennis: e, teva: e, thd: e, theater: e, theatre: e, tiaa: e, tickets: e, tienda: e, tips: e, tires: e, tirol: e, tjmaxx: e, tjx: e, tkmaxx: e, tmall: e, today: [1, { prequalifyme: t }], tokyo: e, tools: [1, { addr: ne, myaddr: t }], top: [1, { ntdll: t, wadl: a }], toray: e, toshiba: e, total: e, tours: e, town: e, toyota: e, toys: e, trade: e, trading: e, training: e, travel: e, travelers: e, travelersinsurance: e, trust: e, trv: e, tube: e, tui: e, tunes: e, tushu: e, tvs: e, ubank: e, ubs: e, unicom: e, university: e, uno: e, uol: e, ups: e, vacations: e, vana: e, vanguard: e, vegas: e, ventures: e, verisign: e, versicherung: e, vet: e, viajes: e, video: e, vig: e, viking: e, villas: e, vin: e, vip: [1, { hidns: t }], virgin: e, visa: e, vision: e, viva: e, vivo: e, vlaanderen: e, vodka: e, volvo: e, vote: e, voting: e, voto: e, voyage: e, wales: e, walmart: e, walter: e, wang: e, wanggou: e, watch: e, watches: e, weather: e, weatherchannel: e, webcam: e, weber: e, website: bn, wed: e, wedding: e, weibo: e, weir: e, whoswho: e, wien: e, wiki: bn, williamhill: e, win: e, windows: e, wine: e, winners: e, wme: e, wolterskluwer: e, woodside: e, work: e, works: e, world: e, wow: e, wtc: e, wtf: e, xbox: e, xerox: e, xihuan: e, xin: e, "xn--11b4c3d": e, कॉम: e, "xn--1ck2e1b": e, セール: e, "xn--1qqw23a": e, 佛山: e, "xn--30rr7y": e, 慈善: e, "xn--3bst00m": e, 集团: e, "xn--3ds443g": e, 在线: e, "xn--3pxu8k": e, 点看: e, "xn--42c2d9a": e, คอม: e, "xn--45q11c": e, 八卦: e, "xn--4gbrim": e, موقع: e, "xn--55qw42g": e, 公益: e, "xn--55qx5d": e, 公司: e, "xn--5su34j936bgsg": e, 香格里拉: e, "xn--5tzm5g": e, 网站: e, "xn--6frz82g": e, 移动: e, "xn--6qq986b3xl": e, 我爱你: e, "xn--80adxhks": e, москва: e, "xn--80aqecdr1a": e, католик: e, "xn--80asehdb": e, онлайн: e, "xn--80aswg": e, сайт: e, "xn--8y0a063a": e, 联通: e, "xn--9dbq2a": e, קום: e, "xn--9et52u": e, 时尚: e, "xn--9krt00a": e, 微博: e, "xn--b4w605ferd": e, 淡马锡: e, "xn--bck1b9a5dre4c": e, ファッション: e, "xn--c1avg": e, орг: e, "xn--c2br7g": e, नेट: e, "xn--cck2b3b": e, ストア: e, "xn--cckwcxetd": e, アマゾン: e, "xn--cg4bki": e, 삼성: e, "xn--czr694b": e, 商标: e, "xn--czrs0t": e, 商店: e, "xn--czru2d": e, 商城: e, "xn--d1acj3b": e, дети: e, "xn--eckvdtc9d": e, ポイント: e, "xn--efvy88h": e, 新闻: e, "xn--fct429k": e, 家電: e, "xn--fhbei": e, كوم: e, "xn--fiq228c5hs": e, 中文网: e, "xn--fiq64b": e, 中信: e, "xn--fjq720a": e, 娱乐: e, "xn--flw351e": e, 谷歌: e, "xn--fzys8d69uvgm": e, 電訊盈科: e, "xn--g2xx48c": e, 购物: e, "xn--gckr3f0f": e, クラウド: e, "xn--gk3at1e": e, 通販: e, "xn--hxt814e": e, 网店: e, "xn--i1b6b1a6a2e": e, संगठन: e, "xn--imr513n": e, 餐厅: e, "xn--io0a7i": e, 网络: e, "xn--j1aef": e, ком: e, "xn--jlq480n2rg": e, 亚马逊: e, "xn--jvr189m": e, 食品: e, "xn--kcrx77d1x4a": e, 飞利浦: e, "xn--kput3i": e, 手机: e, "xn--mgba3a3ejt": e, ارامكو: e, "xn--mgba7c0bbn0a": e, العليان: e, "xn--mgbab2bd": e, بازار: e, "xn--mgbca7dzdo": e, ابوظبي: e, "xn--mgbi4ecexp": e, كاثوليك: e, "xn--mgbt3dhd": e, همراه: e, "xn--mk1bu44c": e, 닷컴: e, "xn--mxtq1m": e, 政府: e, "xn--ngbc5azd": e, شبكة: e, "xn--ngbe9e0a": e, بيتك: e, "xn--ngbrx": e, عرب: e, "xn--nqv7f": e, 机构: e, "xn--nqv7fs00ema": e, 组织机构: e, "xn--nyqy26a": e, 健康: e, "xn--otu796d": e, 招聘: e, "xn--p1acf": [1, { "xn--90amc": t, "xn--j1aef": t, "xn--j1ael8b": t, "xn--h1ahn": t, "xn--j1adp": t, "xn--c1avg": t, "xn--80aaa0cvac": t, "xn--h1aliz": t, "xn--90a1af": t, "xn--41a": t }], рус: [1, { биз: t, ком: t, крым: t, мир: t, мск: t, орг: t, самара: t, сочи: t, спб: t, я: t }], "xn--pssy2u": e, 大拿: e, "xn--q9jyb4c": e, みんな: e, "xn--qcka1pmc": e, グーグル: e, "xn--rhqv96g": e, 世界: e, "xn--rovu88b": e, 書籍: e, "xn--ses554g": e, 网址: e, "xn--t60b56a": e, 닷넷: e, "xn--tckwe": e, コム: e, "xn--tiq49xqyj": e, 天主教: e, "xn--unup4y": e, 游戏: e, "xn--vermgensberater-ctb": e, vermögensberater: e, "xn--vermgensberatung-pwb": e, vermögensberatung: e, "xn--vhquv": e, 企业: e, "xn--vuq861b": e, 信息: e, "xn--w4r85el8fhu5dnra": e, 嘉里大酒店: e, "xn--w4rs40l": e, 嘉里: e, "xn--xhq521b": e, 广东: e, "xn--zfr164b": e, 政务: e, xyz: [1, { botdash: t, telebit: a }], yachts: e, yahoo: e, yamaxun: e, yandex: e, yodobashi: e, yoga: e, yokohama: e, you: e, youtube: e, yun: e, zappos: e, zara: e, zero: e, zip: e, zone: [1, { triton: a, stackit: t, lima: t }], zuerich: e }];
}();
function jp(e, t, n, o) {
  let a = null, r = t;
  for (; r !== void 0 && ((r[0] & o) !== 0 && (a = {
    index: n + 1,
    isIcann: r[0] === 1,
    isPrivate: r[0] === 2
  }), n !== -1); ) {
    const i = r[1];
    r = Object.prototype.hasOwnProperty.call(i, e[n]) ? i[e[n]] : i["*"], n -= 1;
  }
  return a;
}
function H6(e, t, n) {
  var o;
  if (V6(e, t, n))
    return;
  const a = e.split("."), r = (t.allowPrivateDomains ? 2 : 0) | (t.allowIcannDomains ? 1 : 0), i = jp(a, U6, a.length - 1, r);
  if (i !== null) {
    n.isIcann = i.isIcann, n.isPrivate = i.isPrivate, n.publicSuffix = a.slice(i.index + 1).join(".");
    return;
  }
  const s = jp(a, q6, a.length - 1, r);
  if (s !== null) {
    n.isIcann = s.isIcann, n.isPrivate = s.isPrivate, n.publicSuffix = a.slice(s.index).join(".");
    return;
  }
  n.isIcann = !1, n.isPrivate = !1, n.publicSuffix = (o = a[a.length - 1]) !== null && o !== void 0 ? o : null;
}
const Rp = F6();
function K6(e, t = {}) {
  return W6(Rp), B6(e, 3, H6, t, Rp).domain;
}
function t_(e, t) {
  return !!(t === e || e.indexOf(t) === 0 && (t[t.length - 1] === "/" || e.startsWith(t) && e[t.length] === "/"));
}
var Ip = ["local", "example", "invalid", "localhost", "test"], G6 = ["localhost", "invalid"], Z6 = {
  allowSpecialUseDomain: !1,
  ignoreError: !1
};
function Zu(e, t = {}) {
  t = { ...Z6, ...t };
  const n = e.split("."), o = n[n.length - 1], a = !!t.allowSpecialUseDomain, r = !!t.ignoreError;
  if (a && o !== void 0 && Ip.includes(o)) {
    if (n.length > 1)
      return `${n[n.length - 2]}.${o}`;
    if (G6.includes(o))
      return o;
  }
  if (!r && o !== void 0 && Ip.includes(o))
    throw new Error(
      `Cookie has domain set to the public suffix "${o}" which is a special use domain. To allow this, configure your CookieJar with {allowSpecialUseDomain: true, rejectPublicSuffixes: false}.`
    );
  const i = K6(e, {
    allowIcannDomains: !0,
    allowPrivateDomains: !0
  });
  if (i) return i;
}
function J6(e, t) {
  const n = Zu(e, {
    allowSpecialUseDomain: t
  });
  if (!n)
    return;
  if (n == e)
    return [e];
  e.slice(-1) == "." && (e = e.slice(0, -1));
  const o = e.slice(0, -(n.length + 1)).split(".").reverse();
  let a = n;
  const r = [a];
  for (; o.length; )
    a = `${o.shift()}.${a}`, r.push(a);
  return r;
}
var n_ = class {
  constructor() {
    this.synchronous = !1;
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(e, t, n, o) {
    throw new Error("findCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(e, t, n = !1, o) {
    throw new Error("findCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(e, t) {
    throw new Error("putCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(e, t, n) {
    throw new Error("updateCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(e, t, n, o) {
    throw new Error("removeCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(e, t, n) {
    throw new Error("removeCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(e) {
    throw new Error("removeAllCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(e) {
    throw new Error(
      "getAllCookies is not implemented (therefore jar cannot be serialized)"
    );
  }
}, Ju = (e) => Object.prototype.toString.call(e), Y6 = (e, t) => typeof e.join != "function" ? Ju(e) : (t.add(e), e.map(
  (n) => n == null || t.has(n) ? "" : o_(n, t)
).join()), o_ = (e, t = /* @__PURE__ */ new WeakSet()) => typeof e != "object" || e === null ? String(e) : typeof e.toString == "function" ? Array.isArray(e) ? (
  // Arrays have a weird custom toString that we need to replicate
  Y6(e, t)
) : (
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  String(e)
) : Ju(e), mc = (e) => o_(e);
function ot(e) {
  let t, n, o;
  const a = new Promise((r, i) => {
    n = r, o = i;
  });
  return typeof e == "function" ? t = (r, i) => {
    try {
      r ? e(r) : e(null, i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  } : t = (r, i) => {
    try {
      r ? o(r) : n(i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  }, {
    promise: a,
    callback: t,
    resolve: (r) => (t(null, r), a),
    reject: (r) => (t(r), a)
  };
}
function ka(e, t) {
  return e in t;
}
var a_ = class extends n_ {
  /**
   * Create a new {@link MemoryCookieStore}.
   */
  constructor() {
    super(), this.synchronous = !0, this.idx = /* @__PURE__ */ Object.create(null);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(t, n, o, a) {
    const r = ot(a);
    if (t == null || n == null || o == null)
      return r.resolve(void 0);
    const i = this.idx[t]?.[n]?.[o];
    return r.resolve(i);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(t, n, o = !1, a) {
    typeof o == "function" && (a = o, o = !0);
    const r = [], i = ot(a);
    if (!t)
      return i.resolve([]);
    let s;
    n ? s = function(u) {
      for (const d in u)
        if (t_(n, d)) {
          const m = u[d];
          for (const f in m) {
            const g = m[f];
            g && r.push(g);
          }
        }
    } : s = function(u) {
      for (const d in u) {
        const m = u[d];
        for (const f in m) {
          const g = m[f];
          g && r.push(g);
        }
      }
    };
    const l = J6(t, o) || [t], c = this.idx;
    return l.forEach((u) => {
      const d = c[u];
      d && s(d);
    }), i.resolve(r);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(t, n) {
    const o = ot(n), { domain: a, path: r, key: i } = t;
    if (a == null || r == null || i == null)
      return o.resolve(void 0);
    const s = this.idx[a] ?? /* @__PURE__ */ Object.create(null);
    this.idx[a] = s;
    const l = s[r] ?? /* @__PURE__ */ Object.create(null);
    return s[r] = l, l[i] = t, o.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(t, n, o) {
    if (o) this.putCookie(n, o);
    else return this.putCookie(n);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(t, n, o, a) {
    const r = ot(a);
    return delete this.idx[t]?.[n]?.[o], r.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(t, n, o) {
    const a = ot(o), r = this.idx[t];
    return r && (n ? delete r[n] : delete this.idx[t]), a.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(t) {
    const n = ot(t);
    return this.idx = /* @__PURE__ */ Object.create(null), n.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(t) {
    const n = ot(t), o = [], a = this.idx;
    return Object.keys(a).forEach((r) => {
      const i = a[r] ?? {};
      Object.keys(i).forEach((s) => {
        const l = i[s] ?? {};
        Object.keys(l).forEach((c) => {
          const u = l[c];
          u != null && o.push(u);
        });
      });
    }), o.sort((r, i) => (r.creationIndex || 0) - (i.creationIndex || 0)), n.resolve(o);
  }
};
function ml(e) {
  return r_(e) && e !== "";
}
function Yu(e) {
  return e === "" || e instanceof String && e.toString() === "";
}
function r_(e) {
  return typeof e == "string" || e instanceof String;
}
function Jr(e) {
  return Ju(e) === "[object Object]";
}
function da(e, t, n) {
  if (e) return;
  const o = typeof t == "function" ? t : void 0;
  let a = typeof t == "function" ? n : t;
  Jr(a) || (a = "[object Object]");
  const r = new i_(mc(a));
  if (o) o(r);
  else throw r;
}
var i_ = class extends Error {
}, X6 = "6.0.0", Bn = {
  SILENT: "silent",
  STRICT: "strict",
  DISABLED: "unsafe-disabled"
};
Object.freeze(Bn);
var Q6 = `
\\[?(?:
(?:[a-fA-F\\d]{1,4}:){7}(?:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,2}|:)|
(?:[a-fA-F\\d]{1,4}:){4}(?:(?::[a-fA-F\\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,3}|:)|
(?:[a-fA-F\\d]{1,4}:){3}(?:(?::[a-fA-F\\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){2}(?:(?::[a-fA-F\\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,5}|:)|
(?:[a-fA-F\\d]{1,4}:){1}(?:(?::[a-fA-F\\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,6}|:)|
(?::(?:(?::[a-fA-F\\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,7}|:))
)(?:%[0-9a-zA-Z]{1,})?\\]?
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), Xu = new RegExp(`^${Q6}$`), e5 = "(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])", t5 = new RegExp(`^${e5}$`);
function Tp(e) {
  return new URL(`http://${e}`).hostname;
}
function Ei(e) {
  if (e == null)
    return;
  let t = e.trim().replace(/^\./, "");
  return Xu.test(t) ? (t.startsWith("[") || (t = "[" + t), t.endsWith("]") || (t = t + "]"), Tp(t).slice(1, -1)) : /[^\u0001-\u007f]/.test(t) ? Tp(t) : t.toLowerCase();
}
function n5(e) {
  return e.toUTCString();
}
var o5 = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/, $t = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11
};
function fc(e, t, n, o) {
  let a = 0;
  for (; a < e.length; ) {
    const r = e.charCodeAt(a);
    if (r <= 47 || r >= 58)
      break;
    a++;
  }
  if (!(a < t || a > n) && !(!o && a != e.length))
    return parseInt(e.slice(0, a), 10);
}
function a5(e) {
  const t = e.split(":"), n = [0, 0, 0];
  if (t.length === 3) {
    for (let o = 0; o < 3; o++) {
      const a = o == 2, r = t[o];
      if (r === void 0)
        return;
      const i = fc(r, 1, 2, a);
      if (i === void 0)
        return;
      n[o] = i;
    }
    return n;
  }
}
function r5(e) {
  switch (e = String(e).slice(0, 3).toLowerCase(), e) {
    case "jan":
      return $t.jan;
    case "feb":
      return $t.feb;
    case "mar":
      return $t.mar;
    case "apr":
      return $t.apr;
    case "may":
      return $t.may;
    case "jun":
      return $t.jun;
    case "jul":
      return $t.jul;
    case "aug":
      return $t.aug;
    case "sep":
      return $t.sep;
    case "oct":
      return $t.oct;
    case "nov":
      return $t.nov;
    case "dec":
      return $t.dec;
    default:
      return;
  }
}
function gc(e) {
  if (!e)
    return;
  const t = e.split(o5);
  let n, o, a, r, i, s;
  for (let l = 0; l < t.length; l++) {
    const c = (t[l] ?? "").trim();
    if (c.length) {
      if (a === void 0) {
        const u = a5(c);
        if (u) {
          n = u[0], o = u[1], a = u[2];
          continue;
        }
      }
      if (r === void 0) {
        const u = fc(c, 1, 2, !0);
        if (u !== void 0) {
          r = u;
          continue;
        }
      }
      if (i === void 0) {
        const u = r5(c);
        if (u !== void 0) {
          i = u;
          continue;
        }
      }
      if (s === void 0) {
        const u = fc(c, 2, 4, !0);
        u !== void 0 && (s = u, s >= 70 && s <= 99 ? s += 1900 : s >= 0 && s <= 69 && (s += 2e3));
      }
    }
  }
  if (!(r === void 0 || i === void 0 || s === void 0 || n === void 0 || o === void 0 || a === void 0 || r < 1 || r > 31 || s < 1601 || n > 23 || o > 59 || a > 59))
    return new Date(Date.UTC(s, i, r, n, o, a));
}
var i5 = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/, s5 = /[\x20-\x3A\x3C-\x7E]+/, Pp = /[\x00-\x1F]/, Dp = [`
`, "\r", "\0"];
function l5(e) {
  if (Yu(e)) return e;
  for (let t = 0; t < Dp.length; t++) {
    const n = Dp[t], o = n ? e.indexOf(n) : -1;
    o !== -1 && (e = e.slice(0, o));
  }
  return e;
}
function c5(e, t) {
  e = l5(e);
  let n = e.indexOf("=");
  if (t)
    n === 0 && (e = e.substring(1), n = e.indexOf("="));
  else if (n <= 0)
    return;
  let o, a;
  if (n <= 0 ? (o = "", a = e.trim()) : (o = e.slice(0, n).trim(), a = e.slice(n + 1).trim()), Pp.test(o) || Pp.test(a))
    return;
  const r = new bt();
  return r.key = o, r.value = a, r;
}
function u5(e, t) {
  if (Yu(e) || !r_(e))
    return;
  e = e.trim();
  const n = e.indexOf(";"), o = n === -1 ? e : e.slice(0, n), a = c5(o, t?.loose ?? !1);
  if (!a)
    return;
  if (n === -1)
    return a;
  const r = e.slice(n + 1).trim();
  if (r.length === 0)
    return a;
  const i = r.split(";");
  for (; i.length; ) {
    const s = (i.shift() ?? "").trim();
    if (s.length === 0)
      continue;
    const l = s.indexOf("=");
    let c, u;
    switch (l === -1 ? (c = s, u = null) : (c = s.slice(0, l), u = s.slice(l + 1)), c = c.trim().toLowerCase(), u && (u = u.trim()), c) {
      case "expires":
        if (u) {
          const d = gc(u);
          d && (a.expires = d);
        }
        break;
      case "max-age":
        if (u && /^-?[0-9]+$/.test(u)) {
          const d = parseInt(u, 10);
          a.setMaxAge(d);
        }
        break;
      case "domain":
        if (u) {
          const d = u.trim().replace(/^\./, "");
          d && (a.domain = d.toLowerCase());
        }
        break;
      case "path":
        a.path = u && u[0] === "/" ? u : null;
        break;
      case "secure":
        a.secure = !0;
        break;
      case "httponly":
        a.httpOnly = !0;
        break;
      case "samesite":
        switch (u ? u.toLowerCase() : "") {
          case "strict":
            a.sameSite = "strict";
            break;
          case "lax":
            a.sameSite = "lax";
            break;
          case "none":
            a.sameSite = "none";
            break;
          default:
            a.sameSite = void 0;
            break;
        }
        break;
      default:
        a.extensions = a.extensions || [], a.extensions.push(s);
        break;
    }
  }
  return a;
}
function Lp(e) {
  if (!e || Yu(e))
    return;
  let t;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return;
    }
  else
    t = e;
  const n = new bt();
  return bt.serializableProperties.forEach((o) => {
    if (t && typeof t == "object" && ka(o, t)) {
      const a = t[o];
      if (a === void 0 || ka(o, Xe) && a === Xe[o])
        return;
      switch (o) {
        case "key":
        case "value":
        case "sameSite":
          typeof a == "string" && (n[o] = a);
          break;
        case "expires":
        case "creation":
        case "lastAccessed":
          typeof a == "number" || typeof a == "string" || a instanceof Date ? n[o] = t[o] == "Infinity" ? "Infinity" : new Date(a) : a === null && (n[o] = null);
          break;
        case "maxAge":
          (typeof a == "number" || a === "Infinity" || a === "-Infinity") && (n[o] = a);
          break;
        case "domain":
        case "path":
          (typeof a == "string" || a === null) && (n[o] = a);
          break;
        case "secure":
        case "httpOnly":
          typeof a == "boolean" && (n[o] = a);
          break;
        case "extensions":
          Array.isArray(a) && a.every((r) => typeof r == "string") && (n[o] = a);
          break;
        case "hostOnly":
        case "pathIsDefault":
          (typeof a == "boolean" || a === null) && (n[o] = a);
          break;
      }
    }
  }), n;
}
var Xe = {
  // the order in which the RFC has them:
  key: "",
  value: "",
  expires: "Infinity",
  maxAge: null,
  domain: null,
  path: null,
  secure: !1,
  httpOnly: !1,
  extensions: null,
  // set by the CookieJar:
  hostOnly: null,
  pathIsDefault: null,
  creation: null,
  lastAccessed: null,
  sameSite: void 0
}, Ga = class kn {
  /**
   * Create a new Cookie instance.
   * @public
   * @param options - The attributes to set on the cookie
   */
  constructor(t = {}) {
    this.key = t.key ?? Xe.key, this.value = t.value ?? Xe.value, this.expires = t.expires ?? Xe.expires, this.maxAge = t.maxAge ?? Xe.maxAge, this.domain = t.domain ?? Xe.domain, this.path = t.path ?? Xe.path, this.secure = t.secure ?? Xe.secure, this.httpOnly = t.httpOnly ?? Xe.httpOnly, this.extensions = t.extensions ?? Xe.extensions, this.creation = t.creation ?? Xe.creation, this.hostOnly = t.hostOnly ?? Xe.hostOnly, this.pathIsDefault = t.pathIsDefault ?? Xe.pathIsDefault, this.lastAccessed = t.lastAccessed ?? Xe.lastAccessed, this.sameSite = t.sameSite ?? Xe.sameSite, this.creation = t.creation ?? /* @__PURE__ */ new Date(), Object.defineProperty(this, "creationIndex", {
      configurable: !1,
      enumerable: !1,
      // important for assert.deepEqual checks
      writable: !0,
      value: ++kn.cookiesCreated
    }), this.creationIndex = kn.cookiesCreated;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    const t = Date.now(), n = this.hostOnly != null ? this.hostOnly.toString() : "?", o = this.creation && this.creation !== "Infinity" ? `${String(t - this.creation.getTime())}ms` : "?", a = this.lastAccessed && this.lastAccessed !== "Infinity" ? `${String(t - this.lastAccessed.getTime())}ms` : "?";
    return `Cookie="${this.toString()}; hostOnly=${n}; aAge=${a}; cAge=${o}"`;
  }
  /**
   * For convenience in using `JSON.stringify(cookie)`. Returns a plain-old Object that can be JSON-serialized.
   *
   * @remarks
   * - Any `Date` properties (such as {@link Cookie.expires}, {@link Cookie.creation}, and {@link Cookie.lastAccessed}) are exported in ISO format (`Date.toISOString()`).
   *
   *  - Custom Cookie properties are discarded. In tough-cookie 1.x, since there was no {@link Cookie.toJSON} method explicitly defined, all enumerable properties were captured.
   *      If you want a property to be serialized, add the property name to {@link Cookie.serializableProperties}.
   */
  toJSON() {
    const t = {};
    for (const n of kn.serializableProperties) {
      const o = this[n];
      if (o !== Xe[n])
        switch (n) {
          case "key":
          case "value":
          case "sameSite":
            typeof o == "string" && (t[n] = o);
            break;
          case "expires":
          case "creation":
          case "lastAccessed":
            typeof o == "number" || typeof o == "string" || o instanceof Date ? t[n] = o == "Infinity" ? "Infinity" : new Date(o).toISOString() : o === null && (t[n] = null);
            break;
          case "maxAge":
            (typeof o == "number" || o === "Infinity" || o === "-Infinity") && (t[n] = o);
            break;
          case "domain":
          case "path":
            (typeof o == "string" || o === null) && (t[n] = o);
            break;
          case "secure":
          case "httpOnly":
            typeof o == "boolean" && (t[n] = o);
            break;
          case "extensions":
            Array.isArray(o) && (t[n] = o);
            break;
          case "hostOnly":
          case "pathIsDefault":
            (typeof o == "boolean" || o === null) && (t[n] = o);
            break;
        }
    }
    return t;
  }
  /**
   * Does a deep clone of this cookie, implemented exactly as `Cookie.fromJSON(cookie.toJSON())`.
   * @public
   */
  clone() {
    return Lp(this.toJSON());
  }
  /**
   * Validates cookie attributes for semantic correctness. Useful for "lint" checking any `Set-Cookie` headers you generate.
   * For now, it returns a boolean, but eventually could return a reason string.
   *
   * @remarks
   * Works for a few things, but is by no means comprehensive.
   *
   * @beta
   */
  validate() {
    if (!this.value || !i5.test(this.value) || this.expires != "Infinity" && !(this.expires instanceof Date) && !gc(this.expires) || this.maxAge != null && this.maxAge !== "Infinity" && (this.maxAge === "-Infinity" || this.maxAge <= 0) || this.path != null && !s5.test(this.path))
      return !1;
    const t = this.cdomain();
    return !(t && (t.match(/\.$/) || Zu(t) == null));
  }
  /**
   * Sets the 'Expires' attribute on a cookie.
   *
   * @remarks
   * When given a `string` value it will be parsed with {@link parseDate}. If the value can't be parsed as a cookie date
   * then the 'Expires' attribute will be set to `"Infinity"`.
   *
   * @param exp - the new value for the 'Expires' attribute of the cookie.
   */
  setExpires(t) {
    t instanceof Date ? this.expires = t : this.expires = gc(t) || "Infinity";
  }
  /**
   * Sets the 'Max-Age' attribute (in seconds) on a cookie.
   *
   * @remarks
   * Coerces `-Infinity` to `"-Infinity"` and `Infinity` to `"Infinity"` so it can be serialized to JSON.
   *
   * @param age - the new value for the 'Max-Age' attribute (in seconds).
   */
  setMaxAge(t) {
    t === 1 / 0 ? this.maxAge = "Infinity" : t === -1 / 0 ? this.maxAge = "-Infinity" : this.maxAge = t;
  }
  /**
   * Encodes to a `Cookie` header value (specifically, the {@link Cookie.key} and {@link Cookie.value} properties joined with "=").
   * @public
   */
  cookieString() {
    const t = this.value || "";
    return this.key ? `${this.key}=${t}` : t;
  }
  /**
   * Encodes to a `Set-Cookie header` value.
   * @public
   */
  toString() {
    let t = this.cookieString();
    return this.expires != "Infinity" && this.expires instanceof Date && (t += `; Expires=${n5(this.expires)}`), this.maxAge != null && this.maxAge != 1 / 0 && (t += `; Max-Age=${String(this.maxAge)}`), this.domain && !this.hostOnly && (t += `; Domain=${this.domain}`), this.path && (t += `; Path=${this.path}`), this.secure && (t += "; Secure"), this.httpOnly && (t += "; HttpOnly"), this.sameSite && this.sameSite !== "none" && (this.sameSite.toLowerCase() === kn.sameSiteCanonical.lax.toLowerCase() ? t += `; SameSite=${kn.sameSiteCanonical.lax}` : this.sameSite.toLowerCase() === kn.sameSiteCanonical.strict.toLowerCase() ? t += `; SameSite=${kn.sameSiteCanonical.strict}` : t += `; SameSite=${this.sameSite}`), this.extensions && this.extensions.forEach((n) => {
      t += `; ${n}`;
    }), t;
  }
  /**
   * Computes the TTL relative to now (milliseconds).
   *
   * @remarks
   * - `Infinity` is returned for cookies without an explicit expiry
   *
   * - `0` is returned if the cookie is expired.
   *
   * - Otherwise a time-to-live in milliseconds is returned.
   *
   * @param now - passing an explicit value is mostly used for testing purposes since this defaults to the `Date.now()`
   * @public
   */
  TTL(t = Date.now()) {
    if (this.maxAge != null && typeof this.maxAge == "number")
      return this.maxAge <= 0 ? 0 : this.maxAge * 1e3;
    const n = this.expires;
    return n === "Infinity" ? 1 / 0 : (n?.getTime() ?? t) - (t || Date.now());
  }
  /**
   * Computes the absolute unix-epoch milliseconds that this cookie expires.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryTime(t) {
    if (this.maxAge != null) {
      const n = t || this.lastAccessed || /* @__PURE__ */ new Date(), o = typeof this.maxAge == "number" ? this.maxAge : -1 / 0, a = o <= 0 ? -1 / 0 : o * 1e3;
      return n === "Infinity" ? 1 / 0 : n.getTime() + a;
    }
    return this.expires == "Infinity" ? 1 / 0 : this.expires ? this.expires.getTime() : void 0;
  }
  /**
   * Similar to {@link Cookie.expiryTime}, computes the absolute unix-epoch milliseconds that this cookie expires and returns it as a Date.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryDate(t) {
    const n = this.expiryTime(t);
    return n == 1 / 0 ? /* @__PURE__ */ new Date(2147483647e3) : n == -1 / 0 ? /* @__PURE__ */ new Date(0) : n == null ? void 0 : new Date(n);
  }
  /**
   * Indicates if the cookie has been persisted to a store or not.
   * @public
   */
  isPersistent() {
    return this.maxAge != null || this.expires != "Infinity";
  }
  /**
   * Calls {@link canonicalDomain} with the {@link Cookie.domain} property.
   * @public
   */
  canonicalizedDomain() {
    return Ei(this.domain);
  }
  /**
   * Alias for {@link Cookie.canonicalizedDomain}
   * @public
   */
  cdomain() {
    return Ei(this.domain);
  }
  /**
   * Parses a string into a Cookie object.
   *
   * @remarks
   * Note: when parsing a `Cookie` header it must be split by ';' before each Cookie string can be parsed.
   *
   * @example
   * ```
   * // parse a `Set-Cookie` header
   * const setCookieHeader = 'a=bcd; Expires=Tue, 18 Oct 2011 07:05:03 GMT'
   * const cookie = Cookie.parse(setCookieHeader)
   * cookie.key === 'a'
   * cookie.value === 'bcd'
   * cookie.expires === new Date(Date.parse('Tue, 18 Oct 2011 07:05:03 GMT'))
   * ```
   *
   * @example
   * ```
   * // parse a `Cookie` header
   * const cookieHeader = 'name=value; name2=value2; name3=value3'
   * const cookies = cookieHeader.split(';').map(Cookie.parse)
   * cookies[0].name === 'name'
   * cookies[0].value === 'value'
   * cookies[1].name === 'name2'
   * cookies[1].value === 'value2'
   * cookies[2].name === 'name3'
   * cookies[2].value === 'value3'
   * ```
   *
   * @param str - The `Set-Cookie` header or a Cookie string to parse.
   * @param options - Configures `strict` or `loose` mode for cookie parsing
   */
  static parse(t, n) {
    return u5(t, n);
  }
  /**
   * Does the reverse of {@link Cookie.toJSON}.
   *
   * @remarks
   * Any Date properties (such as .expires, .creation, and .lastAccessed) are parsed via Date.parse, not tough-cookie's parseDate, since ISO timestamps are being handled at this layer.
   *
   * @example
   * ```
   * const json = JSON.stringify({
   *   key: 'alpha',
   *   value: 'beta',
   *   domain: 'example.com',
   *   path: '/foo',
   *   expires: '2038-01-19T03:14:07.000Z',
   * })
   * const cookie = Cookie.fromJSON(json)
   * cookie.key === 'alpha'
   * cookie.value === 'beta'
   * cookie.domain === 'example.com'
   * cookie.path === '/foo'
   * cookie.expires === new Date(Date.parse('2038-01-19T03:14:07.000Z'))
   * ```
   *
   * @param str - An unparsed JSON string or a value that has already been parsed as JSON
   */
  static fromJSON(t) {
    return Lp(t);
  }
};
Ga.cookiesCreated = 0;
Ga.sameSiteLevel = {
  strict: 3,
  lax: 2,
  none: 1
};
Ga.sameSiteCanonical = {
  strict: "Strict",
  lax: "Lax"
};
Ga.serializableProperties = [
  "key",
  "value",
  "expires",
  "maxAge",
  "domain",
  "path",
  "secure",
  "httpOnly",
  "extensions",
  "hostOnly",
  "pathIsDefault",
  "creation",
  "lastAccessed",
  "sameSite"
];
var bt = Ga, Mp = 2147483647e3;
function Fp(e, t) {
  let n;
  const o = e.path ? e.path.length : 0;
  if (n = (t.path ? t.path.length : 0) - o, n !== 0)
    return n;
  const a = e.creation && e.creation instanceof Date ? e.creation.getTime() : Mp, r = t.creation && t.creation instanceof Date ? t.creation.getTime() : Mp;
  return n = a - r, n !== 0 || (n = (e.creationIndex || 0) - (t.creationIndex || 0)), n;
}
function d5(e) {
  if (!e || e.slice(0, 1) !== "/")
    return "/";
  if (e === "/")
    return e;
  const t = e.lastIndexOf("/");
  return t === 0 ? "/" : e.slice(0, t);
}
var h5 = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-f\d]{1,4}:){7}(?:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,2}|:)|(?:[a-f\d]{1,4}:){4}(?:(?::[a-f\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,3}|:)|(?:[a-f\d]{1,4}:){3}(?:(?::[a-f\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,4}|:)|(?:[a-f\d]{1,4}:){2}(?:(?::[a-f\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,5}|:)|(?:[a-f\d]{1,4}:){1}(?:(?::[a-f\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,6}|:)|(?::(?:(?::[a-f\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,7}|:)))$)/;
function Wp(e, t, n) {
  if (e == null || t == null)
    return;
  let o, a;
  if (o = e, a = t, o == null || a == null)
    return;
  if (o == a)
    return !0;
  const r = o.lastIndexOf(a);
  return r <= 0 || o.length !== a.length + r || o.substring(r - 1, r) !== "." ? !1 : !h5.test(o);
}
function p5(e) {
  const t = e.split(".");
  return t.length === 4 && t[0] !== void 0 && parseInt(t[0], 10) === 127;
}
function m5(e) {
  return e === "::1";
}
function f5(e) {
  return e.endsWith(".localhost");
}
function g5(e) {
  const t = e.toLowerCase();
  return t === "localhost" || f5(t);
}
function b5(e) {
  return e.length >= 2 && e.startsWith("[") && e.endsWith("]") ? e.substring(1, e.length - 1) : e;
}
function v5(e, t = !0) {
  let n;
  if (typeof e == "string")
    try {
      n = new URL(e);
    } catch {
      return !1;
    }
  else
    n = e;
  const o = n.protocol.replace(":", "").toLowerCase(), a = b5(n.hostname).replace(/\.+$/, "");
  return o === "https" || o === "wss" ? !0 : t ? t5.test(a) ? p5(a) : Xu.test(a) ? m5(a) : g5(a) : !1;
}
var y5 = {
  loose: !1,
  sameSiteContext: void 0,
  ignoreError: !1,
  http: !0
}, Bp = {
  http: !0,
  expire: !0,
  allPaths: !1,
  sameSiteContext: void 0,
  sort: void 0
}, fl = 'Invalid sameSiteContext option for getCookies(); expected one of "strict", "lax", or "none"';
function Vp(e) {
  if (e && typeof e == "object" && "hostname" in e && typeof e.hostname == "string" && "pathname" in e && typeof e.pathname == "string" && "protocol" in e && typeof e.protocol == "string")
    return {
      hostname: e.hostname,
      pathname: e.pathname,
      protocol: e.protocol
    };
  if (typeof e == "string")
    try {
      return new URL(decodeURI(e));
    } catch {
      return new URL(e);
    }
  else
    throw new i_("`url` argument is not a string or URL.");
}
function Up(e) {
  const t = String(e).toLowerCase();
  if (t === "none" || t === "lax" || t === "strict")
    return t;
}
function _5(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Secure-")) || e.secure;
}
function w5(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Host-")) || !!(e.secure && e.hostOnly && e.path != null && e.path === "/");
}
function $r(e) {
  const t = e.toLowerCase();
  switch (t) {
    case Bn.STRICT:
    case Bn.SILENT:
    case Bn.DISABLED:
      return t;
    default:
      return Bn.SILENT;
  }
}
var k5 = class ma {
  /**
   * Creates a new `CookieJar` instance.
   *
   * @remarks
   * - If a custom store is not passed to the constructor, an in-memory store ({@link MemoryCookieStore} will be created and used.
   * - If a boolean value is passed as the `options` parameter, this is equivalent to passing `{ rejectPublicSuffixes: <value> }`
   *
   * @param store - a custom {@link Store} implementation (defaults to {@link MemoryCookieStore})
   * @param options - configures how cookies are processed by the cookie jar
   */
  constructor(t, n) {
    typeof n == "boolean" && (n = { rejectPublicSuffixes: n }), this.rejectPublicSuffixes = n?.rejectPublicSuffixes ?? !0, this.enableLooseMode = n?.looseMode ?? !1, this.allowSpecialUseDomain = n?.allowSpecialUseDomain ?? !0, this.allowSecureOnLocal = n?.allowSecureOnLocal ?? !0, this.prefixSecurity = $r(
      n?.prefixSecurity ?? "silent"
    ), this.store = t ?? new a_();
  }
  callSync(t) {
    if (!this.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    let n = null, o;
    try {
      t.call(this, (a, r) => {
        n = a, o = r;
      });
    } catch (a) {
      n = a;
    }
    if (n) throw n;
    return o;
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  setCookie(t, n, o, a) {
    typeof o == "function" && (a = o, o = void 0);
    const r = ot(a), i = r.callback;
    let s;
    try {
      if (typeof n == "string" && da(
        ml(n),
        a,
        mc(o)
      ), s = Vp(n), typeof n == "function")
        return r.reject(new Error("No URL was specified"));
      if (typeof o == "function" && (o = y5), da(typeof i == "function", i), !ml(t) && !Jr(t) && t instanceof String && t.length == 0)
        return r.resolve(void 0);
    } catch (p) {
      return r.reject(p);
    }
    const l = Ei(s.hostname) ?? null, c = o?.loose || this.enableLooseMode;
    let u = null;
    if (o?.sameSiteContext && (u = Up(o.sameSiteContext), !u))
      return r.reject(new Error(fl));
    if (typeof t == "string" || t instanceof String) {
      const p = bt.parse(t.toString(), { loose: c });
      if (!p) {
        const b = new Error("Cookie failed to parse");
        return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
      }
      t = p;
    } else if (!(t instanceof bt)) {
      const p = new Error(
        "First argument to setCookie must be a Cookie object or string"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    const d = o?.now || /* @__PURE__ */ new Date();
    if (this.rejectPublicSuffixes && t.domain)
      try {
        const p = t.cdomain();
        if ((typeof p == "string" ? Zu(p, {
          allowSpecialUseDomain: this.allowSpecialUseDomain,
          ignoreError: o?.ignoreError
        }) : null) == null && !Xu.test(t.domain)) {
          const b = new Error("Cookie has domain set to a public suffix");
          return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
        }
      } catch (p) {
        return o?.ignoreError ? r.resolve(void 0) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          r.reject(p)
        );
      }
    if (t.domain) {
      if (!Wp(l ?? void 0, t.cdomain() ?? void 0)) {
        const p = new Error(
          `Cookie not in this host's domain. Cookie:${t.cdomain() ?? "null"} Request:${l ?? "null"}`
        );
        return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
      }
      t.hostOnly == null && (t.hostOnly = !1);
    } else
      t.hostOnly = !0, t.domain = l;
    if ((!t.path || t.path[0] !== "/") && (t.path = d5(s.pathname), t.pathIsDefault = !0), o?.http === !1 && t.httpOnly) {
      const p = new Error("Cookie is HttpOnly and this isn't an HTTP API");
      return o.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    if (t.sameSite !== "none" && t.sameSite !== void 0 && u && u === "none") {
      const p = new Error(
        "Cookie is SameSite but this is a cross-origin request"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    const m = this.prefixSecurity === Bn.SILENT;
    if (this.prefixSecurity !== Bn.DISABLED) {
      let p = !1, b;
      if (_5(t) ? w5(t) || (p = !0, b = "Cookie has __Host prefix but either Secure or HostOnly attribute is not set or Path is not '/'") : (p = !0, b = "Cookie has __Secure prefix but Secure attribute is not set"), p)
        return o?.ignoreError || m ? r.resolve(void 0) : r.reject(new Error(b));
    }
    const f = this.store;
    f.updateCookie || (f.updateCookie = async function(p, b, w) {
      return this.putCookie(b).then(
        () => w?.(null),
        (y) => w?.(y)
      );
    });
    const g = function(p, b) {
      if (p) {
        i(p);
        return;
      }
      const w = function(y) {
        y ? i(y) : typeof t == "string" ? i(null, void 0) : i(null, t);
      };
      if (b) {
        if (o && "http" in o && o.http === !1 && b.httpOnly) {
          p = new Error("old Cookie is HttpOnly and this isn't an HTTP API"), o.ignoreError ? i(null, void 0) : i(p);
          return;
        }
        t instanceof bt && (t.creation = b.creation, t.creationIndex = b.creationIndex, t.lastAccessed = d, f.updateCookie(b, t, w));
      } else
        t instanceof bt && (t.creation = t.lastAccessed = d, f.putCookie(t, w));
    };
    return f.findCookie(t.domain, t.path, t.key, g), r.promise;
  }
  /**
   * Synchronously attempt to set the {@link Cookie} in the {@link CookieJar}.
   *
   * <strong>Note:</strong> Only works if the configured {@link Store} is also synchronous.
   *
   * @remarks
   * - If successfully persisted, the {@link Cookie} will have updated
   *     {@link Cookie.creation}, {@link Cookie.lastAccessed} and {@link Cookie.hostOnly}
   *     properties.
   *
   * - As per the RFC, the {@link Cookie.hostOnly} flag is set if there was no `Domain={value}`
   *     attribute on the cookie string. The {@link Cookie.domain} property is set to the
   *     fully-qualified hostname of `currentUrl` in this case. Matching this cookie requires an
   *     exact hostname match (not a {@link domainMatch} as per usual)
   *
   * @param cookie - The cookie object or cookie string to store. A string value will be parsed into a cookie using {@link Cookie.parse}.
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when storing the cookie.
   * @public
   */
  setCookieSync(t, n, o) {
    const a = o ? this.setCookie.bind(this, t, n, o) : this.setCookie.bind(this, t, n);
    return this.callSync(a);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookies(t, n, o) {
    typeof n == "function" ? (o = n, n = Bp) : n === void 0 && (n = Bp);
    const a = ot(o), r = a.callback;
    let i;
    try {
      typeof t == "string" && da(ml(t), r, t), i = Vp(t), da(
        Jr(n),
        r,
        mc(n)
      ), da(typeof r == "function", r);
    } catch (w) {
      return a.reject(w);
    }
    const s = Ei(i.hostname), l = i.pathname || "/", c = v5(
      t,
      this.allowSecureOnLocal
    );
    let u = 0;
    if (n.sameSiteContext) {
      const w = Up(n.sameSiteContext);
      if (w == null)
        return a.reject(new Error(fl));
      if (u = bt.sameSiteLevel[w], !u)
        return a.reject(new Error(fl));
    }
    const d = n.http ?? !0, m = Date.now(), f = n.expire ?? !0, g = n.allPaths ?? !1, p = this.store;
    function b(w) {
      if (w.hostOnly) {
        if (w.domain != s)
          return !1;
      } else if (!Wp(s ?? void 0, w.domain ?? void 0))
        return !1;
      if (!g && typeof w.path == "string" && !t_(l, w.path) || w.secure && !c || w.httpOnly && !d)
        return !1;
      if (u) {
        let _;
        if (w.sameSite === "lax" ? _ = bt.sameSiteLevel.lax : w.sameSite === "strict" ? _ = bt.sameSiteLevel.strict : _ = bt.sameSiteLevel.none, _ > u)
          return !1;
      }
      const y = w.expiryTime();
      return f && y != null && y <= m ? (p.removeCookie(w.domain, w.path, w.key, () => {
      }), !1) : !0;
    }
    return p.findCookies(
      s,
      g ? null : l,
      this.allowSpecialUseDomain,
      (w, y) => {
        if (w) {
          r(w);
          return;
        }
        if (y == null) {
          r(null, []);
          return;
        }
        y = y.filter(b), "sort" in n && n.sort !== !1 && (y = y.sort(Fp));
        const _ = /* @__PURE__ */ new Date();
        for (const k of y)
          k.lastAccessed = _;
        r(null, y);
      }
    ), a.promise;
  }
  /**
   * Synchronously retrieve the list of cookies that can be sent in a Cookie header for the
   * current URL.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - The array of cookies returned will be sorted according to {@link cookieCompare}.
   *
   * - The {@link Cookie.lastAccessed} property will be updated on all returned cookies.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookiesSync(t, n) {
    return this.callSync(this.getCookies.bind(this, t, n)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookieString(t, n, o) {
    typeof n == "function" && (o = n, n = void 0);
    const a = ot(o), r = function(i, s) {
      i ? a.callback(i) : a.callback(
        null,
        s?.sort(Fp).map((l) => l.cookieString()).join("; ")
      );
    };
    return this.getCookies(t, n, r), a.promise;
  }
  /**
   * Synchronous version of `.getCookieString()`. Accepts the same options as `.getCookies()` but returns a string suitable for a
   * `Cookie` header rather than an Array.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookieStringSync(t, n) {
    return this.callSync(
      n ? this.getCookieString.bind(this, t, n) : this.getCookieString.bind(this, t)
    ) ?? "";
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getSetCookieStrings(t, n, o) {
    typeof n == "function" && (o = n, n = void 0);
    const a = ot(
      o
    ), r = function(i, s) {
      i ? a.callback(i) : a.callback(
        null,
        s?.map((l) => l.toString())
      );
    };
    return this.getCookies(t, n, r), a.promise;
  }
  /**
   * Synchronous version of `.getSetCookieStrings()`. Returns an array of strings suitable for `Set-Cookie` headers.
   * Accepts the same options as `.getCookies()`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getSetCookieStringsSync(t, n = {}) {
    return this.callSync(this.getSetCookieStrings.bind(this, t, n)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  serialize(t) {
    const n = ot(t);
    let o = this.store.constructor.name;
    Jr(o) && (o = null);
    const a = {
      // The version of tough-cookie that serialized this jar. Generally a good
      // practice since future versions can make data import decisions based on
      // known past behavior. When/if this matters, use `semver`.
      version: `tough-cookie@${X6}`,
      // add the store type, to make humans happy:
      storeType: o,
      // CookieJar configuration:
      rejectPublicSuffixes: this.rejectPublicSuffixes,
      enableLooseMode: this.enableLooseMode,
      allowSpecialUseDomain: this.allowSpecialUseDomain,
      prefixSecurity: $r(this.prefixSecurity),
      // this gets filled from getAllCookies:
      cookies: []
    };
    return typeof this.store.getAllCookies != "function" ? n.reject(
      new Error(
        "store does not support getAllCookies and cannot be serialized"
      )
    ) : (this.store.getAllCookies((r, i) => {
      if (r) {
        n.callback(r);
        return;
      }
      if (i == null) {
        n.callback(null, a);
        return;
      }
      a.cookies = i.map((s) => {
        const l = s.toJSON();
        return delete l.creationIndex, l;
      }), n.callback(null, a);
    }), n.promise);
  }
  /**
   * Serialize the CookieJar if the underlying store supports `.getAllCookies`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   */
  serializeSync() {
    return this.callSync((t) => {
      this.serialize(t);
    });
  }
  /**
   * Alias of {@link CookieJar.serializeSync}. Allows the cookie to be serialized
   * with `JSON.stringify(cookieJar)`.
   */
  toJSON() {
    return this.serializeSync();
  }
  /**
   * Use the class method CookieJar.deserialize instead of calling this directly
   * @internal
   */
  _importCookies(t, n) {
    let o;
    if (t && typeof t == "object" && ka("cookies", t) && Array.isArray(t.cookies) && (o = t.cookies), !o) {
      n(new Error("serialized jar has no cookies array"), void 0);
      return;
    }
    o = o.slice();
    const a = (r) => {
      if (r) {
        n(r, void 0);
        return;
      }
      if (Array.isArray(o)) {
        if (!o.length) {
          n(r, this);
          return;
        }
        let i;
        try {
          i = bt.fromJSON(o.shift());
        } catch (s) {
          n(s instanceof Error ? s : new Error(), void 0);
          return;
        }
        if (i === void 0) {
          a(null);
          return;
        }
        this.store.putCookie(i, a);
      }
    };
    a(null);
  }
  /**
   * @internal
   */
  _importCookiesSync(t) {
    this.callSync(this._importCookies.bind(this, t));
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  clone(t, n) {
    typeof t == "function" && (n = t, t = void 0);
    const o = ot(n), a = o.callback;
    return this.serialize((r, i) => r ? o.reject(r) : ma.deserialize(i ?? "", t, a)), o.promise;
  }
  /**
   * @internal
   */
  _cloneSync(t) {
    const n = t && typeof t != "function" ? this.clone.bind(this, t) : this.clone.bind(this);
    return this.callSync((o) => {
      n(o);
    });
  }
  /**
   * Produces a deep clone of this CookieJar. Modifications to the original do
   * not affect the clone, and vice versa.
   *
   * <strong>Note</strong>: Only works if both the configured Store and destination
   * Store are synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - Transferring between store types is supported so long as the source
   *     implements `.getAllCookies()` and the destination implements `.putCookie()`.
   *
   * @param newStore - The target {@link Store} to clone cookies into.
   */
  cloneSync(t) {
    if (!t)
      return this._cloneSync();
    if (!t.synchronous)
      throw new Error(
        "CookieJar clone destination store is not synchronous; use async API instead."
      );
    return this._cloneSync(t);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  removeAllCookies(t) {
    const n = ot(t), o = n.callback, a = this.store;
    return typeof a.removeAllCookies == "function" && a.removeAllCookies !== n_.prototype.removeAllCookies ? (a.removeAllCookies(o), n.promise) : (a.getAllCookies((r, i) => {
      if (r) {
        o(r);
        return;
      }
      if (i || (i = []), i.length === 0) {
        o(null, void 0);
        return;
      }
      let s = 0;
      const l = [], c = function(u) {
        if (u && l.push(u), s++, s === i.length) {
          l[0] ? o(l[0]) : o(null, void 0);
          return;
        }
      };
      i.forEach((u) => {
        a.removeCookie(
          u.domain,
          u.path,
          u.key,
          c
        );
      });
    }), n.promise);
  }
  /**
   * Removes all cookies from the CookieJar.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - This is a new backwards-compatible feature of tough-cookie version 2.5,
   *     so not all Stores will implement it efficiently. For Stores that do not
   *     implement `removeAllCookies`, the fallback is to call `removeCookie` after
   *     `getAllCookies`.
   *
   * - If `getAllCookies` fails or isn't implemented in the Store, an error is returned.
   *
   * - If one or more of the `removeCookie` calls fail, only the first error is returned.
   */
  removeAllCookiesSync() {
    this.callSync((t) => {
      this.removeAllCookies(t);
    });
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  static deserialize(t, n, o) {
    typeof n == "function" && (o = n, n = void 0);
    const a = ot(o);
    let r;
    if (typeof t == "string")
      try {
        r = JSON.parse(t);
      } catch (u) {
        return a.reject(u instanceof Error ? u : new Error());
      }
    else
      r = t;
    const i = (u) => r && typeof r == "object" && ka(u, r) ? r[u] : void 0, s = (u) => {
      const d = i(u);
      return typeof d == "boolean" ? d : void 0;
    }, l = (u) => {
      const d = i(u);
      return typeof d == "string" ? d : void 0;
    }, c = new ma(n, {
      rejectPublicSuffixes: s("rejectPublicSuffixes"),
      looseMode: s("enableLooseMode"),
      allowSpecialUseDomain: s("allowSpecialUseDomain"),
      prefixSecurity: $r(
        l("prefixSecurity") ?? "silent"
      )
    });
    return c._importCookies(r, (u) => {
      if (u) {
        a.callback(u);
        return;
      }
      a.callback(null, c);
    }), a.promise;
  }
  /**
   * A new CookieJar is created and the serialized {@link Cookie} values are added to
   * the underlying store. Each {@link Cookie} is added via `store.putCookie(...)` in
   * the order in which they appear in the serialization.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param strOrObj - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static deserializeSync(t, n) {
    const o = typeof t == "string" ? JSON.parse(t) : t, a = (l) => o && typeof o == "object" && ka(l, o) ? o[l] : void 0, r = (l) => {
      const c = a(l);
      return typeof c == "boolean" ? c : void 0;
    }, i = (l) => {
      const c = a(l);
      return typeof c == "string" ? c : void 0;
    }, s = new ma(n, {
      rejectPublicSuffixes: r("rejectPublicSuffixes"),
      looseMode: r("enableLooseMode"),
      allowSpecialUseDomain: r("allowSpecialUseDomain"),
      prefixSecurity: $r(
        i("prefixSecurity") ?? "silent"
      )
    });
    if (!s.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    return s._importCookiesSync(o), s;
  }
  /**
   * Alias of {@link CookieJar.deserializeSync}.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param jsonString - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static fromJSON(t, n) {
    return ma.deserializeSync(t, n);
  }
};
/*!
 * Copyright (c) 2015-2020, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */
function x5(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
let $5 = class {
  #n = "__msw-cookie-store__";
  #t;
  #e;
  constructor() {
    Zy() || Ku(
      typeof localStorage < "u",
      "Failed to create a CookieStore: `localStorage` is not available in this environment. This is likely an issue with your environment, which has been detected as browser (or browser-like) environment and must implement global browser APIs correctly."
    ), this.#e = new a_(), this.#e.idx = this.getCookieStoreIndex(), this.#t = new k5(this.#e);
  }
  getCookies(t) {
    return this.#t.getCookiesSync(t);
  }
  async setCookie(t, n) {
    await this.#t.setCookie(t, n), this.persist();
  }
  getCookieStoreIndex() {
    if (typeof localStorage > "u")
      return {};
    const t = localStorage.getItem(this.#n);
    if (t == null)
      return {};
    const n = x5(t);
    if (n == null)
      return {};
    const o = {};
    for (const a of n) {
      const r = bt.fromJSON(a);
      r != null && r.domain != null && r.path != null && (o[r.domain] ||= {}, o[r.domain][r.path] ||= {}, o[r.domain][r.path][r.key] = r);
    }
    return o;
  }
  persist() {
    if (typeof localStorage > "u")
      return;
    const t = [], { idx: n } = this.#e;
    for (const o in n)
      for (const a in n[o])
        for (const r in n[o][a])
          t.push(n[o][a][r].toJSON());
    localStorage.setItem(this.#n, JSON.stringify(t));
  }
};
const S5 = new $5();
function s_(e) {
  const t = Qy.parse(e), n = {};
  for (const o in t)
    typeof t[o] < "u" && (n[o] = t[o]);
  return n;
}
function qp() {
  return s_(document.cookie);
}
function C5(e) {
  if (typeof document > "u" || typeof location > "u")
    return {};
  switch (e.credentials) {
    case "same-origin": {
      const t = new URL(e.url);
      return location.origin === t.origin ? qp() : {};
    }
    case "include":
      return qp();
    default:
      return {};
  }
}
function E5(e) {
  const t = e.headers.get("cookie"), n = t ? s_(t) : {}, o = C5(e);
  for (const i in o)
    e.headers.append(
      "cookie",
      Qy.serialize(i, o[i])
    );
  const a = S5.getCookies(e.url), r = Object.fromEntries(
    a.map((i) => [i.key, i.value])
  );
  for (const i of a)
    e.headers.append("cookie", i.toString());
  return {
    ...o,
    ...r,
    ...n
  };
}
var xn = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(xn || {});
class A5 extends Ci {
  constructor(t, n, o, a) {
    const r = typeof n == "function" ? "[custom predicate]" : n;
    super({
      info: {
        header: `${t}${r ? ` ${r}` : ""}`,
        path: n,
        method: t
      },
      resolver: o,
      options: a
    }), this.checkRedundantQueryParameters();
  }
  checkRedundantQueryParameters() {
    const { method: t, path: n } = this.info;
    !n || n instanceof RegExp || typeof n == "function" || Jy(n) === n || (g6(n).forEach((o, a) => {
    }), pc.warn(
      `Found a redundant usage of query parameters in the request handler URL for "${t} ${n}". Please match against a path instead and access query parameters using "new URL(request.url).searchParams" instead. Learn more: https://mswjs.io/docs/http/intercepting-requests#querysearch-parameters`
    ));
  }
  async parse(t) {
    const n = new URL(t.request.url), o = E5(t.request);
    if (typeof this.info.path == "function") {
      const a = await this.info.path({
        request: t.request,
        cookies: o
      });
      return {
        match: typeof a == "boolean" ? {
          matches: a,
          params: {}
        } : a,
        cookies: o
      };
    }
    return {
      match: this.info.path ? w6(n, this.info.path, t.resolutionContext?.baseUrl) : { matches: !1, params: {} },
      cookies: o
    };
  }
  async predicate(t) {
    const n = this.matchMethod(t.request.method), o = t.parsedResult.match.matches;
    return n && o;
  }
  matchMethod(t) {
    return this.info.method instanceof RegExp ? this.info.method.test(t) : Pq(this.info.method, t);
  }
  extendResolverArgs(t) {
    return {
      params: t.parsedResult.match?.params || {},
      cookies: t.parsedResult.cookies
    };
  }
  async log(t) {
    const n = k6(t.request.url), o = await Mq(t.request), a = await Jq(t.response), r = Dq(a.status);
    console.groupCollapsed(
      pc.formatMessage(
        `${Lq()} ${t.request.method} ${n} (%c${a.status} ${a.statusText}%c)`
      ),
      `color:${r}`,
      "color:inherit"
    ), console.log("Request", o), console.log("Handler:", this), console.log("Response", a), console.groupEnd();
  }
}
function Mn(e) {
  return (t, n, o = {}) => new A5(e, t, n, o);
}
Mn(xn.HEAD), Mn(xn.GET), Mn(xn.POST), Mn(xn.PUT), Mn(xn.DELETE), Mn(xn.PATCH), Mn(xn.OPTIONS);
var O5 = Object.create, l_ = Object.defineProperty, z5 = Object.getOwnPropertyDescriptor, c_ = Object.getOwnPropertyNames, N5 = Object.getPrototypeOf, j5 = Object.prototype.hasOwnProperty, R5 = (e, t) => function() {
  return t || (0, e[c_(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, I5 = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of c_(t))
      !j5.call(e, a) && a !== n && l_(e, a, { get: () => t[a], enumerable: !(o = z5(t, a)) || o.enumerable });
  return e;
}, T5 = (e, t, n) => (n = e != null ? O5(N5(e)) : {}, I5(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? l_(n, "default", { value: e, enumerable: !0 }) : n,
  e
)), P5 = R5({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(e, t) {
    var n = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function o(l) {
      return typeof l == "string" && !!l.trim();
    }
    function a(l, c) {
      var u = l.split(";").filter(o), d = u.shift(), m = r(d), f = m.name, g = m.value;
      c = c ? Object.assign({}, n, c) : n;
      try {
        g = c.decodeValues ? decodeURIComponent(g) : g;
      } catch (b) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + g + "'. Set options.decodeValues to false to disable this feature.",
          b
        );
      }
      var p = {
        name: f,
        value: g
      };
      return u.forEach(function(b) {
        var w = b.split("="), y = w.shift().trimLeft().toLowerCase(), _ = w.join("=");
        y === "expires" ? p.expires = new Date(_) : y === "max-age" ? p.maxAge = parseInt(_, 10) : y === "secure" ? p.secure = !0 : y === "httponly" ? p.httpOnly = !0 : y === "samesite" ? p.sameSite = _ : p[y] = _;
      }), p;
    }
    function r(l) {
      var c = "", u = "", d = l.split("=");
      return d.length > 1 ? (c = d.shift(), u = d.join("=")) : u = l, { name: c, value: u };
    }
    function i(l, c) {
      if (c = c ? Object.assign({}, n, c) : n, !l)
        return c.map ? {} : [];
      if (l.headers)
        if (typeof l.headers.getSetCookie == "function")
          l = l.headers.getSetCookie();
        else if (l.headers["set-cookie"])
          l = l.headers["set-cookie"];
        else {
          var u = l.headers[Object.keys(l.headers).find(function(m) {
            return m.toLowerCase() === "set-cookie";
          })];
          !u && l.headers.cookie && !c.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), l = u;
        }
      if (Array.isArray(l) || (l = [l]), c = c ? Object.assign({}, n, c) : n, c.map) {
        var d = {};
        return l.filter(o).reduce(function(m, f) {
          var g = a(f, c);
          return m[g.name] = g, m;
        }, d);
      } else
        return l.filter(o).map(function(m) {
          return a(m, c);
        });
    }
    function s(l) {
      if (Array.isArray(l))
        return l;
      if (typeof l != "string")
        return [];
      var c = [], u = 0, d, m, f, g, p;
      function b() {
        for (; u < l.length && /\s/.test(l.charAt(u)); )
          u += 1;
        return u < l.length;
      }
      function w() {
        return m = l.charAt(u), m !== "=" && m !== ";" && m !== ",";
      }
      for (; u < l.length; ) {
        for (d = u, p = !1; b(); )
          if (m = l.charAt(u), m === ",") {
            for (f = u, u += 1, b(), g = u; u < l.length && w(); )
              u += 1;
            u < l.length && l.charAt(u) === "=" ? (p = !0, u = g, c.push(l.substring(d, f)), d = u) : u = f + 1;
          } else
            u += 1;
        (!p || u >= l.length) && c.push(l.substring(d, l.length));
      }
      return c;
    }
    t.exports = i, t.exports.parse = i, t.exports.parseString = a, t.exports.splitCookiesString = s;
  }
});
T5(P5());
const { message: Kye } = qy;
Nq();
async function D5() {
  return T_.post("/legacy-auth/logout");
}
class Hp extends Error {
  code;
  errorData;
  constructor(t, n, o) {
    super(t), this.name = "HeError", this.code = n, this.errorData = o;
  }
}
function u_(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: L5 } = Object.prototype, { getPrototypeOf: Qu } = Object, { iterator: gs, toStringTag: d_ } = Symbol, bs = /* @__PURE__ */ ((e) => (t) => {
  const n = L5.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Mt = (e) => (e = e.toLowerCase(), (t) => bs(t) === e), vs = (e) => (t) => typeof t === e, { isArray: Qo } = Array, Ho = vs("undefined");
function Za(e) {
  return e !== null && !Ho(e) && e.constructor !== null && !Ho(e.constructor) && dt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const h_ = Mt("ArrayBuffer");
function M5(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && h_(e.buffer), t;
}
const F5 = vs("string"), dt = vs("function"), p_ = vs("number"), Ja = (e) => e !== null && typeof e == "object", W5 = (e) => e === !0 || e === !1, Yr = (e) => {
  if (bs(e) !== "object")
    return !1;
  const t = Qu(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(d_ in e) && !(gs in e);
}, B5 = (e) => {
  if (!Ja(e) || Za(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, V5 = Mt("Date"), U5 = Mt("File"), q5 = Mt("Blob"), H5 = Mt("FileList"), K5 = (e) => Ja(e) && dt(e.pipe), G5 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || dt(e.append) && ((t = bs(e)) === "formdata" || // detect form-data instance
  t === "object" && dt(e.toString) && e.toString() === "[object FormData]"));
}, Z5 = Mt("URLSearchParams"), [J5, Y5, X5, Q5] = ["ReadableStream", "Request", "Response", "Headers"].map(Mt), eH = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ya(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, a;
  if (typeof e != "object" && (e = [e]), Qo(e))
    for (o = 0, a = e.length; o < a; o++)
      t.call(null, e[o], o, e);
  else {
    if (Za(e))
      return;
    const r = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function m_(e, t) {
  if (Za(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, a;
  for (; o-- > 0; )
    if (a = n[o], t === a.toLowerCase())
      return a;
  return null;
}
const Vn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, f_ = (e) => !Ho(e) && e !== Vn;
function bc() {
  const { caseless: e, skipUndefined: t } = f_(this) && this || {}, n = {}, o = (a, r) => {
    const i = e && m_(n, r) || r;
    Yr(n[i]) && Yr(a) ? n[i] = bc(n[i], a) : Yr(a) ? n[i] = bc({}, a) : Qo(a) ? n[i] = a.slice() : (!t || !Ho(a)) && (n[i] = a);
  };
  for (let a = 0, r = arguments.length; a < r; a++)
    arguments[a] && Ya(arguments[a], o);
  return n;
}
const tH = (e, t, n, { allOwnKeys: o } = {}) => (Ya(t, (a, r) => {
  n && dt(a) ? e[r] = u_(a, n) : e[r] = a;
}, { allOwnKeys: o }), e), nH = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), oH = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, aH = (e, t, n, o) => {
  let a, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), r = a.length; r-- > 0; )
      i = a[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && Qu(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, rH = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, iH = (e) => {
  if (!e) return null;
  if (Qo(e)) return e;
  let t = e.length;
  if (!p_(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, sH = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Qu(Uint8Array)), lH = (e, t) => {
  const n = (e && e[gs]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, cH = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, uH = Mt("HTMLFormElement"), dH = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, o) {
    return n.toUpperCase() + o;
  }
), Kp = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), hH = Mt("RegExp"), g_ = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  Ya(n, (a, r) => {
    let i;
    (i = t(a, r, e)) !== !1 && (o[r] = i || a);
  }), Object.defineProperties(e, o);
}, pH = (e) => {
  g_(e, (t, n) => {
    if (dt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (dt(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, mH = (e, t) => {
  const n = {}, o = (a) => {
    a.forEach((r) => {
      n[r] = !0;
    });
  };
  return Qo(e) ? o(e) : o(String(e).split(t)), n;
}, fH = () => {
}, gH = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function bH(e) {
  return !!(e && dt(e.append) && e[d_] === "FormData" && e[gs]);
}
const vH = (e) => {
  const t = new Array(10), n = (o, a) => {
    if (Ja(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Za(o))
        return o;
      if (!("toJSON" in o)) {
        t[a] = o;
        const r = Qo(o) ? [] : {};
        return Ya(o, (i, s) => {
          const l = n(i, a + 1);
          !Ho(l) && (r[s] = l);
        }), t[a] = void 0, r;
      }
    }
    return o;
  };
  return n(e, 0);
}, yH = Mt("AsyncFunction"), _H = (e) => e && (Ja(e) || dt(e)) && dt(e.then) && dt(e.catch), b_ = ((e, t) => e ? setImmediate : t ? ((n, o) => (Vn.addEventListener("message", ({ source: a, data: r }) => {
  a === Vn && r === n && o.length && o.shift()();
}, !1), (a) => {
  o.push(a), Vn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  dt(Vn.postMessage)
), wH = typeof queueMicrotask < "u" ? queueMicrotask.bind(Vn) : typeof process < "u" && process.nextTick || b_, kH = (e) => e != null && dt(e[gs]), R = {
  isArray: Qo,
  isArrayBuffer: h_,
  isBuffer: Za,
  isFormData: G5,
  isArrayBufferView: M5,
  isString: F5,
  isNumber: p_,
  isBoolean: W5,
  isObject: Ja,
  isPlainObject: Yr,
  isEmptyObject: B5,
  isReadableStream: J5,
  isRequest: Y5,
  isResponse: X5,
  isHeaders: Q5,
  isUndefined: Ho,
  isDate: V5,
  isFile: U5,
  isBlob: q5,
  isRegExp: hH,
  isFunction: dt,
  isStream: K5,
  isURLSearchParams: Z5,
  isTypedArray: sH,
  isFileList: H5,
  forEach: Ya,
  merge: bc,
  extend: tH,
  trim: eH,
  stripBOM: nH,
  inherits: oH,
  toFlatObject: aH,
  kindOf: bs,
  kindOfTest: Mt,
  endsWith: rH,
  toArray: iH,
  forEachEntry: lH,
  matchAll: cH,
  isHTMLForm: uH,
  hasOwnProperty: Kp,
  hasOwnProp: Kp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: g_,
  freezeMethods: pH,
  toObjectSet: mH,
  toCamelCase: dH,
  noop: fH,
  toFiniteNumber: gH,
  findKey: m_,
  global: Vn,
  isContextDefined: f_,
  isSpecCompliantForm: bH,
  toJSONObject: vH,
  isAsyncFn: yH,
  isThenable: _H,
  setImmediate: b_,
  asap: wH,
  isIterable: kH
};
function he(e, t, n, o, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), a && (this.response = a, this.status = a.status ? a.status : null);
}
R.inherits(he, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: R.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const v_ = he.prototype, y_ = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  y_[e] = { value: e };
});
Object.defineProperties(he, y_);
Object.defineProperty(v_, "isAxiosError", { value: !0 });
he.from = (e, t, n, o, a, r) => {
  const i = Object.create(v_);
  R.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return he.call(i, s, l, n, o, a), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const xH = null;
function vc(e) {
  return R.isPlainObject(e) || R.isArray(e);
}
function __(e) {
  return R.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Gp(e, t, n) {
  return e ? e.concat(t).map(function(o, a) {
    return o = __(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function $H(e) {
  return R.isArray(e) && !e.some(vc);
}
const SH = R.toFlatObject(R, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function ys(e, t, n) {
  if (!R.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = R.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, g) {
    return !R.isUndefined(g[f]);
  });
  const o = n.metaTokens, a = n.visitor || c, r = n.dots, i = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && R.isSpecCompliantForm(t);
  if (!R.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(f) {
    if (f === null) return "";
    if (R.isDate(f))
      return f.toISOString();
    if (R.isBoolean(f))
      return f.toString();
    if (!s && R.isBlob(f))
      throw new he("Blob is not supported. Use a Buffer instead.");
    return R.isArrayBuffer(f) || R.isTypedArray(f) ? s && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, g, p) {
    let b = f;
    if (f && !p && typeof f == "object") {
      if (R.endsWith(g, "{}"))
        g = o ? g : g.slice(0, -2), f = JSON.stringify(f);
      else if (R.isArray(f) && $H(f) || (R.isFileList(f) || R.endsWith(g, "[]")) && (b = R.toArray(f)))
        return g = __(g), b.forEach(function(w, y) {
          !(R.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Gp([g], y, r) : i === null ? g : g + "[]",
            l(w)
          );
        }), !1;
    }
    return vc(f) ? !0 : (t.append(Gp(p, g, r), l(f)), !1);
  }
  const u = [], d = Object.assign(SH, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: vc
  });
  function m(f, g) {
    if (!R.isUndefined(f)) {
      if (u.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      u.push(f), R.forEach(f, function(p, b) {
        (!(R.isUndefined(p) || p === null) && a.call(
          t,
          p,
          R.isString(b) ? b.trim() : b,
          g,
          d
        )) === !0 && m(p, g ? g.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!R.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function Zp(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function ed(e, t) {
  this._pairs = [], e && ys(e, this, t);
}
const w_ = ed.prototype;
w_.append = function(e, t) {
  this._pairs.push([e, t]);
};
w_.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Zp);
  } : Zp;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function CH(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function k_(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || CH;
  R.isFunction(n) && (n = {
    serialize: n
  });
  const a = n && n.serialize;
  let r;
  if (a ? r = a(t, n) : r = R.isURLSearchParams(t) ? t.toString() : new ed(t, n).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let Jp = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    R.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
};
const x_ = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, EH = typeof URLSearchParams < "u" ? URLSearchParams : ed, AH = typeof FormData < "u" ? FormData : null, OH = typeof Blob < "u" ? Blob : null, zH = {
  isBrowser: !0,
  classes: {
    URLSearchParams: EH,
    FormData: AH,
    Blob: OH
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, td = typeof window < "u" && typeof document < "u", yc = typeof navigator == "object" && navigator || void 0, NH = td && (!yc || ["ReactNative", "NativeScript", "NS"].indexOf(yc.product) < 0), jH = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", RH = td && window.location.href || "http://localhost", IH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: td,
  hasStandardBrowserEnv: NH,
  hasStandardBrowserWebWorkerEnv: jH,
  navigator: yc,
  origin: RH
}, Symbol.toStringTag, { value: "Module" })), tt = {
  ...IH,
  ...zH
};
function TH(e, t) {
  return ys(e, new tt.classes.URLSearchParams(), {
    visitor: function(n, o, a, r) {
      return tt.isNode && R.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function PH(e) {
  return R.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function DH(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const a = n.length;
  let r;
  for (o = 0; o < a; o++)
    r = n[o], t[r] = e[r];
  return t;
}
function $_(e) {
  function t(n, o, a, r) {
    let i = n[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= n.length;
    return i = !i && R.isArray(a) ? a.length : i, l ? (R.hasOwnProp(a, i) ? a[i] = [a[i], o] : a[i] = o, !s) : ((!a[i] || !R.isObject(a[i])) && (a[i] = []), t(n, o, a[i], r) && R.isArray(a[i]) && (a[i] = DH(a[i])), !s);
  }
  if (R.isFormData(e) && R.isFunction(e.entries)) {
    const n = {};
    return R.forEachEntry(e, (o, a) => {
      t(PH(o), a, n, 0);
    }), n;
  }
  return null;
}
function LH(e, t, n) {
  if (R.isString(e))
    try {
      return (t || JSON.parse)(e), R.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const Xa = {
  transitional: x_,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", o = n.indexOf("application/json") > -1, a = R.isObject(e);
    if (a && R.isHTMLForm(e) && (e = new FormData(e)), R.isFormData(e))
      return o ? JSON.stringify($_(e)) : e;
    if (R.isArrayBuffer(e) || R.isBuffer(e) || R.isStream(e) || R.isFile(e) || R.isBlob(e) || R.isReadableStream(e))
      return e;
    if (R.isArrayBufferView(e))
      return e.buffer;
    if (R.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return TH(e, this.formSerializer).toString();
      if ((r = R.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return ys(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return a || o ? (t.setContentType("application/json", !1), LH(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Xa.transitional, n = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (R.isResponse(e) || R.isReadableStream(e))
      return e;
    if (e && R.isString(e) && (n && !this.responseType || o)) {
      const a = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (a)
          throw r.name === "SyntaxError" ? he.from(r, he.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: tt.classes.FormData,
    Blob: tt.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
R.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Xa.headers[e] = {};
});
const MH = R.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), FH = (e) => {
  const t = {};
  let n, o, a;
  return e && e.split(`
`).forEach(function(r) {
    a = r.indexOf(":"), n = r.substring(0, a).trim().toLowerCase(), o = r.substring(a + 1).trim(), !(!n || t[n] && MH[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, Yp = Symbol("internals");
function ha(e) {
  return e && String(e).trim().toLowerCase();
}
function Xr(e) {
  return e === !1 || e == null ? e : R.isArray(e) ? e.map(Xr) : String(e);
}
function WH(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const BH = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function gl(e, t, n, o, a) {
  if (R.isFunction(o))
    return o.call(this, t, n);
  if (a && (t = n), !!R.isString(t)) {
    if (R.isString(o))
      return t.indexOf(o) !== -1;
    if (R.isRegExp(o))
      return o.test(t);
  }
}
function VH(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function UH(e, t) {
  const n = R.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(a, r, i) {
        return this[o].call(this, t, a, r, i);
      },
      configurable: !0
    });
  });
}
let ht = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const o = this;
    function a(i, s, l) {
      const c = ha(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = R.findKey(o, c);
      (!u || o[u] === void 0 || l === !0 || l === void 0 && o[u] !== !1) && (o[u || s] = Xr(i));
    }
    const r = (i, s) => R.forEach(i, (l, c) => a(l, c, s));
    if (R.isPlainObject(e) || e instanceof this.constructor)
      r(e, t);
    else if (R.isString(e) && (e = e.trim()) && !BH(e))
      r(FH(e), t);
    else if (R.isObject(e) && R.isIterable(e)) {
      let i = {}, s, l;
      for (const c of e) {
        if (!R.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[l = c[0]] = (s = i[l]) ? R.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      r(i, t);
    } else
      e != null && a(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = ha(e), e) {
      const n = R.findKey(this, e);
      if (n) {
        const o = this[n];
        if (!t)
          return o;
        if (t === !0)
          return WH(o);
        if (R.isFunction(t))
          return t.call(this, o, n);
        if (R.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = ha(e), e) {
      const n = R.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || gl(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let o = !1;
    function a(r) {
      if (r = ha(r), r) {
        const i = R.findKey(n, r);
        i && (!t || gl(n, n[i], i, t)) && (delete n[i], o = !0);
      }
    }
    return R.isArray(e) ? e.forEach(a) : a(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, o = !1;
    for (; n--; ) {
      const a = t[n];
      (!e || gl(this, this[a], a, e, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, n = {};
    return R.forEach(this, (o, a) => {
      const r = R.findKey(n, a);
      if (r) {
        t[r] = Xr(o), delete t[a];
        return;
      }
      const i = e ? VH(a) : String(a).trim();
      i !== a && delete t[a], t[i] = Xr(o), n[i] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return R.forEach(this, (n, o) => {
      n != null && n !== !1 && (t[o] = e && R.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((o) => n.set(o)), n;
  }
  static accessor(e) {
    const t = (this[Yp] = this[Yp] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function o(a) {
      const r = ha(a);
      t[r] || (UH(n, a), t[r] = !0);
    }
    return R.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
ht.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
R.reduceDescriptors(ht.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
R.freezeMethods(ht);
function bl(e, t) {
  const n = this || Xa, o = t || n, a = ht.from(o.headers);
  let r = o.data;
  return R.forEach(e, function(i) {
    r = i.call(n, r, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), r;
}
function S_(e) {
  return !!(e && e.__CANCEL__);
}
function ea(e, t, n) {
  he.call(this, e ?? "canceled", he.ERR_CANCELED, t, n), this.name = "CanceledError";
}
R.inherits(ea, he, {
  __CANCEL__: !0
});
function C_(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new he(
    "Request failed with status code " + n.status,
    [he.ERR_BAD_REQUEST, he.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function qH(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function HH(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let a = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), n[a] = s, o[a] = l;
    let u = r, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === r && (r = (r + 1) % e), l - i < t)
      return;
    const m = c && l - c;
    return m ? Math.round(d * 1e3 / m) : void 0;
  };
}
function KH(e, t) {
  let n = 0, o = 1e3 / t, a, r;
  const i = (s, l = Date.now()) => {
    n = l, a = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= o ? i(s, l) : (a = s, r || (r = setTimeout(() => {
      r = null, i(a);
    }, o - c)));
  }, () => a && i(a)];
}
const Ai = (e, t, n = 3) => {
  let o = 0;
  const a = HH(50, 250);
  return KH((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = a(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Xp = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, Qp = (e) => (...t) => R.asap(() => e(...t)), GH = tt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, tt.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(tt.origin),
  tt.navigator && /(msie|trident)/i.test(tt.navigator.userAgent)
) : () => !0, ZH = tt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, a, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      R.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), R.isString(o) && i.push("path=" + o), R.isString(a) && i.push("domain=" + a), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function JH(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function YH(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function E_(e, t, n) {
  let o = !JH(t);
  return e && (o || n == !1) ? YH(e, t) : t;
}
const em = (e) => e instanceof ht ? { ...e } : e;
function eo(e, t) {
  t = t || {};
  const n = {};
  function o(c, u, d, m) {
    return R.isPlainObject(c) && R.isPlainObject(u) ? R.merge.call({ caseless: m }, c, u) : R.isPlainObject(u) ? R.merge({}, u) : R.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d, m) {
    if (R.isUndefined(u)) {
      if (!R.isUndefined(c))
        return o(void 0, c, d, m);
    } else return o(c, u, d, m);
  }
  function r(c, u) {
    if (!R.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (R.isUndefined(u)) {
      if (!R.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => a(em(c), em(u), d, !0)
  };
  return R.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    R.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const A_ = (e) => {
  const t = eo({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: a, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = ht.from(i), t.url = k_(E_(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), R.isFormData(n)) {
    if (tt.hasStandardBrowserEnv || tt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (R.isFunction(n.getHeaders)) {
      const l = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (tt.hasStandardBrowserEnv && (o && R.isFunction(o) && (o = o(t)), o || o !== !1 && GH(t.url))) {
    const l = a && r && ZH.read(r);
    l && i.set(a, l);
  }
  return t;
}, XH = typeof XMLHttpRequest < "u", QH = XH && function(e) {
  return new Promise(function(t, n) {
    const o = A_(e);
    let a = o.data;
    const r = ht.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, m, f;
    function g() {
      m && m(), f && f(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function b() {
      if (!p)
        return;
      const y = ht.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), _ = {
        data: !i || i === "text" || i === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: y,
        config: e,
        request: p
      };
      C_(function(k) {
        t(k), g();
      }, function(k) {
        n(k), g();
      }, _), p = null;
    }
    "onloadend" in p ? p.onloadend = b : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, p.onabort = function() {
      p && (n(new he("Request aborted", he.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function(y) {
      const _ = y && y.message ? y.message : "Network Error", k = new he(_, he.ERR_NETWORK, e, p);
      k.event = y || null, n(k), p = null;
    }, p.ontimeout = function() {
      let y = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const _ = o.transitional || x_;
      o.timeoutErrorMessage && (y = o.timeoutErrorMessage), n(new he(
        y,
        _.clarifyTimeoutError ? he.ETIMEDOUT : he.ECONNABORTED,
        e,
        p
      )), p = null;
    }, a === void 0 && r.setContentType(null), "setRequestHeader" in p && R.forEach(r.toJSON(), function(y, _) {
      p.setRequestHeader(_, y);
    }), R.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), i && i !== "json" && (p.responseType = o.responseType), l && ([d, f] = Ai(l, !0), p.addEventListener("progress", d)), s && p.upload && ([u, m] = Ai(s), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", m)), (o.cancelToken || o.signal) && (c = (y) => {
      p && (n(!y || y.type ? new ea(null, e, p) : y), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = qH(o.url);
    if (w && tt.protocols.indexOf(w) === -1) {
      n(new he("Unsupported protocol " + w + ":", he.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(a || null);
  });
}, e9 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), a;
    const r = function(c) {
      if (!a) {
        a = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof he ? u : new ea(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new he(`timeout ${t} of ms exceeded`, he.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => R.asap(s), l;
  }
}, t9 = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let o = 0, a;
  for (; o < n; )
    a = o + t, yield e.slice(o, a), o = a;
}, n9 = async function* (e, t) {
  for await (const n of o9(e))
    yield* t9(n, t);
}, o9 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, tm = (e, t, n, o) => {
  const a = n9(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await a.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let m = r += d;
          n(m);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, nm = 64 * 1024, { isFunction: Sr } = R, O_ = (({ fetch: e, Request: t, Response: n }) => ({
  fetch: e,
  Request: t,
  Response: n
}))(R.global), {
  ReadableStream: om,
  TextEncoder: am
} = R.global, rm = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, a9 = (e) => {
  const { fetch: t, Request: n, Response: o } = Object.assign({}, O_, e), a = Sr(t), r = Sr(n), i = Sr(o);
  if (!a)
    return !1;
  const s = a && Sr(om), l = a && (typeof am == "function" ? /* @__PURE__ */ ((g) => (p) => g.encode(p))(new am()) : async (g) => new Uint8Array(await new n(g).arrayBuffer())), c = r && s && rm(() => {
    let g = !1;
    const p = new n(tt.origin, {
      body: new om(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !p;
  }), u = i && s && rm(() => R.isReadableStream(new o("").body)), d = {
    stream: u && ((g) => g.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !d[g] && (d[g] = (p, b) => {
      let w = p && p[g];
      if (w)
        return w.call(p);
      throw new he(`Response type '${g}' is not supported`, he.ERR_NOT_SUPPORT, b);
    });
  });
  const m = async (g) => {
    if (g == null)
      return 0;
    if (R.isBlob(g))
      return g.size;
    if (R.isSpecCompliantForm(g))
      return (await new n(tt.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (R.isArrayBufferView(g) || R.isArrayBuffer(g))
      return g.byteLength;
    if (R.isURLSearchParams(g) && (g = g + ""), R.isString(g))
      return (await l(g)).byteLength;
  }, f = async (g, p) => R.toFiniteNumber(g.getContentLength()) ?? m(p);
  return async (g) => {
    let {
      url: p,
      method: b,
      data: w,
      signal: y,
      cancelToken: _,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: A
    } = A_(g);
    $ = $ ? ($ + "").toLowerCase() : "text";
    let I = e9([y, _ && _.toAbortSignal()], k), U = null;
    const M = I && I.unsubscribe && (() => {
      I.unsubscribe();
    });
    let z;
    try {
      if (S && c && b !== "get" && b !== "head" && (z = await f(E, w)) !== 0) {
        let O = new n(p, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (R.isFormData(w) && (N = O.headers.get("content-type")) && E.setContentType(N), O.body) {
          const [T, W] = Xp(
            z,
            Ai(Qp(S))
          );
          w = tm(O.body, nm, T, W);
        }
      }
      R.isString(C) || (C = C ? "include" : "omit");
      const L = r && "credentials" in n.prototype, q = {
        ...A,
        signal: I,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: L ? C : void 0
      };
      U = r && new n(p, q);
      let K = await (r ? t(U, A) : t(p, q));
      const Z = u && ($ === "stream" || $ === "response");
      if (u && (x || Z && M)) {
        const O = {};
        ["status", "statusText", "headers"].forEach((B) => {
          O[B] = K[B];
        });
        const N = R.toFiniteNumber(K.headers.get("content-length")), [T, W] = x && Xp(
          N,
          Ai(Qp(x), !0)
        ) || [];
        K = new o(
          tm(K.body, nm, T, () => {
            W && W(), M && M();
          }),
          O
        );
      }
      $ = $ || "text";
      let te = await d[R.findKey(d, $) || "text"](K, g);
      return !Z && M && M(), await new Promise((O, N) => {
        C_(O, N, {
          data: te,
          headers: ht.from(K.headers),
          status: K.status,
          statusText: K.statusText,
          config: g,
          request: U
        });
      });
    } catch (L) {
      throw M && M(), L && L.name === "TypeError" && /Load failed|fetch/i.test(L.message) ? Object.assign(
        new he("Network Error", he.ERR_NETWORK, g, U),
        {
          cause: L.cause || L
        }
      ) : he.from(L, L && L.code, g, U);
    }
  };
}, r9 = /* @__PURE__ */ new Map(), z_ = (e) => {
  let t = R.merge.call({
    skipUndefined: !0
  }, O_, e ? e.env : null);
  const { fetch: n, Request: o, Response: a } = t, r = [
    o,
    a,
    n
  ];
  let i = r.length, s = i, l, c, u = r9;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : a9(t)), u = c;
  return c;
};
z_();
const _c = {
  http: xH,
  xhr: QH,
  fetch: {
    get: z_
  }
};
R.forEach(_c, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const im = (e) => `- ${e}`, i9 = (e) => R.isFunction(e) || e === null || e === !1, N_ = {
  getAdapter: (e, t) => {
    e = R.isArray(e) ? e : [e];
    const { length: n } = e;
    let o, a;
    const r = {};
    for (let i = 0; i < n; i++) {
      o = e[i];
      let s;
      if (a = o, !i9(o) && (a = _c[(s = String(o)).toLowerCase()], a === void 0))
        throw new he(`Unknown adapter '${s}'`);
      if (a && (R.isFunction(a) || (a = a.get(t))))
        break;
      r[s || "#" + i] = a;
    }
    if (!a) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = n ? i.length > 1 ? `since :
` + i.map(im).join(`
`) : " " + im(i[0]) : "as no adapter specified";
      throw new he(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: _c
};
function vl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ea(null, e);
}
function sm(e) {
  return vl(e), e.headers = ht.from(e.headers), e.data = bl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), N_.getAdapter(e.adapter || Xa.adapter, e)(e).then(function(t) {
    return vl(e), t.data = bl.call(
      e,
      e.transformResponse,
      t
    ), t.headers = ht.from(t.headers), t;
  }, function(t) {
    return S_(t) || (vl(e), t && t.response && (t.response.data = bl.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = ht.from(t.response.headers))), Promise.reject(t);
  });
}
const j_ = "1.12.0", _s = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  _s[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const lm = {};
_s.transitional = function(e, t, n) {
  function o(a, r) {
    return "[Axios v" + j_ + "] Transitional option '" + a + "'" + r + (n ? ". " + n : "");
  }
  return (a, r, i) => {
    if (e === !1)
      throw new he(
        o(r, " has been removed" + (t ? " in " + t : "")),
        he.ERR_DEPRECATED
      );
    return t && !lm[r] && (lm[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, r, i) : !0;
  };
};
_s.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function s9(e, t, n) {
  if (typeof e != "object")
    throw new he("options must be an object", he.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let a = o.length;
  for (; a-- > 0; ) {
    const r = o[a], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new he("option " + r + " must be " + l, he.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new he("Unknown option " + r, he.ERR_BAD_OPTION);
  }
}
const Qr = {
  assertOptions: s9,
  validators: _s
}, Vt = Qr.validators;
let Kn = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Jp(),
      response: new Jp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = eo(this.defaults, t);
    const { transitional: n, paramsSerializer: o, headers: a } = t;
    n !== void 0 && Qr.assertOptions(n, {
      silentJSONParsing: Vt.transitional(Vt.boolean),
      forcedJSONParsing: Vt.transitional(Vt.boolean),
      clarifyTimeoutError: Vt.transitional(Vt.boolean)
    }, !1), o != null && (R.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Qr.assertOptions(o, {
      encode: Vt.function,
      serialize: Vt.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Qr.assertOptions(t, {
      baseUrl: Vt.spelling("baseURL"),
      withXsrfToken: Vt.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let r = a && R.merge(
      a.common,
      a[t.method]
    );
    a && R.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete a[f];
      }
    ), t.headers = ht.concat(r, a);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(t) === !1 || (s = s && f.synchronous, i.unshift(f.fulfilled, f.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(f) {
      l.push(f.fulfilled, f.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const f = [sm.bind(this), void 0];
      for (f.unshift(...i), f.push(...l), d = f.length, c = Promise.resolve(t); u < d; )
        c = c.then(f[u++], f[u++]);
      return c;
    }
    d = i.length;
    let m = t;
    for (u = 0; u < d; ) {
      const f = i[u++], g = i[u++];
      try {
        m = f(m);
      } catch (p) {
        g.call(this, p);
        break;
      }
    }
    try {
      c = sm.call(this, m);
    } catch (f) {
      return Promise.reject(f);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = eo(this.defaults, e);
    const t = E_(e.baseURL, e.url, e.allowAbsoluteUrls);
    return k_(t, e.params, e.paramsSerializer);
  }
};
R.forEach(["delete", "get", "head", "options"], function(e) {
  Kn.prototype[e] = function(t, n) {
    return this.request(eo(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
R.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, a, r) {
      return this.request(eo(r || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  Kn.prototype[e] = t(), Kn.prototype[e + "Form"] = t(!0);
});
let l9 = class R_ {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const o = this;
    this.promise.then((a) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](a);
      o._listeners = null;
    }), this.promise.then = (a) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(a);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(a, r, i) {
      o.reason || (o.reason = new ea(a, r, i), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new R_(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function c9(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function u9(e) {
  return R.isObject(e) && e.isAxiosError === !0;
}
const wc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(wc).forEach(([e, t]) => {
  wc[t] = e;
});
function I_(e) {
  const t = new Kn(e), n = u_(Kn.prototype.request, t);
  return R.extend(n, Kn.prototype, t, { allOwnKeys: !0 }), R.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return I_(eo(e, o));
  }, n;
}
const Be = I_(Xa);
Be.Axios = Kn;
Be.CanceledError = ea;
Be.CancelToken = l9;
Be.isCancel = S_;
Be.VERSION = j_;
Be.toFormData = ys;
Be.AxiosError = he;
Be.Cancel = Be.CanceledError;
Be.all = function(e) {
  return Promise.all(e);
};
Be.spread = c9;
Be.isAxiosError = u9;
Be.mergeConfig = eo;
Be.AxiosHeaders = ht;
Be.formToJSON = (e) => $_(R.isHTMLForm(e) ? new FormData(e) : e);
Be.getAdapter = N_.getAdapter;
Be.HttpStatusCode = wc;
Be.default = Be;
const {
  Axios: Zye,
  AxiosError: d9,
  CanceledError: Jye,
  isCancel: Yye,
  CancelToken: Xye,
  VERSION: Qye,
  all: e_e,
  Cancel: t_e,
  isAxiosError: n_e,
  spread: o_e,
  toFormData: a_e,
  AxiosHeaders: r_e,
  HttpStatusCode: i_e,
  formToJSON: s_e,
  getAdapter: l_e,
  mergeConfig: c_e
} = Be, h9 = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class p9 {
  baseUrl;
  headers;
  constructor(t, n = {}) {
    this.baseUrl = t, this.headers = n?.headers || {};
  }
  async fetch(t, n = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const a = h9.test(t) ? t : `${this.baseUrl}${t}`;
    a.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Be(a, {
        ...o,
        method: n,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof d9 ? new Hp(`${r.code} - ${r.status} - ${a}`, r.status, r.response?.data) : new Hp("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
}
let T_;
function m9(e, t = {}) {
  T_ = new p9(e, t);
}
Pt();
function P_(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = P_(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Rt() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = P_(e)) && (o && (o += " "), o += t);
  return o;
}
const f9 = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], g9 = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, b9 = f9.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: g9[e]
})), v9 = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, y9 = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function _9(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const Oa = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = b9.find((l) => l.name === e), s = Rt("icon", `ds-${i?.class}`, y9[t], v9[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: _9(i?.paths) });
  }
);
Oa.displayName = "Icon";
const w9 = "_loader_1ksyv_29", k9 = "_circle_1ksyv_41", xo = {
  loader: w9,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: k9,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, x9 = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, $9 = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function S9({ onDark: e, size: t = "medium", color: n = "primary", className: o }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      className: Rt(
        xo.loader,
        xo[x9[t]],
        xo[$9[n]],
        e && xo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: xo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ P(
          "circle",
          {
            className: xo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const C9 = "_button_z1os6_29", E9 = "_disabled_z1os6_43", A9 = "_loader_z1os6_263", sn = {
  button: C9,
  disabled: E9,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: A9,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, O9 = pt(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: o = !1,
    icon: a,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...m
  }, f) => {
    const g = Rt(
      sn.button,
      sn[z9[t]],
      sn[N9[n]],
      o && sn["is-full-width"],
      c && sn.disabled,
      r === "right" && sn["has-icon-right"],
      l && sn["is-contrasted"],
      i && sn["is-loading"],
      u
    ), p = /* @__PURE__ */ P(je, { children: [
      i && /* @__PURE__ */ v(S9, { className: sn.loader, onDark: !0, size: "small" }),
      a && r === "left" && /* @__PURE__ */ v(Oa, { color: "inherit", size: s, name: a }),
      d ?? e,
      a && r === "right" && /* @__PURE__ */ v(Oa, { color: "inherit", size: s, name: a })
    ] });
    if (j9(m))
      return /* @__PURE__ */ v(
        "a",
        {
          ...m,
          href: c ? void 0 : m.href,
          className: g,
          target: m.target,
          ref: f,
          children: p
        }
      );
    if (R9(m))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...m,
          className: g,
          ref: f,
          children: p
        }
      );
  }
);
O9.displayName = "Button";
const z9 = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, N9 = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function j9(e) {
  return "href" in e && typeof e.href == "string";
}
function R9(e) {
  return !("href" in e);
}
const I9 = 0;
function T9(e, t, n, o) {
  const [a, r] = Ne(!1), i = a ? e : t, [s, l] = Ne(i ? i.length : I9), [c, u] = Ne(!1);
  return {
    valueCounter: s,
    isOnBlur: c,
    handleBlur: () => {
      u(!0), o && o();
    },
    handleChange: (d) => {
      r(!0), l(d.target.value.length), n && n(d), u(!1);
    }
  };
}
const cm = {
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, yl = {
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
}, P9 = "_input_s9iwc_29", D9 = "_filled_s9iwc_48", L9 = "_error_s9iwc_154", M9 = "_counter_s9iwc_174", gt = {
  input: P9,
  "group-label": "_group-label_s9iwc_29",
  filled: D9,
  "is-error": "_is-error_s9iwc_51",
  "is-success": "_is-success_s9iwc_54",
  "is-warning": "_is-warning_s9iwc_57",
  "helper-text": "_helper-text_s9iwc_60",
  "is-disabled": "_is-disabled_s9iwc_86",
  "is-full-width": "_is-full-width_s9iwc_101",
  "container-counter-icon": "_container-counter-icon_s9iwc_148",
  error: L9,
  "container-icon": "_container-icon_s9iwc_157",
  counter: M9,
  "dialog-overlay-show": "_dialog-overlay-show_s9iwc_1",
  "dialog-content-show": "_dialog-content-show_s9iwc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_s9iwc_1"
}, F9 = pt(
  ({
    className: e,
    type: t = "text",
    value: n,
    message: o,
    status: a,
    placeholder: r,
    onChange: i,
    onBlur: s,
    disabled: l,
    label: c,
    helperText: u,
    name: d,
    isFullWidth: m,
    defaultValue: f,
    id: g,
    optionalMessage: p,
    maxLength: b,
    ...w
  }, y) => {
    const {
      valueCounter: _,
      handleBlur: k,
      handleChange: x
    } = T9(
      n?.toString(),
      f?.toString(),
      i,
      s ? () => s({}) : void 0
    ), S = Rt(
      gt.input,
      a && gt[yl[a]],
      l && gt["is-disabled"],
      m && gt["is-full-width"],
      e
    );
    return /* @__PURE__ */ P("div", { className: S, children: [
      /* @__PURE__ */ P("div", { className: gt["group-label"], children: [
        /* @__PURE__ */ P("div", { children: [
          c && /* @__PURE__ */ v("label", { className: Rt(a && gt[a]), children: c }),
          p && /* @__PURE__ */ v("span", { children: p })
        ] }),
        u && /* @__PURE__ */ v("div", { className: gt["helper-text"], children: u })
      ] }),
      /* @__PURE__ */ v(
        "input",
        {
          id: g,
          ref: y,
          value: n,
          className: Rt(a && !l && gt[yl[a]]),
          type: t,
          placeholder: r,
          onChange: x,
          onBlur: k,
          name: d,
          defaultValue: f,
          "aria-label": c,
          disabled: l,
          ...w
        }
      ),
      (o && a && !l || b) && /* @__PURE__ */ P("div", { className: gt["container-counter-icon"], children: [
        o && a && !l && /* @__PURE__ */ P("div", { className: gt["container-icon"], children: [
          /* @__PURE__ */ v(Oa, { name: cm[a].name, size: "medium", color: cm[a].color }),
          /* @__PURE__ */ v("span", { className: gt[yl[a]], children: o })
        ] }),
        b && /* @__PURE__ */ P("div", { className: Rt(gt.counter, _ > b && gt.error), children: [
          _,
          "/",
          b
        ] })
      ] })
    ] });
  }
);
F9.displayName = "Input";
const W9 = "_container_1iybi_29", B9 = "_message_1iybi_33", V9 = "_error_1iybi_39", U9 = "_disabled_1iybi_49", ln = {
  container: W9,
  message: B9,
  error: V9,
  "input-container": "_input-container_1iybi_43",
  disabled: U9,
  "checkbox-input": "_checkbox-input_1iybi_52",
  "label-container": "_label-container_1iybi_99"
}, q9 = pt(
  ({ label: e, value: t, onChange: n, name: o, message: a, hasError: r, disabled: i, checked: s }, l) => {
    const c = Rt(ln["checkbox-input"], r && ln.error, i && ln.disabled);
    return /* @__PURE__ */ P("div", { className: ln.container, children: [
      /* @__PURE__ */ P("label", { className: Rt(ln["input-container"], i && ln.disabled), children: [
        /* @__PURE__ */ v(
          "input",
          {
            type: "checkbox",
            className: c,
            name: o,
            value: t,
            onChange: n,
            disabled: i,
            checked: s,
            ref: l
          }
        ),
        /* @__PURE__ */ v("div", { className: ln["label-container"], children: e })
      ] }),
      a && /* @__PURE__ */ v("span", { className: Rt(ln.message, r && ln.error), children: a })
    ] });
  }
);
q9.displayName = "Checkbox";
function ve(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var nt = globalThis?.document ? h.useLayoutEffect : () => {
};
function um(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function D_(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((a) => {
      const r = um(a, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let a = 0; a < o.length; a++) {
          const r = o[a];
          typeof r == "function" ? r() : um(e[a], null);
        }
      };
  };
}
function Re(...e) {
  return h.useCallback(D_(...e), e);
}
function H9(e, t) {
  const n = h.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = h.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(n.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function a(r) {
    const i = h.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, a];
}
function Qa(e, t = []) {
  let n = [];
  function o(r, i) {
    const s = h.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      const { scope: m, children: f, ...g } = d, p = m?.[e]?.[l] || s, b = h.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: f });
    };
    c.displayName = r + "Provider";
    function u(d, m) {
      const f = m?.[e]?.[l] || s, g = h.useContext(f);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const a = () => {
    const r = n.map((i) => h.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return a.scopeName = e, [o, K9(a, ...t)];
}
function K9(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(a) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(a)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function za(e) {
  const t = /* @__PURE__ */ G9(e), n = h.forwardRef((o, a) => {
    const { children: r, ...i } = o, s = h.Children.toArray(r), l = s.find(J9);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? h.Children.count(c) > 1 ? h.Children.only(null) : h.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: a, children: h.isValidElement(c) ? h.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: a, children: r });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function G9(e) {
  const t = h.forwardRef((n, o) => {
    const { children: a, ...r } = n;
    if (h.isValidElement(a)) {
      const i = X9(a), s = Y9(r, a.props);
      return a.type !== h.Fragment && (s.ref = o ? D_(o, i) : i), h.cloneElement(a, s);
    }
    return h.Children.count(a) > 1 ? h.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Z9 = Symbol("radix.slottable");
function J9(e) {
  return h.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Z9;
}
function Y9(e, t) {
  const n = { ...t };
  for (const o in t) {
    const a = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? a && r ? n[o] = (...i) => {
      const s = r(...i);
      return a(...i), s;
    } : a && (n[o] = a) : o === "style" ? n[o] = { ...a, ...r } : o === "className" && (n[o] = [a, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function X9(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Q9 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ye = Q9.reduce((e, t) => {
  const n = /* @__PURE__ */ za(`Primitive.${t}`), o = h.forwardRef((a, r) => {
    const { asChild: i, ...s } = a, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function eK(e, t) {
  e && so.flushSync(() => e.dispatchEvent(t));
}
var tK = h.createContext(void 0);
function nK(e) {
  const t = h.useContext(tK);
  return e || t || "ltr";
}
function oK(e) {
  const t = e + "CollectionProvider", [n, o] = Qa(t), [a, r] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, y = ae.useRef(null), _ = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(a, { scope: b, itemMap: _, collectionRef: y, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ za(s), c = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y } = p, _ = r(s, w), k = Re(b, _.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: y });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ za(u), f = ae.forwardRef(
    (p, b) => {
      const { scope: w, children: y, ..._ } = p, k = ae.useRef(null), x = Re(b, k), S = r(u, w);
      return ae.useEffect(() => (S.itemMap.set(k, { ref: k, ..._ }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(m, { [d]: "", ref: x, children: y });
    }
  );
  f.displayName = u;
  function g(p) {
    const b = r(e + "CollectionConsumer", p);
    return ae.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const y = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (_, k) => y.indexOf(_.ref.current) - y.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    g,
    o
  ];
}
var aK = h[" useId ".trim().toString()] || (() => {
}), rK = 0;
function L_(e) {
  const [t, n] = h.useState(aK());
  return nt(() => {
    n((o) => o ?? String(rK++));
  }, [e]), t ? `radix-${t}` : "";
}
function iK(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var po = (e) => {
  const { present: t, children: n } = e, o = sK(t), a = typeof n == "function" ? n({ present: o.isPresent }) : h.Children.only(n), r = Re(o.ref, lK(a));
  return typeof n == "function" || o.isPresent ? h.cloneElement(a, { ref: r }) : null;
};
po.displayName = "Presence";
function sK(e) {
  const [t, n] = h.useState(), o = h.useRef(null), a = h.useRef(e), r = h.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = iK(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const c = Cr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), nt(() => {
    const c = o.current, u = a.current;
    if (u !== e) {
      const d = r.current, m = Cr(c);
      e ? l("MOUNT") : m === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== m ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, l]), nt(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (f) => {
        const g = Cr(o.current).includes(CSS.escape(f.animationName));
        if (f.target === t && g && (l("ANIMATION_END"), !a.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, m = (f) => {
        f.target === t && (r.current = Cr(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: h.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Cr(e) {
  return e?.animationName || "none";
}
function lK(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function lt(e) {
  const t = h.useRef(e);
  return h.useEffect(() => {
    t.current = e;
  }), h.useMemo(() => (...n) => t.current?.(...n), []);
}
function cK(e) {
  const [t, n] = h.useState(void 0);
  return nt(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const r = a[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function uK(e) {
  const t = h.useRef({ value: e, previous: e });
  return h.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const dK = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: n,
  onChangeCountry: o
}) => {
  const [a, r] = Ne(e), [i, s] = Ne(t);
  return {
    phoneNumber: a,
    country: i,
    handlePhoneNumberChange: (l) => {
      r(l), n?.(l);
    },
    handleCountryChange: (l) => {
      s(l), o?.(l);
    }
  };
}, hK = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, pK = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, mK = { ...hK, ...pK }, fK = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, gK = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, bK = { ...fK, ...gK }, vK = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, yK = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, _K = { ...vK, ...yK }, wK = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, kK = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, xK = { ...wK, ...kK }, $K = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, SK = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, CK = { ...$K, ...SK }, EK = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, AK = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, OK = { ...EK, ...AK }, zK = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, NK = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, jK = { ...zK, ...NK }, RK = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, IK = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, dm = { ...RK, ...IK }, TK = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, PK = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, DK = { ...TK, ...PK }, LK = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, MK = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, FK = { ...LK, ...MK }, WK = {
  en: _K,
  fr: CK,
  it: jK,
  es: xK,
  de: bK,
  da: mK,
  hr: OK,
  nb: dm,
  nl: dm,
  pt: DK,
  sv: FK
}, hm = {
  error: "is-error"
}, pm = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
};
var BK = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], M_ = [];
for (const e of BK)
  M_.push({
    name: "",
    // populated in the plugin
    iso2: e[0],
    dialCode: e[1],
    priority: e[2] || 0,
    areaCodes: e[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: e[4] || null
  });
var xa = M_, VK = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, UK = VK, qK = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, HK = qK, KK = { ...UK, ...HK }, F_ = KK;
for (const e of xa)
  e.name = F_[e.iso2];
var GK = 0, _l = (e) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches, ZK = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const e = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = _l("(max-width: 500px)"), n = _l("(max-height: 600px)"), o = _l("(pointer: coarse)");
    return e || t || o && n;
  }
  return !1;
}, W_ = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: ZK(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
}, JK = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], ei = (e) => e.replace(/\D/g, ""), mm = (e = "") => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), fm = (e) => {
  const t = ei(e);
  if (t.charAt(0) === "1") {
    const n = t.substring(1, 4);
    return JK.includes(n);
  }
  return !1;
}, YK = (e, t, n, o) => {
  if (n === 0 && !o)
    return 0;
  let a = 0;
  for (let r = 0; r < t.length; r++) {
    if (/[+0-9]/.test(t[r]) && a++, a === e && !o)
      return r + 1;
    if (o && a === e + 1)
      return r;
  }
  return t.length;
}, Ue = (e, t, n) => {
  const o = document.createElement(e);
  return t && Object.entries(t).forEach(([a, r]) => o.setAttribute(a, r)), n && n.appendChild(o), o;
}, $a = (e, ...t) => {
  const { instances: n } = le;
  Object.values(n).forEach((o) => o[e](...t));
}, XK = class kc {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(t) {
    return Object.keys(t).filter((n) => !!t[n]).join(" ");
  }
  constructor(t, n = {}) {
    this.id = GK++, this.telInput = t, this.highlightedItem = null, this.options = Object.assign({}, W_, n), this.hadInitialPlaceholder = !!t.getAttribute("placeholder");
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    this.options.useFullscreenPopup && (this.options.fixDropdownWidth = !1), this.options.onlyCountries.length === 1 && (this.options.initialCountry = this.options.onlyCountries[0]), this.options.separateDialCode && (this.options.nationalMode = !1), this.options.allowDropdown && !this.options.showFlags && !this.options.separateDialCode && (this.options.nationalMode = !1), this.options.useFullscreenPopup && !this.options.dropdownContainer && (this.options.dropdownContainer = document.body), this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const t = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !t : t, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft), this.options.i18n = { ...F_, ...this.options.i18n };
    const n = new Promise((a, r) => {
      this.resolveAutoCountryPromise = a, this.rejectAutoCountryPromise = r;
    }), o = new Promise((a, r) => {
      this.resolveUtilsScriptPromise = a, this.rejectUtilsScriptPromise = r;
    });
    this.promise = Promise.all([n, o]), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this._processAllCountries(), this._processDialCodes(), this._translateCountryNames(), this._sortCountries(), this.countryByIso2 = new Map(this.countries.map((t) => [t.iso2, t])), this._cacheSearchTokens();
  }
  //* Precompute and cache country search tokens to speed up filtering
  _cacheSearchTokens() {
    for (const t of this.countries)
      t.normalisedName = mm(t.name), t.initials = t.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((n) => n[0]).join("").toLowerCase(), t.dialCodePlus = `+${t.dialCode}`;
  }
  //* Sort countries by countryOrder option (if present), then name.
  _sortCountries() {
    this.options.countryOrder && (this.options.countryOrder = this.options.countryOrder.map((t) => t.toLowerCase())), this.countries.sort((t, n) => {
      const { countryOrder: o } = this.options;
      if (o) {
        const a = o.indexOf(t.iso2), r = o.indexOf(n.iso2), i = a > -1, s = r > -1;
        if (i || s)
          return i && s ? a - r : i ? -1 : 1;
      }
      return t.name.localeCompare(n.name);
    });
  }
  //* Add a dial code to this.dialCodeToIso2Map.
  _addToDialCodeMap(t, n, o) {
    if (!t || !n)
      return;
    n.length > this.dialCodeMaxLen && (this.dialCodeMaxLen = n.length), this.dialCodeToIso2Map.hasOwnProperty(n) || (this.dialCodeToIso2Map[n] = []);
    const a = this.dialCodeToIso2Map[n];
    if (a.includes(t))
      return;
    const r = o !== void 0 ? o : a.length;
    a[r] = t;
  }
  //* Process onlyCountries or excludeCountries array if present.
  _processAllCountries() {
    const { onlyCountries: t, excludeCountries: n } = this.options;
    if (t.length) {
      const o = t.map(
        (a) => a.toLowerCase()
      );
      this.countries = xa.filter(
        (a) => o.includes(a.iso2)
      );
    } else if (n.length) {
      const o = n.map(
        (a) => a.toLowerCase()
      );
      this.countries = xa.filter(
        (a) => !o.includes(a.iso2)
      );
    } else
      this.countries = xa;
  }
  //* Translate Countries by object literal provided on config.
  _translateCountryNames() {
    for (const t of this.countries) {
      const n = t.iso2.toLowerCase();
      this.options.i18n.hasOwnProperty(n) && (t.name = this.options.i18n[n]);
    }
  }
  //* Generate this.dialCodes and this.dialCodeToIso2Map.
  _processDialCodes() {
    this.dialCodes = /* @__PURE__ */ new Set(), this.dialCodeMaxLen = 0, this.dialCodeToIso2Map = {};
    for (const t of this.countries)
      this.dialCodes.has(t.dialCode) || this.dialCodes.add(t.dialCode), this._addToDialCodeMap(t.iso2, t.dialCode, t.priority);
    (this.options.onlyCountries.length || this.options.excludeCountries.length) && this.dialCodes.forEach((t) => {
      this.dialCodeToIso2Map[t] = this.dialCodeToIso2Map[t].filter(Boolean);
    });
    for (const t of this.countries)
      if (t.areaCodes) {
        const n = this.dialCodeToIso2Map[t.dialCode][0];
        for (const o of t.areaCodes) {
          for (let a = 1; a < o.length; a++) {
            const r = o.substring(0, a), i = t.dialCode + r;
            this._addToDialCodeMap(n, i), this._addToDialCodeMap(t.iso2, i);
          }
          this._addToDialCodeMap(t.iso2, t.dialCode + o);
        }
      }
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
    const {
      allowDropdown: t,
      separateDialCode: n,
      showFlags: o,
      containerClass: a,
      hiddenInput: r,
      dropdownContainer: i,
      fixDropdownWidth: s,
      useFullscreenPopup: l,
      countrySearch: c,
      i18n: u
    } = this.options, d = kc._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": t,
      "iti--show-flags": o,
      "iti--inline-dropdown": !l,
      [a]: !!a
    }), m = Ue("div", { class: d });
    if (this.telInput.parentNode?.insertBefore(m, this.telInput), t || o || n) {
      this.countryContainer = Ue(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        m
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", t ? (this.selectedCountry = Ue(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = Ue(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const f = Ue(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      if (this.selectedCountryInner = Ue(
        "div",
        { class: "iti__flag" },
        f
      ), t && (this.dropdownArrow = Ue(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        f
      )), n && (this.selectedDialCode = Ue(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), t) {
        const g = s ? "" : "iti--flexible-dropdown-width";
        if (this.dropdownContent = Ue("div", {
          id: `iti-${this.id}__dropdown-content`,
          class: `iti__dropdown-content iti__hide ${g}`,
          role: "dialog",
          "aria-modal": "true"
        }), c) {
          const p = Ue(
            "div",
            { class: "iti__search-input-wrapper" },
            this.dropdownContent
          );
          this.searchIcon = Ue(
            "span",
            {
              class: "iti__search-icon",
              "aria-hidden": "true"
            },
            p
          ), this.searchIcon.innerHTML = `
            <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>`, this.searchInput = Ue(
            "input",
            {
              id: `iti-${this.id}__search-input`,
              // Chrome says inputs need either a name or an id
              type: "search",
              class: "iti__search-input",
              placeholder: u.searchPlaceholder,
              // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
              role: "combobox",
              "aria-expanded": "true",
              "aria-label": u.searchPlaceholder,
              "aria-controls": `iti-${this.id}__country-listbox`,
              "aria-autocomplete": "list",
              autocomplete: "off"
            },
            p
          ), this.searchClearButton = Ue(
            "button",
            {
              type: "button",
              class: "iti__search-clear iti__hide",
              "aria-label": u.clearSearchAriaLabel,
              tabindex: "-1"
            },
            p
          );
          const b = `iti-${this.id}-clear-mask`;
          this.searchClearButton.innerHTML = `
            <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <mask id="${b}" maskUnits="userSpaceOnUse">
                <rect width="16" height="16" fill="white" />
                <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
              </mask>
              <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${b})" />
            </svg>`, this.searchResultsA11yText = Ue(
            "span",
            { class: "iti__a11y-text" },
            this.dropdownContent
          ), this.searchNoResults = Ue(
            "div",
            {
              class: "iti__no-results iti__hide",
              "aria-hidden": "true"
              // all a11y messaging happens in this.searchResultsA11yText
            },
            this.dropdownContent
          ), this.searchNoResults.textContent = u.zeroSearchResults;
        }
        if (this.countryList = Ue(
          "ul",
          {
            class: "iti__country-list",
            id: `iti-${this.id}__country-listbox`,
            role: "listbox",
            "aria-label": u.countryListAriaLabel
          },
          this.dropdownContent
        ), this._appendListItems(), c && this._updateSearchResultsA11yText(), i) {
          const p = kc._buildClassNames({
            iti: !0,
            "iti--container": !0,
            "iti--fullscreen-popup": l,
            "iti--inline-dropdown": !l,
            [a]: !!a
          });
          this.dropdown = Ue("div", { class: p }), this.dropdown.appendChild(this.dropdownContent);
        } else
          this.countryContainer.appendChild(this.dropdownContent);
      }
    }
    if (m.appendChild(this.telInput), this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide")), r) {
      const f = this.telInput.getAttribute("name") || "", g = r(f);
      if (g.phone) {
        const p = this.telInput.form?.querySelector(`input[name="${g.phone}"]`);
        p ? this.hiddenInput = p : (this.hiddenInput = Ue("input", {
          type: "hidden",
          name: g.phone
        }), m.appendChild(this.hiddenInput));
      }
      if (g.country) {
        const p = this.telInput.form?.querySelector(`input[name="${g.country}"]`);
        p ? this.hiddenInputCountry = p : (this.hiddenInputCountry = Ue("input", {
          type: "hidden",
          name: g.country
        }), m.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let t = 0; t < this.countries.length; t++) {
      const n = this.countries[t], o = t === 0 ? "iti__highlight" : "", a = Ue(
        "li",
        {
          id: `iti-${this.id}__item-${n.iso2}`,
          class: `iti__country ${o}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": n.dialCode,
          "data-country-code": n.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      n.nodeById[this.id] = a;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${n.iso2}'></div>`), r += `<span class='iti__country-name'>${n.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${n.dialCode}</span>`, a.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(t = !1) {
    const n = this.telInput.getAttribute("value"), o = this.telInput.value, a = n && n.charAt(0) === "+" && (!o || o.charAt(0) !== "+") ? n : o, r = this._getDialCode(a), i = fm(a), { initialCountry: s, geoIpLookup: l } = this.options, c = s === "auto" && l;
    if (r && !i)
      this._updateCountryFromNumber(a);
    else if (!c || t) {
      const u = s ? s.toLowerCase() : "";
      u && this._getCountryData(u, !0) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry();
    }
    a && this._updateValFromNumber(a);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (n) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : n.preventDefault();
    };
    const t = this.telInput.closest("label");
    t && t.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (n) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(n.key) && (n.preventDefault(), n.stopPropagation(), this._openDropdown()), n.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: t, initialCountry: n, geoIpLookup: o } = this.options;
    t && !le.utils ? (this._handlePageLoad = () => {
      window.removeEventListener("load", this._handlePageLoad), le.attachUtils(t)?.catch(() => {
      });
    }, le.documentReady() ? this._handlePageLoad() : window.addEventListener("load", this._handlePageLoad)) : this.resolveUtilsScriptPromise(), n === "auto" && o && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    le.autoCountry ? this.handleAutoCountry() : le.startedLoadingAutoCountry || (le.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (t = "") => {
        const n = t.toLowerCase();
        n && this._getCountryData(n, !0) ? (le.autoCountry = n, setTimeout(() => $a("handleAutoCountry"))) : (this._setInitialState(!0), $a("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), $a("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    const { strictMode: t, formatAsYouType: n, separateDialCode: o, allowDropdown: a, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (s) => {
      if (this.isAndroid && s?.data === "+" && o && a && r) {
        const d = this.telInput.selectionStart || 0, m = this.telInput.value.substring(0, d - 1), f = this.telInput.value.substring(d);
        this.telInput.value = m + f, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const l = s?.data && /[^+0-9]/.test(s.data), c = s?.inputType === "insertFromPaste" && this.telInput.value;
      l || c && !t ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = s?.detail && s.detail.isSetNumber;
      if (n && !i && !u) {
        const d = this.telInput.selectionStart || 0, m = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, f = s?.inputType === "deleteContentForward", g = this._formatNumberAsYouType(), p = YK(m, g, d, f);
        this.telInput.value = g, this.telInput.setSelectionRange(p, p);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent), (t || o) && (this._handleKeydownEvent = (s) => {
      if (s.key && s.key.length === 1 && !s.altKey && !s.ctrlKey && !s.metaKey) {
        if (o && a && r && s.key === "+") {
          s.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (t) {
          const l = this.telInput.value, c = l.charAt(0) !== "+" && this.telInput.selectionStart === 0 && s.key === "+", u = /^[0-9]$/.test(s.key), d = o ? u : c || u, m = l.slice(0, this.telInput.selectionStart) + s.key + l.slice(this.telInput.selectionEnd), f = this._getFullNumber(m), g = le.utils.getCoreNumber(f, this.selectedCountryData.iso2), p = this.maxCoreNumberLength && g.length > this.maxCoreNumberLength, b = this._getNewCountryFromNumber(f) !== null;
          (!d || p && !b && !c) && s.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(t) {
    const n = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return n && t.length > n ? t.substring(0, n) : t;
  }
  //* Trigger a custom event on the input.
  _trigger(t, n = {}) {
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: n
    });
    this.telInput.dispatchEvent(o);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: t, countrySearch: n } = this.options;
    if (t && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), n) {
      const o = this.countryList.firstElementChild;
      o && (this._highlightListItem(o, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const t = this.telInput.getBoundingClientRect(), n = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${t.top + n}px`, this.dropdown.style.left = `${t.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (o) => {
      const a = o.target?.closest(".iti__country");
      a && this._highlightListItem(a, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (o) => {
      const a = o.target?.closest(".iti__country");
      a && this._selectListItem(a);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (o) => {
      o.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let t = "", n = null;
    if (this._handleKeydownOnDropdown = (o) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(o.key) && (o.preventDefault(), o.stopPropagation(), o.key === "ArrowUp" || o.key === "ArrowDown" ? this._handleUpDownKey(o.key) : o.key === "Enter" ? this._handleEnterKey() : o.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(o.key) && (o.stopPropagation(), n && clearTimeout(n), t += o.key.toLowerCase(), this._searchForCountry(t), n = setTimeout(() => {
        t = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const o = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let a = null;
      this._handleSearchChange = () => {
        a && clearTimeout(a), a = setTimeout(() => {
          o(), a = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), o();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(t) {
    for (const n of this.countries)
      if (n.name.substring(0, t.length).toLowerCase() === t) {
        const o = n.nodeById[this.id];
        this._highlightListItem(o, !1), this._scrollTo(o);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(t) {
    let n = !0;
    this.countryList.innerHTML = "";
    const o = mm(t);
    let a;
    if (t === "")
      a = this.countries;
    else {
      const r = [], i = [], s = [], l = [], c = [], u = [];
      for (const d of this.countries)
        d.iso2 === o ? r.push(d) : d.normalisedName.startsWith(o) ? i.push(d) : d.normalisedName.includes(o) ? s.push(d) : o === d.dialCode || o === d.dialCodePlus ? l.push(d) : d.dialCodePlus.includes(o) ? c.push(d) : d.initials.includes(o) && u.push(d);
      a = [
        ...r.sort((d, m) => d.priority - m.priority),
        ...i.sort((d, m) => d.priority - m.priority),
        ...s.sort((d, m) => d.priority - m.priority),
        ...l.sort((d, m) => d.priority - m.priority),
        ...c.sort((d, m) => d.priority - m.priority),
        ...u.sort((d, m) => d.priority - m.priority)
      ];
    }
    for (const r of a) {
      const i = r.nodeById[this.id];
      i && (this.countryList.appendChild(i), n && (this._highlightListItem(i, !1), n = !1));
    }
    n ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: t } = this.options, n = this.countryList.childElementCount;
    let o;
    n === 0 ? o = t.zeroSearchResults : t.searchResultsText ? o = t.searchResultsText(n) : n === 1 ? o = t.oneSearchResult : o = t.multipleSearchResults.replace("${count}", n.toString()), this.searchResultsA11yText.textContent = o;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(t) {
    let n = t === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !n && this.countryList.childElementCount > 1 && (n = t === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), n && (this._scrollTo(n), this._highlightListItem(n, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(t) {
    let n = t;
    if (this.options.formatOnDisplay && le.utils && this.selectedCountryData) {
      const o = this.options.nationalMode || n.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: a, INTERNATIONAL: r } = le.utils.numberFormat, i = o ? a : r;
      n = le.utils.formatNumber(
        n,
        this.selectedCountryData.iso2,
        i
      );
    }
    n = this._beforeSetNumber(n), this.telInput.value = n;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(t) {
    const n = this._getNewCountryFromNumber(t);
    return n !== null ? this._setCountry(n) : !1;
  }
  _ensureHasDialCode(t) {
    const { dialCode: n, nationalPrefix: o } = this.selectedCountryData;
    if (t.charAt(0) === "+" || !n)
      return t;
    const a = o && t.charAt(0) === o && !this.options.separateDialCode ? t.substring(1) : t;
    return `+${n}${a}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(t) {
    const n = t.indexOf("+");
    let o = n ? t.substring(n) : t;
    const a = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    o = this._ensureHasDialCode(o);
    const i = this._getDialCode(o, !0), s = ei(o);
    if (i) {
      const l = ei(i), c = this.dialCodeToIso2Map[l];
      if (c.length === 1)
        return c[0] === a ? null : c[0];
      if (!a && this.defaultCountry && c.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && fm(s))
        return null;
      const u = this.selectedCountryData.areaCodes && s.length > l.length;
      if (!(a && c.includes(a) && !u))
        return c[0];
    } else {
      if (o.charAt(0) === "+" && s.length)
        return "";
      if ((!o || o === "+") && !a)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(t, n) {
    const o = this.highlightedItem;
    if (o && (o.classList.remove("iti__highlight"), o.setAttribute("aria-selected", "false")), this.highlightedItem = t, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const a = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", a);
    }
    n && this.highlightedItem.focus();
  }
  //* Find the country data for the given iso2 code
  //* the allowFail option is only used during init() for the initialCountry option, and for the iso2 returned from geoIpLookup - in these 2 cases we don't want to error out
  _getCountryData(t, n) {
    const o = this.countryByIso2.get(t);
    if (o)
      return o;
    if (n)
      return null;
    throw new Error(`No country data for '${t}'`);
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(t) {
    const { separateDialCode: n, showFlags: o, i18n: a } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = t ? this._getCountryData(t, !1) || {} : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = t && o ? `iti__flag iti__${t}` : "iti__flag iti__globe";
      let s, l;
      if (t) {
        const { name: c, dialCode: u } = this.selectedCountryData;
        l = c, s = a.selectedCountryAriaLabel.replace("${countryName}", c).replace("${dialCode}", `+${u}`);
      } else
        l = a.noCountrySelected, s = a.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", l), this.selectedCountry.setAttribute("aria-label", s);
    }
    if (n) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== t;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const t = this.options.separateDialCode ? 78 : 42, n = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || t) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${n}px` : this.telInput.style.paddingRight = `${n}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: t, placeholderNumberType: n, validationNumberTypes: o } = this.options, { iso2: a } = this.selectedCountryData;
    if (t && le.utils)
      if (a) {
        const r = le.utils.numberType[n];
        let i = le.utils.getExampleNumber(
          a,
          !1,
          r,
          !0
        ), s = i;
        for (; le.utils.isPossibleNumber(i, a, o); )
          s = i, i += "0";
        const l = le.utils.getCoreNumber(s, a);
        this.maxCoreNumberLength = l.length, a === "by" && (this.maxCoreNumberLength = l.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let t;
      try {
        t = window.top.document.body;
      } catch {
        t = document.body;
      }
      const n = this.telInput.parentNode.cloneNode(!1);
      n.style.visibility = "hidden", t.appendChild(n);
      const o = this.countryContainer.cloneNode();
      n.appendChild(o);
      const a = this.selectedCountry.cloneNode(!0);
      o.appendChild(a);
      const r = a.offsetWidth;
      return t.removeChild(n), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: t,
      placeholderNumberType: n,
      nationalMode: o,
      customPlaceholder: a
    } = this.options, r = t === "aggressive" || !this.hadInitialPlaceholder && t === "polite";
    if (le.utils && r) {
      const i = le.utils.numberType[n];
      let s = this.selectedCountryData.iso2 ? le.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        o,
        i
      ) : "";
      s = this._beforeSetNumber(s), typeof a == "function" && (s = a(s, this.selectedCountryData)), this.telInput.setAttribute("placeholder", s);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(t) {
    const n = this._setCountry(
      t.getAttribute("data-country-code")
    );
    this._closeDropdown(), this._updateDialCode(t.getAttribute("data-dial-code")), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), n && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(t) {
    const n = this.countryList, o = document.documentElement.scrollTop, a = n.offsetHeight, r = n.getBoundingClientRect().top + o, i = r + a, s = t.offsetHeight, l = t.getBoundingClientRect().top + o, c = l + s, u = l - r + n.scrollTop;
    if (l < r)
      n.scrollTop = u;
    else if (c > i) {
      const d = a - s;
      n.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(t) {
    const n = this.telInput.value, o = `+${t}`;
    let a;
    if (n.charAt(0) === "+") {
      const r = this._getDialCode(n);
      r ? a = n.replace(r, o) : a = o, this.telInput.value = a;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(t, n) {
    let o = "";
    if (t.charAt(0) === "+") {
      let a = "";
      for (let r = 0; r < t.length; r++) {
        const i = t.charAt(r);
        if (!isNaN(parseInt(i, 10))) {
          if (a += i, n)
            this.dialCodeToIso2Map[a] && (o = t.substring(0, r + 1));
          else if (this.dialCodes.has(a)) {
            o = t.substring(0, r + 1);
            break;
          }
          if (a.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return o;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(t) {
    const n = t || this.telInput.value.trim(), { dialCode: o } = this.selectedCountryData;
    let a;
    const r = ei(n);
    return this.options.separateDialCode && n.charAt(0) !== "+" && o && r ? a = `+${o}` : a = "", a + n;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(t) {
    let n = t;
    if (this.options.separateDialCode) {
      let o = this._getDialCode(n);
      if (o) {
        o = `+${this.selectedCountryData.dialCode}`;
        const a = n[o.length] === " " || n[o.length] === "-" ? o.length + 1 : o.length;
        n = n.substring(a);
      }
    }
    return this._cap(n);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //* Format the number as the user types.
  _formatNumberAsYouType() {
    const t = this._getFullNumber(), n = le.utils ? le.utils.formatNumberAsYouType(t, this.selectedCountryData.iso2) : t, { dialCode: o } = this.selectedCountryData;
    return this.options.separateDialCode && this.telInput.value.charAt(0) !== "+" && n.includes(`+${o}`) ? (n.split(`+${o}`)[1] || "").trim() : n;
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && le.autoCountry && (this.defaultCountry = le.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    le.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: t, separateDialCode: n } = this.options;
    if (t) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: o } = this.telInput;
    this._handleHiddenInputSubmit && o && o.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this.telInput.removeAttribute("data-intl-tel-input-id"), n && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const a = this.telInput.parentNode;
    a?.parentNode?.insertBefore(this.telInput, a), a?.parentNode?.removeChild(a), delete le.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return le.utils ? le.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(t) {
    if (le.utils) {
      const { iso2: n } = this.selectedCountryData;
      return le.utils.formatNumber(
        this._getFullNumber(),
        n,
        t
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return le.utils ? le.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (le.utils) {
      const { iso2: t } = this.selectedCountryData;
      return le.utils.getValidationError(this._getFullNumber(), t);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(t) {
    return le.utils ? le.utils.isPossibleNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(t) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const n = (r) => t ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), o = this._getFullNumber(), a = o.search(new RegExp("\\p{L}", "u"));
    if (a > -1 && !this.options.allowPhonewords) {
      const r = o.substring(0, a), i = n(r), s = n(o);
      return i && s;
    }
    return n(o);
  }
  _utilsIsValidNumber(t) {
    return le.utils ? le.utils.isValidNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(t) {
    const n = t?.toLowerCase(), o = this.selectedCountryData.iso2;
    (t && n !== o || !t && o) && (this._setCountry(n), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(t) {
    const n = this._updateCountryFromNumber(t);
    this._updateValFromNumber(t), n && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(t) {
    this.options.placeholderNumberType = t, this._updatePlaceholder();
  }
  setDisabled(t) {
    this.telInput.disabled = t, t ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, QK = (e) => {
  if (!le.utils && !le.startedLoadingUtilsScript) {
    let t;
    if (typeof e == "function")
      try {
        t = Promise.resolve(e());
      } catch (n) {
        return Promise.reject(n);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof e}`));
    return le.startedLoadingUtilsScript = !0, t.then((n) => {
      const o = n?.default;
      if (!o || typeof o != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return le.utils = o, $a("handleUtils"), !0;
    }).catch((n) => {
      throw $a("rejectUtilsScriptPromise", n), n;
    });
  }
  return null;
}, le = Object.assign(
  (e, t) => {
    const n = new XK(e, t);
    return n._init(), e.setAttribute("data-intl-tel-input-id", n.id.toString()), le.instances[n.id] = n, e.iti = n, n;
  },
  {
    defaults: W_,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => xa,
    //* A getter for the plugin instance.
    getInstance: (e) => {
      const t = e.getAttribute("data-intl-tel-input-id");
      return t ? le.instances[t] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: QK,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.6"
  }
), e8 = le, t8 = pt(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: n = () => {
  },
  onChangeValidity: o = () => {
  },
  onChangeErrorCode: a = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: s = {},
  disabled: l = void 0
}, c) {
  const u = Te(null), d = Te(null);
  zk(c, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const m = De(() => {
    const f = d.current?.getNumber() || "", g = d.current?.getSelectedCountryData().iso2 || "";
    if (t(f), n(g), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        o(!0), a(null);
      else {
        const p = d.current.getValidationError();
        o(!1), a(p);
      }
  }, [n, a, t, o, r]);
  return Se(() => (u.current && (d.current = e8(u.current, i)), () => {
    d.current?.destroy();
  }), []), Se(() => {
    const f = u.current;
    return f && (f.addEventListener("countrychange", m), d.current.promise.then(m)), () => {
      f && f.removeEventListener("countrychange", m);
    };
  }, [m]), Se(() => {
    d.current && l !== void 0 && d.current.setDisabled(l);
  }, [l]), /* @__PURE__ */ ae.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: m,
      defaultValue: e,
      ...s
    }
  );
}), n8 = t8;
const yn = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
pt(
  ({
    label: e,
    helperText: t,
    initialPhoneNumber: n,
    onChangePhoneNumber: o,
    initialCountry: a,
    onChangeCountry: r,
    locale: i = "en",
    message: s,
    status: l,
    disabled: c,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: m,
    setIsValidPhoneNumber: f
  }, g) => {
    const { phoneNumber: p, country: b, handlePhoneNumberChange: w, handleCountryChange: y } = dK({
      initialPhoneNumber: n,
      initialCountry: a,
      onChangePhoneNumber: o,
      onChangeCountry: r
    }), _ = Rt(
      yn["phone-number"],
      c && yn["is-disabled"],
      l && yn[hm[l]],
      u && yn["is-full-width"]
    );
    return /* @__PURE__ */ P("div", { className: _, children: [
      /* @__PURE__ */ P("div", { className: yn["group-label"], children: [
        e && /* @__PURE__ */ v("label", { children: e }),
        t && /* @__PURE__ */ v("div", { className: yn["helper-text"], children: t })
      ] }),
      /* @__PURE__ */ v(
        n8,
        {
          initialValue: p,
          onChangeErrorCode: m,
          onChangeValidity: f,
          onChangeCountry: y,
          onChangeNumber: w,
          inputProps: {
            disabled: c,
            "aria-label": d?.["aria-label"] || e,
            ...d
          },
          ref: g,
          initOptions: {
            strictMode: !0,
            initialCountry: b,
            i18n: WK[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CaI5VMju-BMN_h3sy-BGyUDE__.js")
          }
        }
      ),
      s && l && !c && /* @__PURE__ */ P("div", { className: yn["container-icon"], children: [
        /* @__PURE__ */ v(Oa, { name: pm[l].name, size: "medium", color: pm[l].color }),
        /* @__PURE__ */ v("span", { className: yn[hm[l]], children: s })
      ] })
    ] });
  }
);
function o8(e, t = globalThis?.document) {
  const n = lt(e);
  h.useEffect(() => {
    const o = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var a8 = "DismissableLayer", xc = "dismissableLayer.update", r8 = "dismissableLayer.pointerDownOutside", i8 = "dismissableLayer.focusOutside", gm, B_ = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nd = h.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = h.useContext(B_), [u, d] = h.useState(null), m = u?.ownerDocument ?? globalThis?.document, [, f] = h.useState({}), g = Re(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), y = u ? p.indexOf(u) : -1, _ = c.layersWithOutsidePointerEventsDisabled.size > 0, k = y >= w, x = c8(($) => {
      const E = $.target, C = [...c.branches].some((A) => A.contains(E));
      !k || C || (a?.($), i?.($), $.defaultPrevented || s?.());
    }, m), S = u8(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, m);
    return o8(($) => {
      y === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, m), h.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (gm = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), bm(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = gm);
        };
    }, [u, m, n, c]), h.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), bm());
    }, [u, c]), h.useEffect(() => {
      const $ = () => f({});
      return document.addEventListener(xc, $), () => document.removeEventListener(xc, $);
    }, []), /* @__PURE__ */ v(
      ye.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: _ ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ve(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ve(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ve(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
nd.displayName = a8;
var s8 = "DismissableLayerBranch", l8 = h.forwardRef((e, t) => {
  const n = h.useContext(B_), o = h.useRef(null), a = Re(t, o);
  return h.useEffect(() => {
    const r = o.current;
    if (r)
      return n.branches.add(r), () => {
        n.branches.delete(r);
      };
  }, [n.branches]), /* @__PURE__ */ v(ye.div, { ...e, ref: a });
});
l8.displayName = s8;
function c8(e, t = globalThis?.document) {
  const n = lt(e), o = h.useRef(!1), a = h.useRef(() => {
  });
  return h.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          V_(
            r8,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", a.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function u8(e, t = globalThis?.document) {
  const n = lt(e), o = h.useRef(!1);
  return h.useEffect(() => {
    const a = (r) => {
      r.target && !o.current && V_(i8, n, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function bm() {
  const e = new CustomEvent(xc);
  document.dispatchEvent(e);
}
function V_(e, t, n, { discrete: o }) {
  const a = n.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), o ? eK(a, r) : a.dispatchEvent(r);
}
var d8 = "Portal", h8 = h.forwardRef((e, t) => {
  const { container: n, ...o } = e, [a, r] = h.useState(!1);
  nt(() => r(!0), []);
  const i = n || a && globalThis?.document?.body;
  return i ? Ui.createPortal(/* @__PURE__ */ v(ye.div, { ...o, ref: t }), i) : null;
});
h8.displayName = d8;
var qt = function() {
  return qt = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, qt.apply(this, arguments);
};
function U_(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, o = Object.getOwnPropertySymbols(e); a < o.length; a++)
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
  return n;
}
function p8(e, t, n) {
  for (var o = 0, a = t.length, r; o < a; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var wl = "focusScope.autoFocusOnMount", kl = "focusScope.autoFocusOnUnmount", vm = { bubbles: !1, cancelable: !0 }, m8 = "FocusScope", od = h.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = h.useState(null), c = lt(a), u = lt(r), d = h.useRef(null), m = Re(t, (p) => l(p)), f = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (o) {
      let p = function(_) {
        if (f.paused || !s) return;
        const k = _.target;
        s.contains(k) ? d.current = k : $n(d.current, { select: !0 });
      }, b = function(_) {
        if (f.paused || !s) return;
        const k = _.relatedTarget;
        k !== null && (s.contains(k) || $n(d.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const k of _)
            k.removedNodes.length > 0 && $n(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const y = new MutationObserver(w);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [o, s, f.paused]), h.useEffect(() => {
    if (s) {
      _m.add(f);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(wl, vm);
        s.addEventListener(wl, c), s.dispatchEvent(b), b.defaultPrevented || (f8(_8(q_(s)), { select: !0 }), document.activeElement === p && $n(s));
      }
      return () => {
        s.removeEventListener(wl, c), setTimeout(() => {
          const b = new CustomEvent(kl, vm);
          s.addEventListener(kl, u), s.dispatchEvent(b), b.defaultPrevented || $n(p ?? document.body, { select: !0 }), s.removeEventListener(kl, u), _m.remove(f);
        }, 0);
      };
    }
  }, [s, c, u, f]);
  const g = h.useCallback(
    (p) => {
      if (!n && !o || f.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const y = p.currentTarget, [_, k] = g8(y);
        _ && k ? !p.shiftKey && w === k ? (p.preventDefault(), n && $n(_, { select: !0 })) : p.shiftKey && w === _ && (p.preventDefault(), n && $n(k, { select: !0 })) : w === y && p.preventDefault();
      }
    },
    [n, o, f.paused]
  );
  return /* @__PURE__ */ v(ye.div, { tabIndex: -1, ...i, ref: m, onKeyDown: g });
});
od.displayName = m8;
function f8(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if ($n(o, { select: t }), document.activeElement !== n) return;
}
function g8(e) {
  const t = q_(e), n = ym(t, e), o = ym(t.reverse(), e);
  return [n, o];
}
function q_(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const a = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || a ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ym(e, t) {
  for (const n of e)
    if (!b8(n, { upTo: t })) return n;
}
function b8(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function v8(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function $n(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && v8(e) && t && e.select();
  }
}
var _m = y8();
function y8() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = wm(e, t), e.unshift(t);
    },
    remove(t) {
      e = wm(e, t), e[0]?.resume();
    }
  };
}
function wm(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function _8(e) {
  return e.filter((t) => t.tagName !== "A");
}
var xl = 0;
function H_() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? km()), document.body.insertAdjacentElement("beforeend", e[1] ?? km()), xl++, () => {
      xl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), xl--;
    };
  }, []);
}
function km() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ti = "right-scroll-bar-position", ni = "width-before-scroll-bar", w8 = "with-scroll-bars-hidden", k8 = "--removed-body-scroll-bar-size";
function $l(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function x8(e, t) {
  var n = Ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var a = n.value;
          a !== o && (n.value = o, n.callback(o, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var $8 = typeof window < "u" ? h.useLayoutEffect : h.useEffect, xm = /* @__PURE__ */ new WeakMap();
function S8(e, t) {
  var n = x8(null, function(o) {
    return e.forEach(function(a) {
      return $l(a, o);
    });
  });
  return $8(function() {
    var o = xm.get(n);
    if (o) {
      var a = new Set(o), r = new Set(e), i = n.current;
      a.forEach(function(s) {
        r.has(s) || $l(s, null);
      }), r.forEach(function(s) {
        a.has(s) || $l(s, i);
      });
    }
    xm.set(n, e);
  }, [e]), n;
}
function C8(e) {
  return e;
}
function E8(e, t) {
  t === void 0 && (t = C8);
  var n = [], o = !1, a = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(r);
      }
      n = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(r), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return a;
}
function A8(e) {
  e === void 0 && (e = {});
  var t = E8(null);
  return t.options = qt({ async: !0, ssr: !1 }, e), t;
}
var K_ = function(e) {
  var t = e.sideCar, n = U_(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return h.createElement(o, qt({}, n));
};
K_.isSideCarExport = !0;
function O8(e, t) {
  return e.useMedium(t), K_;
}
var G_ = A8(), Sl = function() {
}, ws = h.forwardRef(function(e, t) {
  var n = h.useRef(null), o = h.useState({
    onScrollCapture: Sl,
    onWheelCapture: Sl,
    onTouchMoveCapture: Sl
  }), a = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, f = e.noIsolation, g = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, y = e.gapMode, _ = U_(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = m, x = S8([n, t]), S = qt(qt({}, _), a);
  return h.createElement(
    h.Fragment,
    null,
    u && h.createElement(k, { sideCar: G_, removeScrollBar: c, shards: d, noIsolation: f, inert: g, setCallbacks: r, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    i ? h.cloneElement(h.Children.only(s), qt(qt({}, S), { ref: x })) : h.createElement(w, qt({}, S, { className: l, ref: x }), s)
  );
});
ws.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ws.classNames = {
  fullWidth: ni,
  zeroRight: ti
};
var z8 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function N8() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = z8();
  return t && e.setAttribute("nonce", t), e;
}
function j8(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function R8(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var I8 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = N8()) && (j8(t, n), R8(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, T8 = function() {
  var e = I8();
  return function(t, n) {
    h.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Z_ = function() {
  var e = T8(), t = function(n) {
    var o = n.styles, a = n.dynamic;
    return e(o, a), null;
  };
  return t;
}, P8 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Cl = function(e) {
  return parseInt(e || "", 10) || 0;
}, D8 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Cl(n), Cl(o), Cl(a)];
}, L8 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return P8;
  var t = D8(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, M8 = Z_(), Io = "data-scroll-locked", F8 = function(e, t, n, o) {
  var a = e.left, r = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(w8, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Io, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ti, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ni, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ti, " .").concat(ti, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ni, " .").concat(ni, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Io, `] {
    `).concat(k8, ": ").concat(s, `px;
  }
`);
}, $m = function() {
  var e = parseInt(document.body.getAttribute(Io) || "0", 10);
  return isFinite(e) ? e : 0;
}, W8 = function() {
  h.useEffect(function() {
    return document.body.setAttribute(Io, ($m() + 1).toString()), function() {
      var e = $m() - 1;
      e <= 0 ? document.body.removeAttribute(Io) : document.body.setAttribute(Io, e.toString());
    };
  }, []);
}, B8 = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, a = o === void 0 ? "margin" : o;
  W8();
  var r = h.useMemo(function() {
    return L8(a);
  }, [a]);
  return h.createElement(M8, { styles: F8(r, !t, a, n ? "" : "!important") });
}, $c = !1;
if (typeof window < "u")
  try {
    var Er = Object.defineProperty({}, "passive", {
      get: function() {
        return $c = !0, !0;
      }
    });
    window.addEventListener("test", Er, Er), window.removeEventListener("test", Er, Er);
  } catch {
    $c = !1;
  }
var $o = $c ? { passive: !1 } : !1, V8 = function(e) {
  return e.tagName === "TEXTAREA";
}, J_ = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !V8(e) && n[t] === "visible")
  );
}, U8 = function(e) {
  return J_(e, "overflowY");
}, q8 = function(e) {
  return J_(e, "overflowX");
}, Sm = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var a = Y_(e, o);
    if (a) {
      var r = X_(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, H8 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, K8 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Y_ = function(e, t) {
  return e === "v" ? U8(t) : q8(t);
}, X_ = function(e, t) {
  return e === "v" ? H8(t) : K8(t);
}, G8 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Z8 = function(e, t, n, o, a) {
  var r = G8(e, window.getComputedStyle(t).direction), i = r * o, s = n.target, l = t.contains(s), c = !1, u = i > 0, d = 0, m = 0;
  do {
    var f = X_(e, s), g = f[0], p = f[1], b = f[2], w = p - b - r * g;
    (g || w) && Y_(e, s) && (d += w, m += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(m) < 1) && (c = !0), c;
}, Ar = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Cm = function(e) {
  return [e.deltaX, e.deltaY];
}, Em = function(e) {
  return e && "current" in e ? e.current : e;
}, J8 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Y8 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, X8 = 0, So = [];
function Q8(e) {
  var t = h.useRef([]), n = h.useRef([0, 0]), o = h.useRef(), a = h.useState(X8++)[0], r = h.useState(Z_)[0], i = h.useRef(e);
  h.useEffect(function() {
    i.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = p8([e.lockRef.current], (e.shards || []).map(Em)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = h.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Ar(p), y = n.current, _ = "deltaX" in p ? p.deltaX : y[0] - w[0], k = "deltaY" in p ? p.deltaY : y[1] - w[1], x, S = p.target, $ = Math.abs(_) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = Sm($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = Sm($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (_ || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return Z8(C, b, p, C === "h" ? _ : k);
  }, []), l = h.useCallback(function(p) {
    var b = p;
    if (!(!So.length || So[So.length - 1] !== r)) {
      var w = "deltaY" in b ? Cm(b) : Ar(b), y = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && J8(x.delta, w);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var _ = (i.current.shards || []).map(Em).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = _.length > 0 ? s(b, _[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = h.useCallback(function(p, b, w, y) {
    var _ = { name: p, delta: b, target: w, should: y, shadowParent: eG(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== _;
      });
    }, 1);
  }, []), u = h.useCallback(function(p) {
    n.current = Ar(p), o.current = void 0;
  }, []), d = h.useCallback(function(p) {
    c(p.type, Cm(p), p.target, s(p, e.lockRef.current));
  }, []), m = h.useCallback(function(p) {
    c(p.type, Ar(p), p.target, s(p, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return So.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, $o), document.addEventListener("touchmove", l, $o), document.addEventListener("touchstart", u, $o), function() {
      So = So.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, $o), document.removeEventListener("touchmove", l, $o), document.removeEventListener("touchstart", u, $o);
    };
  }, []);
  var f = e.removeScrollBar, g = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    g ? h.createElement(r, { styles: Y8(a) }) : null,
    f ? h.createElement(B8, { gapMode: e.gapMode }) : null
  );
}
function eG(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const tG = O8(G_, Q8);
var ad = h.forwardRef(function(e, t) {
  return h.createElement(ws, qt({}, e, { ref: t, sideCar: tG }));
});
ad.classNames = ws.classNames;
var nG = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Co = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), zr = {}, El = 0, Q_ = function(e) {
  return e && (e.host || Q_(e.parentNode));
}, oG = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Q_(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, aG = function(e, t, n, o) {
  var a = oG(t, Array.isArray(e) ? e : [e]);
  zr[n] || (zr[n] = /* @__PURE__ */ new WeakMap());
  var r = zr[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(a), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  a.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var f = m.getAttribute(o), g = f !== null && f !== "false", p = (Co.get(m) || 0) + 1, b = (r.get(m) || 0) + 1;
          Co.set(m, p), r.set(m, b), i.push(m), p === 1 && g && Or.set(m, !0), b === 1 && m.setAttribute(n, "true"), g || m.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return u(t), s.clear(), El++, function() {
    i.forEach(function(d) {
      var m = Co.get(d) - 1, f = r.get(d) - 1;
      Co.set(d, m), r.set(d, f), m || (Or.has(d) || d.removeAttribute(o), Or.delete(d)), f || d.removeAttribute(n);
    }), El--, El || (Co = /* @__PURE__ */ new WeakMap(), Co = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), zr = {});
  };
}, ew = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), a = nG(e);
  return a ? (o.push.apply(o, Array.from(a.querySelectorAll("[aria-live]"))), aG(o, a, n, "aria-hidden")) : function() {
    return null;
  };
}, tw = "Dialog", [nw, u_e] = Qa(tw), [d_e, Qt] = nw(tw), ow = "DialogTrigger", rG = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Qt(ow, n), r = Re(t, a.triggerRef);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": id(a.open),
        ...o,
        ref: r,
        onClick: ve(e.onClick, a.onOpenToggle)
      }
    );
  }
);
rG.displayName = ow;
var iG = "DialogPortal", [h_e, aw] = nw(iG, {
  forceMount: void 0
}), Oi = "DialogOverlay", sG = h.forwardRef(
  (e, t) => {
    const n = aw(Oi, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Qt(Oi, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(po, { present: o || r.open, children: /* @__PURE__ */ v(cG, { ...a, ref: t }) }) : null;
  }
);
sG.displayName = Oi;
var lG = /* @__PURE__ */ za("DialogOverlay.RemoveScroll"), cG = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Qt(Oi, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(ad, { as: lG, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-state": id(a.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), to = "DialogContent", uG = h.forwardRef(
  (e, t) => {
    const n = aw(to, e.__scopeDialog), { forceMount: o = n.forceMount, ...a } = e, r = Qt(to, e.__scopeDialog);
    return /* @__PURE__ */ v(po, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(dG, { ...a, ref: t }) : /* @__PURE__ */ v(hG, { ...a, ref: t }) });
  }
);
uG.displayName = to;
var dG = h.forwardRef(
  (e, t) => {
    const n = Qt(to, e.__scopeDialog), o = h.useRef(null), a = Re(t, n.contentRef, o);
    return h.useEffect(() => {
      const r = o.current;
      if (r) return ew(r);
    }, []), /* @__PURE__ */ v(
      rw,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ve(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: ve(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: ve(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), hG = h.forwardRef(
  (e, t) => {
    const n = Qt(to, e.__scopeDialog), o = h.useRef(!1), a = h.useRef(!1);
    return /* @__PURE__ */ v(
      rw,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || n.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, a.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = r.target;
          n.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && a.current && r.preventDefault();
        }
      }
    );
  }
), rw = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: r, ...i } = e, s = Qt(to, n), l = h.useRef(null), c = Re(t, l);
    return H_(), /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        od,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: a,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            nd,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": id(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ P(je, { children: [
        /* @__PURE__ */ v(gG, { titleId: s.titleId }),
        /* @__PURE__ */ v(vG, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), rd = "DialogTitle", pG = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Qt(rd, n);
    return /* @__PURE__ */ v(ye.h2, { id: a.titleId, ...o, ref: t });
  }
);
pG.displayName = rd;
var iw = "DialogDescription", mG = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Qt(iw, n);
    return /* @__PURE__ */ v(ye.p, { id: a.descriptionId, ...o, ref: t });
  }
);
mG.displayName = iw;
var sw = "DialogClose", fG = h.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, a = Qt(sw, n);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: ve(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
fG.displayName = sw;
function id(e) {
  return e ? "open" : "closed";
}
var lw = "DialogTitleWarning", [p_e, cw] = H9(lw, {
  contentName: to,
  titleName: rd,
  docsSlug: "dialog"
}), gG = ({ titleId: e }) => {
  const t = cw(lw), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return h.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, bG = "DialogDescriptionWarning", vG = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${cw(bG).contentName}}.`;
  return h.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
};
function Sc(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function yG(e, t) {
  return h.useReducer((n, o) => t[n][o] ?? n, e);
}
var sd = "ScrollArea", [uw, m_e] = Qa(sd), [_G, zt] = uw(sd), wG = h.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: a,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = h.useState(null), [c, u] = h.useState(null), [d, m] = h.useState(null), [f, g] = h.useState(null), [p, b] = h.useState(null), [w, y] = h.useState(0), [_, k] = h.useState(0), [x, S] = h.useState(!1), [$, E] = h.useState(!1), C = Re(t, (I) => l(I)), A = nK(a);
    return /* @__PURE__ */ v(
      _G,
      {
        scope: n,
        type: o,
        dir: A,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: m,
        scrollbarX: f,
        onScrollbarXChange: g,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: y,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          ye.div,
          {
            dir: A,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
wG.displayName = sd;
var dw = "ScrollAreaViewport", kG = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: a, ...r } = e, i = zt(dw, n), s = h.useRef(null), l = Re(t, s, i.onViewportChange);
    return /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
kG.displayName = dw;
var en = "ScrollAreaScrollbar", xG = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = zt(en, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = a, s = e.orientation === "horizontal";
    return h.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), a.type === "hover" ? /* @__PURE__ */ v($G, { ...o, ref: t, forceMount: n }) : a.type === "scroll" ? /* @__PURE__ */ v(SG, { ...o, ref: t, forceMount: n }) : a.type === "auto" ? /* @__PURE__ */ v(hw, { ...o, ref: t, forceMount: n }) : a.type === "always" ? /* @__PURE__ */ v(ld, { ...o, ref: t }) : null;
  }
);
xG.displayName = en;
var $G = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = zt(en, e.__scopeScrollArea), [r, i] = h.useState(!1);
  return h.useEffect(() => {
    const s = a.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), a.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ v(po, { present: n || r, children: /* @__PURE__ */ v(
    hw,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), SG = h.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = zt(en, e.__scopeScrollArea), r = e.orientation === "horizontal", i = xs(() => l("SCROLL_END"), 100), [s, l] = yG("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return h.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, a.scrollHideDelay, l]), h.useEffect(() => {
    const c = a.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const m = () => {
        const f = c[u];
        d !== f && (l("SCROLL"), i()), d = f;
      };
      return c.addEventListener("scroll", m), () => c.removeEventListener("scroll", m);
    }
  }, [a.viewport, r, l, i]), /* @__PURE__ */ v(po, { present: n || s !== "hidden", children: /* @__PURE__ */ v(
    ld,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: ve(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ve(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), hw = h.forwardRef((e, t) => {
  const n = zt(en, e.__scopeScrollArea), { forceMount: o, ...a } = e, [r, i] = h.useState(!1), s = e.orientation === "horizontal", l = xs(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Ko(n.viewport, l), Ko(n.content, l), /* @__PURE__ */ v(po, { present: o || r, children: /* @__PURE__ */ v(
    ld,
    {
      "data-state": r ? "visible" : "hidden",
      ...a,
      ref: t
    }
  ) });
}), ld = h.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, a = zt(en, e.__scopeScrollArea), r = h.useRef(null), i = h.useRef(0), [s, l] = h.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = fw(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (m) => r.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function d(m, f) {
    return RG(m, i.current, s, f);
  }
  return n === "horizontal" ? /* @__PURE__ */ v(
    CG,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollLeft, f = Am(m, s, a.dir);
          r.current.style.transform = `translate3d(${f}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollLeft = d(m, a.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ v(
    EG,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && r.current) {
          const m = a.viewport.scrollTop, f = Am(m, s);
          r.current.style.transform = `translate3d(0, ${f}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        a.viewport && (a.viewport.scrollTop = d(m));
      }
    }
  ) : null;
}), CG = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = zt(en, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = Re(t, l, r.onScrollbarXChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    mw,
    {
      "data-orientation": "horizontal",
      ...a,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ks(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(m), bw(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Ni(i.paddingLeft),
            paddingEnd: Ni(i.paddingRight)
          }
        });
      }
    }
  );
}), EG = h.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...a } = e, r = zt(en, e.__scopeScrollArea), [i, s] = h.useState(), l = h.useRef(null), c = Re(t, l, r.onScrollbarYChange);
  return h.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    mw,
    {
      "data-orientation": "vertical",
      ...a,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ks(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const m = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(m), bw(m, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Ni(i.paddingTop),
            paddingEnd: Ni(i.paddingBottom)
          }
        });
      }
    }
  );
}), [AG, pw] = uw(en), mw = h.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: a,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...m
  } = e, f = zt(en, n), [g, p] = h.useState(null), b = Re(t, (C) => p(C)), w = h.useRef(null), y = h.useRef(""), _ = f.viewport, k = o.content - o.viewport, x = lt(u), S = lt(l), $ = xs(d, 10);
  function E(C) {
    if (w.current) {
      const A = C.clientX - w.current.left, I = C.clientY - w.current.top;
      c({ x: A, y: I });
    }
  }
  return h.useEffect(() => {
    const C = (A) => {
      const I = A.target;
      g?.contains(I) && x(A, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [_, g, k, x]), h.useEffect(S, [o, S]), Ko(g, $), Ko(f.content, $), /* @__PURE__ */ v(
    AG,
    {
      scope: n,
      scrollbar: g,
      hasThumb: a,
      onThumbChange: lt(r),
      onThumbPointerUp: lt(i),
      onThumbPositionChange: S,
      onThumbPointerDown: lt(s),
      children: /* @__PURE__ */ v(
        ye.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: ve(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = g.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", f.viewport && (f.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: ve(e.onPointerMove, E),
          onPointerUp: ve(e.onPointerUp, (C) => {
            const A = C.target;
            A.hasPointerCapture(C.pointerId) && A.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = y.current, f.viewport && (f.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), zi = "ScrollAreaThumb", OG = h.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, a = pw(zi, e.__scopeScrollArea);
    return /* @__PURE__ */ v(po, { present: n || a.hasThumb, children: /* @__PURE__ */ v(zG, { ref: t, ...o }) });
  }
), zG = h.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...a } = e, r = zt(zi, n), i = pw(zi, n), { onThumbPositionChange: s } = i, l = Re(
      t,
      (d) => i.onThumbChange(d)
    ), c = h.useRef(void 0), u = xs(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return h.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const m = () => {
          if (u(), !c.current) {
            const f = IG(d, s);
            c.current = f, s();
          }
        };
        return s(), d.addEventListener("scroll", m), () => d.removeEventListener("scroll", m);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      ye.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...a,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: ve(e.onPointerDownCapture, (d) => {
          const m = d.target.getBoundingClientRect(), f = d.clientX - m.left, g = d.clientY - m.top;
          i.onThumbPointerDown({ x: f, y: g });
        }),
        onPointerUp: ve(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
OG.displayName = zi;
var cd = "ScrollAreaCorner", NG = h.forwardRef(
  (e, t) => {
    const n = zt(cd, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ v(jG, { ...e, ref: t }) : null;
  }
);
NG.displayName = cd;
var jG = h.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, a = zt(cd, n), [r, i] = h.useState(0), [s, l] = h.useState(0), c = !!(r && s);
  return Ko(a.scrollbarX, () => {
    const u = a.scrollbarX?.offsetHeight || 0;
    a.onCornerHeightChange(u), l(u);
  }), Ko(a.scrollbarY, () => {
    const u = a.scrollbarY?.offsetWidth || 0;
    a.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    ye.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ni(e) {
  return e ? parseInt(e, 10) : 0;
}
function fw(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function ks(e) {
  const t = fw(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function RG(e, t, n, o = "ltr") {
  const a = ks(n), r = a / 2, i = t || r, s = a - i, l = n.scrollbar.paddingStart + i, c = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return gw([l, c], d)(e);
}
function Am(e, t, n = "ltr") {
  const o = ks(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - a, i = t.content - t.viewport, s = r - o, l = n === "ltr" ? [0, i] : [i * -1, 0], c = Sc(e, l);
  return gw([0, i], [0, s])(c);
}
function gw(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function bw(e, t) {
  return e > 0 && e < t;
}
var IG = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function a() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== r.left, s = n.top !== r.top;
    (i || s) && t(), n = r, o = window.requestAnimationFrame(a);
  }(), () => window.cancelAnimationFrame(o);
};
function xs(e, t) {
  const n = lt(e), o = h.useRef(0);
  return h.useEffect(() => () => window.clearTimeout(o.current), []), h.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Ko(e, t) {
  const n = lt(t);
  nt(() => {
    let o = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(o), a.unobserve(e);
      };
    }
  }, [e, n]);
}
const TG = ["top", "right", "bottom", "left"], An = Math.min, yt = Math.max, ji = Math.round, Nr = Math.floor, Gt = (e) => ({
  x: e,
  y: e
}), PG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, DG = {
  start: "end",
  end: "start"
};
function Cc(e, t, n) {
  return yt(e, An(t, n));
}
function hn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pn(e) {
  return e.split("-")[0];
}
function ta(e) {
  return e.split("-")[1];
}
function ud(e) {
  return e === "x" ? "y" : "x";
}
function dd(e) {
  return e === "y" ? "height" : "width";
}
function un(e) {
  return ["top", "bottom"].includes(pn(e)) ? "y" : "x";
}
function hd(e) {
  return ud(un(e));
}
function LG(e, t, n) {
  n === void 0 && (n = !1);
  const o = ta(e), a = hd(e), r = dd(a);
  let i = a === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (i = Ri(i)), [i, Ri(i)];
}
function MG(e) {
  const t = Ri(e);
  return [Ec(e), t, Ec(t)];
}
function Ec(e) {
  return e.replace(/start|end/g, (t) => DG[t]);
}
function FG(e, t, n) {
  const o = ["left", "right"], a = ["right", "left"], r = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : o : t ? o : a;
    case "left":
    case "right":
      return t ? r : i;
    default:
      return [];
  }
}
function WG(e, t, n, o) {
  const a = ta(e);
  let r = FG(pn(e), n === "start", o);
  return a && (r = r.map((i) => i + "-" + a), t && (r = r.concat(r.map(Ec)))), r;
}
function Ri(e) {
  return e.replace(/left|right|bottom|top/g, (t) => PG[t]);
}
function BG(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function vw(e) {
  return typeof e != "number" ? BG(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ii(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: a
  } = e;
  return {
    width: o,
    height: a,
    top: n,
    left: t,
    right: t + o,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Om(e, t, n) {
  let {
    reference: o,
    floating: a
  } = e;
  const r = un(t), i = hd(t), s = dd(i), l = pn(t), c = r === "y", u = o.x + o.width / 2 - a.width / 2, d = o.y + o.height / 2 - a.height / 2, m = o[s] / 2 - a[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: o.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: o.x - a.width,
        y: d
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (ta(t)) {
    case "start":
      f[i] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      f[i] += m * (n && c ? -1 : 1);
      break;
  }
  return f;
}
const VG = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: a = "absolute",
    middleware: r = [],
    platform: i
  } = n, s = r.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: d
  } = Om(c, o, l), m = o, f = {}, g = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: b,
      fn: w
    } = s[p], {
      x: y,
      y: _,
      data: k,
      reset: x
    } = await w({
      x: u,
      y: d,
      initialPlacement: o,
      placement: m,
      strategy: a,
      middlewareData: f,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y ?? u, d = _ ?? d, f = {
      ...f,
      [b]: {
        ...f[b],
        ...k
      }
    }, x && g <= 50 && (g++, typeof x == "object" && (x.placement && (m = x.placement), x.rects && (c = x.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : x.rects), {
      x: u,
      y: d
    } = Om(c, m, l)), p = -1);
  }
  return {
    x: u,
    y: d,
    placement: m,
    strategy: a,
    middlewareData: f
  };
};
async function Na(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: a,
    platform: r,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: m = !1,
    padding: f = 0
  } = hn(t, e), g = vw(f), p = s[m ? d === "floating" ? "reference" : "floating" : d], b = Ii(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(p))) == null || n ? p : p.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: o,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), _ = await (r.isElement == null ? void 0 : r.isElement(y)) ? await (r.getScale == null ? void 0 : r.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = Ii(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: y,
    strategy: l
  }) : w);
  return {
    top: (b.top - k.top + g.top) / _.y,
    bottom: (k.bottom - b.bottom + g.bottom) / _.y,
    left: (b.left - k.left + g.left) / _.x,
    right: (k.right - b.right + g.right) / _.x
  };
}
const UG = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: a,
      rects: r,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = hn(e, t) || {};
    if (c == null)
      return {};
    const d = vw(u), m = {
      x: n,
      y: o
    }, f = hd(a), g = dd(f), p = await i.getDimensions(c), b = f === "y", w = b ? "top" : "left", y = b ? "bottom" : "right", _ = b ? "clientHeight" : "clientWidth", k = r.reference[g] + r.reference[f] - m[f] - r.floating[g], x = m[f] - r.reference[f], S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let $ = S ? S[_] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(S))) && ($ = s.floating[_] || r.floating[g]);
    const E = k / 2 - x / 2, C = $ / 2 - p[g] / 2 - 1, A = An(d[w], C), I = An(d[y], C), U = A, M = $ - p[g] - I, z = $ / 2 - p[g] / 2 + E, L = Cc(U, z, M), q = !l.arrow && ta(a) != null && z !== L && r.reference[g] / 2 - (z < U ? A : I) - p[g] / 2 < 0, K = q ? z < U ? z - U : z - M : 0;
    return {
      [f]: m[f] + K,
      data: {
        [f]: L,
        centerOffset: z - L - K,
        ...q && {
          alignmentOffset: K
        }
      },
      reset: q
    };
  }
}), qG = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: a,
        middlewareData: r,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: m,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: p = !0,
        ...b
      } = hn(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const w = pn(a), y = un(s), _ = pn(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = m || (_ || !p ? [Ri(s)] : MG(s)), S = g !== "none";
      !m && S && x.push(...WG(s, p, g, k));
      const $ = [s, ...x], E = await Na(t, b), C = [];
      let A = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && C.push(E[w]), d) {
        const L = LG(a, i, k);
        C.push(E[L[0]], E[L[1]]);
      }
      if (A = [...A, {
        placement: a,
        overflows: C
      }], !C.every((L) => L <= 0)) {
        var I, U;
        const L = (((I = r.flip) == null ? void 0 : I.index) || 0) + 1, q = $[L];
        if (q) {
          var M;
          const Z = d === "alignment" ? y !== un(q) : !1, te = ((M = A[0]) == null ? void 0 : M.overflows[0]) > 0;
          if (!Z || te)
            return {
              data: {
                index: L,
                overflows: A
              },
              reset: {
                placement: q
              }
            };
        }
        let K = (U = A.filter((Z) => Z.overflows[0] <= 0).sort((Z, te) => Z.overflows[1] - te.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!K)
          switch (f) {
            case "bestFit": {
              var z;
              const Z = (z = A.filter((te) => {
                if (S) {
                  const O = un(te.placement);
                  return O === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  O === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((O) => O > 0).reduce((O, N) => O + N, 0)]).sort((te, O) => te[1] - O[1])[0]) == null ? void 0 : z[0];
              Z && (K = Z);
              break;
            }
            case "initialPlacement":
              K = s;
              break;
          }
        if (a !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
};
function zm(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Nm(e) {
  return TG.some((t) => e[t] >= 0);
}
const HG = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...a
      } = hn(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await Na(t, {
            ...a,
            elementContext: "reference"
          }), i = zm(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Nm(i)
            }
          };
        }
        case "escaped": {
          const r = await Na(t, {
            ...a,
            altBoundary: !0
          }), i = zm(r, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Nm(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function KG(e, t) {
  const {
    placement: n,
    platform: o,
    elements: a
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(a.floating)), i = pn(n), s = ta(n), l = un(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = r && l ? -1 : 1, d = hn(t, e);
  let {
    mainAxis: m,
    crossAxis: f,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof g == "number" && (f = s === "end" ? g * -1 : g), l ? {
    x: f * u,
    y: m * c
  } : {
    x: m * c,
    y: f * u
  };
}
const GG = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: a,
        y: r,
        placement: i,
        middlewareData: s
      } = t, l = await KG(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: a + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, ZG = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: a
      } = t, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y
            } = b;
            return {
              x: w,
              y
            };
          }
        },
        ...l
      } = hn(e, t), c = {
        x: n,
        y: o
      }, u = await Na(t, l), d = un(pn(a)), m = ud(d);
      let f = c[m], g = c[d];
      if (r) {
        const b = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", y = f + u[b], _ = f - u[w];
        f = Cc(y, f, _);
      }
      if (i) {
        const b = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", y = g + u[b], _ = g - u[w];
        g = Cc(y, g, _);
      }
      const p = s.fn({
        ...t,
        [m]: f,
        [d]: g
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - o,
          enabled: {
            [m]: r,
            [d]: i
          }
        }
      };
    }
  };
}, JG = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: a,
        rects: r,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = hn(e, t), u = {
        x: n,
        y: o
      }, d = un(a), m = ud(d);
      let f = u[m], g = u[d];
      const p = hn(s, t), b = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const _ = m === "y" ? "height" : "width", k = r.reference[m] - r.floating[_] + b.mainAxis, x = r.reference[m] + r.reference[_] - b.mainAxis;
        f < k ? f = k : f > x && (f = x);
      }
      if (c) {
        var w, y;
        const _ = m === "y" ? "width" : "height", k = ["top", "left"].includes(pn(a)), x = r.reference[d] - r.floating[_] + (k && ((w = i.offset) == null ? void 0 : w[d]) || 0) + (k ? 0 : b.crossAxis), S = r.reference[d] + r.reference[_] + (k ? 0 : ((y = i.offset) == null ? void 0 : y[d]) || 0) - (k ? b.crossAxis : 0);
        g < x ? g = x : g > S && (g = S);
      }
      return {
        [m]: f,
        [d]: g
      };
    }
  };
}, YG = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: a,
        rects: r,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = hn(e, t), u = await Na(t, c), d = pn(a), m = ta(a), f = un(a) === "y", {
        width: g,
        height: p
      } = r.floating;
      let b, w;
      d === "top" || d === "bottom" ? (b = d, w = m === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = d, b = m === "end" ? "top" : "bottom");
      const y = p - u.top - u.bottom, _ = g - u.left - u.right, k = An(p - u[b], y), x = An(g - u[w], _), S = !t.middlewareData.shift;
      let $ = k, E = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (E = _), (o = t.middlewareData.shift) != null && o.enabled.y && ($ = y), S && !m) {
        const A = yt(u.left, 0), I = yt(u.right, 0), U = yt(u.top, 0), M = yt(u.bottom, 0);
        f ? E = g - 2 * (A !== 0 || I !== 0 ? A + I : yt(u.left, u.right)) : $ = p - 2 * (U !== 0 || M !== 0 ? U + M : yt(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: $
      });
      const C = await i.getDimensions(s.floating);
      return g !== C.width || p !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function $s() {
  return typeof window < "u";
}
function na(e) {
  return yw(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function _t(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tn(e) {
  var t;
  return (t = (yw(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function yw(e) {
  return $s() ? e instanceof Node || e instanceof _t(e).Node : !1;
}
function It(e) {
  return $s() ? e instanceof Element || e instanceof _t(e).Element : !1;
}
function Zt(e) {
  return $s() ? e instanceof HTMLElement || e instanceof _t(e).HTMLElement : !1;
}
function jm(e) {
  return !$s() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof _t(e).ShadowRoot;
}
function er(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: a
  } = Tt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(a);
}
function XG(e) {
  return ["table", "td", "th"].includes(na(e));
}
function Ss(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function pd(e) {
  const t = md(), n = It(e) ? Tt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function QG(e) {
  let t = On(e);
  for (; Zt(t) && !Go(t); ) {
    if (pd(t))
      return t;
    if (Ss(t))
      return null;
    t = On(t);
  }
  return null;
}
function md() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Go(e) {
  return ["html", "body", "#document"].includes(na(e));
}
function Tt(e) {
  return _t(e).getComputedStyle(e);
}
function Cs(e) {
  return It(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function On(e) {
  if (na(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    jm(e) && e.host || // Fallback.
    tn(e)
  );
  return jm(t) ? t.host : t;
}
function _w(e) {
  const t = On(e);
  return Go(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Zt(t) && er(t) ? t : _w(t);
}
function ja(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = _w(e), r = a === ((o = e.ownerDocument) == null ? void 0 : o.body), i = _t(a);
  if (r) {
    const s = Ac(i);
    return t.concat(i, i.visualViewport || [], er(a) ? a : [], s && n ? ja(s) : []);
  }
  return t.concat(a, ja(a, [], n));
}
function Ac(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ww(e) {
  const t = Tt(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const a = Zt(e), r = a ? e.offsetWidth : n, i = a ? e.offsetHeight : o, s = ji(n) !== r || ji(o) !== i;
  return s && (n = r, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function fd(e) {
  return It(e) ? e : e.contextElement;
}
function To(e) {
  const t = fd(e);
  if (!Zt(t))
    return Gt(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: a,
    $: r
  } = ww(t);
  let i = (r ? ji(n.width) : n.width) / o, s = (r ? ji(n.height) : n.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const e7 = /* @__PURE__ */ Gt(0);
function kw(e) {
  const t = _t(e);
  return !md() || !t.visualViewport ? e7 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function t7(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== _t(e) ? !1 : t;
}
function no(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), r = fd(e);
  let i = Gt(1);
  t && (o ? It(o) && (i = To(o)) : i = To(e));
  const s = t7(r, n, o) ? kw(r) : Gt(0);
  let l = (a.left + s.x) / i.x, c = (a.top + s.y) / i.y, u = a.width / i.x, d = a.height / i.y;
  if (r) {
    const m = _t(r), f = o && It(o) ? _t(o) : o;
    let g = m, p = Ac(g);
    for (; p && o && f !== g; ) {
      const b = To(p), w = p.getBoundingClientRect(), y = Tt(p), _ = w.left + (p.clientLeft + parseFloat(y.paddingLeft)) * b.x, k = w.top + (p.clientTop + parseFloat(y.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, d *= b.y, l += _, c += k, g = _t(p), p = Ac(g);
    }
  }
  return Ii({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function gd(e, t) {
  const n = Cs(e).scrollLeft;
  return t ? t.left + n : no(tn(e)).left + n;
}
function xw(e, t, n) {
  n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = o.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    gd(e, o)
  )), r = o.top + t.scrollTop;
  return {
    x: a,
    y: r
  };
}
function n7(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: a
  } = e;
  const r = a === "fixed", i = tn(o), s = t ? Ss(t.floating) : !1;
  if (o === i || s && r)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Gt(1);
  const u = Gt(0), d = Zt(o);
  if ((d || !d && !r) && ((na(o) !== "body" || er(i)) && (l = Cs(o)), Zt(o))) {
    const f = no(o);
    c = To(o), u.x = f.x + o.clientLeft, u.y = f.y + o.clientTop;
  }
  const m = i && !d && !r ? xw(i, l, !0) : Gt(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + m.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + m.y
  };
}
function o7(e) {
  return Array.from(e.getClientRects());
}
function a7(e) {
  const t = tn(e), n = Cs(e), o = e.ownerDocument.body, a = yt(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = yt(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + gd(e);
  const s = -n.scrollTop;
  return Tt(o).direction === "rtl" && (i += yt(t.clientWidth, o.clientWidth) - a), {
    width: a,
    height: r,
    x: i,
    y: s
  };
}
function r7(e, t) {
  const n = _t(e), o = tn(e), a = n.visualViewport;
  let r = o.clientWidth, i = o.clientHeight, s = 0, l = 0;
  if (a) {
    r = a.width, i = a.height;
    const c = md();
    (!c || c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
function i7(e, t) {
  const n = no(e, !0, t === "fixed"), o = n.top + e.clientTop, a = n.left + e.clientLeft, r = Zt(e) ? To(e) : Gt(1), i = e.clientWidth * r.x, s = e.clientHeight * r.y, l = a * r.x, c = o * r.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function Rm(e, t, n) {
  let o;
  if (t === "viewport")
    o = r7(e, n);
  else if (t === "document")
    o = a7(tn(e));
  else if (It(t))
    o = i7(t, n);
  else {
    const a = kw(e);
    o = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Ii(o);
}
function $w(e, t) {
  const n = On(e);
  return n === t || !It(n) || Go(n) ? !1 : Tt(n).position === "fixed" || $w(n, t);
}
function s7(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = ja(e, [], !1).filter((s) => It(s) && na(s) !== "body"), a = null;
  const r = Tt(e).position === "fixed";
  let i = r ? On(e) : e;
  for (; It(i) && !Go(i); ) {
    const s = Tt(i), l = pd(i);
    !l && s.position === "fixed" && (a = null), (r ? !l && !a : !l && s.position === "static" && a && ["absolute", "fixed"].includes(a.position) || er(i) && !l && $w(e, i)) ? o = o.filter((c) => c !== i) : a = s, i = On(i);
  }
  return t.set(e, o), o;
}
function l7(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: a
  } = e;
  const r = [...n === "clippingAncestors" ? Ss(t) ? [] : s7(t, this._c) : [].concat(n), o], i = r[0], s = r.reduce((l, c) => {
    const u = Rm(t, c, a);
    return l.top = yt(u.top, l.top), l.right = An(u.right, l.right), l.bottom = An(u.bottom, l.bottom), l.left = yt(u.left, l.left), l;
  }, Rm(t, i, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function c7(e) {
  const {
    width: t,
    height: n
  } = ww(e);
  return {
    width: t,
    height: n
  };
}
function u7(e, t, n) {
  const o = Zt(t), a = tn(t), r = n === "fixed", i = no(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Gt(0);
  function c() {
    l.x = gd(a);
  }
  if (o || !o && !r)
    if ((na(t) !== "body" || er(a)) && (s = Cs(t)), o) {
      const f = no(t, !0, r, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else a && c();
  r && !o && a && c();
  const u = a && !o && !r ? xw(a, s) : Gt(0), d = i.left + s.scrollLeft - l.x - u.x, m = i.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: m,
    width: i.width,
    height: i.height
  };
}
function Al(e) {
  return Tt(e).position === "static";
}
function Im(e, t) {
  if (!Zt(e) || Tt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return tn(e) === n && (n = n.ownerDocument.body), n;
}
function Sw(e, t) {
  const n = _t(e);
  if (Ss(e))
    return n;
  if (!Zt(e)) {
    let a = On(e);
    for (; a && !Go(a); ) {
      if (It(a) && !Al(a))
        return a;
      a = On(a);
    }
    return n;
  }
  let o = Im(e, t);
  for (; o && XG(o) && Al(o); )
    o = Im(o, t);
  return o && Go(o) && Al(o) && !pd(o) ? n : o || QG(e) || n;
}
const d7 = async function(e) {
  const t = this.getOffsetParent || Sw, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: u7(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function h7(e) {
  return Tt(e).direction === "rtl";
}
const p7 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: n7,
  getDocumentElement: tn,
  getClippingRect: l7,
  getOffsetParent: Sw,
  getElementRects: d7,
  getClientRects: o7,
  getDimensions: c7,
  getScale: To,
  isElement: It,
  isRTL: h7
};
function Cw(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function m7(e, t) {
  let n = null, o;
  const a = tn(e);
  function r() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), r();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: m,
      height: f
    } = c;
    if (s || t(), !m || !f)
      return;
    const g = Nr(d), p = Nr(a.clientWidth - (u + m)), b = Nr(a.clientHeight - (d + f)), w = Nr(u), y = {
      rootMargin: -g + "px " + -p + "px " + -b + "px " + -w + "px",
      threshold: yt(0, An(1, l)) || 1
    };
    let _ = !0;
    function k(x) {
      const S = x[0].intersectionRatio;
      if (S !== l) {
        if (!_)
          return i();
        S ? i(!1, S) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !Cw(c, e.getBoundingClientRect()) && i(), _ = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, y);
    }
    n.observe(e);
  }
  return i(!0), r;
}
function f7(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: r = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = fd(e), u = a || r ? [...c ? ja(c) : [], ...ja(t)] : [];
  u.forEach((w) => {
    a && w.addEventListener("scroll", n, {
      passive: !0
    }), r && w.addEventListener("resize", n);
  });
  const d = c && s ? m7(c, n) : null;
  let m = -1, f = null;
  i && (f = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === c && f && (f.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var _;
      (_ = f) == null || _.observe(t);
    })), n();
  }), c && !l && f.observe(c), f.observe(t));
  let g, p = l ? no(e) : null;
  l && b();
  function b() {
    const w = no(e);
    p && !Cw(p, w) && n(), p = w, g = requestAnimationFrame(b);
  }
  return n(), () => {
    var w;
    u.forEach((y) => {
      a && y.removeEventListener("scroll", n), r && y.removeEventListener("resize", n);
    }), d?.(), (w = f) == null || w.disconnect(), f = null, l && cancelAnimationFrame(g);
  };
}
const g7 = GG, b7 = ZG, v7 = qG, y7 = YG, _7 = HG, Tm = UG, w7 = JG, k7 = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), a = {
    platform: p7,
    ...n
  }, r = {
    ...a.platform,
    _c: o
  };
  return VG(e, t, {
    ...a,
    platform: r
  });
};
var oi = typeof document < "u" ? bf : Se;
function Ti(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ti(e[o], t[o]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const r = a[o];
      if (!(r === "_owner" && e.$$typeof) && !Ti(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ew(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Pm(e, t) {
  const n = Ew(e);
  return Math.round(t * n) / n;
}
function Ol(e) {
  const t = h.useRef(e);
  return oi(() => {
    t.current = e;
  }), t;
}
function x7(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: a,
    elements: {
      reference: r,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = h.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, f] = h.useState(o);
  Ti(m, o) || f(o);
  const [g, p] = h.useState(null), [b, w] = h.useState(null), y = h.useCallback((Z) => {
    Z !== S.current && (S.current = Z, p(Z));
  }, []), _ = h.useCallback((Z) => {
    Z !== $.current && ($.current = Z, w(Z));
  }, []), k = r || g, x = i || b, S = h.useRef(null), $ = h.useRef(null), E = h.useRef(u), C = l != null, A = Ol(l), I = Ol(a), U = Ol(c), M = h.useCallback(() => {
    if (!S.current || !$.current)
      return;
    const Z = {
      placement: t,
      strategy: n,
      middleware: m
    };
    I.current && (Z.platform = I.current), k7(S.current, $.current, Z).then((te) => {
      const O = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: U.current !== !1
      };
      z.current && !Ti(E.current, O) && (E.current = O, so.flushSync(() => {
        d(O);
      }));
    });
  }, [m, t, n, I, U]);
  oi(() => {
    c === !1 && E.current.isPositioned && (E.current.isPositioned = !1, d((Z) => ({
      ...Z,
      isPositioned: !1
    })));
  }, [c]);
  const z = h.useRef(!1);
  oi(() => (z.current = !0, () => {
    z.current = !1;
  }), []), oi(() => {
    if (k && (S.current = k), x && ($.current = x), k && x) {
      if (A.current)
        return A.current(k, x, M);
      M();
    }
  }, [k, x, M, A, C]);
  const L = h.useMemo(() => ({
    reference: S,
    floating: $,
    setReference: y,
    setFloating: _
  }), [y, _]), q = h.useMemo(() => ({
    reference: k,
    floating: x
  }), [k, x]), K = h.useMemo(() => {
    const Z = {
      position: n,
      left: 0,
      top: 0
    };
    if (!q.floating)
      return Z;
    const te = Pm(q.floating, u.x), O = Pm(q.floating, u.y);
    return s ? {
      ...Z,
      transform: "translate(" + te + "px, " + O + "px)",
      ...Ew(q.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: te,
      top: O
    };
  }, [n, s, q.floating, u.x, u.y]);
  return h.useMemo(() => ({
    ...u,
    update: M,
    refs: L,
    elements: q,
    floatingStyles: K
  }), [u, M, L, q, K]);
}
const $7 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Tm({
        element: o.current,
        padding: a
      }).fn(n) : {} : o ? Tm({
        element: o,
        padding: a
      }).fn(n) : {};
    }
  };
}, S7 = (e, t) => ({
  ...g7(e),
  options: [e, t]
}), C7 = (e, t) => ({
  ...b7(e),
  options: [e, t]
}), E7 = (e, t) => ({
  ...w7(e),
  options: [e, t]
}), A7 = (e, t) => ({
  ...v7(e),
  options: [e, t]
}), O7 = (e, t) => ({
  ...y7(e),
  options: [e, t]
}), z7 = (e, t) => ({
  ..._7(e),
  options: [e, t]
}), N7 = (e, t) => ({
  ...$7(e),
  options: [e, t]
});
var j7 = "Arrow", Aw = h.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: a = 5, ...r } = e;
  return /* @__PURE__ */ v(
    ye.svg,
    {
      ...r,
      ref: t,
      width: o,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ v("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Aw.displayName = j7;
var R7 = Aw, Ow = "Popper", [zw, Nw] = Qa(Ow), [f_e, jw] = zw(Ow), Rw = "PopperAnchor", Iw = h.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...a } = e, r = jw(Rw, n), i = h.useRef(null), s = Re(t, i), l = h.useRef(null);
    return h.useEffect(() => {
      const c = l.current;
      l.current = o?.current || i.current, c !== l.current && r.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ v(ye.div, { ...a, ref: s });
  }
);
Iw.displayName = Rw;
var bd = "PopperContent", [I7, T7] = zw(bd), Tw = h.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: a = 0,
      align: r = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: f = "optimized",
      onPlaced: g,
      ...p
    } = e, b = jw(bd, n), [w, y] = h.useState(null), _ = Re(t, (D) => y(D)), [k, x] = h.useState(null), S = cK(k), $ = S?.width ?? 0, E = S?.height ?? 0, C = o + (r !== "center" ? "-" + r : ""), A = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, I = Array.isArray(c) ? c : [c], U = I.length > 0, M = {
      padding: A,
      boundary: I.filter(D7),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: U
    }, { refs: z, floatingStyles: L, placement: q, isPositioned: K, middlewareData: Z } = x7({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: C,
      whileElementsMounted: (...D) => f7(...D, {
        animationFrame: f === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        S7({ mainAxis: a + E, alignmentAxis: i }),
        l && C7({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? E7() : void 0,
          ...M
        }),
        l && A7({ ...M }),
        O7({
          ...M,
          apply: ({ elements: D, rects: Y, availableWidth: Q, availableHeight: G }) => {
            const { width: ne, height: V } = Y.reference, fe = D.floating.style;
            fe.setProperty("--radix-popper-available-width", `${Q}px`), fe.setProperty("--radix-popper-available-height", `${G}px`), fe.setProperty("--radix-popper-anchor-width", `${ne}px`), fe.setProperty("--radix-popper-anchor-height", `${V}px`);
          }
        }),
        k && N7({ element: k, padding: s }),
        L7({ arrowWidth: $, arrowHeight: E }),
        m && z7({ strategy: "referenceHidden", ...M })
      ]
    }), [te, O] = Lw(q), N = lt(g);
    nt(() => {
      K && N?.();
    }, [K, N]);
    const T = Z.arrow?.x, W = Z.arrow?.y, B = Z.arrow?.centerOffset !== 0, [J, ee] = h.useState();
    return nt(() => {
      w && ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ v(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: K ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: J,
          "--radix-popper-transform-origin": [
            Z.transformOrigin?.x,
            Z.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...Z.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ v(
          I7,
          {
            scope: n,
            placedSide: te,
            onArrowChange: x,
            arrowX: T,
            arrowY: W,
            shouldHideArrow: B,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                "data-side": te,
                "data-align": O,
                ...p,
                ref: _,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Tw.displayName = bd;
var Pw = "PopperArrow", P7 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Dw = h.forwardRef(function(e, t) {
  const { __scopePopper: n, ...o } = e, a = T7(Pw, n), r = P7[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [r]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v(
          R7,
          {
            ...o,
            ref: t,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Dw.displayName = Pw;
function D7(e) {
  return e !== null;
}
var L7 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: o, middlewareData: a } = t, r = a.arrow?.centerOffset !== 0, i = r ? 0 : e.arrowWidth, s = r ? 0 : e.arrowHeight, [l, c] = Lw(n), u = { start: "0%", center: "50%", end: "100%" }[c], d = (a.arrow?.x ?? 0) + i / 2, m = (a.arrow?.y ?? 0) + s / 2;
    let f = "", g = "";
    return l === "bottom" ? (f = r ? u : `${d}px`, g = `${-s}px`) : l === "top" ? (f = r ? u : `${d}px`, g = `${o.floating.height + s}px`) : l === "right" ? (f = `${-s}px`, g = r ? u : `${m}px`) : l === "left" && (f = `${o.floating.width + s}px`, g = r ? u : `${m}px`), { data: { x: f, y: g } };
  }
});
function Lw(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var M7 = Iw, F7 = Tw, W7 = Dw, Mw = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), B7 = "VisuallyHidden", V7 = h.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    ye.span,
    {
      ...e,
      ref: t,
      style: { ...Mw, ...e.style }
    }
  )
);
V7.displayName = B7;
var U7 = [" ", "Enter", "ArrowUp", "ArrowDown"], q7 = [" ", "Enter"], Es = "Select", [vd, As, H7] = oK(Es), [oa, g_e] = Qa(Es, [
  H7,
  Nw
]), yd = Nw(), [b_e, zn] = oa(Es), [v_e, K7] = oa(Es), Fw = "SelectTrigger", G7 = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...a } = e, r = yd(n), i = zn(Fw, n), s = i.disabled || o, l = Re(t, i.onTriggerChange), c = As(n), u = h.useRef("touch"), [d, m, f] = Yw((p) => {
      const b = c().filter((_) => !_.disabled), w = b.find((_) => _.value === i.value), y = Xw(b, p, w);
      y !== void 0 && i.onValueChange(y.value);
    }), g = (p) => {
      s || (i.onOpenChange(!0), f()), p && (i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ v(M7, { asChild: !0, ...r, children: /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Jw(i.value) ? "" : void 0,
        ...a,
        ref: l,
        onClick: ve(a.onClick, (p) => {
          p.currentTarget.focus(), u.current !== "mouse" && g(p);
        }),
        onPointerDown: ve(a.onPointerDown, (p) => {
          u.current = p.pointerType;
          const b = p.target;
          b.hasPointerCapture(p.pointerId) && b.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (g(p), p.preventDefault());
        }),
        onKeyDown: ve(a.onKeyDown, (p) => {
          const b = d.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && m(p.key), !(b && p.key === " ") && U7.includes(p.key) && (g(), p.preventDefault());
        })
      }
    ) });
  }
);
G7.displayName = Fw;
var Ww = "SelectValue", Z7 = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: a, children: r, placeholder: i = "", ...s } = e, l = zn(Ww, n), { onValueNodeHasChildrenChange: c } = l, u = r !== void 0, d = Re(t, l.onValueNodeChange);
    return nt(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ v(
      ye.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: Jw(l.value) ? /* @__PURE__ */ v(je, { children: i }) : r
      }
    );
  }
);
Z7.displayName = Ww;
var J7 = "SelectIcon", Y7 = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...a } = e;
    return /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...a, ref: t, children: o || "▼" });
  }
);
Y7.displayName = J7;
var oo = "SelectContent", X7 = h.forwardRef(
  (e, t) => {
    const n = zn(oo, e.__scopeSelect), [o, a] = h.useState();
    if (nt(() => {
      a(new DocumentFragment());
    }, []), !n.open) {
      const r = o;
      return r ? so.createPortal(
        /* @__PURE__ */ v(Bw, { scope: e.__scopeSelect, children: /* @__PURE__ */ v(vd.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ v("div", { children: e.children }) }) }),
        r
      ) : null;
    }
    return /* @__PURE__ */ v(Vw, { ...e, ref: t });
  }
);
X7.displayName = oo;
var jt = 10, [Bw, Nn] = oa(oo), Q7 = "SelectContentImpl", eZ = /* @__PURE__ */ za("SelectContent.RemoveScroll"), Vw = h.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: m,
      collisionPadding: f,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: b,
      //
      ...w
    } = e, y = zn(oo, n), [_, k] = h.useState(null), [x, S] = h.useState(null), $ = Re(t, (D) => k(D)), [E, C] = h.useState(null), [A, I] = h.useState(
      null
    ), U = As(n), [M, z] = h.useState(!1), L = h.useRef(!1);
    h.useEffect(() => {
      if (_) return ew(_);
    }, [_]), H_();
    const q = h.useCallback(
      (D) => {
        const [Y, ...Q] = U().map((V) => V.ref.current), [G] = Q.slice(-1), ne = document.activeElement;
        for (const V of D)
          if (V === ne || (V?.scrollIntoView({ block: "nearest" }), V === Y && x && (x.scrollTop = 0), V === G && x && (x.scrollTop = x.scrollHeight), V?.focus(), document.activeElement !== ne)) return;
      },
      [U, x]
    ), K = h.useCallback(
      () => q([E, _]),
      [q, E, _]
    );
    h.useEffect(() => {
      M && K();
    }, [M, K]);
    const { onOpenChange: Z, triggerPointerDownPosRef: te } = y;
    h.useEffect(() => {
      if (_) {
        let D = { x: 0, y: 0 };
        const Y = (G) => {
          D = {
            x: Math.abs(Math.round(G.pageX) - (te.current?.x ?? 0)),
            y: Math.abs(Math.round(G.pageY) - (te.current?.y ?? 0))
          };
        }, Q = (G) => {
          D.x <= 10 && D.y <= 10 ? G.preventDefault() : _.contains(G.target) || Z(!1), document.removeEventListener("pointermove", Y), te.current = null;
        };
        return te.current !== null && (document.addEventListener("pointermove", Y), document.addEventListener("pointerup", Q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Y), document.removeEventListener("pointerup", Q, { capture: !0 });
        };
      }
    }, [_, Z, te]), h.useEffect(() => {
      const D = () => Z(!1);
      return window.addEventListener("blur", D), window.addEventListener("resize", D), () => {
        window.removeEventListener("blur", D), window.removeEventListener("resize", D);
      };
    }, [Z]);
    const [O, N] = Yw((D) => {
      const Y = U().filter((ne) => !ne.disabled), Q = Y.find((ne) => ne.ref.current === document.activeElement), G = Xw(Y, D, Q);
      G && setTimeout(() => G.ref.current.focus());
    }), T = h.useCallback(
      (D, Y, Q) => {
        const G = !L.current && !Q;
        (y.value !== void 0 && y.value === Y || G) && (C(D), G && (L.current = !0));
      },
      [y.value]
    ), W = h.useCallback(() => _?.focus(), [_]), B = h.useCallback(
      (D, Y, Q) => {
        const G = !L.current && !Q;
        (y.value !== void 0 && y.value === Y || G) && I(D);
      },
      [y.value]
    ), J = o === "popper" ? Oc : Uw, ee = J === Oc ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: m,
      collisionPadding: f,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v(
      Bw,
      {
        scope: n,
        content: _,
        viewport: x,
        onViewportChange: S,
        itemRefCallback: T,
        selectedItem: E,
        onItemLeave: W,
        itemTextRefCallback: B,
        focusSelectedItem: K,
        selectedItemText: A,
        position: o,
        isPositioned: M,
        searchRef: O,
        children: /* @__PURE__ */ v(ad, { as: eZ, allowPinchZoom: !0, children: /* @__PURE__ */ v(
          od,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (D) => {
              D.preventDefault();
            },
            onUnmountAutoFocus: ve(a, (D) => {
              y.trigger?.focus({ preventScroll: !0 }), D.preventDefault();
            }),
            children: /* @__PURE__ */ v(
              nd,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: r,
                onPointerDownOutside: i,
                onFocusOutside: (D) => D.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ v(
                  J,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (D) => D.preventDefault(),
                    ...w,
                    ...ee,
                    onPlaced: () => z(!0),
                    ref: $,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ve(w.onKeyDown, (D) => {
                      const Y = D.ctrlKey || D.altKey || D.metaKey;
                      if (D.key === "Tab" && D.preventDefault(), !Y && D.key.length === 1 && N(D.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(D.key)) {
                        let Q = U().filter((G) => !G.disabled).map((G) => G.ref.current);
                        if (["ArrowUp", "End"].includes(D.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(D.key)) {
                          const G = D.target, ne = Q.indexOf(G);
                          Q = Q.slice(ne + 1);
                        }
                        setTimeout(() => q(Q)), D.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Vw.displayName = Q7;
var tZ = "SelectItemAlignedPosition", Uw = h.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...a } = e, r = zn(oo, n), i = Nn(oo, n), [s, l] = h.useState(null), [c, u] = h.useState(null), d = Re(t, ($) => u($)), m = As(n), f = h.useRef(!1), g = h.useRef(!0), { viewport: p, selectedItem: b, selectedItemText: w, focusSelectedItem: y } = i, _ = h.useCallback(() => {
    if (r.trigger && r.valueNode && s && c && p && b && w) {
      const $ = r.trigger.getBoundingClientRect(), E = c.getBoundingClientRect(), C = r.valueNode.getBoundingClientRect(), A = w.getBoundingClientRect();
      if (r.dir !== "rtl") {
        const G = A.left - E.left, ne = C.left - G, V = $.left - ne, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - jt, Ve = Sc(ne, [
          jt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(jt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.left = Ve + "px";
      } else {
        const G = E.right - A.right, ne = window.innerWidth - C.right - G, V = window.innerWidth - $.right - ne, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - jt, Ve = Sc(ne, [
          jt,
          Math.max(jt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.right = Ve + "px";
      }
      const I = m(), U = window.innerHeight - jt * 2, M = p.scrollHeight, z = window.getComputedStyle(c), L = parseInt(z.borderTopWidth, 10), q = parseInt(z.paddingTop, 10), K = parseInt(z.borderBottomWidth, 10), Z = parseInt(z.paddingBottom, 10), te = L + q + M + Z + K, O = Math.min(b.offsetHeight * 5, te), N = window.getComputedStyle(p), T = parseInt(N.paddingTop, 10), W = parseInt(N.paddingBottom, 10), B = $.top + $.height / 2 - jt, J = U - B, ee = b.offsetHeight / 2, D = b.offsetTop + ee, Y = L + q + D, Q = te - Y;
      if (Y <= B) {
        const G = I.length > 0 && b === I[I.length - 1].ref.current;
        s.style.bottom = "0px";
        const ne = c.clientHeight - p.offsetTop - p.offsetHeight, V = Math.max(
          J,
          ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (G ? W : 0) + ne + K
        ), fe = Y + V;
        s.style.height = fe + "px";
      } else {
        const G = I.length > 0 && b === I[0].ref.current;
        s.style.top = "0px";
        const ne = Math.max(
          B,
          L + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (G ? T : 0) + ee
        ) + Q;
        s.style.height = ne + "px", p.scrollTop = Y - B + p.offsetTop;
      }
      s.style.margin = `${jt}px 0`, s.style.minHeight = O + "px", s.style.maxHeight = U + "px", o?.(), requestAnimationFrame(() => f.current = !0);
    }
  }, [
    m,
    r.trigger,
    r.valueNode,
    s,
    c,
    p,
    b,
    w,
    r.dir,
    o
  ]);
  nt(() => _(), [_]);
  const [k, x] = h.useState();
  nt(() => {
    c && x(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = h.useCallback(
    ($) => {
      $ && g.current === !0 && (_(), y?.(), g.current = !1);
    },
    [_, y]
  );
  return /* @__PURE__ */ v(
    oZ,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: f,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ v(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: k
          },
          children: /* @__PURE__ */ v(
            ye.div,
            {
              ...a,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
Uw.displayName = tZ;
var nZ = "SelectPopperPosition", Oc = h.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: a = jt,
    ...r
  } = e, i = yd(n);
  return /* @__PURE__ */ v(
    F7,
    {
      ...i,
      ...r,
      ref: t,
      align: o,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...r.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Oc.displayName = nZ;
var [oZ, _d] = oa(oo, {}), zc = "SelectViewport", aZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...a } = e, r = Nn(zc, n), i = _d(zc, n), s = Re(t, r.onViewportChange), l = h.useRef(0);
    return /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ v(vd.Slot, { scope: n, children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...a.style
          },
          onScroll: ve(a.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: m } = i;
            if (m?.current && d) {
              const f = Math.abs(l.current - u.scrollTop);
              if (f > 0) {
                const g = window.innerHeight - jt * 2, p = parseFloat(d.style.minHeight), b = parseFloat(d.style.height), w = Math.max(p, b);
                if (w < g) {
                  const y = w + f, _ = Math.min(g, y), k = y - _;
                  d.style.height = _ + "px", d.style.bottom === "0px" && (u.scrollTop = k > 0 ? k : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
aZ.displayName = zc;
var qw = "SelectGroup", [rZ, iZ] = oa(qw), sZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, a = L_();
    return /* @__PURE__ */ v(rZ, { scope: n, id: a, children: /* @__PURE__ */ v(ye.div, { role: "group", "aria-labelledby": a, ...o, ref: t }) });
  }
);
sZ.displayName = qw;
var Hw = "SelectLabel", lZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, a = iZ(Hw, n);
    return /* @__PURE__ */ v(ye.div, { id: a.id, ...o, ref: t });
  }
);
lZ.displayName = Hw;
var Pi = "SelectItem", [cZ, Kw] = oa(Pi), uZ = h.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: a = !1,
      textValue: r,
      ...i
    } = e, s = zn(Pi, n), l = Nn(Pi, n), c = s.value === o, [u, d] = h.useState(r ?? ""), [m, f] = h.useState(!1), g = Re(
      t,
      (y) => l.itemRefCallback?.(y, o, a)
    ), p = L_(), b = h.useRef("touch"), w = () => {
      a || (s.onValueChange(o), s.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v(
      cZ,
      {
        scope: n,
        value: o,
        disabled: a,
        textId: p,
        isSelected: c,
        onItemTextChange: h.useCallback((y) => {
          d((_) => _ || (y?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v(
          vd.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: a,
            textValue: u,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...i,
                ref: g,
                onFocus: ve(i.onFocus, () => f(!0)),
                onBlur: ve(i.onBlur, () => f(!1)),
                onClick: ve(i.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: ve(i.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: ve(i.onPointerDown, (y) => {
                  b.current = y.pointerType;
                }),
                onPointerMove: ve(i.onPointerMove, (y) => {
                  b.current = y.pointerType, a ? l.onItemLeave?.() : b.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ve(i.onPointerLeave, (y) => {
                  y.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: ve(i.onKeyDown, (y) => {
                  l.searchRef?.current !== "" && y.key === " " || (q7.includes(y.key) && w(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
uZ.displayName = Pi;
var fa = "SelectItemText", dZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: a, ...r } = e, i = zn(fa, n), s = Nn(fa, n), l = Kw(fa, n), c = K7(fa, n), [u, d] = h.useState(null), m = Re(
      t,
      (w) => d(w),
      l.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, l.value, l.disabled)
    ), f = u?.textContent, g = h.useMemo(
      () => /* @__PURE__ */ v("option", { value: l.value, disabled: l.disabled, children: f }, l.value),
      [l.disabled, l.value, f]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: b } = c;
    return nt(() => (p(g), () => b(g)), [p, b, g]), /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(ye.span, { id: l.textId, ...r, ref: m }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? so.createPortal(r.children, i.valueNode) : null
    ] });
  }
);
dZ.displayName = fa;
var Gw = "SelectItemIndicator", hZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Kw(Gw, n).isSelected ? /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
hZ.displayName = Gw;
var Nc = "SelectScrollUpButton", pZ = h.forwardRef((e, t) => {
  const n = Nn(Nc, e.__scopeSelect), o = _d(Nc, e.__scopeSelect), [a, r] = h.useState(!1), i = Re(t, o.onScrollButtonChange);
  return nt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        r(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ v(
    Zw,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
pZ.displayName = Nc;
var jc = "SelectScrollDownButton", mZ = h.forwardRef((e, t) => {
  const n = Nn(jc, e.__scopeSelect), o = _d(jc, e.__scopeSelect), [a, r] = h.useState(!1), i = Re(t, o.onScrollButtonChange);
  return nt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        r(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ v(
    Zw,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
mZ.displayName = jc;
var Zw = h.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...a } = e, r = Nn("SelectScrollButton", n), i = h.useRef(null), s = As(n), l = h.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return h.useEffect(() => () => l(), [l]), nt(() => {
    s().find((c) => c.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ v(
    ye.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: t,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: ve(a.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: ve(a.onPointerMove, () => {
        r.onItemLeave?.(), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: ve(a.onPointerLeave, () => {
        l();
      })
    }
  );
}), fZ = "SelectSeparator", gZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ v(ye.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
gZ.displayName = fZ;
var Rc = "SelectArrow", bZ = h.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, a = yd(n), r = zn(Rc, n), i = Nn(Rc, n);
    return r.open && i.position === "popper" ? /* @__PURE__ */ v(W7, { ...a, ...o, ref: t }) : null;
  }
);
bZ.displayName = Rc;
var vZ = "SelectBubbleInput", yZ = h.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const a = h.useRef(null), r = Re(o, a), i = uK(t);
    return h.useEffect(() => {
      const s = a.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && c) {
        const u = new Event("change", { bubbles: !0 });
        c.call(s, t), s.dispatchEvent(u);
      }
    }, [i, t]), /* @__PURE__ */ v(
      ye.select,
      {
        ...n,
        style: { ...Mw, ...n.style },
        ref: r,
        defaultValue: t
      }
    );
  }
);
yZ.displayName = vZ;
function Jw(e) {
  return e === "" || e === void 0;
}
function Yw(e) {
  const t = lt(e), n = h.useRef(""), o = h.useRef(0), a = h.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(o.current), c !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), r = h.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return h.useEffect(() => () => window.clearTimeout(o.current), []), [n, a, r];
}
function Xw(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let r = _Z(e, Math.max(a, 0));
  o.length === 1 && (r = r.filter((s) => s !== n));
  const i = r.find(
    (s) => s.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return i !== n ? i : void 0;
}
function _Z(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
const wZ = Pt(void 0), Dm = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (s, l) => {
    const c = typeof s == "function" ? s(t) : s;
    if (!Object.is(c, t)) {
      const u = t;
      t = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), n.forEach((d) => d(t, u));
    }
  }, a = () => t, r = { setState: o, getState: a, getInitialState: () => i, subscribe: (s) => (n.add(s), () => n.delete(s)) }, i = t = e(o, a, r);
  return r;
}, kZ = (e) => e ? Dm(e) : Dm;
function xZ(e) {
  const t = {
    config: {
      apiUrl: "",
      assetsUrl: ""
    }
  };
  return kZ((n) => ({
    ...t,
    ...e,
    setConfig: (o) => n({ config: o })
  }));
}
function $Z({ children: e, ...t }) {
  const n = Te(null);
  return n.current || (n.current = xZ(t)), /* @__PURE__ */ v(wZ.Provider, { value: n.current, children: e });
}
const se = (e) => typeof e == "string", pa = () => {
  let e, t;
  const n = new Promise((o, a) => {
    e = o, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, Lm = (e) => e == null ? "" : "" + e, SZ = (e, t, n) => {
  e.forEach((o) => {
    t[o] && (n[o] = t[o]);
  });
}, CZ = /###/g, Mm = (e) => e && e.indexOf("###") > -1 ? e.replace(CZ, ".") : e, Fm = (e) => !e || se(e), Sa = (e, t, n) => {
  const o = se(t) ? t.split(".") : t;
  let a = 0;
  for (; a < o.length - 1; ) {
    if (Fm(e)) return {};
    const r = Mm(o[a]);
    !e[r] && n && (e[r] = new n()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++a;
  }
  return Fm(e) ? {} : {
    obj: e,
    k: Mm(o[a])
  };
}, Wm = (e, t, n) => {
  const {
    obj: o,
    k: a
  } = Sa(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[a] = n;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = Sa(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = Sa(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = n;
}, EZ = (e, t, n, o) => {
  const {
    obj: a,
    k: r
  } = Sa(e, t, Object);
  a[r] = a[r] || [], a[r].push(n);
}, Di = (e, t) => {
  const {
    obj: n,
    k: o
  } = Sa(e, t);
  if (n && Object.prototype.hasOwnProperty.call(n, o))
    return n[o];
}, AZ = (e, t, n) => {
  const o = Di(e, n);
  return o !== void 0 ? o : Di(t, n);
}, Qw = (e, t, n) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? se(e[o]) || e[o] instanceof String || se(t[o]) || t[o] instanceof String ? n && (e[o] = t[o]) : Qw(e[o], t[o], n) : e[o] = t[o]);
  return e;
}, Eo = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var OZ = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const zZ = (e) => se(e) ? e.replace(/[&<>"'\/]/g, (t) => OZ[t]) : e;
class NZ {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const jZ = [" ", ",", "?", "!", ";"], RZ = new NZ(20), IZ = (e, t, n) => {
  t = t || "", n = n || "";
  const o = jZ.filter((i) => t.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const a = RZ.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !a.test(e);
  if (!r) {
    const i = e.indexOf(n);
    i > 0 && !a.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Ic = (e, t, n = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(n);
  let a = e;
  for (let r = 0; r < o.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += n), s += o[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    a = i;
  }
  return a;
}, Ra = (e) => e?.replace("_", "-"), TZ = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Li {
  constructor(t, n = {}) {
    this.init(t, n);
  }
  init(t, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = t || TZ, this.options = n, this.debug = n.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, o, a) {
    return a && !this.debug ? null : (se(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new Li(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Li(this.logger, t);
  }
}
var Kt = new Li();
class Os {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const a = this.observers[o].get(n) || 0;
      this.observers[o].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t, ...n) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, a]) => {
      for (let r = 0; r < a; r++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, a]) => {
      for (let r = 0; r < a; r++)
        o.apply(o, [t, ...n]);
    });
  }
}
class Bm extends Os {
  constructor(t, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, o, a = {}) {
    const r = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, i = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], o && (Array.isArray(o) ? s.push(...o) : se(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Di(this.data, s);
    return !l && !n && !o && t.indexOf(".") > -1 && (t = s[0], n = s[1], o = s.slice(2).join(".")), l || !i || !se(o) ? l : Ic(this.data?.[t]?.[n], o, r);
  }
  addResource(t, n, o, a, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, n];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), Wm(this.data, s, a), r.silent || this.emit("added", t, n, o, a);
  }
  addResources(t, n, o, a = {
    silent: !1
  }) {
    for (const r in o)
      (se(o[r]) || Array.isArray(o[r])) && this.addResource(t, n, r, o[r], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, o);
  }
  addResourceBundle(t, n, o, a, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = o, o = n, n = s[1]), this.addNamespaces(n);
    let l = Di(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), a ? Qw(l, o, r) : l = {
      ...l,
      ...o
    }, Wm(this.data, s, l), i.silent || this.emit("added", t, n, o);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ek = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, o, a) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, n, o, a) ?? t;
    }), t;
  }
};
const tk = Symbol("i18next/PATH_KEY");
function PZ() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let n;
  return t.get = (o, a) => (n?.revoke?.(), a === tk ? e : (e.push(a), n = Proxy.revocable(o, t), n.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Tc(e, t) {
  const {
    [tk]: n
  } = e(PZ());
  return n.join(t?.keySeparator ?? ".");
}
const Vm = {}, Um = (e) => !se(e) && typeof e != "boolean" && typeof e != "number";
class Mi extends Os {
  constructor(t, n = {}) {
    super(), SZ(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Kt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, n = {
    interpolation: {}
  }) {
    const o = {
      ...n
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, n) {
    let o = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let r = n.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !IZ(t, o, a);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: se(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== a || o === a && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: se(r) ? [r] : r
    };
  }
  translate(t, n, o) {
    let a = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof a != "object" && this.options.overloadTranslationOptionHandler && (a = this.options.overloadTranslationOptionHandler(arguments)), typeof a == "object" && (a = {
      ...a
    }), a || (a = {}), t == null) return "";
    typeof t == "function" && (t = Tc(t, {
      ...this.options,
      ...a
    })), Array.isArray(t) || (t = [String(t)]);
    const r = a.returnDetails !== void 0 ? a.returnDetails : this.options.returnDetails, i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], a), c = l[l.length - 1];
    let u = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = a.lng || this.language, m = a.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return m ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : s;
    const f = this.resolve(t, a);
    let g = f?.res;
    const p = f?.usedKey || s, b = f?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], y = a.joinArrays !== void 0 ? a.joinArrays : this.options.joinArrays, _ = !this.i18nFormat || this.i18nFormat.handleAsObject, k = a.count !== void 0 && !se(a.count), x = Mi.hasDefaultValue(a), S = k ? this.pluralResolver.getSuffix(d, a.count, a) : "", $ = a.ordinal && k ? this.pluralResolver.getSuffix(d, a.count, {
      ordinal: !1
    }) : "", E = k && !a.ordinal && a.count === 0, C = E && a[`defaultValue${this.options.pluralSeparator}zero`] || a[`defaultValue${S}`] || a[`defaultValue${$}`] || a.defaultValue;
    let A = g;
    _ && !g && x && (A = C);
    const I = Um(A), U = Object.prototype.toString.apply(A);
    if (_ && A && I && w.indexOf(U) < 0 && !(se(y) && Array.isArray(A))) {
      if (!a.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, A, {
          ...a,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (f.res = M, f.usedParams = this.getUsedParamsDetails(a), f) : M;
      }
      if (i) {
        const M = Array.isArray(A), z = M ? [] : {}, L = M ? b : p;
        for (const q in A)
          if (Object.prototype.hasOwnProperty.call(A, q)) {
            const K = `${L}${i}${q}`;
            x && !g ? z[q] = this.translate(K, {
              ...a,
              defaultValue: Um(C) ? C[q] : void 0,
              joinArrays: !1,
              ns: l
            }) : z[q] = this.translate(K, {
              ...a,
              joinArrays: !1,
              ns: l
            }), z[q] === K && (z[q] = A[q]);
          }
        g = z;
      }
    } else if (_ && se(y) && Array.isArray(g))
      g = g.join(y), g && (g = this.extendTranslation(g, t, a, o));
    else {
      let M = !1, z = !1;
      !this.isValidLookup(g) && x && (M = !0, g = C), this.isValidLookup(g) || (z = !0, g = s);
      const L = (a.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && z ? void 0 : g, q = x && C !== g && this.options.updateMissing;
      if (z || M || q) {
        if (this.logger.log(q ? "updateKey" : "missingKey", d, c, s, q ? C : g), i) {
          const O = this.resolve(s, {
            ...a,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const Z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, a.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Z && Z[0])
          for (let O = 0; O < Z.length; O++)
            K.push(Z[O]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(a.lng || this.language) : K.push(a.lng || this.language);
        const te = (O, N, T) => {
          const W = x && T !== g ? T : L;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, c, N, W, q, a) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(O, c, N, W, q, a), this.emit("missingKey", O, c, N, g);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? K.forEach((O) => {
          const N = this.pluralResolver.getSuffixes(O, a);
          E && a[`defaultValue${this.options.pluralSeparator}zero`] && N.indexOf(`${this.options.pluralSeparator}zero`) < 0 && N.push(`${this.options.pluralSeparator}zero`), N.forEach((T) => {
            te([O], s + T, a[`defaultValue${T}`] || C);
          });
        }) : te(K, s, C));
      }
      g = this.extendTranslation(g, t, a, f, o), z && g === s && this.options.appendNamespaceToMissingKey && (g = `${c}${u}${s}`), (z || M) && this.options.parseMissingKeyHandler && (g = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, M ? g : void 0, a));
    }
    return r ? (f.res = g, f.usedParams = this.getUsedParamsDetails(a), f) : g;
  }
  extendTranslation(t, n, o, a, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = se(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !se(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || a.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), m = d && d.length;
        c < m && (o.nest = !1);
      }
      !o.lng && a && a.res && (o.lng = this.language || a.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null) : this.translate(...d, n), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = se(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = ek.handle(s, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, n = {}) {
    let o, a, r, i, s;
    return se(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const m = n.count !== void 0 && !se(n.count), f = m && !n.ordinal && n.count === 0, g = n.context !== void 0 && (se(n.context) || typeof n.context == "number") && n.context !== "", p = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !Vm[`${p[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (Vm[`${p[0]}-${b}`] = !0, this.logger.warn(`key "${a}" for languages "${p.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const y = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(y, u, w, b, n);
          else {
            let k;
            m && (k = this.pluralResolver.getSuffix(w, n.count, n));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (m && (n.ordinal && k.indexOf(S) === 0 && y.push(u + k.replace(S, this.options.pluralSeparator)), y.push(u + k), f && y.push(u + x)), g) {
              const $ = `${u}${this.options.contextSeparator || "_"}${n.context}`;
              y.push($), m && (n.ordinal && k.indexOf(S) === 0 && y.push($ + k.replace(S, this.options.pluralSeparator)), y.push($ + k), f && y.push($ + x));
            }
          }
          let _;
          for (; _ = y.pop(); )
            this.isValidLookup(o) || (r = _, o = this.getResource(w, b, _, n));
        }));
      });
    }), {
      res: o,
      usedKey: a,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, o, a = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, n, o, a) : this.resourceStore.getResource(t, n, o, a);
  }
  getUsedParamsDetails(t = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !se(t.replace);
    let a = o ? t.replace : t;
    if (o && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !o) {
      a = {
        ...a
      };
      for (const r of n)
        delete a[r];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && n === o.substring(0, n.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class qm {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Kt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Ra(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Ra(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (se(t) && t.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((o) => {
      if (n) return;
      const a = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((o) => {
      if (n) return;
      const a = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(a)) return n = a;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return n = r;
      n = this.options.supportedLngs.find((i) => {
        if (i === r || !(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), se(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let o = t[n];
    return o || (o = t[this.getScriptPartFromCode(n)]), o || (o = t[this.formatLanguageCode(n)]), o || (o = t[this.getLanguagePartFromCode(n)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, n) {
    const o = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], t), a = [], r = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return se(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : se(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      a.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), a;
  }
}
const Hm = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Km = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class DZ {
  constructor(t, n = {}) {
    this.languageUtils = t, this.options = n, this.logger = Kt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, n = {}) {
    const o = Ra(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: a
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: a
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Km;
      if (!t.match(/-|_/)) return Km;
      const s = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(s, n);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, n, o = {}) {
    return this.getSuffixes(t, o).map((a) => `${n}${a}`);
  }
  getSuffixes(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o ? o.resolvedOptions().pluralCategories.sort((a, r) => Hm[a] - Hm[r]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : [];
  }
  getSuffix(t, n, o = {}) {
    const a = this.getRule(t, o);
    return a ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", n, o));
  }
}
const Gm = (e, t, n, o = ".", a = !0) => {
  let r = AZ(e, t, n);
  return !r && a && se(n) && (r = Ic(e, n, o), r === void 0 && (r = Ic(t, n, o))), r;
}, zl = (e) => e.replace(/\$/g, "$$$$");
class LZ {
  constructor(t = {}) {
    this.logger = Kt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: o,
      useRawValueToEscape: a,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: m,
      nestingPrefixEscaped: f,
      nestingSuffix: g,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: y
    } = t.interpolation;
    this.escape = n !== void 0 ? n : zZ, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = r ? Eo(r) : i || "{{", this.suffix = s ? Eo(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = m ? Eo(m) : f || Eo("$t("), this.nestingSuffix = g ? Eo(g) : p || Eo(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = y !== void 0 ? y : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, o) => n?.source === o ? (n.lastIndex = 0, n) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, n, o, a) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const b = Gm(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, o, {
          ...a,
          ...n,
          interpolationkey: m
        }) : b;
      }
      const f = m.split(this.formatSeparator), g = f.shift().trim(), p = f.join(this.formatSeparator).trim();
      return this.format(Gm(n, l, g, this.options.keySeparator, this.options.ignoreJSONStructure), p, o, {
        ...a,
        ...n,
        interpolationkey: g
      });
    };
    this.resetRegExp();
    const u = a?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a?.interpolation?.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => zl(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? zl(this.escape(m)) : zl(m)
    }].forEach((m) => {
      for (s = 0; r = m.regex.exec(t); ) {
        const f = r[1].trim();
        if (i = c(f), i === void 0)
          if (typeof u == "function") {
            const p = u(t, r, a);
            i = se(p) ? p : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, f))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${t}`), i = "";
        else !se(i) && !this.useRawValueToEscape && (i = Lm(i));
        const g = m.safeValue(i);
        if (t = t.replace(r[0], g), d ? (m.regex.lastIndex += i.length, m.regex.lastIndex -= r[0].length) : m.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n, o = {}) {
    let a, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let m = `{${d[1]}`;
      l = d[0], m = this.interpolate(m, i);
      const f = m.match(/'/g), g = m.match(/"/g);
      ((f?.length ?? 0) % 2 === 0 && !g || g.length % 2 !== 0) && (m = m.replace(/'/g, '"'));
      try {
        i = JSON.parse(m), c && (i = {
          ...c,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${m}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !se(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(a[1]) ? a[1].lastIndexOf("}") + 1 : a[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = a[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), a[1] = a[1].slice(0, c)), r = n(s.call(this, a[1].trim(), i), i), r && a[0] === t && !se(r)) return r;
      se(r) || (r = Lm(r)), r || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: a[1].trim()
      }), r.trim())), t = t.replace(a[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const MZ = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const a = o[1].substring(0, o[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((r) => {
      if (r) {
        const [i, ...s] = r.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, Zm = (e) => {
  const t = {};
  return (n, o, a) => {
    let r = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (r = {
      ...r,
      [a.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Ra(o), a), t[i] = s), s(n);
  };
}, FZ = (e) => (t, n, o) => e(Ra(n), o)(t);
class WZ {
  constructor(t = {}) {
    this.logger = Kt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const o = n.cacheInBuiltFormats ? Zm : FZ;
    this.formats = {
      number: o((a, r) => {
        const i = new Intl.NumberFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((a, r) => {
        const i = new Intl.NumberFormat(a, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((a, r) => {
        const i = new Intl.DateTimeFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((a, r) => {
        const i = new Intl.RelativeTimeFormat(a, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((a, r) => {
        const i = new Intl.ListFormat(a, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Zm(n);
  }
  format(t, n, o, a = {}) {
    const r = n.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((i) => i.indexOf(")") > -1)) {
      const i = r.findIndex((s) => s.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, i)].join(this.formatSeparator);
    }
    return r.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = MZ(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = a?.formatParams?.[a.interpolationkey] || {}, m = d.locale || d.lng || a.locale || a.lng || o;
          u = this.formats[l](i, m, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
}
const BZ = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class VZ extends Os {
  constructor(t, n, o, a = {}) {
    super(), this.backend = t, this.store = n, this.services = o, this.languageUtils = o.languageUtils, this.options = a, this.logger = Kt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, a.backend, a);
  }
  queueLoad(t, n, o, a) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const m = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[m] = 2 : this.state[m] < 0 || (this.state[m] === 1 ? i[m] === void 0 && (i[m] = !0) : (this.state[m] = 1, u = !1, i[m] === void 0 && (i[m] = !0), r[m] === void 0 && (r[m] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, o) {
    const a = t.split("|"), r = a[0], i = a[1];
    n && this.emit("failedLoading", r, i, n), !n && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      EZ(l.loaded, [r], i), BZ(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, o, a = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: o,
        tried: a,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, o, a + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n, o = {}, a) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    se(t) && (t = this.languageUtils.toResolveHierarchy(t)), se(n) && (n = [n]);
    const r = this.queueLoad(t, n, o, a);
    if (!r.toLoad.length)
      return r.pending.length || a(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, n, o) {
    this.prepareLoading(t, n, {}, o);
  }
  reload(t, n, o) {
    this.prepareLoading(t, n, {
      reload: !0
    }, o);
  }
  loadOne(t, n = "") {
    const o = t.split("|"), a = o[0], r = o[1];
    this.read(a, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${r} for language ${a} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${r} for language ${a}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, n, o, a, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, o, a, l) : u = c(t, n, o, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, o, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, o, a);
    }
  }
}
const Jm = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), se(e[1]) && (t.defaultValue = e[1]), se(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((o) => {
        t[o] = n[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Ym = (e) => (se(e.ns) && (e.ns = [e.ns]), se(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), se(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), jr = () => {
}, UZ = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Ia extends Os {
  constructor(t = {}, n) {
    if (super(), this.options = Ym(t), this.services = {}, this.logger = Kt, this.modules = {
      external: []
    }, UZ(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init(t = {}, n) {
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), t.defaultNS == null && t.ns && (se(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Jm();
    this.options = {
      ...o,
      ...this.options,
      ...Ym(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const a = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Kt.init(a(this.modules.logger), this.options) : Kt.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = WZ;
      const l = new qm(this.options);
      this.store = new Bm(this.options.resources, this.options);
      const c = this.services;
      c.logger = Kt, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new DZ(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = a(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new LZ(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new VZ(a(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = a(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = a(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Mi(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = jr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const r = pa(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), n(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), r;
  }
  loadResources(t, n = jr) {
    let o = n;
    const a = se(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        !s || s === "cimode" || this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && r.indexOf(l) < 0 && r.push(l);
        });
      };
      a ? i(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => i(s)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, n, o) {
    const a = pa();
    return typeof t == "function" && (o = t, t = void 0), typeof n == "function" && (o = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), o || (o = jr), this.services.backendConnector.reload(t, n, (r) => {
      a.resolve(), o(r);
    }), a;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && ek.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const o = this.languages[n];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, n) {
    this.isLanguageChangingTo = t;
    const o = pa();
    this.emit("languageChanging", t);
    const a = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (a(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), n && n(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = se(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(se(s) ? [s] : s);
      c && (this.language || a(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, n, o) {
    const a = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || a.lng, l.lngs = l.lngs || a.lngs, l.ns = l.ns || a.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || a.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Tc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = Tc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return se(t) ? a.lng = t : a.lngs = t, a.ns = n, a.keyPrefix = o, a;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!a || i(r, t)));
  }
  loadNamespaces(t, n) {
    const o = pa();
    return this.options.ns ? (se(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      o.resolve(), n && n(a);
    }), o) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const o = pa();
    se(t) && (t = [t]);
    const a = this.options.preload || [], r = t.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = a.concat(r), this.loadResources((i) => {
      o.resolve(), n && n(i);
    }), o) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const a = new Intl.Locale(t);
      if (a && a.getTextInfo) {
        const r = a.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new qm(Jm());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, n) {
    return new Ia(t, n);
  }
  cloneInstance(t = {}, n = jr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Ia(a);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      r[i] = this[i];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      r.store = new Bm(i, a), r.services.resourceStore = r.store;
    }
    return r.translator = new Mi(r.services, a), r.translator.on("*", (i, ...s) => {
      r.emit(i, ...s);
    }), r.init(a, n), r.translator.options = a, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const rt = Ia.createInstance();
rt.createInstance = Ia.createInstance;
const qZ = rt.createInstance;
rt.dir;
rt.init;
rt.loadResources;
rt.reloadResources;
rt.use;
rt.changeLanguage;
rt.getFixedT;
rt.t;
rt.exists;
rt.setDefaultNamespace;
rt.hasLoadedNamespace;
rt.loadNamespaces;
rt.loadLanguages;
const HZ = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-mail er klar! Log ind for at fortsætte.",
  "modal.emailVerif.alreadyVerified.title": "Din e-mailadresse er allerede blevet bekræftet",
  "modal.emailVerif.callout": "Vi har sendt en bekræftelsesmail.",
  "modal.emailVerif.desc": "Vi har sendt en bekræftelsesmail til <b>{{email}}</b>.<br/>Tjek din indbakke. Linket i denne e-mail udløber om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "Log ind for at modtage et nyt bekræftelseslink i din indbakke.",
  "modal.emailVerif.linkExpired.title": "Dette link er udløbet",
  "modal.emailVerif.resend-email-link": "Send ny bekræftelsesmail",
  "modal.emailVerif.resend-link": "Send ny bekræftelsesmail.",
  "modal.emailVerif.title": "Bekræft din e-mailadresse",
  "modal.finishCreatingAccount.event": "Til en begivenhed",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alle kender til HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Indtast dit fornavn",
  "modal.finishCreatingAccount.friends_family": "Gennem venner, familie eller bekendte",
  "modal.finishCreatingAccount.hearAboutHE": "Hvor har du hørt om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Indtast dit efternavn",
  "modal.finishCreatingAccount.other": "Andet",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Indtast dit telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Angiv venligst",
  "modal.finishCreatingAccount.press": "I pressen",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Trykte medier",
  "modal.finishCreatingAccount.radio": "I radioen",
  "modal.finishCreatingAccount.referral": "Henvisningskode",
  "modal.finishCreatingAccount.referralCode.error": "Denne henvisningskode er ugyldig",
  "modal.finishCreatingAccount.search_engine": "På en søgemaskine",
  "modal.finishCreatingAccount.social_media": "Via sociale medier",
  "modal.finishCreatingAccount.social_network_other": "Andre sociale medier (angiv venligst)",
  "modal.finishCreatingAccount.title": "Færdiggør oprettelsen af din konto",
  "modal.finishCreatingAccount.tv": "I fjernsynet",
  "modal.finishCreatingAccount.tv_ad": "I en reklame",
  "modal.finishCreatingAccount.tv_show": "Under et tv-indslag/tv-program",
  "modal.genericError.desc": "Platformen kan være nede, eller der kan være en midlertidig fejl hos os, så prøv venligst igen.<br><br>Vi registrerer automatisk disse fejl, men hvis problemet fortsætter, er du velkommen til at kontakte os på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hov! Der opstod en fejl",
  "modal.noEmailRecieved.desc": "<b>Har du ikke modtaget en e-mail?</b>Tjek din spammappe, og at du har stavet din e-mail korrekt, inden du anmoder om en ny bekræftelsesmail.",
  "modal.noEmailRecieved.error": "Der opstod en fejl. Prøv igen senere.",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt dig en ny bekræftelsesmail.",
  "signin-modal.apple.button": "Log ind med Apple",
  "signin-modal.button": "Log ind",
  "signin-modal.email.button": "Log ind",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Log ind med Facebook",
  "signin-modal.no-account": "Nyt medlem?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Skift kodeord",
  "signup-modal.accept-cgu": "Ved at oprette en profil accepterer jeg de",
  "signup-modal.apple.button": "Log ind med Apple",
  "signup-modal.button": "Tilmeld dig",
  "signup-modal.cgu.link": "Generelle brugervilkår",
  "signup-modal.description": "Rejs på en ny måde med HomeExchange: Bliv budt velkommen over hele verden og spar penge!",
  "signup-modal.email.button": "Tilmeld dig med din e-mailadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Tilmeld dig med Facebook",
  "signup-modal.have-an-account": "Har du allerede en profil?"
}, KZ = "Studio", GZ = "{{count}} soveværelse", ZZ = "{{count}} soveværelser", JZ = "", YZ = "{{count}} seng", XZ = "{{count}} senge", QZ = "Din kalender er blevet opdateret.", eJ = "", tJ = "", nJ = "", oJ = "", aJ = "", rJ = "", iJ = "", sJ = "", lJ = "Annuller", cJ = "Datoer", uJ = "Slet", dJ = "Beskrivelse", hJ = "Destination", pJ = "Sådan!", mJ = "Rediger", fJ = "Filtre", gJ = "", bJ = "", vJ = "Gæster", yJ = "boliger", _J = "", wJ = "Lokation", kJ = "Rediger", xJ = "Navn", $J = "Næste", SJ = "", CJ = "", EJ = "{{count}} voksne", AJ = "", OJ = "", zJ = "{{count}} babyer", NJ = "", jJ = "", RJ = "{{count}} børn", IJ = "{{count}} gæst", TJ = "{{count}} gæst", PJ = "{{count}} gæster", DJ = "Telefonnummerets format er ikke gyldigt.", LJ = "Modtag e-mailnotifikationer", MJ = "Gem", FJ = "Ingen lokationer fundet", WJ = "Rejseliste", BJ = "", VJ = "valgfrit", UJ = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: KZ,
  bedroomsNumbers_one: GZ,
  bedroomsNumbers_other: ZZ,
  beds_zero: JZ,
  beds_one: YZ,
  beds_other: XZ,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_calendarUpdated_toast: QZ,
  global_calendar_aMonth: eJ,
  global_calendar_exactDates: tJ,
  global_calendar_oneWeek: nJ,
  global_calendar_oneWeekend: oJ,
  global_calendar_plusMinusDay_zero: aJ,
  global_calendar_plusMinusDay_one: rJ,
  global_calendar_plusMinusDay_other: iJ,
  global_calendar_twoWeeks: sJ,
  global_cancel: lJ,
  global_dates: cJ,
  global_delete: uJ,
  global_description: dJ,
  global_destination: hJ,
  global_done: pJ,
  global_edit: mJ,
  global_filters: fJ,
  global_fixDates: gJ,
  global_flexibleDates: bJ,
  global_guests: vJ,
  global_homes: yJ,
  global_lastMinute: _J,
  global_location: wJ,
  global_modify: kJ,
  global_name: xJ,
  global_next: $J,
  global_numberOfAdults_zero: SJ,
  global_numberOfAdults_one: CJ,
  global_numberOfAdults_other: EJ,
  global_numberOfBabies_zero: AJ,
  global_numberOfBabies_one: OJ,
  global_numberOfBabies_other: zJ,
  global_numberOfChildren_zero: NJ,
  global_numberOfChildren_one: jJ,
  global_numberOfChildren_other: RJ,
  global_numberOfGuests_zero: IJ,
  global_numberOfGuests_one: TJ,
  global_numberOfGuests_other: PJ,
  global_phoneNumber_notValid: DJ,
  global_receiveEmailAlerts: LJ,
  global_save: MJ,
  global_searchBar_noLocationFound: FJ,
  global_travelWishlist: WJ,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: BJ,
  optional: VJ,
  "privacy-policy": "Privatpolitik"
}, qJ = "https://www.homeexchange.com/blog/", HJ = "/p/general-terms-of-use", KJ = "https://www.homeexchange.com/da/p/community-da", GJ = "https://homeexchangehelp.zendesk.com/hc/en-us", ZJ = "", JJ = "https://www.homeexchange.com/da/p/service-homeexchange-da", YJ = "https://www.homeexchange.com/da/p/guestpoints-da", XJ = "https://www.homeexchange.com/da/p/press-da", QJ = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", eY = "", tY = "", nY = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", oY = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: qJ,
  cgu: HJ,
  community: KJ,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: GJ,
  forum: ZJ,
  guarantees: JJ,
  guestpoints: YJ,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: XJ,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: QJ,
  travelWishlist_faq_links: eY,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: tY,
  values: nY
}, aY = "Fornavn", rY = "Efternavn", iY = "Tilføj til din rejseliste", sY = "En opdateret rejseliste giver dig mulighed for at modtage flere anmodninger om gensidige boligbytninger.", lY = "Er du sikker på, at du vil slette {{fullAddress}}?", cY = "Dette er de filtre, du har valgt. Hvis du har skiftet mening, kan du slette nogle af dem nedenfor. Men hvis du gerne vil tilføje flere, skal du starte en ny søgning (selvom dette snart ændrer sig... vi giver dig besked)!", uY = "Dette kan være et land, by eller en hel region. Hvis du vælger en bred lokation, er dine resultater muligvis mindre nøjagtige.", dY = "Indtast et land, by eller region", hY = "Se ledige boliger", pY = "Når boliger med tilgængelighed matcher dine rejseplaner.", mY = "Tilføj til din rejseliste", fY = "{{fullAddress}} er blevet slettet fra din rejseliste.", gY = "Vælg dine ideelle rejsedatoer (fleksible eller faste).", bY = "Tilføj detaljer, der hjælper andre, som bruger den omvendte søgefunktion, med at se, hvorfor du er interesseret i deres lokation.", vY = "Angiv, hvor mange personer der rejser sammen med dig under denne tur.", yY = "Hovsa! {{fullAddress}} kunne ikke gemmes til din rejseliste af en uventet årsag.%", _Y = "Fortæl os, hvornår og hvorhen du ønsker at rejse for at modtage bytteanmodninger og notifikationer, så snart passende boliger bliver tilgængelige. Vi gemmer dine søgninger i din rejseliste!", wY = "Er der andre rejseeventyr, du vil gå i gang med at planlægge?", kY = "<updateDates>Opdater dine datoer</updateDates> for at fortsætte med at modtage relevante e-mailnotifikationer eller <delete>slet denne destination</delete> fra din rejseliste, hvis du ikke længere overvejer den.", xY = "Disse datoer er i fortiden", $Y = "{{fullAddress}} er blevet tilføjet til din rejseliste!", SY = "{{fullAddress}} er blevet opdateret.", CY = "Din søgning er gemt, og din kalender er blevet opdateret!", EY = "Din søgning er blevet gemt. Du finder den i din rejseliste.", AY = "Lær mere om rejselister", OY = {
  firstname: aY,
  lastname: rY,
  modal_travelWishlist_addNew_title: iY,
  modal_travelWishlist_delete_body: sY,
  modal_travelWishlist_delete_title: lY,
  modal_travelWishlist_filtersApplied_helper: cY,
  modal_travelWishlist_location_helper: uY,
  modal_travelWishlist_searchBar_placeholder: dY,
  page_travelWishlist_card_cta: hY,
  page_travelWishlist_card_emailAlerts_helper: pY,
  page_travelWishlist_cta: mY,
  page_travelWishlist_deleted_toast: fY,
  page_travelWishlist_edit_dates_helper: gY,
  page_travelWishlist_edit_description_helper: bY,
  page_travelWishlist_edit_guests_helper: vY,
  page_travelWishlist_error_toast: yY,
  page_travelWishlist_none_body: _Y,
  page_travelWishlist_none_subheader: wY,
  page_travelWishlist_pastDates_desc: kY,
  page_travelWishlist_pastDates_title: xY,
  page_travelWishlist_saved_toast: $Y,
  page_travelWishlist_updated_toast: SY,
  search_travelWishlist_calendarUpdated_toast: CY,
  search_travelWishlist_saved_toast: EY,
  travelWishlist_faq: AY
}, zY = {
  "modal.emailVerif.alreadyVerified.desc": "Ihre E-Mail ist fertig! Melden Sie sich an, um fortzufahren.",
  "modal.emailVerif.alreadyVerified.title": "Ihre E-Mail-Adresse wurde bereits verifiziert",
  "modal.emailVerif.callout": "Eine Bestätigungs-E-Mail wurde versandt.",
  "modal.emailVerif.desc": "Wir haben eine Bestätigungs-E-Mail an <b>{{email}}</b> gesendet. <br/>Überprüfen Sie Ihren Posteingang. Der Link in dieser E-Mail läuft in 24 Stunden ab.",
  "modal.emailVerif.linkExpired.desc": "Um einen neuen Verifizierungslink per E-Mail zu erhalten, melden Sie sich bitte an.",
  "modal.emailVerif.linkExpired.title": "Dieser Link ist abgelaufen",
  "modal.emailVerif.resend-email-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.resend-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.title": "Verifizieren Sie Ihre E-Mail-Adresse",
  "modal.finishCreatingAccount.event": "Bei einer Veranstaltung",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Jeder kennt HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Geben Sie Ihren Vornamen ein",
  "modal.finishCreatingAccount.friends_family": "Durch Freunde, Familie oder Bekannte",
  "modal.finishCreatingAccount.hearAboutHE": "Wie haben Sie von HomeExchange erfahren?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Geben Sie Ihren Nachnamen ein",
  "modal.finishCreatingAccount.other": "Anderes",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Bitte geben Sie ihre Telefonnummer ein",
  "modal.finishCreatingAccount.pleaseSpecify": "Bitte angeben",
  "modal.finishCreatingAccount.press": "In der Presse",
  "modal.finishCreatingAccount.press_online": "Im Internet",
  "modal.finishCreatingAccount.press_print": "Gedruckte Ausgabe",
  "modal.finishCreatingAccount.radio": "Im Radio",
  "modal.finishCreatingAccount.referral": "Empfehlungscode",
  "modal.finishCreatingAccount.referralCode.error": "Dieser Empfehlungscode ist ungültig",
  "modal.finishCreatingAccount.search_engine": "Über eine Suchmaschine",
  "modal.finishCreatingAccount.social_media": "Über soziale Medien",
  "modal.finishCreatingAccount.social_network_other": "Anderes soziales Netzwerk (bitte angeben)",
  "modal.finishCreatingAccount.title": "Schließen Sie die Erstellung Ihres Kontos ab",
  "modal.finishCreatingAccount.tv": "Im Fernsehen",
  "modal.finishCreatingAccount.tv_ad": "In der Werbung",
  "modal.finishCreatingAccount.tv_show": "In einer Reportage / TV-Sendung",
  "modal.genericError.desc": "Die Plattform ist möglicherweise nicht erreichbar oder es liegt ein vorübergehender Fehler auf unserer Seite vor. Bitte versuchen Sie es noch einmal.<br><br>Wir erfassen diese Fehler automatisch, aber wenn das Problem weiterhin besteht, können Sie uns gerne unter <br><a>tech@homeexchange.com</a> kontaktieren.",
  "modal.genericError.title": "Hoppla! Da ist etwas schiefgelaufen",
  "modal.noEmailRecieved.desc": "<b>Sie haben keine E-Mail erhalten?</b>Überprüfen Sie Ihren Spam-Ordner und die Schreibweise Ihrer E-Mail, bevor Sie eine weitere Bestätigungs-E-Mail anfordern.",
  "modal.noEmailRecieved.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
  "modal.verifyEmail.emailResent.toast": "Wir haben Ihnen eine neue E-Mail zur Verifizierung geschickt.",
  "signin-modal.apple.button": "Mit Google verbinden",
  "signin-modal.button": "Einloggen",
  "signin-modal.email.button": "Einloggen",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Mit Facebook verbinden",
  "signin-modal.no-account": "Noch keinen Account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Passwort zurücksetzen",
  "signup-modal.accept-cgu": "Mit der Erstellung des Kontos akzeptiere ich die",
  "signup-modal.apple.button": "Melden Sie sich mit Apple an",
  "signup-modal.button": "Anmelden",
  "signup-modal.cgu.link": "Allgemeine Nutzungsbedingungen",
  "signup-modal.description": "Entdecken Sie dank Wohnungs-und Haustausch eine neue Art des Reisens: Seien Sie auf der ganzen Welt willkommen und sparen Sie Geld!",
  "signup-modal.email.button": "Mit E-Mail-Adresse anmelden",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Mit Facebook anmelden",
  "signup-modal.have-an-account": "Sie haben bereits ein Konto?"
}, NY = "Studio", jY = "{{count}} schlafzimmer", RY = "{{count}} schlafzimmer", IY = "", TY = "{{count}} Bett", PY = "{{count}} Betten", DY = "Ihr Kalender wurde aktualisiert.", LY = "Ein Monat", MY = "Genaue Daten", FY = "Eine Woche", WY = "Ein Wochenende", BY = "", VY = "{{count}} Tag", UY = "{{count}} Tage", qY = "Zwei Wochen", HY = "Abbrechen", KY = "Daten", GY = "Löschen", ZY = "Beschreibung", JY = "Reiseziel", YY = "Fertig!", XY = "Bearbeiten", QY = "Filter", eX = "Feste Daten", tX = "Flexible Daten", nX = "Gäste", oX = "Unterkünfte", aX = "Last Minute", rX = "Ort", iX = "Ändern", sX = "Name", lX = "Weiter", cX = "", uX = "{{count}} Erwachsener", dX = "{{count}} Erwachsene", hX = "", pX = "{{count}} Baby", mX = "{{count}} Babys", fX = "", gX = "{{count}} Kind", bX = "{{count}} Kinder", vX = "{{count}} Gast", yX = "{{count}} Gast", _X = "{{count}} Gäste", wX = "Das Format der Telefonnummer ist ungültig.", kX = "Benachrichtigungen per E-Mail erhalten", xX = "Speichern", $X = "Kein Reiseziel gefunden", SX = "Reiseprojekte", CX = "", EX = "optional", AX = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: NY,
  bedroomsNumbers_one: jY,
  bedroomsNumbers_other: RY,
  beds_zero: IY,
  beds_one: TY,
  beds_other: PY,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_calendarUpdated_toast: DY,
  global_calendar_aMonth: LY,
  global_calendar_exactDates: MY,
  global_calendar_oneWeek: FY,
  global_calendar_oneWeekend: WY,
  global_calendar_plusMinusDay_zero: BY,
  global_calendar_plusMinusDay_one: VY,
  global_calendar_plusMinusDay_other: UY,
  global_calendar_twoWeeks: qY,
  global_cancel: HY,
  global_dates: KY,
  global_delete: GY,
  global_description: ZY,
  global_destination: JY,
  global_done: YY,
  global_edit: XY,
  global_filters: QY,
  global_fixDates: eX,
  global_flexibleDates: tX,
  global_guests: nX,
  global_homes: oX,
  global_lastMinute: aX,
  global_location: rX,
  global_modify: iX,
  global_name: sX,
  global_next: lX,
  global_numberOfAdults_zero: cX,
  global_numberOfAdults_one: uX,
  global_numberOfAdults_other: dX,
  global_numberOfBabies_zero: hX,
  global_numberOfBabies_one: pX,
  global_numberOfBabies_other: mX,
  global_numberOfChildren_zero: fX,
  global_numberOfChildren_one: gX,
  global_numberOfChildren_other: bX,
  global_numberOfGuests_zero: vX,
  global_numberOfGuests_one: yX,
  global_numberOfGuests_other: _X,
  global_phoneNumber_notValid: wX,
  global_receiveEmailAlerts: kX,
  global_save: xX,
  global_searchBar_noLocationFound: $X,
  global_travelWishlist: SX,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: CX,
  optional: EX,
  "privacy-policy": "Datenschutz"
}, OX = "https://www.homeexchange.com/de/blog/", zX = "/de/p/homeexchangenutzungsbedingungen", NX = "https://www.homeexchange.com/de/p/our-community-de", jX = "https://homeexchangehelp.zendesk.com/hc/de", RX = "", IX = "https://www.homeexchange.com/de/p/service-homeexchange-de", TX = "https://www.homeexchange.com/de/p/guestpoints-de", PX = "https://www.homeexchange.com/de/p/press-de", DX = "https://www.homeexchange.com/p/worte-homeexchanger", LX = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", MX = "", FX = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", WX = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: OX,
  cgu: zX,
  community: NX,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: jX,
  forum: RX,
  guarantees: IX,
  guestpoints: TX,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: PX,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: DX,
  travelWishlist_faq_links: LX,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: MX,
  values: FX
}, BX = "Vorname", VX = "Nachname", UX = "Zu Ihren Reiseprojekten hinzufügen", qX = "Aktualisierte Reiseprojekte ermöglichen es Ihnen, mehr gegenseitige Tauschanfragen zu erhalten.", HX = "Sind Sie sicher, dass Sie {{fullAddress}} löschen möchten?", KX = "Dies sind die Filter, die Sie ausgewählt haben. Wenn Sie Ihre Meinung geändert haben, können Sie einige von ihnen löschen. Wenn Sie jedoch weitere Filter hinzufügen möchten, müssen Sie eine neue Suche starten (dies wird sich jedoch bald ändern... bleiben Sie dran)!", GX = "Dies kann ein Land, eine Stadt oder eine ganze Region sein. Wenn Sie einen großen Bereich auswählen, sind Ihre Ergebnisse möglicherweise weniger genau.", ZX = "Geben Sie ein Land, eine Stadt oder eine Region ein", JX = "Verfügbare Häuser anzeigen", YX = "Falls Unterkünfte mit Verfügbarkeit mit Ihren Reiseplänen übereinstimmen.", XX = "Zu den Reiseprojekten hinzufügen", QX = "{{fullAddress}} wurde aus Ihren Reiseprojekten gelöscht.", eQ = "Wählen Sie Ihre idealen Reisedaten (flexibel oder fest).", tQ = "Fügen Sie Details hinzu, damit andere, die die Umgekehrte Suche verwenden, erkennen können, warum Sie an ihrem Standort interessiert sind.", nQ = "Geben Sie an, wie viele Personen Sie auf dieser Reise begleiten werden.", oQ = "Hoppla! {{fullAddress}} konnte aus einem unerwarteten Grund nicht in Ihren Reiseprojekten gespeichert werden.%", aQ = "Teilen Sie uns mit, wann und wohin Sie reisen möchten, um Tauschanfragen und Benachrichtigungen zu erhalten, sobald passende Häuser verfügbar sind. Wir speichern Ihre Suchanfragen in Ihren Reiseprojekten!", rQ = "Gibt es Reisen, die Sie planen möchten?", iQ = "<updateDates>Aktualisieren Sie Ihre Daten</updateDates>, um weiterhin relevante E-Mail-Benachrichtigungen zu erhalten oder <delete>löschen Sie dieses Reiseziel</delete> aus Ihren Reiseprojekten, wenn Sie es nicht mehr in Betracht ziehen.", sQ = "Diese Daten liegen in der Vergangenheit", lQ = "{{fullAddress}} wurde zu Ihren Reiseprojekten hinzugefügt!", cQ = "{{fullAddress}} wurde erfolgreich aktualisiert.", uQ = "Ihre Suche wurde gespeichert und Ihr Kalender aktualisiert!", dQ = "Ihre Suche wurde gespeichert. Finden Sie sie in Ihren Reiseprojekten.", hQ = "Erfahren Sie mehr über Reiseprojekte", pQ = {
  firstname: BX,
  lastname: VX,
  modal_travelWishlist_addNew_title: UX,
  modal_travelWishlist_delete_body: qX,
  modal_travelWishlist_delete_title: HX,
  modal_travelWishlist_filtersApplied_helper: KX,
  modal_travelWishlist_location_helper: GX,
  modal_travelWishlist_searchBar_placeholder: ZX,
  page_travelWishlist_card_cta: JX,
  page_travelWishlist_card_emailAlerts_helper: YX,
  page_travelWishlist_cta: XX,
  page_travelWishlist_deleted_toast: QX,
  page_travelWishlist_edit_dates_helper: eQ,
  page_travelWishlist_edit_description_helper: tQ,
  page_travelWishlist_edit_guests_helper: nQ,
  page_travelWishlist_error_toast: oQ,
  page_travelWishlist_none_body: aQ,
  page_travelWishlist_none_subheader: rQ,
  page_travelWishlist_pastDates_desc: iQ,
  page_travelWishlist_pastDates_title: sQ,
  page_travelWishlist_saved_toast: lQ,
  page_travelWishlist_updated_toast: cQ,
  search_travelWishlist_calendarUpdated_toast: uQ,
  search_travelWishlist_saved_toast: dQ,
  travelWishlist_faq: hQ
}, mQ = {
  "modal.emailVerif.alreadyVerified.desc": "Your email is ready! Log in to continue.",
  "modal.emailVerif.alreadyVerified.title": "Your email address has already been verified",
  "modal.emailVerif.callout": "A verification email has been sent.",
  "modal.emailVerif.desc": "We have sent a verification email to <b>{{email}}</b>.<br/>Check your inbox. The link in this email will expire in 24-hours.",
  "modal.emailVerif.linkExpired.desc": "To receive a new verification link in your inbox, please log in.",
  "modal.emailVerif.linkExpired.title": "This link has expired",
  "modal.emailVerif.resend-email-link": "Resend verification email",
  "modal.emailVerif.resend-link": "Resend verification email",
  "modal.emailVerif.title": "Verify your email address",
  "modal.finishCreatingAccount.event": "At an event",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Everyone knows HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Enter your first name",
  "modal.finishCreatingAccount.friends_family": "Through friends, family, or acquaintances",
  "modal.finishCreatingAccount.hearAboutHE": "How did you hear about HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Enter your last name",
  "modal.finishCreatingAccount.other": "Other ",
  "modal.finishCreatingAccount.phone_number": "Phone number",
  "modal.finishCreatingAccount.phone_number.error": "Please enter your phone number",
  "modal.finishCreatingAccount.pleaseSpecify": "Please specify",
  "modal.finishCreatingAccount.press": "In the press",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Print",
  "modal.finishCreatingAccount.radio": "On the radio",
  "modal.finishCreatingAccount.referral": "Referral code",
  "modal.finishCreatingAccount.referralCode.error": "This referral code is invalid",
  "modal.finishCreatingAccount.search_engine": "On a search engine",
  "modal.finishCreatingAccount.social_media": "Via social media",
  "modal.finishCreatingAccount.social_network_other": "Other social network (please specify)",
  "modal.finishCreatingAccount.title": "Finish creating your account",
  "modal.finishCreatingAccount.tv": "On TV",
  "modal.finishCreatingAccount.tv_ad": "Through an advertisement",
  "modal.finishCreatingAccount.tv_show": "During a report / TV show",
  "modal.genericError.desc": "The platform might be down or there might be a temporary glitch on our side, so please try again.<br><br>We track these errors automatically, but if the problem persists feel free to contact us at:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! something went wrong",
  "modal.noEmailRecieved.desc": "<b>Didn’t receive an email?</b>Check your spam folder and the spelling of your email before requesting another verification email.",
  "modal.noEmailRecieved.error": "Something went wrong, please try again later",
  "modal.verifyEmail.emailResent.toast": "We've sent you a new verification email.",
  "signin-modal.apple.button": "Connect with Apple",
  "signin-modal.button": "Sign in",
  "signin-modal.email.button": "Sign in",
  "signin-modal.error.content": "An error occured",
  "signin-modal.error.email_no_verified.content": "Email not verified",
  "signin-modal.error.email_no_verified.title": "Error",
  "signin-modal.error.title": "Error",
  "signin-modal.facebook.button": "Connect with Facebook",
  "signin-modal.no-account": "Don't have an account yet?",
  "signin-modal.reset-password": "Reset password",
  "signin-modal.title": "Sign in ",
  "signin.modal.reset-password": "Reset password",
  "signup-modal.accept-cgu": "By creating an account, I accept the",
  "signup-modal.apple.button": "Sign in with Apple",
  "signup-modal.button": "Sign up",
  "signup-modal.cgu.link": "General Terms of Use",
  "signup-modal.description": "Discover a new way of traveling with HomeExchange: Be welcomed all over the world and save money!",
  "signup-modal.email.button": "Sign up with your email address",
  "signup-modal.email.form.submit": "Sign up",
  "signup-modal.error.content": "An error occured",
  "signup-modal.error.title": "Error",
  "signup-modal.facebook.button": "Sign up with Facebook",
  "signup-modal.have-an-account": "Already have an account?"
}, fQ = "Studio", gQ = "{{count}} bedroom", bQ = "{{count}} bedrooms", vQ = "", yQ = "{{count}} bed", _Q = "{{count}} beds", wQ = "Your calendar has been updated.", kQ = "A month", xQ = "Exact dates", $Q = "One week", SQ = "One weekend", CQ = "", EQ = "± {{count}} day", AQ = "± {{count}} days", OQ = "Two weeks", zQ = "Cancel", NQ = "Dates", jQ = "Delete", RQ = "Description", IQ = "Destination", TQ = "Done!", PQ = "Edit", DQ = "Filters", LQ = "Fixed dates", MQ = "Flexible dates", FQ = "Guests", WQ = "homes", BQ = "Last minute", VQ = "Location", UQ = "Modify", qQ = "Name", HQ = "Next", KQ = "", GQ = "{{count}} adult", ZQ = "{{count}} adults", JQ = "", YQ = "{{count}} baby", XQ = "{{count}} babies", QQ = "", eee = "{{count}} child", tee = "{{count}} children", nee = "{{count}} guest", oee = "{{count}} guest", aee = "{{count}} guests", ree = "The phone number format is not valid", iee = "Receive email alerts", see = "Save", lee = "No locations found", cee = "Travel wishlist", uee = "No result", dee = "optional", hee = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: fQ,
  bedroomsNumbers_one: gQ,
  bedroomsNumbers_other: bQ,
  beds_zero: vQ,
  beds_one: yQ,
  beds_other: _Q,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_calendarUpdated_toast: wQ,
  global_calendar_aMonth: kQ,
  global_calendar_exactDates: xQ,
  global_calendar_oneWeek: $Q,
  global_calendar_oneWeekend: SQ,
  global_calendar_plusMinusDay_zero: CQ,
  global_calendar_plusMinusDay_one: EQ,
  global_calendar_plusMinusDay_other: AQ,
  global_calendar_twoWeeks: OQ,
  global_cancel: zQ,
  global_dates: NQ,
  global_delete: jQ,
  global_description: RQ,
  global_destination: IQ,
  global_done: TQ,
  global_edit: PQ,
  global_filters: DQ,
  global_fixDates: LQ,
  global_flexibleDates: MQ,
  global_guests: FQ,
  global_homes: WQ,
  global_lastMinute: BQ,
  global_location: VQ,
  global_modify: UQ,
  global_name: qQ,
  global_next: HQ,
  global_numberOfAdults_zero: KQ,
  global_numberOfAdults_one: GQ,
  global_numberOfAdults_other: ZQ,
  global_numberOfBabies_zero: JQ,
  global_numberOfBabies_one: YQ,
  global_numberOfBabies_other: XQ,
  global_numberOfChildren_zero: QQ,
  global_numberOfChildren_one: eee,
  global_numberOfChildren_other: tee,
  global_numberOfGuests_zero: nee,
  global_numberOfGuests_one: oee,
  global_numberOfGuests_other: aee,
  global_phoneNumber_notValid: ree,
  global_receiveEmailAlerts: iee,
  global_save: see,
  global_searchBar_noLocationFound: lee,
  global_travelWishlist: cee,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: uee,
  optional: dee,
  "privacy-policy": "Privacy Policy"
}, pee = "https://www.homeexchange.com/blog/", mee = "/p/general-terms-of-use", fee = "https://www.homeexchange.com/p/community", gee = "https://homeexchangehelp.zendesk.com/hc/en-us", bee = "https://forum.homeexchange.com/c/english/20", vee = "https://www.homeexchange.com/p/service-homeexchange-en", yee = "https://www.homeexchange.com/p/guestpoints-en", _ee = "https://www.homeexchange.com/p/press", wee = "https://www.homeexchange.com/p/words-of-homeexchanges", kee = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", xee = "https://www.homeexchange.com/p/where-the-welcome-really-begins", $ee = "https://www.homeexchange.com/p/where-the-welcome-really-begins", See = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: pee,
  cgu: mee,
  community: fee,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: gee,
  forum: bee,
  guarantees: vee,
  guestpoints: yee,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: _ee,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: wee,
  travelWishlist_faq_links: kee,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: xee,
  values: $ee
}, Cee = "First name", Eee = "Last name", Aee = "Add to your travel wishlist", Oee = "An updated travel wishlist will enable you to receive more reciprocal exchange requests.", zee = "Are you sure you want to delete {{fullAddress}}?", Nee = "These are the filters you've selected. If you've changed your mind, you can delete some of them below. But if you'd like to add additional ones, you'll need to start a new search (though this will change soon... stay tuned)!", jee = "This could be a country, city or a whole region. If you pick a broad location, your results might be less accurate.", Ree = "Type a country, city, or region", Iee = "View available homes", Tee = "When homes with availability match your travel plans.", Pee = "Add to your travel wishlist", Dee = "{{fullAddress}} has been deleted from your travel wishlist.", Lee = "Select your ideal travel dates (flexible or fixed).", Mee = "Add details to help others using the reverse search feature see why you’re interested in their location.", Fee = "Specify how many people will be traveling with you for this trip.", Wee = "Oops! {{fullAddress}} couldn't be saved to your travel wishlist for an unexpected reason.%", Bee = "Let us know when and where you'd like to travel to receive exchange requests and alerts as soon as suitable homes become available. We'll save your searches to your travel wishlist!", Vee = "Any travel adventures you'd like to start planning?", Uee = "<updateDates>Update your dates</updateDates> to keep receiving relevant email alerts or <delete>delete this destination</delete> from your travel wishlist if you're no longer considering it.", qee = "These dates are in the past", Hee = "{{fullAddress}} has been added to your travel wishlist!", Kee = "{{fullAddress}} has been successfully updated.", Gee = "Your search has been saved, and your calendar has been updated!", Zee = "Your search has been saved. Find it in your travel wishlist.", Jee = "Learn more about travel wishlists", Yee = {
  firstname: Cee,
  lastname: Eee,
  modal_travelWishlist_addNew_title: Aee,
  modal_travelWishlist_delete_body: Oee,
  modal_travelWishlist_delete_title: zee,
  modal_travelWishlist_filtersApplied_helper: Nee,
  modal_travelWishlist_location_helper: jee,
  modal_travelWishlist_searchBar_placeholder: Ree,
  page_travelWishlist_card_cta: Iee,
  page_travelWishlist_card_emailAlerts_helper: Tee,
  page_travelWishlist_cta: Pee,
  page_travelWishlist_deleted_toast: Dee,
  page_travelWishlist_edit_dates_helper: Lee,
  page_travelWishlist_edit_description_helper: Mee,
  page_travelWishlist_edit_guests_helper: Fee,
  page_travelWishlist_error_toast: Wee,
  page_travelWishlist_none_body: Bee,
  page_travelWishlist_none_subheader: Vee,
  page_travelWishlist_pastDates_desc: Uee,
  page_travelWishlist_pastDates_title: qee,
  page_travelWishlist_saved_toast: Hee,
  page_travelWishlist_updated_toast: Kee,
  search_travelWishlist_calendarUpdated_toast: Gee,
  search_travelWishlist_saved_toast: Zee,
  travelWishlist_faq: Jee
}, Xee = {
  "modal.emailVerif.alreadyVerified.desc": "¡Tu correo electrónico está listo! Inicia sesión para continuar.",
  "modal.emailVerif.alreadyVerified.title": "Tu dirección de correo ya está verificada",
  "modal.emailVerif.callout": "Te hemos enviado un correo de verificación.",
  "modal.emailVerif.desc": "Hemos enviado un correo de verificación a <b>{{email}}</b>.<br/>Comprueba tu bandeja de entrada. El enlace del correo electrónico caduca en 24 horas.",
  "modal.emailVerif.linkExpired.desc": "Inicia sesión para recibir un nuevo enlace de verificación en tu bandeja de entrada.",
  "modal.emailVerif.linkExpired.title": "Este enlace ha caducado",
  "modal.emailVerif.resend-email-link": "Reenviar correo de verificación",
  "modal.emailVerif.resend-link": "Reenviar correo de verificación",
  "modal.emailVerif.title": "Verifica tu dirección de correo electrónico",
  "modal.finishCreatingAccount.event": "En un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Todo el mundo conoce HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Introduce tu nombre.",
  "modal.finishCreatingAccount.friends_family": "Por amigos, familiares o conocidos",
  "modal.finishCreatingAccount.hearAboutHE": "¿Cómo has descubierto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Introduce tus apellidos.",
  "modal.finishCreatingAccount.other": "Otros",
  "modal.finishCreatingAccount.phone_number": "Número de teléfono",
  "modal.finishCreatingAccount.phone_number.error": "Introduce tu número de teléfono",
  "modal.finishCreatingAccount.pleaseSpecify": "Por favor, especifica",
  "modal.finishCreatingAccount.press": "Por la prensa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Medios impresos",
  "modal.finishCreatingAccount.radio": "Por la radio",
  "modal.finishCreatingAccount.referral": "Código de invitación",
  "modal.finishCreatingAccount.referralCode.error": "Este código de invitación no es válido.",
  "modal.finishCreatingAccount.search_engine": "En un motor de búsqueda",
  "modal.finishCreatingAccount.social_media": "Por las redes sociales",
  "modal.finishCreatingAccount.social_network_other": "Otra red social (especifica cuál)",
  "modal.finishCreatingAccount.title": "Termina de crear tu cuenta",
  "modal.finishCreatingAccount.tv": "En la televisión",
  "modal.finishCreatingAccount.tv_ad": "En un anuncio",
  "modal.finishCreatingAccount.tv_show": "En un reportaje/programa de televisión",
  "modal.genericError.desc": "Es posible que la plataforma esté fuera de servicio o que estemos experimentando un problema técnico temporal, así que vuelve a intentarlo.<br><br>Llevamos un seguimiento automático de estos errores, pero si el problema persiste, no dudes en ponerte en contacto con nosotros en:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "¡Vaya! Algo salió mal...",
  "modal.noEmailRecieved.desc": "<b>¿No has recibido el correo electrónico?</b>Comprueba tu carpeta de spam y asegúrate de que tu dirección esté bien escrita antes de solicitar otro correo de verificación.",
  "modal.noEmailRecieved.error": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
  "modal.verifyEmail.emailResent.toast": "Te hemos enviado un nuevo correo de verificación.",
  "signin-modal.apple.button": "Inicia sesión con Apple",
  "signin-modal.button": "Inicia sesión",
  "signin-modal.email.button": "Inicia sesión",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Inicia sesión con Facebook",
  "signin-modal.no-account": "¿Aún no tienes una cuenta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Restablecer la contraseña",
  "signup-modal.accept-cgu": "Al crear una cuenta acepto las",
  "signup-modal.apple.button": "Inicia sesión con Apple",
  "signup-modal.button": "Regístrate",
  "signup-modal.cgu.link": "Condiciones Generales de Uso",
  "signup-modal.description": "Descubre otra forma de viajar con el intercambio de casas: ¡siéntete bienvenido/a en todo el mundo y ahorra en alojamiento!",
  "signup-modal.email.button": "Regístrate con tu correo electrónico",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Regístrate con Facebook",
  "signup-modal.have-an-account": "¿Ya tienes una cuenta?"
}, Qee = "Estudio", ete = "{{count}} dormitorio", tte = "{{count}} dormitorios", nte = "", ote = "{{count}} cama", ate = "{{count}} camas", rte = "Tu calendario ha sido actualizado.", ite = "Un mes", ste = "Fechas exactas", lte = "Una semana", cte = "Un fin de semana", ute = "", dte = "± 1:{{count}} día", hte = "± 1:{{count}} días", pte = "Dos semanas", mte = "Cancelar", fte = "Fechas", gte = "Eliminar", bte = "Descripción", vte = "Destino", yte = "¡Listo!", _te = "Editar", wte = "Filtros", kte = "Fechas fijas", xte = "Fechas flexibles", $te = "Invitados", Ste = "casas", Cte = "Último minuto", Ete = "Ubicación", Ate = "Modificar", Ote = "Nombre", zte = "Siguiente", Nte = "", jte = "{{count}} adulto", Rte = "{{count}} adultos", Ite = "", Tte = "{{count}} bebé", Pte = "bebé", Dte = "", Lte = "{{count}} niño/a", Mte = "{{count}} niños", Fte = "", Wte = "{{count}} invitado/a", Bte = "{{count}} invitados", Vte = "El formato del número de teléfono no es válido.", Ute = "Recibir notificaciones por correo electrónico", qte = "Guardar", Hte = "No encontramos este lugar", Kte = "Proyectos de viaje", Gte = "", Zte = "opcional", Jte = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: Qee,
  bedroomsNumbers_one: ete,
  bedroomsNumbers_other: tte,
  beds_zero: nte,
  beds_one: ote,
  beds_other: ate,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_calendarUpdated_toast: rte,
  global_calendar_aMonth: ite,
  global_calendar_exactDates: ste,
  global_calendar_oneWeek: lte,
  global_calendar_oneWeekend: cte,
  global_calendar_plusMinusDay_zero: ute,
  global_calendar_plusMinusDay_one: dte,
  global_calendar_plusMinusDay_other: hte,
  global_calendar_twoWeeks: pte,
  global_cancel: mte,
  global_dates: fte,
  global_delete: gte,
  global_description: bte,
  global_destination: vte,
  global_done: yte,
  global_edit: _te,
  global_filters: wte,
  global_fixDates: kte,
  global_flexibleDates: xte,
  global_guests: $te,
  global_homes: Ste,
  global_lastMinute: Cte,
  global_location: Ete,
  global_modify: Ate,
  global_name: Ote,
  global_next: zte,
  global_numberOfAdults_zero: Nte,
  global_numberOfAdults_one: jte,
  global_numberOfAdults_other: Rte,
  global_numberOfBabies_zero: Ite,
  global_numberOfBabies_one: Tte,
  global_numberOfBabies_other: Pte,
  global_numberOfChildren_zero: Dte,
  global_numberOfChildren_one: Lte,
  global_numberOfChildren_other: Mte,
  global_numberOfGuests_zero: Fte,
  global_numberOfGuests_one: Wte,
  global_numberOfGuests_other: Bte,
  global_phoneNumber_notValid: Vte,
  global_receiveEmailAlerts: Ute,
  global_save: qte,
  global_searchBar_noLocationFound: Hte,
  global_travelWishlist: Kte,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Gte,
  optional: Zte,
  "privacy-policy": "Política de Privacidad"
}, Yte = "https://www.homeexchange.com/es/blog/", Xte = "/es/p/homeexchange-condiciones-de-uso", Qte = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", ene = "https://homeexchangehelp.zendesk.com/hc/es", tne = "https://forum.homeexchange.com/c/espanol/22", nne = "https://www.homeexchange.com/es/p/service-homeexchange-es", one = "https://www.homeexchange.com/es/p/los-guestpoints", ane = "https://www.homeexchange.com/es/p/prensa", rne = "https://www.homeexchange.com/p/palabra-de-homeexchanger", ine = "", sne = "https://www.homeexchange.com/es/p/principios-intercambio-casa", lne = "https://www.homeexchange.com/es/p/principios-intercambio-casa", cne = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: Yte,
  cgu: Xte,
  community: Qte,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: ene,
  forum: tne,
  guarantees: nne,
  guestpoints: one,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: ane,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: rne,
  travelWishlist_faq_links: ine,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: sne,
  values: lne
}, une = "", dne = "", hne = "Añadir a tus proyectos de viaje", pne = "Tener tus proyectos de viaje actualizados te permitirá recibir más solicitudes de intercambio recíproco.", mne = "¿Seguro que quieres eliminar {{fullAddress}}?", fne = "Estos son los filtros que has seleccionado. Si has cambiado de opinión, puedes eliminar algunos de ellos a continuación. Pero si quieres añadir otros, tendrás que iniciar una nueva búsqueda (aunque esto cambiará pronto... ¡tendrás noticias!)", gne = "Puede ser un país, una ciudad o una región entera. Si eliges una ubicación general, los resultados pueden ser menos precisos.", bne = "Introduce un país, ciudad o región", vne = "Ver casas disponibles", yne = "Cuando haya casas disponibles que coincidan con tus proyectos de viaje.", _ne = "Añadir a tus proyectos de viaje", wne = "{{fullAddress}} se ha eliminado de tus proyectos de viaje.", kne = "Selecciona tus fechas ideales de viaje (flexibles o fijas).", xne = "Añade detalles para ayudar a otras personas que utilicen la función de búsqueda inversa a entender por qué te interesa su región.", $ne = "Especifica cuántas personas viajarán contigo.", Sne = "¡Vaya! {{fullAddress}} no se ha guardado en tus proyectos de viaje por un motivo desconocido.%", Cne = "Indícanos cuándo y dónde te gustaría viajar para recibir solicitudes de intercambio y notificaciones cuando haya casas disponibles. Guardaremos tus búsquedas en tus proyectos de viaje.", Ene = "¿Te apetece empezar a planear alguna aventura?", Ane = "<updateDates>Actualiza la fecha</updateDates> para seguir recibiendo notificaciones por correo electrónico o <delete>elimina este destino</delete>  de tus proyectos de viaje si ya no lo tienes en mente.", One = "Esta fecha ya ha pasado", zne = "{{fullAddress}} se ha añadido a tus proyectos de viaje", Nne = "{{fullAddress}} se ha actualizado correctamente.", jne = "¡Tu búsqueda se ha guardado y tu calendario se ha actualizado!", Rne = "Tu búsqueda se ha guardado. Podrás verla en tus proyectos de viaje.", Ine = "Saber más sobre los proyectos de viaje", Tne = {
  firstname: une,
  lastname: dne,
  modal_travelWishlist_addNew_title: hne,
  modal_travelWishlist_delete_body: pne,
  modal_travelWishlist_delete_title: mne,
  modal_travelWishlist_filtersApplied_helper: fne,
  modal_travelWishlist_location_helper: gne,
  modal_travelWishlist_searchBar_placeholder: bne,
  page_travelWishlist_card_cta: vne,
  page_travelWishlist_card_emailAlerts_helper: yne,
  page_travelWishlist_cta: _ne,
  page_travelWishlist_deleted_toast: wne,
  page_travelWishlist_edit_dates_helper: kne,
  page_travelWishlist_edit_description_helper: xne,
  page_travelWishlist_edit_guests_helper: $ne,
  page_travelWishlist_error_toast: Sne,
  page_travelWishlist_none_body: Cne,
  page_travelWishlist_none_subheader: Ene,
  page_travelWishlist_pastDates_desc: Ane,
  page_travelWishlist_pastDates_title: One,
  page_travelWishlist_saved_toast: zne,
  page_travelWishlist_updated_toast: Nne,
  search_travelWishlist_calendarUpdated_toast: jne,
  search_travelWishlist_saved_toast: Rne,
  travelWishlist_faq: Ine
}, Pne = {
  "modal.emailVerif.alreadyVerified.desc": "C'est tout bon ! Connectez-vous pour continuer.",
  "modal.emailVerif.alreadyVerified.title": "Votre adresse email a déjà été vérifiée",
  "modal.emailVerif.callout": "Un email de vérification a été envoyé.",
  "modal.emailVerif.desc": "Consultez votre boîte de réception : nous avons envoyé un email de vérification à l'adresse <b>{{email}}</b>. <br/> Le lien inclus dans cet email expirera au bout de 24 heures.",
  "modal.emailVerif.linkExpired.desc": "Connectez-vous pour recevoir un nouveau lien de vérification dans votre boîte de réception.",
  "modal.emailVerif.linkExpired.title": "Ce lien a expiré",
  "modal.emailVerif.resend-email-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.resend-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.title": "Confirmez votre adresse email",
  "modal.finishCreatingAccount.event": "Lors d'un événement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tout le monde connaît HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Merci de saisir votre prénom",
  "modal.finishCreatingAccount.friends_family": "Par l'intermédiaire de proches",
  "modal.finishCreatingAccount.hearAboutHE": "Comment avez-vous entendu parler de HomeExchange ?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Merci de saisir votre nom de famille",
  "modal.finishCreatingAccount.other": "Autre",
  "modal.finishCreatingAccount.phone_number": "Téléphone",
  "modal.finishCreatingAccount.phone_number.error": "Merci de renseigner votre numéro de téléphone",
  "modal.finishCreatingAccount.pleaseSpecify": "Merci de préciser",
  "modal.finishCreatingAccount.press": "Dans la presse",
  "modal.finishCreatingAccount.press_online": "En ligne",
  "modal.finishCreatingAccount.press_print": "Écrite",
  "modal.finishCreatingAccount.radio": "À la radio",
  "modal.finishCreatingAccount.referral": "Code de parrainage",
  "modal.finishCreatingAccount.referralCode.error": "Ce code de parrainage n'est pas valide",
  "modal.finishCreatingAccount.search_engine": "Sur un moteur de recherche",
  "modal.finishCreatingAccount.social_media": "Sur les réseaux sociaux",
  "modal.finishCreatingAccount.social_network_other": "Autre réseau social (merci de préciser)",
  "modal.finishCreatingAccount.title": "Terminez la création de votre compte",
  "modal.finishCreatingAccount.tv": "À la télévision",
  "modal.finishCreatingAccount.tv_ad": "Dans une publicité",
  "modal.finishCreatingAccount.tv_show": "Dans un reportage/une émission TV",
  "modal.genericError.desc": "Notre plateforme pourrait être indisponible ou victime d'une panne temporaire, il va vous falloir réessayer.<br><br> Nous détectons ces erreurs automatiquement, mais n'hésitez pas à nous contacter à l'adresse suivante si le problème persiste :<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oups ! Une erreur est survenue",
  "modal.noEmailRecieved.desc": "<b>Vous n'avez pas reçu d'email ?</b> Vérifiez vos spams et l'orthographe de votre adresse email avant de demander l'envoi d'un nouvel email de vérification.",
  "modal.noEmailRecieved.error": "Une erreur est survenue, réessayez plus tard",
  "modal.verifyEmail.emailResent.toast": "Nous vous avons envoyé un nouvel email de vérification.",
  "signin-modal.apple.button": "Se connecter avec Google",
  "signin-modal.button": "Se connecter",
  "signin-modal.email.button": "Se connecter",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Se connecter avec Facebook",
  "signin-modal.no-account": "Pas encore de compte ?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Réinitialiser le mot de passe",
  "signup-modal.accept-cgu": "En créant un compte, j’accepte les",
  "signup-modal.apple.button": "Se connecter avec Apple",
  "signup-modal.button": "S'inscrire",
  "signup-modal.cgu.link": "Conditions Générales d’Utilisation",
  "signup-modal.description": "Découvrez une autre manière de voyager avec l’échange de maison : soyez accueilli(e) partout dans le monde et faites des économies !",
  "signup-modal.email.button": "S’inscrire avec votre adresse email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "S’inscrire avec Facebook",
  "signup-modal.have-an-account": "Vous avez déjà un compte ?"
}, Dne = "Studio", Lne = "{{count}} chambre", Mne = "{{count}} chambres", Fne = "", Wne = "{{count}} lit", Bne = "{{count}} lits", Vne = "Votre calendrier a été mis à jour.", Une = "Un mois", qne = "Dates exactes", Hne = "Une semaine", Kne = "Un week-end", Gne = "Vide", Zne = "± {{count}} jour", Jne = "± {{count}} jours", Yne = "Deux semaines", Xne = "Annuler", Qne = "Dates", eoe = "Supprimer", toe = "Description", noe = "Destination", ooe = "C'est prêt !", aoe = "Modifier", roe = "Filtres", ioe = "Dates fixes", soe = "Dates flexibles", loe = "Personnes", coe = "maisons", uoe = "Dernière minute", doe = "Lieu", hoe = "Modifier", poe = "Titre", moe = "Suivant", foe = "Vide", goe = "{{count}} adulte", boe = "{{count}} adultes", voe = "Vide", yoe = "{{count}} bébé", _oe = "{{count}} bébés", woe = "Vide", koe = "{{count}} enfant", xoe = "{{count}} enfants", $oe = "{{count}} invité·e", Soe = "{{count}} invité·e", Coe = "{{count}} invité·es", Eoe = "Le format du numéro de téléphone est invalide.", Aoe = "Recevoir des alertes par email", Ooe = "Sauvegarder", zoe = "Aucun lieu trouvé", Noe = "Projets de voyage", joe = "", Roe = "facultatif", Ioe = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: Dne,
  bedroomsNumbers_one: Lne,
  bedroomsNumbers_other: Mne,
  beds_zero: Fne,
  beds_one: Wne,
  beds_other: Bne,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_calendarUpdated_toast: Vne,
  global_calendar_aMonth: Une,
  global_calendar_exactDates: qne,
  global_calendar_oneWeek: Hne,
  global_calendar_oneWeekend: Kne,
  global_calendar_plusMinusDay_zero: Gne,
  global_calendar_plusMinusDay_one: Zne,
  global_calendar_plusMinusDay_other: Jne,
  global_calendar_twoWeeks: Yne,
  global_cancel: Xne,
  global_dates: Qne,
  global_delete: eoe,
  global_description: toe,
  global_destination: noe,
  global_done: ooe,
  global_edit: aoe,
  global_filters: roe,
  global_fixDates: ioe,
  global_flexibleDates: soe,
  global_guests: loe,
  global_homes: coe,
  global_lastMinute: uoe,
  global_location: doe,
  global_modify: hoe,
  global_name: poe,
  global_next: moe,
  global_numberOfAdults_zero: foe,
  global_numberOfAdults_one: goe,
  global_numberOfAdults_other: boe,
  global_numberOfBabies_zero: voe,
  global_numberOfBabies_one: yoe,
  global_numberOfBabies_other: _oe,
  global_numberOfChildren_zero: woe,
  global_numberOfChildren_one: koe,
  global_numberOfChildren_other: xoe,
  global_numberOfGuests_zero: $oe,
  global_numberOfGuests_one: Soe,
  global_numberOfGuests_other: Coe,
  global_phoneNumber_notValid: Eoe,
  global_receiveEmailAlerts: Aoe,
  global_save: Ooe,
  global_searchBar_noLocationFound: zoe,
  global_travelWishlist: Noe,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: joe,
  optional: Roe,
  "privacy-policy": "Charte de vie privée"
}, Toe = "https://www.homeexchange.fr/blog/", Poe = "/p/conditions-generale-d-utilisation", Doe = "https://www.homeexchange.fr/p/communaute", Loe = "https://homeexchangehelp.zendesk.com/hc/fr", Moe = "https://forum.homeexchange.com/c/francais/21", Foe = "https://www.homeexchange.fr/p/service-homeexchange-fr", Woe = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", Boe = "https://www.homeexchange.fr/p/presse", Voe = "https://www.homeexchange.com/p/paroles-homeexchangers", Uoe = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", qoe = "https://www.homeexchange.fr/p/les-fondamentaux ", Hoe = "https://www.homeexchange.fr/p/les-fondamentaux", Koe = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: Toe,
  cgu: Poe,
  community: Doe,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: Loe,
  forum: Moe,
  guarantees: Foe,
  guestpoints: Woe,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: Boe,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: Voe,
  travelWishlist_faq_links: Uoe,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: qoe,
  values: Hoe
}, Goe = "Prénom", Zoe = "Nom", Joe = "Ajouter un projet de voyage", Yoe = "Garder vos projets de voyage à jour vous permet de recevoir davantage de demandes d'échange réciproques.", Xoe = "Voulez-vous vraiment supprimer {{fullAddress}} ?", Qoe = "Ce sont les filtres que vous avez sélectionnés lors de votre recherche enregistrée : vous pouvez en supprimer mais si vous souhaitez en ajouter, vous devrez lancer une nouvelle recherche (mais plus pour très longtemps... on vous tiendra au courant !).", eae = "Vous pouvez indiquer un pays, région ou une ville ou une région. Si vous visez large, les résultats seront peut-être moins précis.", tae = "Entrez un pays, une ville ou une région", nae = "Voir les maisons disponibles", oae = "Lorsque des logements correspondant à vos critères ont de nouvelles disponibilités", aae = "Ajouter un projet de voyage", rae = "Nous avons bien supprimé {{fullAddress}} de vos projets de voyage.", iae = "Indiquez vos dates de voyage estimées (qu'elles soient flexibles ou fixes).", sae = "Ajoutez des détails pour aider les membres utilisant la recherche inversée à savoir ce qui vous intéresse dans leur région.", lae = "Indiquez combien de personnes voyageront avec vous cette fois-ci.", cae = "Oups ! Pour une raison inattendue, nous n'avons pas pu ajouter {{fullAddress}} à vos projets de voyage.", uae = "Indiquez où et quand vous aimeriez partir pour recevoir des demandes d'échange adaptées ainsi que des alertes dès que des logements correspondent à vos critères. Chaque recherche sera enregistrée dans vos projets de voyage.", dae = "Des envies de voyage en tête ?", hae = "<updateDates>Mettez à jour vos dates</updateDates> pour continuer à recevoir des alertes par email pertinentes ou <delete>supprimez cette destination</delete> de vos projets de voyage si elle n'est plus d'actualité.", pae = "Ces dates sont passées", mae = "Nous avons bien ajouté {{fullAddress}} à vos projets de voyage.", fae = "Nous avons bien mis à jour les informations pour {{fullAddress}}", gae = "Votre recherche a bien été enregistrée et votre calendrier a été mis à jour.", bae = "Votre recherche a bien été enregistrée. Retrouvez-la dans vos projets de voyage.", vae = "En savoir plus sur les projets de voyage", yae = {
  firstname: Goe,
  lastname: Zoe,
  modal_travelWishlist_addNew_title: Joe,
  modal_travelWishlist_delete_body: Yoe,
  modal_travelWishlist_delete_title: Xoe,
  modal_travelWishlist_filtersApplied_helper: Qoe,
  modal_travelWishlist_location_helper: eae,
  modal_travelWishlist_searchBar_placeholder: tae,
  page_travelWishlist_card_cta: nae,
  page_travelWishlist_card_emailAlerts_helper: oae,
  page_travelWishlist_cta: aae,
  page_travelWishlist_deleted_toast: rae,
  page_travelWishlist_edit_dates_helper: iae,
  page_travelWishlist_edit_description_helper: sae,
  page_travelWishlist_edit_guests_helper: lae,
  page_travelWishlist_error_toast: cae,
  page_travelWishlist_none_body: uae,
  page_travelWishlist_none_subheader: dae,
  page_travelWishlist_pastDates_desc: hae,
  page_travelWishlist_pastDates_title: pae,
  page_travelWishlist_saved_toast: mae,
  page_travelWishlist_updated_toast: fae,
  search_travelWishlist_calendarUpdated_toast: gae,
  search_travelWishlist_saved_toast: bae,
  travelWishlist_faq: vae
}, _ae = {
  "modal.emailVerif.alreadyVerified.desc": "Vaša adresa e-pošte je spremna! Prijavite se kako biste nastavili.",
  "modal.emailVerif.alreadyVerified.title": "Ova adresa e-pošte je već potvrđena",
  "modal.emailVerif.callout": "E-poruka s potvrdom je poslana.",
  "modal.emailVerif.desc": "Poslali smo e-poruku s potvrdom na <b>{{email}}</b>.<br/>Provjerite svoju dolaznu poštu. Poveznica u ovoj poruci će isteći u roku od 24 sata.",
  "modal.emailVerif.linkExpired.desc": "Ako želite dobiti novu poveznicu s potvrdom, morate se prijaviti.",
  "modal.emailVerif.linkExpired.title": "Ova je poveznica istekla",
  "modal.emailVerif.resend-email-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.resend-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.title": "Potvrdite adresu e-pošte",
  "modal.finishCreatingAccount.event": "na nekom događaju",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "svi znaju za HomeExchange",
  "modal.finishCreatingAccount.facebook": "na Facebooku",
  "modal.finishCreatingAccount.firstName.error": "Upišite svoje ime",
  "modal.finishCreatingAccount.friends_family": "preko obitelji, prijatelja ili poznanika",
  "modal.finishCreatingAccount.hearAboutHE": "Kako ste čuli za HomeExchange?",
  "modal.finishCreatingAccount.instagram": "na Instagramu",
  "modal.finishCreatingAccount.lastName.error": "Upišite svoje prezime",
  "modal.finishCreatingAccount.other": "ostalo",
  "modal.finishCreatingAccount.phone_number": "Broj telefona",
  "modal.finishCreatingAccount.phone_number.error": "Molimo unesite svoj broj telefona",
  "modal.finishCreatingAccount.pleaseSpecify": "napišite konkretnije",
  "modal.finishCreatingAccount.press": "u novinama",
  "modal.finishCreatingAccount.press_online": "na internetu",
  "modal.finishCreatingAccount.press_print": "u tiskanim medijima",
  "modal.finishCreatingAccount.radio": "na radiju",
  "modal.finishCreatingAccount.referral": "Kod za preporuku",
  "modal.finishCreatingAccount.referralCode.error": "Ovaj kod za preporuku nije valjan",
  "modal.finishCreatingAccount.search_engine": "u tražilici",
  "modal.finishCreatingAccount.social_media": "na društvenim mrežama",
  "modal.finishCreatingAccount.social_network_other": "na drugoj društvenoj mreži (napišite kojoj)",
  "modal.finishCreatingAccount.title": "Dovršite izradu svojeg računa",
  "modal.finishCreatingAccount.tv": "na televiziji",
  "modal.finishCreatingAccount.tv_ad": "u reklami",
  "modal.finishCreatingAccount.tv_show": "u nekoj reportaži/TV emisiji",
  "modal.genericError.desc": "Platforma možda trenutačno nije dostupna ili možda imamo nekih problema, zbog čega Vas molimo da pokušate ponovno.<br><br>Automatski pratimo ove greške, ali ako i dalje budete nailazili na problem, slobodno nam se javite na:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Ajoj! Nešto nije u redu",
  "modal.noEmailRecieved.desc": "<b>Niste primili e-poruku?</b>Provjerite svoj pretinac neželjene pošte i jeste li točno upisali svoju adresu e-pošte prije nego što zatražite još jednu e-poruku s potvrdom.",
  "modal.noEmailRecieved.error": "Nešto nije u redu, pokušajte ponovno kasnije",
  "modal.verifyEmail.emailResent.toast": "Poslali smo Vam novu e-poruku s potvrdom.",
  "signin-modal.apple.button": "Prijavite se s Apple ID-om",
  "signin-modal.button": "Prijavite se",
  "signin-modal.email.button": "Prijavite se",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Prijavite se putem Facebooka",
  "signin-modal.no-account": "Još nemate račun?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Resetirajte lozinku",
  "signup-modal.accept-cgu": "Izradom računa, prihvaćam",
  "signup-modal.apple.button": "Prijavite se s Apple ID-om",
  "signup-modal.button": "Registrirajte se",
  "signup-modal.cgu.link": "Opće Uvjete korištenja",
  "signup-modal.description": "Otkrijte novi način putovanja sa zamjenom domova: odsjedajte svugdje po svijetu i uštedite novac!",
  "signup-modal.email.button": "Registrirajte se sa Vašom email adresom",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrirajte se putem Facebooka",
  "signup-modal.have-an-account": "Već imate račun?"
}, wae = "Studio", kae = "{{count}} soba", xae = "{{count}} sobe", $ae = "{{count}} sobe", Sae = "", Cae = "{{count}} krevet", Eae = "{{count}} kreveti", Aae = "{{count}} kreveti", Oae = "Vaš je kalendar ažuriran.", zae = "Mjesec", Nae = "Točni datumi", jae = "Jedan tjedan", Rae = "Jedan vikend", Iae = "dana", Tae = "dan", Pae = "dana", Dae = "± {{count}} dan", Lae = "Dva tjedna", Mae = "Odustani", Fae = "Datumi", Wae = "Izbrišite", Bae = "Opis", Vae = "Odredište", Uae = "Gotovo!", qae = "Uredite", Hae = "Filtri", Kae = "Fiksni datumi", Gae = "Fleksibilni datumi", Zae = "Gosti", Jae = "domova", Yae = "U zadnji tren", Xae = "Lokacija", Qae = "Uredi", ere = "", tre = "Dalje", nre = "odraslih osoba", ore = "odrasla osoba", are = "odrasle osobe", rre = "odraslih osoba", ire = "beba", sre = "beba", lre = "bebe", cre = "beba", ure = "djece", dre = "dijete", hre = "djeteta", pre = "djece", mre = "gostiju", fre = "gost", gre = "gosta", bre = "gostiju", vre = "Format telefonskog broja nije valjan.", yre = "Primajte obavijesti e-poštom", _re = "Spremi", wre = "Nema pronađenih lokacija", kre = "Planovi putovanja", xre = "", $re = "nije obavezno", Sre = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: wae,
  bedroomsNumbers_one: kae,
  bedroomsNumbers_few: xae,
  bedroomsNumbers_other: $ae,
  beds_zero: Sae,
  beds_one: Cae,
  beds_few: Eae,
  beds_other: Aae,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_calendarUpdated_toast: Oae,
  global_calendar_aMonth: zae,
  global_calendar_exactDates: Nae,
  global_calendar_oneWeek: jae,
  global_calendar_oneWeekend: Rae,
  global_calendar_plusMinusDay_zero: Iae,
  global_calendar_plusMinusDay_one: Tae,
  global_calendar_plusMinusDay_few: Pae,
  global_calendar_plusMinusDay_other: Dae,
  global_calendar_twoWeeks: Lae,
  global_cancel: Mae,
  global_dates: Fae,
  global_delete: Wae,
  global_description: Bae,
  global_destination: Vae,
  global_done: Uae,
  global_edit: qae,
  global_filters: Hae,
  global_fixDates: Kae,
  global_flexibleDates: Gae,
  global_guests: Zae,
  global_homes: Jae,
  global_lastMinute: Yae,
  global_location: Xae,
  global_modify: Qae,
  global_name: ere,
  global_next: tre,
  global_numberOfAdults_zero: nre,
  global_numberOfAdults_one: ore,
  global_numberOfAdults_few: are,
  global_numberOfAdults_other: rre,
  global_numberOfBabies_zero: ire,
  global_numberOfBabies_one: sre,
  global_numberOfBabies_few: lre,
  global_numberOfBabies_other: cre,
  global_numberOfChildren_zero: ure,
  global_numberOfChildren_one: dre,
  global_numberOfChildren_few: hre,
  global_numberOfChildren_other: pre,
  global_numberOfGuests_zero: mre,
  global_numberOfGuests_one: fre,
  global_numberOfGuests_few: gre,
  global_numberOfGuests_other: bre,
  global_phoneNumber_notValid: vre,
  global_receiveEmailAlerts: yre,
  global_save: _re,
  global_searchBar_noLocationFound: wre,
  global_travelWishlist: kre,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: xre,
  optional: $re,
  "privacy-policy": "Pravila o privatnosti"
}, Cre = "https://www.homeexchange.com/blog/", Ere = "/p/general-terms-of-use", Are = "https://www.homeexchange.com/hr/p/zajednica", Ore = "https://homeexchangehelp.zendesk.com/hc/en-us", zre = "", Nre = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", jre = "https://www.homeexchange.com/hr/p/guestpoints-hr", Rre = "https://www.homeexchange.com/hr/p/press-hr", Ire = "https://www.homeexchange.com/p/rijeci-homeexchange", Tre = "", Pre = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", Dre = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", Lre = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: Cre,
  cgu: Ere,
  community: Are,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Ore,
  forum: zre,
  guarantees: Nre,
  guestpoints: jre,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Rre,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Ire,
  travelWishlist_faq_links: Tre,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Pre,
  values: Dre
}, Mre = "Ime", Fre = "Prezime", Wre = "Dodajte u svoje planove putovanja", Bre = "Ažurirani planovi putovanja će Vam omogućiti da dobivate više zahtjeva za recipročne zamjene.", Vre = "Jeste li sigurni da želite obrisati lokaciju {{fullAddress}}?", Ure = "Ovo su filtri koji ste odabrali. Ako ste se predomislili, možete obrisati neke od njih. Ali ako želite dodati neke druge, morate započeti novo pretraživanje (iako će se ovo uskoro promijeniti... pratite obavijesti)!", qre = "Ovo može biti neka zemlja, grad ili cijela regija. Ako odaberete jako široku lokaciju, Vaši bi rezultati mogli biti manje točni.", Hre = "Upišite zemlju, grad ili regiju", Kre = "Pogledajte dostupne domove", Gre = "Kada domovi s dostupnošću odgovaraju Vašim planovima putovanja.", Zre = "Dodajte u svoje planove putovanja", Jre = "Lokacija {{fullAddress}} je obrisana iz Vaših planova putovanja.", Yre = "Odaberite svoje idealne datume putovanja (fleksibilne ili fiksne).", Xre = "Dodajte detalje kako biste pomogli drugima koji koriste značajku obrnutog pretraživanja da vide zašto Vas zanima njihova lokacija.", Qre = "Navedite koliko će ljudi putovati s Vama na ovom putovanju.", eie = "Ups! Lokacija {{fullAddress}} nije mogla biti spremljena u Vaše planove putovanja zbog neočekivanog razloga.%", tie = "Recite nam kada i kamo biste željeli otputovati kako biste dobivali zahtjeve za zamjene i obavijesti čim odgovarajući domovi postanu dostupni. Spremit ćemo Vaše pretraživanje u Vaše planove putovanja!", nie = "Postoje li neke pustolovine za putovanja koje biste voljeli početi planirati?", oie = "<updateDates>Ažurirajte svoje datume</updateDates> kako biste i dalje dobivali odgovarajuće obavijesti preko e-poruka ili <delete>obrišite ovo odredište</delete> iz svojih planova putovanja ako više ne razmišljate o njemu.", aie = "Ovi datumi su u prošlosti", rie = "Lokacija {{fullAddress}} je dodana u Vaše planove putovanja!", iie = "{{fullAddress}} je uspješno ažurirana.", sie = "Vaše je pretraživanje spremljeno i Vaš je kalendar ažuriran!", lie = "Vaše je pretraživanje spremljeno. Pronađite ga u svojim planovima putovanja.", cie = "Saznajte više o planovima putovanja", uie = {
  firstname: Mre,
  lastname: Fre,
  modal_travelWishlist_addNew_title: Wre,
  modal_travelWishlist_delete_body: Bre,
  modal_travelWishlist_delete_title: Vre,
  modal_travelWishlist_filtersApplied_helper: Ure,
  modal_travelWishlist_location_helper: qre,
  modal_travelWishlist_searchBar_placeholder: Hre,
  page_travelWishlist_card_cta: Kre,
  page_travelWishlist_card_emailAlerts_helper: Gre,
  page_travelWishlist_cta: Zre,
  page_travelWishlist_deleted_toast: Jre,
  page_travelWishlist_edit_dates_helper: Yre,
  page_travelWishlist_edit_description_helper: Xre,
  page_travelWishlist_edit_guests_helper: Qre,
  page_travelWishlist_error_toast: eie,
  page_travelWishlist_none_body: tie,
  page_travelWishlist_none_subheader: nie,
  page_travelWishlist_pastDates_desc: oie,
  page_travelWishlist_pastDates_title: aie,
  page_travelWishlist_saved_toast: rie,
  page_travelWishlist_updated_toast: iie,
  search_travelWishlist_calendarUpdated_toast: sie,
  search_travelWishlist_saved_toast: lie,
  travelWishlist_faq: cie
}, die = {
  "modal.emailVerif.alreadyVerified.desc": "La tua email è pronta! Accedi per continuare.",
  "modal.emailVerif.alreadyVerified.title": "Il tuo indirizzo email è già stato verificato",
  "modal.emailVerif.callout": "Abbiamo inviato un'email di verifica.",
  "modal.emailVerif.desc": "Abbiamo inviato un'email di verifica a <b>{{email}}</b>. <br/>Controlla la tua casella di posta. Il link all'interno scade dopo 24 ore.",
  "modal.emailVerif.linkExpired.desc": "Per ricevere un nuovo link di verifica alla tua mail, fai l'accesso.",
  "modal.emailVerif.linkExpired.title": "Questo link è scaduto",
  "modal.emailVerif.resend-email-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.resend-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.title": "Verifica il tuo indirizzo email",
  "modal.finishCreatingAccount.event": "A un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tutti conoscono HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Inserisci il tuo nome",
  "modal.finishCreatingAccount.friends_family": "Tramite amici, parenti o conoscenti",
  "modal.finishCreatingAccount.hearAboutHE": "Come hai scoperto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Inserisci il tuo cognome",
  "modal.finishCreatingAccount.other": "Altro",
  "modal.finishCreatingAccount.phone_number": "Numero di telefono",
  "modal.finishCreatingAccount.phone_number.error": "Inserisci il tuo numero di telefono",
  "modal.finishCreatingAccount.pleaseSpecify": "Per favore, specifica",
  "modal.finishCreatingAccount.press": "Sulla stampa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Stampa",
  "modal.finishCreatingAccount.radio": "Alla radio",
  "modal.finishCreatingAccount.referral": "Codice invito",
  "modal.finishCreatingAccount.referralCode.error": "Questo codice invito non è valido",
  "modal.finishCreatingAccount.search_engine": "Su un motore di ricerca",
  "modal.finishCreatingAccount.social_media": "Nei social media",
  "modal.finishCreatingAccount.social_network_other": "Altro social network (specificare)",
  "modal.finishCreatingAccount.title": "Completa la creazione del tuo account",
  "modal.finishCreatingAccount.tv": "Alla TV",
  "modal.finishCreatingAccount.tv_ad": "In una pubblicità",
  "modal.finishCreatingAccount.tv_show": "In un reportage / programma televisivo",
  "modal.genericError.desc": "La piattaforma potrebbe essere inattiva o potrebbe esserci un problema temporaneo da parte nostra, quindi riprova. <br> <br>Monitoriamo questi errori automaticamente, ma se il problema persiste non esitare a contattarci all'indirizzo:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! Qualcosa è andato storto",
  "modal.noEmailRecieved.desc": "<b>Non hai ricevuto l'email?</b>Controlla la cartella spam e l'ortografia della tua email prima di richiedere un'altra email di verifica.",
  "modal.noEmailRecieved.error": "Qualcosa è andato storto, per favore riprova più tardi",
  "modal.verifyEmail.emailResent.toast": "Ti abbiamo inviato una nuova email di verifica.",
  "signin-modal.apple.button": "Accedi tramite Google",
  "signin-modal.button": "Accedi",
  "signin-modal.email.button": "Accedi",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Accedi tramite Facebook",
  "signin-modal.no-account": "Non hai ancora un account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Reimposta la password",
  "signup-modal.accept-cgu": "Creando un account, accetto le",
  "signup-modal.apple.button": "Accedi con Apple",
  "signup-modal.button": "Registrati",
  "signup-modal.cgu.link": "Condizioni Generali di Utilizzo",
  "signup-modal.description": "Scopri un nuovo modo di viaggiare con lo scambio casa: lasciati accogliere in tutto il mondo e risparmia!",
  "signup-modal.email.button": "Registrati con il tuo indirizzo email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrati tramite Facebook",
  "signup-modal.have-an-account": "Hai già un account?"
}, hie = "Monolocale", pie = "{{count}} camera da letto", mie = "{{count}} camere da letto", fie = "", gie = "{{count}} letto", bie = "{{count}} letti", vie = "Il tuo calendario è stato aggiornato.", yie = "", _ie = "", wie = "", kie = "", xie = "", $ie = "", Sie = "", Cie = "", Eie = "Annulla", Aie = "Date", Oie = "Elimina", zie = "Descrizione", Nie = "Destinazione", jie = "Fatto!", Rie = "Modifica", Iie = "Filtri", Tie = "", Pie = "", Die = "Ospiti", Lie = "case", Mie = "", Fie = "Posizione", Wie = "Modifica", Bie = "Nome", Vie = "Avanti", Uie = "Zero", qie = "Uno", Hie = "Altro", Kie = "Zero", Gie = "Uno", Zie = "Altro", Jie = "Zero", Yie = "Uno", Xie = "Altro", Qie = "Zero", ese = "Uno", tse = "Altro", nse = "Il formato del numero di telefono non è valido.", ose = "Ricevi avvisi via email", ase = "Salva", rse = "Nessuna posizione trovata", ise = "Lista dei programmi di viaggio", sse = "", lse = "facoltativo", cse = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: hie,
  bedroomsNumbers_one: pie,
  bedroomsNumbers_other: mie,
  beds_zero: fie,
  beds_one: gie,
  beds_other: bie,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_calendarUpdated_toast: vie,
  global_calendar_aMonth: yie,
  global_calendar_exactDates: _ie,
  global_calendar_oneWeek: wie,
  global_calendar_oneWeekend: kie,
  global_calendar_plusMinusDay_zero: xie,
  global_calendar_plusMinusDay_one: $ie,
  global_calendar_plusMinusDay_other: Sie,
  global_calendar_twoWeeks: Cie,
  global_cancel: Eie,
  global_dates: Aie,
  global_delete: Oie,
  global_description: zie,
  global_destination: Nie,
  global_done: jie,
  global_edit: Rie,
  global_filters: Iie,
  global_fixDates: Tie,
  global_flexibleDates: Pie,
  global_guests: Die,
  global_homes: Lie,
  global_lastMinute: Mie,
  global_location: Fie,
  global_modify: Wie,
  global_name: Bie,
  global_next: Vie,
  global_numberOfAdults_zero: Uie,
  global_numberOfAdults_one: qie,
  global_numberOfAdults_other: Hie,
  global_numberOfBabies_zero: Kie,
  global_numberOfBabies_one: Gie,
  global_numberOfBabies_other: Zie,
  global_numberOfChildren_zero: Jie,
  global_numberOfChildren_one: Yie,
  global_numberOfChildren_other: Xie,
  global_numberOfGuests_zero: Qie,
  global_numberOfGuests_one: ese,
  global_numberOfGuests_other: tse,
  global_phoneNumber_notValid: nse,
  global_receiveEmailAlerts: ose,
  global_save: ase,
  global_searchBar_noLocationFound: rse,
  global_travelWishlist: ise,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: sse,
  optional: lse,
  "privacy-policy": "Informativa sulla privacy"
}, use = "https://www.homeexchange.it/blog/", dse = "/p/homeexchange-condizioni-di-uso", hse = "https://www.homeexchange.it/p/comunita", pse = "https://homeexchangehelp.zendesk.com/hc/it", mse = "", fse = "https://www.homeexchange.it/p/service-homeexchange-it", gse = "https://www.homeexchange.it/p/guestpoints-it", bse = "https://www.homeexchange.it/p/stampa", vse = "https://www.homeexchange.com/p/racconti-homeexchangers", yse = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", _se = "", wse = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", kse = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: use,
  cgu: dse,
  community: hse,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: pse,
  forum: mse,
  guarantees: fse,
  guestpoints: gse,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: bse,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: vse,
  travelWishlist_faq_links: yse,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: _se,
  values: wse
}, xse = "Nome", $se = "Cognome", Sse = "Aggiungi alla lista dei tuoi progetti di viaggio", Cse = "Una lista dei tuoi programmi di viaggio aggiornata ti consentirà di ricevere più richieste di scambio reciproco.", Ese = "Vuoi davvero eliminare {{fullAddress}}?", Ase = "Hai selezionato questi filtri. Se hai cambiato idea, puoi eliminarne alcuni qui sotto. Se invece desideri aggiungerne altri, dovrai avviare una nuova ricerca (ma presto non sarà più così... non perderti gli aggiornamenti)!", Ose = "Potrebbe trattarsi di un paese, una città o un'intera regione. Se scegli una zona ampia, i risultati potrebbero essere meno accurati.", zse = "Digita un paese, una città o una regione", Nse = "Vedi le case disponibili", jse = "Quando le case disponibili corrispondono ai tuoi programmi di viaggio.", Rse = "Aggiungi ai progetti di viaggio", Ise = "{{fullAddress}} è stato eliminato dai tuoi programmi di viaggio.", Tse = "Seleziona le date di viaggio ideali (flessibili o fisse).", Pse = "Aggiungi dei dettagli per aiutare gli altri utenti che utilizzano la funzione di ricerca inversa a capire perché ti interessa la loro zona.", Dse = "Specifica quante persone viaggeranno con te.", Lse = "Ops! {{fullAddress}} non è stato salvato nella lista dei tuoi programmi di viaggio per un motivo imprevisto.%", Mse = "Facci sapere quando e dove vorresti viaggiare per ricevere richieste di scambio e avvisi non appena saranno disponibili delle case adatte. Salveremo le tue ricerche nella lista dei tuoi programmi di viaggio!", Fse = "Ci sono nuove avventure che vorresti iniziare a pianificare?", Wse = "<updateDates>Aggiorna le tue date</updateDates> per continuare a ricevere gli avvisi pertinenti via mail oppure <delete>elimina questa destinazione</delete> dalla lista dei tuoi progetti di viaggio se hai cambiato idea.", Bse = "Queste date sono già passate", Vse = "{{fullAddress}} è stato aggiunto alla lista dei tuoi programmi di viaggio!", Use = "{{fullAddress}} è stato aggiornato correttamente.", qse = "La tua ricerca è stata salvata e il tuo calendario è aggiornato!", Hse = "La tua ricerca è stata salvata. La trovi nella lista dei tuoi programmi di viaggio.", Kse = "Scopri di più sulle liste per i programmi di viaggio", Gse = {
  firstname: xse,
  lastname: $se,
  modal_travelWishlist_addNew_title: Sse,
  modal_travelWishlist_delete_body: Cse,
  modal_travelWishlist_delete_title: Ese,
  modal_travelWishlist_filtersApplied_helper: Ase,
  modal_travelWishlist_location_helper: Ose,
  modal_travelWishlist_searchBar_placeholder: zse,
  page_travelWishlist_card_cta: Nse,
  page_travelWishlist_card_emailAlerts_helper: jse,
  page_travelWishlist_cta: Rse,
  page_travelWishlist_deleted_toast: Ise,
  page_travelWishlist_edit_dates_helper: Tse,
  page_travelWishlist_edit_description_helper: Pse,
  page_travelWishlist_edit_guests_helper: Dse,
  page_travelWishlist_error_toast: Lse,
  page_travelWishlist_none_body: Mse,
  page_travelWishlist_none_subheader: Fse,
  page_travelWishlist_pastDates_desc: Wse,
  page_travelWishlist_pastDates_title: Bse,
  page_travelWishlist_saved_toast: Vse,
  page_travelWishlist_updated_toast: Use,
  search_travelWishlist_calendarUpdated_toast: qse,
  search_travelWishlist_saved_toast: Hse,
  travelWishlist_faq: Kse
}, Zse = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.resend-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.title": "Verifiser din e-postadresse",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Skriv inn telefonnummeret",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Logg inn med Apple",
  "signin-modal.button": "Logg inn",
  "signin-modal.email.button": "Logg inn",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logg inn med Facebook",
  "signin-modal.no-account": "Ingen konto ennå?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Tilbakestill passord",
  "signup-modal.accept-cgu": "Ved å opprette en konto, aksepterer jeg",
  "signup-modal.apple.button": "Logg inn med Apple",
  "signup-modal.button": "Registrer deg",
  "signup-modal.cgu.link": "Generelle vilkår for bruk",
  "signup-modal.description": "Oppdag en ny måte å reise på med HomeExchange: bli ønsket velkommen over hele verden og spar penger!",
  "signup-modal.email.button": "Registrer deg med e-postadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrer deg med Facebook",
  "signup-modal.have-an-account": "Har du allerede en konto?"
}, Jse = "Studio", Yse = "{{count}} soverom", Xse = "{{count}} soverom", Qse = "", ele = "{{count}} seng", tle = "{{count}} senger", nle = "", ole = "", ale = "", rle = "", ile = "", sle = "", lle = "", cle = "", ule = "", dle = "", hle = "", ple = "", mle = "", fle = "", gle = "", ble = "", vle = "", yle = "", _le = "", wle = "", kle = "", xle = "", $le = "", Sle = "", Cle = "", Ele = "", Ale = "", Ole = "", zle = "", Nle = "", jle = "", Rle = "", Ile = "", Tle = "", Ple = "", Dle = "", Lle = "", Mle = "", Fle = "", Wle = "", Ble = "", Vle = "", Ule = "", qle = "", Hle = "", Kle = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: Jse,
  bedroomsNumbers_one: Yse,
  bedroomsNumbers_other: Xse,
  beds_zero: Qse,
  beds_one: ele,
  beds_other: tle,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: nle,
  global_calendar_aMonth: ole,
  global_calendar_exactDates: ale,
  global_calendar_oneWeek: rle,
  global_calendar_oneWeekend: ile,
  global_calendar_plusMinusDay_zero: sle,
  global_calendar_plusMinusDay_one: lle,
  global_calendar_plusMinusDay_other: cle,
  global_calendar_twoWeeks: ule,
  global_cancel: dle,
  global_dates: hle,
  global_delete: ple,
  global_description: mle,
  global_destination: fle,
  global_done: gle,
  global_edit: ble,
  global_filters: vle,
  global_fixDates: yle,
  global_flexibleDates: _le,
  global_guests: wle,
  global_homes: kle,
  global_lastMinute: xle,
  global_location: $le,
  global_modify: Sle,
  global_name: Cle,
  global_next: Ele,
  global_numberOfAdults_zero: Ale,
  global_numberOfAdults_one: Ole,
  global_numberOfAdults_other: zle,
  global_numberOfBabies_zero: Nle,
  global_numberOfBabies_one: jle,
  global_numberOfBabies_other: Rle,
  global_numberOfChildren_zero: Ile,
  global_numberOfChildren_one: Tle,
  global_numberOfChildren_other: Ple,
  global_numberOfGuests_zero: Dle,
  global_numberOfGuests_one: Lle,
  global_numberOfGuests_other: Mle,
  global_phoneNumber_notValid: Fle,
  global_receiveEmailAlerts: Wle,
  global_save: Ble,
  global_searchBar_noLocationFound: Vle,
  global_travelWishlist: Ule,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: qle,
  optional: Hle,
  "privacy-policy": "Personvernpolicy"
}, Gle = "https://www.homeexchange.com/blog/", Zle = "/p/general-terms-of-use", Jle = "https://www.homeexchange.com/nb/p/nettverk", Yle = "https://homeexchangehelp.zendesk.com/hc/pt", Xle = "", Qle = "https://www.homeexchange.com/nb/p/service-homeexchange-no", ece = "https://www.homeexchange.com/nb/p/guestpoints-no", tce = "https://www.homeexchange.com/nb/p/press-no", nce = "https://www.homeexchange.com/p/ifolge-homeexchangers", oce = "", ace = "", rce = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", ice = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: Gle,
  cgu: Zle,
  community: Jle,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Yle,
  forum: Xle,
  guarantees: Qle,
  guestpoints: ece,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: tce,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: nce,
  travelWishlist_faq_links: oce,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ace,
  values: rce
}, sce = "Fornavn", lce = "Etternavn", cce = "", uce = "", dce = "", hce = "", pce = "", mce = "", fce = "Se tilgjengelige hjem", gce = "", bce = "", vce = "", yce = "", _ce = "", wce = "", kce = "", xce = "", $ce = "", Sce = "", Cce = "", Ece = "", Ace = "", Oce = "", zce = "", Nce = "", jce = {
  firstname: sce,
  lastname: lce,
  modal_travelWishlist_addNew_title: cce,
  modal_travelWishlist_delete_body: uce,
  modal_travelWishlist_delete_title: dce,
  modal_travelWishlist_filtersApplied_helper: hce,
  modal_travelWishlist_location_helper: pce,
  modal_travelWishlist_searchBar_placeholder: mce,
  page_travelWishlist_card_cta: fce,
  page_travelWishlist_card_emailAlerts_helper: gce,
  page_travelWishlist_cta: bce,
  page_travelWishlist_deleted_toast: vce,
  page_travelWishlist_edit_dates_helper: yce,
  page_travelWishlist_edit_description_helper: _ce,
  page_travelWishlist_edit_guests_helper: wce,
  page_travelWishlist_error_toast: kce,
  page_travelWishlist_none_body: xce,
  page_travelWishlist_none_subheader: $ce,
  page_travelWishlist_pastDates_desc: Sce,
  page_travelWishlist_pastDates_title: Cce,
  page_travelWishlist_saved_toast: Ece,
  page_travelWishlist_updated_toast: Ace,
  search_travelWishlist_calendarUpdated_toast: Oce,
  search_travelWishlist_saved_toast: zce,
  travelWishlist_faq: Nce
}, Rce = {
  "modal.emailVerif.alreadyVerified.desc": "Je e-mailadres is klaar! Log in om verder te gaan.",
  "modal.emailVerif.alreadyVerified.title": "Je e-mailadres is al geverifieerd",
  "modal.emailVerif.callout": "Er is een verificatie-e-mail verzonden.",
  "modal.emailVerif.desc": "We hebben een verificatie-e-mail gestuurd naar <b>{{email}}</b>.<br/>Controleer je inbox. De link in deze e-mail verloopt binnen 24 uur.",
  "modal.emailVerif.linkExpired.desc": "Log in om een nieuwe verificatielink in je inbox te ontvangen.",
  "modal.emailVerif.linkExpired.title": "Deze link is verlopen",
  "modal.emailVerif.resend-email-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.resend-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.title": "Verifieer je e-mailadres",
  "modal.finishCreatingAccount.event": "Op een evenement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Iedereen kent HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Voer je voornaam in",
  "modal.finishCreatingAccount.friends_family": "Via vrienden, familie of kennissen",
  "modal.finishCreatingAccount.hearAboutHE": "Hoe heb je over HomeExchange gehoord?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Voer je achternaam in",
  "modal.finishCreatingAccount.other": "Andere",
  "modal.finishCreatingAccount.phone_number": "Telefoonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Voer je telefoonnummer in",
  "modal.finishCreatingAccount.pleaseSpecify": "Gelieve te specificeren",
  "modal.finishCreatingAccount.press": "In de pers",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Gedrukte pers",
  "modal.finishCreatingAccount.radio": "Op de radio",
  "modal.finishCreatingAccount.referral": "Doorverwijzingscode",
  "modal.finishCreatingAccount.referralCode.error": "Deze doorverwijzingscode is ongeldig",
  "modal.finishCreatingAccount.search_engine": "Op een zoekmachine",
  "modal.finishCreatingAccount.social_media": "Via sociale media",
  "modal.finishCreatingAccount.social_network_other": "Ander sociaal netwerk (specificeer)",
  "modal.finishCreatingAccount.title": "Voltooi het aanmaken van je account",
  "modal.finishCreatingAccount.tv": "Op tv",
  "modal.finishCreatingAccount.tv_ad": "Via een advertentie",
  "modal.finishCreatingAccount.tv_show": "Tijdens een reportage/tv-programma",
  "modal.genericError.desc": "Het platform is mogelijk niet beschikbaar of er kan een tijdelijke storing zijn aan onze kant, dus probeer het opnieuw.<br><br> We traceren deze fouten automatisch, maar als het probleem zich blijft voordoen, neem dan gerust contact met ons op:<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oeps! Er is iets misgegaan",
  "modal.noEmailRecieved.desc": "<b>Geen e-mail ontvangen?</b>Controleer je spammap en de spelling van je e-mail voordat je een nieuwe verificatiemail aanvraagt.",
  "modal.noEmailRecieved.error": "Er is iets misgegaan, probeer het later opnieuw",
  "modal.verifyEmail.emailResent.toast": "We hebben je een nieuwe verificatiemail gestuurd.",
  "signin-modal.apple.button": "Meld je aan zonder Google",
  "signin-modal.button": "Inloggen",
  "signin-modal.email.button": "Inloggen",
  "signin-modal.error.content": "Er is een fout opgetreden",
  "signin-modal.error.email_no_verified.content": "E-mailadres niet geverifieerd",
  "signin-modal.error.email_no_verified.title": "Fout",
  "signin-modal.error.title": "Fout",
  "signin-modal.facebook.button": "Meld je aan zonder Facebook",
  "signin-modal.no-account": "Heb je nog geen account?",
  "signin-modal.reset-password": "Wachtwoord opnieuw instellen",
  "signin-modal.title": "Inloggen",
  "signin.modal.reset-password": "Wachtwoord opnieuw instellen",
  "signup-modal.accept-cgu": "Door een account aan te maken, accepteer ik de",
  "signup-modal.apple.button": "Inloggen met Apple",
  "signup-modal.button": "Inschrijven",
  "signup-modal.cgu.link": "Wettelijke bepalingen",
  "signup-modal.description": "Ontdek een nieuwe manier van reizen met HomeExchange: word overal ter wereld verwelkomd en bespaar geld!",
  "signup-modal.email.button": "Meld je aan met je e-mail adres",
  "signup-modal.email.form.submit": "Registreren",
  "signup-modal.error.content": "Er is een fout opgetreden",
  "signup-modal.error.title": "Fout",
  "signup-modal.facebook.button": "Inloggen met Facebook",
  "signup-modal.have-an-account": "Heb je al een account?"
}, Ice = "Studio", Tce = "{{count}} slaapkamer", Pce = "{{count}} slaapkamers", Dce = "", Lce = "{{count}} bed", Mce = "{{count}} bedden", Fce = "Je kalender is bijgewerkt.", Wce = "Een maand", Bce = "Exacte data", Vce = "Een week", Uce = "Een weekend", qce = "", Hce = "", Kce = "± {{count}} dagen", Gce = "Twee weken", Zce = "Annuleren", Jce = "Data", Yce = "Verwijderen", Xce = "Beschrijving", Qce = "Bestemming", eue = "Klaar!", tue = "Bewerken", nue = "Filters", oue = "Vaste data", aue = "Flexibele data", rue = "Gasten", iue = "huizen", sue = "Last minute", lue = "Locatie", cue = "Wijzigen", uue = "Naam", due = "Volgende", hue = "", pue = "{{count}} volwassene", mue = "{{count}} volwassenen", fue = "", gue = "{{count}} baby", bue = "{{count}} baby's", vue = "", yue = "{{count}} kind", _ue = "{{count}} kinderen", wue = "", kue = "{{count}} gast", xue = "{{count}} gasten", $ue = "De indeling van het telefoonnummer is niet geldig.", Sue = "E-mailmeldingen ontvangen", Cue = "Opslaan", Eue = "Geen locaties gevonden", Aue = "Reisplannen", Oue = "Geen resultaat", zue = "optioneel", Nue = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: Ice,
  bedroomsNumbers_one: Tce,
  bedroomsNumbers_other: Pce,
  beds_zero: Dce,
  beds_one: Lce,
  beds_other: Mce,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_calendarUpdated_toast: Fce,
  global_calendar_aMonth: Wce,
  global_calendar_exactDates: Bce,
  global_calendar_oneWeek: Vce,
  global_calendar_oneWeekend: Uce,
  global_calendar_plusMinusDay_zero: qce,
  global_calendar_plusMinusDay_one: Hce,
  global_calendar_plusMinusDay_other: Kce,
  global_calendar_twoWeeks: Gce,
  global_cancel: Zce,
  global_dates: Jce,
  global_delete: Yce,
  global_description: Xce,
  global_destination: Qce,
  global_done: eue,
  global_edit: tue,
  global_filters: nue,
  global_fixDates: oue,
  global_flexibleDates: aue,
  global_guests: rue,
  global_homes: iue,
  global_lastMinute: sue,
  global_location: lue,
  global_modify: cue,
  global_name: uue,
  global_next: due,
  global_numberOfAdults_zero: hue,
  global_numberOfAdults_one: pue,
  global_numberOfAdults_other: mue,
  global_numberOfBabies_zero: fue,
  global_numberOfBabies_one: gue,
  global_numberOfBabies_other: bue,
  global_numberOfChildren_zero: vue,
  global_numberOfChildren_one: yue,
  global_numberOfChildren_other: _ue,
  global_numberOfGuests_zero: wue,
  global_numberOfGuests_one: kue,
  global_numberOfGuests_other: xue,
  global_phoneNumber_notValid: $ue,
  global_receiveEmailAlerts: Sue,
  global_save: Cue,
  global_searchBar_noLocationFound: Eue,
  global_travelWishlist: Aue,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: Oue,
  optional: zue,
  "privacy-policy": "Privacy"
}, jue = "https://www.homeexchange.com/nl/blog/", Rue = "/nl/p/homeexchangegebruiksvoorwaarden", Iue = "https://www.homeexchange.com/nl/p/gemeenschap", Tue = "https://homeexchangehelp.zendesk.com/hc/en-us", Pue = "https://forum.homeexchange.com/c/english/20", Due = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", Lue = "https://www.homeexchange.com/nl/p/guestpoints-nl", Mue = "https://www.homeexchange.com/nl/p/pers", Fue = "https://www.homeexchange.com/p/wordsonhomeexchange", Wue = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", Bue = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", Vue = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", Uue = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: jue,
  cgu: Rue,
  community: Iue,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Tue,
  forum: Pue,
  guarantees: Due,
  guestpoints: Lue,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Mue,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: Fue,
  travelWishlist_faq_links: Wue,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Bue,
  values: Vue
}, que = "Voornaam", Hue = "Achternaam", Kue = "Voeg toe aan je reisplannen", Gue = "Met bijgewerkte reisplannen kun je meer wederzijdse uitwisselingsverzoeken ontvangen.", Zue = "Weet je zeker dat je {{fullAddress}} wilt verwijderen?", Jue = "Dit zijn de filters die je hebt geselecteerd. Als je van gedachten bent veranderd, kun je er hieronder een paar verwijderen. Maar als je extra filters wilt toevoegen, moet je een nieuwe zoekopdracht starten (dit zal binnenkort veranderen...hou het in de gaten)!", Yue = "Dit kan een land, stad of een hele regio zijn. Als je een brede locatie kiest, zijn je resultaten mogelijk minder nauwkeurig.", Xue = "Typ een land, stad of regio", Que = "Bekijk beschikbare huizen", ede = "Als er beschikbare huizen zijn die overeenkomen met je reisplannen.", tde = "Voeg toe aan je reisplannen", nde = "{{fullAddress}} is verwijderd uit je reisplannen.", ode = "Selecteer je ideale reisdata (flexibel of vast).", ade = "Voeg details toe zodat anderen die de omgekeerde zoekfunctie gebruiken kunnen zien waarom je geïnteresseerd bent in hun locatie.", rde = "Geef aan hoeveel mensen met je meereizen voor deze reis.", ide = "Oeps! {{fullAddress}} kon om een onverwachte reden niet worden opgeslagen in je reisplannen.", sde = "Laat ons weten wanneer en waar je naartoe wilt reizen en ontvang uitwisselingsverzoeken en meldingen zodra er geschikte huizen beschikbaar zijn. We slaan je zoekopdrachten op in je reisplannen!", lde = "Zijn er nog reisavonturen die je wilt plannen?", cde = "<updateDates>Werk je data</updateDates> bij om relevante e-mailmeldingen te blijven ontvangen of <delete>verwijder deze bestemming</delete> uit je reisplannen als je het niet langer overweegt.", ude = "Deze data liggen in het verleden", dde = "{{fullAddress}} is toegevoegd aan je reisplannen!", hde = "{{fullAddress}} is succesvol bijgewerkt.", pde = "Je zoekopdracht is opgeslagen en je kalender is bijgewerkt!", mde = "Je zoekopdracht is opgeslagen. Je vindt hem in je reisplannen.", fde = "Meer informatie over reisplannen", gde = {
  firstname: que,
  lastname: Hue,
  modal_travelWishlist_addNew_title: Kue,
  modal_travelWishlist_delete_body: Gue,
  modal_travelWishlist_delete_title: Zue,
  modal_travelWishlist_filtersApplied_helper: Jue,
  modal_travelWishlist_location_helper: Yue,
  modal_travelWishlist_searchBar_placeholder: Xue,
  page_travelWishlist_card_cta: Que,
  page_travelWishlist_card_emailAlerts_helper: ede,
  page_travelWishlist_cta: tde,
  page_travelWishlist_deleted_toast: nde,
  page_travelWishlist_edit_dates_helper: ode,
  page_travelWishlist_edit_description_helper: ade,
  page_travelWishlist_edit_guests_helper: rde,
  page_travelWishlist_error_toast: ide,
  page_travelWishlist_none_body: sde,
  page_travelWishlist_none_subheader: lde,
  page_travelWishlist_pastDates_desc: cde,
  page_travelWishlist_pastDates_title: ude,
  page_travelWishlist_saved_toast: dde,
  page_travelWishlist_updated_toast: hde,
  search_travelWishlist_calendarUpdated_toast: pde,
  search_travelWishlist_saved_toast: mde,
  travelWishlist_faq: fde
}, bde = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "",
  "modal.emailVerif.resend-link": "",
  "modal.emailVerif.title": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "",
  "modal.finishCreatingAccount.phone_number.error": "",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Iniciar sessão com a Apple",
  "signin-modal.button": "Iniciar sessão",
  "signin-modal.email.button": "Iniciar sessão",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Iniciar sessão com o Facebook",
  "signin-modal.no-account": "Ainda não tem conta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Redefinir palavra-passe",
  "signup-modal.accept-cgu": "Ao criar uma conta, eu aceito os",
  "signup-modal.apple.button": "Iniciar sessão com a Apple",
  "signup-modal.button": "Inscreva-se",
  "signup-modal.cgu.link": "Termos Gerais de Utilização",
  "signup-modal.description": "Descubra uma nova forma de viajar com a HomeExchange: sinta-se bem-vindo/a em todo o mundo e poupe dinheiro!",
  "signup-modal.email.button": "Inscreva-se com o seu endereço de e-mail",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Inscreva-se com o Facebook",
  "signup-modal.have-an-account": "Já possui uma conta?"
}, vde = "Studio", yde = "{{count}} quarto", _de = "{{count}} quartos", wde = "", kde = "{{count}} cama", xde = "{{count}} camas", $de = "O seu calendário foi atualizado.", Sde = "Um mês", Cde = "Datas exatas", Ede = "Uma semana", Ade = "Um fim de semana", Ode = "", zde = "± 1:{{count}} dia", Nde = "± {{count]] dias", jde = "Duas semanas", Rde = "Cancelar", Ide = "Datas", Tde = "Eliminar", Pde = "Descrição", Dde = "Destino", Lde = "Feito!", Mde = "Editar", Fde = "Filtros", Wde = "Datas fixas", Bde = "Datas flexíveis", Vde = "Convidados", Ude = "casas", qde = "Última hora", Hde = "Localização", Kde = "Modificar", Gde = "Nome", Zde = "Seguinte", Jde = "", Yde = "{{count}} adulto", Xde = "{{count}} adultos", Qde = "", ehe = "{{count}} bebé", the = "{{count}} bebés", nhe = "", ohe = "{{count}} criança", ahe = "{{count}} crianças", rhe = "", ihe = "{{count}} convidado", she = "{{count}} convidados", lhe = "O formato do número de telefone não é válido.", che = "Receber alertas por e-mail", uhe = "Guardar", dhe = "Não foram encontradas localizações", hhe = "Ideias de viagens", phe = "", mhe = "", fhe = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: vde,
  bedroomsNumbers_one: yde,
  bedroomsNumbers_other: _de,
  beds_zero: wde,
  beds_one: kde,
  beds_other: xde,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: $de,
  global_calendar_aMonth: Sde,
  global_calendar_exactDates: Cde,
  global_calendar_oneWeek: Ede,
  global_calendar_oneWeekend: Ade,
  global_calendar_plusMinusDay_zero: Ode,
  global_calendar_plusMinusDay_one: zde,
  global_calendar_plusMinusDay_other: Nde,
  global_calendar_twoWeeks: jde,
  global_cancel: Rde,
  global_dates: Ide,
  global_delete: Tde,
  global_description: Pde,
  global_destination: Dde,
  global_done: Lde,
  global_edit: Mde,
  global_filters: Fde,
  global_fixDates: Wde,
  global_flexibleDates: Bde,
  global_guests: Vde,
  global_homes: Ude,
  global_lastMinute: qde,
  global_location: Hde,
  global_modify: Kde,
  global_name: Gde,
  global_next: Zde,
  global_numberOfAdults_zero: Jde,
  global_numberOfAdults_one: Yde,
  global_numberOfAdults_other: Xde,
  global_numberOfBabies_zero: Qde,
  global_numberOfBabies_one: ehe,
  global_numberOfBabies_other: the,
  global_numberOfChildren_zero: nhe,
  global_numberOfChildren_one: ohe,
  global_numberOfChildren_other: ahe,
  global_numberOfGuests_zero: rhe,
  global_numberOfGuests_one: ihe,
  global_numberOfGuests_other: she,
  global_phoneNumber_notValid: lhe,
  global_receiveEmailAlerts: che,
  global_save: uhe,
  global_searchBar_noLocationFound: dhe,
  global_travelWishlist: hhe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: phe,
  optional: mhe,
  "privacy-policy": "Privacidade"
}, ghe = "https://www.homeexchange.com/pt/blog/", bhe = "/p/general-terms-of-use", vhe = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", yhe = "https://homeexchangehelp.zendesk.com/hc/en-us", _he = "", whe = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", khe = "https://www.homeexchange.com/pt/p/os-guestpoints", xhe = "https://www.homeexchange.com/pt/p/press-pt", $he = "https://www.homeexchange.com/p/palavras-de-homeexchangers", She = "", Che = "", Ehe = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", Ahe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: ghe,
  cgu: bhe,
  community: vhe,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: yhe,
  forum: _he,
  guarantees: whe,
  guestpoints: khe,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: xhe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: $he,
  travelWishlist_faq_links: She,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Che,
  values: Ehe
}, Ohe = "", zhe = "", Nhe = "Adicionar às suas ideias de viagens", jhe = "As ideias de viagens atualizadas permitem-lhe receber mais pedidos de trocas recíprocas.", Rhe = "Tem a certeza de que pretende eliminar {{fullAddress}}?", Ihe = "Estes são os filtros que selecionou. Se tiver mudado de ideias, pode eliminar alguns deles abaixo. Contudo, se quiser adicionar outros filtros, terá de iniciar uma nova pesquisa (contudo, isto será alterado em breve... mantenha-se a par)!", The = "Pode ser um país, cidade ou região. Se optar por uma localização mais ampla, os resultados podem ser menos precisos.", Phe = "Escreva um país, cidade ou região", Dhe = "Ver casas disponíveis", Lhe = "Quando existirem casas com disponibilidade correspondentes aos seus planos de viagem.", Mhe = "Adicionar às ideias de viagens", Fhe = "{{fullAddress}} foi eliminada das suas ideias de viagens.", Whe = "Selecione as suas datas de viagem ideais (flexíveis ou fixas).", Bhe = "Adicione detalhes, para ajudar as pessoas que utilizam a funcionalidade de busca invertida a perceber porque tem interesse na respetiva região.", Vhe = "Especifique quantas pessoas vão viajar consigo.", Uhe = "Ups! Não foi possível guardar {{fullAddress}} nas suas ideias de viagens devido a um motivo inesperado.%", qhe = "Diga-nos para onde e quando quer viajar para receber pedidos de troca e alertas quando se tornarem disponíveis casas correspondentes. Vamos guardar estas pesquisas nas suas ideias de viagens!", Hhe = "Existem aventuras de viagens que queira começar a planear?", Khe = "<updateDates>Atualize as datas</updateDates> para continuar a receber alertas relevantes por e-mail ou <delete>elimine este destino</delete> das suas ideias de viagens se já não está a considerá-lo.", Ghe = "Estas datas já passaram", Zhe = "{{fullAddress}} foi adicionada às suas ideias de viagens!", Jhe = "{{fullAddress}} foi atualizada com sucesso.", Yhe = "A sua pesquisa foi guardada e o calendário foi atualizado!", Xhe = "A sua pesquisa foi guardada. Encontre-a nas suas ideias de viagens.", Qhe = "Saiba mais sobre as ideias de viagens", epe = {
  firstname: Ohe,
  lastname: zhe,
  modal_travelWishlist_addNew_title: Nhe,
  modal_travelWishlist_delete_body: jhe,
  modal_travelWishlist_delete_title: Rhe,
  modal_travelWishlist_filtersApplied_helper: Ihe,
  modal_travelWishlist_location_helper: The,
  modal_travelWishlist_searchBar_placeholder: Phe,
  page_travelWishlist_card_cta: Dhe,
  page_travelWishlist_card_emailAlerts_helper: Lhe,
  page_travelWishlist_cta: Mhe,
  page_travelWishlist_deleted_toast: Fhe,
  page_travelWishlist_edit_dates_helper: Whe,
  page_travelWishlist_edit_description_helper: Bhe,
  page_travelWishlist_edit_guests_helper: Vhe,
  page_travelWishlist_error_toast: Uhe,
  page_travelWishlist_none_body: qhe,
  page_travelWishlist_none_subheader: Hhe,
  page_travelWishlist_pastDates_desc: Khe,
  page_travelWishlist_pastDates_title: Ghe,
  page_travelWishlist_saved_toast: Zhe,
  page_travelWishlist_updated_toast: Jhe,
  search_travelWishlist_calendarUpdated_toast: Yhe,
  search_travelWishlist_saved_toast: Xhe,
  travelWishlist_faq: Qhe
}, tpe = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-post är redo! Logga in för att fortsätta.",
  "modal.emailVerif.alreadyVerified.title": "Din e-postadress har redan verifierats",
  "modal.emailVerif.callout": "Ett verifieringsmail har skickats.",
  "modal.emailVerif.desc": "Vi har skickat ett verifieringsmail till <b>{{email}}</b>.<br/>Kontrollera din inkorg. Länken i det här mailet löper ut om 24 timmar.",
  "modal.emailVerif.linkExpired.desc": "Logga in för att få en ny verifieringslänk till din e-post.",
  "modal.emailVerif.linkExpired.title": "Den här länken har löpt ut",
  "modal.emailVerif.resend-email-link": "Skicka nytt bekräftelsemail",
  "modal.emailVerif.resend-link": "Skicka verifieringsmailet igen",
  "modal.emailVerif.title": "Verifiera din e-postadress",
  "modal.finishCreatingAccount.event": "På ett evenemang",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alla känner till HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Ange ditt förnamn",
  "modal.finishCreatingAccount.friends_family": "Genom vänner, familj eller bekanta",
  "modal.finishCreatingAccount.hearAboutHE": "Hur hörde du talas om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Ange ditt efternamn",
  "modal.finishCreatingAccount.other": "Annat",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Ange ditt telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Vänligen specificera",
  "modal.finishCreatingAccount.press": "Genom nyhetskanaler",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Tryckt media",
  "modal.finishCreatingAccount.radio": "På radion",
  "modal.finishCreatingAccount.referral": "Referenskod",
  "modal.finishCreatingAccount.referralCode.error": "Den här referenskoden är ogiltig",
  "modal.finishCreatingAccount.search_engine": "Från en sökmotor",
  "modal.finishCreatingAccount.social_media": "Via sociala medier",
  "modal.finishCreatingAccount.social_network_other": "Andra sociala medier (vänligen specificera)",
  "modal.finishCreatingAccount.title": "Slutför kontoskapandet",
  "modal.finishCreatingAccount.tv": "På tv",
  "modal.finishCreatingAccount.tv_ad": "Genom en annons",
  "modal.finishCreatingAccount.tv_show": "Under ett reportage/tv-program",
  "modal.genericError.desc": "Plattformen kan vara nere eller så kan det vara ett tillfälligt fel hos oss, vänligen försök igen.<br><br>Vi spårar de här felen automatiskt, men om problemet kvarstår, kontakta oss gärna på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hoppsan! Något gick fel",
  "modal.noEmailRecieved.desc": "<b>Fick du inget e-postmeddelande?</b> Kontrollera din skräppost och stavningen av din e-post innan du begär ett nytt verifieringsmail.",
  "modal.noEmailRecieved.error": "Något gick fel, försök igen senare",
  "modal.verifyEmail.emailResent.toast": "Vi har skickat ett nytt verifieringsmail till dig.",
  "signin-modal.apple.button": "Logga in med Apple",
  "signin-modal.button": "Logga in",
  "signin-modal.email.button": "Logga in",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logga in med Facebook",
  "signin-modal.no-account": "Har du inget konto ännu?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Återställ lösenord",
  "signup-modal.accept-cgu": "Genom att skapa ett konto godkänner jag",
  "signup-modal.apple.button": "Logga in med Apple",
  "signup-modal.button": "Registrera dig",
  "signup-modal.cgu.link": "de allmänna villkoren",
  "signup-modal.description": "Upptäck ett nytt sätt att resa med HomeExchange: bli välkomnad över hela världen och spara pengar!",
  "signup-modal.email.button": "Registrera dig med din e-postadress",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrera dig med Facebook",
  "signup-modal.have-an-account": "Har du redan ett konto?"
}, npe = "Studio", ope = "{{count}} sovrum", ape = "{{count}} sovrum", rpe = "", ipe = "{{count}} säng", spe = "{{count}} sängar", lpe = "", cpe = "En månad", upe = "Exakta datum", dpe = "En vecka", hpe = "En helg", ppe = "", mpe = "± {{count}} dag", fpe = "± {{count}} dagar", gpe = "Två veckor", bpe = "Avbryt", vpe = "Datum", ype = "Ta bort", _pe = "Beskrivning", wpe = "Resmål", kpe = "Klart!", xpe = "", $pe = "", Spe = "Fasta datum", Cpe = "Flexibla datum", Epe = "", Ape = "hem", Ope = "Sista minuten", zpe = "Plats", Npe = "Ändra", jpe = "Namn", Rpe = "Nästa", Ipe = "", Tpe = "{{count}} vuxen", Ppe = "{{count}} vuxna", Dpe = "", Lpe = "{{count}} bebis", Mpe = "{{count}} bebisar", Fpe = "", Wpe = "{{count}} barn", Bpe = "{{count}} barn", Vpe = "{{count}} gäst", Upe = "{{count}} gäst", qpe = "{{count}} gäster", Hpe = "Telefonnumrets format är inte giltigt.", Kpe = "Få e-postaviseringar", Gpe = "Spara", Zpe = "Inga resmål hittades", Jpe = "", Ype = "", Xpe = "valfritt", Qpe = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: npe,
  bedroomsNumbers_one: ope,
  bedroomsNumbers_other: ape,
  beds_zero: rpe,
  beds_one: ipe,
  beds_other: spe,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_calendarUpdated_toast: lpe,
  global_calendar_aMonth: cpe,
  global_calendar_exactDates: upe,
  global_calendar_oneWeek: dpe,
  global_calendar_oneWeekend: hpe,
  global_calendar_plusMinusDay_zero: ppe,
  global_calendar_plusMinusDay_one: mpe,
  global_calendar_plusMinusDay_other: fpe,
  global_calendar_twoWeeks: gpe,
  global_cancel: bpe,
  global_dates: vpe,
  global_delete: ype,
  global_description: _pe,
  global_destination: wpe,
  global_done: kpe,
  global_edit: xpe,
  global_filters: $pe,
  global_fixDates: Spe,
  global_flexibleDates: Cpe,
  global_guests: Epe,
  global_homes: Ape,
  global_lastMinute: Ope,
  global_location: zpe,
  global_modify: Npe,
  global_name: jpe,
  global_next: Rpe,
  global_numberOfAdults_zero: Ipe,
  global_numberOfAdults_one: Tpe,
  global_numberOfAdults_other: Ppe,
  global_numberOfBabies_zero: Dpe,
  global_numberOfBabies_one: Lpe,
  global_numberOfBabies_other: Mpe,
  global_numberOfChildren_zero: Fpe,
  global_numberOfChildren_one: Wpe,
  global_numberOfChildren_other: Bpe,
  global_numberOfGuests_zero: Vpe,
  global_numberOfGuests_one: Upe,
  global_numberOfGuests_other: qpe,
  global_phoneNumber_notValid: Hpe,
  global_receiveEmailAlerts: Kpe,
  global_save: Gpe,
  global_searchBar_noLocationFound: Zpe,
  global_travelWishlist: Jpe,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: Ype,
  optional: Xpe,
  "privacy-policy": "Sekretesspolicy"
}, eme = "https://www.homeexchange.com/blog/", tme = "/p/general-terms-of-use", nme = "https://www.homeexchange.com/sv/p/natverket", ome = "https://homeexchangehelp.zendesk.com/hc/es", ame = "", rme = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", ime = "https://www.homeexchange.com/sv/p/guestpoints-sv", sme = "https://www.homeexchange.com/sv/p/press-sv", lme = "https://www.homeexchange.com/p/medlemmarna-har-ordet", cme = "", ume = "", dme = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", hme = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: eme,
  cgu: tme,
  community: nme,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: ome,
  forum: ame,
  guarantees: rme,
  guestpoints: ime,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: sme,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: lme,
  travelWishlist_faq_links: cme,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ume,
  values: dme
}, pme = "Förnamn", mme = "Efternamn", fme = "Lägg till i din reslista", gme = "", bme = "", vme = "", yme = "", _me = "Ange ett land, en stad eller en region", wme = "Visa tillgängliga hem", kme = "", xme = "Lägg till i din reslista", $me = "", Sme = "Välj dina ideala resedatum (flexibla eller fasta).", Cme = "Lägg till detaljer för att hjälpa andra som använder funktionen för omvänd sökning att se varför du är intresserad av deras plats.", Eme = "Ange hur många personer som följer med dig på den här resan.", Ame = "", Ome = "", zme = "", Nme = "<updateDates> Uppdatera dina datum </updateDates> för att fortsätta få relevanta e-postmeddelanden eller <delete> ta bort det här resmålet </delete>från din reslista om du inte längre vill resa dit.", jme = "Dessa datum har redan varit", Rme = "", Ime = "", Tme = "", Pme = "", Dme = "", Lme = {
  firstname: pme,
  lastname: mme,
  modal_travelWishlist_addNew_title: fme,
  modal_travelWishlist_delete_body: gme,
  modal_travelWishlist_delete_title: bme,
  modal_travelWishlist_filtersApplied_helper: vme,
  modal_travelWishlist_location_helper: yme,
  modal_travelWishlist_searchBar_placeholder: _me,
  page_travelWishlist_card_cta: wme,
  page_travelWishlist_card_emailAlerts_helper: kme,
  page_travelWishlist_cta: xme,
  page_travelWishlist_deleted_toast: $me,
  page_travelWishlist_edit_dates_helper: Sme,
  page_travelWishlist_edit_description_helper: Cme,
  page_travelWishlist_edit_guests_helper: Eme,
  page_travelWishlist_error_toast: Ame,
  page_travelWishlist_none_body: Ome,
  page_travelWishlist_none_subheader: zme,
  page_travelWishlist_pastDates_desc: Nme,
  page_travelWishlist_pastDates_title: jme,
  page_travelWishlist_saved_toast: Rme,
  page_travelWishlist_updated_toast: Ime,
  search_travelWishlist_calendarUpdated_toast: Tme,
  search_travelWishlist_saved_toast: Pme,
  travelWishlist_faq: Dme
}, Mme = "en", nk = qZ({
  fallbackLng: Mme,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      auth: HZ,
      common: UJ,
      user: OY,
      links: oY
    },
    de: {
      auth: zY,
      common: AX,
      user: pQ,
      links: WX
    },
    en: {
      auth: mQ,
      common: hee,
      user: Yee,
      links: See
    },
    es: {
      auth: Xee,
      common: Jte,
      user: Tne,
      links: cne
    },
    fr: {
      auth: Pne,
      common: Ioe,
      user: yae,
      links: Koe
    },
    hr: {
      auth: _ae,
      common: Sre,
      user: uie,
      links: Lre
    },
    it: {
      auth: die,
      common: cse,
      user: Gse,
      links: kse
    },
    nb: {
      auth: Zse,
      common: Kle,
      user: jce,
      links: ice
    },
    nl: {
      auth: Rce,
      common: Nue,
      user: gde,
      links: Uue
    },
    pt: {
      auth: bde,
      common: fhe,
      user: epe,
      links: Ahe
    },
    sv: {
      auth: tpe,
      common: Qpe,
      user: Lme,
      links: hme
    }
  }
});
nk.init();
const ga = nk, Fme = ae.createContext(null);
Fme.displayName = "HookFormContext";
typeof window < "u" ? ae.useLayoutEffect : ae.useEffect;
function F(e, t, n) {
  function o(s, l) {
    var c;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (c = s._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, l);
    for (const u in i.prototype)
      u in s || Object.defineProperty(s, u, { value: i.prototype[u].bind(s) });
    s._zod.constr = i, s._zod.def = l;
  }
  const a = n?.Parent ?? Object;
  class r extends a {
  }
  Object.defineProperty(r, "name", { value: e });
  function i(s) {
    var l;
    const c = n?.Parent ? new r() : this;
    o(c, s), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(i, "init", { value: o }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => n?.Parent && s instanceof n.Parent ? !0 : s?._zod?.traits?.has(e)
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class Po extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class ok extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const ak = {};
function ao(e) {
  return ak;
}
function Wme(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, o]) => t.indexOf(+n) === -1).map(([n, o]) => o);
}
function Pc(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function wd(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function kd(e) {
  return e == null;
}
function xd(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const Xm = Symbol("evaluating");
function Ie(e, t, n) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== Xm)
        return o === void 0 && (o = Xm, o = n()), o;
    },
    set(a) {
      Object.defineProperty(e, t, {
        value: a
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Bme(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function jn(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function aa(...e) {
  const t = {};
  for (const n of e) {
    const o = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Qm(e) {
  return JSON.stringify(e);
}
const rk = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Fi(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Vme = wd(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Ta(e) {
  if (Fi(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(Fi(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function ik(e) {
  return Ta(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Ume = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Zo(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Rn(e, t, n) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (o._zod.parent = e), o;
}
function re(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function qme(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function Hme(e, t) {
  const n = e._zod.def, o = aa(e._zod.def, {
    get shape() {
      const a = {};
      for (const r in t) {
        if (!(r in n.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && (a[r] = n.shape[r]);
      }
      return jn(this, "shape", a), a;
    },
    checks: []
  });
  return Rn(e, o);
}
function Kme(e, t) {
  const n = e._zod.def, o = aa(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape };
      for (const r in t) {
        if (!(r in n.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && delete a[r];
      }
      return jn(this, "shape", a), a;
    },
    checks: []
  });
  return Rn(e, o);
}
function Gme(e, t) {
  if (!Ta(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const o = aa(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t };
      return jn(this, "shape", a), a;
    },
    checks: []
  });
  return Rn(e, o);
}
function Zme(e, t) {
  if (!Ta(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return jn(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return Rn(e, n);
}
function Jme(e, t) {
  const n = aa(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return jn(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Rn(e, n);
}
function Yme(e, t, n) {
  const o = aa(t._zod.def, {
    get shape() {
      const a = t._zod.def.shape, r = { ...a };
      if (n)
        for (const i in n) {
          if (!(i in a))
            throw new Error(`Unrecognized key: "${i}"`);
          n[i] && (r[i] = e ? new e({
            type: "optional",
            innerType: a[i]
          }) : a[i]);
        }
      else
        for (const i in a)
          r[i] = e ? new e({
            type: "optional",
            innerType: a[i]
          }) : a[i];
      return jn(this, "shape", r), r;
    },
    checks: []
  });
  return Rn(t, o);
}
function Xme(e, t, n) {
  const o = aa(t._zod.def, {
    get shape() {
      const a = t._zod.def.shape, r = { ...a };
      if (n)
        for (const i in n) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          n[i] && (r[i] = new e({
            type: "nonoptional",
            innerType: a[i]
          }));
        }
      else
        for (const i in a)
          r[i] = new e({
            type: "nonoptional",
            innerType: a[i]
          });
      return jn(this, "shape", r), r;
    },
    checks: []
  });
  return Rn(t, o);
}
function No(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function sk(e, t) {
  return t.map((n) => {
    var o;
    return (o = n).path ?? (o.path = []), n.path.unshift(e), n;
  });
}
function Rr(e) {
  return typeof e == "string" ? e : e?.message;
}
function ro(e, t, n) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const a = Rr(e.inst?._zod.def?.error?.(e)) ?? Rr(t?.error?.(e)) ?? Rr(n.customError?.(e)) ?? Rr(n.localeError?.(e)) ?? "Invalid input";
    o.message = a;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function $d(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Pa(...e) {
  const [t, n, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: o
  } : { ...t };
}
const lk = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Pc, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, ck = F("$ZodError", lk), uk = F("$ZodError", lk, { Parent: Error });
function Qme(e, t = (n) => n.message) {
  const n = {}, o = [];
  for (const a of e.issues)
    a.path.length > 0 ? (n[a.path[0]] = n[a.path[0]] || [], n[a.path[0]].push(t(a))) : o.push(t(a));
  return { formErrors: o, fieldErrors: n };
}
function efe(e, t) {
  const n = t || function(r) {
    return r.message;
  }, o = { _errors: [] }, a = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => a({ issues: s }));
      else if (i.code === "invalid_key")
        a({ issues: i.issues });
      else if (i.code === "invalid_element")
        a({ issues: i.issues });
      else if (i.path.length === 0)
        o._errors.push(n(i));
      else {
        let s = o, l = 0;
        for (; l < i.path.length; ) {
          const c = i.path[l];
          l === i.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(n(i))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
        }
      }
  };
  return a(e), o;
}
const Sd = (e) => (t, n, o, a) => {
  const r = o ? Object.assign(o, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise)
    throw new Po();
  if (i.issues.length) {
    const s = new (a?.Err ?? e)(i.issues.map((l) => ro(l, r, ao())));
    throw rk(s, a?.callee), s;
  }
  return i.value;
}, Cd = (e) => async (t, n, o, a) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new (a?.Err ?? e)(i.issues.map((l) => ro(l, r, ao())));
    throw rk(s, a?.callee), s;
  }
  return i.value;
}, zs = (e) => (t, n, o) => {
  const a = o ? { ...o, async: !1 } : { async: !1 }, r = t._zod.run({ value: n, issues: [] }, a);
  if (r instanceof Promise)
    throw new Po();
  return r.issues.length ? {
    success: !1,
    error: new (e ?? ck)(r.issues.map((i) => ro(i, a, ao())))
  } : { success: !0, data: r.value };
}, tfe = /* @__PURE__ */ zs(uk), Ns = (e) => async (t, n, o) => {
  const a = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: n, issues: [] }, a);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new e(r.issues.map((i) => ro(i, a, ao())))
  } : { success: !0, data: r.value };
}, nfe = /* @__PURE__ */ Ns(uk), ofe = (e) => (t, n, o) => {
  const a = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Sd(e)(t, n, a);
}, afe = (e) => (t, n, o) => Sd(e)(t, n, o), rfe = (e) => async (t, n, o) => {
  const a = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Cd(e)(t, n, a);
}, ife = (e) => async (t, n, o) => Cd(e)(t, n, o), sfe = (e) => (t, n, o) => {
  const a = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return zs(e)(t, n, a);
}, lfe = (e) => (t, n, o) => zs(e)(t, n, o), cfe = (e) => async (t, n, o) => {
  const a = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ns(e)(t, n, a);
}, ufe = (e) => async (t, n, o) => Ns(e)(t, n, o), dfe = /^[cC][^\s-]{8,}$/, hfe = /^[0-9a-z]+$/, pfe = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, mfe = /^[0-9a-vA-V]{20}$/, ffe = /^[A-Za-z0-9]{27}$/, gfe = /^[a-zA-Z0-9_-]{21}$/, bfe = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, vfe = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, ef = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, yfe = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, _fe = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function wfe() {
  return new RegExp(_fe, "u");
}
const kfe = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, xfe = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, $fe = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Sfe = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Cfe = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, dk = /^[A-Za-z0-9_-]*$/, Efe = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Afe = /^\+(?:[0-9]){6,14}[0-9]$/, hk = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Ofe = /* @__PURE__ */ new RegExp(`^${hk}$`);
function pk(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function zfe(e) {
  return new RegExp(`^${pk(e)}$`);
}
function Nfe(e) {
  const t = pk({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${hk}T(?:${o})$`);
}
const jfe = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Rfe = /^[^A-Z]*$/, Ife = /^[^a-z]*$/, nn = /* @__PURE__ */ F("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Tfe = /* @__PURE__ */ F("$ZodCheckMaxLength", (e, t) => {
  var n;
  nn.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const a = o.value;
    return !kd(a) && a.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const a = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < a && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const a = o.value;
    if (a.length <= t.maximum)
      return;
    const r = $d(a);
    o.issues.push({
      origin: r,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: a,
      inst: e,
      continue: !t.abort
    });
  };
}), Pfe = /* @__PURE__ */ F("$ZodCheckMinLength", (e, t) => {
  var n;
  nn.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const a = o.value;
    return !kd(a) && a.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const a = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > a && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const a = o.value;
    if (a.length >= t.minimum)
      return;
    const r = $d(a);
    o.issues.push({
      origin: r,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: a,
      inst: e,
      continue: !t.abort
    });
  };
}), Dfe = /* @__PURE__ */ F("$ZodCheckLengthEquals", (e, t) => {
  var n;
  nn.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const a = o.value;
    return !kd(a) && a.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const a = o._zod.bag;
    a.minimum = t.length, a.maximum = t.length, a.length = t.length;
  }), e._zod.check = (o) => {
    const a = o.value, r = a.length;
    if (r === t.length)
      return;
    const i = $d(a), s = r > t.length;
    o.issues.push({
      origin: i,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), js = /* @__PURE__ */ F("$ZodCheckStringFormat", (e, t) => {
  var n, o;
  nn.init(e, t), e._zod.onattach.push((a) => {
    const r = a._zod.bag;
    r.format = t.format, t.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (a) => {
    t.pattern.lastIndex = 0, !t.pattern.test(a.value) && a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: a.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), Lfe = /* @__PURE__ */ F("$ZodCheckRegex", (e, t) => {
  js.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Mfe = /* @__PURE__ */ F("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Rfe), js.init(e, t);
}), Ffe = /* @__PURE__ */ F("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Ife), js.init(e, t);
}), Wfe = /* @__PURE__ */ F("$ZodCheckIncludes", (e, t) => {
  nn.init(e, t);
  const n = Zo(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = o, e._zod.onattach.push((a) => {
    const r = a._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(o);
  }), e._zod.check = (a) => {
    a.value.includes(t.includes, t.position) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Bfe = /* @__PURE__ */ F("$ZodCheckStartsWith", (e, t) => {
  nn.init(e, t);
  const n = new RegExp(`^${Zo(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const a = o._zod.bag;
    a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Vfe = /* @__PURE__ */ F("$ZodCheckEndsWith", (e, t) => {
  nn.init(e, t);
  const n = new RegExp(`.*${Zo(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const a = o._zod.bag;
    a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ufe = /* @__PURE__ */ F("$ZodCheckOverwrite", (e, t) => {
  nn.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class qfe {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((r) => r), o = Math.min(...n.map((r) => r.length - r.trimStart().length)), a = n.map((r) => r.slice(o)).map((r) => " ".repeat(this.indent * 2) + r);
    for (const r of a)
      this.content.push(r);
  }
  compile() {
    const t = Function, n = this?.args, o = [...(this?.content ?? [""]).map((a) => `  ${a}`)];
    return new t(...n, o.join(`
`));
  }
}
const Hfe = {
  major: 4,
  minor: 1,
  patch: 8
}, Ke = /* @__PURE__ */ F("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Hfe;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const a of o)
    for (const r of a._zod.onattach)
      r(e);
  if (o.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const a = (i, s, l) => {
      let c = No(i), u;
      for (const d of s) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (c)
          continue;
        const m = i.issues.length, f = d._zod.check(i);
        if (f instanceof Promise && l?.async === !1)
          throw new Po();
        if (u || f instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await f, i.issues.length !== m && (c || (c = No(i, m)));
          });
        else {
          if (i.issues.length === m)
            continue;
          c || (c = No(i, m));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, s, l) => {
      if (No(i))
        return i.aborted = !0, i;
      const c = a(s, o, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new Po();
        return c.then((u) => e._zod.parse(u, l));
      }
      return e._zod.parse(c, l);
    };
    e._zod.run = (i, s) => {
      if (s.skipChecks)
        return e._zod.parse(i, s);
      if (s.direction === "backward") {
        const c = e._zod.parse({ value: i.value, issues: [] }, { ...s, skipChecks: !0 });
        return c instanceof Promise ? c.then((u) => r(u, i, s)) : r(c, i, s);
      }
      const l = e._zod.parse(i, s);
      if (l instanceof Promise) {
        if (s.async === !1)
          throw new Po();
        return l.then((c) => a(c, o, s));
      }
      return a(l, o, s);
    };
  }
  e["~standard"] = {
    validate: (a) => {
      try {
        const r = tfe(e, a);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return nfe(e, a).then((r) => r.success ? { value: r.data } : { issues: r.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Ed = /* @__PURE__ */ F("$ZodString", (e, t) => {
  Ke.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? jfe(e._zod.bag), e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), Pe = /* @__PURE__ */ F("$ZodStringFormat", (e, t) => {
  js.init(e, t), Ed.init(e, t);
}), Kfe = /* @__PURE__ */ F("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = vfe), Pe.init(e, t);
}), Gfe = /* @__PURE__ */ F("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = ef(n));
  } else
    t.pattern ?? (t.pattern = ef());
  Pe.init(e, t);
}), Zfe = /* @__PURE__ */ F("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = yfe), Pe.init(e, t);
}), Jfe = /* @__PURE__ */ F("$ZodURL", (e, t) => {
  Pe.init(e, t), e._zod.check = (n) => {
    try {
      const o = n.value.trim(), a = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(a.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Efe.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(a.protocol.endsWith(":") ? a.protocol.slice(0, -1) : a.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = a.href : n.value = o;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Yfe = /* @__PURE__ */ F("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = wfe()), Pe.init(e, t);
}), Xfe = /* @__PURE__ */ F("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = gfe), Pe.init(e, t);
}), Qfe = /* @__PURE__ */ F("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = dfe), Pe.init(e, t);
}), ege = /* @__PURE__ */ F("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = hfe), Pe.init(e, t);
}), tge = /* @__PURE__ */ F("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = pfe), Pe.init(e, t);
}), nge = /* @__PURE__ */ F("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = mfe), Pe.init(e, t);
}), oge = /* @__PURE__ */ F("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = ffe), Pe.init(e, t);
}), age = /* @__PURE__ */ F("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Nfe(t)), Pe.init(e, t);
}), rge = /* @__PURE__ */ F("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Ofe), Pe.init(e, t);
}), ige = /* @__PURE__ */ F("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = zfe(t)), Pe.init(e, t);
}), sge = /* @__PURE__ */ F("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = bfe), Pe.init(e, t);
}), lge = /* @__PURE__ */ F("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = kfe), Pe.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv4";
  });
}), cge = /* @__PURE__ */ F("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = xfe), Pe.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), uge = /* @__PURE__ */ F("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = $fe), Pe.init(e, t);
}), dge = /* @__PURE__ */ F("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Sfe), Pe.init(e, t), e._zod.check = (n) => {
    const o = n.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [a, r] = o;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${a}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function mk(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const hge = /* @__PURE__ */ F("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Cfe), Pe.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    mk(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function pge(e) {
  if (!dk.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return mk(n);
}
const mge = /* @__PURE__ */ F("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = dk), Pe.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    pge(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), fge = /* @__PURE__ */ F("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Afe), Pe.init(e, t);
});
function gge(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [o] = n;
    if (!o)
      return !1;
    const a = JSON.parse(atob(o));
    return !("typ" in a && a?.typ !== "JWT" || !a.alg || t && (!("alg" in a) || a.alg !== t));
  } catch {
    return !1;
  }
}
const bge = /* @__PURE__ */ F("$ZodJWT", (e, t) => {
  Pe.init(e, t), e._zod.check = (n) => {
    gge(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), vge = /* @__PURE__ */ F("$ZodUnknown", (e, t) => {
  Ke.init(e, t), e._zod.parse = (n) => n;
}), yge = /* @__PURE__ */ F("$ZodNever", (e, t) => {
  Ke.init(e, t), e._zod.parse = (n, o) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function tf(e, t, n) {
  e.issues.length && t.issues.push(...sk(n, e.issues)), t.value[n] = e.value;
}
const _ge = /* @__PURE__ */ F("$ZodArray", (e, t) => {
  Ke.init(e, t), e._zod.parse = (n, o) => {
    const a = n.value;
    if (!Array.isArray(a))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: a,
        inst: e
      }), n;
    n.value = Array(a.length);
    const r = [];
    for (let i = 0; i < a.length; i++) {
      const s = a[i], l = t.element._zod.run({
        value: s,
        issues: []
      }, o);
      l instanceof Promise ? r.push(l.then((c) => tf(c, n, i))) : tf(l, n, i);
    }
    return r.length ? Promise.all(r).then(() => n) : n;
  };
});
function Wi(e, t, n, o) {
  e.issues.length && t.issues.push(...sk(n, e.issues)), e.value === void 0 ? n in o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function fk(e) {
  const t = Object.keys(e.shape);
  for (const o of t)
    if (!e.shape?.[o]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${o}": expected a Zod schema`);
  const n = qme(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function gk(e, t, n, o, a, r) {
  const i = [], s = a.keySet, l = a.catchall._zod, c = l.def.type;
  for (const u of Object.keys(t)) {
    if (s.has(u))
      continue;
    if (c === "never") {
      i.push(u);
      continue;
    }
    const d = l.run({ value: t[u], issues: [] }, o);
    d instanceof Promise ? e.push(d.then((m) => Wi(m, n, u, t))) : Wi(d, n, u, t);
  }
  return i.length && n.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: t,
    inst: r
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const wge = /* @__PURE__ */ F("$ZodObject", (e, t) => {
  Ke.init(e, t);
  const n = wd(() => fk(t));
  Ie(e._zod, "propValues", () => {
    const i = t.shape, s = {};
    for (const l in i) {
      const c = i[l]._zod;
      if (c.values) {
        s[l] ?? (s[l] = /* @__PURE__ */ new Set());
        for (const u of c.values)
          s[l].add(u);
      }
    }
    return s;
  });
  const o = Fi, a = t.catchall;
  let r;
  e._zod.parse = (i, s) => {
    r ?? (r = n.value);
    const l = i.value;
    if (!o(l))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), i;
    i.value = {};
    const c = [], u = r.shape;
    for (const d of r.keys) {
      const m = u[d]._zod.run({ value: l[d], issues: [] }, s);
      m instanceof Promise ? c.push(m.then((f) => Wi(f, i, d, l))) : Wi(m, i, d, l);
    }
    return a ? gk(c, l, i, s, n.value, e) : c.length ? Promise.all(c).then(() => i) : i;
  };
}), kge = /* @__PURE__ */ F("$ZodObjectJIT", (e, t) => {
  wge.init(e, t);
  const n = e._zod.parse, o = wd(() => fk(t)), a = (d) => {
    const m = new qfe(["shape", "payload", "ctx"]), f = o.value, g = (y) => {
      const _ = Qm(y);
      return `shape[${_}]._zod.run({ value: input[${_}], issues: [] }, ctx)`;
    };
    m.write("const input = payload.value;");
    const p = /* @__PURE__ */ Object.create(null);
    let b = 0;
    for (const y of f.keys)
      p[y] = `key_${b++}`;
    m.write("const newResult = {};");
    for (const y of f.keys) {
      const _ = p[y], k = Qm(y);
      m.write(`const ${_} = ${g(y)};`), m.write(`
        if (${_}.issues.length) {
          payload.issues = payload.issues.concat(${_}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        
        if (${_}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${_}.value;
        }
        
      `);
    }
    m.write("payload.value = newResult;"), m.write("return payload;");
    const w = m.compile();
    return (y, _) => w(d, y, _);
  };
  let r;
  const i = Fi, s = !ak.jitless, l = s && Vme.value, c = t.catchall;
  let u;
  e._zod.parse = (d, m) => {
    u ?? (u = o.value);
    const f = d.value;
    return i(f) ? s && l && m?.async === !1 && m.jitless !== !0 ? (r || (r = a(t.shape)), d = r(d, m), c ? gk([], f, d, m, u, e) : d) : n(d, m) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: f,
      inst: e
    }), d);
  };
});
function nf(e, t, n, o) {
  for (const r of e)
    if (r.issues.length === 0)
      return t.value = r.value, t;
  const a = e.filter((r) => !No(r));
  return a.length === 1 ? (t.value = a[0].value, a[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((r) => r.issues.map((i) => ro(i, o, ao())))
  }), t);
}
const xge = /* @__PURE__ */ F("$ZodUnion", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "optin", () => t.options.some((a) => a._zod.optin === "optional") ? "optional" : void 0), Ie(e._zod, "optout", () => t.options.some((a) => a._zod.optout === "optional") ? "optional" : void 0), Ie(e._zod, "values", () => {
    if (t.options.every((a) => a._zod.values))
      return new Set(t.options.flatMap((a) => Array.from(a._zod.values)));
  }), Ie(e._zod, "pattern", () => {
    if (t.options.every((a) => a._zod.pattern)) {
      const a = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${a.map((r) => xd(r.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (a, r) => {
    if (n)
      return o(a, r);
    let i = !1;
    const s = [];
    for (const l of t.options) {
      const c = l._zod.run({
        value: a.value,
        issues: []
      }, r);
      if (c instanceof Promise)
        s.push(c), i = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return i ? Promise.all(s).then((l) => nf(l, a, e, r)) : nf(s, a, e, r);
  };
}), $ge = /* @__PURE__ */ F("$ZodIntersection", (e, t) => {
  Ke.init(e, t), e._zod.parse = (n, o) => {
    const a = n.value, r = t.left._zod.run({ value: a, issues: [] }, o), i = t.right._zod.run({ value: a, issues: [] }, o);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([s, l]) => of(n, s, l)) : of(n, r, i);
  };
});
function Dc(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Ta(e) && Ta(t)) {
    const n = Object.keys(t), o = Object.keys(e).filter((r) => n.indexOf(r) !== -1), a = { ...e, ...t };
    for (const r of o) {
      const i = Dc(e[r], t[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      a[r] = i.data;
    }
    return { valid: !0, data: a };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let o = 0; o < e.length; o++) {
      const a = e[o], r = t[o], i = Dc(a, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...i.mergeErrorPath]
        };
      n.push(i.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function of(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), No(e))
    return e;
  const o = Dc(t.value, n.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const Sge = /* @__PURE__ */ F("$ZodEnum", (e, t) => {
  Ke.init(e, t);
  const n = Wme(t.entries), o = new Set(n);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${n.filter((a) => Ume.has(typeof a)).map((a) => typeof a == "string" ? Zo(a) : a.toString()).join("|")})$`), e._zod.parse = (a, r) => {
    const i = a.value;
    return o.has(i) || a.issues.push({
      code: "invalid_value",
      values: n,
      input: i,
      inst: e
    }), a;
  };
}), Cge = /* @__PURE__ */ F("$ZodLiteral", (e, t) => {
  if (Ke.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(t.values), e._zod.pattern = new RegExp(`^(${t.values.map((n) => typeof n == "string" ? Zo(n) : n ? Zo(n.toString()) : String(n)).join("|")})$`), e._zod.parse = (n, o) => {
    const a = n.value;
    return e._zod.values.has(a) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: a,
      inst: e
    }), n;
  };
}), Ege = /* @__PURE__ */ F("$ZodTransform", (e, t) => {
  Ke.init(e, t), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new ok(e.constructor.name);
    const a = t.transform(n.value, n);
    if (o.async)
      return (a instanceof Promise ? a : Promise.resolve(a)).then((r) => (n.value = r, n));
    if (a instanceof Promise)
      throw new Po();
    return n.value = a, n;
  };
});
function af(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Age = /* @__PURE__ */ F("$ZodOptional", (e, t) => {
  Ke.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Ie(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Ie(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${xd(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, o) => {
    if (t.innerType._zod.optin === "optional") {
      const a = t.innerType._zod.run(n, o);
      return a instanceof Promise ? a.then((r) => af(r, n.value)) : af(a, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, o);
  };
}), Oge = /* @__PURE__ */ F("$ZodNullable", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "optin", () => t.innerType._zod.optin), Ie(e._zod, "optout", () => t.innerType._zod.optout), Ie(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${xd(n.source)}|null)$`) : void 0;
  }), Ie(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, o) => n.value === null ? n : t.innerType._zod.run(n, o);
}), zge = /* @__PURE__ */ F("$ZodDefault", (e, t) => {
  Ke.init(e, t), e._zod.optin = "optional", Ie(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const a = t.innerType._zod.run(n, o);
    return a instanceof Promise ? a.then((r) => rf(r, t)) : rf(a, t);
  };
});
function rf(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Nge = /* @__PURE__ */ F("$ZodPrefault", (e, t) => {
  Ke.init(e, t), e._zod.optin = "optional", Ie(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => (o.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, o));
}), jge = /* @__PURE__ */ F("$ZodNonOptional", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (n, o) => {
    const a = t.innerType._zod.run(n, o);
    return a instanceof Promise ? a.then((r) => sf(r, e)) : sf(a, e);
  };
});
function sf(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Rge = /* @__PURE__ */ F("$ZodCatch", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "optin", () => t.innerType._zod.optin), Ie(e._zod, "optout", () => t.innerType._zod.optout), Ie(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const a = t.innerType._zod.run(n, o);
    return a instanceof Promise ? a.then((r) => (n.value = r.value, r.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: r.issues.map((i) => ro(i, o, ao()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = a.value, a.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: a.issues.map((r) => ro(r, o, ao()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Ige = /* @__PURE__ */ F("$ZodPipe", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "values", () => t.in._zod.values), Ie(e._zod, "optin", () => t.in._zod.optin), Ie(e._zod, "optout", () => t.out._zod.optout), Ie(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, o) => {
    if (o.direction === "backward") {
      const r = t.out._zod.run(n, o);
      return r instanceof Promise ? r.then((i) => Ir(i, t.in, o)) : Ir(r, t.in, o);
    }
    const a = t.in._zod.run(n, o);
    return a instanceof Promise ? a.then((r) => Ir(r, t.out, o)) : Ir(a, t.out, o);
  };
});
function Ir(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Tge = /* @__PURE__ */ F("$ZodReadonly", (e, t) => {
  Ke.init(e, t), Ie(e._zod, "propValues", () => t.innerType._zod.propValues), Ie(e._zod, "values", () => t.innerType._zod.values), Ie(e._zod, "optin", () => t.innerType._zod.optin), Ie(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const a = t.innerType._zod.run(n, o);
    return a instanceof Promise ? a.then(lf) : lf(a);
  };
});
function lf(e) {
  return e.value = Object.freeze(e.value), e;
}
const Pge = /* @__PURE__ */ F("$ZodCustom", (e, t) => {
  nn.init(e, t), Ke.init(e, t), e._zod.parse = (n, o) => n, e._zod.check = (n) => {
    const o = n.value, a = t.fn(o);
    if (a instanceof Promise)
      return a.then((r) => cf(r, n, o, e));
    cf(a, n, o, e);
  };
});
function cf(e, t, n, o) {
  if (!e) {
    const a = {
      code: "custom",
      input: n,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (a.params = o._zod.def.params), t.issues.push(Pa(a));
  }
}
class Dge {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const o = n[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const o = { ...this.get(n) ?? {} };
      delete o.id;
      const a = { ...o, ...this._map.get(t) };
      return Object.keys(a).length ? a : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Lge() {
  return new Dge();
}
const Tr = /* @__PURE__ */ Lge();
function Mge(e, t) {
  return new e({
    type: "string",
    ...re(t)
  });
}
function bk(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function uf(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Fge(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Wge(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...re(t)
  });
}
function Bge(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...re(t)
  });
}
function Vge(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...re(t)
  });
}
function Uge(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function qge(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Hge(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Kge(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Gge(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Zge(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Jge(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Yge(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Xge(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Qge(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function ebe(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function tbe(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function nbe(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function obe(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function abe(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function rbe(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function ibe(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...re(t)
  });
}
function sbe(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...re(t)
  });
}
function lbe(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...re(t)
  });
}
function cbe(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...re(t)
  });
}
function ube(e) {
  return new e({
    type: "unknown"
  });
}
function dbe(e, t) {
  return new e({
    type: "never",
    ...re(t)
  });
}
function vk(e, t) {
  return new Tfe({
    check: "max_length",
    ...re(t),
    maximum: e
  });
}
function Bi(e, t) {
  return new Pfe({
    check: "min_length",
    ...re(t),
    minimum: e
  });
}
function yk(e, t) {
  return new Dfe({
    check: "length_equals",
    ...re(t),
    length: e
  });
}
function hbe(e, t) {
  return new Lfe({
    check: "string_format",
    format: "regex",
    ...re(t),
    pattern: e
  });
}
function pbe(e) {
  return new Mfe({
    check: "string_format",
    format: "lowercase",
    ...re(e)
  });
}
function mbe(e) {
  return new Ffe({
    check: "string_format",
    format: "uppercase",
    ...re(e)
  });
}
function fbe(e, t) {
  return new Wfe({
    check: "string_format",
    format: "includes",
    ...re(t),
    includes: e
  });
}
function gbe(e, t) {
  return new Bfe({
    check: "string_format",
    format: "starts_with",
    ...re(t),
    prefix: e
  });
}
function bbe(e, t) {
  return new Vfe({
    check: "string_format",
    format: "ends_with",
    ...re(t),
    suffix: e
  });
}
function tr(e) {
  return new Ufe({
    check: "overwrite",
    tx: e
  });
}
function vbe(e) {
  return tr((t) => t.normalize(e));
}
function ybe() {
  return tr((e) => e.trim());
}
function _be() {
  return tr((e) => e.toLowerCase());
}
function wbe() {
  return tr((e) => e.toUpperCase());
}
function kbe(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...re(n)
  });
}
function xbe(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...re(n)
  });
}
function $be(e) {
  const t = Sbe((n) => (n.addIssue = (o) => {
    if (typeof o == "string")
      n.issues.push(Pa(o, n.value, t._zod.def));
    else {
      const a = o;
      a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = t), a.continue ?? (a.continue = !t._zod.def.abort), n.issues.push(Pa(a));
    }
  }, e(n.value, n)));
  return t;
}
function Sbe(e, t) {
  const n = new nn({
    check: "custom",
    ...re(t)
  });
  return n._zod.check = e, n;
}
const Cbe = /* @__PURE__ */ F("ZodISODateTime", (e, t) => {
  age.init(e, t), Le.init(e, t);
});
function Ebe(e) {
  return ibe(Cbe, e);
}
const Abe = /* @__PURE__ */ F("ZodISODate", (e, t) => {
  rge.init(e, t), Le.init(e, t);
});
function Obe(e) {
  return sbe(Abe, e);
}
const zbe = /* @__PURE__ */ F("ZodISOTime", (e, t) => {
  ige.init(e, t), Le.init(e, t);
});
function Nbe(e) {
  return lbe(zbe, e);
}
const jbe = /* @__PURE__ */ F("ZodISODuration", (e, t) => {
  sge.init(e, t), Le.init(e, t);
});
function Rbe(e) {
  return cbe(jbe, e);
}
const Ibe = (e, t) => {
  ck.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => efe(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Qme(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Pc, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Pc, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Nt = F("ZodError", Ibe, {
  Parent: Error
}), Tbe = /* @__PURE__ */ Sd(Nt), Pbe = /* @__PURE__ */ Cd(Nt), Dbe = /* @__PURE__ */ zs(Nt), Lbe = /* @__PURE__ */ Ns(Nt), Mbe = /* @__PURE__ */ ofe(Nt), Fbe = /* @__PURE__ */ afe(Nt), Wbe = /* @__PURE__ */ rfe(Nt), Bbe = /* @__PURE__ */ ife(Nt), Vbe = /* @__PURE__ */ sfe(Nt), Ube = /* @__PURE__ */ lfe(Nt), qbe = /* @__PURE__ */ cfe(Nt), Hbe = /* @__PURE__ */ ufe(Nt), Je = /* @__PURE__ */ F("ZodType", (e, t) => (Ke.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...n.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (n, o) => Rn(e, n, o), e.brand = () => e, e.register = (n, o) => (n.add(e, o), e), e.parse = (n, o) => Tbe(e, n, o, { callee: e.parse }), e.safeParse = (n, o) => Dbe(e, n, o), e.parseAsync = async (n, o) => Pbe(e, n, o, { callee: e.parseAsync }), e.safeParseAsync = async (n, o) => Lbe(e, n, o), e.spa = e.safeParseAsync, e.encode = (n, o) => Mbe(e, n, o), e.decode = (n, o) => Fbe(e, n, o), e.encodeAsync = async (n, o) => Wbe(e, n, o), e.decodeAsync = async (n, o) => Bbe(e, n, o), e.safeEncode = (n, o) => Vbe(e, n, o), e.safeDecode = (n, o) => Ube(e, n, o), e.safeEncodeAsync = async (n, o) => qbe(e, n, o), e.safeDecodeAsync = async (n, o) => Hbe(e, n, o), e.refine = (n, o) => e.check(Lve(n, o)), e.superRefine = (n) => e.check(Mve(n)), e.overwrite = (n) => e.check(tr(n)), e.optional = () => pf(e), e.nullable = () => mf(e), e.nullish = () => pf(mf(e)), e.nonoptional = (n) => Nve(e, n), e.array = () => fve(e), e.or = (n) => vve([e, n]), e.and = (n) => _ve(e, n), e.transform = (n) => ff(e, Sve(n)), e.default = (n) => Ave(e, n), e.prefault = (n) => zve(e, n), e.catch = (n) => Rve(e, n), e.pipe = (n) => ff(e, n), e.readonly = () => Pve(e), e.describe = (n) => {
  const o = e.clone();
  return Tr.add(o, { description: n }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Tr.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Tr.get(e);
  const o = e.clone();
  return Tr.add(o, n[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), _k = /* @__PURE__ */ F("_ZodString", (e, t) => {
  Ed.init(e, t), Je.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...o) => e.check(hbe(...o)), e.includes = (...o) => e.check(fbe(...o)), e.startsWith = (...o) => e.check(gbe(...o)), e.endsWith = (...o) => e.check(bbe(...o)), e.min = (...o) => e.check(Bi(...o)), e.max = (...o) => e.check(vk(...o)), e.length = (...o) => e.check(yk(...o)), e.nonempty = (...o) => e.check(Bi(1, ...o)), e.lowercase = (o) => e.check(pbe(o)), e.uppercase = (o) => e.check(mbe(o)), e.trim = () => e.check(ybe()), e.normalize = (...o) => e.check(vbe(...o)), e.toLowerCase = () => e.check(_be()), e.toUpperCase = () => e.check(wbe());
}), Kbe = /* @__PURE__ */ F("ZodString", (e, t) => {
  Ed.init(e, t), _k.init(e, t), e.email = (n) => e.check(bk(wk, n)), e.url = (n) => e.check(Uge(Zbe, n)), e.jwt = (n) => e.check(rbe(uve, n)), e.emoji = (n) => e.check(qge(Jbe, n)), e.guid = (n) => e.check(uf(df, n)), e.uuid = (n) => e.check(Fge(Pr, n)), e.uuidv4 = (n) => e.check(Wge(Pr, n)), e.uuidv6 = (n) => e.check(Bge(Pr, n)), e.uuidv7 = (n) => e.check(Vge(Pr, n)), e.nanoid = (n) => e.check(Hge(Ybe, n)), e.guid = (n) => e.check(uf(df, n)), e.cuid = (n) => e.check(Kge(Xbe, n)), e.cuid2 = (n) => e.check(Gge(Qbe, n)), e.ulid = (n) => e.check(Zge(eve, n)), e.base64 = (n) => e.check(nbe(sve, n)), e.base64url = (n) => e.check(obe(lve, n)), e.xid = (n) => e.check(Jge(tve, n)), e.ksuid = (n) => e.check(Yge(nve, n)), e.ipv4 = (n) => e.check(Xge(ove, n)), e.ipv6 = (n) => e.check(Qge(ave, n)), e.cidrv4 = (n) => e.check(ebe(rve, n)), e.cidrv6 = (n) => e.check(tbe(ive, n)), e.e164 = (n) => e.check(abe(cve, n)), e.datetime = (n) => e.check(Ebe(n)), e.date = (n) => e.check(Obe(n)), e.time = (n) => e.check(Nbe(n)), e.duration = (n) => e.check(Rbe(n));
});
function it(e) {
  return Mge(Kbe, e);
}
const Le = /* @__PURE__ */ F("ZodStringFormat", (e, t) => {
  Pe.init(e, t), _k.init(e, t);
}), wk = /* @__PURE__ */ F("ZodEmail", (e, t) => {
  Zfe.init(e, t), Le.init(e, t);
});
function Gbe(e) {
  return bk(wk, e);
}
const df = /* @__PURE__ */ F("ZodGUID", (e, t) => {
  Kfe.init(e, t), Le.init(e, t);
}), Pr = /* @__PURE__ */ F("ZodUUID", (e, t) => {
  Gfe.init(e, t), Le.init(e, t);
}), Zbe = /* @__PURE__ */ F("ZodURL", (e, t) => {
  Jfe.init(e, t), Le.init(e, t);
}), Jbe = /* @__PURE__ */ F("ZodEmoji", (e, t) => {
  Yfe.init(e, t), Le.init(e, t);
}), Ybe = /* @__PURE__ */ F("ZodNanoID", (e, t) => {
  Xfe.init(e, t), Le.init(e, t);
}), Xbe = /* @__PURE__ */ F("ZodCUID", (e, t) => {
  Qfe.init(e, t), Le.init(e, t);
}), Qbe = /* @__PURE__ */ F("ZodCUID2", (e, t) => {
  ege.init(e, t), Le.init(e, t);
}), eve = /* @__PURE__ */ F("ZodULID", (e, t) => {
  tge.init(e, t), Le.init(e, t);
}), tve = /* @__PURE__ */ F("ZodXID", (e, t) => {
  nge.init(e, t), Le.init(e, t);
}), nve = /* @__PURE__ */ F("ZodKSUID", (e, t) => {
  oge.init(e, t), Le.init(e, t);
}), ove = /* @__PURE__ */ F("ZodIPv4", (e, t) => {
  lge.init(e, t), Le.init(e, t);
}), ave = /* @__PURE__ */ F("ZodIPv6", (e, t) => {
  cge.init(e, t), Le.init(e, t);
}), rve = /* @__PURE__ */ F("ZodCIDRv4", (e, t) => {
  uge.init(e, t), Le.init(e, t);
}), ive = /* @__PURE__ */ F("ZodCIDRv6", (e, t) => {
  dge.init(e, t), Le.init(e, t);
}), sve = /* @__PURE__ */ F("ZodBase64", (e, t) => {
  hge.init(e, t), Le.init(e, t);
}), lve = /* @__PURE__ */ F("ZodBase64URL", (e, t) => {
  mge.init(e, t), Le.init(e, t);
}), cve = /* @__PURE__ */ F("ZodE164", (e, t) => {
  fge.init(e, t), Le.init(e, t);
}), uve = /* @__PURE__ */ F("ZodJWT", (e, t) => {
  bge.init(e, t), Le.init(e, t);
}), dve = /* @__PURE__ */ F("ZodUnknown", (e, t) => {
  vge.init(e, t), Je.init(e, t);
});
function hf() {
  return ube(dve);
}
const hve = /* @__PURE__ */ F("ZodNever", (e, t) => {
  yge.init(e, t), Je.init(e, t);
});
function pve(e) {
  return dbe(hve, e);
}
const mve = /* @__PURE__ */ F("ZodArray", (e, t) => {
  _ge.init(e, t), Je.init(e, t), e.element = t.element, e.min = (n, o) => e.check(Bi(n, o)), e.nonempty = (n) => e.check(Bi(1, n)), e.max = (n, o) => e.check(vk(n, o)), e.length = (n, o) => e.check(yk(n, o)), e.unwrap = () => e.element;
});
function fve(e, t) {
  return kbe(mve, e, t);
}
const gve = /* @__PURE__ */ F("ZodObject", (e, t) => {
  kge.init(e, t), Je.init(e, t), Ie(e, "shape", () => t.shape), e.keyof = () => wve(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: hf() }), e.loose = () => e.clone({ ...e._zod.def, catchall: hf() }), e.strict = () => e.clone({ ...e._zod.def, catchall: pve() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Gme(e, n), e.safeExtend = (n) => Zme(e, n), e.merge = (n) => Jme(e, n), e.pick = (n) => Hme(e, n), e.omit = (n) => Kme(e, n), e.partial = (...n) => Yme(kk, e, n[0]), e.required = (...n) => Xme(xk, e, n[0]);
});
function Vi(e, t) {
  const n = {
    type: "object",
    get shape() {
      return jn(this, "shape", e ? Bme(e) : {}), this.shape;
    },
    ...re(t)
  };
  return new gve(n);
}
const bve = /* @__PURE__ */ F("ZodUnion", (e, t) => {
  xge.init(e, t), Je.init(e, t), e.options = t.options;
});
function vve(e, t) {
  return new bve({
    type: "union",
    options: e,
    ...re(t)
  });
}
const yve = /* @__PURE__ */ F("ZodIntersection", (e, t) => {
  $ge.init(e, t), Je.init(e, t);
});
function _ve(e, t) {
  return new yve({
    type: "intersection",
    left: e,
    right: t
  });
}
const Lc = /* @__PURE__ */ F("ZodEnum", (e, t) => {
  Sge.init(e, t), Je.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (o, a) => {
    const r = {};
    for (const i of o)
      if (n.has(i))
        r[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Lc({
      ...t,
      checks: [],
      ...re(a),
      entries: r
    });
  }, e.exclude = (o, a) => {
    const r = { ...t.entries };
    for (const i of o)
      if (n.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Lc({
      ...t,
      checks: [],
      ...re(a),
      entries: r
    });
  };
});
function wve(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new Lc({
    type: "enum",
    entries: n,
    ...re(t)
  });
}
const kve = /* @__PURE__ */ F("ZodLiteral", (e, t) => {
  Cge.init(e, t), Je.init(e, t), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function xve(e, t) {
  return new kve({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...re(t)
  });
}
const $ve = /* @__PURE__ */ F("ZodTransform", (e, t) => {
  Ege.init(e, t), Je.init(e, t), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new ok(e.constructor.name);
    n.addIssue = (r) => {
      if (typeof r == "string")
        n.issues.push(Pa(r, n.value, t));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = e), n.issues.push(Pa(i));
      }
    };
    const a = t.transform(n.value, n);
    return a instanceof Promise ? a.then((r) => (n.value = r, n)) : (n.value = a, n);
  };
});
function Sve(e) {
  return new $ve({
    type: "transform",
    transform: e
  });
}
const kk = /* @__PURE__ */ F("ZodOptional", (e, t) => {
  Age.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function pf(e) {
  return new kk({
    type: "optional",
    innerType: e
  });
}
const Cve = /* @__PURE__ */ F("ZodNullable", (e, t) => {
  Oge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function mf(e) {
  return new Cve({
    type: "nullable",
    innerType: e
  });
}
const Eve = /* @__PURE__ */ F("ZodDefault", (e, t) => {
  zge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Ave(e, t) {
  return new Eve({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : ik(t);
    }
  });
}
const Ove = /* @__PURE__ */ F("ZodPrefault", (e, t) => {
  Nge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function zve(e, t) {
  return new Ove({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : ik(t);
    }
  });
}
const xk = /* @__PURE__ */ F("ZodNonOptional", (e, t) => {
  jge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Nve(e, t) {
  return new xk({
    type: "nonoptional",
    innerType: e,
    ...re(t)
  });
}
const jve = /* @__PURE__ */ F("ZodCatch", (e, t) => {
  Rge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Rve(e, t) {
  return new jve({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Ive = /* @__PURE__ */ F("ZodPipe", (e, t) => {
  Ige.init(e, t), Je.init(e, t), e.in = t.in, e.out = t.out;
});
function ff(e, t) {
  return new Ive({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Tve = /* @__PURE__ */ F("ZodReadonly", (e, t) => {
  Tge.init(e, t), Je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Pve(e) {
  return new Tve({
    type: "readonly",
    innerType: e
  });
}
const Dve = /* @__PURE__ */ F("ZodCustom", (e, t) => {
  Pge.init(e, t), Je.init(e, t);
});
function Lve(e, t = {}) {
  return xbe(Dve, e, t);
}
function Mve(e) {
  return $be(e);
}
Vi({
  email: Gbe(),
  password: it().min(8)
}).required();
Vi({
  firstname: it().min(1),
  lastname: it().min(1),
  email: it().email(),
  password: it().min(8),
  sponsor: it().optional(),
  cgus: xve(!0)
});
function Fve({ children: e, onLogout: t }) {
  return e ? gf(e, {
    onClick: async () => {
      await D5(), t && await t();
    }
  }) : null;
}
function $k({ config: e, children: t, onLogout: n }) {
  return m9(e.apiUrl), /* @__PURE__ */ v($Z, { config: e, children: /* @__PURE__ */ v(Fve, { onLogout: n, children: t }) });
}
function Sk(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Sk(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Wve() {
  for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Sk(e)) && (o && (o += " "), o += t);
  return o;
}
const Bve = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Vve = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Uve = Bve.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Vve[e]
})), qve = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Hve = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Kve(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ v("span", { className: n }, n));
}
const Gve = pt(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...a }, r) => {
    const i = Uve.find((l) => l.name === e), s = Wve("icon", `ds-${i?.class}`, Hve[t], qve[n], o);
    return /* @__PURE__ */ v("i", { className: s, ...a, ref: r, children: Kve(i?.paths) });
  }
);
Gve.displayName = "Icon";
Pt({
  locale: "en"
});
const Zve = Vi({
  firstName: it({ error: ga.t("auth:modal.finishCreatingAccount.firstName.error") }).min(1, ga.t("auth:modal.finishCreatingAccount.firstName.error")),
  lastName: it({ error: ga.t("auth:modal.finishCreatingAccount.lastName.error") }).min(1, ga.t("auth:modal.finishCreatingAccount.lastName.error")),
  referralCode: it().optional(),
  phoneNumber: it().optional(),
  howDoYouKnowHE: Vi({
    firstLevel: it().optional(),
    secondLevel: it().optional(),
    openField: it().optional()
  })
});
Zve.extend({
  phoneNumber: it().min(1, { error: ga.t("auth:modal.finishCreatingAccount.phone_number.error") })
});
function Ck() {
  const { t: e } = lo("header");
  return /* @__PURE__ */ P(ru, { children: [
    /* @__PURE__ */ v(iu, { children: /* @__PURE__ */ P(ce, { gap: "2", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-help" }),
      e("help")
    ] }) }),
    /* @__PURE__ */ P(su, { children: [
      /* @__PURE__ */ v(ue, { href: e("links:faq"), children: e("faq") }),
      /* @__PURE__ */ v(St, {}),
      /* @__PURE__ */ v(ue, { href: e("links:guestpoints"), children: e("guestpoints") }),
      /* @__PURE__ */ v(St, {}),
      /* @__PURE__ */ v(ue, { href: e("links:about-calendar"), children: e("about-the-calendar") }),
      /* @__PURE__ */ v(St, {}),
      /* @__PURE__ */ v(ue, { href: e("links:guarantees"), children: e("guarantees") }),
      /* @__PURE__ */ v(St, {}),
      /* @__PURE__ */ v(ue, { href: e("links:contact-us"), children: e("contact") })
    ] })
  ] });
}
function Jve() {
  const { url: e } = Ae("/conversations"), { conversations: t, userInfos: n } = Qn((a) => ({
    conversations: a.conversations,
    userInfos: a.userInfos
  })), { t: o } = lo("header");
  return /* @__PURE__ */ P(ru, { hideOn: "mobile", children: [
    /* @__PURE__ */ v(iu, { children: /* @__PURE__ */ P(ce, { gap: "2", alignItems: "center", children: [
      t && t?.notifications > 0 && /* @__PURE__ */ v(Xc, { value: t?.notifications, onIcon: !0, children: /* @__PURE__ */ v($e, { name: "header-message-new" }) }),
      o("messages")
    ] }) }),
    /* @__PURE__ */ P(su, { size: "medium", children: [
      t?.all?.length ? /* @__PURE__ */ v(ue, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ v(Yve, { conversations: t }) }) : /* @__PURE__ */ v(ue, { children: /* @__PURE__ */ P(ce, { justifyContent: "center", children: [
        /* @__PURE__ */ v(Ze, { children: o("no-messages") }),
        /* @__PURE__ */ v(
          "img",
          {
            src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/header/messages_empty.svg",
            alt: "no messages"
          }
        )
      ] }) }),
      /* @__PURE__ */ v(ue, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ P(ce, { justifyContent: "space-between", isFullWidth: !0, alignItems: "center", children: [
        /* @__PURE__ */ P(Ze, { size: "sm", children: [
          o("my-response-rate"),
          " ",
          /* @__PURE__ */ P(Ze, { isSpan: !0, isBold: !0, size: "sm", children: [
            n?.response_rate,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ v(Mc, { color: "tertiary", size: "medium", href: e, children: o("view-inbox") })
      ] }) })
    ] })
  ] });
}
const Yve = ({ conversations: e }) => /* @__PURE__ */ v(
  Y0,
  {
    isFullWidth: !0,
    size: "small",
    tabs: [
      {
        title: "All",
        content: /* @__PURE__ */ v(je, { children: e.all.map((t) => /* @__PURE__ */ v(Nl, { conversation: t }, t.id)) })
      },
      {
        title: `Unreplied (${e.stats.unreplied})`,
        content: /* @__PURE__ */ v(je, { children: e.unreplied.map((t) => /* @__PURE__ */ v(Nl, { conversation: t }, t.id)) })
      },
      {
        title: `Finalized (${e.stats.finalized})`,
        content: /* @__PURE__ */ v(je, { children: e.finalized.map((t) => /* @__PURE__ */ v(Nl, { conversation: t }, t.id)) })
      }
    ]
  }
), Nl = ({ conversation: e }) => {
  const { url: t } = Ae(`/conversations/${e.id}`);
  return /* @__PURE__ */ P("a", { href: t, children: [
    /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", noMargin: !0, children: [
      /* @__PURE__ */ v(
        "img",
        {
          src: e.interlocutor.profilePicture,
          style: { height: "40px", width: "40px", background: "blue", borderRadius: "9999px" },
          alt: "user"
        }
      ),
      /* @__PURE__ */ P(
        "div",
        {
          style: {
            overflow: "hidden",
            flex: "1 0 0"
          },
          children: [
            /* @__PURE__ */ v(
              "div",
              {
                style: {
                  fontWeight: "bold"
                },
                children: e.interlocutor.firstName
              }
            ),
            /* @__PURE__ */ v(Ze, { ellipsis: !0, size: "sm", children: e.lastMessage.content })
          ]
        }
      ),
      /* @__PURE__ */ v("div", { children: Nk(e.lastMessage.createdAt) })
    ] }),
    /* @__PURE__ */ v(F0, { space: "small" })
  ] });
};
function Xve() {
  const { t: e } = lo("header"), { userInfos: t, completionRate: n, userProfile: o, userMembership: a, apiUrl: r } = Qn((p) => ({
    userInfos: p.userInfos,
    completionRate: p.userInfos?.profil.completionRate ?? 0,
    userProfile: p.userInfos?.notifications?.user?.details.userProfile,
    userMembership: p.userInfos?.notifications?.user?.details.membership,
    apiUrl: p.apiUrl
  })), { signout: i } = ms((p) => ({
    signout: p.signout
  })), { url: s } = Ae(`/user/edit/${t?.profil.id}`), { url: l } = Ae("/homes/edit"), { url: c } = Ae("/homes/create"), { url: u } = Ae("/myexchanges"), { url: d } = Ae("/my-plan"), { url: m } = Ae("/user/favorite"), { url: f } = Ae("/user/they-love-my-home"), { url: g } = Ae(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ P(je, { children: [
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: s, children: /* @__PURE__ */ P(ce, { gap: "2", isFullWidth: !0, children: [
      /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v($e, { name: "header-profile-profile" }),
          e("my-profile")
        ] }),
        /* @__PURE__ */ P(ce, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ P(Ze, { size: "sm", children: [
            n,
            "%"
          ] }),
          /* @__PURE__ */ v(Gd, { value: n, color: "tertiary", size: "small", ariaLabel: "User completion rate" })
        ] })
      ] }),
      /* @__PURE__ */ v(Ze, { isBold: !0, size: "sm", color: "tertiary", children: o && e(`notification.user_profile.${o.status}`, {
        gp: o.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    t?.homes?.map((p) => /* @__PURE__ */ P("div", { children: [
      /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: `${l}/${p.id}`, children: /* @__PURE__ */ P(ce, { gap: "2", isFullWidth: !0, children: [
        /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "space-between", children: [
          /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
            /* @__PURE__ */ v($e, { name: "header-profile-home" }),
            /* @__PURE__ */ v(Ze, { size: "sm", children: "My Home" })
          ] }),
          /* @__PURE__ */ P(ce, { alignItems: "center", gap: "2", children: [
            /* @__PURE__ */ P(Ze, { size: "sm", children: [
              p.completionRate,
              "%"
            ] }),
            /* @__PURE__ */ v(
              Gd,
              {
                value: p.completionRate,
                color: "tertiary",
                size: "small",
                ariaLabel: "Home completion rate"
              }
            )
          ] })
        ] }),
        p.notifications?.status && /* @__PURE__ */ v(Ze, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
          gp: p.notifications.gpReward
        }) })
      ] }) }),
      /* @__PURE__ */ v(St, {})
    ] }, p.id)),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: c, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "plus" }),
      e("add-home")
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: u, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "keys" }),
      e("my-exchanges")
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: d, children: /* @__PURE__ */ P(ce, { gap: "2", children: [
      /* @__PURE__ */ v(ce, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ v(ce, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v($e, { name: "credit-card" }),
        e("my-membership")
      ] }) }) }),
      a && /* @__PURE__ */ v(Ze, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${a.status}`, {
        gp: a.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: m, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, gap: "4", justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "heart" }),
      e("my-favorite-homes")
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: f, children: /* @__PURE__ */ P(ce, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-profile-they-love-my-home" }),
      e("they-love-my-home")
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v(ue, { noPaddingRight: !0, href: g, children: /* @__PURE__ */ P(ce, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-profile-settings" }),
      e("settings")
    ] }) }),
    /* @__PURE__ */ v(St, {}),
    /* @__PURE__ */ v($k, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(ue, { noPaddingRight: !0, children: /* @__PURE__ */ P(ce, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function Qve() {
  const { t: e } = lo("header"), { userInfos: t, userProfile: n, userCompletionRate: o, userMemberShip: a } = Qn((p) => ({
    userInfos: p.userInfos,
    userProfile: p.userInfos?.profil,
    userCompletionRate: p.userInfos?.profil.completionRate ?? 0,
    userMemberShip: p.userInfos?.notifications?.user?.details.membership
  })), { url: r } = Ae("/conversations"), { url: i } = Ae(`/user/edit/${t?.profil.id}`), { url: s } = Ae("/homes/edit"), { url: l } = Ae("/homes/create"), { url: c } = Ae("/myexchanges"), { url: u } = Ae("/my-plan"), { url: d } = Ae("/user/favorite"), { url: m } = Ae("/user/they-love-my-home"), { url: f } = Ae("/user/gpdetails"), { url: g } = Ae(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ P(je, { children: [
    /* @__PURE__ */ v(ue, { largerPaddingBottom: !0, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Kg, { url: n?.profilePicture ?? "", alt: "avatar" }),
      /* @__PURE__ */ P("div", { children: [
        /* @__PURE__ */ P(Ze, { isBold: !0, isSpan: !0, children: [
          n?.firstName,
          " ",
          t?.profil.lastName
        ] }),
        /* @__PURE__ */ P("div", { children: [
          /* @__PURE__ */ v(Ze, { isBold: !0, isSpan: !0, color: "secondary", children: n?.totalGP }),
          " ",
          "GP"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ v(ue, { href: r, children: /* @__PURE__ */ v(ce, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-message-new" }),
      "Inbox"
    ] }) }) }),
    /* @__PURE__ */ v(ue, { href: i, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v($e, { name: "header-profile-profile" }),
        "My Profile"
      ] }),
      /* @__PURE__ */ P(Ze, { color: o === 1 ? "primary" : "tertiary", children: [
        o,
        "%"
      ] })
    ] }) }),
    t?.homes?.map((p) => /* @__PURE__ */ v(ue, { href: `${s}/${p.id}`, children: /* @__PURE__ */ P(ce, { gap: "0", isFullWidth: !0, children: [
      /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ P(ce, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v($e, { name: "header-profile-home" }),
          "My Home"
        ] }),
        /* @__PURE__ */ P(Ze, { color: p.completionRate === 1 ? "primary" : "tertiary", children: [
          p.completionRate,
          "%"
        ] })
      ] }),
      p.notifications?.status && /* @__PURE__ */ v(Ze, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
        gp: p.notifications.gpReward
      }) })
    ] }) }, p.id)),
    /* @__PURE__ */ v(ue, { href: l, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "plus" }),
      "Add a home"
    ] }) }),
    /* @__PURE__ */ v(ue, { href: c, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "keys" }),
      "My exchanges"
    ] }) }),
    /* @__PURE__ */ v(ue, { href: u, children: /* @__PURE__ */ P(ce, { gap: "0", children: [
      /* @__PURE__ */ v(ce, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(ce, { justifyContent: "start", gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v($e, { name: "credit-card" }),
        "My membership"
      ] }) }),
      a && /* @__PURE__ */ v(Ze, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${a.status}`, {
        gp: a.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(ue, { href: d, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "heart" }),
      "My favorite homes"
    ] }) }),
    /* @__PURE__ */ v(ue, { href: m, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-profile-they-love-my-home" }),
      "They love my home"
    ] }) }),
    /* @__PURE__ */ v(ue, { href: g, children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v($e, { name: "header-profile-settings" }),
      "My settings"
    ] }) }),
    /* @__PURE__ */ v(ue, { href: f, children: /* @__PURE__ */ v(Ze, { isSpan: !0, color: "secondary", children: "Sponsor 10 friends and receive up to 2500 GP" }) })
  ] });
}
function eye() {
  const { t: e } = lo("header"), { url: t } = Ae("/user/gpdetails"), { url: n } = Ae("/"), { url: o } = Ae("/collection"), { userInfos: a, apiUrl: r } = Qn((s) => ({
    userInfos: s.userInfos,
    apiUrl: s.apiUrl
  })), { signout: i } = ms((s) => ({
    signout: s.signout
  }));
  return /* @__PURE__ */ P(Ug, { notificationValue: a?.notifications?.user?.total, children: [
    /* @__PURE__ */ P(qg, { position: "end", children: [
      /* @__PURE__ */ v(Mo, { hideOn: "desktop", children: /* @__PURE__ */ v(Qve, {}) }),
      /* @__PURE__ */ v(Oo, { hideOn: "desktop" }),
      /* @__PURE__ */ v(Ck, {}),
      /* @__PURE__ */ v(Oo, {}),
      /* @__PURE__ */ v(Jve, {}),
      /* @__PURE__ */ v(Oo, { hideOn: "mobile" }),
      /* @__PURE__ */ v(ue, { href: t, hideOn: "mobile", children: /* @__PURE__ */ P(ce, { gap: "1", children: [
        /* @__PURE__ */ v(Ze, { isSpan: !0, isBold: !0, color: "secondary", children: a?.profil.totalGP }),
        /* @__PURE__ */ v(Ze, { isSpan: !0, children: "GP" })
      ] }) }),
      /* @__PURE__ */ v(Oo, { hideOn: "mobile" }),
      /* @__PURE__ */ P(ru, { hideOn: "mobile", children: [
        /* @__PURE__ */ v(iu, { children: /* @__PURE__ */ P(ce, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ v(Xc, { value: a?.notifications?.user?.total ?? 0, children: /* @__PURE__ */ v(Kg, { url: a?.profil.profilePicture ?? "", alt: "avatar" }) }),
          e("my-account")
        ] }) }),
        /* @__PURE__ */ v(su, { size: "small", children: /* @__PURE__ */ v(Xve, {}) })
      ] }),
      /* @__PURE__ */ v(ue, { hideOn: "desktop", href: o, children: "Home Exchange Collection" }),
      /* @__PURE__ */ v(ue, { hideOn: "desktop", href: n, children: "English" }),
      /* @__PURE__ */ v(ue, { hideOn: "desktop", href: n, children: "US dollars - $" })
    ] }),
    /* @__PURE__ */ v($k, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(ue, { marginAutoTop: !0, hideOn: "desktop", children: /* @__PURE__ */ P(ce, { isFullWidth: !0, justifyContent: "start", children: [
      /* @__PURE__ */ v($e, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function tye() {
  const [e, t] = Ne(!1), [n, o] = Ne(!1), { url: a } = Ae("/#signup"), { url: r } = Ae("/#signin"), { url: i } = Ae("/"), { url: s } = Ae("/collection"), { apiUrl: l } = Qn((f) => ({ apiUrl: f.apiUrl })), { currentWidth: c } = Tj(), { t: u } = lo(["header", "links"]), { setIsSignedIn: d } = ms((f) => ({
    setIsSignedIn: f.setIsSignedIn
  })), { setNavigationBarData: m } = Qn((f) => ({
    setNavigationBarData: f.setNavigationBarData
  }));
  return Pj("navigation-bar:open-signup-modal", () => {
    o(!0);
  }), /* @__PURE__ */ v(Ug, { children: /* @__PURE__ */ P(qg, { position: "end", children: [
    /* @__PURE__ */ v(ue, { href: u("links:how-it-works"), children: c && c <= 1300 ? /* @__PURE__ */ v($e, { name: "circle-help" }) : u("how-it-works") }),
    /* @__PURE__ */ v(ue, { href: u("links:subscription-cost"), children: c && c <= 1300 ? /* @__PURE__ */ v($e, { name: "dollar" }) : u("how-much-does-it-cost") }),
    /* @__PURE__ */ v(Mo, { hideOn: "desktop", children: /* @__PURE__ */ v(Oo, {}) }),
    /* @__PURE__ */ v(Ck, {}),
    /* @__PURE__ */ v(Mo, { hideOn: "desktop", children: /* @__PURE__ */ v(Oo, {}) }),
    /* @__PURE__ */ v(ue, { href: s, hideOn: "desktop", children: "Home Exchange Collection" }),
    /* @__PURE__ */ v(ue, { href: i, hideOn: "desktop", children: "English" }),
    /* @__PURE__ */ v(ue, { href: i, hideOn: "desktop", children: "US dollars - $" }),
    /* @__PURE__ */ P(je, { children: [
      /* @__PURE__ */ v(ue, { href: r, isSecondOnMobile: !0, isButton: !0, children: u("sign-in") }),
      /* @__PURE__ */ v(ue, { isFirstOnMobile: !0, largerPaddingBottom: !0, children: /* @__PURE__ */ v(Mc, { href: a, size: "regular", color: "primary", children: u("sign-up-for-free") }) })
    ] })
  ] }) });
}
function nye({ theme: e, locale: t }) {
  const { t: n } = lo("header"), { apiUrl: o, assetsUrl: a } = Qn((l) => ({ apiUrl: l.apiUrl, assetsUrl: l.assetsUrl })), { isSignedIn: r } = ms((l) => ({ isSignedIn: l.isSignedIn })), { url: i } = Ae("/"), s = `${a}/navigation/he-logo${e === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ P(Vg, { children: [
    /* @__PURE__ */ P(Hg, { children: [
      /* @__PURE__ */ v(ue, { backgroundOnHover: !1, href: i, children: /* @__PURE__ */ v("img", { src: s, alt: `HomeExchange ${e} logo ` }) }),
      /* @__PURE__ */ v(ue, { isFlexGrow: !0, children: /* @__PURE__ */ v(
        Rj,
        {
          config: { apiUrl: o, locale: t },
          id: "navbar-search-bar",
          placeholder: n("common:autocomplete.placeholder"),
          buttonText: n("common:autocomplete.button"),
          hideButtonText: !0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ v(eye, {}) : /* @__PURE__ */ v(tye, {})
  ] });
}
function y_e({
  conversations: e,
  userInfos: t,
  theme: n,
  isSignedIn: o,
  locale: a = "en",
  apiUrl: r,
  assetsUrl: i
}) {
  return Ep.changeLanguage(a), jk(r), /* @__PURE__ */ v(Vj, { isSignedIn: o, children: /* @__PURE__ */ v(Mj, { conversations: e, userInfos: t, apiUrl: r, assetsUrl: i, children: /* @__PURE__ */ v(Gk, { i18n: Ep, children: /* @__PURE__ */ v(Jg, { locale: a, children: /* @__PURE__ */ v(nye, { theme: n, locale: a }) }) }) }) });
}
const oye = ({ logoIsLink: e, theme: t, assetsUrl: n }) => {
  const { url: o } = Ae("/"), a = `${n}/navigation/he-logo${t === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ v(Vg, { isFixedTop: !0, children: /* @__PURE__ */ v(Hg, { children: /* @__PURE__ */ v(ue, { href: e ? o : void 0, children: /* @__PURE__ */ v("img", { src: a, alt: `HomeExchange ${t} logo ` }) }) }) });
}, __e = ({ logoIsLink: e, locale: t, theme: n, assetsUrl: o }) => /* @__PURE__ */ v(Jg, { locale: t || "en", children: /* @__PURE__ */ v(oye, { logoIsLink: e, theme: n, assetsUrl: o }) });
function w_e({ locale: e }) {
  const [t, n] = Ne();
  return Se(() => {
    t || Rk(e).then(n);
  }, [t, e]), t && /* @__PURE__ */ v(
    V$,
    {
      text: t.communicationBanner.data.text,
      url: t.communicationBanner.data.link
    }
  );
}
export {
  w_e as CommunicationBanner,
  Xve as DesktopMenu,
  Ck as HelpItem,
  __e as LiteHeader,
  eye as LoggedInMenu,
  tye as LoggedOutMenu,
  Jve as MessagesItem,
  Qve as MobileMenu,
  y_e as NavigationBar,
  Mj as NavigationBarProvider,
  Yve as TabContent,
  Dy as UserContext,
  Vj as UserProvider,
  Lj as createNavigationBarStore,
  Bj as createUserStore,
  Rk as getCommunicationBannerData,
  $_e as getNavigationBarData,
  S_e as heFetch,
  Ep as i18nConfig,
  jk as setNavigationBarFetchConfig,
  Qn as useNavigationBarContext,
  ms as useUserContext
};
